
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3c1f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3c1f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {
/** @license React v16.8.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $013Yp = parcelRequire("013Yp");
var $b9040d2deeb360f4$var$n = "function" === typeof Symbol && Symbol.for, $b9040d2deeb360f4$var$p = $b9040d2deeb360f4$var$n ? Symbol.for("react.element") : 60103, $b9040d2deeb360f4$var$q = $b9040d2deeb360f4$var$n ? Symbol.for("react.portal") : 60106, $b9040d2deeb360f4$var$r = $b9040d2deeb360f4$var$n ? Symbol.for("react.fragment") : 60107, $b9040d2deeb360f4$var$t = $b9040d2deeb360f4$var$n ? Symbol.for("react.strict_mode") : 60108, $b9040d2deeb360f4$var$u = $b9040d2deeb360f4$var$n ? Symbol.for("react.profiler") : 60114, $b9040d2deeb360f4$var$v = $b9040d2deeb360f4$var$n ? Symbol.for("react.provider") : 60109, $b9040d2deeb360f4$var$w = $b9040d2deeb360f4$var$n ? Symbol.for("react.context") : 60110, $b9040d2deeb360f4$var$x = $b9040d2deeb360f4$var$n ? Symbol.for("react.concurrent_mode") : 60111, $b9040d2deeb360f4$var$y = $b9040d2deeb360f4$var$n ? Symbol.for("react.forward_ref") : 60112, $b9040d2deeb360f4$var$z = $b9040d2deeb360f4$var$n ? Symbol.for("react.suspense") : 60113, $b9040d2deeb360f4$var$aa = $b9040d2deeb360f4$var$n ? Symbol.for("react.memo") : 60115, $b9040d2deeb360f4$var$ba = $b9040d2deeb360f4$var$n ? Symbol.for("react.lazy") : 60116, $b9040d2deeb360f4$var$A = "function" === typeof Symbol && Symbol.iterator;
function $b9040d2deeb360f4$var$ca(a, b, d, c, e, g, h, f) {
    if (!a) {
        a = void 0;
        if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var l = [
                d,
                c,
                e,
                g,
                h,
                f
            ], m = 0;
            a = Error(b.replace(/%s/g, function() {
                return l[m++];
            }));
            a.name = "Invariant Violation";
        }
        a.framesToPop = 1;
        throw a;
    }
}
function $b9040d2deeb360f4$var$B(a) {
    for(var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++)d += "&args[]=" + encodeURIComponent(arguments[c + 1]);
    $b9040d2deeb360f4$var$ca(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);
}
var $b9040d2deeb360f4$var$C = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, d) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = d || $b9040d2deeb360f4$var$C;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    "object" !== typeof a && "function" !== typeof a && null != a && $b9040d2deeb360f4$var$B("85");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, d) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = d || $b9040d2deeb360f4$var$C;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$013Yp($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = {
    current: null
}, $b9040d2deeb360f4$var$J = {
    current: null
}, $b9040d2deeb360f4$var$K = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, d) {
    var c = void 0, e = {}, g = null, h = null;
    if (null != b) for(c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b)$b9040d2deeb360f4$var$K.call(b, c) && !$b9040d2deeb360f4$var$L.hasOwnProperty(c) && (e[c] = b[c]);
    var f = arguments.length - 2;
    if (1 === f) e.children = d;
    else if (1 < f) {
        for(var l = Array(f), m = 0; m < f; m++)l[m] = arguments[m + 2];
        e.children = l;
    }
    if (a && a.defaultProps) for(c in f = a.defaultProps, f)void 0 === e[c] && (e[c] = f[c]);
    return {
        $$typeof: $b9040d2deeb360f4$var$p,
        type: a,
        key: g,
        ref: h,
        props: e,
        _owner: $b9040d2deeb360f4$var$J.current
    };
}
function $b9040d2deeb360f4$var$da(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$N(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$p;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$O = /\/+/g, $b9040d2deeb360f4$var$P = [];
function $b9040d2deeb360f4$var$Q(a, b, d, c) {
    if ($b9040d2deeb360f4$var$P.length) {
        var e = $b9040d2deeb360f4$var$P.pop();
        e.result = a;
        e.keyPrefix = b;
        e.func = d;
        e.context = c;
        e.count = 0;
        return e;
    }
    return {
        result: a,
        keyPrefix: b,
        func: d,
        context: c,
        count: 0
    };
}
function $b9040d2deeb360f4$var$R(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $b9040d2deeb360f4$var$P.length && $b9040d2deeb360f4$var$P.push(a);
}
function $b9040d2deeb360f4$var$S(a, b, d, c) {
    var e = typeof a;
    if ("undefined" === e || "boolean" === e) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(e){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$p:
                case $b9040d2deeb360f4$var$q:
                    g = !0;
            }
    }
    if (g) return d(c, a, "" === b ? "." + $b9040d2deeb360f4$var$T(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var h = 0; h < a.length; h++){
        e = a[h];
        var f = b + $b9040d2deeb360f4$var$T(e, h);
        g += $b9040d2deeb360f4$var$S(e, f, d, c);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $b9040d2deeb360f4$var$A && a[$b9040d2deeb360f4$var$A] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), h = 0; !(e = a.next()).done;)e = e.value, f = b + $b9040d2deeb360f4$var$T(e, h++), g += $b9040d2deeb360f4$var$S(e, f, d, c);
    else "object" === e && (d = "" + a, $b9040d2deeb360f4$var$B("31", "[object Object]" === d ? "object with keys {" + Object.keys(a).join(", ") + "}" : d, ""));
    return g;
}
function $b9040d2deeb360f4$var$U(a, b, d) {
    return null == a ? 0 : $b9040d2deeb360f4$var$S(a, "", b, d);
}
function $b9040d2deeb360f4$var$T(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape(a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$ea(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $b9040d2deeb360f4$var$fa(a, b, d) {
    var c = a.result, e = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $b9040d2deeb360f4$var$V(a, c, d, function(a) {
        return a;
    }) : null != a && ($b9040d2deeb360f4$var$N(a) && (a = $b9040d2deeb360f4$var$da(a, e + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($b9040d2deeb360f4$var$O, "$&/") + "/") + d)), c.push(a));
}
function $b9040d2deeb360f4$var$V(a, b, d, c, e) {
    var g = "";
    null != d && (g = ("" + d).replace($b9040d2deeb360f4$var$O, "$&/") + "/");
    b = $b9040d2deeb360f4$var$Q(b, g, c, e);
    $b9040d2deeb360f4$var$U(a, $b9040d2deeb360f4$var$fa, b);
    $b9040d2deeb360f4$var$R(b);
}
function $b9040d2deeb360f4$var$W() {
    var a = $b9040d2deeb360f4$var$I.current;
    null === a && $b9040d2deeb360f4$var$B("307");
    return a;
}
var $b9040d2deeb360f4$var$X = {
    Children: {
        map: function(a, b, d) {
            if (null == a) return a;
            var c = [];
            $b9040d2deeb360f4$var$V(a, c, null, b, d);
            return c;
        },
        forEach: function(a, b, d) {
            if (null == a) return a;
            b = $b9040d2deeb360f4$var$Q(null, null, b, d);
            $b9040d2deeb360f4$var$U(a, $b9040d2deeb360f4$var$ea, b);
            $b9040d2deeb360f4$var$R(b);
        },
        count: function(a) {
            return $b9040d2deeb360f4$var$U(a, function() {
                return null;
            }, null);
        },
        toArray: function(a) {
            var b = [];
            $b9040d2deeb360f4$var$V(a, b, null, function(a) {
                return a;
            });
            return b;
        },
        only: function(a) {
            $b9040d2deeb360f4$var$N(a) || $b9040d2deeb360f4$var$B("143");
            return a;
        }
    },
    createRef: function() {
        return {
            current: null
        };
    },
    Component: $b9040d2deeb360f4$var$E,
    PureComponent: $b9040d2deeb360f4$var$G,
    createContext: function(a, b) {
        void 0 === b && (b = null);
        a = {
            $$typeof: $b9040d2deeb360f4$var$w,
            _calculateChangedBits: b,
            _currentValue: a,
            _currentValue2: a,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        a.Provider = {
            $$typeof: $b9040d2deeb360f4$var$v,
            _context: a
        };
        return a.Consumer = a;
    },
    forwardRef: function(a) {
        return {
            $$typeof: $b9040d2deeb360f4$var$y,
            render: a
        };
    },
    lazy: function(a) {
        return {
            $$typeof: $b9040d2deeb360f4$var$ba,
            _ctor: a,
            _status: -1,
            _result: null
        };
    },
    memo: function(a, b) {
        return {
            $$typeof: $b9040d2deeb360f4$var$aa,
            type: a,
            compare: void 0 === b ? null : b
        };
    },
    useCallback: function(a, b) {
        return $b9040d2deeb360f4$var$W().useCallback(a, b);
    },
    useContext: function(a, b) {
        return $b9040d2deeb360f4$var$W().useContext(a, b);
    },
    useEffect: function(a, b) {
        return $b9040d2deeb360f4$var$W().useEffect(a, b);
    },
    useImperativeHandle: function(a, b, d) {
        return $b9040d2deeb360f4$var$W().useImperativeHandle(a, b, d);
    },
    useDebugValue: function() {},
    useLayoutEffect: function(a, b) {
        return $b9040d2deeb360f4$var$W().useLayoutEffect(a, b);
    },
    useMemo: function(a, b) {
        return $b9040d2deeb360f4$var$W().useMemo(a, b);
    },
    useReducer: function(a, b, d) {
        return $b9040d2deeb360f4$var$W().useReducer(a, b, d);
    },
    useRef: function(a) {
        return $b9040d2deeb360f4$var$W().useRef(a);
    },
    useState: function(a) {
        return $b9040d2deeb360f4$var$W().useState(a);
    },
    Fragment: $b9040d2deeb360f4$var$r,
    StrictMode: $b9040d2deeb360f4$var$t,
    Suspense: $b9040d2deeb360f4$var$z,
    createElement: $b9040d2deeb360f4$var$M,
    cloneElement: function(a, b, d) {
        (null === a || void 0 === a) && $b9040d2deeb360f4$var$B("267", a);
        var c = void 0, e = $013Yp({}, a.props), g = a.key, h = a.ref, f = a._owner;
        if (null != b) {
            void 0 !== b.ref && (h = b.ref, f = $b9040d2deeb360f4$var$J.current);
            void 0 !== b.key && (g = "" + b.key);
            var l = void 0;
            a.type && a.type.defaultProps && (l = a.type.defaultProps);
            for(c in b)$b9040d2deeb360f4$var$K.call(b, c) && !$b9040d2deeb360f4$var$L.hasOwnProperty(c) && (e[c] = void 0 === b[c] && void 0 !== l ? l[c] : b[c]);
        }
        c = arguments.length - 2;
        if (1 === c) e.children = d;
        else if (1 < c) {
            l = Array(c);
            for(var m = 0; m < c; m++)l[m] = arguments[m + 2];
            e.children = l;
        }
        return {
            $$typeof: $b9040d2deeb360f4$var$p,
            type: a.type,
            key: g,
            ref: h,
            props: e,
            _owner: f
        };
    },
    createFactory: function(a) {
        var b = $b9040d2deeb360f4$var$M.bind(null, a);
        b.type = a;
        return b;
    },
    isValidElement: $b9040d2deeb360f4$var$N,
    version: "16.8.0",
    unstable_ConcurrentMode: $b9040d2deeb360f4$var$x,
    unstable_Profiler: $b9040d2deeb360f4$var$u,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: $b9040d2deeb360f4$var$I,
        ReactCurrentOwner: $b9040d2deeb360f4$var$J,
        assign: $013Yp
    }
}, $b9040d2deeb360f4$var$Y = {
    default: $b9040d2deeb360f4$var$X
}, $b9040d2deeb360f4$var$Z = $b9040d2deeb360f4$var$Y && $b9040d2deeb360f4$var$X || $b9040d2deeb360f4$var$Y;
module.exports = $b9040d2deeb360f4$var$Z.default || $b9040d2deeb360f4$var$Z;

});
parcelRegister("013Yp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("6EA3T", function(module, exports) {
/** @license React v16.8.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $013Yp = parcelRequire("013Yp");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$ca(a, b, c, d, e, f, g, h) {
    if (!a) {
        a = void 0;
        if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var l = [
                c,
                d,
                e,
                f,
                g,
                h
            ], k = 0;
            a = Error(b.replace(/%s/g, function() {
                return l[k++];
            }));
            a.name = "Invariant Violation";
        }
        a.framesToPop = 1;
        throw a;
    }
}
function $4d82739dd229d539$var$t(a) {
    for(var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++)c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
    $4d82739dd229d539$var$ca(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
}
$7fPBF || $4d82739dd229d539$var$t("227");
function $4d82739dd229d539$var$da(a, b, c, d, e, f, g, h, l) {
    var k = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, k);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$ea = !1, $4d82739dd229d539$var$fa = null, $4d82739dd229d539$var$ha = !1, $4d82739dd229d539$var$ia = null, $4d82739dd229d539$var$ja = {
    onError: function(a) {
        $4d82739dd229d539$var$ea = !0;
        $4d82739dd229d539$var$fa = a;
    }
};
function $4d82739dd229d539$var$ka(a, b, c, d, e, f, g, h, l) {
    $4d82739dd229d539$var$ea = !1;
    $4d82739dd229d539$var$fa = null;
    $4d82739dd229d539$var$da.apply($4d82739dd229d539$var$ja, arguments);
}
function $4d82739dd229d539$var$la(a, b, c, d, e, f, g, h, l) {
    $4d82739dd229d539$var$ka.apply(this, arguments);
    if ($4d82739dd229d539$var$ea) {
        if ($4d82739dd229d539$var$ea) {
            var k = $4d82739dd229d539$var$fa;
            $4d82739dd229d539$var$ea = !1;
            $4d82739dd229d539$var$fa = null;
        } else $4d82739dd229d539$var$t("198"), k = void 0;
        $4d82739dd229d539$var$ha || ($4d82739dd229d539$var$ha = !0, $4d82739dd229d539$var$ia = k);
    }
}
var $4d82739dd229d539$var$ma = null, $4d82739dd229d539$var$na = {};
function $4d82739dd229d539$var$oa() {
    if ($4d82739dd229d539$var$ma) for(var a in $4d82739dd229d539$var$na){
        var b = $4d82739dd229d539$var$na[a], c = $4d82739dd229d539$var$ma.indexOf(a);
        -1 < c || $4d82739dd229d539$var$t("96", a);
        if (!$4d82739dd229d539$var$pa[c]) {
            b.extractEvents || $4d82739dd229d539$var$t("97", a);
            $4d82739dd229d539$var$pa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                $4d82739dd229d539$var$ra.hasOwnProperty(h) && $4d82739dd229d539$var$t("99", h);
                $4d82739dd229d539$var$ra[h] = f;
                var l = f.phasedRegistrationNames;
                if (l) {
                    for(e in l)l.hasOwnProperty(e) && $4d82739dd229d539$var$sa(l[e], g, h);
                    e = !0;
                } else f.registrationName ? ($4d82739dd229d539$var$sa(f.registrationName, g, h), e = !0) : e = !1;
                e || $4d82739dd229d539$var$t("98", d, a);
            }
        }
    }
}
function $4d82739dd229d539$var$sa(a, b, c) {
    $4d82739dd229d539$var$ta[a] && $4d82739dd229d539$var$t("100", a);
    $4d82739dd229d539$var$ta[a] = b;
    $4d82739dd229d539$var$ua[a] = b.eventTypes[c].dependencies;
}
var $4d82739dd229d539$var$pa = [], $4d82739dd229d539$var$ra = {}, $4d82739dd229d539$var$ta = {}, $4d82739dd229d539$var$ua = {}, $4d82739dd229d539$var$va = null, $4d82739dd229d539$var$wa = null, $4d82739dd229d539$var$xa = null;
function $4d82739dd229d539$var$ya(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $4d82739dd229d539$var$xa(c);
    $4d82739dd229d539$var$la(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$za(a, b) {
    null == b && $4d82739dd229d539$var$t("30");
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $4d82739dd229d539$var$Aa(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $4d82739dd229d539$var$Ba = null;
function $4d82739dd229d539$var$Ca(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$4d82739dd229d539$var$ya(a, b[d], c[d]);
        else b && $4d82739dd229d539$var$ya(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
var $4d82739dd229d539$var$Da = {
    injectEventPluginOrder: function(a) {
        $4d82739dd229d539$var$ma && $4d82739dd229d539$var$t("101");
        $4d82739dd229d539$var$ma = Array.prototype.slice.call(a);
        $4d82739dd229d539$var$oa();
    },
    injectEventPluginsByName: function(a) {
        var b = !1, c;
        for(c in a)if (a.hasOwnProperty(c)) {
            var d = a[c];
            $4d82739dd229d539$var$na.hasOwnProperty(c) && $4d82739dd229d539$var$na[c] === d || ($4d82739dd229d539$var$na[c] && $4d82739dd229d539$var$t("102", c), $4d82739dd229d539$var$na[c] = d, b = !0);
        }
        b && $4d82739dd229d539$var$oa();
    }
};
function $4d82739dd229d539$var$Ea(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $4d82739dd229d539$var$va(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    c && "function" !== typeof c && $4d82739dd229d539$var$t("231", b, typeof c);
    return c;
}
function $4d82739dd229d539$var$Fa(a) {
    null !== a && ($4d82739dd229d539$var$Ba = $4d82739dd229d539$var$za($4d82739dd229d539$var$Ba, a));
    a = $4d82739dd229d539$var$Ba;
    $4d82739dd229d539$var$Ba = null;
    if (a && ($4d82739dd229d539$var$Aa(a, $4d82739dd229d539$var$Ca), $4d82739dd229d539$var$Ba && $4d82739dd229d539$var$t("95"), $4d82739dd229d539$var$ha)) throw a = $4d82739dd229d539$var$ia, $4d82739dd229d539$var$ha = !1, $4d82739dd229d539$var$ia = null, a;
}
var $4d82739dd229d539$var$Ga = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Ha = "__reactInternalInstance$" + $4d82739dd229d539$var$Ga, $4d82739dd229d539$var$Ia = "__reactEventHandlers$" + $4d82739dd229d539$var$Ga;
function $4d82739dd229d539$var$Ja(a) {
    if (a[$4d82739dd229d539$var$Ha]) return a[$4d82739dd229d539$var$Ha];
    for(; !a[$4d82739dd229d539$var$Ha];)if (a.parentNode) a = a.parentNode;
    else return null;
    a = a[$4d82739dd229d539$var$Ha];
    return 5 === a.tag || 6 === a.tag ? a : null;
}
function $4d82739dd229d539$var$Ka(a) {
    a = a[$4d82739dd229d539$var$Ha];
    return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$La(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    $4d82739dd229d539$var$t("33");
}
function $4d82739dd229d539$var$Ma(a) {
    return a[$4d82739dd229d539$var$Ia] || null;
}
function $4d82739dd229d539$var$Na(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$Oa(a, b, c) {
    if (b = $4d82739dd229d539$var$Ea(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $4d82739dd229d539$var$za(c._dispatchListeners, b), c._dispatchInstances = $4d82739dd229d539$var$za(c._dispatchInstances, a);
}
function $4d82739dd229d539$var$Pa(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $4d82739dd229d539$var$Na(b);
        for(b = c.length; 0 < b--;)$4d82739dd229d539$var$Oa(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$4d82739dd229d539$var$Oa(c[b], "bubbled", a);
    }
}
function $4d82739dd229d539$var$Qa(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $4d82739dd229d539$var$Ea(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $4d82739dd229d539$var$za(c._dispatchListeners, b), c._dispatchInstances = $4d82739dd229d539$var$za(c._dispatchInstances, a));
}
function $4d82739dd229d539$var$Ra(a) {
    a && a.dispatchConfig.registrationName && $4d82739dd229d539$var$Qa(a._targetInst, null, a);
}
function $4d82739dd229d539$var$Sa(a) {
    $4d82739dd229d539$var$Aa(a, $4d82739dd229d539$var$Pa);
}
var $4d82739dd229d539$var$Ta = !("undefined" === typeof window || !window.document || !window.document.createElement);
function $4d82739dd229d539$var$Ua(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$Va = {
    animationend: $4d82739dd229d539$var$Ua("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ua("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ua("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ua("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Wa = {}, $4d82739dd229d539$var$Xa = {};
$4d82739dd229d539$var$Ta && ($4d82739dd229d539$var$Xa = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$Va.animationend.animation, delete $4d82739dd229d539$var$Va.animationiteration.animation, delete $4d82739dd229d539$var$Va.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$Va.transitionend.transition);
function $4d82739dd229d539$var$Ya(a) {
    if ($4d82739dd229d539$var$Wa[a]) return $4d82739dd229d539$var$Wa[a];
    if (!$4d82739dd229d539$var$Va[a]) return a;
    var b = $4d82739dd229d539$var$Va[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Xa) return $4d82739dd229d539$var$Wa[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$Za = $4d82739dd229d539$var$Ya("animationend"), $4d82739dd229d539$var$$a = $4d82739dd229d539$var$Ya("animationiteration"), $4d82739dd229d539$var$ab = $4d82739dd229d539$var$Ya("animationstart"), $4d82739dd229d539$var$bb = $4d82739dd229d539$var$Ya("transitionend"), $4d82739dd229d539$var$cb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$db = null, $4d82739dd229d539$var$eb = null, $4d82739dd229d539$var$fb = null;
function $4d82739dd229d539$var$gb() {
    if ($4d82739dd229d539$var$fb) return $4d82739dd229d539$var$fb;
    var a, b = $4d82739dd229d539$var$eb, c = b.length, d, e = "value" in $4d82739dd229d539$var$db ? $4d82739dd229d539$var$db.value : $4d82739dd229d539$var$db.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$fb = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$hb() {
    return !0;
}
function $4d82739dd229d539$var$ib() {
    return !1;
}
function $4d82739dd229d539$var$A(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $4d82739dd229d539$var$hb : $4d82739dd229d539$var$ib;
    this.isPropagationStopped = $4d82739dd229d539$var$ib;
    return this;
}
$013Yp($4d82739dd229d539$var$A.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$hb);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$hb);
    },
    persist: function() {
        this.isPersistent = $4d82739dd229d539$var$hb;
    },
    isPersistent: $4d82739dd229d539$var$ib,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $4d82739dd229d539$var$ib;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$4d82739dd229d539$var$A.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$4d82739dd229d539$var$A.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $013Yp(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $013Yp({}, d.Interface, a);
    c.extend = d.extend;
    $4d82739dd229d539$var$jb(c);
    return c;
};
$4d82739dd229d539$var$jb($4d82739dd229d539$var$A);
function $4d82739dd229d539$var$kb(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $4d82739dd229d539$var$lb(a) {
    a instanceof this || $4d82739dd229d539$var$t("279");
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $4d82739dd229d539$var$jb(a) {
    a.eventPool = [];
    a.getPooled = $4d82739dd229d539$var$kb;
    a.release = $4d82739dd229d539$var$lb;
}
var $4d82739dd229d539$var$mb = $4d82739dd229d539$var$A.extend({
    data: null
}), $4d82739dd229d539$var$nb = $4d82739dd229d539$var$A.extend({
    data: null
}), $4d82739dd229d539$var$ob = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$pb = $4d82739dd229d539$var$Ta && "CompositionEvent" in window, $4d82739dd229d539$var$qb = null;
$4d82739dd229d539$var$Ta && "documentMode" in document && ($4d82739dd229d539$var$qb = document.documentMode);
var $4d82739dd229d539$var$rb = $4d82739dd229d539$var$Ta && "TextEvent" in window && !$4d82739dd229d539$var$qb, $4d82739dd229d539$var$sb = $4d82739dd229d539$var$Ta && (!$4d82739dd229d539$var$pb || $4d82739dd229d539$var$qb && 8 < $4d82739dd229d539$var$qb && 11 >= $4d82739dd229d539$var$qb), $4d82739dd229d539$var$tb = String.fromCharCode(32), $4d82739dd229d539$var$vb = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $4d82739dd229d539$var$wb = !1;
function $4d82739dd229d539$var$xb(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$ob.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$yb(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$zb = !1;
function $4d82739dd229d539$var$Ab(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$yb(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$wb = !0;
            return $4d82739dd229d539$var$tb;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$tb && $4d82739dd229d539$var$wb ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$Bb(a, b) {
    if ($4d82739dd229d539$var$zb) return "compositionend" === a || !$4d82739dd229d539$var$pb && $4d82739dd229d539$var$xb(a, b) ? (a = $4d82739dd229d539$var$gb(), $4d82739dd229d539$var$fb = $4d82739dd229d539$var$eb = $4d82739dd229d539$var$db = null, $4d82739dd229d539$var$zb = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$sb && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Cb = {
    eventTypes: $4d82739dd229d539$var$vb,
    extractEvents: function(a, b, c, d) {
        var e = void 0;
        var f = void 0;
        if ($4d82739dd229d539$var$pb) b: {
            switch(a){
                case "compositionstart":
                    e = $4d82739dd229d539$var$vb.compositionStart;
                    break b;
                case "compositionend":
                    e = $4d82739dd229d539$var$vb.compositionEnd;
                    break b;
                case "compositionupdate":
                    e = $4d82739dd229d539$var$vb.compositionUpdate;
                    break b;
            }
            e = void 0;
        }
        else $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$xb(a, c) && (e = $4d82739dd229d539$var$vb.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = $4d82739dd229d539$var$vb.compositionStart);
        e ? ($4d82739dd229d539$var$sb && "ko" !== c.locale && ($4d82739dd229d539$var$zb || e !== $4d82739dd229d539$var$vb.compositionStart ? e === $4d82739dd229d539$var$vb.compositionEnd && $4d82739dd229d539$var$zb && (f = $4d82739dd229d539$var$gb()) : ($4d82739dd229d539$var$db = d, $4d82739dd229d539$var$eb = "value" in $4d82739dd229d539$var$db ? $4d82739dd229d539$var$db.value : $4d82739dd229d539$var$db.textContent, $4d82739dd229d539$var$zb = !0)), e = $4d82739dd229d539$var$mb.getPooled(e, b, c, d), f ? e.data = f : (f = $4d82739dd229d539$var$yb(c), null !== f && (e.data = f)), $4d82739dd229d539$var$Sa(e), f = e) : f = null;
        (a = $4d82739dd229d539$var$rb ? $4d82739dd229d539$var$Ab(a, c) : $4d82739dd229d539$var$Bb(a, c)) ? (b = $4d82739dd229d539$var$nb.getPooled($4d82739dd229d539$var$vb.beforeInput, b, c, d), b.data = a, $4d82739dd229d539$var$Sa(b)) : b = null;
        return null === f ? b : null === b ? f : [
            f,
            b
        ];
    }
}, $4d82739dd229d539$var$Db = null, $4d82739dd229d539$var$Eb = null, $4d82739dd229d539$var$Fb = null;
function $4d82739dd229d539$var$Gb(a) {
    if (a = $4d82739dd229d539$var$wa(a)) {
        "function" !== typeof $4d82739dd229d539$var$Db && $4d82739dd229d539$var$t("280");
        var b = $4d82739dd229d539$var$va(a.stateNode);
        $4d82739dd229d539$var$Db(a.stateNode, a.type, b);
    }
}
function $4d82739dd229d539$var$Hb(a) {
    $4d82739dd229d539$var$Eb ? $4d82739dd229d539$var$Fb ? $4d82739dd229d539$var$Fb.push(a) : $4d82739dd229d539$var$Fb = [
        a
    ] : $4d82739dd229d539$var$Eb = a;
}
function $4d82739dd229d539$var$Ib() {
    if ($4d82739dd229d539$var$Eb) {
        var a = $4d82739dd229d539$var$Eb, b = $4d82739dd229d539$var$Fb;
        $4d82739dd229d539$var$Fb = $4d82739dd229d539$var$Eb = null;
        $4d82739dd229d539$var$Gb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Gb(b[a]);
    }
}
function $4d82739dd229d539$var$Jb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Kb(a, b, c) {
    return a(b, c);
}
function $4d82739dd229d539$var$Lb() {}
var $4d82739dd229d539$var$Mb = !1;
function $4d82739dd229d539$var$Nb(a, b) {
    if ($4d82739dd229d539$var$Mb) return a(b);
    $4d82739dd229d539$var$Mb = !0;
    try {
        return $4d82739dd229d539$var$Jb(a, b);
    } finally{
        if ($4d82739dd229d539$var$Mb = !1, null !== $4d82739dd229d539$var$Eb || null !== $4d82739dd229d539$var$Fb) $4d82739dd229d539$var$Lb(), $4d82739dd229d539$var$Ib();
    }
}
var $4d82739dd229d539$var$Ob = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$Pb(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$Ob[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$Qb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $4d82739dd229d539$var$Sb(a) {
    if (!$4d82739dd229d539$var$Ta) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
function $4d82739dd229d539$var$Tb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ub(a) {
    var b = $4d82739dd229d539$var$Tb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Vb(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ub(a));
}
function $4d82739dd229d539$var$Wb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Tb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
var $4d82739dd229d539$var$Xb = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$Yb = /^(.*)[\\\/]/, $4d82739dd229d539$var$D = "function" === typeof Symbol && Symbol.for, $4d82739dd229d539$var$Zb = $4d82739dd229d539$var$D ? Symbol.for("react.element") : 60103, $4d82739dd229d539$var$$b = $4d82739dd229d539$var$D ? Symbol.for("react.portal") : 60106, $4d82739dd229d539$var$ac = $4d82739dd229d539$var$D ? Symbol.for("react.fragment") : 60107, $4d82739dd229d539$var$bc = $4d82739dd229d539$var$D ? Symbol.for("react.strict_mode") : 60108, $4d82739dd229d539$var$cc = $4d82739dd229d539$var$D ? Symbol.for("react.profiler") : 60114, $4d82739dd229d539$var$dc = $4d82739dd229d539$var$D ? Symbol.for("react.provider") : 60109, $4d82739dd229d539$var$ec = $4d82739dd229d539$var$D ? Symbol.for("react.context") : 60110, $4d82739dd229d539$var$fc = $4d82739dd229d539$var$D ? Symbol.for("react.concurrent_mode") : 60111, $4d82739dd229d539$var$gc = $4d82739dd229d539$var$D ? Symbol.for("react.forward_ref") : 60112, $4d82739dd229d539$var$hc = $4d82739dd229d539$var$D ? Symbol.for("react.suspense") : 60113, $4d82739dd229d539$var$ic = $4d82739dd229d539$var$D ? Symbol.for("react.memo") : 60115, $4d82739dd229d539$var$jc = $4d82739dd229d539$var$D ? Symbol.for("react.lazy") : 60116, $4d82739dd229d539$var$kc = "function" === typeof Symbol && Symbol.iterator;
function $4d82739dd229d539$var$lc(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$kc && a[$4d82739dd229d539$var$kc] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $4d82739dd229d539$var$mc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$fc:
            return "ConcurrentMode";
        case $4d82739dd229d539$var$ac:
            return "Fragment";
        case $4d82739dd229d539$var$$b:
            return "Portal";
        case $4d82739dd229d539$var$cc:
            return "Profiler";
        case $4d82739dd229d539$var$bc:
            return "StrictMode";
        case $4d82739dd229d539$var$hc:
            return "Suspense";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$ec:
            return "Context.Consumer";
        case $4d82739dd229d539$var$dc:
            return "Context.Provider";
        case $4d82739dd229d539$var$gc:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $4d82739dd229d539$var$ic:
            return $4d82739dd229d539$var$mc(a.type);
        case $4d82739dd229d539$var$jc:
            if (a = 1 === a._status ? a._result : null) return $4d82739dd229d539$var$mc(a);
    }
    return null;
}
function $4d82739dd229d539$var$nc(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $4d82739dd229d539$var$mc(a.type);
                c = null;
                d && (c = $4d82739dd229d539$var$mc(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($4d82739dd229d539$var$Yb, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
var $4d82739dd229d539$var$oc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$pc = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$qc = {}, $4d82739dd229d539$var$rc = {};
function $4d82739dd229d539$var$sc(a) {
    if ($4d82739dd229d539$var$pc.call($4d82739dd229d539$var$rc, a)) return !0;
    if ($4d82739dd229d539$var$pc.call($4d82739dd229d539$var$qc, a)) return !1;
    if ($4d82739dd229d539$var$oc.test(a)) return $4d82739dd229d539$var$rc[a] = !0;
    $4d82739dd229d539$var$qc[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$tc(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$uc(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$tc(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$F(a, b, c, d, e) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
}
var $4d82739dd229d539$var$G = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 0, !1, a, null);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$G[b] = new $4d82739dd229d539$var$F(b, 1, !1, a[1], null);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 2, !1, a.toLowerCase(), null);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 2, !1, a, null);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 3, !1, a.toLowerCase(), null);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 3, !0, a, null);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 4, !1, a, null);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 6, !1, a, null);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$G[a] = new $4d82739dd229d539$var$F(a, 5, !1, a.toLowerCase(), null);
});
var $4d82739dd229d539$var$vc = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$wc(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$vc, $4d82739dd229d539$var$wc);
    $4d82739dd229d539$var$G[b] = new $4d82739dd229d539$var$F(b, 1, !1, a, null);
});
"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$vc, $4d82739dd229d539$var$wc);
    $4d82739dd229d539$var$G[b] = new $4d82739dd229d539$var$F(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$vc, $4d82739dd229d539$var$wc);
    $4d82739dd229d539$var$G[b] = new $4d82739dd229d539$var$F(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});
$4d82739dd229d539$var$G.tabIndex = new $4d82739dd229d539$var$F("tabIndex", 1, !1, "tabindex", null);
function $4d82739dd229d539$var$xc(a, b, c, d) {
    var e = $4d82739dd229d539$var$G.hasOwnProperty(b) ? $4d82739dd229d539$var$G[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($4d82739dd229d539$var$uc(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$sc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function $4d82739dd229d539$var$yc(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$zc(a, b) {
    var c = b.checked;
    return $013Yp({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Ac(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$yc(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$Bc(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$xc(a, "checked", b, !1);
}
function $4d82739dd229d539$var$Cc(a, b) {
    $4d82739dd229d539$var$Bc(a, b);
    var c = $4d82739dd229d539$var$yc(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$Dc(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$Dc(a, b.type, $4d82739dd229d539$var$yc(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$Ec(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !a.defaultChecked;
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$Dc(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$Fc = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $4d82739dd229d539$var$Gc(a, b, c) {
    a = $4d82739dd229d539$var$A.getPooled($4d82739dd229d539$var$Fc.change, a, b, c);
    a.type = "change";
    $4d82739dd229d539$var$Hb(c);
    $4d82739dd229d539$var$Sa(a);
    return a;
}
var $4d82739dd229d539$var$Hc = null, $4d82739dd229d539$var$Ic = null;
function $4d82739dd229d539$var$Jc(a) {
    $4d82739dd229d539$var$Fa(a);
}
function $4d82739dd229d539$var$Kc(a) {
    var b = $4d82739dd229d539$var$La(a);
    if ($4d82739dd229d539$var$Wb(b)) return a;
}
function $4d82739dd229d539$var$Lc(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$Mc = !1;
$4d82739dd229d539$var$Ta && ($4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Sb("input") && (!document.documentMode || 9 < document.documentMode));
function $4d82739dd229d539$var$Nc() {
    $4d82739dd229d539$var$Hc && ($4d82739dd229d539$var$Hc.detachEvent("onpropertychange", $4d82739dd229d539$var$Oc), $4d82739dd229d539$var$Ic = $4d82739dd229d539$var$Hc = null);
}
function $4d82739dd229d539$var$Oc(a) {
    "value" === a.propertyName && $4d82739dd229d539$var$Kc($4d82739dd229d539$var$Ic) && (a = $4d82739dd229d539$var$Gc($4d82739dd229d539$var$Ic, a, $4d82739dd229d539$var$Qb(a)), $4d82739dd229d539$var$Nb($4d82739dd229d539$var$Jc, a));
}
function $4d82739dd229d539$var$Pc(a, b, c) {
    "focus" === a ? ($4d82739dd229d539$var$Nc(), $4d82739dd229d539$var$Hc = b, $4d82739dd229d539$var$Ic = c, $4d82739dd229d539$var$Hc.attachEvent("onpropertychange", $4d82739dd229d539$var$Oc)) : "blur" === a && $4d82739dd229d539$var$Nc();
}
function $4d82739dd229d539$var$Qc(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$Kc($4d82739dd229d539$var$Ic);
}
function $4d82739dd229d539$var$Rc(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$Kc(b);
}
function $4d82739dd229d539$var$Sc(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$Kc(b);
}
var $4d82739dd229d539$var$Tc = {
    eventTypes: $4d82739dd229d539$var$Fc,
    _isInputEventSupported: $4d82739dd229d539$var$Mc,
    extractEvents: function(a, b, c, d) {
        var e = b ? $4d82739dd229d539$var$La(b) : window, f = void 0, g = void 0, h = e.nodeName && e.nodeName.toLowerCase();
        "select" === h || "input" === h && "file" === e.type ? f = $4d82739dd229d539$var$Lc : $4d82739dd229d539$var$Pb(e) ? $4d82739dd229d539$var$Mc ? f = $4d82739dd229d539$var$Sc : (f = $4d82739dd229d539$var$Qc, g = $4d82739dd229d539$var$Pc) : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = $4d82739dd229d539$var$Rc);
        if (f && (f = f(a, b))) return $4d82739dd229d539$var$Gc(f, c, d);
        g && g(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $4d82739dd229d539$var$Dc(e, "number", e.value);
    }
}, $4d82739dd229d539$var$Uc = $4d82739dd229d539$var$A.extend({
    view: null,
    detail: null
}), $4d82739dd229d539$var$Vc = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Wc(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Vc[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$Xc() {
    return $4d82739dd229d539$var$Wc;
}
var $4d82739dd229d539$var$Yc = 0, $4d82739dd229d539$var$Zc = 0, $4d82739dd229d539$var$$c = !1, $4d82739dd229d539$var$ad = !1, $4d82739dd229d539$var$bd = $4d82739dd229d539$var$Uc.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $4d82739dd229d539$var$Xc,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $4d82739dd229d539$var$Yc;
        $4d82739dd229d539$var$Yc = a.screenX;
        return $4d82739dd229d539$var$$c ? "mousemove" === a.type ? a.screenX - b : 0 : ($4d82739dd229d539$var$$c = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $4d82739dd229d539$var$Zc;
        $4d82739dd229d539$var$Zc = a.screenY;
        return $4d82739dd229d539$var$ad ? "mousemove" === a.type ? a.screenY - b : 0 : ($4d82739dd229d539$var$ad = !0, 0);
    }
}), $4d82739dd229d539$var$cd = $4d82739dd229d539$var$bd.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $4d82739dd229d539$var$dd = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $4d82739dd229d539$var$ed = {
    eventTypes: $4d82739dd229d539$var$dd,
    extractEvents: function(a, b, c, d) {
        var e = "mouseover" === a || "pointerover" === a, f = "mouseout" === a || "pointerout" === a;
        if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;
        e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
        f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? $4d82739dd229d539$var$Ja(b) : null) : f = null;
        if (f === b) return null;
        var g = void 0, h = void 0, l = void 0, k = void 0;
        if ("mouseout" === a || "mouseover" === a) g = $4d82739dd229d539$var$bd, h = $4d82739dd229d539$var$dd.mouseLeave, l = $4d82739dd229d539$var$dd.mouseEnter, k = "mouse";
        else if ("pointerout" === a || "pointerover" === a) g = $4d82739dd229d539$var$cd, h = $4d82739dd229d539$var$dd.pointerLeave, l = $4d82739dd229d539$var$dd.pointerEnter, k = "pointer";
        var m = null == f ? e : $4d82739dd229d539$var$La(f);
        e = null == b ? e : $4d82739dd229d539$var$La(b);
        a = g.getPooled(h, f, c, d);
        a.type = k + "leave";
        a.target = m;
        a.relatedTarget = e;
        c = g.getPooled(l, b, c, d);
        c.type = k + "enter";
        c.target = e;
        c.relatedTarget = m;
        d = b;
        if (f && d) a: {
            b = f;
            e = d;
            k = 0;
            for(g = b; g; g = $4d82739dd229d539$var$Na(g))k++;
            g = 0;
            for(l = e; l; l = $4d82739dd229d539$var$Na(l))g++;
            for(; 0 < k - g;)b = $4d82739dd229d539$var$Na(b), k--;
            for(; 0 < g - k;)e = $4d82739dd229d539$var$Na(e), g--;
            for(; k--;){
                if (b === e || b === e.alternate) break a;
                b = $4d82739dd229d539$var$Na(b);
                e = $4d82739dd229d539$var$Na(e);
            }
            b = null;
        }
        else b = null;
        e = b;
        for(b = []; f && f !== e;){
            k = f.alternate;
            if (null !== k && k === e) break;
            b.push(f);
            f = $4d82739dd229d539$var$Na(f);
        }
        for(f = []; d && d !== e;){
            k = d.alternate;
            if (null !== k && k === e) break;
            f.push(d);
            d = $4d82739dd229d539$var$Na(d);
        }
        for(d = 0; d < b.length; d++)$4d82739dd229d539$var$Qa(b[d], "bubbled", a);
        for(d = f.length; 0 < d--;)$4d82739dd229d539$var$Qa(f[d], "captured", c);
        return [
            a,
            c
        ];
    }
};
function $4d82739dd229d539$var$fd(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$gd = Object.prototype.hasOwnProperty;
function $4d82739dd229d539$var$hd(a, b) {
    if ($4d82739dd229d539$var$fd(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$4d82739dd229d539$var$gd.call(b, c[d]) || !$4d82739dd229d539$var$fd(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $4d82739dd229d539$var$kd(a) {
    var b = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        if (0 !== (b.effectTag & 2)) return 1;
        for(; b.return;)if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
    }
    return 3 === b.tag ? 2 : 3;
}
function $4d82739dd229d539$var$ld(a) {
    2 !== $4d82739dd229d539$var$kd(a) && $4d82739dd229d539$var$t("188");
}
function $4d82739dd229d539$var$md(a) {
    var b = a.alternate;
    if (!b) return b = $4d82739dd229d539$var$kd(a), 3 === b && $4d82739dd229d539$var$t("188"), 1 === b ? null : a;
    for(var c = a, d = b;;){
        var e = c.return, f = e ? e.alternate : null;
        if (!e || !f) break;
        if (e.child === f.child) {
            for(var g = e.child; g;){
                if (g === c) return $4d82739dd229d539$var$ld(e), a;
                if (g === d) return $4d82739dd229d539$var$ld(e), b;
                g = g.sibling;
            }
            $4d82739dd229d539$var$t("188");
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            g = !1;
            for(var h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                g || $4d82739dd229d539$var$t("189");
            }
        }
        c.alternate !== d && $4d82739dd229d539$var$t("190");
    }
    3 !== c.tag && $4d82739dd229d539$var$t("188");
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$nd(a) {
    a = $4d82739dd229d539$var$md(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
var $4d82739dd229d539$var$od = $4d82739dd229d539$var$A.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $4d82739dd229d539$var$pd = $4d82739dd229d539$var$A.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$qd = $4d82739dd229d539$var$Uc.extend({
    relatedTarget: null
});
function $4d82739dd229d539$var$rd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $4d82739dd229d539$var$sd = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$td = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$ud = $4d82739dd229d539$var$Uc.extend({
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$sd[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$rd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$td[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $4d82739dd229d539$var$Xc,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$rd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$rd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$bd.extend({
    dataTransfer: null
}), $4d82739dd229d539$var$wd = $4d82739dd229d539$var$Uc.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $4d82739dd229d539$var$Xc
}), $4d82739dd229d539$var$xd = $4d82739dd229d539$var$A.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $4d82739dd229d539$var$yd = $4d82739dd229d539$var$bd.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $4d82739dd229d539$var$zd = [
    [
        "abort",
        "abort"
    ],
    [
        $4d82739dd229d539$var$Za,
        "animationEnd"
    ],
    [
        $4d82739dd229d539$var$$a,
        "animationIteration"
    ],
    [
        $4d82739dd229d539$var$ab,
        "animationStart"
    ],
    [
        "canplay",
        "canPlay"
    ],
    [
        "canplaythrough",
        "canPlayThrough"
    ],
    [
        "drag",
        "drag"
    ],
    [
        "dragenter",
        "dragEnter"
    ],
    [
        "dragexit",
        "dragExit"
    ],
    [
        "dragleave",
        "dragLeave"
    ],
    [
        "dragover",
        "dragOver"
    ],
    [
        "durationchange",
        "durationChange"
    ],
    [
        "emptied",
        "emptied"
    ],
    [
        "encrypted",
        "encrypted"
    ],
    [
        "ended",
        "ended"
    ],
    [
        "error",
        "error"
    ],
    [
        "gotpointercapture",
        "gotPointerCapture"
    ],
    [
        "load",
        "load"
    ],
    [
        "loadeddata",
        "loadedData"
    ],
    [
        "loadedmetadata",
        "loadedMetadata"
    ],
    [
        "loadstart",
        "loadStart"
    ],
    [
        "lostpointercapture",
        "lostPointerCapture"
    ],
    [
        "mousemove",
        "mouseMove"
    ],
    [
        "mouseout",
        "mouseOut"
    ],
    [
        "mouseover",
        "mouseOver"
    ],
    [
        "playing",
        "playing"
    ],
    [
        "pointermove",
        "pointerMove"
    ],
    [
        "pointerout",
        "pointerOut"
    ],
    [
        "pointerover",
        "pointerOver"
    ],
    [
        "progress",
        "progress"
    ],
    [
        "scroll",
        "scroll"
    ],
    [
        "seeking",
        "seeking"
    ],
    [
        "stalled",
        "stalled"
    ],
    [
        "suspend",
        "suspend"
    ],
    [
        "timeupdate",
        "timeUpdate"
    ],
    [
        "toggle",
        "toggle"
    ],
    [
        "touchmove",
        "touchMove"
    ],
    [
        $4d82739dd229d539$var$bb,
        "transitionEnd"
    ],
    [
        "waiting",
        "waiting"
    ],
    [
        "wheel",
        "wheel"
    ]
], $4d82739dd229d539$var$Ad = {}, $4d82739dd229d539$var$Bd = {};
function $4d82739dd229d539$var$Cd(a, b) {
    var c = a[0];
    a = a[1];
    var d = "on" + (a[0].toUpperCase() + a.slice(1));
    b = {
        phasedRegistrationNames: {
            bubbled: d,
            captured: d + "Capture"
        },
        dependencies: [
            c
        ],
        isInteractive: b
    };
    $4d82739dd229d539$var$Ad[a] = b;
    $4d82739dd229d539$var$Bd[c] = b;
}
[
    [
        "blur",
        "blur"
    ],
    [
        "cancel",
        "cancel"
    ],
    [
        "click",
        "click"
    ],
    [
        "close",
        "close"
    ],
    [
        "contextmenu",
        "contextMenu"
    ],
    [
        "copy",
        "copy"
    ],
    [
        "cut",
        "cut"
    ],
    [
        "auxclick",
        "auxClick"
    ],
    [
        "dblclick",
        "doubleClick"
    ],
    [
        "dragend",
        "dragEnd"
    ],
    [
        "dragstart",
        "dragStart"
    ],
    [
        "drop",
        "drop"
    ],
    [
        "focus",
        "focus"
    ],
    [
        "input",
        "input"
    ],
    [
        "invalid",
        "invalid"
    ],
    [
        "keydown",
        "keyDown"
    ],
    [
        "keypress",
        "keyPress"
    ],
    [
        "keyup",
        "keyUp"
    ],
    [
        "mousedown",
        "mouseDown"
    ],
    [
        "mouseup",
        "mouseUp"
    ],
    [
        "paste",
        "paste"
    ],
    [
        "pause",
        "pause"
    ],
    [
        "play",
        "play"
    ],
    [
        "pointercancel",
        "pointerCancel"
    ],
    [
        "pointerdown",
        "pointerDown"
    ],
    [
        "pointerup",
        "pointerUp"
    ],
    [
        "ratechange",
        "rateChange"
    ],
    [
        "reset",
        "reset"
    ],
    [
        "seeked",
        "seeked"
    ],
    [
        "submit",
        "submit"
    ],
    [
        "touchcancel",
        "touchCancel"
    ],
    [
        "touchend",
        "touchEnd"
    ],
    [
        "touchstart",
        "touchStart"
    ],
    [
        "volumechange",
        "volumeChange"
    ]
].forEach(function(a) {
    $4d82739dd229d539$var$Cd(a, !0);
});
$4d82739dd229d539$var$zd.forEach(function(a) {
    $4d82739dd229d539$var$Cd(a, !1);
});
var $4d82739dd229d539$var$Dd = {
    eventTypes: $4d82739dd229d539$var$Ad,
    isInteractiveTopLevelEventType: function(a) {
        a = $4d82739dd229d539$var$Bd[a];
        return void 0 !== a && !0 === a.isInteractive;
    },
    extractEvents: function(a, b, c, d) {
        var e = $4d82739dd229d539$var$Bd[a];
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $4d82739dd229d539$var$rd(c)) return null;
            case "keydown":
            case "keyup":
                a = $4d82739dd229d539$var$ud;
                break;
            case "blur":
            case "focus":
                a = $4d82739dd229d539$var$qd;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $4d82739dd229d539$var$bd;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $4d82739dd229d539$var$vd;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $4d82739dd229d539$var$wd;
                break;
            case $4d82739dd229d539$var$Za:
            case $4d82739dd229d539$var$$a:
            case $4d82739dd229d539$var$ab:
                a = $4d82739dd229d539$var$od;
                break;
            case $4d82739dd229d539$var$bb:
                a = $4d82739dd229d539$var$xd;
                break;
            case "scroll":
                a = $4d82739dd229d539$var$Uc;
                break;
            case "wheel":
                a = $4d82739dd229d539$var$yd;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $4d82739dd229d539$var$pd;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $4d82739dd229d539$var$cd;
                break;
            default:
                a = $4d82739dd229d539$var$A;
        }
        b = a.getPooled(e, b, c, d);
        $4d82739dd229d539$var$Sa(b);
        return b;
    }
}, $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$Dd.isInteractiveTopLevelEventType, $4d82739dd229d539$var$Fd = [];
function $4d82739dd229d539$var$Gd(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d;
        for(d = c; d.return;)d = d.return;
        d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        if (!d) break;
        a.ancestors.push(c);
        c = $4d82739dd229d539$var$Ja(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $4d82739dd229d539$var$Qb(a.nativeEvent);
        d = a.topLevelType;
        for(var f = a.nativeEvent, g = null, h = 0; h < $4d82739dd229d539$var$pa.length; h++){
            var l = $4d82739dd229d539$var$pa[h];
            l && (l = l.extractEvents(d, b, f, e)) && (g = $4d82739dd229d539$var$za(g, l));
        }
        $4d82739dd229d539$var$Fa(g);
    }
}
var $4d82739dd229d539$var$Hd = !0;
function $4d82739dd229d539$var$H(a, b) {
    if (!b) return null;
    var c = ($4d82739dd229d539$var$Ed(a) ? $4d82739dd229d539$var$Id : $4d82739dd229d539$var$Jd).bind(null, a);
    b.addEventListener(a, c, !1);
}
function $4d82739dd229d539$var$Kd(a, b) {
    if (!b) return null;
    var c = ($4d82739dd229d539$var$Ed(a) ? $4d82739dd229d539$var$Id : $4d82739dd229d539$var$Jd).bind(null, a);
    b.addEventListener(a, c, !0);
}
function $4d82739dd229d539$var$Id(a, b) {
    $4d82739dd229d539$var$Kb($4d82739dd229d539$var$Jd, a, b);
}
function $4d82739dd229d539$var$Jd(a, b) {
    if ($4d82739dd229d539$var$Hd) {
        var c = $4d82739dd229d539$var$Qb(b);
        c = $4d82739dd229d539$var$Ja(c);
        null === c || "number" !== typeof c.tag || 2 === $4d82739dd229d539$var$kd(c) || (c = null);
        if ($4d82739dd229d539$var$Fd.length) {
            var d = $4d82739dd229d539$var$Fd.pop();
            d.topLevelType = a;
            d.nativeEvent = b;
            d.targetInst = c;
            a = d;
        } else a = {
            topLevelType: a,
            nativeEvent: b,
            targetInst: c,
            ancestors: []
        };
        try {
            $4d82739dd229d539$var$Nb($4d82739dd229d539$var$Gd, a);
        } finally{
            a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > $4d82739dd229d539$var$Fd.length && $4d82739dd229d539$var$Fd.push(a);
        }
    }
}
var $4d82739dd229d539$var$Ld = {}, $4d82739dd229d539$var$Md = 0, $4d82739dd229d539$var$Nd = "_reactListenersID" + ("" + Math.random()).slice(2);
function $4d82739dd229d539$var$Od(a) {
    Object.prototype.hasOwnProperty.call(a, $4d82739dd229d539$var$Nd) || (a[$4d82739dd229d539$var$Nd] = $4d82739dd229d539$var$Md++, $4d82739dd229d539$var$Ld[a[$4d82739dd229d539$var$Nd]] = {});
    return $4d82739dd229d539$var$Ld[a[$4d82739dd229d539$var$Nd]];
}
function $4d82739dd229d539$var$Pd(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Qd(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Rd(a, b) {
    var c = $4d82739dd229d539$var$Qd(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Qd(c);
    }
}
function $4d82739dd229d539$var$Sd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Sd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Td() {
    for(var a = window, b = $4d82739dd229d539$var$Pd(); b instanceof a.HTMLIFrameElement;){
        try {
            a = b.contentDocument.defaultView;
        } catch (c) {
            break;
        }
        b = $4d82739dd229d539$var$Pd(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ud(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$Ta && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Wd = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $4d82739dd229d539$var$Xd = null, $4d82739dd229d539$var$Yd = null, $4d82739dd229d539$var$Zd = null, $4d82739dd229d539$var$$d = !1;
function $4d82739dd229d539$var$ae(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($4d82739dd229d539$var$$d || null == $4d82739dd229d539$var$Xd || $4d82739dd229d539$var$Xd !== $4d82739dd229d539$var$Pd(c)) return null;
    c = $4d82739dd229d539$var$Xd;
    "selectionStart" in c && $4d82739dd229d539$var$Ud(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $4d82739dd229d539$var$Zd && $4d82739dd229d539$var$hd($4d82739dd229d539$var$Zd, c) ? null : ($4d82739dd229d539$var$Zd = c, a = $4d82739dd229d539$var$A.getPooled($4d82739dd229d539$var$Wd.select, $4d82739dd229d539$var$Yd, a, b), a.type = "select", a.target = $4d82739dd229d539$var$Xd, $4d82739dd229d539$var$Sa(a), a);
}
var $4d82739dd229d539$var$be = {
    eventTypes: $4d82739dd229d539$var$Wd,
    extractEvents: function(a, b, c, d) {
        var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument, f;
        if (!(f = !e)) {
            a: {
                e = $4d82739dd229d539$var$Od(e);
                f = $4d82739dd229d539$var$ua.onSelect;
                for(var g = 0; g < f.length; g++){
                    var h = f[g];
                    if (!e.hasOwnProperty(h) || !e[h]) {
                        e = !1;
                        break a;
                    }
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $4d82739dd229d539$var$La(b) : window;
        switch(a){
            case "focus":
                if ($4d82739dd229d539$var$Pb(e) || "true" === e.contentEditable) $4d82739dd229d539$var$Xd = e, $4d82739dd229d539$var$Yd = b, $4d82739dd229d539$var$Zd = null;
                break;
            case "blur":
                $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$Xd = null;
                break;
            case "mousedown":
                $4d82739dd229d539$var$$d = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $4d82739dd229d539$var$$d = !1, $4d82739dd229d539$var$ae(c, d);
            case "selectionchange":
                if ($4d82739dd229d539$var$Vd) break;
            case "keydown":
            case "keyup":
                return $4d82739dd229d539$var$ae(c, d);
        }
        return null;
    }
};
$4d82739dd229d539$var$Da.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$4d82739dd229d539$var$va = $4d82739dd229d539$var$Ma;
$4d82739dd229d539$var$wa = $4d82739dd229d539$var$Ka;
$4d82739dd229d539$var$xa = $4d82739dd229d539$var$La;
$4d82739dd229d539$var$Da.injectEventPluginsByName({
    SimpleEventPlugin: $4d82739dd229d539$var$Dd,
    EnterLeaveEventPlugin: $4d82739dd229d539$var$ed,
    ChangeEventPlugin: $4d82739dd229d539$var$Tc,
    SelectEventPlugin: $4d82739dd229d539$var$be,
    BeforeInputEventPlugin: $4d82739dd229d539$var$Cb
});
function $4d82739dd229d539$var$ce(a) {
    var b = "";
    $7fPBF.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $4d82739dd229d539$var$de(a, b) {
    a = $013Yp({
        children: void 0
    }, b);
    if (b = $4d82739dd229d539$var$ce(b.children)) a.children = b;
    return a;
}
function $4d82739dd229d539$var$ee(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$yc(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$fe(a, b) {
    null != b.dangerouslySetInnerHTML && $4d82739dd229d539$var$t("91");
    return $013Yp({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$ge(a, b) {
    var c = b.value;
    null == c && (c = b.defaultValue, b = b.children, null != b && (null != c && $4d82739dd229d539$var$t("92"), Array.isArray(b) && (1 >= b.length || $4d82739dd229d539$var$t("93"), b = b[0]), c = b), null == c && (c = ""));
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$yc(c)
    };
}
function $4d82739dd229d539$var$he(a, b) {
    var c = $4d82739dd229d539$var$yc(b.value), d = $4d82739dd229d539$var$yc(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$ie(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && (a.value = b);
}
var $4d82739dd229d539$var$je = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $4d82739dd229d539$var$ke(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$le(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$ke(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$me = void 0, $4d82739dd229d539$var$ne = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $4d82739dd229d539$var$je.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$me = $4d82739dd229d539$var$me || document.createElement("div");
        $4d82739dd229d539$var$me.innerHTML = "<svg>" + b + "</svg>";
        for(b = $4d82739dd229d539$var$me.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$oe(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pe = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qe = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pe).forEach(function(a) {
    $4d82739dd229d539$var$qe.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pe[b] = $4d82739dd229d539$var$pe[a];
    });
});
function $4d82739dd229d539$var$re(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pe.hasOwnProperty(a) && $4d82739dd229d539$var$pe[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$se(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$re(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$te = $013Yp({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ue(a, b) {
    b && ($4d82739dd229d539$var$te[a] && (null != b.children || null != b.dangerouslySetInnerHTML) && $4d82739dd229d539$var$t("137", a, ""), null != b.dangerouslySetInnerHTML && (null != b.children && $4d82739dd229d539$var$t("60"), "object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML || $4d82739dd229d539$var$t("61")), null != b.style && "object" !== typeof b.style && $4d82739dd229d539$var$t("62", ""));
}
function $4d82739dd229d539$var$ve(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $4d82739dd229d539$var$we(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $4d82739dd229d539$var$Od(a);
    b = $4d82739dd229d539$var$ua[b];
    for(var d = 0; d < b.length; d++){
        var e = b[d];
        if (!c.hasOwnProperty(e) || !c[e]) {
            switch(e){
                case "scroll":
                    $4d82739dd229d539$var$Kd("scroll", a);
                    break;
                case "focus":
                case "blur":
                    $4d82739dd229d539$var$Kd("focus", a);
                    $4d82739dd229d539$var$Kd("blur", a);
                    c.blur = !0;
                    c.focus = !0;
                    break;
                case "cancel":
                case "close":
                    $4d82739dd229d539$var$Sb(e) && $4d82739dd229d539$var$Kd(e, a);
                    break;
                case "invalid":
                case "submit":
                case "reset":
                    break;
                default:
                    -1 === $4d82739dd229d539$var$cb.indexOf(e) && $4d82739dd229d539$var$H(e, a);
            }
            c[e] = !0;
        }
    }
}
function $4d82739dd229d539$var$xe() {}
var $4d82739dd229d539$var$ye = null, $4d82739dd229d539$var$ze = null;
function $4d82739dd229d539$var$Ae(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $4d82739dd229d539$var$Be(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ce = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$De = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Ee = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$Fe = $33s19.unstable_cancelCallback;
function $4d82739dd229d539$var$Ge(a, b, c, d, e) {
    a[$4d82739dd229d539$var$Ia] = e;
    "input" === c && "radio" === e.type && null != e.name && $4d82739dd229d539$var$Bc(a, e);
    $4d82739dd229d539$var$ve(c, d);
    d = $4d82739dd229d539$var$ve(c, e);
    for(var f = 0; f < b.length; f += 2){
        var g = b[f], h = b[f + 1];
        "style" === g ? $4d82739dd229d539$var$se(a, h) : "dangerouslySetInnerHTML" === g ? $4d82739dd229d539$var$ne(a, h) : "children" === g ? $4d82739dd229d539$var$oe(a, h) : $4d82739dd229d539$var$xc(a, g, h, d);
    }
    switch(c){
        case "input":
            $4d82739dd229d539$var$Cc(a, e);
            break;
        case "textarea":
            $4d82739dd229d539$var$he(a, e);
            break;
        case "select":
            b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? $4d82739dd229d539$var$ee(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? $4d82739dd229d539$var$ee(a, !!e.multiple, e.defaultValue, !0) : $4d82739dd229d539$var$ee(a, !!e.multiple, e.multiple ? [] : "", !1));
    }
}
function $4d82739dd229d539$var$He(a) {
    for(a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;)a = a.nextSibling;
    return a;
}
function $4d82739dd229d539$var$Ie(a) {
    for(a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;)a = a.nextSibling;
    return a;
}
new Set;
var $4d82739dd229d539$var$Je = [], $4d82739dd229d539$var$Ke = -1;
function $4d82739dd229d539$var$I(a) {
    0 > $4d82739dd229d539$var$Ke || (a.current = $4d82739dd229d539$var$Je[$4d82739dd229d539$var$Ke], $4d82739dd229d539$var$Je[$4d82739dd229d539$var$Ke] = null, $4d82739dd229d539$var$Ke--);
}
function $4d82739dd229d539$var$J(a, b) {
    $4d82739dd229d539$var$Ke++;
    $4d82739dd229d539$var$Je[$4d82739dd229d539$var$Ke] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Le = {}, $4d82739dd229d539$var$K = {
    current: $4d82739dd229d539$var$Le
}, $4d82739dd229d539$var$L = {
    current: !1
}, $4d82739dd229d539$var$Me = $4d82739dd229d539$var$Le;
function $4d82739dd229d539$var$Oe(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Le;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$M(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$Pe(a) {
    $4d82739dd229d539$var$I($4d82739dd229d539$var$L, a);
    $4d82739dd229d539$var$I($4d82739dd229d539$var$K, a);
}
function $4d82739dd229d539$var$Qe(a) {
    $4d82739dd229d539$var$I($4d82739dd229d539$var$L, a);
    $4d82739dd229d539$var$I($4d82739dd229d539$var$K, a);
}
function $4d82739dd229d539$var$Re(a, b, c) {
    $4d82739dd229d539$var$K.current !== $4d82739dd229d539$var$Le && $4d82739dd229d539$var$t("168");
    $4d82739dd229d539$var$J($4d82739dd229d539$var$K, b, a);
    $4d82739dd229d539$var$J($4d82739dd229d539$var$L, c, a);
}
function $4d82739dd229d539$var$Se(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)e in a || $4d82739dd229d539$var$t("108", $4d82739dd229d539$var$mc(b) || "Unknown", e);
    return $013Yp({}, c, d);
}
function $4d82739dd229d539$var$Te(a) {
    var b = a.stateNode;
    b = b && b.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Le;
    $4d82739dd229d539$var$Me = $4d82739dd229d539$var$K.current;
    $4d82739dd229d539$var$J($4d82739dd229d539$var$K, b, a);
    $4d82739dd229d539$var$J($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current, a);
    return !0;
}
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = a.stateNode;
    d || $4d82739dd229d539$var$t("169");
    c ? (b = $4d82739dd229d539$var$Se(a, b, $4d82739dd229d539$var$Me), d.__reactInternalMemoizedMergedChildContext = b, $4d82739dd229d539$var$I($4d82739dd229d539$var$L, a), $4d82739dd229d539$var$I($4d82739dd229d539$var$K, a), $4d82739dd229d539$var$J($4d82739dd229d539$var$K, b, a)) : $4d82739dd229d539$var$I($4d82739dd229d539$var$L, a);
    $4d82739dd229d539$var$J($4d82739dd229d539$var$L, c, a);
}
var $4d82739dd229d539$var$Ve = null, $4d82739dd229d539$var$We = null;
function $4d82739dd229d539$var$Xe(a) {
    return function(b) {
        try {
            return a(b);
        } catch (c) {}
    };
}
function $4d82739dd229d539$var$Ye(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $4d82739dd229d539$var$Ve = $4d82739dd229d539$var$Xe(function(a) {
            return b.onCommitFiberRoot(c, a);
        });
        $4d82739dd229d539$var$We = $4d82739dd229d539$var$Xe(function(a) {
            return b.onCommitFiberUnmount(c, a);
        });
    } catch (d) {}
    return !0;
}
function $4d82739dd229d539$var$Ze(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.contextDependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$N(a, b, c, d) {
    return new $4d82739dd229d539$var$Ze(a, b, c, d);
}
function $4d82739dd229d539$var$$e(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$af(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$$e(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$gc) return 11;
        if (a === $4d82739dd229d539$var$ic) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$bf(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$N(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    c.contextDependencies = a.contextDependencies;
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$cf(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$$e(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ac:
            return $4d82739dd229d539$var$df(c.children, e, f, b);
        case $4d82739dd229d539$var$fc:
            return $4d82739dd229d539$var$ef(c, e | 3, f, b);
        case $4d82739dd229d539$var$bc:
            return $4d82739dd229d539$var$ef(c, e | 2, f, b);
        case $4d82739dd229d539$var$cc:
            return a = $4d82739dd229d539$var$N(12, c, b, e | 4), a.elementType = $4d82739dd229d539$var$cc, a.type = $4d82739dd229d539$var$cc, a.expirationTime = f, a;
        case $4d82739dd229d539$var$hc:
            return a = $4d82739dd229d539$var$N(13, c, b, e), a.elementType = $4d82739dd229d539$var$hc, a.type = $4d82739dd229d539$var$hc, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$dc:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$ec:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$gc:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$ic:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$jc:
                    g = 16;
                    d = null;
                    break a;
            }
            $4d82739dd229d539$var$t("130", null == a ? a : typeof a, "");
    }
    b = $4d82739dd229d539$var$N(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $4d82739dd229d539$var$df(a, b, c, d) {
    a = $4d82739dd229d539$var$N(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $4d82739dd229d539$var$ef(a, b, c, d) {
    a = $4d82739dd229d539$var$N(8, a, d, b);
    b = 0 === (b & 1) ? $4d82739dd229d539$var$bc : $4d82739dd229d539$var$fc;
    a.elementType = b;
    a.type = b;
    a.expirationTime = c;
    return a;
}
function $4d82739dd229d539$var$ff(a, b, c) {
    a = $4d82739dd229d539$var$N(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $4d82739dd229d539$var$gf(a, b, c) {
    b = $4d82739dd229d539$var$N(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$hf(a, b) {
    a.didError = !1;
    var c = a.earliestPendingTime;
    0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c < b ? a.earliestPendingTime = b : a.latestPendingTime > b && (a.latestPendingTime = b);
    $4d82739dd229d539$var$jf(b, a);
}
function $4d82739dd229d539$var$kf(a, b) {
    a.didError = !1;
    a.latestPingedTime >= b && (a.latestPingedTime = 0);
    var c = a.earliestPendingTime, d = a.latestPendingTime;
    c === b ? a.earliestPendingTime = d === b ? a.latestPendingTime = 0 : d : d === b && (a.latestPendingTime = c);
    c = a.earliestSuspendedTime;
    d = a.latestSuspendedTime;
    0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = b : c < b ? a.earliestSuspendedTime = b : d > b && (a.latestSuspendedTime = b);
    $4d82739dd229d539$var$jf(b, a);
}
function $4d82739dd229d539$var$lf(a, b) {
    var c = a.earliestPendingTime;
    a = a.earliestSuspendedTime;
    c > b && (b = c);
    a > b && (b = a);
    return b;
}
function $4d82739dd229d539$var$jf(a, b) {
    var c = b.earliestSuspendedTime, d = b.latestSuspendedTime, e = b.earliestPendingTime, f = b.latestPingedTime;
    e = 0 !== e ? e : f;
    0 === e && (0 === a || d < a) && (e = d);
    a = e;
    0 !== a && c > a && (a = c);
    b.nextExpirationTimeToWorkOn = e;
    b.expirationTime = a;
}
function $4d82739dd229d539$var$P(a, b) {
    if (a && a.defaultProps) {
        b = $013Yp({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
function $4d82739dd229d539$var$mf(a) {
    var b = a._result;
    switch(a._status){
        case 1:
            return b;
        case 2:
            throw b;
        case 0:
            throw b;
        default:
            a._status = 0;
            b = a._ctor;
            b = b();
            b.then(function(b) {
                0 === a._status && (b = b.default, a._status = 1, a._result = b);
            }, function(b) {
                0 === a._status && (a._status = 2, a._result = b);
            });
            switch(a._status){
                case 1:
                    return a._result;
                case 2:
                    throw a._result;
            }
            a._result = b;
            throw b;
    }
}
var $4d82739dd229d539$var$nf = (new $7fPBF.Component).refs;
function $4d82739dd229d539$var$of(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $013Yp({}, b, c);
    a.memoizedState = c;
    d = a.updateQueue;
    null !== d && 0 === a.expirationTime && (d.baseState = c);
}
var $4d82739dd229d539$var$xf = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? 2 === $4d82739dd229d539$var$kd(a) : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $4d82739dd229d539$var$pf();
        d = $4d82739dd229d539$var$qf(d, a);
        var e = $4d82739dd229d539$var$rf(d);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $4d82739dd229d539$var$sf();
        $4d82739dd229d539$var$tf(a, e);
        $4d82739dd229d539$var$uf(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $4d82739dd229d539$var$pf();
        d = $4d82739dd229d539$var$qf(d, a);
        var e = $4d82739dd229d539$var$rf(d);
        e.tag = $4d82739dd229d539$var$vf;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $4d82739dd229d539$var$sf();
        $4d82739dd229d539$var$tf(a, e);
        $4d82739dd229d539$var$uf(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $4d82739dd229d539$var$pf();
        c = $4d82739dd229d539$var$qf(c, a);
        var d = $4d82739dd229d539$var$rf(c);
        d.tag = $4d82739dd229d539$var$wf;
        void 0 !== b && null !== b && (d.callback = b);
        $4d82739dd229d539$var$sf();
        $4d82739dd229d539$var$tf(a, d);
        $4d82739dd229d539$var$uf(a, c);
    }
};
function $4d82739dd229d539$var$yf(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$hd(c, d) || !$4d82739dd229d539$var$hd(e, f) : !0;
}
function $4d82739dd229d539$var$zf(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Le;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$Af(f) : (e = $4d82739dd229d539$var$M(b) ? $4d82739dd229d539$var$Me : $4d82739dd229d539$var$K.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Oe(a, e) : $4d82739dd229d539$var$Le);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$xf;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Bf(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$xf.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Cf(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $4d82739dd229d539$var$nf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$Af(f) : (f = $4d82739dd229d539$var$M(b) ? $4d82739dd229d539$var$Me : $4d82739dd229d539$var$K.current, e.context = $4d82739dd229d539$var$Oe(a, f));
    f = a.updateQueue;
    null !== f && ($4d82739dd229d539$var$Df(a, f, c, e, d), e.state = a.memoizedState);
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$of(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$xf.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && ($4d82739dd229d539$var$Df(a, f, c, e, d), e.state = a.memoizedState));
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $4d82739dd229d539$var$Ef = Array.isArray;
function $4d82739dd229d539$var$Ff(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            var d = void 0;
            c && (1 !== c.tag && $4d82739dd229d539$var$t("309"), d = c.stateNode);
            d || $4d82739dd229d539$var$t("147", a);
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $4d82739dd229d539$var$nf && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        "string" !== typeof a && $4d82739dd229d539$var$t("284");
        c._owner || $4d82739dd229d539$var$t("290", a);
    }
    return a;
}
function $4d82739dd229d539$var$Gf(a, b) {
    "textarea" !== a.type && $4d82739dd229d539$var$t("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function $4d82739dd229d539$var$Hf(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b, c) {
        a = $4d82739dd229d539$var$bf(a, b, c);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$ff(c, a.mode, d), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function l(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props, d), d.ref = $4d82739dd229d539$var$Ff(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$cf(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Ff(a, b, c);
        d.return = a;
        return d;
    }
    function k(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$gf(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || [], d);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$df(c, a.mode, d, f), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $4d82739dd229d539$var$ff("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$Zb:
                    return c = $4d82739dd229d539$var$cf(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Ff(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$$b:
                    return b = $4d82739dd229d539$var$gf(b, a.mode, c), b.return = a, b;
            }
            if ($4d82739dd229d539$var$Ef(b) || $4d82739dd229d539$var$lc(b)) return b = $4d82739dd229d539$var$df(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Gf(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$Zb:
                    return c.key === e ? c.type === $4d82739dd229d539$var$ac ? m(a, b, c.props.children, d, e) : l(a, b, c, d) : null;
                case $4d82739dd229d539$var$$b:
                    return c.key === e ? k(a, b, c, d) : null;
            }
            if ($4d82739dd229d539$var$Ef(c) || $4d82739dd229d539$var$lc(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Gf(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$Zb:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $4d82739dd229d539$var$ac ? m(b, a, d.props.children, e, d.key) : l(b, a, d, e);
                case $4d82739dd229d539$var$$b:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
            }
            if ($4d82739dd229d539$var$Ef(d) || $4d82739dd229d539$var$lc(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Gf(b, d);
        }
        return null;
    }
    function w(e, g, h, k) {
        for(var l = null, m = null, n = g, u = g = 0, r = null; null !== n && u < h.length; u++){
            n.index > u ? (r = n, n = null) : r = n.sibling;
            var v = x(e, n, h[u], k);
            if (null === v) {
                null === n && (n = r);
                break;
            }
            a && n && null === v.alternate && b(e, n);
            g = f(v, g, u);
            null === m ? l = v : m.sibling = v;
            m = v;
            n = r;
        }
        if (u === h.length) return c(e, n), l;
        if (null === n) {
            for(; u < h.length; u++)if (n = q(e, h[u], k)) g = f(n, g, u), null === m ? l = n : m.sibling = n, m = n;
            return l;
        }
        for(n = d(e, n); u < h.length; u++)if (r = C(n, e, u, h[u], k)) a && null !== r.alternate && n.delete(null === r.key ? u : r.key), g = f(r, g, u), null === m ? l = r : m.sibling = r, m = r;
        a && n.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function E(e, g, h, k) {
        var l = $4d82739dd229d539$var$lc(h);
        "function" !== typeof l && $4d82739dd229d539$var$t("150");
        h = l.call(h);
        null == h && $4d82739dd229d539$var$t("151");
        for(var m = l = null, n = g, u = g = 0, r = null, v = h.next(); null !== n && !v.done; u++, v = h.next()){
            n.index > u ? (r = n, n = null) : r = n.sibling;
            var z = x(e, n, v.value, k);
            if (null === z) {
                n || (n = r);
                break;
            }
            a && n && null === z.alternate && b(e, n);
            g = f(z, g, u);
            null === m ? l = z : m.sibling = z;
            m = z;
            n = r;
        }
        if (v.done) return c(e, n), l;
        if (null === n) {
            for(; !v.done; u++, v = h.next())v = q(e, v.value, k), null !== v && (g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);
            return l;
        }
        for(n = d(e, n); !v.done; u++, v = h.next())v = C(n, e, u, v.value, k), null !== v && (a && null !== v.alternate && n.delete(null === v.key ? u : v.key), g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ac && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $4d82739dd229d539$var$Zb:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            if (7 === k.tag ? f.type === $4d82739dd229d539$var$ac : k.elementType === f.type) {
                                c(a, k.sibling);
                                d = e(k, f.type === $4d82739dd229d539$var$ac ? f.props.children : f.props, h);
                                d.ref = $4d82739dd229d539$var$Ff(a, k, f);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, k);
                                break;
                            }
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $4d82739dd229d539$var$ac ? (d = $4d82739dd229d539$var$df(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$cf(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Ff(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $4d82739dd229d539$var$$b:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || [], h);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $4d82739dd229d539$var$gf(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$ff(f, a.mode, h), d.return = a, a = d), g(a);
        if ($4d82739dd229d539$var$Ef(f)) return w(a, d, f, h);
        if ($4d82739dd229d539$var$lc(f)) return E(a, d, f, h);
        l && $4d82739dd229d539$var$Gf(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                h = a.type, $4d82739dd229d539$var$t("152", h.displayName || h.name || "Component");
        }
        return c(a, d);
    };
}
var $4d82739dd229d539$var$If = $4d82739dd229d539$var$Hf(!0), $4d82739dd229d539$var$Jf = $4d82739dd229d539$var$Hf(!1), $4d82739dd229d539$var$Kf = {}, $4d82739dd229d539$var$Lf = {
    current: $4d82739dd229d539$var$Kf
}, $4d82739dd229d539$var$Mf = {
    current: $4d82739dd229d539$var$Kf
}, $4d82739dd229d539$var$Nf = {
    current: $4d82739dd229d539$var$Kf
};
function $4d82739dd229d539$var$Of(a) {
    a === $4d82739dd229d539$var$Kf && $4d82739dd229d539$var$t("174");
    return a;
}
function $4d82739dd229d539$var$Pf(a, b) {
    $4d82739dd229d539$var$J($4d82739dd229d539$var$Nf, b, a);
    $4d82739dd229d539$var$J($4d82739dd229d539$var$Mf, a, a);
    $4d82739dd229d539$var$J($4d82739dd229d539$var$Lf, $4d82739dd229d539$var$Kf, a);
    var c = b.nodeType;
    switch(c){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$le(null, "");
            break;
        default:
            c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = $4d82739dd229d539$var$le(b, c);
    }
    $4d82739dd229d539$var$I($4d82739dd229d539$var$Lf, a);
    $4d82739dd229d539$var$J($4d82739dd229d539$var$Lf, b, a);
}
function $4d82739dd229d539$var$Qf(a) {
    $4d82739dd229d539$var$I($4d82739dd229d539$var$Lf, a);
    $4d82739dd229d539$var$I($4d82739dd229d539$var$Mf, a);
    $4d82739dd229d539$var$I($4d82739dd229d539$var$Nf, a);
}
function $4d82739dd229d539$var$Rf(a) {
    $4d82739dd229d539$var$Of($4d82739dd229d539$var$Nf.current);
    var b = $4d82739dd229d539$var$Of($4d82739dd229d539$var$Lf.current);
    var c = $4d82739dd229d539$var$le(b, a.type);
    b !== c && ($4d82739dd229d539$var$J($4d82739dd229d539$var$Mf, a, a), $4d82739dd229d539$var$J($4d82739dd229d539$var$Lf, c, a));
}
function $4d82739dd229d539$var$Sf(a) {
    $4d82739dd229d539$var$Mf.current === a && ($4d82739dd229d539$var$I($4d82739dd229d539$var$Lf, a), $4d82739dd229d539$var$I($4d82739dd229d539$var$Mf, a));
}
var $4d82739dd229d539$var$Tf = 0, $4d82739dd229d539$var$Uf = 2, $4d82739dd229d539$var$Vf = 4, $4d82739dd229d539$var$Wf = 8, $4d82739dd229d539$var$Xf = 16, $4d82739dd229d539$var$Yf = 32, $4d82739dd229d539$var$Zf = 64, $4d82739dd229d539$var$$f = 128, $4d82739dd229d539$var$ag = $4d82739dd229d539$var$Xb.ReactCurrentDispatcher, $4d82739dd229d539$var$bg = 0, $4d82739dd229d539$var$cg = null, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$dg = null, $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$fg = null, $4d82739dd229d539$var$gg = 0, $4d82739dd229d539$var$hg = null, $4d82739dd229d539$var$ig = 0, $4d82739dd229d539$var$jg = !1, $4d82739dd229d539$var$kg = null, $4d82739dd229d539$var$lg = 0;
function $4d82739dd229d539$var$mg() {
    $4d82739dd229d539$var$t("307");
}
function $4d82739dd229d539$var$ng(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$fd(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$og(a, b, c, d, e, f) {
    $4d82739dd229d539$var$bg = f;
    $4d82739dd229d539$var$cg = b;
    $4d82739dd229d539$var$dg = null !== a ? a.memoizedState : null;
    $4d82739dd229d539$var$ag.current = null === $4d82739dd229d539$var$dg ? $4d82739dd229d539$var$pg : $4d82739dd229d539$var$qg;
    b = c(d, e);
    if ($4d82739dd229d539$var$jg) {
        do $4d82739dd229d539$var$jg = !1, $4d82739dd229d539$var$lg += 1, $4d82739dd229d539$var$dg = null !== a ? a.memoizedState : null, $4d82739dd229d539$var$fg = $4d82739dd229d539$var$eg, $4d82739dd229d539$var$hg = $4d82739dd229d539$var$R = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$ag.current = $4d82739dd229d539$var$qg, b = c(d, e);
        while ($4d82739dd229d539$var$jg);
        $4d82739dd229d539$var$kg = null;
        $4d82739dd229d539$var$lg = 0;
    }
    $4d82739dd229d539$var$ag.current = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$cg;
    a.memoizedState = $4d82739dd229d539$var$eg;
    a.expirationTime = $4d82739dd229d539$var$gg;
    a.updateQueue = $4d82739dd229d539$var$hg;
    a.effectTag |= $4d82739dd229d539$var$ig;
    a = null !== $4d82739dd229d539$var$Q && null !== $4d82739dd229d539$var$Q.next;
    $4d82739dd229d539$var$bg = 0;
    $4d82739dd229d539$var$fg = $4d82739dd229d539$var$R = $4d82739dd229d539$var$eg = $4d82739dd229d539$var$dg = $4d82739dd229d539$var$Q = $4d82739dd229d539$var$cg = null;
    $4d82739dd229d539$var$gg = 0;
    $4d82739dd229d539$var$hg = null;
    $4d82739dd229d539$var$ig = 0;
    a && $4d82739dd229d539$var$t("300");
    return b;
}
function $4d82739dd229d539$var$sg() {
    $4d82739dd229d539$var$ag.current = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$bg = 0;
    $4d82739dd229d539$var$fg = $4d82739dd229d539$var$R = $4d82739dd229d539$var$eg = $4d82739dd229d539$var$dg = $4d82739dd229d539$var$Q = $4d82739dd229d539$var$cg = null;
    $4d82739dd229d539$var$gg = 0;
    $4d82739dd229d539$var$hg = null;
    $4d82739dd229d539$var$ig = 0;
    $4d82739dd229d539$var$jg = !1;
    $4d82739dd229d539$var$kg = null;
    $4d82739dd229d539$var$lg = 0;
}
function $4d82739dd229d539$var$tg() {
    var a = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
    };
    null === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$eg = $4d82739dd229d539$var$R = a : $4d82739dd229d539$var$R = $4d82739dd229d539$var$R.next = a;
    return $4d82739dd229d539$var$R;
}
function $4d82739dd229d539$var$ug() {
    if (null !== $4d82739dd229d539$var$fg) $4d82739dd229d539$var$R = $4d82739dd229d539$var$fg, $4d82739dd229d539$var$fg = $4d82739dd229d539$var$R.next, $4d82739dd229d539$var$Q = $4d82739dd229d539$var$dg, $4d82739dd229d539$var$dg = null !== $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Q.next : null;
    else {
        null === $4d82739dd229d539$var$dg && $4d82739dd229d539$var$t("310");
        $4d82739dd229d539$var$Q = $4d82739dd229d539$var$dg;
        var a = {
            memoizedState: $4d82739dd229d539$var$Q.memoizedState,
            baseState: $4d82739dd229d539$var$Q.baseState,
            queue: $4d82739dd229d539$var$Q.queue,
            baseUpdate: $4d82739dd229d539$var$Q.baseUpdate,
            next: null
        };
        $4d82739dd229d539$var$R = null === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$eg = a : $4d82739dd229d539$var$R.next = a;
        $4d82739dd229d539$var$dg = $4d82739dd229d539$var$Q.next;
    }
    return $4d82739dd229d539$var$R;
}
function $4d82739dd229d539$var$vg(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$wg(a) {
    var b = $4d82739dd229d539$var$ug(), c = b.queue;
    null === c && $4d82739dd229d539$var$t("311");
    if (0 < $4d82739dd229d539$var$lg) {
        var d = c.dispatch;
        if (null !== $4d82739dd229d539$var$kg) {
            var e = $4d82739dd229d539$var$kg.get(c);
            if (void 0 !== e) {
                $4d82739dd229d539$var$kg.delete(c);
                var f = b.memoizedState;
                do f = a(f, e.action), e = e.next;
                while (null !== e);
                $4d82739dd229d539$var$fd(f, b.memoizedState) || ($4d82739dd229d539$var$xg = !0);
                b.memoizedState = f;
                b.baseUpdate === c.last && (b.baseState = f);
                return [
                    f,
                    d
                ];
            }
        }
        return [
            b.memoizedState,
            d
        ];
    }
    d = c.last;
    var g = b.baseUpdate;
    f = b.baseState;
    null !== g ? (null !== d && (d.next = null), d = g.next) : d = null !== d ? d.next : null;
    if (null !== d) {
        var h = e = null, l = d, k = !1;
        do {
            var m = l.expirationTime;
            m < $4d82739dd229d539$var$bg ? (k || (k = !0, h = g, e = f), m > $4d82739dd229d539$var$gg && ($4d82739dd229d539$var$gg = m)) : f = l.eagerReducer === a ? l.eagerState : a(f, l.action);
            g = l;
            l = l.next;
        }while (null !== l && l !== d);
        k || (h = g, e = f);
        $4d82739dd229d539$var$fd(f, b.memoizedState) || ($4d82739dd229d539$var$xg = !0);
        b.memoizedState = f;
        b.baseUpdate = h;
        b.baseState = e;
        c.eagerReducer = a;
        c.eagerState = f;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$yg(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    null === $4d82739dd229d539$var$hg ? ($4d82739dd229d539$var$hg = {
        lastEffect: null
    }, $4d82739dd229d539$var$hg.lastEffect = a.next = a) : (b = $4d82739dd229d539$var$hg.lastEffect, null === b ? $4d82739dd229d539$var$hg.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, $4d82739dd229d539$var$hg.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$zg(a, b, c, d) {
    var e = $4d82739dd229d539$var$tg();
    $4d82739dd229d539$var$ig |= a;
    e.memoizedState = $4d82739dd229d539$var$yg(b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    var e = $4d82739dd229d539$var$ug();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$Q) {
        var g = $4d82739dd229d539$var$Q.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$ng(d, g.deps)) {
            $4d82739dd229d539$var$yg($4d82739dd229d539$var$Tf, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$ig |= a;
    e.memoizedState = $4d82739dd229d539$var$yg(b, c, f, d);
}
function $4d82739dd229d539$var$Cg(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$Dg() {}
function $4d82739dd229d539$var$Eg(a, b, c) {
    25 > $4d82739dd229d539$var$lg || $4d82739dd229d539$var$t("301");
    var d = a.alternate;
    if (a === $4d82739dd229d539$var$cg || null !== d && d === $4d82739dd229d539$var$cg) {
        if ($4d82739dd229d539$var$jg = !0, a = {
            expirationTime: $4d82739dd229d539$var$bg,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, null === $4d82739dd229d539$var$kg && ($4d82739dd229d539$var$kg = new Map), c = $4d82739dd229d539$var$kg.get(b), void 0 === c) $4d82739dd229d539$var$kg.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    } else {
        $4d82739dd229d539$var$sf();
        var e = $4d82739dd229d539$var$pf();
        e = $4d82739dd229d539$var$qf(e, a);
        var f = {
            expirationTime: e,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, g = b.last;
        if (null === g) f.next = f;
        else {
            var h = g.next;
            null !== h && (f.next = h);
            g.next = f;
        }
        b.last = f;
        if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.eagerReducer, null !== d)) try {
            var l = b.eagerState, k = d(l, c);
            f.eagerReducer = d;
            f.eagerState = k;
            if ($4d82739dd229d539$var$fd(k, l)) return;
        } catch (m) {} finally{}
        $4d82739dd229d539$var$uf(a, e);
    }
}
var $4d82739dd229d539$var$rg = {
    readContext: $4d82739dd229d539$var$Af,
    useCallback: $4d82739dd229d539$var$mg,
    useContext: $4d82739dd229d539$var$mg,
    useEffect: $4d82739dd229d539$var$mg,
    useImperativeHandle: $4d82739dd229d539$var$mg,
    useLayoutEffect: $4d82739dd229d539$var$mg,
    useMemo: $4d82739dd229d539$var$mg,
    useReducer: $4d82739dd229d539$var$mg,
    useRef: $4d82739dd229d539$var$mg,
    useState: $4d82739dd229d539$var$mg,
    useDebugValue: $4d82739dd229d539$var$mg
}, $4d82739dd229d539$var$pg = {
    readContext: $4d82739dd229d539$var$Af,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$tg().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$Af,
    useEffect: function(a, b) {
        return $4d82739dd229d539$var$zg(516, $4d82739dd229d539$var$$f | $4d82739dd229d539$var$Zf, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : [
            a
        ];
        return $4d82739dd229d539$var$zg(4, $4d82739dd229d539$var$Vf | $4d82739dd229d539$var$Yf, $4d82739dd229d539$var$Cg.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$zg(4, $4d82739dd229d539$var$Vf | $4d82739dd229d539$var$Yf, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$tg();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$tg();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            last: null,
            dispatch: null,
            eagerReducer: a,
            eagerState: b
        };
        a = a.dispatch = $4d82739dd229d539$var$Eg.bind(null, $4d82739dd229d539$var$cg, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$tg();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: function(a) {
        var b = $4d82739dd229d539$var$tg();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = {
            last: null,
            dispatch: null,
            eagerReducer: $4d82739dd229d539$var$vg,
            eagerState: a
        };
        a = a.dispatch = $4d82739dd229d539$var$Eg.bind(null, $4d82739dd229d539$var$cg, a);
        return [
            b.memoizedState,
            a
        ];
    },
    useDebugValue: $4d82739dd229d539$var$Dg
}, $4d82739dd229d539$var$qg = {
    readContext: $4d82739dd229d539$var$Af,
    useCallback: function(a, b) {
        var c = $4d82739dd229d539$var$ug();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $4d82739dd229d539$var$ng(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$Af,
    useEffect: function(a, b) {
        return $4d82739dd229d539$var$Bg(516, $4d82739dd229d539$var$$f | $4d82739dd229d539$var$Zf, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : [
            a
        ];
        return $4d82739dd229d539$var$Bg(4, $4d82739dd229d539$var$Vf | $4d82739dd229d539$var$Yf, $4d82739dd229d539$var$Cg.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$Bg(4, $4d82739dd229d539$var$Vf | $4d82739dd229d539$var$Yf, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$ug();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $4d82739dd229d539$var$ng(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $4d82739dd229d539$var$wg,
    useRef: function() {
        return $4d82739dd229d539$var$ug().memoizedState;
    },
    useState: function(a) {
        return $4d82739dd229d539$var$wg($4d82739dd229d539$var$vg, a);
    },
    useDebugValue: $4d82739dd229d539$var$Dg
}, $4d82739dd229d539$var$Fg = null, $4d82739dd229d539$var$Gg = null, $4d82739dd229d539$var$Hg = !1;
function $4d82739dd229d539$var$Ig(a, b) {
    var c = $4d82739dd229d539$var$N(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $4d82739dd229d539$var$Jg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Kg(a) {
    if ($4d82739dd229d539$var$Hg) {
        var b = $4d82739dd229d539$var$Gg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Jg(a, b)) {
                b = $4d82739dd229d539$var$He(c);
                if (!b || !$4d82739dd229d539$var$Jg(a, b)) {
                    a.effectTag |= 2;
                    $4d82739dd229d539$var$Hg = !1;
                    $4d82739dd229d539$var$Fg = a;
                    return;
                }
                $4d82739dd229d539$var$Ig($4d82739dd229d539$var$Fg, c);
            }
            $4d82739dd229d539$var$Fg = a;
            $4d82739dd229d539$var$Gg = $4d82739dd229d539$var$Ie(b);
        } else a.effectTag |= 2, $4d82739dd229d539$var$Hg = !1, $4d82739dd229d539$var$Fg = a;
    }
}
function $4d82739dd229d539$var$Lg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$Fg = a;
}
function $4d82739dd229d539$var$Mg(a) {
    if (a !== $4d82739dd229d539$var$Fg) return !1;
    if (!$4d82739dd229d539$var$Hg) return $4d82739dd229d539$var$Lg(a), $4d82739dd229d539$var$Hg = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$4d82739dd229d539$var$Be(b, a.memoizedProps)) for(b = $4d82739dd229d539$var$Gg; b;)$4d82739dd229d539$var$Ig(a, b), b = $4d82739dd229d539$var$He(b);
    $4d82739dd229d539$var$Lg(a);
    $4d82739dd229d539$var$Gg = $4d82739dd229d539$var$Fg ? $4d82739dd229d539$var$He(a.stateNode) : null;
    return !0;
}
function $4d82739dd229d539$var$Ng() {
    $4d82739dd229d539$var$Gg = $4d82739dd229d539$var$Fg = null;
    $4d82739dd229d539$var$Hg = !1;
}
var $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Xb.ReactCurrentOwner, $4d82739dd229d539$var$xg = !1;
function $4d82739dd229d539$var$S(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Jf(b, null, c, d) : $4d82739dd229d539$var$If(b, a.child, c, d);
}
function $4d82739dd229d539$var$Pg(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$Qg(b, e);
    d = $4d82739dd229d539$var$og(a, b, c, d, f, e);
    if (null !== a && !$4d82739dd229d539$var$xg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $4d82739dd229d539$var$Rg(a, b, e);
    b.effectTag |= 1;
    $4d82739dd229d539$var$S(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$Sg(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$4d82739dd229d539$var$$e(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $4d82739dd229d539$var$Tg(a, b, g, d, e, f);
        a = $4d82739dd229d539$var$cf(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $4d82739dd229d539$var$hd, c(e, d) && a.ref === b.ref)) return $4d82739dd229d539$var$Rg(a, b, f);
    b.effectTag |= 1;
    a = $4d82739dd229d539$var$bf(g, d, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$Tg(a, b, c, d, e, f) {
    return null !== a && $4d82739dd229d539$var$hd(a.memoizedProps, d) && a.ref === b.ref && ($4d82739dd229d539$var$xg = !1, e < f) ? $4d82739dd229d539$var$Rg(a, b, f) : $4d82739dd229d539$var$Ug(a, b, c, d, f);
}
function $4d82739dd229d539$var$Vg(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $4d82739dd229d539$var$Ug(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$M(c) ? $4d82739dd229d539$var$Me : $4d82739dd229d539$var$K.current;
    f = $4d82739dd229d539$var$Oe(b, f);
    $4d82739dd229d539$var$Qg(b, e);
    c = $4d82739dd229d539$var$og(a, b, c, d, f, e);
    if (null !== a && !$4d82739dd229d539$var$xg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $4d82739dd229d539$var$Rg(a, b, e);
    b.effectTag |= 1;
    $4d82739dd229d539$var$S(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$Wg(a, b, c, d, e) {
    if ($4d82739dd229d539$var$M(c)) {
        var f = !0;
        $4d82739dd229d539$var$Te(b);
    } else f = !1;
    $4d82739dd229d539$var$Qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $4d82739dd229d539$var$zf(b, c, d, e), $4d82739dd229d539$var$Cf(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var l = g.context, k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$Af(k) : (k = $4d82739dd229d539$var$M(c) ? $4d82739dd229d539$var$Me : $4d82739dd229d539$var$K.current, k = $4d82739dd229d539$var$Oe(b, k));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || l !== k) && $4d82739dd229d539$var$Bf(b, g, d, k);
        $4d82739dd229d539$var$Xg = !1;
        var x = b.memoizedState;
        l = g.state = x;
        var C = b.updateQueue;
        null !== C && ($4d82739dd229d539$var$Df(b, C, d, g, e), l = b.memoizedState);
        h !== d || x !== l || $4d82739dd229d539$var$L.current || $4d82739dd229d539$var$Xg ? ("function" === typeof m && ($4d82739dd229d539$var$of(b, c, m, d), l = b.memoizedState), (h = $4d82739dd229d539$var$Xg || $4d82739dd229d539$var$yf(b, c, h, d, x, l, k)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = l), g.props = d, g.state = l, g.context = k, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, h = b.memoizedProps, g.props = b.type === b.elementType ? h : $4d82739dd229d539$var$P(b.type, h), l = g.context, k = c.contextType, "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$Af(k) : (k = $4d82739dd229d539$var$M(c) ? $4d82739dd229d539$var$Me : $4d82739dd229d539$var$K.current, k = $4d82739dd229d539$var$Oe(b, k)), m = c.getDerivedStateFromProps, (q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || l !== k) && $4d82739dd229d539$var$Bf(b, g, d, k), $4d82739dd229d539$var$Xg = !1, l = b.memoizedState, x = g.state = l, C = b.updateQueue, null !== C && ($4d82739dd229d539$var$Df(b, C, d, g, e), x = b.memoizedState), h !== d || l !== x || $4d82739dd229d539$var$L.current || $4d82739dd229d539$var$Xg ? ("function" === typeof m && ($4d82739dd229d539$var$of(b, c, m, d), x = b.memoizedState), (m = $4d82739dd229d539$var$Xg || $4d82739dd229d539$var$yf(b, c, h, d, l, x, k)) ? (q || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $4d82739dd229d539$var$Yg(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$Yg(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Vg(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $4d82739dd229d539$var$Ue(b, c, !1), $4d82739dd229d539$var$Rg(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Og.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$If(b, a.child, null, f), b.child = $4d82739dd229d539$var$If(b, null, h, f)) : $4d82739dd229d539$var$S(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$Ue(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$Zg(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$Re(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$Re(a, b.context, !1);
    $4d82739dd229d539$var$Pf(a, b.containerInfo);
}
function $4d82739dd229d539$var$$g(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = b.memoizedState;
    if (0 === (b.effectTag & 64)) {
        f = null;
        var g = !1;
    } else f = {
        timedOutAt: null !== f ? f.timedOutAt : 0
    }, g = !0, b.effectTag &= -65;
    if (null === a) {
        if (g) {
            var h = e.fallback;
            a = $4d82739dd229d539$var$df(null, d, 0, null);
            0 === (b.mode & 1) && (a.child = null !== b.memoizedState ? b.child.child : b.child);
            d = $4d82739dd229d539$var$df(h, d, c, null);
            a.sibling = d;
            c = a;
            c.return = d.return = b;
        } else c = d = $4d82739dd229d539$var$Jf(b, null, e.children, c);
    } else null !== a.memoizedState ? (d = a.child, h = d.sibling, g ? (c = e.fallback, e = $4d82739dd229d539$var$bf(d, d.pendingProps, 0), 0 === (b.mode & 1) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== d.child && (e.child = g)), d = e.sibling = $4d82739dd229d539$var$bf(h, c, h.expirationTime), c = e, e.childExpirationTime = 0, c.return = d.return = b) : c = d = $4d82739dd229d539$var$If(b, d.child, e.children, c)) : (h = a.child, g ? (g = e.fallback, e = $4d82739dd229d539$var$df(null, d, 0, null), e.child = h, 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = e.sibling = $4d82739dd229d539$var$df(g, d, c, null), d.effectTag |= 2, c = e, e.childExpirationTime = 0, c.return = d.return = b) : d = c = $4d82739dd229d539$var$If(b, h, e.children, c)), b.stateNode = a.stateNode;
    b.memoizedState = f;
    b.child = c;
    return d;
}
function $4d82739dd229d539$var$Rg(a, b, c) {
    null !== a && (b.contextDependencies = a.contextDependencies);
    if (b.childExpirationTime < c) return null;
    null !== a && b.child !== a.child && $4d82739dd229d539$var$t("153");
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$bf(a, a.pendingProps, a.expirationTime);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$bf(a, a.pendingProps, a.expirationTime), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ah(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$L.current) $4d82739dd229d539$var$xg = !0;
        else if (d < c) {
            $4d82739dd229d539$var$xg = !1;
            switch(b.tag){
                case 3:
                    $4d82739dd229d539$var$Zg(b);
                    $4d82739dd229d539$var$Ng();
                    break;
                case 5:
                    $4d82739dd229d539$var$Rf(b);
                    break;
                case 1:
                    $4d82739dd229d539$var$M(b.type) && $4d82739dd229d539$var$Te(b);
                    break;
                case 4:
                    $4d82739dd229d539$var$Pf(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    $4d82739dd229d539$var$bh(b, b.memoizedProps.value);
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        d = b.child.childExpirationTime;
                        if (0 !== d && d >= c) return $4d82739dd229d539$var$$g(a, b, c);
                        b = $4d82739dd229d539$var$Rg(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
            }
            return $4d82739dd229d539$var$Rg(a, b, c);
        }
    } else $4d82739dd229d539$var$xg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Oe(b, $4d82739dd229d539$var$K.current);
            $4d82739dd229d539$var$Qg(b, c);
            e = $4d82739dd229d539$var$og(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                $4d82739dd229d539$var$sg();
                if ($4d82739dd229d539$var$M(d)) {
                    var f = !0;
                    $4d82739dd229d539$var$Te(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $4d82739dd229d539$var$of(b, d, g, a);
                e.updater = $4d82739dd229d539$var$xf;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $4d82739dd229d539$var$Cf(b, d, a, c);
                b = $4d82739dd229d539$var$Yg(null, b, d, !0, f, c);
            } else b.tag = 0, $4d82739dd229d539$var$S(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            f = b.pendingProps;
            a = $4d82739dd229d539$var$mf(e);
            b.type = a;
            e = b.tag = $4d82739dd229d539$var$af(a);
            f = $4d82739dd229d539$var$P(a, f);
            g = void 0;
            switch(e){
                case 0:
                    g = $4d82739dd229d539$var$Ug(null, b, a, f, c);
                    break;
                case 1:
                    g = $4d82739dd229d539$var$Wg(null, b, a, f, c);
                    break;
                case 11:
                    g = $4d82739dd229d539$var$Pg(null, b, a, f, c);
                    break;
                case 14:
                    g = $4d82739dd229d539$var$Sg(null, b, a, $4d82739dd229d539$var$P(a.type, f), d, c);
                    break;
                default:
                    $4d82739dd229d539$var$t("306", a, "");
            }
            return g;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$P(d, e), $4d82739dd229d539$var$Ug(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$P(d, e), $4d82739dd229d539$var$Wg(a, b, d, e, c);
        case 3:
            $4d82739dd229d539$var$Zg(b);
            d = b.updateQueue;
            null === d && $4d82739dd229d539$var$t("282");
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $4d82739dd229d539$var$Df(b, d, b.pendingProps, null, c);
            d = b.memoizedState.element;
            if (d === e) $4d82739dd229d539$var$Ng(), b = $4d82739dd229d539$var$Rg(a, b, c);
            else {
                e = b.stateNode;
                if (e = (null === a || null === a.child) && e.hydrate) $4d82739dd229d539$var$Gg = $4d82739dd229d539$var$Ie(b.stateNode.containerInfo), $4d82739dd229d539$var$Fg = b, e = $4d82739dd229d539$var$Hg = !0;
                e ? (b.effectTag |= 2, b.child = $4d82739dd229d539$var$Jf(b, null, d, c)) : ($4d82739dd229d539$var$S(a, b, d, c), $4d82739dd229d539$var$Ng());
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Rf(b), null === a && $4d82739dd229d539$var$Kg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Be(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Be(d, f) && (b.effectTag |= 16), $4d82739dd229d539$var$Vg(a, b), 1 !== c && b.mode & 1 && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($4d82739dd229d539$var$S(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $4d82739dd229d539$var$Kg(b), null;
        case 13:
            return $4d82739dd229d539$var$$g(a, b, c);
        case 4:
            return $4d82739dd229d539$var$Pf(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$If(b, null, d, c) : $4d82739dd229d539$var$S(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$P(d, e), $4d82739dd229d539$var$Pg(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$S(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$S(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$S(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                $4d82739dd229d539$var$bh(b, f);
                if (null !== g) {
                    var h = g.value;
                    f = $4d82739dd229d539$var$fd(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;
                    if (0 === f) {
                        if (g.children === e.children && !$4d82739dd229d539$var$L.current) {
                            b = $4d82739dd229d539$var$Rg(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var l = h.contextDependencies;
                        if (null !== l) {
                            g = h.child;
                            for(var k = l.first; null !== k;){
                                if (k.context === d && 0 !== (k.observedBits & f)) {
                                    1 === h.tag && (k = $4d82739dd229d539$var$rf(c), k.tag = $4d82739dd229d539$var$wf, $4d82739dd229d539$var$tf(h, k));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    k = h.alternate;
                                    null !== k && k.expirationTime < c && (k.expirationTime = c);
                                    for(var m = h.return; null !== m;){
                                        k = m.alternate;
                                        if (m.childExpirationTime < c) m.childExpirationTime = c, null !== k && k.childExpirationTime < c && (k.childExpirationTime = c);
                                        else if (null !== k && k.childExpirationTime < c) k.childExpirationTime = c;
                                        else break;
                                        m = m.return;
                                    }
                                    l.expirationTime < c && (l.expirationTime = c);
                                    break;
                                }
                                k = k.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $4d82739dd229d539$var$S(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $4d82739dd229d539$var$Qg(b, c), e = $4d82739dd229d539$var$Af(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $4d82739dd229d539$var$S(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $4d82739dd229d539$var$P(e, b.pendingProps), f = $4d82739dd229d539$var$P(e.type, f), $4d82739dd229d539$var$Sg(a, b, e, f, d, c);
        case 15:
            return $4d82739dd229d539$var$Tg(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$P(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $4d82739dd229d539$var$M(d) ? (a = !0, $4d82739dd229d539$var$Te(b)) : a = !1, $4d82739dd229d539$var$Qg(b, c), $4d82739dd229d539$var$zf(b, d, e, c), $4d82739dd229d539$var$Cf(b, d, e, c), $4d82739dd229d539$var$Yg(null, b, d, !0, a, c);
        default:
            $4d82739dd229d539$var$t("156");
    }
}
var $4d82739dd229d539$var$ch = {
    current: null
}, $4d82739dd229d539$var$dh = null, $4d82739dd229d539$var$eh = null, $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$bh(a, b) {
    var c = a.type._context;
    $4d82739dd229d539$var$J($4d82739dd229d539$var$ch, c._currentValue, a);
    c._currentValue = b;
}
function $4d82739dd229d539$var$gh(a) {
    var b = $4d82739dd229d539$var$ch.current;
    $4d82739dd229d539$var$I($4d82739dd229d539$var$ch, a);
    a.type._context._currentValue = b;
}
function $4d82739dd229d539$var$Qg(a, b) {
    $4d82739dd229d539$var$dh = a;
    $4d82739dd229d539$var$fh = $4d82739dd229d539$var$eh = null;
    var c = a.contextDependencies;
    null !== c && c.expirationTime >= b && ($4d82739dd229d539$var$xg = !0);
    a.contextDependencies = null;
}
function $4d82739dd229d539$var$Af(a, b) {
    if ($4d82739dd229d539$var$fh !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $4d82739dd229d539$var$fh = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        null === $4d82739dd229d539$var$eh ? (null === $4d82739dd229d539$var$dh && $4d82739dd229d539$var$t("308"), $4d82739dd229d539$var$eh = b, $4d82739dd229d539$var$dh.contextDependencies = {
            first: b,
            expirationTime: 0
        }) : $4d82739dd229d539$var$eh = $4d82739dd229d539$var$eh.next = b;
    }
    return a._currentValue;
}
var $4d82739dd229d539$var$hh = 0, $4d82739dd229d539$var$vf = 1, $4d82739dd229d539$var$wf = 2, $4d82739dd229d539$var$ih = 3, $4d82739dd229d539$var$Xg = !1;
function $4d82739dd229d539$var$jh(a) {
    return {
        baseState: a,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $4d82739dd229d539$var$kh(a) {
    return {
        baseState: a.baseState,
        firstUpdate: a.firstUpdate,
        lastUpdate: a.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $4d82739dd229d539$var$rf(a) {
    return {
        expirationTime: a,
        tag: $4d82739dd229d539$var$hh,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function $4d82739dd229d539$var$tf(a, b) {
    var c = a.alternate;
    if (null === c) {
        var d = a.updateQueue;
        var e = null;
        null === d && (d = a.updateQueue = $4d82739dd229d539$var$jh(a.memoizedState));
    } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = $4d82739dd229d539$var$jh(a.memoizedState), e = c.updateQueue = $4d82739dd229d539$var$jh(c.memoizedState)) : d = a.updateQueue = $4d82739dd229d539$var$kh(e) : null === e && (e = c.updateQueue = $4d82739dd229d539$var$kh(d));
    null === e || d === e ? $4d82739dd229d539$var$lh(d, b) : null === d.lastUpdate || null === e.lastUpdate ? ($4d82739dd229d539$var$lh(d, b), $4d82739dd229d539$var$lh(e, b)) : ($4d82739dd229d539$var$lh(d, b), e.lastUpdate = b);
}
function $4d82739dd229d539$var$mh(a, b) {
    var c = a.updateQueue;
    c = null === c ? a.updateQueue = $4d82739dd229d539$var$jh(a.memoizedState) : $4d82739dd229d539$var$nh(a, c);
    null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}
function $4d82739dd229d539$var$nh(a, b) {
    var c = a.alternate;
    null !== c && b === c.updateQueue && (b = a.updateQueue = $4d82739dd229d539$var$kh(b));
    return b;
}
function $4d82739dd229d539$var$oh(a, b, c, d, e, f) {
    switch(c.tag){
        case $4d82739dd229d539$var$vf:
            return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
        case $4d82739dd229d539$var$ih:
            a.effectTag = a.effectTag & -2049 | 64;
        case $4d82739dd229d539$var$hh:
            a = c.payload;
            e = "function" === typeof a ? a.call(f, d, e) : a;
            if (null === e || void 0 === e) break;
            return $013Yp({}, d, e);
        case $4d82739dd229d539$var$wf:
            $4d82739dd229d539$var$Xg = !0;
    }
    return d;
}
function $4d82739dd229d539$var$Df(a, b, c, d, e) {
    $4d82739dd229d539$var$Xg = !1;
    b = $4d82739dd229d539$var$nh(a, b);
    for(var f = b.baseState, g = null, h = 0, l = b.firstUpdate, k = f; null !== l;){
        var m = l.expirationTime;
        m < e ? (null === g && (g = l, f = k), h < m && (h = m)) : (k = $4d82739dd229d539$var$oh(a, b, l, k, c, d), null !== l.callback && (a.effectTag |= 32, l.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = l : (b.lastEffect.nextEffect = l, b.lastEffect = l)));
        l = l.next;
    }
    m = null;
    for(l = b.firstCapturedUpdate; null !== l;){
        var q = l.expirationTime;
        q < e ? (null === m && (m = l, null === g && (f = k)), h < q && (h = q)) : (k = $4d82739dd229d539$var$oh(a, b, l, k, c, d), null !== l.callback && (a.effectTag |= 32, l.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = l : (b.lastCapturedEffect.nextEffect = l, b.lastCapturedEffect = l)));
        l = l.next;
    }
    null === g && (b.lastUpdate = null);
    null === m ? b.lastCapturedUpdate = null : a.effectTag |= 32;
    null === g && null === m && (f = k);
    b.baseState = f;
    b.firstUpdate = g;
    b.firstCapturedUpdate = m;
    a.expirationTime = h;
    a.memoizedState = k;
}
function $4d82739dd229d539$var$ph(a, b, c) {
    null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
    $4d82739dd229d539$var$qh(b.firstEffect, c);
    b.firstEffect = b.lastEffect = null;
    $4d82739dd229d539$var$qh(b.firstCapturedEffect, c);
    b.firstCapturedEffect = b.lastCapturedEffect = null;
}
function $4d82739dd229d539$var$qh(a, b) {
    for(; null !== a;){
        var c = a.callback;
        if (null !== c) {
            a.callback = null;
            var d = b;
            "function" !== typeof c && $4d82739dd229d539$var$t("191", c);
            c.call(d);
        }
        a = a.nextEffect;
    }
}
function $4d82739dd229d539$var$rh(a, b) {
    return {
        value: a,
        source: b,
        stack: $4d82739dd229d539$var$nc(b)
    };
}
function $4d82739dd229d539$var$sh(a) {
    a.effectTag |= 4;
}
var $4d82739dd229d539$var$wh = void 0, $4d82739dd229d539$var$xh = void 0, $4d82739dd229d539$var$yh = void 0, $4d82739dd229d539$var$zh = void 0;
$4d82739dd229d539$var$wh = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$xh = function() {};
$4d82739dd229d539$var$yh = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $4d82739dd229d539$var$Of($4d82739dd229d539$var$Lf.current);
        a = null;
        switch(c){
            case "input":
                f = $4d82739dd229d539$var$zc(g, f);
                d = $4d82739dd229d539$var$zc(g, d);
                a = [];
                break;
            case "option":
                f = $4d82739dd229d539$var$de(g, f);
                d = $4d82739dd229d539$var$de(g, d);
                a = [];
                break;
            case "select":
                f = $013Yp({}, f, {
                    value: void 0
                });
                d = $013Yp({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $4d82739dd229d539$var$fe(g, f);
                d = $4d82739dd229d539$var$fe(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $4d82739dd229d539$var$xe);
        }
        $4d82739dd229d539$var$ue(c, d);
        g = c = void 0;
        var h = null;
        for(c in f)if (!d.hasOwnProperty(c) && f.hasOwnProperty(c) && null != f[c]) {
            if ("style" === c) {
                var l = f[c];
                for(g in l)l.hasOwnProperty(g) && (h || (h = {}), h[g] = "");
            } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && ($4d82739dd229d539$var$ta.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
        }
        for(c in d){
            var k = d[c];
            l = null != f ? f[c] : void 0;
            if (d.hasOwnProperty(c) && k !== l && (null != k || null != l)) {
                if ("style" === c) {
                    if (l) {
                        for(g in l)!l.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (h || (h = {}), h[g] = "");
                        for(g in k)k.hasOwnProperty(g) && l[g] !== k[g] && (h || (h = {}), h[g] = k[g]);
                    } else h || (a || (a = []), a.push(c, h)), h = k;
                } else "dangerouslySetInnerHTML" === c ? (k = k ? k.__html : void 0, l = l ? l.__html : void 0, null != k && l !== k && (a = a || []).push(c, "" + k)) : "children" === c ? l === k || "string" !== typeof k && "number" !== typeof k || (a = a || []).push(c, "" + k) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && ($4d82739dd229d539$var$ta.hasOwnProperty(c) ? (null != k && $4d82739dd229d539$var$we(e, c), a || l === k || (a = [])) : (a = a || []).push(c, k));
            }
        }
        h && (a = a || []).push("style", h);
        e = a;
        (b.updateQueue = e) && $4d82739dd229d539$var$sh(b);
    }
};
$4d82739dd229d539$var$zh = function(a, b, c, d) {
    c !== d && $4d82739dd229d539$var$sh(b);
};
var $4d82739dd229d539$var$Ah = "function" === typeof WeakSet ? WeakSet : Set;
function $4d82739dd229d539$var$Bh(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $4d82739dd229d539$var$nc(c));
    null !== c && $4d82739dd229d539$var$mc(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $4d82739dd229d539$var$mc(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $4d82739dd229d539$var$Ch(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $4d82739dd229d539$var$Dh(a, c);
        }
        else b.current = null;
    }
}
function $4d82739dd229d539$var$Eh(a, b, c) {
    c = c.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) !== $4d82739dd229d539$var$Tf) {
                var e = d.destroy;
                d.destroy = void 0;
                void 0 !== e && e();
            }
            (d.tag & b) !== $4d82739dd229d539$var$Tf && (e = d.create, d.destroy = e());
            d = d.next;
        }while (d !== c);
    }
}
function $4d82739dd229d539$var$Fh(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d.style.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $4d82739dd229d539$var$re("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if (13 === c.tag && null !== c.memoizedState) {
            d = c.child.sibling;
            d.return = c;
            c = d;
            continue;
        } else if (null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $4d82739dd229d539$var$Gh(a) {
    "function" === typeof $4d82739dd229d539$var$We && $4d82739dd229d539$var$We(a);
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            var b = a.updateQueue;
            if (null !== b && (b = b.lastEffect, null !== b)) {
                var c = b = b.next;
                do {
                    var d = c.destroy;
                    if (void 0 !== d) {
                        var e = a;
                        try {
                            d();
                        } catch (f) {
                            $4d82739dd229d539$var$Dh(e, f);
                        }
                    }
                    c = c.next;
                }while (c !== b);
            }
            break;
        case 1:
            $4d82739dd229d539$var$Ch(a);
            b = a.stateNode;
            if ("function" === typeof b.componentWillUnmount) try {
                b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
            } catch (f) {
                $4d82739dd229d539$var$Dh(a, f);
            }
            break;
        case 5:
            $4d82739dd229d539$var$Ch(a);
            break;
        case 4:
            $4d82739dd229d539$var$Hh(a);
    }
}
function $4d82739dd229d539$var$Ih(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Jh(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($4d82739dd229d539$var$Ih(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        $4d82739dd229d539$var$t("160");
        c = void 0;
    }
    var d = b = void 0;
    switch(c.tag){
        case 5:
            b = c.stateNode;
            d = !1;
            break;
        case 3:
            b = c.stateNode.containerInfo;
            d = !0;
            break;
        case 4:
            b = c.stateNode.containerInfo;
            d = !0;
            break;
        default:
            $4d82739dd229d539$var$t("161");
    }
    c.effectTag & 16 && ($4d82739dd229d539$var$oe(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $4d82739dd229d539$var$Ih(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    for(var e = a;;){
        if (5 === e.tag || 6 === e.tag) {
            if (c) {
                if (d) {
                    var f = b, g = e.stateNode, h = c;
                    8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
                } else b.insertBefore(e.stateNode, c);
            } else d ? (g = b, h = e.stateNode, 8 === g.nodeType ? (f = g.parentNode, f.insertBefore(h, g)) : (f = g, f.appendChild(h)), g = g._reactRootContainer, null !== g && void 0 !== g || null !== f.onclick || (f.onclick = $4d82739dd229d539$var$xe)) : b.appendChild(e.stateNode);
        } else if (4 !== e.tag && null !== e.child) {
            e.child.return = e;
            e = e.child;
            continue;
        }
        if (e === a) break;
        for(; null === e.sibling;){
            if (null === e.return || e.return === a) return;
            e = e.return;
        }
        e.sibling.return = e.return;
        e = e.sibling;
    }
}
function $4d82739dd229d539$var$Hh(a) {
    for(var b = a, c = !1, d = void 0, e = void 0;;){
        if (!c) {
            c = b.return;
            a: for(;;){
                null === c && $4d82739dd229d539$var$t("160");
                switch(c.tag){
                    case 5:
                        d = c.stateNode;
                        e = !1;
                        break a;
                    case 3:
                        d = c.stateNode.containerInfo;
                        e = !0;
                        break a;
                    case 4:
                        d = c.stateNode.containerInfo;
                        e = !0;
                        break a;
                }
                c = c.return;
            }
            c = !0;
        }
        if (5 === b.tag || 6 === b.tag) {
            a: for(var f = b, g = f;;)if ($4d82739dd229d539$var$Gh(g), null !== g.child && 4 !== g.tag) g.child.return = g, g = g.child;
            else {
                if (g === f) break;
                for(; null === g.sibling;){
                    if (null === g.return || g.return === f) break a;
                    g = g.return;
                }
                g.sibling.return = g.return;
                g = g.sibling;
            }
            e ? (f = d, g = b.stateNode, 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);
        } else if (4 === b.tag ? (d = b.stateNode.containerInfo, e = !0) : $4d82739dd229d539$var$Gh(b), null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return;
            b = b.return;
            4 === b.tag && (c = !1);
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
}
function $4d82739dd229d539$var$Kh(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$Eh($4d82739dd229d539$var$Vf, $4d82739dd229d539$var$Wf, b);
            break;
        case 1:
            break;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps;
                a = null !== a ? a.memoizedProps : d;
                var e = b.type, f = b.updateQueue;
                b.updateQueue = null;
                null !== f && $4d82739dd229d539$var$Ge(c, f, e, a, d, b);
            }
            break;
        case 6:
            null === b.stateNode && $4d82739dd229d539$var$t("162");
            b.stateNode.nodeValue = b.memoizedProps;
            break;
        case 3:
            break;
        case 12:
            break;
        case 13:
            c = b.memoizedState;
            d = void 0;
            a = b;
            null === c ? d = !1 : (d = !0, a = b.child, 0 === c.timedOutAt && (c.timedOutAt = $4d82739dd229d539$var$pf()));
            null !== a && $4d82739dd229d539$var$Fh(a, d);
            c = b.updateQueue;
            if (null !== c) {
                b.updateQueue = null;
                var g = b.stateNode;
                null === g && (g = b.stateNode = new $4d82739dd229d539$var$Ah);
                c.forEach(function(a) {
                    var c = $4d82739dd229d539$var$Lh.bind(null, b, a);
                    g.has(a) || (g.add(a), a.then(c, c));
                });
            }
            break;
        case 17:
            break;
        default:
            $4d82739dd229d539$var$t("163");
    }
}
var $4d82739dd229d539$var$Mh = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Nh(a, b, c) {
    c = $4d82739dd229d539$var$rf(c);
    c.tag = $4d82739dd229d539$var$ih;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oh(d);
        $4d82739dd229d539$var$Bh(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Ph(a, b, c) {
    c = $4d82739dd229d539$var$rf(c);
    c.tag = $4d82739dd229d539$var$ih;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $4d82739dd229d539$var$Qh ? $4d82739dd229d539$var$Qh = new Set([
            this
        ]) : $4d82739dd229d539$var$Qh.add(this));
        var c = b.value, e = b.stack;
        $4d82739dd229d539$var$Bh(a, b);
        this.componentDidCatch(c, {
            componentStack: null !== e ? e : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Rh(a) {
    switch(a.tag){
        case 1:
            $4d82739dd229d539$var$M(a.type) && $4d82739dd229d539$var$Pe(a);
            var b = a.effectTag;
            return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 3:
            return $4d82739dd229d539$var$Qf(a), $4d82739dd229d539$var$Qe(a), b = a.effectTag, 0 !== (b & 64) && $4d82739dd229d539$var$t("285"), a.effectTag = b & -2049 | 64, a;
        case 5:
            return $4d82739dd229d539$var$Sf(a), null;
        case 13:
            return b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 4:
            return $4d82739dd229d539$var$Qf(a), null;
        case 10:
            return $4d82739dd229d539$var$gh(a), null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Sh = $4d82739dd229d539$var$Xb.ReactCurrentDispatcher, $4d82739dd229d539$var$Th = $4d82739dd229d539$var$Xb.ReactCurrentOwner, $4d82739dd229d539$var$Uh = 1073741822, $4d82739dd229d539$var$Vh = 0, $4d82739dd229d539$var$Wh = !1, $4d82739dd229d539$var$T = null, $4d82739dd229d539$var$Xh = null, $4d82739dd229d539$var$U = 0, $4d82739dd229d539$var$Yh = -1, $4d82739dd229d539$var$Zh = !1, $4d82739dd229d539$var$V = null, $4d82739dd229d539$var$$h = !1, $4d82739dd229d539$var$ai = null, $4d82739dd229d539$var$bi = null, $4d82739dd229d539$var$ci = null, $4d82739dd229d539$var$Qh = null;
function $4d82739dd229d539$var$di() {
    if (null !== $4d82739dd229d539$var$T) for(var a = $4d82739dd229d539$var$T.return; null !== a;){
        var b = a;
        switch(b.tag){
            case 1:
                var c = b.type.childContextTypes;
                null !== c && void 0 !== c && $4d82739dd229d539$var$Pe(b);
                break;
            case 3:
                $4d82739dd229d539$var$Qf(b);
                $4d82739dd229d539$var$Qe(b);
                break;
            case 5:
                $4d82739dd229d539$var$Sf(b);
                break;
            case 4:
                $4d82739dd229d539$var$Qf(b);
                break;
            case 10:
                $4d82739dd229d539$var$gh(b);
        }
        a = a.return;
    }
    $4d82739dd229d539$var$Xh = null;
    $4d82739dd229d539$var$U = 0;
    $4d82739dd229d539$var$Yh = -1;
    $4d82739dd229d539$var$Zh = !1;
    $4d82739dd229d539$var$T = null;
}
function $4d82739dd229d539$var$ei(a, b) {
    $4d82739dd229d539$var$ci = $4d82739dd229d539$var$bi = $4d82739dd229d539$var$ai = null;
    var c = $4d82739dd229d539$var$W;
    $4d82739dd229d539$var$W = !0;
    do {
        if (b.effectTag & 512) {
            var d = !1, e = void 0;
            try {
                var f = b;
                $4d82739dd229d539$var$Eh($4d82739dd229d539$var$$f, $4d82739dd229d539$var$Tf, f);
                $4d82739dd229d539$var$Eh($4d82739dd229d539$var$Tf, $4d82739dd229d539$var$Zf, f);
            } catch (g) {
                d = !0, e = g;
            }
            d && $4d82739dd229d539$var$Dh(b, e);
        }
        b = b.nextEffect;
    }while (null !== b);
    $4d82739dd229d539$var$W = c;
    c = a.expirationTime;
    0 !== c && $4d82739dd229d539$var$fi(a, c);
}
function $4d82739dd229d539$var$sf() {
    null !== $4d82739dd229d539$var$bi && $4d82739dd229d539$var$Fe($4d82739dd229d539$var$bi);
    null !== $4d82739dd229d539$var$ci && $4d82739dd229d539$var$ci();
}
function $4d82739dd229d539$var$gi(a) {
    for(;;){
        var b = a.alternate, c = a.return, d = a.sibling;
        if (0 === (a.effectTag & 1024)) {
            $4d82739dd229d539$var$T = a;
            a: {
                var e = b;
                b = a;
                var f = $4d82739dd229d539$var$U;
                var g = b.pendingProps;
                switch(b.tag){
                    case 2:
                        break;
                    case 16:
                        break;
                    case 15:
                    case 0:
                        break;
                    case 1:
                        $4d82739dd229d539$var$M(b.type) && $4d82739dd229d539$var$Pe(b);
                        break;
                    case 3:
                        $4d82739dd229d539$var$Qf(b);
                        $4d82739dd229d539$var$Qe(b);
                        g = b.stateNode;
                        g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null);
                        if (null === e || null === e.child) $4d82739dd229d539$var$Mg(b), b.effectTag &= -3;
                        $4d82739dd229d539$var$xh(b);
                        break;
                    case 5:
                        $4d82739dd229d539$var$Sf(b);
                        var h = $4d82739dd229d539$var$Of($4d82739dd229d539$var$Nf.current);
                        f = b.type;
                        if (null !== e && null != b.stateNode) $4d82739dd229d539$var$yh(e, b, f, g, h), e.ref !== b.ref && (b.effectTag |= 128);
                        else if (g) {
                            var l = $4d82739dd229d539$var$Of($4d82739dd229d539$var$Lf.current);
                            if ($4d82739dd229d539$var$Mg(b)) {
                                g = b;
                                e = g.stateNode;
                                var k = g.type, m = g.memoizedProps, q = h;
                                e[$4d82739dd229d539$var$Ha] = g;
                                e[$4d82739dd229d539$var$Ia] = m;
                                f = void 0;
                                h = k;
                                switch(h){
                                    case "iframe":
                                    case "object":
                                        $4d82739dd229d539$var$H("load", e);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(k = 0; k < $4d82739dd229d539$var$cb.length; k++)$4d82739dd229d539$var$H($4d82739dd229d539$var$cb[k], e);
                                        break;
                                    case "source":
                                        $4d82739dd229d539$var$H("error", e);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $4d82739dd229d539$var$H("error", e);
                                        $4d82739dd229d539$var$H("load", e);
                                        break;
                                    case "form":
                                        $4d82739dd229d539$var$H("reset", e);
                                        $4d82739dd229d539$var$H("submit", e);
                                        break;
                                    case "details":
                                        $4d82739dd229d539$var$H("toggle", e);
                                        break;
                                    case "input":
                                        $4d82739dd229d539$var$Ac(e, m);
                                        $4d82739dd229d539$var$H("invalid", e);
                                        $4d82739dd229d539$var$we(q, "onChange");
                                        break;
                                    case "select":
                                        e._wrapperState = {
                                            wasMultiple: !!m.multiple
                                        };
                                        $4d82739dd229d539$var$H("invalid", e);
                                        $4d82739dd229d539$var$we(q, "onChange");
                                        break;
                                    case "textarea":
                                        $4d82739dd229d539$var$ge(e, m), $4d82739dd229d539$var$H("invalid", e), $4d82739dd229d539$var$we(q, "onChange");
                                }
                                $4d82739dd229d539$var$ue(h, m);
                                k = null;
                                for(f in m)m.hasOwnProperty(f) && (l = m[f], "children" === f ? "string" === typeof l ? e.textContent !== l && (k = [
                                    "children",
                                    l
                                ]) : "number" === typeof l && e.textContent !== "" + l && (k = [
                                    "children",
                                    "" + l
                                ]) : $4d82739dd229d539$var$ta.hasOwnProperty(f) && null != l && $4d82739dd229d539$var$we(q, f));
                                switch(h){
                                    case "input":
                                        $4d82739dd229d539$var$Vb(e);
                                        $4d82739dd229d539$var$Ec(e, m, !0);
                                        break;
                                    case "textarea":
                                        $4d82739dd229d539$var$Vb(e);
                                        $4d82739dd229d539$var$ie(e, m);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" === typeof m.onClick && (e.onclick = $4d82739dd229d539$var$xe);
                                }
                                f = k;
                                g.updateQueue = f;
                                g = null !== f ? !0 : !1;
                                g && $4d82739dd229d539$var$sh(b);
                            } else {
                                m = b;
                                e = f;
                                q = g;
                                k = 9 === h.nodeType ? h : h.ownerDocument;
                                l === $4d82739dd229d539$var$je.html && (l = $4d82739dd229d539$var$ke(e));
                                l === $4d82739dd229d539$var$je.html ? "script" === e ? (e = k.createElement("div"), e.innerHTML = "<script>\x3c/script>", k = e.removeChild(e.firstChild)) : "string" === typeof q.is ? k = k.createElement(e, {
                                    is: q.is
                                }) : (k = k.createElement(e), "select" === e && q.multiple && (k.multiple = !0)) : k = k.createElementNS(l, e);
                                e = k;
                                e[$4d82739dd229d539$var$Ha] = m;
                                e[$4d82739dd229d539$var$Ia] = g;
                                $4d82739dd229d539$var$wh(e, b, !1, !1);
                                q = e;
                                k = f;
                                m = g;
                                var x = h, C = $4d82739dd229d539$var$ve(k, m);
                                switch(k){
                                    case "iframe":
                                    case "object":
                                        $4d82739dd229d539$var$H("load", q);
                                        h = m;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(h = 0; h < $4d82739dd229d539$var$cb.length; h++)$4d82739dd229d539$var$H($4d82739dd229d539$var$cb[h], q);
                                        h = m;
                                        break;
                                    case "source":
                                        $4d82739dd229d539$var$H("error", q);
                                        h = m;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $4d82739dd229d539$var$H("error", q);
                                        $4d82739dd229d539$var$H("load", q);
                                        h = m;
                                        break;
                                    case "form":
                                        $4d82739dd229d539$var$H("reset", q);
                                        $4d82739dd229d539$var$H("submit", q);
                                        h = m;
                                        break;
                                    case "details":
                                        $4d82739dd229d539$var$H("toggle", q);
                                        h = m;
                                        break;
                                    case "input":
                                        $4d82739dd229d539$var$Ac(q, m);
                                        h = $4d82739dd229d539$var$zc(q, m);
                                        $4d82739dd229d539$var$H("invalid", q);
                                        $4d82739dd229d539$var$we(x, "onChange");
                                        break;
                                    case "option":
                                        h = $4d82739dd229d539$var$de(q, m);
                                        break;
                                    case "select":
                                        q._wrapperState = {
                                            wasMultiple: !!m.multiple
                                        };
                                        h = $013Yp({}, m, {
                                            value: void 0
                                        });
                                        $4d82739dd229d539$var$H("invalid", q);
                                        $4d82739dd229d539$var$we(x, "onChange");
                                        break;
                                    case "textarea":
                                        $4d82739dd229d539$var$ge(q, m);
                                        h = $4d82739dd229d539$var$fe(q, m);
                                        $4d82739dd229d539$var$H("invalid", q);
                                        $4d82739dd229d539$var$we(x, "onChange");
                                        break;
                                    default:
                                        h = m;
                                }
                                $4d82739dd229d539$var$ue(k, h);
                                l = void 0;
                                var w = k, E = q, v = h;
                                for(l in v)if (v.hasOwnProperty(l)) {
                                    var n = v[l];
                                    "style" === l ? $4d82739dd229d539$var$se(E, n) : "dangerouslySetInnerHTML" === l ? (n = n ? n.__html : void 0, null != n && $4d82739dd229d539$var$ne(E, n)) : "children" === l ? "string" === typeof n ? ("textarea" !== w || "" !== n) && $4d82739dd229d539$var$oe(E, n) : "number" === typeof n && $4d82739dd229d539$var$oe(E, "" + n) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ta.hasOwnProperty(l) ? null != n && $4d82739dd229d539$var$we(x, l) : null != n && $4d82739dd229d539$var$xc(E, l, n, C));
                                }
                                switch(k){
                                    case "input":
                                        $4d82739dd229d539$var$Vb(q);
                                        $4d82739dd229d539$var$Ec(q, m, !1);
                                        break;
                                    case "textarea":
                                        $4d82739dd229d539$var$Vb(q);
                                        $4d82739dd229d539$var$ie(q, m);
                                        break;
                                    case "option":
                                        null != m.value && q.setAttribute("value", "" + $4d82739dd229d539$var$yc(m.value));
                                        break;
                                    case "select":
                                        h = q;
                                        h.multiple = !!m.multiple;
                                        q = m.value;
                                        null != q ? $4d82739dd229d539$var$ee(h, !!m.multiple, q, !1) : null != m.defaultValue && $4d82739dd229d539$var$ee(h, !!m.multiple, m.defaultValue, !0);
                                        break;
                                    default:
                                        "function" === typeof h.onClick && (q.onclick = $4d82739dd229d539$var$xe);
                                }
                                (g = $4d82739dd229d539$var$Ae(f, g)) && $4d82739dd229d539$var$sh(b);
                                b.stateNode = e;
                            }
                            null !== b.ref && (b.effectTag |= 128);
                        } else null === b.stateNode && $4d82739dd229d539$var$t("166");
                        break;
                    case 6:
                        e && null != b.stateNode ? $4d82739dd229d539$var$zh(e, b, e.memoizedProps, g) : ("string" !== typeof g && null === b.stateNode && $4d82739dd229d539$var$t("166"), e = $4d82739dd229d539$var$Of($4d82739dd229d539$var$Nf.current), $4d82739dd229d539$var$Of($4d82739dd229d539$var$Lf.current), $4d82739dd229d539$var$Mg(b) ? (g = b, f = g.stateNode, e = g.memoizedProps, f[$4d82739dd229d539$var$Ha] = g, (g = f.nodeValue !== e) && $4d82739dd229d539$var$sh(b)) : (f = b, g = (9 === e.nodeType ? e : e.ownerDocument).createTextNode(g), g[$4d82739dd229d539$var$Ha] = b, f.stateNode = g));
                        break;
                    case 11:
                        break;
                    case 13:
                        g = b.memoizedState;
                        if (0 !== (b.effectTag & 64)) {
                            b.expirationTime = f;
                            $4d82739dd229d539$var$T = b;
                            break a;
                        }
                        g = null !== g;
                        f = null !== e && null !== e.memoizedState;
                        null !== e && !g && f && (e = e.child.sibling, null !== e && (h = b.firstEffect, null !== h ? (b.firstEffect = e, e.nextEffect = h) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8));
                        if (g || f) b.effectTag |= 4;
                        break;
                    case 7:
                        break;
                    case 8:
                        break;
                    case 12:
                        break;
                    case 4:
                        $4d82739dd229d539$var$Qf(b);
                        $4d82739dd229d539$var$xh(b);
                        break;
                    case 10:
                        $4d82739dd229d539$var$gh(b);
                        break;
                    case 9:
                        break;
                    case 14:
                        break;
                    case 17:
                        $4d82739dd229d539$var$M(b.type) && $4d82739dd229d539$var$Pe(b);
                        break;
                    default:
                        $4d82739dd229d539$var$t("156");
                }
                $4d82739dd229d539$var$T = null;
            }
            b = a;
            if (1 === $4d82739dd229d539$var$U || 1 !== b.childExpirationTime) {
                g = 0;
                for(f = b.child; null !== f;)e = f.expirationTime, h = f.childExpirationTime, e > g && (g = e), h > g && (g = h), f = f.sibling;
                b.childExpirationTime = g;
            }
            if (null !== $4d82739dd229d539$var$T) return $4d82739dd229d539$var$T;
            null !== c && 0 === (c.effectTag & 1024) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
        } else {
            a = $4d82739dd229d539$var$Rh(a, $4d82739dd229d539$var$U);
            if (null !== a) return a.effectTag &= 1023, a;
            null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 1024);
        }
        if (null !== d) return d;
        if (null !== c) a = c;
        else break;
    }
    return null;
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$ah(a.alternate, a, $4d82739dd229d539$var$U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $4d82739dd229d539$var$gi(a));
    $4d82739dd229d539$var$Th.current = null;
    return b;
}
function $4d82739dd229d539$var$ii(a, b) {
    $4d82739dd229d539$var$Wh && $4d82739dd229d539$var$t("243");
    $4d82739dd229d539$var$sf();
    $4d82739dd229d539$var$Wh = !0;
    var c = $4d82739dd229d539$var$Sh.current;
    $4d82739dd229d539$var$Sh.current = $4d82739dd229d539$var$rg;
    var d = a.nextExpirationTimeToWorkOn;
    if (d !== $4d82739dd229d539$var$U || a !== $4d82739dd229d539$var$Xh || null === $4d82739dd229d539$var$T) $4d82739dd229d539$var$di(), $4d82739dd229d539$var$Xh = a, $4d82739dd229d539$var$U = d, $4d82739dd229d539$var$T = $4d82739dd229d539$var$bf($4d82739dd229d539$var$Xh.current, null, $4d82739dd229d539$var$U), a.pendingCommitExpirationTime = 0;
    var e = !1;
    do {
        try {
            if (b) for(; null !== $4d82739dd229d539$var$T && !$4d82739dd229d539$var$ji();)$4d82739dd229d539$var$T = $4d82739dd229d539$var$hi($4d82739dd229d539$var$T);
            else for(; null !== $4d82739dd229d539$var$T;)$4d82739dd229d539$var$T = $4d82739dd229d539$var$hi($4d82739dd229d539$var$T);
        } catch (E) {
            if ($4d82739dd229d539$var$fh = $4d82739dd229d539$var$eh = $4d82739dd229d539$var$dh = null, $4d82739dd229d539$var$sg(), null === $4d82739dd229d539$var$T) e = !0, $4d82739dd229d539$var$Oh(E);
            else {
                null === $4d82739dd229d539$var$T && $4d82739dd229d539$var$t("271");
                var f = $4d82739dd229d539$var$T, g = f.return;
                if (null === g) e = !0, $4d82739dd229d539$var$Oh(E);
                else {
                    a: {
                        var h = a, l = g, k = f, m = E;
                        g = $4d82739dd229d539$var$U;
                        k.effectTag |= 1024;
                        k.firstEffect = k.lastEffect = null;
                        if (null !== m && "object" === typeof m && "function" === typeof m.then) {
                            var q = m;
                            m = l;
                            var x = -1, C = -1;
                            do {
                                if (13 === m.tag) {
                                    var w = m.alternate;
                                    if (null !== w && (w = w.memoizedState, null !== w)) {
                                        C = 10 * (1073741822 - w.timedOutAt);
                                        break;
                                    }
                                    w = m.pendingProps.maxDuration;
                                    if ("number" === typeof w) {
                                        if (0 >= w) x = 0;
                                        else if (-1 === x || w < x) x = w;
                                    }
                                }
                                m = m.return;
                            }while (null !== m);
                            m = l;
                            do {
                                if (w = 13 === m.tag) w = void 0 === m.memoizedProps.fallback ? !1 : null === m.memoizedState;
                                if (w) {
                                    l = m.updateQueue;
                                    null === l ? (l = new Set, l.add(q), m.updateQueue = l) : l.add(q);
                                    if (0 === (m.mode & 1)) {
                                        m.effectTag |= 64;
                                        k.effectTag &= -1957;
                                        1 === k.tag && (null === k.alternate ? k.tag = 17 : (g = $4d82739dd229d539$var$rf(1073741823), g.tag = $4d82739dd229d539$var$wf, $4d82739dd229d539$var$tf(k, g)));
                                        k.expirationTime = 1073741823;
                                        break a;
                                    }
                                    k = h.pingCache;
                                    null === k ? (k = h.pingCache = new $4d82739dd229d539$var$Mh, l = new Set, k.set(q, l)) : (l = k.get(q), void 0 === l && (l = new Set, k.set(q, l)));
                                    l.has(g) || (l.add(g), k = $4d82739dd229d539$var$ki.bind(null, h, q, g), q.then(k, k));
                                    -1 === x ? h = 1073741823 : (-1 === C && (C = 10 * (1073741822 - $4d82739dd229d539$var$lf(h, g)) - 5E3), h = C + x);
                                    0 <= h && $4d82739dd229d539$var$Yh < h && ($4d82739dd229d539$var$Yh = h);
                                    m.effectTag |= 2048;
                                    m.expirationTime = g;
                                    break a;
                                }
                                m = m.return;
                            }while (null !== m);
                            m = Error(($4d82739dd229d539$var$mc(k.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $4d82739dd229d539$var$nc(k));
                        }
                        $4d82739dd229d539$var$Zh = !0;
                        m = $4d82739dd229d539$var$rh(m, k);
                        h = l;
                        do {
                            switch(h.tag){
                                case 3:
                                    h.effectTag |= 2048;
                                    h.expirationTime = g;
                                    g = $4d82739dd229d539$var$Nh(h, m, g);
                                    $4d82739dd229d539$var$mh(h, g);
                                    break a;
                                case 1:
                                    if (q = m, x = h.type, C = h.stateNode, 0 === (h.effectTag & 64) && ("function" === typeof x.getDerivedStateFromError || null !== C && "function" === typeof C.componentDidCatch && (null === $4d82739dd229d539$var$Qh || !$4d82739dd229d539$var$Qh.has(C)))) {
                                        h.effectTag |= 2048;
                                        h.expirationTime = g;
                                        g = $4d82739dd229d539$var$Ph(h, q, g);
                                        $4d82739dd229d539$var$mh(h, g);
                                        break a;
                                    }
                            }
                            h = h.return;
                        }while (null !== h);
                    }
                    $4d82739dd229d539$var$T = $4d82739dd229d539$var$gi(f);
                    continue;
                }
            }
        }
        break;
    }while (1);
    $4d82739dd229d539$var$Wh = !1;
    $4d82739dd229d539$var$Sh.current = c;
    $4d82739dd229d539$var$fh = $4d82739dd229d539$var$eh = $4d82739dd229d539$var$dh = null;
    $4d82739dd229d539$var$sg();
    if (e) $4d82739dd229d539$var$Xh = null, a.finishedWork = null;
    else if (null !== $4d82739dd229d539$var$T) a.finishedWork = null;
    else {
        c = a.current.alternate;
        null === c && $4d82739dd229d539$var$t("281");
        $4d82739dd229d539$var$Xh = null;
        if ($4d82739dd229d539$var$Zh) {
            e = a.latestPendingTime;
            f = a.latestSuspendedTime;
            g = a.latestPingedTime;
            if (0 !== e && e < d || 0 !== f && f < d || 0 !== g && g < d) {
                $4d82739dd229d539$var$kf(a, d);
                $4d82739dd229d539$var$li(a, c, d, a.expirationTime, -1);
                return;
            }
            if (!a.didError && b) {
                a.didError = !0;
                d = a.nextExpirationTimeToWorkOn = d;
                b = a.expirationTime = 1073741823;
                $4d82739dd229d539$var$li(a, c, d, b, -1);
                return;
            }
        }
        b && -1 !== $4d82739dd229d539$var$Yh ? ($4d82739dd229d539$var$kf(a, d), b = 10 * (1073741822 - $4d82739dd229d539$var$lf(a, d)), b < $4d82739dd229d539$var$Yh && ($4d82739dd229d539$var$Yh = b), b = 10 * (1073741822 - $4d82739dd229d539$var$pf()), b = $4d82739dd229d539$var$Yh - b, $4d82739dd229d539$var$li(a, c, d, a.expirationTime, 0 > b ? 0 : b)) : (a.pendingCommitExpirationTime = d, a.finishedWork = c);
    }
}
function $4d82739dd229d539$var$Dh(a, b) {
    for(var c = a.return; null !== c;){
        switch(c.tag){
            case 1:
                var d = c.stateNode;
                if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Qh || !$4d82739dd229d539$var$Qh.has(d))) {
                    a = $4d82739dd229d539$var$rh(b, a);
                    a = $4d82739dd229d539$var$Ph(c, a, 1073741823);
                    $4d82739dd229d539$var$tf(c, a);
                    $4d82739dd229d539$var$uf(c, 1073741823);
                    return;
                }
                break;
            case 3:
                a = $4d82739dd229d539$var$rh(b, a);
                a = $4d82739dd229d539$var$Nh(c, a, 1073741823);
                $4d82739dd229d539$var$tf(c, a);
                $4d82739dd229d539$var$uf(c, 1073741823);
                return;
        }
        c = c.return;
    }
    3 === a.tag && (c = $4d82739dd229d539$var$rh(b, a), c = $4d82739dd229d539$var$Nh(a, c, 1073741823), $4d82739dd229d539$var$tf(a, c), $4d82739dd229d539$var$uf(a, 1073741823));
}
function $4d82739dd229d539$var$qf(a, b) {
    0 !== $4d82739dd229d539$var$Vh ? a = $4d82739dd229d539$var$Vh : $4d82739dd229d539$var$Wh ? a = $4d82739dd229d539$var$$h ? 1073741823 : $4d82739dd229d539$var$U : b.mode & 1 ? (a = $4d82739dd229d539$var$mi ? 1073741822 - 10 * (((1073741822 - a + 15) / 10 | 0) + 1) : 1073741822 - 25 * (((1073741822 - a + 500) / 25 | 0) + 1), null !== $4d82739dd229d539$var$Xh && a === $4d82739dd229d539$var$U && --a) : a = 1073741823;
    $4d82739dd229d539$var$mi && (0 === $4d82739dd229d539$var$ni || a < $4d82739dd229d539$var$ni) && ($4d82739dd229d539$var$ni = a);
    return a;
}
function $4d82739dd229d539$var$ki(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    if (null !== $4d82739dd229d539$var$Xh && $4d82739dd229d539$var$U === c) $4d82739dd229d539$var$Xh = null;
    else if (b = a.earliestSuspendedTime, d = a.latestSuspendedTime, 0 !== b && c <= b && c >= d) {
        a.didError = !1;
        b = a.latestPingedTime;
        if (0 === b || b > c) a.latestPingedTime = c;
        $4d82739dd229d539$var$jf(c, a);
        c = a.expirationTime;
        0 !== c && $4d82739dd229d539$var$fi(a, c);
    }
}
function $4d82739dd229d539$var$Lh(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = $4d82739dd229d539$var$pf();
    b = $4d82739dd229d539$var$qf(b, a);
    a = $4d82739dd229d539$var$oi(a, b);
    null !== a && ($4d82739dd229d539$var$hf(a, b), b = a.expirationTime, 0 !== b && $4d82739dd229d539$var$fi(a, b));
}
function $4d82739dd229d539$var$oi(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    return e;
}
function $4d82739dd229d539$var$uf(a, b) {
    a = $4d82739dd229d539$var$oi(a, b);
    null !== a && (!$4d82739dd229d539$var$Wh && 0 !== $4d82739dd229d539$var$U && b > $4d82739dd229d539$var$U && $4d82739dd229d539$var$di(), $4d82739dd229d539$var$hf(a, b), $4d82739dd229d539$var$Wh && !$4d82739dd229d539$var$$h && $4d82739dd229d539$var$Xh === a || $4d82739dd229d539$var$fi(a, a.expirationTime), $4d82739dd229d539$var$pi > $4d82739dd229d539$var$qi && ($4d82739dd229d539$var$pi = 0, $4d82739dd229d539$var$t("185")));
}
function $4d82739dd229d539$var$ri(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Vh;
    $4d82739dd229d539$var$Vh = 1073741823;
    try {
        return a(b, c, d, e);
    } finally{
        $4d82739dd229d539$var$Vh = f;
    }
}
var $4d82739dd229d539$var$si = null, $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$ti = 0, $4d82739dd229d539$var$ui = void 0, $4d82739dd229d539$var$W = !1, $4d82739dd229d539$var$vi = null, $4d82739dd229d539$var$Y = 0, $4d82739dd229d539$var$ni = 0, $4d82739dd229d539$var$wi = !1, $4d82739dd229d539$var$xi = null, $4d82739dd229d539$var$Z = !1, $4d82739dd229d539$var$yi = !1, $4d82739dd229d539$var$mi = !1, $4d82739dd229d539$var$zi = null, $4d82739dd229d539$var$Ai = $33s19.unstable_now(), $4d82739dd229d539$var$Bi = 1073741822 - ($4d82739dd229d539$var$Ai / 10 | 0), $4d82739dd229d539$var$Ci = $4d82739dd229d539$var$Bi, $4d82739dd229d539$var$qi = 50, $4d82739dd229d539$var$pi = 0, $4d82739dd229d539$var$Di = null;
function $4d82739dd229d539$var$Ei() {
    $4d82739dd229d539$var$Bi = 1073741822 - (($33s19.unstable_now() - $4d82739dd229d539$var$Ai) / 10 | 0);
}
function $4d82739dd229d539$var$Fi(a, b) {
    if (0 !== $4d82739dd229d539$var$ti) {
        if (b < $4d82739dd229d539$var$ti) return;
        null !== $4d82739dd229d539$var$ui && $33s19.unstable_cancelCallback($4d82739dd229d539$var$ui);
    }
    $4d82739dd229d539$var$ti = b;
    a = $33s19.unstable_now() - $4d82739dd229d539$var$Ai;
    $4d82739dd229d539$var$ui = $33s19.unstable_scheduleCallback($4d82739dd229d539$var$Gi, {
        timeout: 10 * (1073741822 - b) - a
    });
}
function $4d82739dd229d539$var$li(a, b, c, d, e) {
    a.expirationTime = d;
    0 !== e || $4d82739dd229d539$var$ji() ? 0 < e && (a.timeoutHandle = $4d82739dd229d539$var$Ce($4d82739dd229d539$var$Hi.bind(null, a, b, c), e)) : (a.pendingCommitExpirationTime = c, a.finishedWork = b);
}
function $4d82739dd229d539$var$Hi(a, b, c) {
    a.pendingCommitExpirationTime = c;
    a.finishedWork = b;
    $4d82739dd229d539$var$Ei();
    $4d82739dd229d539$var$Ci = $4d82739dd229d539$var$Bi;
    $4d82739dd229d539$var$Ii(a, c);
}
function $4d82739dd229d539$var$pf() {
    if ($4d82739dd229d539$var$W) return $4d82739dd229d539$var$Ci;
    $4d82739dd229d539$var$Ji();
    if (0 === $4d82739dd229d539$var$Y || 1 === $4d82739dd229d539$var$Y) $4d82739dd229d539$var$Ei(), $4d82739dd229d539$var$Ci = $4d82739dd229d539$var$Bi;
    return $4d82739dd229d539$var$Ci;
}
function $4d82739dd229d539$var$fi(a, b) {
    null === a.nextScheduledRoot ? (a.expirationTime = b, null === $4d82739dd229d539$var$X ? ($4d82739dd229d539$var$si = $4d82739dd229d539$var$X = a, a.nextScheduledRoot = a) : ($4d82739dd229d539$var$X = $4d82739dd229d539$var$X.nextScheduledRoot = a, $4d82739dd229d539$var$X.nextScheduledRoot = $4d82739dd229d539$var$si)) : b > a.expirationTime && (a.expirationTime = b);
    $4d82739dd229d539$var$W || ($4d82739dd229d539$var$Z ? $4d82739dd229d539$var$yi && ($4d82739dd229d539$var$vi = a, $4d82739dd229d539$var$Y = 1073741823, $4d82739dd229d539$var$Ki(a, 1073741823, !1)) : 1073741823 === b ? $4d82739dd229d539$var$Li(1073741823, !1) : $4d82739dd229d539$var$Fi(a, b));
}
function $4d82739dd229d539$var$Ji() {
    var a = 0, b = null;
    if (null !== $4d82739dd229d539$var$X) for(var c = $4d82739dd229d539$var$X, d = $4d82739dd229d539$var$si; null !== d;){
        var e = d.expirationTime;
        if (0 === e) {
            (null === c || null === $4d82739dd229d539$var$X) && $4d82739dd229d539$var$t("244");
            if (d === d.nextScheduledRoot) {
                $4d82739dd229d539$var$si = $4d82739dd229d539$var$X = d.nextScheduledRoot = null;
                break;
            } else if (d === $4d82739dd229d539$var$si) $4d82739dd229d539$var$si = e = d.nextScheduledRoot, $4d82739dd229d539$var$X.nextScheduledRoot = e, d.nextScheduledRoot = null;
            else if (d === $4d82739dd229d539$var$X) {
                $4d82739dd229d539$var$X = c;
                $4d82739dd229d539$var$X.nextScheduledRoot = $4d82739dd229d539$var$si;
                d.nextScheduledRoot = null;
                break;
            } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;
            d = c.nextScheduledRoot;
        } else {
            e > a && (a = e, b = d);
            if (d === $4d82739dd229d539$var$X) break;
            if (1073741823 === a) break;
            c = d;
            d = d.nextScheduledRoot;
        }
    }
    $4d82739dd229d539$var$vi = b;
    $4d82739dd229d539$var$Y = a;
}
var $4d82739dd229d539$var$Mi = !1;
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Mi ? !0 : $33s19.unstable_shouldYield() ? $4d82739dd229d539$var$Mi = !0 : !1;
}
function $4d82739dd229d539$var$Gi() {
    try {
        if (!$4d82739dd229d539$var$ji() && null !== $4d82739dd229d539$var$si) {
            $4d82739dd229d539$var$Ei();
            var a = $4d82739dd229d539$var$si;
            do {
                var b = a.expirationTime;
                0 !== b && $4d82739dd229d539$var$Bi <= b && (a.nextExpirationTimeToWorkOn = $4d82739dd229d539$var$Bi);
                a = a.nextScheduledRoot;
            }while (a !== $4d82739dd229d539$var$si);
        }
        $4d82739dd229d539$var$Li(0, !0);
    } finally{
        $4d82739dd229d539$var$Mi = !1;
    }
}
function $4d82739dd229d539$var$Li(a, b) {
    $4d82739dd229d539$var$Ji();
    if (b) for($4d82739dd229d539$var$Ei(), $4d82739dd229d539$var$Ci = $4d82739dd229d539$var$Bi; null !== $4d82739dd229d539$var$vi && 0 !== $4d82739dd229d539$var$Y && a <= $4d82739dd229d539$var$Y && !($4d82739dd229d539$var$Mi && $4d82739dd229d539$var$Bi > $4d82739dd229d539$var$Y);)$4d82739dd229d539$var$Ki($4d82739dd229d539$var$vi, $4d82739dd229d539$var$Y, $4d82739dd229d539$var$Bi > $4d82739dd229d539$var$Y), $4d82739dd229d539$var$Ji(), $4d82739dd229d539$var$Ei(), $4d82739dd229d539$var$Ci = $4d82739dd229d539$var$Bi;
    else for(; null !== $4d82739dd229d539$var$vi && 0 !== $4d82739dd229d539$var$Y && a <= $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Ki($4d82739dd229d539$var$vi, $4d82739dd229d539$var$Y, !1), $4d82739dd229d539$var$Ji();
    b && ($4d82739dd229d539$var$ti = 0, $4d82739dd229d539$var$ui = null);
    0 !== $4d82739dd229d539$var$Y && $4d82739dd229d539$var$Fi($4d82739dd229d539$var$vi, $4d82739dd229d539$var$Y);
    $4d82739dd229d539$var$pi = 0;
    $4d82739dd229d539$var$Di = null;
    if (null !== $4d82739dd229d539$var$zi) for(a = $4d82739dd229d539$var$zi, $4d82739dd229d539$var$zi = null, b = 0; b < a.length; b++){
        var c = a[b];
        try {
            c._onComplete();
        } catch (d) {
            $4d82739dd229d539$var$wi || ($4d82739dd229d539$var$wi = !0, $4d82739dd229d539$var$xi = d);
        }
    }
    if ($4d82739dd229d539$var$wi) throw a = $4d82739dd229d539$var$xi, $4d82739dd229d539$var$xi = null, $4d82739dd229d539$var$wi = !1, a;
}
function $4d82739dd229d539$var$Ii(a, b) {
    $4d82739dd229d539$var$W && $4d82739dd229d539$var$t("253");
    $4d82739dd229d539$var$vi = a;
    $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$Ki(a, b, !1);
    $4d82739dd229d539$var$Li(1073741823, !1);
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    $4d82739dd229d539$var$W && $4d82739dd229d539$var$t("245");
    $4d82739dd229d539$var$W = !0;
    if (c) {
        var d = a.finishedWork;
        null !== d ? $4d82739dd229d539$var$Oi(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, $4d82739dd229d539$var$De(d)), $4d82739dd229d539$var$ii(a, c), d = a.finishedWork, null !== d && ($4d82739dd229d539$var$ji() ? a.finishedWork = d : $4d82739dd229d539$var$Oi(a, d, b)));
    } else d = a.finishedWork, null !== d ? $4d82739dd229d539$var$Oi(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, $4d82739dd229d539$var$De(d)), $4d82739dd229d539$var$ii(a, c), d = a.finishedWork, null !== d && $4d82739dd229d539$var$Oi(a, d, b));
    $4d82739dd229d539$var$W = !1;
}
function $4d82739dd229d539$var$Oi(a, b, c) {
    var d = a.firstBatch;
    if (null !== d && d._expirationTime >= c && (null === $4d82739dd229d539$var$zi ? $4d82739dd229d539$var$zi = [
        d
    ] : $4d82739dd229d539$var$zi.push(d), d._defer)) {
        a.finishedWork = b;
        a.expirationTime = 0;
        return;
    }
    a.finishedWork = null;
    a === $4d82739dd229d539$var$Di ? $4d82739dd229d539$var$pi++ : ($4d82739dd229d539$var$Di = a, $4d82739dd229d539$var$pi = 0);
    $4d82739dd229d539$var$$h = $4d82739dd229d539$var$Wh = !0;
    a.current === b && $4d82739dd229d539$var$t("177");
    c = a.pendingCommitExpirationTime;
    0 === c && $4d82739dd229d539$var$t("261");
    a.pendingCommitExpirationTime = 0;
    d = b.expirationTime;
    var e = b.childExpirationTime;
    d = e > d ? e : d;
    a.didError = !1;
    0 === d ? (a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0) : (d < a.latestPingedTime && (a.latestPingedTime = 0), e = a.latestPendingTime, 0 !== e && (e > d ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime > d && (a.earliestPendingTime = a.latestPendingTime)), e = a.earliestSuspendedTime, 0 === e ? $4d82739dd229d539$var$hf(a, d) : d < a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, $4d82739dd229d539$var$hf(a, d)) : d > e && $4d82739dd229d539$var$hf(a, d));
    $4d82739dd229d539$var$jf(0, a);
    $4d82739dd229d539$var$Th.current = null;
    1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;
    $4d82739dd229d539$var$ye = $4d82739dd229d539$var$Hd;
    e = $4d82739dd229d539$var$Td();
    if ($4d82739dd229d539$var$Ud(e)) {
        if ("selectionStart" in e) var f = {
            start: e.selectionStart,
            end: e.selectionEnd
        };
        else a: {
            f = (f = e.ownerDocument) && f.defaultView || window;
            var g = f.getSelection && f.getSelection();
            if (g && 0 !== g.rangeCount) {
                f = g.anchorNode;
                var h = g.anchorOffset, l = g.focusNode;
                g = g.focusOffset;
                try {
                    f.nodeType, l.nodeType;
                } catch (ub) {
                    f = null;
                    break a;
                }
                var k = 0, m = -1, q = -1, x = 0, C = 0, w = e, E = null;
                b: for(;;){
                    for(var v;;){
                        w !== f || 0 !== h && 3 !== w.nodeType || (m = k + h);
                        w !== l || 0 !== g && 3 !== w.nodeType || (q = k + g);
                        3 === w.nodeType && (k += w.nodeValue.length);
                        if (null === (v = w.firstChild)) break;
                        E = w;
                        w = v;
                    }
                    for(;;){
                        if (w === e) break b;
                        E === f && ++x === h && (m = k);
                        E === l && ++C === g && (q = k);
                        if (null !== (v = w.nextSibling)) break;
                        w = E;
                        E = w.parentNode;
                    }
                    w = v;
                }
                f = -1 === m || -1 === q ? null : {
                    start: m,
                    end: q
                };
            } else f = null;
        }
        f = f || {
            start: 0,
            end: 0
        };
    } else f = null;
    $4d82739dd229d539$var$ze = {
        focusedElem: e,
        selectionRange: f
    };
    $4d82739dd229d539$var$Hd = !1;
    for($4d82739dd229d539$var$V = d; null !== $4d82739dd229d539$var$V;){
        e = !1;
        f = void 0;
        try {
            for(; null !== $4d82739dd229d539$var$V;){
                if ($4d82739dd229d539$var$V.effectTag & 256) a: {
                    var n = $4d82739dd229d539$var$V.alternate;
                    h = $4d82739dd229d539$var$V;
                    switch(h.tag){
                        case 0:
                        case 11:
                        case 15:
                            $4d82739dd229d539$var$Eh($4d82739dd229d539$var$Uf, $4d82739dd229d539$var$Tf, h);
                            break a;
                        case 1:
                            if (h.effectTag & 256 && null !== n) {
                                var u = n.memoizedProps, z = n.memoizedState, Ag = h.stateNode, Ni = Ag.getSnapshotBeforeUpdate(h.elementType === h.type ? u : $4d82739dd229d539$var$P(h.type, u), z);
                                Ag.__reactInternalSnapshotBeforeUpdate = Ni;
                            }
                            break a;
                        case 3:
                        case 5:
                        case 6:
                        case 4:
                        case 17:
                            break a;
                        default:
                            $4d82739dd229d539$var$t("163");
                    }
                }
                $4d82739dd229d539$var$V = $4d82739dd229d539$var$V.nextEffect;
            }
        } catch (ub) {
            e = !0, f = ub;
        }
        e && (null === $4d82739dd229d539$var$V && $4d82739dd229d539$var$t("178"), $4d82739dd229d539$var$Dh($4d82739dd229d539$var$V, f), null !== $4d82739dd229d539$var$V && ($4d82739dd229d539$var$V = $4d82739dd229d539$var$V.nextEffect));
    }
    for($4d82739dd229d539$var$V = d; null !== $4d82739dd229d539$var$V;){
        n = !1;
        u = void 0;
        try {
            for(; null !== $4d82739dd229d539$var$V;){
                var y = $4d82739dd229d539$var$V.effectTag;
                y & 16 && $4d82739dd229d539$var$oe($4d82739dd229d539$var$V.stateNode, "");
                if (y & 128) {
                    var B = $4d82739dd229d539$var$V.alternate;
                    if (null !== B) {
                        var r = B.ref;
                        null !== r && ("function" === typeof r ? r(null) : r.current = null);
                    }
                }
                switch(y & 14){
                    case 2:
                        $4d82739dd229d539$var$Jh($4d82739dd229d539$var$V);
                        $4d82739dd229d539$var$V.effectTag &= -3;
                        break;
                    case 6:
                        $4d82739dd229d539$var$Jh($4d82739dd229d539$var$V);
                        $4d82739dd229d539$var$V.effectTag &= -3;
                        $4d82739dd229d539$var$Kh($4d82739dd229d539$var$V.alternate, $4d82739dd229d539$var$V);
                        break;
                    case 4:
                        $4d82739dd229d539$var$Kh($4d82739dd229d539$var$V.alternate, $4d82739dd229d539$var$V);
                        break;
                    case 8:
                        z = $4d82739dd229d539$var$V;
                        $4d82739dd229d539$var$Hh(z);
                        z.return = null;
                        z.child = null;
                        z.memoizedState = null;
                        z.updateQueue = null;
                        var O = z.alternate;
                        null !== O && (O.return = null, O.child = null, O.memoizedState = null, O.updateQueue = null);
                }
                $4d82739dd229d539$var$V = $4d82739dd229d539$var$V.nextEffect;
            }
        } catch (ub) {
            n = !0, u = ub;
        }
        n && (null === $4d82739dd229d539$var$V && $4d82739dd229d539$var$t("178"), $4d82739dd229d539$var$Dh($4d82739dd229d539$var$V, u), null !== $4d82739dd229d539$var$V && ($4d82739dd229d539$var$V = $4d82739dd229d539$var$V.nextEffect));
    }
    r = $4d82739dd229d539$var$ze;
    B = $4d82739dd229d539$var$Td();
    y = r.focusedElem;
    n = r.selectionRange;
    if (B !== y && y && y.ownerDocument && $4d82739dd229d539$var$Sd(y.ownerDocument.documentElement, y)) {
        null !== n && $4d82739dd229d539$var$Ud(y) && (B = n.start, r = n.end, void 0 === r && (r = B), "selectionStart" in y ? (y.selectionStart = B, y.selectionEnd = Math.min(r, y.value.length)) : (r = (B = y.ownerDocument || document) && B.defaultView || window, r.getSelection && (r = r.getSelection(), u = y.textContent.length, O = Math.min(n.start, u), n = void 0 === n.end ? O : Math.min(n.end, u), !r.extend && O > n && (u = n, n = O, O = u), u = $4d82739dd229d539$var$Rd(y, O), z = $4d82739dd229d539$var$Rd(y, n), u && z && (1 !== r.rangeCount || r.anchorNode !== u.node || r.anchorOffset !== u.offset || r.focusNode !== z.node || r.focusOffset !== z.offset) && (B = B.createRange(), B.setStart(u.node, u.offset), r.removeAllRanges(), O > n ? (r.addRange(B), r.extend(z.node, z.offset)) : (B.setEnd(z.node, z.offset), r.addRange(B))))));
        B = [];
        for(r = y; r = r.parentNode;)1 === r.nodeType && B.push({
            element: r,
            left: r.scrollLeft,
            top: r.scrollTop
        });
        "function" === typeof y.focus && y.focus();
        for(y = 0; y < B.length; y++)r = B[y], r.element.scrollLeft = r.left, r.element.scrollTop = r.top;
    }
    $4d82739dd229d539$var$ze = null;
    $4d82739dd229d539$var$Hd = !!$4d82739dd229d539$var$ye;
    $4d82739dd229d539$var$ye = null;
    a.current = b;
    for($4d82739dd229d539$var$V = d; null !== $4d82739dd229d539$var$V;){
        y = !1;
        B = void 0;
        try {
            for(r = a, O = c; null !== $4d82739dd229d539$var$V;){
                var qa = $4d82739dd229d539$var$V.effectTag;
                if (qa & 36) {
                    var Rb = $4d82739dd229d539$var$V.alternate;
                    n = $4d82739dd229d539$var$V;
                    u = O;
                    switch(n.tag){
                        case 0:
                        case 11:
                        case 15:
                            $4d82739dd229d539$var$Eh($4d82739dd229d539$var$Xf, $4d82739dd229d539$var$Yf, n);
                            break;
                        case 1:
                            var id = n.stateNode;
                            if (n.effectTag & 4) {
                                if (null === Rb) id.componentDidMount();
                                else {
                                    var dj = n.elementType === n.type ? Rb.memoizedProps : $4d82739dd229d539$var$P(n.type, Rb.memoizedProps);
                                    id.componentDidUpdate(dj, Rb.memoizedState, id.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var th = n.updateQueue;
                            null !== th && $4d82739dd229d539$var$ph(n, th, id, u);
                            break;
                        case 3:
                            var uh = n.updateQueue;
                            if (null !== uh) {
                                z = null;
                                if (null !== n.child) switch(n.child.tag){
                                    case 5:
                                        z = n.child.stateNode;
                                        break;
                                    case 1:
                                        z = n.child.stateNode;
                                }
                                $4d82739dd229d539$var$ph(n, uh, z, u);
                            }
                            break;
                        case 5:
                            var ej = n.stateNode;
                            null === Rb && n.effectTag & 4 && $4d82739dd229d539$var$Ae(n.type, n.memoizedProps) && ej.focus();
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            break;
                        case 17:
                            break;
                        default:
                            $4d82739dd229d539$var$t("163");
                    }
                }
                if (qa & 128) {
                    var jd = $4d82739dd229d539$var$V.ref;
                    if (null !== jd) {
                        var vh = $4d82739dd229d539$var$V.stateNode;
                        switch($4d82739dd229d539$var$V.tag){
                            case 5:
                                var Ne = vh;
                                break;
                            default:
                                Ne = vh;
                        }
                        "function" === typeof jd ? jd(Ne) : jd.current = Ne;
                    }
                }
                qa & 512 && ($4d82739dd229d539$var$ai = r);
                $4d82739dd229d539$var$V = $4d82739dd229d539$var$V.nextEffect;
            }
        } catch (ub) {
            y = !0, B = ub;
        }
        y && (null === $4d82739dd229d539$var$V && $4d82739dd229d539$var$t("178"), $4d82739dd229d539$var$Dh($4d82739dd229d539$var$V, B), null !== $4d82739dd229d539$var$V && ($4d82739dd229d539$var$V = $4d82739dd229d539$var$V.nextEffect));
    }
    null !== d && null !== $4d82739dd229d539$var$ai && (qa = $4d82739dd229d539$var$ei.bind(null, a, d), $4d82739dd229d539$var$bi = $4d82739dd229d539$var$Ee(qa), $4d82739dd229d539$var$ci = qa);
    $4d82739dd229d539$var$Wh = $4d82739dd229d539$var$$h = !1;
    "function" === typeof $4d82739dd229d539$var$Ve && $4d82739dd229d539$var$Ve(b.stateNode);
    qa = b.expirationTime;
    b = b.childExpirationTime;
    b = b > qa ? b : qa;
    0 === b && ($4d82739dd229d539$var$Qh = null);
    a.expirationTime = b;
    a.finishedWork = null;
}
function $4d82739dd229d539$var$Oh(a) {
    null === $4d82739dd229d539$var$vi && $4d82739dd229d539$var$t("246");
    $4d82739dd229d539$var$vi.expirationTime = 0;
    $4d82739dd229d539$var$wi || ($4d82739dd229d539$var$wi = !0, $4d82739dd229d539$var$xi = a);
}
function $4d82739dd229d539$var$Pi(a, b) {
    var c = $4d82739dd229d539$var$Z;
    $4d82739dd229d539$var$Z = !0;
    try {
        return a(b);
    } finally{
        ($4d82739dd229d539$var$Z = c) || $4d82739dd229d539$var$W || $4d82739dd229d539$var$Li(1073741823, !1);
    }
}
function $4d82739dd229d539$var$Qi(a, b) {
    if ($4d82739dd229d539$var$Z && !$4d82739dd229d539$var$yi) {
        $4d82739dd229d539$var$yi = !0;
        try {
            return a(b);
        } finally{
            $4d82739dd229d539$var$yi = !1;
        }
    }
    return a(b);
}
function $4d82739dd229d539$var$Ri(a, b, c) {
    if ($4d82739dd229d539$var$mi) return a(b, c);
    $4d82739dd229d539$var$Z || $4d82739dd229d539$var$W || 0 === $4d82739dd229d539$var$ni || ($4d82739dd229d539$var$Li($4d82739dd229d539$var$ni, !1), $4d82739dd229d539$var$ni = 0);
    var d = $4d82739dd229d539$var$mi, e = $4d82739dd229d539$var$Z;
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$mi = !0;
    try {
        return a(b, c);
    } finally{
        $4d82739dd229d539$var$mi = d, ($4d82739dd229d539$var$Z = e) || $4d82739dd229d539$var$W || $4d82739dd229d539$var$Li(1073741823, !1);
    }
}
function $4d82739dd229d539$var$Si(a, b, c, d, e) {
    var f = b.current;
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            2 === $4d82739dd229d539$var$kd(c) && 1 === c.tag || $4d82739dd229d539$var$t("170");
            var g = c;
            do {
                switch(g.tag){
                    case 3:
                        g = g.stateNode.context;
                        break b;
                    case 1:
                        if ($4d82739dd229d539$var$M(g.type)) {
                            g = g.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                g = g.return;
            }while (null !== g);
            $4d82739dd229d539$var$t("171");
            g = void 0;
        }
        if (1 === c.tag) {
            var h = c.type;
            if ($4d82739dd229d539$var$M(h)) {
                c = $4d82739dd229d539$var$Se(c, h, g);
                break a;
            }
        }
        c = g;
    } else c = $4d82739dd229d539$var$Le;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = e;
    e = $4d82739dd229d539$var$rf(d);
    e.payload = {
        element: a
    };
    b = void 0 === b ? null : b;
    null !== b && (e.callback = b);
    $4d82739dd229d539$var$sf();
    $4d82739dd229d539$var$tf(f, e);
    $4d82739dd229d539$var$uf(f, d);
    return d;
}
function $4d82739dd229d539$var$Ti(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$pf();
    e = $4d82739dd229d539$var$qf(f, e);
    return $4d82739dd229d539$var$Si(a, b, c, e, d);
}
function $4d82739dd229d539$var$Ui(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$Vi(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$$b,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$4d82739dd229d539$var$Db = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$Cc(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Ma(d);
                        e || $4d82739dd229d539$var$t("90");
                        $4d82739dd229d539$var$Wb(d);
                        $4d82739dd229d539$var$Cc(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$he(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$ee(a, !!c.multiple, b, !1);
    }
};
function $4d82739dd229d539$var$Wi(a) {
    var b = 1073741822 - 25 * (((1073741822 - $4d82739dd229d539$var$pf() + 500) / 25 | 0) + 1);
    b >= $4d82739dd229d539$var$Uh && (b = $4d82739dd229d539$var$Uh - 1);
    this._expirationTime = $4d82739dd229d539$var$Uh = b;
    this._root = a;
    this._callbacks = this._next = null;
    this._hasChildren = this._didComplete = !1;
    this._children = null;
    this._defer = !0;
}
$4d82739dd229d539$var$Wi.prototype.render = function(a) {
    this._defer || $4d82739dd229d539$var$t("250");
    this._hasChildren = !0;
    this._children = a;
    var b = this._root._internalRoot, c = this._expirationTime, d = new $4d82739dd229d539$var$Xi;
    $4d82739dd229d539$var$Si(a, b, null, c, d._onCommit);
    return d;
};
$4d82739dd229d539$var$Wi.prototype.then = function(a) {
    if (this._didComplete) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$4d82739dd229d539$var$Wi.prototype.commit = function() {
    var a = this._root._internalRoot, b = a.firstBatch;
    this._defer && null !== b || $4d82739dd229d539$var$t("251");
    if (this._hasChildren) {
        var c = this._expirationTime;
        if (b !== this) {
            this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));
            for(var d = null, e = b; e !== this;)d = e, e = e._next;
            null === d && $4d82739dd229d539$var$t("251");
            d._next = e._next;
            this._next = b;
            a.firstBatch = this;
        }
        this._defer = !1;
        $4d82739dd229d539$var$Ii(a, c);
        b = this._next;
        this._next = null;
        b = a.firstBatch = b;
        null !== b && b._hasChildren && b.render(b._children);
    } else this._next = null, this._defer = !1;
};
$4d82739dd229d539$var$Wi.prototype._onComplete = function() {
    if (!this._didComplete) {
        this._didComplete = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++)(0, a[b])();
    }
};
function $4d82739dd229d539$var$Xi() {
    this._callbacks = null;
    this._didCommit = !1;
    this._onCommit = this._onCommit.bind(this);
}
$4d82739dd229d539$var$Xi.prototype.then = function(a) {
    if (this._didCommit) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$4d82739dd229d539$var$Xi.prototype._onCommit = function() {
    if (!this._didCommit) {
        this._didCommit = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++){
            var c = a[b];
            "function" !== typeof c && $4d82739dd229d539$var$t("191", c);
            c();
        }
    }
};
function $4d82739dd229d539$var$Yi(a, b, c) {
    b = $4d82739dd229d539$var$N(3, null, null, b ? 3 : 0);
    a = {
        current: b,
        containerInfo: a,
        pendingChildren: null,
        pingCache: null,
        earliestPendingTime: 0,
        latestPendingTime: 0,
        earliestSuspendedTime: 0,
        latestSuspendedTime: 0,
        latestPingedTime: 0,
        didError: !1,
        pendingCommitExpirationTime: 0,
        finishedWork: null,
        timeoutHandle: -1,
        context: null,
        pendingContext: null,
        hydrate: c,
        nextExpirationTimeToWorkOn: 0,
        expirationTime: 0,
        firstBatch: null,
        nextScheduledRoot: null
    };
    this._internalRoot = b.stateNode = a;
}
$4d82739dd229d539$var$Yi.prototype.render = function(a, b) {
    var c = this._internalRoot, d = new $4d82739dd229d539$var$Xi;
    b = void 0 === b ? null : b;
    null !== b && d.then(b);
    $4d82739dd229d539$var$Ti(a, c, null, d._onCommit);
    return d;
};
$4d82739dd229d539$var$Yi.prototype.unmount = function(a) {
    var b = this._internalRoot, c = new $4d82739dd229d539$var$Xi;
    a = void 0 === a ? null : a;
    null !== a && c.then(a);
    $4d82739dd229d539$var$Ti(null, b, null, c._onCommit);
    return c;
};
$4d82739dd229d539$var$Yi.prototype.legacy_renderSubtreeIntoContainer = function(a, b, c) {
    var d = this._internalRoot, e = new $4d82739dd229d539$var$Xi;
    c = void 0 === c ? null : c;
    null !== c && e.then(c);
    $4d82739dd229d539$var$Ti(b, d, a, e._onCommit);
    return e;
};
$4d82739dd229d539$var$Yi.prototype.createBatch = function() {
    var a = new $4d82739dd229d539$var$Wi(this), b = a._expirationTime, c = this._internalRoot, d = c.firstBatch;
    if (null === d) c.firstBatch = a, a._next = null;
    else {
        for(c = null; null !== d && d._expirationTime >= b;)c = d, d = d._next;
        a._next = d;
        null !== c && (c._next = a);
    }
    return a;
};
function $4d82739dd229d539$var$Zi(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
$4d82739dd229d539$var$Jb = $4d82739dd229d539$var$Pi;
$4d82739dd229d539$var$Kb = $4d82739dd229d539$var$Ri;
$4d82739dd229d539$var$Lb = function() {
    $4d82739dd229d539$var$W || 0 === $4d82739dd229d539$var$ni || ($4d82739dd229d539$var$Li($4d82739dd229d539$var$ni, !1), $4d82739dd229d539$var$ni = 0);
};
function $4d82739dd229d539$var$$i(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $4d82739dd229d539$var$Yi(a, !1, b);
}
function $4d82739dd229d539$var$aj(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        if ("function" === typeof e) {
            var g = e;
            e = function() {
                var a = $4d82739dd229d539$var$Ui(f._internalRoot);
                g.call(a);
            };
        }
        null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    } else {
        f = c._reactRootContainer = $4d82739dd229d539$var$$i(c, d);
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$Ui(f._internalRoot);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$Qi(function() {
            null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
        });
    }
    return $4d82739dd229d539$var$Ui(f._internalRoot);
}
function $4d82739dd229d539$var$bj(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    $4d82739dd229d539$var$Zi(b) || $4d82739dd229d539$var$t("200");
    return $4d82739dd229d539$var$Vi(a, b, null, c);
}
var $4d82739dd229d539$var$fj = {
    createPortal: $4d82739dd229d539$var$bj,
    findDOMNode: function(a) {
        if (null == a) return null;
        if (1 === a.nodeType) return a;
        var b = a._reactInternalFiber;
        void 0 === b && ("function" === typeof a.render ? $4d82739dd229d539$var$t("188") : $4d82739dd229d539$var$t("268", Object.keys(a)));
        a = $4d82739dd229d539$var$nd(b);
        a = null === a ? null : a.stateNode;
        return a;
    },
    hydrate: function(a, b, c) {
        $4d82739dd229d539$var$Zi(b) || $4d82739dd229d539$var$t("200");
        return $4d82739dd229d539$var$aj(null, a, b, !0, c);
    },
    render: function(a, b, c) {
        $4d82739dd229d539$var$Zi(b) || $4d82739dd229d539$var$t("200");
        return $4d82739dd229d539$var$aj(null, a, b, !1, c);
    },
    unstable_renderSubtreeIntoContainer: function(a, b, c, d) {
        $4d82739dd229d539$var$Zi(c) || $4d82739dd229d539$var$t("200");
        (null == a || void 0 === a._reactInternalFiber) && $4d82739dd229d539$var$t("38");
        return $4d82739dd229d539$var$aj(a, b, c, !1, d);
    },
    unmountComponentAtNode: function(a) {
        $4d82739dd229d539$var$Zi(a) || $4d82739dd229d539$var$t("40");
        return a._reactRootContainer ? ($4d82739dd229d539$var$Qi(function() {
            $4d82739dd229d539$var$aj(null, null, a, !1, function() {
                a._reactRootContainer = null;
            });
        }), !0) : !1;
    },
    unstable_createPortal: function() {
        return $4d82739dd229d539$var$bj.apply(void 0, arguments);
    },
    unstable_batchedUpdates: $4d82739dd229d539$var$Pi,
    unstable_interactiveUpdates: $4d82739dd229d539$var$Ri,
    flushSync: function(a, b) {
        $4d82739dd229d539$var$W && $4d82739dd229d539$var$t("187");
        var c = $4d82739dd229d539$var$Z;
        $4d82739dd229d539$var$Z = !0;
        try {
            return $4d82739dd229d539$var$ri(a, b);
        } finally{
            $4d82739dd229d539$var$Z = c, $4d82739dd229d539$var$Li(1073741823, !1);
        }
    },
    unstable_createRoot: $4d82739dd229d539$var$cj,
    unstable_flushControlled: function(a) {
        var b = $4d82739dd229d539$var$Z;
        $4d82739dd229d539$var$Z = !0;
        try {
            $4d82739dd229d539$var$ri(a);
        } finally{
            ($4d82739dd229d539$var$Z = b) || $4d82739dd229d539$var$W || $4d82739dd229d539$var$Li(1073741823, !1);
        }
    },
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        Events: [
            $4d82739dd229d539$var$Ka,
            $4d82739dd229d539$var$La,
            $4d82739dd229d539$var$Ma,
            $4d82739dd229d539$var$Da.injectEventPluginsByName,
            $4d82739dd229d539$var$ra,
            $4d82739dd229d539$var$Sa,
            function(a) {
                $4d82739dd229d539$var$Aa(a, $4d82739dd229d539$var$Ra);
            },
            $4d82739dd229d539$var$Hb,
            $4d82739dd229d539$var$Ib,
            $4d82739dd229d539$var$Jd,
            $4d82739dd229d539$var$Fa
        ]
    }
};
function $4d82739dd229d539$var$cj(a, b) {
    $4d82739dd229d539$var$Zi(a) || $4d82739dd229d539$var$t("299", "unstable_createRoot");
    return new $4d82739dd229d539$var$Yi(a, !0, null != b && !0 === b.hydrate);
}
(function(a) {
    var b = a.findFiberByHostInstance;
    return $4d82739dd229d539$var$Ye($013Yp({}, a, {
        overrideProps: null,
        currentDispatcherRef: $4d82739dd229d539$var$Xb.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $4d82739dd229d539$var$nd(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        }
    }));
})({
    findFiberByHostInstance: $4d82739dd229d539$var$Ja,
    bundleType: 0,
    version: "16.8.0",
    rendererPackageName: "react-dom"
});
var $4d82739dd229d539$var$gj = {
    default: $4d82739dd229d539$var$fj
}, $4d82739dd229d539$var$hj = $4d82739dd229d539$var$gj && $4d82739dd229d539$var$fj || $4d82739dd229d539$var$gj;
module.exports = $4d82739dd229d539$var$hj.default || $4d82739dd229d539$var$hj;

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {
/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $749777fefd570b40$var$d = null, $749777fefd570b40$var$e = !1, $749777fefd570b40$var$g = 3, $749777fefd570b40$var$k = -1, $749777fefd570b40$var$l = -1, $749777fefd570b40$var$m = !1, $749777fefd570b40$var$n = !1;
function $749777fefd570b40$var$p() {
    if (!$749777fefd570b40$var$m) {
        var a = $749777fefd570b40$var$d.expirationTime;
        $749777fefd570b40$var$n ? $749777fefd570b40$var$q() : $749777fefd570b40$var$n = !0;
        $749777fefd570b40$var$r($749777fefd570b40$var$t, a);
    }
}
function $749777fefd570b40$var$u() {
    var a = $749777fefd570b40$var$d, b = $749777fefd570b40$var$d.next;
    if ($749777fefd570b40$var$d === b) $749777fefd570b40$var$d = null;
    else {
        var c = $749777fefd570b40$var$d.previous;
        $749777fefd570b40$var$d = c.next = b;
        b.previous = c;
    }
    a.next = a.previous = null;
    c = a.callback;
    b = a.expirationTime;
    a = a.priorityLevel;
    var f = $749777fefd570b40$var$g, Q = $749777fefd570b40$var$l;
    $749777fefd570b40$var$g = a;
    $749777fefd570b40$var$l = b;
    try {
        var h = c();
    } finally{
        $749777fefd570b40$var$g = f, $749777fefd570b40$var$l = Q;
    }
    if ("function" === typeof h) {
        if (h = {
            callback: h,
            priorityLevel: a,
            expirationTime: b,
            next: null,
            previous: null
        }, null === $749777fefd570b40$var$d) $749777fefd570b40$var$d = h.next = h.previous = h;
        else {
            c = null;
            a = $749777fefd570b40$var$d;
            do {
                if (a.expirationTime >= b) {
                    c = a;
                    break;
                }
                a = a.next;
            }while (a !== $749777fefd570b40$var$d);
            null === c ? c = $749777fefd570b40$var$d : c === $749777fefd570b40$var$d && ($749777fefd570b40$var$d = h, $749777fefd570b40$var$p());
            b = c.previous;
            b.next = c.previous = h;
            h.next = c;
            h.previous = b;
        }
    }
}
function $749777fefd570b40$var$v() {
    if (-1 === $749777fefd570b40$var$k && null !== $749777fefd570b40$var$d && 1 === $749777fefd570b40$var$d.priorityLevel) {
        $749777fefd570b40$var$m = !0;
        try {
            do $749777fefd570b40$var$u();
            while (null !== $749777fefd570b40$var$d && 1 === $749777fefd570b40$var$d.priorityLevel);
        } finally{
            $749777fefd570b40$var$m = !1, null !== $749777fefd570b40$var$d ? $749777fefd570b40$var$p() : $749777fefd570b40$var$n = !1;
        }
    }
}
function $749777fefd570b40$var$t(a) {
    $749777fefd570b40$var$m = !0;
    var b = $749777fefd570b40$var$e;
    $749777fefd570b40$var$e = a;
    try {
        if (a) for(; null !== $749777fefd570b40$var$d;){
            var c = module.exports.unstable_now();
            if ($749777fefd570b40$var$d.expirationTime <= c) do $749777fefd570b40$var$u();
            while (null !== $749777fefd570b40$var$d && $749777fefd570b40$var$d.expirationTime <= c);
            else break;
        }
        else if (null !== $749777fefd570b40$var$d) do $749777fefd570b40$var$u();
        while (null !== $749777fefd570b40$var$d && !$749777fefd570b40$var$w());
    } finally{
        $749777fefd570b40$var$m = !1, $749777fefd570b40$var$e = b, null !== $749777fefd570b40$var$d ? $749777fefd570b40$var$p() : $749777fefd570b40$var$n = !1, $749777fefd570b40$var$v();
    }
}
var $749777fefd570b40$var$x = Date, $749777fefd570b40$var$y = "function" === typeof setTimeout ? setTimeout : void 0, $749777fefd570b40$var$z = "function" === typeof clearTimeout ? clearTimeout : void 0, $749777fefd570b40$var$A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0, $749777fefd570b40$var$B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0, $749777fefd570b40$var$C, $749777fefd570b40$var$D;
function $749777fefd570b40$var$E(a) {
    $749777fefd570b40$var$C = $749777fefd570b40$var$A(function(b) {
        $749777fefd570b40$var$z($749777fefd570b40$var$D);
        a(b);
    });
    $749777fefd570b40$var$D = $749777fefd570b40$var$y(function() {
        $749777fefd570b40$var$B($749777fefd570b40$var$C);
        a(module.exports.unstable_now());
    }, 100);
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$F = performance;
    module.exports.unstable_now = function() {
        return $749777fefd570b40$var$F.now();
    };
} else module.exports.unstable_now = function() {
    return $749777fefd570b40$var$x.now();
};
var $749777fefd570b40$var$r, $749777fefd570b40$var$q, $749777fefd570b40$var$w, $749777fefd570b40$var$G = null;
"undefined" !== typeof window ? $749777fefd570b40$var$G = window : "undefined" !== typeof $parcel$global && ($749777fefd570b40$var$G = $parcel$global);
if ($749777fefd570b40$var$G && $749777fefd570b40$var$G._schedMock) {
    var $749777fefd570b40$var$H = $749777fefd570b40$var$G._schedMock;
    $749777fefd570b40$var$r = $749777fefd570b40$var$H[0];
    $749777fefd570b40$var$q = $749777fefd570b40$var$H[1];
    $749777fefd570b40$var$w = $749777fefd570b40$var$H[2];
    module.exports.unstable_now = $749777fefd570b40$var$H[3];
} else if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $749777fefd570b40$var$I = null, $749777fefd570b40$var$J = function(a) {
        if (null !== $749777fefd570b40$var$I) try {
            $749777fefd570b40$var$I(a);
        } finally{
            $749777fefd570b40$var$I = null;
        }
    };
    $749777fefd570b40$var$r = function(a) {
        null !== $749777fefd570b40$var$I ? setTimeout($749777fefd570b40$var$r, 0, a) : ($749777fefd570b40$var$I = a, setTimeout($749777fefd570b40$var$J, 0, !1));
    };
    $749777fefd570b40$var$q = function() {
        $749777fefd570b40$var$I = null;
    };
    $749777fefd570b40$var$w = function() {
        return !1;
    };
} else {
    "undefined" !== typeof console && ("function" !== typeof $749777fefd570b40$var$A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof $749777fefd570b40$var$B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    var $749777fefd570b40$var$K = null, $749777fefd570b40$var$L = !1, $749777fefd570b40$var$M = -1, $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = !1, $749777fefd570b40$var$P = 0, $749777fefd570b40$var$R = 33, $749777fefd570b40$var$S = 33;
    $749777fefd570b40$var$w = function() {
        return $749777fefd570b40$var$P <= module.exports.unstable_now();
    };
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = function() {
        $749777fefd570b40$var$L = !1;
        var a = $749777fefd570b40$var$K, b = $749777fefd570b40$var$M;
        $749777fefd570b40$var$K = null;
        $749777fefd570b40$var$M = -1;
        var c = module.exports.unstable_now(), f = !1;
        if (0 >= $749777fefd570b40$var$P - c) {
            if (-1 !== b && b <= c) f = !0;
            else {
                $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$E($749777fefd570b40$var$V));
                $749777fefd570b40$var$K = a;
                $749777fefd570b40$var$M = b;
                return;
            }
        }
        if (null !== a) {
            $749777fefd570b40$var$O = !0;
            try {
                a(f);
            } finally{
                $749777fefd570b40$var$O = !1;
            }
        }
    };
    var $749777fefd570b40$var$V = function(a) {
        if (null !== $749777fefd570b40$var$K) {
            $749777fefd570b40$var$E($749777fefd570b40$var$V);
            var b = a - $749777fefd570b40$var$P + $749777fefd570b40$var$S;
            b < $749777fefd570b40$var$S && $749777fefd570b40$var$R < $749777fefd570b40$var$S ? (8 > b && (b = 8), $749777fefd570b40$var$S = b < $749777fefd570b40$var$R ? $749777fefd570b40$var$R : b) : $749777fefd570b40$var$R = b;
            $749777fefd570b40$var$P = a + $749777fefd570b40$var$S;
            $749777fefd570b40$var$L || ($749777fefd570b40$var$L = !0, $749777fefd570b40$var$U.postMessage(void 0));
        } else $749777fefd570b40$var$N = !1;
    };
    $749777fefd570b40$var$r = function(a, b) {
        $749777fefd570b40$var$K = a;
        $749777fefd570b40$var$M = b;
        $749777fefd570b40$var$O || 0 > b ? $749777fefd570b40$var$U.postMessage(void 0) : $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$E($749777fefd570b40$var$V));
    };
    $749777fefd570b40$var$q = function() {
        $749777fefd570b40$var$K = null;
        $749777fefd570b40$var$L = !1;
        $749777fefd570b40$var$M = -1;
    };
}
module.exports.unstable_ImmediatePriority = 1;
module.exports.unstable_UserBlockingPriority = 2;
module.exports.unstable_NormalPriority = 3;
module.exports.unstable_IdlePriority = 5;
module.exports.unstable_LowPriority = 4;
module.exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$g, f = $749777fefd570b40$var$k;
    $749777fefd570b40$var$g = a;
    $749777fefd570b40$var$k = module.exports.unstable_now();
    try {
        return b();
    } finally{
        $749777fefd570b40$var$g = c, $749777fefd570b40$var$k = f, $749777fefd570b40$var$v();
    }
};
module.exports.unstable_next = function(a) {
    switch($749777fefd570b40$var$g){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$g;
    }
    var c = $749777fefd570b40$var$g, f = $749777fefd570b40$var$k;
    $749777fefd570b40$var$g = b;
    $749777fefd570b40$var$k = module.exports.unstable_now();
    try {
        return a();
    } finally{
        $749777fefd570b40$var$g = c, $749777fefd570b40$var$k = f, $749777fefd570b40$var$v();
    }
};
module.exports.unstable_scheduleCallback = function(a, b) {
    var c = -1 !== $749777fefd570b40$var$k ? $749777fefd570b40$var$k : module.exports.unstable_now();
    if ("object" === typeof b && null !== b && "number" === typeof b.timeout) b = c + b.timeout;
    else switch($749777fefd570b40$var$g){
        case 1:
            b = c + -1;
            break;
        case 2:
            b = c + 250;
            break;
        case 5:
            b = c + 1073741823;
            break;
        case 4:
            b = c + 1E4;
            break;
        default:
            b = c + 5E3;
    }
    a = {
        callback: a,
        priorityLevel: $749777fefd570b40$var$g,
        expirationTime: b,
        next: null,
        previous: null
    };
    if (null === $749777fefd570b40$var$d) $749777fefd570b40$var$d = a.next = a.previous = a, $749777fefd570b40$var$p();
    else {
        c = null;
        var f = $749777fefd570b40$var$d;
        do {
            if (f.expirationTime > b) {
                c = f;
                break;
            }
            f = f.next;
        }while (f !== $749777fefd570b40$var$d);
        null === c ? c = $749777fefd570b40$var$d : c === $749777fefd570b40$var$d && ($749777fefd570b40$var$d = a, $749777fefd570b40$var$p());
        b = c.previous;
        b.next = c.previous = a;
        a.next = c;
        a.previous = b;
    }
    return a;
};
module.exports.unstable_cancelCallback = function(a) {
    var b = a.next;
    if (null !== b) {
        if (b === a) $749777fefd570b40$var$d = null;
        else {
            a === $749777fefd570b40$var$d && ($749777fefd570b40$var$d = b);
            var c = a.previous;
            c.next = b;
            b.previous = c;
        }
        a.next = a.previous = null;
    }
};
module.exports.unstable_wrapCallback = function(a) {
    var b = $749777fefd570b40$var$g;
    return function() {
        var c = $749777fefd570b40$var$g, f = $749777fefd570b40$var$k;
        $749777fefd570b40$var$g = b;
        $749777fefd570b40$var$k = module.exports.unstable_now();
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$g = c, $749777fefd570b40$var$k = f, $749777fefd570b40$var$v();
        }
    };
};
module.exports.unstable_getCurrentPriorityLevel = function() {
    return $749777fefd570b40$var$g;
};
module.exports.unstable_shouldYield = function() {
    return !$749777fefd570b40$var$e && (null !== $749777fefd570b40$var$d && $749777fefd570b40$var$d.expirationTime < $749777fefd570b40$var$l || $749777fefd570b40$var$w());
};
module.exports.unstable_continueExecution = function() {
    null !== $749777fefd570b40$var$d && $749777fefd570b40$var$p();
};
module.exports.unstable_pauseExecution = function() {};
module.exports.unstable_getFirstCallbackNode = function() {
    return $749777fefd570b40$var$d;
};

});



parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("7IJ3O", function(module, exports) {
/** @license React v0.26.2
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 


module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    'use strict';
    var aa = (parcelRequire("013Yp")), ba = (parcelRequire("7fPBF")), m = (parcelRequire("b81Wb"));
    function q(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ca = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, da = 60103, ea = 60106, fa = 60107, ha = 60108, ia = 60114, ja = 60109, ka = 60110, la = 60112, ma = 60113, na = 60120, oa = 60115, pa = 60116, qa = 60121, ra = 60129, sa = 60130, ta = 60131;
    if ("function" === typeof Symbol && Symbol.for) {
        var r = Symbol.for;
        da = r("react.element");
        ea = r("react.portal");
        fa = r("react.fragment");
        ha = r("react.strict_mode");
        ia = r("react.profiler");
        ja = r("react.provider");
        ka = r("react.context");
        la = r("react.forward_ref");
        ma = r("react.suspense");
        na = r("react.suspense_list");
        oa = r("react.memo");
        pa = r("react.lazy");
        qa = r("react.block");
        r("react.scope");
        ra = r("react.debug_trace_mode");
        sa = r("react.offscreen");
        ta = r("react.legacy_hidden");
    }
    var ua = "function" === typeof Symbol && Symbol.iterator;
    function va(a) {
        if (null === a || "object" !== typeof a) return null;
        a = ua && a[ua] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function wa(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case fa:
                return "Fragment";
            case ea:
                return "Portal";
            case ia:
                return "Profiler";
            case ha:
                return "StrictMode";
            case ma:
                return "Suspense";
            case na:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ka:
                return (a.displayName || "Context") + ".Consumer";
            case ja:
                return (a._context.displayName || "Context") + ".Provider";
            case la:
                var b = a.render;
                b = b.displayName || b.name || "";
                return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
            case oa:
                return wa(a.type);
            case qa:
                return wa(a._render);
            case pa:
                b = a._payload;
                a = a._init;
                try {
                    return wa(a(b));
                } catch (c) {}
        }
        return null;
    }
    function xa(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function ya(a) {
        if (xa(a) !== a) throw Error(q(188));
    }
    function za(a) {
        var b = a.alternate;
        if (!b) {
            b = xa(a);
            if (null === b) throw Error(q(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return ya(e), a;
                    if (f === d) return ya(e), b;
                    f = f.sibling;
                }
                throw Error(q(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(q(189));
                }
            }
            if (c.alternate !== d) throw Error(q(190));
        }
        if (3 !== c.tag) throw Error(q(188));
        return c.stateNode.current === c ? a : b;
    }
    function Aa(a) {
        a = za(a);
        if (!a) return null;
        for(var b = a;;){
            if (5 === b.tag || 6 === b.tag) return b;
            if (b.child) b.child.return = b, b = b.child;
            else {
                if (b === a) break;
                for(; !b.sibling;){
                    if (!b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return null;
    }
    function Ba(a) {
        a = za(a);
        if (!a) return null;
        for(var b = a;;){
            if (5 === b.tag || 6 === b.tag) return b;
            if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;
            else {
                if (b === a) break;
                for(; !b.sibling;){
                    if (!b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return null;
    }
    function Ca(a, b) {
        for(var c = a.alternate; null !== b;){
            if (b === a || b === c) return !0;
            b = b.return;
        }
        return !1;
    }
    var Da = $$$hostConfig.getPublicInstance, Ea = $$$hostConfig.getRootHostContext, Fa = $$$hostConfig.getChildHostContext, Ga = $$$hostConfig.prepareForCommit, Ha = $$$hostConfig.resetAfterCommit, Ia = $$$hostConfig.createInstance, Ja = $$$hostConfig.appendInitialChild, Ka = $$$hostConfig.finalizeInitialChildren, La = $$$hostConfig.prepareUpdate, Ma = $$$hostConfig.shouldSetTextContent, Na = $$$hostConfig.createTextInstance, Pa = $$$hostConfig.scheduleTimeout, Qa = $$$hostConfig.cancelTimeout, Ra = $$$hostConfig.noTimeout, Sa = $$$hostConfig.isPrimaryRenderer, Ta = $$$hostConfig.supportsMutation, Ua = $$$hostConfig.supportsPersistence, Va = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.makeOpaqueHydratingObject, Ya = $$$hostConfig.makeClientId, Za = $$$hostConfig.beforeActiveInstanceBlur, $a = $$$hostConfig.afterActiveInstanceBlur, ab = $$$hostConfig.preparePortalMount, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.isSuspenseInstancePending, Ib = $$$hostConfig.isSuspenseInstanceFallback, Jb = $$$hostConfig.getNextHydratableSibling, Kb = $$$hostConfig.getFirstHydratableChild, Lb = $$$hostConfig.hydrateInstance, Mb = $$$hostConfig.hydrateTextInstance, Nb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Ob = $$$hostConfig.commitHydratedContainer, Pb = $$$hostConfig.commitHydratedSuspenseInstance, Qb;
    function Rb(a) {
        if (void 0 === Qb) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            Qb = b && b[1] || "";
        }
        return "\n" + Qb + a;
    }
    var Sb = !1;
    function Tb(a, b) {
        if (!a || Sb) return "";
        Sb = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (k) {
                        var d = k;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (k) {
                        d = k;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (k) {
                    d = k;
                }
                a();
            }
        } catch (k) {
            if (k && d && "string" === typeof k.stack) {
                for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            Sb = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? Rb(a) : "";
    }
    var Ub = [], Vb = -1;
    function Wb(a) {
        return {
            current: a
        };
    }
    function z(a) {
        0 > Vb || (a.current = Ub[Vb], Ub[Vb] = null, Vb--);
    }
    function A(a, b) {
        Vb++;
        Ub[Vb] = a.current;
        a.current = b;
    }
    var Xb = {}, B = Wb(Xb), D = Wb(!1), Yb = Xb;
    function Zb(a, b) {
        var c = a.type.contextTypes;
        if (!c) return Xb;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function E(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function $b() {
        z(D);
        z(B);
    }
    function ac(a, b, c) {
        if (B.current !== Xb) throw Error(q(168));
        A(B, b);
        A(D, c);
    }
    function bc(a, b, c) {
        var d = a.stateNode;
        a = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in a)) throw Error(q(108, wa(b) || "Unknown", e));
        return aa({}, c, d);
    }
    function cc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Xb;
        Yb = B.current;
        A(B, a);
        A(D, D.current);
        return !0;
    }
    function dc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(q(169));
        c ? (a = bc(a, b, Yb), d.__reactInternalMemoizedMergedChildContext = a, z(D), z(B), A(B, a)) : z(D);
        A(D, c);
    }
    var ec = null, fc = null, gc = m.unstable_now;
    gc();
    var hc = 0, F = 8;
    function ic(a) {
        if (0 !== (1 & a)) return F = 15, 1;
        if (0 !== (2 & a)) return F = 14, 2;
        if (0 !== (4 & a)) return F = 13, 4;
        var b = 24 & a;
        if (0 !== b) return F = 12, b;
        if (0 !== (a & 32)) return F = 11, 32;
        b = 192 & a;
        if (0 !== b) return F = 10, b;
        if (0 !== (a & 256)) return F = 9, 256;
        b = 3584 & a;
        if (0 !== b) return F = 8, b;
        if (0 !== (a & 4096)) return F = 7, 4096;
        b = 4186112 & a;
        if (0 !== b) return F = 6, b;
        b = 62914560 & a;
        if (0 !== b) return F = 5, b;
        if (a & 67108864) return F = 4, 67108864;
        if (0 !== (a & 134217728)) return F = 3, 134217728;
        b = 805306368 & a;
        if (0 !== b) return F = 2, b;
        if (0 !== (1073741824 & a)) return F = 1, 1073741824;
        F = 8;
        return a;
    }
    function jc(a) {
        switch(a){
            case 99:
                return 15;
            case 98:
                return 10;
            case 97:
            case 96:
                return 8;
            case 95:
                return 2;
            default:
                return 0;
        }
    }
    function kc(a) {
        switch(a){
            case 15:
            case 14:
                return 99;
            case 13:
            case 12:
            case 11:
            case 10:
                return 98;
            case 9:
            case 8:
            case 7:
            case 6:
            case 4:
            case 5:
                return 97;
            case 3:
            case 2:
            case 1:
                return 95;
            case 0:
                return 90;
            default:
                throw Error(q(358, a));
        }
    }
    function lc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return F = 0;
        var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
        if (0 !== f) d = f, e = F = 15;
        else if (f = c & 134217727, 0 !== f) {
            var k = f & ~g;
            0 !== k ? (d = ic(k), e = F) : (h &= f, 0 !== h && (d = ic(h), e = F));
        } else f = c & ~g, 0 !== f ? (d = ic(f), e = F) : 0 !== h && (d = ic(h), e = F);
        if (0 === d) return 0;
        d = 31 - mc(d);
        d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
        if (0 !== b && b !== d && 0 === (b & g)) {
            ic(b);
            if (e <= F) return b;
            F = e;
        }
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - mc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function nc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function oc(a, b) {
        switch(a){
            case 15:
                return 1;
            case 14:
                return 2;
            case 12:
                return a = pc(24 & ~b), 0 === a ? oc(10, b) : a;
            case 10:
                return a = pc(192 & ~b), 0 === a ? oc(8, b) : a;
            case 8:
                return a = pc(3584 & ~b), 0 === a && (a = pc(4186112 & ~b), 0 === a && (a = 512)), a;
            case 2:
                return b = pc(805306368 & ~b), 0 === b && (b = 268435456), b;
        }
        throw Error(q(358, a));
    }
    function pc(a) {
        return a & -a;
    }
    function qc(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function rc(a, b, c) {
        a.pendingLanes |= b;
        var d = b - 1;
        a.suspendedLanes &= d;
        a.pingedLanes &= d;
        a = a.eventTimes;
        b = 31 - mc(b);
        a[b] = c;
    }
    var mc = Math.clz32 ? Math.clz32 : sc, tc = Math.log, uc = Math.LN2;
    function sc(a) {
        return 0 === a ? 32 : 31 - (tc(a) / uc | 0) | 0;
    }
    var vc = m.unstable_runWithPriority, wc = m.unstable_scheduleCallback, xc = m.unstable_cancelCallback, yc = m.unstable_shouldYield, zc = m.unstable_requestPaint, Ac = m.unstable_now, Bc = m.unstable_getCurrentPriorityLevel, Cc = m.unstable_ImmediatePriority, Dc = m.unstable_UserBlockingPriority, Ec = m.unstable_NormalPriority, Fc = m.unstable_LowPriority, Gc = m.unstable_IdlePriority, Hc = {}, Ic = void 0 !== zc ? zc : function() {}, Jc = null, Kc = null, Lc = !1, Mc = Ac(), G = 1E4 > Mc ? Ac : function() {
        return Ac() - Mc;
    };
    function Nc() {
        switch(Bc()){
            case Cc:
                return 99;
            case Dc:
                return 98;
            case Ec:
                return 97;
            case Fc:
                return 96;
            case Gc:
                return 95;
            default:
                throw Error(q(332));
        }
    }
    function Oc(a) {
        switch(a){
            case 99:
                return Cc;
            case 98:
                return Dc;
            case 97:
                return Ec;
            case 96:
                return Fc;
            case 95:
                return Gc;
            default:
                throw Error(q(332));
        }
    }
    function Pc(a, b) {
        a = Oc(a);
        return vc(a, b);
    }
    function Qc(a, b, c) {
        a = Oc(a);
        return wc(a, b, c);
    }
    function H() {
        if (null !== Kc) {
            var a = Kc;
            Kc = null;
            xc(a);
        }
        Rc();
    }
    function Rc() {
        if (!Lc && null !== Jc) {
            Lc = !0;
            var a = 0;
            try {
                var b = Jc;
                Pc(99, function() {
                    for(; a < b.length; a++){
                        var c = b[a];
                        do c = c(!0);
                        while (null !== c);
                    }
                });
                Jc = null;
            } catch (c) {
                throw null !== Jc && (Jc = Jc.slice(a + 1)), wc(Cc, H), c;
            } finally{
                Lc = !1;
            }
        }
    }
    var Sc = ca.ReactCurrentBatchConfig;
    function Tc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var I = "function" === typeof Object.is ? Object.is : Tc, Uc = Object.prototype.hasOwnProperty;
    function Vc(a, b) {
        if (I(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++)if (!Uc.call(b, c[d]) || !I(a[c[d]], b[c[d]])) return !1;
        return !0;
    }
    function Wc(a) {
        switch(a.tag){
            case 5:
                return Rb(a.type);
            case 16:
                return Rb("Lazy");
            case 13:
                return Rb("Suspense");
            case 19:
                return Rb("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = Tb(a.type, !1), a;
            case 11:
                return a = Tb(a.type.render, !1), a;
            case 22:
                return a = Tb(a.type._render, !1), a;
            case 1:
                return a = Tb(a.type, !0), a;
            default:
                return "";
        }
    }
    function Xc(a, b) {
        if (a && a.defaultProps) {
            b = aa({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var Yc = Wb(null), Zc = null, $c = null, ad = null;
    function bd() {
        ad = $c = Zc = null;
    }
    function cd(a, b) {
        a = a.type._context;
        Sa ? (A(Yc, a._currentValue), a._currentValue = b) : (A(Yc, a._currentValue2), a._currentValue2 = b);
    }
    function dd(a) {
        var b = Yc.current;
        z(Yc);
        a = a.type._context;
        Sa ? a._currentValue = b : a._currentValue2 = b;
    }
    function ed(a, b) {
        for(; null !== a;){
            var c = a.alternate;
            if ((a.childLanes & b) === b) {
                if (null === c || (c.childLanes & b) === b) break;
                else c.childLanes |= b;
            } else a.childLanes |= b, null !== c && (c.childLanes |= b);
            a = a.return;
        }
    }
    function fd(a, b) {
        Zc = a;
        ad = $c = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (gd = !0), a.firstContext = null);
    }
    function J(a, b) {
        if (ad !== a && !1 !== b && 0 !== b) {
            if ("number" !== typeof b || 1073741823 === b) ad = a, b = 1073741823;
            b = {
                context: a,
                observedBits: b,
                next: null
            };
            if (null === $c) {
                if (null === Zc) throw Error(q(308));
                $c = b;
                Zc.dependencies = {
                    lanes: 0,
                    firstContext: b,
                    responders: null
                };
            } else $c = $c.next = b;
        }
        return Sa ? a._currentValue : a._currentValue2;
    }
    var hd = !1;
    function id(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null
            },
            effects: null
        };
    }
    function jd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function kd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function md(a, b) {
        a = a.updateQueue;
        if (null !== a) {
            a = a.shared;
            var c = a.pending;
            null === c ? b.next = b : (b.next = c.next, c.next = b);
            a.pending = b;
        }
    }
    function nd(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function od(a, b, c, d) {
        var e = a.updateQueue;
        hd = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var n = a.alternate;
            if (null !== n) {
                n = n.updateQueue;
                var t = n.lastBaseUpdate;
                t !== g && (null === t ? n.firstBaseUpdate = l : t.next = l, n.lastBaseUpdate = k);
            }
        }
        if (null !== f) {
            t = e.baseState;
            g = 0;
            n = l = k = null;
            do {
                h = f.lane;
                var p = f.eventTime;
                if ((d & h) === h) {
                    null !== n && (n = n.next = {
                        eventTime: p,
                        lane: 0,
                        tag: f.tag,
                        payload: f.payload,
                        callback: f.callback,
                        next: null
                    });
                    a: {
                        var y = a, x = f;
                        h = b;
                        p = c;
                        switch(x.tag){
                            case 1:
                                y = x.payload;
                                if ("function" === typeof y) {
                                    t = y.call(p, t, h);
                                    break a;
                                }
                                t = y;
                                break a;
                            case 3:
                                y.flags = y.flags & -4097 | 64;
                            case 0:
                                y = x.payload;
                                h = "function" === typeof y ? y.call(p, t, h) : y;
                                if (null === h || void 0 === h) break a;
                                t = aa({}, t, h);
                                break a;
                            case 2:
                                hd = !0;
                        }
                    }
                    null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                        f
                    ] : h.push(f));
                } else p = {
                    eventTime: p,
                    lane: h,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                }, null === n ? (l = n = p, k = t) : n = n.next = p, g |= h;
                f = f.next;
                if (null === f) {
                    if (h = e.shared.pending, null === h) break;
                    else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
                }
            }while (1);
            null === n && (k = t);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = n;
            pd |= g;
            a.lanes = g;
            a.memoizedState = t;
        }
    }
    function qd(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(q(191, e));
                e.call(d);
            }
        }
    }
    var rd = (new ba.Component).refs;
    function sd(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : aa({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var vd = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? xa(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = K(), e = td(a), f = kd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            md(a, f);
            ud(a, e, d);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = K(), e = td(a), f = kd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            md(a, f);
            ud(a, e, d);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = K(), d = td(a), e = kd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            md(a, e);
            ud(a, d, c);
        }
    };
    function wd(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Vc(c, d) || !Vc(e, f) : !0;
    }
    function xd(a, b, c) {
        var d = !1, e = Xb;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = J(f) : (e = E(b) ? Yb : B.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Zb(a, e) : Xb);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = vd;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function yd(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && vd.enqueueReplaceState(b, b.state, null);
    }
    function zd(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = rd;
        id(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = J(f) : (f = E(b) ? Yb : B.current, e.context = Zb(a, f));
        od(a, c, e, d);
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (sd(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && vd.enqueueReplaceState(e, e.state, null), od(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4);
    }
    var Ad = Array.isArray;
    function Bd(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(q(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(q(147, a));
                var e = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
                b = function(a) {
                    var b = d.refs;
                    b === rd && (b = d.refs = {});
                    null === a ? delete b[e] : b[e] = a;
                };
                b._stringRef = e;
                return b;
            }
            if ("string" !== typeof a) throw Error(q(284));
            if (!c._owner) throw Error(q(290, a));
        }
        return a;
    }
    function Cd(a, b) {
        if ("textarea" !== a.type) throw Error(q(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
    }
    function Dd(a) {
        function b(b, c) {
            if (a) {
                var d = b.lastEffect;
                null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
                c.nextEffect = null;
                c.flags = 8;
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = Ed(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
            b.flags = 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags = 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = Fd(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Bd(a, b, c), d.return = a, d;
            d = Gd(c.type, c.key, c.props, null, a.mode, d);
            d.ref = Bd(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Hd(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function n(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = Id(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function t(a, b, c) {
            if ("string" === typeof b || "number" === typeof b) return b = Fd("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case da:
                        return c = Gd(b.type, b.key, b.props, null, a.mode, c), c.ref = Bd(a, null, b), c.return = a, c;
                    case ea:
                        return b = Hd(b, a.mode, c), b.return = a, b;
                }
                if (Ad(b) || va(b)) return b = Id(b, a.mode, c, null), b.return = a, b;
                Cd(a, b);
            }
            return null;
        }
        function p(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case da:
                        return c.key === e ? c.type === fa ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                    case ea:
                        return c.key === e ? l(a, b, c, d) : null;
                }
                if (Ad(c) || va(c)) return null !== e ? null : n(a, b, c, d, null);
                Cd(a, c);
            }
            return null;
        }
        function y(a, b, c, d, e) {
            if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case da:
                        return a = a.get(null === d.key ? c : d.key) || null, d.type === fa ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                    case ea:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                }
                if (Ad(d) || va(d)) return a = a.get(c) || null, n(b, a, d, e, null);
                Cd(b, d);
            }
            return null;
        }
        function x(e, g, h, k) {
            for(var l = null, v = null, u = g, C = g = 0, n = null; null !== u && C < h.length; C++){
                u.index > C ? (n = u, u = null) : n = u.sibling;
                var w = p(e, u, h[C], k);
                if (null === w) {
                    null === u && (u = n);
                    break;
                }
                a && u && null === w.alternate && b(e, u);
                g = f(w, g, C);
                null === v ? l = w : v.sibling = w;
                v = w;
                u = n;
            }
            if (C === h.length) return c(e, u), l;
            if (null === u) {
                for(; C < h.length; C++)u = t(e, h[C], k), null !== u && (g = f(u, g, C), null === v ? l = u : v.sibling = u, v = u);
                return l;
            }
            for(u = d(e, u); C < h.length; C++)n = y(u, e, C, h[C], k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? C : n.key), g = f(n, g, C), null === v ? l = n : v.sibling = n, v = n);
            a && u.forEach(function(a) {
                return b(e, a);
            });
            return l;
        }
        function Y(e, g, h, k) {
            var l = va(h);
            if ("function" !== typeof l) throw Error(q(150));
            h = l.call(h);
            if (null == h) throw Error(q(151));
            for(var u = l = null, v = g, n = g = 0, C = null, w = h.next(); null !== v && !w.done; n++, w = h.next()){
                v.index > n ? (C = v, v = null) : C = v.sibling;
                var x = p(e, v, w.value, k);
                if (null === x) {
                    null === v && (v = C);
                    break;
                }
                a && v && null === x.alternate && b(e, v);
                g = f(x, g, n);
                null === u ? l = x : u.sibling = x;
                u = x;
                v = C;
            }
            if (w.done) return c(e, v), l;
            if (null === v) {
                for(; !w.done; n++, w = h.next())w = t(e, w.value, k), null !== w && (g = f(w, g, n), null === u ? l = w : u.sibling = w, u = w);
                return l;
            }
            for(v = d(e, v); !w.done; n++, w = h.next())w = y(v, e, n, w.value, k), null !== w && (a && null !== w.alternate && v.delete(null === w.key ? n : w.key), g = f(w, g, n), null === u ? l = w : u.sibling = w, u = w);
            a && v.forEach(function(a) {
                return b(e, a);
            });
            return l;
        }
        return function(a, d, f, h) {
            var k = "object" === typeof f && null !== f && f.type === fa && null === f.key;
            k && (f = f.props.children);
            var l = "object" === typeof f && null !== f;
            if (l) switch(f.$$typeof){
                case da:
                    a: {
                        l = f.key;
                        for(k = d; null !== k;){
                            if (k.key === l) {
                                switch(k.tag){
                                    case 7:
                                        if (f.type === fa) {
                                            c(a, k.sibling);
                                            d = e(k, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                        break;
                                    default:
                                        if (k.elementType === f.type) {
                                            c(a, k.sibling);
                                            d = e(k, f.props);
                                            d.ref = Bd(a, k, f);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                }
                                c(a, k);
                                break;
                            } else b(a, k);
                            k = k.sibling;
                        }
                        f.type === fa ? (d = Id(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Gd(f.type, f.key, f.props, null, a.mode, h), h.ref = Bd(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case ea:
                    a: {
                        for(k = f.key; null !== d;){
                            if (d.key === k) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Hd(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
            }
            if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Fd(f, a.mode, h), d.return = a, a = d), g(a);
            if (Ad(f)) return x(a, d, f, h);
            if (va(f)) return Y(a, d, f, h);
            l && Cd(a, f);
            if ("undefined" === typeof f && !k) switch(a.tag){
                case 1:
                case 22:
                case 0:
                case 11:
                case 15:
                    throw Error(q(152, wa(a.type) || "Component"));
            }
            return c(a, d);
        };
    }
    var Jd = Dd(!0), Kd = Dd(!1), Ld = {}, L = Wb(Ld), Md = Wb(Ld), Nd = Wb(Ld);
    function Od(a) {
        if (a === Ld) throw Error(q(174));
        return a;
    }
    function Pd(a, b) {
        A(Nd, b);
        A(Md, a);
        A(L, Ld);
        a = Ea(b);
        z(L);
        A(L, a);
    }
    function Qd() {
        z(L);
        z(Md);
        z(Nd);
    }
    function Rd(a) {
        var b = Od(Nd.current), c = Od(L.current);
        b = Fa(c, a.type, b);
        c !== b && (A(Md, a), A(L, b));
    }
    function Sd(a) {
        Md.current === a && (z(L), z(Md));
    }
    var M = Wb(0);
    function Td(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Hb(c) || Ib(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 64)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var Ud = null, Vd = null, Wd = !1;
    function Xd(a, b) {
        var c = Yd(5, null, null, 0);
        c.elementType = "DELETED";
        c.type = "DELETED";
        c.stateNode = b;
        c.return = a;
        c.flags = 8;
        null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
    }
    function Zd(a, b) {
        switch(a.tag){
            case 5:
                return b = Fb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
            case 6:
                return b = Gb(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
            case 13:
                return !1;
            default:
                return !1;
        }
    }
    function $d(a) {
        if (Wd) {
            var b = Vd;
            if (b) {
                var c = b;
                if (!Zd(a, b)) {
                    b = Jb(c);
                    if (!b || !Zd(a, b)) {
                        a.flags = a.flags & -1025 | 2;
                        Wd = !1;
                        Ud = a;
                        return;
                    }
                    Xd(Ud, c);
                }
                Ud = a;
                Vd = Kb(b);
            } else a.flags = a.flags & -1025 | 2, Wd = !1, Ud = a;
        }
    }
    function ae(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        Ud = a;
    }
    function be(a) {
        if (!Va || a !== Ud) return !1;
        if (!Wd) return ae(a), Wd = !0, !1;
        var b = a.type;
        if (5 !== a.tag || "head" !== b && "body" !== b && !Ma(b, a.memoizedProps)) for(b = Vd; b;)Xd(a, b), b = Jb(b);
        ae(a);
        if (13 === a.tag) {
            if (!Va) throw Error(q(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(q(317));
            Vd = Nb(a);
        } else Vd = Ud ? Jb(a.stateNode) : null;
        return !0;
    }
    function ce() {
        Va && (Vd = Ud = null, Wd = !1);
    }
    var de = [];
    function ee() {
        for(var a = 0; a < de.length; a++){
            var b = de[a];
            Sa ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        de.length = 0;
    }
    var fe = ca.ReactCurrentDispatcher, ge = ca.ReactCurrentBatchConfig, he = 0, N = null, O = null, P = null, ie = !1, je = !1;
    function Q() {
        throw Error(q(321));
    }
    function ke(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!I(a[c], b[c])) return !1;
        return !0;
    }
    function le(a, b, c, d, e, f) {
        he = f;
        N = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        fe.current = null === a || null === a.memoizedState ? me : ne;
        a = c(d, e);
        if (je) {
            f = 0;
            do {
                je = !1;
                if (!(25 > f)) throw Error(q(301));
                f += 1;
                P = O = null;
                b.updateQueue = null;
                fe.current = oe;
                a = c(d, e);
            }while (je);
        }
        fe.current = pe;
        b = null !== O && null !== O.next;
        he = 0;
        P = O = N = null;
        ie = !1;
        if (b) throw Error(q(300));
        return a;
    }
    function qe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
        return P;
    }
    function re() {
        if (null === O) {
            var a = N.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = O.next;
        var b = null === P ? N.memoizedState : P.next;
        if (null !== b) P = b, O = a;
        else {
            if (null === a) throw Error(q(310));
            O = a;
            a = {
                memoizedState: O.memoizedState,
                baseState: O.baseState,
                baseQueue: O.baseQueue,
                queue: O.queue,
                next: null
            };
            null === P ? N.memoizedState = P = a : P = P.next = a;
        }
        return P;
    }
    function se(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function te(a) {
        var b = re(), c = b.queue;
        if (null === c) throw Error(q(311));
        c.lastRenderedReducer = a;
        var d = O, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            e = e.next;
            d = d.baseState;
            var h = g = f = null, k = e;
            do {
                var l = k.lane;
                if ((he & l) === l) null !== h && (h = h.next = {
                    lane: 0,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
                else {
                    var n = {
                        lane: l,
                        action: k.action,
                        eagerReducer: k.eagerReducer,
                        eagerState: k.eagerState,
                        next: null
                    };
                    null === h ? (g = h = n, f = d) : h = h.next = n;
                    N.lanes |= l;
                    pd |= l;
                }
                k = k.next;
            }while (null !== k && k !== e);
            null === h ? f = d : h.next = g;
            I(d, b.memoizedState) || (gd = !0);
            b.memoizedState = d;
            b.baseState = f;
            b.baseQueue = h;
            c.lastRenderedState = d;
        }
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function ue(a) {
        var b = re(), c = b.queue;
        if (null === c) throw Error(q(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            I(f, b.memoizedState) || (gd = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function ve(a, b, c) {
        var d = b._getVersion;
        d = d(b._source);
        var e = Sa ? b._workInProgressVersionPrimary : b._workInProgressVersionSecondary;
        if (null !== e) a = e === d;
        else if (a = a.mutableReadLanes, a = (he & a) === a) Sa ? b._workInProgressVersionPrimary = d : b._workInProgressVersionSecondary = d, de.push(b);
        if (a) return c(b._source);
        de.push(b);
        throw Error(q(350));
    }
    function we(a, b, c, d) {
        var e = R;
        if (null === e) throw Error(q(349));
        var f = b._getVersion, g = f(b._source), h = fe.current, k = h.useState(function() {
            return ve(e, b, c);
        }), l = k[1], n = k[0];
        k = P;
        var t = a.memoizedState, p = t.refs, y = p.getSnapshot, x = t.source;
        t = t.subscribe;
        var Y = N;
        a.memoizedState = {
            refs: p,
            source: b,
            subscribe: d
        };
        h.useEffect(function() {
            p.getSnapshot = c;
            p.setSnapshot = l;
            var a = f(b._source);
            if (!I(g, a)) {
                a = c(b._source);
                I(n, a) || (l(a), a = td(Y), e.mutableReadLanes |= a & e.pendingLanes);
                a = e.mutableReadLanes;
                e.entangledLanes |= a;
                for(var d = e.entanglements, h = a; 0 < h;){
                    var k = 31 - mc(h), t = 1 << k;
                    d[k] |= a;
                    h &= ~t;
                }
            }
        }, [
            c,
            b,
            d
        ]);
        h.useEffect(function() {
            return d(b._source, function() {
                var a = p.getSnapshot, c = p.setSnapshot;
                try {
                    c(a(b._source));
                    var d = td(Y);
                    e.mutableReadLanes |= d & e.pendingLanes;
                } catch (Oa) {
                    c(function() {
                        throw Oa;
                    });
                }
            });
        }, [
            b,
            d
        ]);
        I(y, c) && I(x, b) && I(t, d) || (a = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: se,
            lastRenderedState: n
        }, a.dispatch = l = xe.bind(null, N, a), k.queue = a, k.baseQueue = null, n = ve(e, b, c), k.memoizedState = k.baseState = n);
        return n;
    }
    function ye(a, b, c) {
        var d = re();
        return we(d, a, b, c);
    }
    function ze(a) {
        var b = qe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: se,
            lastRenderedState: a
        };
        a = a.dispatch = xe.bind(null, N, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ae(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = N.updateQueue;
        null === b ? (b = {
            lastEffect: null
        }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function Be(a) {
        var b = qe();
        a = {
            current: a
        };
        return b.memoizedState = a;
    }
    function Ce() {
        return re().memoizedState;
    }
    function De(a, b, c, d) {
        var e = qe();
        N.flags |= a;
        e.memoizedState = Ae(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function Ee(a, b, c, d) {
        var e = re();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== O) {
            var g = O.memoizedState;
            f = g.destroy;
            if (null !== d && ke(d, g.deps)) {
                Ae(b, c, f, d);
                return;
            }
        }
        N.flags |= a;
        e.memoizedState = Ae(1 | b, c, f, d);
    }
    function Fe(a, b) {
        return De(516, 4, a, b);
    }
    function Ge(a, b) {
        return Ee(516, 4, a, b);
    }
    function He(a, b) {
        return Ee(4, 2, a, b);
    }
    function Ie(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function Je(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ee(4, 2, Ie.bind(null, b, a), c);
    }
    function Ke() {}
    function Le(a, b) {
        var c = re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && ke(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function Me(a, b) {
        var c = re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && ke(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function Ne(a, b) {
        var c = Nc();
        Pc(98 > c ? 98 : c, function() {
            a(!0);
        });
        Pc(97 < c ? 97 : c, function() {
            var c = ge.transition;
            ge.transition = 1;
            try {
                a(!1), b();
            } finally{
                ge.transition = c;
            }
        });
    }
    function xe(a, b, c) {
        var d = K(), e = td(a), f = {
            lane: e,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, g = b.pending;
        null === g ? f.next = f : (f.next = g.next, g.next = f);
        b.pending = f;
        g = a.alternate;
        if (a === N || null !== g && g === N) je = ie = !0;
        else {
            if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
                var h = b.lastRenderedState, k = g(h, c);
                f.eagerReducer = g;
                f.eagerState = k;
                if (I(k, h)) return;
            } catch (l) {} finally{}
            ud(a, e, d);
        }
    }
    var pe = {
        readContext: J,
        useCallback: Q,
        useContext: Q,
        useEffect: Q,
        useImperativeHandle: Q,
        useLayoutEffect: Q,
        useMemo: Q,
        useReducer: Q,
        useRef: Q,
        useState: Q,
        useDebugValue: Q,
        useDeferredValue: Q,
        useTransition: Q,
        useMutableSource: Q,
        useOpaqueIdentifier: Q,
        unstable_isNewReconciler: !1
    }, me = {
        readContext: J,
        useCallback: function(a, b) {
            qe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: J,
        useEffect: Fe,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return De(4, 2, Ie.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return De(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = qe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = qe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = d.queue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            a = a.dispatch = xe.bind(null, N, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: Be,
        useState: ze,
        useDebugValue: Ke,
        useDeferredValue: function(a) {
            var b = ze(a), c = b[0], d = b[1];
            Fe(function() {
                var b = ge.transition;
                ge.transition = 1;
                try {
                    d(a);
                } finally{
                    ge.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = ze(!1), b = a[0];
            a = Ne.bind(null, a[1]);
            Be(a);
            return [
                a,
                b
            ];
        },
        useMutableSource: function(a, b, c) {
            var d = qe();
            d.memoizedState = {
                refs: {
                    getSnapshot: b,
                    setSnapshot: null
                },
                source: a,
                subscribe: c
            };
            return we(d, a, b, c);
        },
        useOpaqueIdentifier: function() {
            if (Wd) {
                var a = !1, b = Xa(function() {
                    a || (a = !0, c(Ya()));
                    throw Error(q(355));
                }), c = ze(b)[1];
                0 === (N.mode & 2) && (N.flags |= 516, Ae(5, function() {
                    c(Ya());
                }, void 0, null));
                return b;
            }
            b = Ya();
            ze(b);
            return b;
        },
        unstable_isNewReconciler: !1
    }, ne = {
        readContext: J,
        useCallback: Le,
        useContext: J,
        useEffect: Ge,
        useImperativeHandle: Je,
        useLayoutEffect: He,
        useMemo: Me,
        useReducer: te,
        useRef: Ce,
        useState: function() {
            return te(se);
        },
        useDebugValue: Ke,
        useDeferredValue: function(a) {
            var b = te(se), c = b[0], d = b[1];
            Ge(function() {
                var b = ge.transition;
                ge.transition = 1;
                try {
                    d(a);
                } finally{
                    ge.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = te(se)[0];
            return [
                Ce().current,
                a
            ];
        },
        useMutableSource: ye,
        useOpaqueIdentifier: function() {
            return te(se)[0];
        },
        unstable_isNewReconciler: !1
    }, oe = {
        readContext: J,
        useCallback: Le,
        useContext: J,
        useEffect: Ge,
        useImperativeHandle: Je,
        useLayoutEffect: He,
        useMemo: Me,
        useReducer: ue,
        useRef: Ce,
        useState: function() {
            return ue(se);
        },
        useDebugValue: Ke,
        useDeferredValue: function(a) {
            var b = ue(se), c = b[0], d = b[1];
            Ge(function() {
                var b = ge.transition;
                ge.transition = 1;
                try {
                    d(a);
                } finally{
                    ge.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = ue(se)[0];
            return [
                Ce().current,
                a
            ];
        },
        useMutableSource: ye,
        useOpaqueIdentifier: function() {
            return ue(se)[0];
        },
        unstable_isNewReconciler: !1
    }, Oe = ca.ReactCurrentOwner, gd = !1;
    function S(a, b, c, d) {
        b.child = null === a ? Kd(b, null, c, d) : Jd(b, a.child, c, d);
    }
    function Pe(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        fd(b, e);
        d = le(a, b, c, d, f, e);
        if (null !== a && !gd) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, Re(a, b, e);
        b.flags |= 1;
        S(a, b, d, e);
        return b.child;
    }
    function Se(a, b, c, d, e, f) {
        if (null === a) {
            var g = c.type;
            if ("function" === typeof g && !Te(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, Ue(a, b, g, d, e, f);
            a = Gd(c.type, null, d, b, b.mode, f);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        g = a.child;
        if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Vc, c(e, d) && a.ref === b.ref)) return Re(a, b, f);
        b.flags |= 1;
        a = Ed(g, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function Ue(a, b, c, d, e, f) {
        if (null !== a && Vc(a.memoizedProps, d) && a.ref === b.ref) {
            if (gd = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (gd = !0);
            else return b.lanes = a.lanes, Re(a, b, f);
        }
        return Ve(a, b, c, d, f);
    }
    function We(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
            if (0 === (b.mode & 4)) b.memoizedState = {
                baseLanes: 0
            }, Xe(b, c);
            else if (0 !== (c & 1073741824)) b.memoizedState = {
                baseLanes: 0
            }, Xe(b, null !== f ? f.baseLanes : c);
            else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a
            }, Xe(b, a), null;
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, Xe(b, d);
        S(a, b, e, c);
        return b.child;
    }
    function Ye(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
    }
    function Ve(a, b, c, d, e) {
        var f = E(c) ? Yb : B.current;
        f = Zb(b, f);
        fd(b, e);
        c = le(a, b, c, d, f, e);
        if (null !== a && !gd) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, Re(a, b, e);
        b.flags |= 1;
        S(a, b, c, e);
        return b.child;
    }
    function Ze(a, b, c, d, e) {
        if (E(c)) {
            var f = !0;
            cc(b);
        } else f = !1;
        fd(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), xd(b, c, d), zd(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = J(l) : (l = E(c) ? Yb : B.current, l = Zb(b, l));
            var n = c.getDerivedStateFromProps, t = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
            t || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && yd(b, g, d, l);
            hd = !1;
            var p = b.memoizedState;
            g.state = p;
            od(b, d, g, e);
            k = b.memoizedState;
            h !== d || p !== k || D.current || hd ? ("function" === typeof n && (sd(b, c, n, d), k = b.memoizedState), (h = hd || wd(b, c, h, d, p, k, l)) ? (t || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
        } else {
            g = b.stateNode;
            jd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : Xc(b.type, h);
            g.props = l;
            t = b.pendingProps;
            p = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = J(k) : (k = E(c) ? Yb : B.current, k = Zb(b, k));
            var y = c.getDerivedStateFromProps;
            (n = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== t || p !== k) && yd(b, g, d, k);
            hd = !1;
            p = b.memoizedState;
            g.state = p;
            od(b, d, g, e);
            var x = b.memoizedState;
            h !== t || p !== x || D.current || hd ? ("function" === typeof y && (sd(b, c, y, d), x = b.memoizedState), (l = hd || wd(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
        }
        return $e(a, b, c, d, f, e);
    }
    function $e(a, b, c, d, e, f) {
        Ye(a, b);
        var g = 0 !== (b.flags & 64);
        if (!d && !g) return e && dc(b, c, !1), Re(a, b, f);
        d = b.stateNode;
        Oe.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = Jd(b, a.child, null, f), b.child = Jd(b, null, h, f)) : S(a, b, h, f);
        b.memoizedState = d.state;
        e && dc(b, c, !0);
        return b.child;
    }
    function af(a) {
        var b = a.stateNode;
        b.pendingContext ? ac(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ac(a, b.context, !1);
        Pd(a, b.containerInfo);
    }
    var bf = {
        dehydrated: null,
        retryLane: 0
    };
    function cf(a, b, c) {
        var d = b.pendingProps, e = M.current, f = !1, g;
        (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
        A(M, e & 1);
        if (null === a) {
            void 0 !== d.fallback && $d(b);
            a = d.children;
            e = d.fallback;
            if (f) return a = df(b, a, e, c), b.child.memoizedState = {
                baseLanes: c
            }, b.memoizedState = bf, a;
            if ("number" === typeof d.unstable_expectedLoadTime) return a = df(b, a, e, c), b.child.memoizedState = {
                baseLanes: c
            }, b.memoizedState = bf, b.lanes = 33554432, a;
            c = ef({
                mode: "visible",
                children: a
            }, b.mode, c, null);
            c.return = b;
            return b.child = c;
        }
        if (null !== a.memoizedState) {
            if (f) return d = ff(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
                baseLanes: c
            } : {
                baseLanes: e.baseLanes | c
            }, f.childLanes = a.childLanes & ~c, b.memoizedState = bf, d;
            c = gf(a, b, d.children, c);
            b.memoizedState = null;
            return c;
        }
        if (f) return d = ff(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = bf, d;
        c = gf(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    function df(a, b, c, d) {
        var e = a.mode, f = a.child;
        b = {
            mode: "hidden",
            children: b
        };
        0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = ef(b, e, 0, null);
        c = Id(c, e, d, null);
        f.return = a;
        c.return = a;
        f.sibling = c;
        a.child = f;
        return c;
    }
    function gf(a, b, c, d) {
        var e = a.child;
        a = e.sibling;
        c = Ed(e, {
            mode: "visible",
            children: c
        });
        0 === (b.mode & 2) && (c.lanes = d);
        c.return = b;
        c.sibling = null;
        null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
        return b.child = c;
    }
    function ff(a, b, c, d, e) {
        var f = b.mode, g = a.child;
        a = g.sibling;
        var h = {
            mode: "hidden",
            children: c
        };
        0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Ed(g, h);
        null !== a ? d = Ed(a, d) : (d = Id(d, f, e, null), d.flags |= 2);
        d.return = b;
        c.return = b;
        c.sibling = d;
        b.child = c;
        return d;
    }
    function hf(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        ed(a.return, b);
    }
    function jf(a, b, c, d, e, f) {
        var g = a.memoizedState;
        null === g ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e,
            lastEffect: f
        } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
    }
    function kf(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        S(a, b, d.children, c);
        d = M.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
        else {
            if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && hf(a, c);
                else if (19 === a.tag) hf(a, c);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        A(M, d);
        if (0 === (b.mode & 2)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === Td(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                jf(b, !1, e, c, f, b.lastEffect);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === Td(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                jf(b, !0, c, null, f, b.lastEffect);
                break;
            case "together":
                jf(b, !1, null, null, void 0, b.lastEffect);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function Re(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        pd |= b.lanes;
        if (0 !== (c & b.childLanes)) {
            if (null !== a && b.child !== a.child) throw Error(q(153));
            if (null !== b.child) {
                a = b.child;
                c = Ed(a, a.pendingProps);
                b.child = c;
                for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Ed(a, a.pendingProps), c.return = b;
                c.sibling = null;
            }
            return b.child;
        }
        return null;
    }
    function lf(a) {
        a.flags |= 4;
    }
    var mf, nf, of, pf;
    if (Ta) mf = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) Ja(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, nf = function() {}, of = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = Od(L.current);
            c = La(f, c, a, d, e, g);
            (b.updateQueue = c) && lf(b);
        }
    }, pf = function(a, b, c, d) {
        c !== d && lf(b);
    };
    else if (Ua) {
        mf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ja(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ja(a, f);
                else if (4 !== e.tag) {
                    if (13 === e.tag && 0 !== (e.flags & 4) && (f = null !== e.memoizedState)) {
                        var g = e.child;
                        if (null !== g && (null !== g.child && (g.child.return = g, mf(a, g, !0, f)), f = g.sibling, null !== f)) {
                            f.return = e;
                            e = f;
                            continue;
                        }
                    }
                    if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var qf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (13 === e.tag && 0 !== (e.flags & 4) && (f = null !== e.memoizedState)) {
                        var g = e.child;
                        if (null !== g && (null !== g.child && (g.child.return = g, qf(a, g, !0, f)), f = g.sibling, null !== f)) {
                            f.return = e;
                            e = f;
                            continue;
                        }
                    }
                    if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        nf = function(a) {
            var b = a.stateNode;
            if (null !== a.firstEffect) {
                var c = b.containerInfo, d = zb(c);
                qf(d, a, !1, !1);
                b.pendingChildren = d;
                lf(a);
                Bb(c, d);
            }
        };
        of = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = null === b.firstEffect) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = Od(L.current), l = null;
                g !== d && (l = La(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), Ka(f, c, d, e, k) && lf(b), b.stateNode = f, a ? lf(b) : mf(f, b, !1, !1));
            }
        };
        pf = function(a, b, c, d) {
            c !== d ? (a = Od(Nd.current), c = Od(L.current), b.stateNode = Na(d, a, c, b), lf(b)) : b.stateNode = a.stateNode;
        };
    } else nf = function() {}, of = function() {}, pf = function() {};
    function rf(a, b) {
        if (!Wd) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function sf(a, b, c) {
        var d = b.pendingProps;
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return null;
            case 1:
                return E(b.type) && $b(), null;
            case 3:
                Qd();
                z(D);
                z(B);
                ee();
                d = b.stateNode;
                d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                if (null === a || null === a.child) be(b) ? lf(b) : d.hydrate || (b.flags |= 256);
                nf(b);
                return null;
            case 5:
                Sd(b);
                var e = Od(Nd.current);
                c = b.type;
                if (null !== a && null != b.stateNode) of(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(q(166));
                        return null;
                    }
                    a = Od(L.current);
                    if (be(b)) {
                        if (!Va) throw Error(q(175));
                        a = Lb(b.stateNode, b.type, b.memoizedProps, e, a, b);
                        b.updateQueue = a;
                        null !== a && lf(b);
                    } else {
                        var f = Ia(c, d, e, a, b);
                        mf(f, b, !1, !1);
                        b.stateNode = f;
                        Ka(f, c, d, e, a) && lf(b);
                    }
                    null !== b.ref && (b.flags |= 128);
                }
                return null;
            case 6:
                if (a && null != b.stateNode) pf(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(q(166));
                    a = Od(Nd.current);
                    e = Od(L.current);
                    if (be(b)) {
                        if (!Va) throw Error(q(176));
                        Mb(b.stateNode, b.memoizedProps, b) && lf(b);
                    } else b.stateNode = Na(d, a, e, b);
                }
                return null;
            case 13:
                z(M);
                d = b.memoizedState;
                if (0 !== (b.flags & 64)) return b.lanes = c, b;
                d = null !== d;
                e = !1;
                null === a ? void 0 !== b.memoizedProps.fallback && be(b) : e = null !== a.memoizedState;
                if (d && !e && 0 !== (b.mode & 2)) {
                    if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) 0 === T && (T = 3);
                    else {
                        if (0 === T || 3 === T) T = 4;
                        null === R || 0 === (pd & 134217727) && 0 === (tf & 134217727) || uf(R, U);
                    }
                }
                Ua && d && (b.flags |= 4);
                Ta && (d || e) && (b.flags |= 4);
                return null;
            case 4:
                return Qd(), nf(b), null === a && ab(b.stateNode.containerInfo), null;
            case 10:
                return dd(b), null;
            case 17:
                return E(b.type) && $b(), null;
            case 19:
                z(M);
                d = b.memoizedState;
                if (null === d) return null;
                e = 0 !== (b.flags & 64);
                f = d.rendering;
                if (null === f) {
                    if (e) rf(d, !1);
                    else {
                        if (0 !== T || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                            f = Td(a);
                            if (null !== f) {
                                b.flags |= 64;
                                rf(d, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                null === d.lastEffect && (b.firstEffect = null);
                                b.lastEffect = d.lastEffect;
                                a = c;
                                for(d = b.child; null !== d;)e = d, c = a, e.flags &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, f = e.alternate, null === f ? (e.childLanes = 0, e.lanes = c, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = f.childLanes, e.lanes = f.lanes, e.child = f.child, e.memoizedProps = f.memoizedProps, e.memoizedState = f.memoizedState, e.updateQueue = f.updateQueue, e.type = f.type, c = f.dependencies, e.dependencies = null === c ? null : {
                                    lanes: c.lanes,
                                    firstContext: c.firstContext
                                }), d = d.sibling;
                                A(M, M.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== d.tail && G() > vf && (b.flags |= 64, e = !0, rf(d, !1), b.lanes = 33554432);
                    }
                } else {
                    if (!e) {
                        if (a = Td(f), null !== a) {
                            if (b.flags |= 64, e = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), rf(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate && !Wd) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                        } else 2 * G() - d.renderingStartTime > vf && 1073741824 !== c && (b.flags |= 64, e = !0, rf(d, !1), b.lanes = 33554432);
                    }
                    d.isBackwards ? (f.sibling = b.child, b.child = f) : (a = d.last, null !== a ? a.sibling = f : b.child = f, d.last = f);
                }
                return null !== d.tail ? (a = d.tail, d.rendering = a, d.tail = a.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = G(), a.sibling = null, b = M.current, A(M, e ? b & 1 | 2 : b & 1), a) : null;
            case 23:
            case 24:
                return wf(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
        }
        throw Error(q(156, b.tag));
    }
    function xf(a) {
        switch(a.tag){
            case 1:
                E(a.type) && $b();
                var b = a.flags;
                return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
            case 3:
                Qd();
                z(D);
                z(B);
                ee();
                b = a.flags;
                if (0 !== (b & 64)) throw Error(q(285));
                a.flags = b & -4097 | 64;
                return a;
            case 5:
                return Sd(a), null;
            case 13:
                return z(M), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
            case 19:
                return z(M), null;
            case 4:
                return Qd(), null;
            case 10:
                return dd(a), null;
            case 23:
            case 24:
                return wf(), null;
            default:
                return null;
        }
    }
    function yf(a, b) {
        try {
            var c = "", d = b;
            do c += Wc(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e
        };
    }
    function zf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var Af = "function" === typeof WeakMap ? WeakMap : Map;
    function Bf(a, b, c) {
        c = kd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Cf || (Cf = !0, Df = d);
            zf(a, b);
        };
        return c;
    }
    function Ef(a, b, c) {
        c = kd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                zf(a, b);
                return d(e);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            "function" !== typeof d && (null === Ff ? Ff = new Set([
                this
            ]) : Ff.add(this), zf(a, b));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    var Gf = "function" === typeof WeakSet ? WeakSet : Set;
    function Hf(a) {
        var b = a.ref;
        if (null !== b) {
            if ("function" === typeof b) try {
                b(null);
            } catch (c) {
                If(a, c);
            }
            else b.current = null;
        }
    }
    function Jf(a, b) {
        switch(b.tag){
            case 0:
            case 11:
            case 15:
            case 22:
                return;
            case 1:
                if (b.flags & 256 && null !== a) {
                    var c = a.memoizedProps, d = a.memoizedState;
                    a = b.stateNode;
                    b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : Xc(b.type, c), d);
                    a.__reactInternalSnapshotBeforeUpdate = b;
                }
                return;
            case 3:
                Ta && b.flags & 256 && xb(b.stateNode.containerInfo);
                return;
            case 5:
            case 6:
            case 4:
            case 17:
                return;
        }
        throw Error(q(163));
    }
    function Kf(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.destroy;
                    c.destroy = void 0;
                    void 0 !== d && d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Lf(a, b, c) {
        switch(c.tag){
            case 0:
            case 11:
            case 15:
            case 22:
                b = c.updateQueue;
                b = null !== b ? b.lastEffect : null;
                if (null !== b) {
                    a = b = b.next;
                    do {
                        if (3 === (a.tag & 3)) {
                            var d = a.create;
                            a.destroy = d();
                        }
                        a = a.next;
                    }while (a !== b);
                }
                b = c.updateQueue;
                b = null !== b ? b.lastEffect : null;
                if (null !== b) {
                    a = b = b.next;
                    do {
                        var e = a;
                        d = e.next;
                        e = e.tag;
                        0 !== (e & 4) && 0 !== (e & 1) && (Mf(c, a), Nf(c, a));
                        a = d;
                    }while (a !== b);
                }
                return;
            case 1:
                a = c.stateNode;
                c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : Xc(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
                b = c.updateQueue;
                null !== b && qd(c, b, a);
                return;
            case 3:
                b = c.updateQueue;
                if (null !== b) {
                    a = null;
                    if (null !== c.child) switch(c.child.tag){
                        case 5:
                            a = Da(c.child.stateNode);
                            break;
                        case 1:
                            a = c.child.stateNode;
                    }
                    qd(c, b, a);
                }
                return;
            case 5:
                a = c.stateNode;
                null === b && c.flags & 4 && mb(a, c.type, c.memoizedProps, c);
                return;
            case 6:
                return;
            case 4:
                return;
            case 12:
                return;
            case 13:
                Va && null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Pb(c))));
                return;
            case 19:
            case 17:
            case 20:
            case 21:
            case 23:
            case 24:
                return;
        }
        throw Error(q(163));
    }
    function Of(a, b) {
        if (Ta) for(var c = a;;){
            if (5 === c.tag) {
                var d = c.stateNode;
                b ? tb(d) : vb(c.stateNode, c.memoizedProps);
            } else if (6 === c.tag) d = c.stateNode, b ? ub(d) : wb(d, c.memoizedProps);
            else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === a) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === a) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }
    function Pf(a, b) {
        if (fc && "function" === typeof fc.onCommitFiberUnmount) try {
            fc.onCommitFiberUnmount(ec, b);
        } catch (f) {}
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var c = a = a.next;
                    do {
                        var d = c, e = d.destroy;
                        d = d.tag;
                        if (void 0 !== e) {
                            if (0 !== (d & 4)) Mf(b, c);
                            else {
                                d = b;
                                try {
                                    e();
                                } catch (f) {
                                    If(d, f);
                                }
                            }
                        }
                        c = c.next;
                    }while (c !== a);
                }
                break;
            case 1:
                Hf(b);
                a = b.stateNode;
                if ("function" === typeof a.componentWillUnmount) try {
                    a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
                } catch (f) {
                    If(b, f);
                }
                break;
            case 5:
                Hf(b);
                break;
            case 4:
                Ta ? Qf(a, b) : Ua && Ua && (b = b.stateNode.containerInfo, a = zb(b), Cb(b, a));
        }
    }
    function Rf(a, b) {
        for(var c = b;;)if (Pf(a, c), null === c.child || Ta && 4 === c.tag) {
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        } else c.child.return = c, c = c.child;
    }
    function Sf(a) {
        a.alternate = null;
        a.child = null;
        a.dependencies = null;
        a.firstEffect = null;
        a.lastEffect = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.return = null;
        a.updateQueue = null;
    }
    function Tf(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Uf(a) {
        if (Ta) {
            a: {
                for(var b = a.return; null !== b;){
                    if (Tf(b)) break a;
                    b = b.return;
                }
                throw Error(q(160));
            }
            var c = b;
            b = c.stateNode;
            switch(c.tag){
                case 5:
                    var d = !1;
                    break;
                case 3:
                    b = b.containerInfo;
                    d = !0;
                    break;
                case 4:
                    b = b.containerInfo;
                    d = !0;
                    break;
                default:
                    throw Error(q(161));
            }
            c.flags & 16 && (sb(b), c.flags &= -17);
            a: b: for(c = a;;){
                for(; null === c.sibling;){
                    if (null === c.return || Tf(c.return)) {
                        c = null;
                        break a;
                    }
                    c = c.return;
                }
                c.sibling.return = c.return;
                for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
                    if (c.flags & 2) continue b;
                    if (null === c.child || 4 === c.tag) continue b;
                    else c.child.return = c, c = c.child;
                }
                if (!(c.flags & 2)) {
                    c = c.stateNode;
                    break a;
                }
            }
            d ? Vf(a, c, b) : Wf(a, c, b);
        }
    }
    function Vf(a, b, c) {
        var d = a.tag, e = 5 === d || 6 === d;
        if (e) a = e ? a.stateNode : a.stateNode.instance, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Vf(a, b, c), a = a.sibling; null !== a;)Vf(a, b, c), a = a.sibling;
    }
    function Wf(a, b, c) {
        var d = a.tag, e = 5 === d || 6 === d;
        if (e) a = e ? a.stateNode : a.stateNode.instance, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Wf(a, b, c), a = a.sibling; null !== a;)Wf(a, b, c), a = a.sibling;
    }
    function Qf(a, b) {
        for(var c = b, d = !1, e, f;;){
            if (!d) {
                d = c.return;
                a: for(;;){
                    if (null === d) throw Error(q(160));
                    e = d.stateNode;
                    switch(d.tag){
                        case 5:
                            f = !1;
                            break a;
                        case 3:
                            e = e.containerInfo;
                            f = !0;
                            break a;
                        case 4:
                            e = e.containerInfo;
                            f = !0;
                            break a;
                    }
                    d = d.return;
                }
                d = !0;
            }
            if (5 === c.tag || 6 === c.tag) Rf(a, c), f ? rb(e, c.stateNode) : qb(e, c.stateNode);
            else if (4 === c.tag) {
                if (null !== c.child) {
                    e = c.stateNode.containerInfo;
                    f = !0;
                    c.child.return = c;
                    c = c.child;
                    continue;
                }
            } else if (Pf(a, c), null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
                4 === c.tag && (d = !1);
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }
    function Xf(a, b) {
        if (Ta) {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                case 22:
                    Kf(3, b);
                    return;
                case 1:
                    return;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && nb(c, f, e, a, d, b);
                    }
                    return;
                case 6:
                    if (null === b.stateNode) throw Error(q(162));
                    c = b.memoizedProps;
                    lb(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    return;
                case 3:
                    Va && (b = b.stateNode, b.hydrate && (b.hydrate = !1, Ob(b.containerInfo)));
                    return;
                case 12:
                    return;
                case 13:
                    Yf(b);
                    Zf(b);
                    return;
                case 19:
                    Zf(b);
                    return;
                case 17:
                    return;
                case 23:
                case 24:
                    Of(b, null !== b.memoizedState);
                    return;
            }
            throw Error(q(163));
        }
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
                Kf(3, b);
                return;
            case 12:
                return;
            case 13:
                Yf(b);
                Zf(b);
                return;
            case 19:
                Zf(b);
                return;
            case 3:
                Va && (c = b.stateNode, c.hydrate && (c.hydrate = !1, Ob(c.containerInfo)));
                break;
            case 23:
            case 24:
                return;
        }
        a: if (Ua) {
            switch(b.tag){
                case 1:
                case 5:
                case 6:
                case 20:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    Cb(b.containerInfo, b.pendingChildren);
                    break a;
            }
            throw Error(q(163));
        }
    }
    function Yf(a) {
        null !== a.memoizedState && ($f = G(), Ta && Of(a.child, !0));
    }
    function Zf(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Gf);
            b.forEach(function(b) {
                var d = ag.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function bg(a, b) {
        return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
    }
    var cg = 0, dg = 1, eg = 2, fg = 3, gg = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var hg = Symbol.for;
        cg = hg("selector.component");
        dg = hg("selector.has_pseudo_class");
        eg = hg("selector.role");
        fg = hg("selector.test_id");
        gg = hg("selector.text");
    }
    function ig(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(q(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(q(362));
        return a.stateNode.current;
    }
    function jg(a, b) {
        switch(b.$$typeof){
            case cg:
                if (a.type === b.value) return !0;
                break;
            case dg:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && jg(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case eg:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case gg:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case fg:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(q(365, b));
        }
        return !1;
    }
    function kg(a) {
        switch(a.$$typeof){
            case cg:
                return "<" + (wa(a.value) || "Unknown") + ">";
            case dg:
                return ":has(" + (kg(a) || "") + ")";
            case eg:
                return '[role="' + a.value + '"]';
            case gg:
                return '"' + a.value + '"';
            case fg:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(q(365, a));
        }
    }
    function lg(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && jg(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function mg(a, b) {
        if (!bb) throw Error(q(363));
        a = ig(a);
        a = lg(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var ng = null;
    function og(a) {
        if (null === ng) try {
            var b = ("require" + Math.random()).slice(0, 7);
            ng = (module && module[b]).call(module, "timers").setImmediate;
        } catch (c) {
            ng = function(a) {
                var b = new MessageChannel;
                b.port1.onmessage = a;
                b.port2.postMessage(void 0);
            };
        }
        return ng(a);
    }
    var pg = Math.ceil, qg = ca.ReactCurrentDispatcher, rg = ca.ReactCurrentOwner, sg = ca.IsSomeRendererActing, V = 0, R = null, W = null, U = 0, tg = 0, ug = Wb(0), T = 0, vg = null, wg = 0, pd = 0, tf = 0, xg = 0, yg = null, $f = 0, vf = Infinity;
    function zg() {
        vf = G() + 500;
    }
    var X = null, Cf = !1, Df = null, Ff = null, Ag = !1, Bg = null, Cg = 90, Dg = [], Eg = [], Fg = null, Gg = 0, Hg = null, Ig = -1, Jg = 0, Kg = 0, Lg = null, Mg = !1;
    function K() {
        return 0 !== (V & 48) ? G() : -1 !== Ig ? Ig : Ig = G();
    }
    function td(a) {
        a = a.mode;
        if (0 === (a & 2)) return 1;
        if (0 === (a & 4)) return 99 === Nc() ? 1 : 2;
        0 === Jg && (Jg = wg);
        if (0 !== Sc.transition) {
            0 !== Kg && (Kg = null !== yg ? yg.pendingLanes : 0);
            a = Jg;
            var b = 4186112 & ~Kg;
            b &= -b;
            0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
            return b;
        }
        a = Nc();
        0 !== (V & 4) && 98 === a ? a = oc(12, Jg) : (a = jc(a), a = oc(a, Jg));
        return a;
    }
    function ud(a, b, c) {
        if (50 < Gg) throw Gg = 0, Hg = null, Error(q(185));
        a = Ng(a, b);
        if (null === a) return null;
        rc(a, b, c);
        a === R && (tf |= b, 4 === T && uf(a, U));
        var d = Nc();
        1 === b ? 0 !== (V & 8) && 0 === (V & 48) ? Og(a) : (Z(a, c), 0 === V && (zg(), H())) : (0 === (V & 4) || 98 !== d && 99 !== d || (null === Fg ? Fg = new Set([
            a
        ]) : Fg.add(a)), Z(a, c));
        yg = a;
    }
    function Ng(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    function Z(a, b) {
        for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
            var h = 31 - mc(g), k = 1 << h, l = f[h];
            if (-1 === l) {
                if (0 === (k & d) || 0 !== (k & e)) {
                    l = b;
                    ic(k);
                    var n = F;
                    f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
                }
            } else l <= b && (a.expiredLanes |= k);
            g &= ~k;
        }
        d = lc(a, a === R ? U : 0);
        b = F;
        if (0 === d) null !== c && (c !== Hc && xc(c), a.callbackNode = null, a.callbackPriority = 0);
        else {
            if (null !== c) {
                if (a.callbackPriority === b) return;
                c !== Hc && xc(c);
            }
            15 === b ? (c = Og.bind(null, a), null === Jc ? (Jc = [
                c
            ], Kc = wc(Cc, Rc)) : Jc.push(c), c = Hc) : 14 === b ? c = Qc(99, Og.bind(null, a)) : (c = kc(b), c = Qc(c, Pg.bind(null, a)));
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Pg(a) {
        Ig = -1;
        Kg = Jg = 0;
        if (0 !== (V & 48)) throw Error(q(327));
        var b = a.callbackNode;
        if (Qg() && a.callbackNode !== b) return null;
        var c = lc(a, a === R ? U : 0);
        if (0 === c) return null;
        var d = c;
        var e = V;
        V |= 16;
        var f = Rg();
        if (R !== a || U !== d) zg(), Sg(a, d);
        for(;;)try {
            Tg();
            break;
        } catch (h) {
            Ug(a, h);
        }
        bd();
        qg.current = f;
        V = e;
        null !== W ? d = 0 : (R = null, U = 0, d = T);
        if (0 !== (wg & tf)) Sg(a, 0);
        else if (0 !== d) {
            2 === d && (V |= 64, a.hydrate && (a.hydrate = !1, xb(a.containerInfo)), c = nc(a), 0 !== c && (d = Vg(a, c)));
            if (1 === d) throw b = vg, Sg(a, 0), uf(a, c), Z(a, G()), b;
            a.finishedWork = a.current.alternate;
            a.finishedLanes = c;
            switch(d){
                case 0:
                case 1:
                    throw Error(q(345));
                case 2:
                    Zg(a);
                    break;
                case 3:
                    uf(a, c);
                    if ((c & 62914560) === c && (d = $f + 500 - G(), 10 < d)) {
                        if (0 !== lc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & c) !== c) {
                            K();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Pa(Zg.bind(null, a), d);
                        break;
                    }
                    Zg(a);
                    break;
                case 4:
                    uf(a, c);
                    if ((c & 4186112) === c) break;
                    d = a.eventTimes;
                    for(e = -1; 0 < c;){
                        var g = 31 - mc(c);
                        f = 1 << g;
                        g = d[g];
                        g > e && (e = g);
                        c &= ~f;
                    }
                    c = e;
                    c = G() - c;
                    c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * pg(c / 1960)) - c;
                    if (10 < c) {
                        a.timeoutHandle = Pa(Zg.bind(null, a), c);
                        break;
                    }
                    Zg(a);
                    break;
                case 5:
                    Zg(a);
                    break;
                default:
                    throw Error(q(329));
            }
        }
        Z(a, G());
        return a.callbackNode === b ? Pg.bind(null, a) : null;
    }
    function uf(a, b) {
        b &= ~xg;
        b &= ~tf;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - mc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Og(a) {
        if (0 !== (V & 48)) throw Error(q(327));
        Qg();
        if (a === R && 0 !== (a.expiredLanes & U)) {
            var b = U;
            var c = Vg(a, b);
            0 !== (wg & tf) && (b = lc(a, b), c = Vg(a, b));
        } else b = lc(a, 0), c = Vg(a, b);
        0 !== a.tag && 2 === c && (V |= 64, a.hydrate && (a.hydrate = !1, xb(a.containerInfo)), b = nc(a), 0 !== b && (c = Vg(a, b)));
        if (1 === c) throw c = vg, Sg(a, 0), uf(a, b), Z(a, G()), c;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Zg(a);
        Z(a, G());
        return null;
    }
    function $g() {
        if (null !== Fg) {
            var a = Fg;
            Fg = null;
            a.forEach(function(a) {
                a.expiredLanes |= 24 & a.pendingLanes;
                Z(a, G());
            });
        }
        H();
    }
    function ah(a, b) {
        var c = V;
        V |= 1;
        try {
            return a(b);
        } finally{
            V = c, 0 === V && (zg(), H());
        }
    }
    function bh(a, b) {
        var c = V;
        if (0 !== (c & 48)) return a(b);
        V |= 1;
        try {
            if (a) return Pc(99, a.bind(null, b));
        } finally{
            V = c, H();
        }
    }
    function Xe(a, b) {
        A(ug, tg);
        tg |= b;
        wg |= b;
    }
    function wf() {
        tg = ug.current;
        z(ug);
    }
    function Sg(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Ra && (a.timeoutHandle = Ra, Qa(c));
        if (null !== W) for(c = W.return; null !== c;){
            var d = c;
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && $b();
                    break;
                case 3:
                    Qd();
                    z(D);
                    z(B);
                    ee();
                    break;
                case 5:
                    Sd(d);
                    break;
                case 4:
                    Qd();
                    break;
                case 13:
                    z(M);
                    break;
                case 19:
                    z(M);
                    break;
                case 10:
                    dd(d);
                    break;
                case 23:
                case 24:
                    wf();
            }
            c = c.return;
        }
        R = a;
        W = Ed(a.current, null);
        U = tg = wg = b;
        T = 0;
        vg = null;
        xg = tf = pd = 0;
    }
    function Ug(a, b) {
        do {
            var c = W;
            try {
                bd();
                fe.current = pe;
                if (ie) {
                    for(var d = N.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    ie = !1;
                }
                he = 0;
                P = O = N = null;
                je = !1;
                rg.current = null;
                if (null === c || null === c.return) {
                    T = 1;
                    vg = b;
                    W = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = U;
                    h.flags |= 2048;
                    h.firstEffect = h.lastEffect = null;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k;
                        if (0 === (h.mode & 2)) {
                            var n = h.alternate;
                            n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                        }
                        var t = 0 !== (M.current & 1), p = g;
                        do {
                            var y;
                            if (y = 13 === p.tag) {
                                var x = p.memoizedState;
                                if (null !== x) y = null !== x.dehydrated ? !0 : !1;
                                else {
                                    var Y = p.memoizedProps;
                                    y = void 0 === Y.fallback ? !1 : !0 !== Y.unstable_avoidThisFallback ? !0 : t ? !1 : !0;
                                }
                            }
                            if (y) {
                                var u = p.updateQueue;
                                if (null === u) {
                                    var v = new Set;
                                    v.add(l);
                                    p.updateQueue = v;
                                } else u.add(l);
                                if (0 === (p.mode & 2)) {
                                    p.flags |= 64;
                                    h.flags |= 16384;
                                    h.flags &= -2981;
                                    if (1 === h.tag) {
                                        if (null === h.alternate) h.tag = 17;
                                        else {
                                            var C = kd(-1, 1);
                                            C.tag = 2;
                                            md(h, C);
                                        }
                                    }
                                    h.lanes |= 1;
                                    break a;
                                }
                                k = void 0;
                                h = b;
                                var Oa = f.pingCache;
                                null === Oa ? (Oa = f.pingCache = new Af, k = new Set, Oa.set(l, k)) : (k = Oa.get(l), void 0 === k && (k = new Set, Oa.set(l, k)));
                                if (!k.has(h)) {
                                    k.add(h);
                                    var Qe = ch.bind(null, f, l, h);
                                    l.then(Qe, Qe);
                                }
                                p.flags |= 4096;
                                p.lanes = b;
                                break a;
                            }
                            p = p.return;
                        }while (null !== p);
                        k = Error((wa(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                    }
                    5 !== T && (T = 2);
                    k = yf(k, h);
                    p = g;
                    do {
                        switch(p.tag){
                            case 3:
                                f = k;
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var Wg = Bf(p, f, b);
                                nd(p, Wg);
                                break a;
                            case 1:
                                f = k;
                                var Xg = p.type, ld = p.stateNode;
                                if (0 === (p.flags & 64) && ("function" === typeof Xg.getDerivedStateFromError || null !== ld && "function" === typeof ld.componentDidCatch && (null === Ff || !Ff.has(ld)))) {
                                    p.flags |= 4096;
                                    b &= -b;
                                    p.lanes |= b;
                                    var Yg = Ef(p, f, b);
                                    nd(p, Yg);
                                    break a;
                                }
                        }
                        p = p.return;
                    }while (null !== p);
                }
                dh(c);
            } catch (w) {
                b = w;
                W === c && null !== c && (W = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Rg() {
        var a = qg.current;
        qg.current = pe;
        return null === a ? pe : a;
    }
    function Vg(a, b) {
        var c = V;
        V |= 16;
        var d = Rg();
        R === a && U === b || Sg(a, b);
        for(;;)try {
            eh();
            break;
        } catch (e) {
            Ug(a, e);
        }
        bd();
        V = c;
        qg.current = d;
        if (null !== W) throw Error(q(261));
        R = null;
        U = 0;
        return T;
    }
    function eh() {
        for(; null !== W;)fh(W);
    }
    function Tg() {
        for(; null !== W && !yc();)fh(W);
    }
    function fh(a) {
        var b = gh(a.alternate, a, tg);
        a.memoizedProps = a.pendingProps;
        null === b ? dh(a) : W = b;
        rg.current = null;
    }
    function dh(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 2048)) {
                c = sf(c, b, tg);
                if (null !== c) {
                    W = c;
                    return;
                }
                c = b;
                if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (tg & 1073741824) || 0 === (c.mode & 4)) {
                    for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                    c.childLanes = d;
                }
                null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
            } else {
                c = xf(b);
                if (null !== c) {
                    c.flags &= 2047;
                    W = c;
                    return;
                }
                null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
            }
            b = b.sibling;
            if (null !== b) {
                W = b;
                return;
            }
            W = b = a;
        }while (null !== b);
        0 === T && (T = 5);
    }
    function Zg(a) {
        var b = Nc();
        Pc(99, hh.bind(null, a, b));
        return null;
    }
    function hh(a, b) {
        do Qg();
        while (null !== Bg);
        if (0 !== (V & 48)) throw Error(q(327));
        var c = a.finishedWork;
        if (null === c) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (c === a.current) throw Error(q(177));
        a.callbackNode = null;
        var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
        a.pendingLanes = e;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= e;
        a.mutableReadLanes &= e;
        a.entangledLanes &= e;
        e = a.entanglements;
        for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
            var k = 31 - mc(f), l = 1 << k;
            e[k] = 0;
            g[k] = -1;
            h[k] = -1;
            f &= ~l;
        }
        null !== Fg && 0 === (d & 24) && Fg.has(a) && Fg.delete(a);
        a === R && (W = R = null, U = 0);
        1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
        if (null !== d) {
            e = V;
            V |= 32;
            rg.current = null;
            Lg = Ga(a.containerInfo);
            Mg = !1;
            X = d;
            do try {
                ih();
            } catch (v) {
                if (null === X) throw Error(q(330));
                If(X, v);
                X = X.nextEffect;
            }
            while (null !== X);
            Lg = null;
            X = d;
            do try {
                for(g = a; null !== X;){
                    var n = X.flags;
                    n & 16 && Ta && sb(X.stateNode);
                    if (n & 128) {
                        var t = X.alternate;
                        if (null !== t) {
                            var p = t.ref;
                            null !== p && ("function" === typeof p ? p(null) : p.current = null);
                        }
                    }
                    switch(n & 1038){
                        case 2:
                            Uf(X);
                            X.flags &= -3;
                            break;
                        case 6:
                            Uf(X);
                            X.flags &= -3;
                            Xf(X.alternate, X);
                            break;
                        case 1024:
                            X.flags &= -1025;
                            break;
                        case 1028:
                            X.flags &= -1025;
                            Xf(X.alternate, X);
                            break;
                        case 4:
                            Xf(X.alternate, X);
                            break;
                        case 8:
                            h = g;
                            f = X;
                            Ta ? Qf(h, f) : Rf(h, f);
                            var y = f.alternate;
                            Sf(f);
                            null !== y && Sf(y);
                    }
                    X = X.nextEffect;
                }
            } catch (v) {
                if (null === X) throw Error(q(330));
                If(X, v);
                X = X.nextEffect;
            }
            while (null !== X);
            Mg && $a();
            Ha(a.containerInfo);
            a.current = c;
            X = d;
            do try {
                for(n = a; null !== X;){
                    var x = X.flags;
                    x & 36 && Lf(n, X.alternate, X);
                    if (x & 128) {
                        t = void 0;
                        var Y = X.ref;
                        if (null !== Y) {
                            var u = X.stateNode;
                            switch(X.tag){
                                case 5:
                                    t = Da(u);
                                    break;
                                default:
                                    t = u;
                            }
                            "function" === typeof Y ? Y(t) : Y.current = t;
                        }
                    }
                    X = X.nextEffect;
                }
            } catch (v) {
                if (null === X) throw Error(q(330));
                If(X, v);
                X = X.nextEffect;
            }
            while (null !== X);
            X = null;
            Ic();
            V = e;
        } else a.current = c;
        if (Ag) Ag = !1, Bg = a, Cg = b;
        else for(X = d; null !== X;)b = X.nextEffect, X.nextEffect = null, X.flags & 8 && (x = X, x.sibling = null, x.stateNode = null), X = b;
        d = a.pendingLanes;
        0 === d && (Ff = null);
        1 === d ? a === Hg ? Gg++ : (Gg = 0, Hg = a) : Gg = 0;
        c = c.stateNode;
        if (fc && "function" === typeof fc.onCommitFiberRoot) try {
            fc.onCommitFiberRoot(ec, c, void 0, 64 === (c.current.flags & 64));
        } catch (v) {}
        Z(a, G());
        if (Cf) throw Cf = !1, a = Df, Df = null, a;
        if (0 !== (V & 8)) return null;
        H();
        return null;
    }
    function ih() {
        for(; null !== X;){
            var a = X.alternate;
            Mg || null === Lg || (0 !== (X.flags & 8) ? Ca(X, Lg) && (Mg = !0, Za()) : 13 === X.tag && bg(a, X) && Ca(X, Lg) && (Mg = !0, Za()));
            var b = X.flags;
            0 !== (b & 256) && Jf(a, X);
            0 === (b & 512) || Ag || (Ag = !0, Qc(97, function() {
                Qg();
                return null;
            }));
            X = X.nextEffect;
        }
    }
    function Qg() {
        if (90 !== Cg) {
            var a = 97 < Cg ? 97 : Cg;
            Cg = 90;
            return Pc(a, jh);
        }
        return !1;
    }
    function Nf(a, b) {
        Dg.push(b, a);
        Ag || (Ag = !0, Qc(97, function() {
            Qg();
            return null;
        }));
    }
    function Mf(a, b) {
        Eg.push(b, a);
        Ag || (Ag = !0, Qc(97, function() {
            Qg();
            return null;
        }));
    }
    function jh() {
        if (null === Bg) return !1;
        var a = Bg;
        Bg = null;
        if (0 !== (V & 48)) throw Error(q(331));
        var b = V;
        V |= 32;
        var c = Eg;
        Eg = [];
        for(var d = 0; d < c.length; d += 2){
            var e = c[d], f = c[d + 1], g = e.destroy;
            e.destroy = void 0;
            if ("function" === typeof g) try {
                g();
            } catch (k) {
                if (null === f) throw Error(q(330));
                If(f, k);
            }
        }
        c = Dg;
        Dg = [];
        for(d = 0; d < c.length; d += 2){
            e = c[d];
            f = c[d + 1];
            try {
                var h = e.create;
                e.destroy = h();
            } catch (k) {
                if (null === f) throw Error(q(330));
                If(f, k);
            }
        }
        for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
        V = b;
        H();
        return !0;
    }
    function kh(a, b, c) {
        b = yf(c, b);
        b = Bf(a, b, 1);
        md(a, b);
        b = K();
        a = Ng(a, 1);
        null !== a && (rc(a, 1, b), Z(a, b));
    }
    function If(a, b) {
        if (3 === a.tag) kh(a, a, b);
        else for(var c = a.return; null !== c;){
            if (3 === c.tag) {
                kh(c, a, b);
                break;
            } else if (1 === c.tag) {
                var d = c.stateNode;
                if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ff || !Ff.has(d))) {
                    a = yf(b, a);
                    var e = Ef(c, a, 1);
                    md(c, e);
                    e = K();
                    c = Ng(c, 1);
                    if (null !== c) rc(c, 1, e), Z(c, e);
                    else if ("function" === typeof d.componentDidCatch && (null === Ff || !Ff.has(d))) try {
                        d.componentDidCatch(b, a);
                    } catch (f) {}
                    break;
                }
            }
            c = c.return;
        }
    }
    function ch(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = K();
        a.pingedLanes |= a.suspendedLanes & c;
        R === a && (U & c) === c && (4 === T || 3 === T && (U & 62914560) === U && 500 > G() - $f ? Sg(a, 0) : xg |= c);
        Z(a, b);
    }
    function ag(a, b) {
        var c = a.stateNode;
        null !== c && c.delete(b);
        b = 0;
        0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === Nc() ? 1 : 2 : (0 === Jg && (Jg = wg), b = pc(62914560 & ~Jg), 0 === b && (b = 4194304)));
        c = K();
        a = Ng(a, b);
        null !== a && (rc(a, b, c), Z(a, c));
    }
    var gh;
    gh = function(a, b, c) {
        var d = b.lanes;
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || D.current) gd = !0;
            else if (0 !== (c & d)) gd = 0 !== (a.flags & 16384) ? !0 : !1;
            else {
                gd = !1;
                switch(b.tag){
                    case 3:
                        af(b);
                        ce();
                        break;
                    case 5:
                        Rd(b);
                        break;
                    case 1:
                        E(b.type) && cc(b);
                        break;
                    case 4:
                        Pd(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        cd(b, b.memoizedProps.value);
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            if (0 !== (c & b.child.childLanes)) return cf(a, b, c);
                            A(M, M.current & 1);
                            b = Re(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        A(M, M.current & 1);
                        break;
                    case 19:
                        d = 0 !== (c & b.childLanes);
                        if (0 !== (a.flags & 64)) {
                            if (d) return kf(a, b, c);
                            b.flags |= 64;
                        }
                        var e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                        A(M, M.current);
                        if (d) break;
                        else return null;
                    case 23:
                    case 24:
                        return b.lanes = 0, We(a, b, c);
                }
                return Re(a, b, c);
            }
        } else gd = !1;
        b.lanes = 0;
        switch(b.tag){
            case 2:
                d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                e = Zb(b, B.current);
                fd(b, c);
                e = le(null, b, d, a, e, c);
                b.flags |= 1;
                if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                    b.tag = 1;
                    b.memoizedState = null;
                    b.updateQueue = null;
                    if (E(d)) {
                        var f = !0;
                        cc(b);
                    } else f = !1;
                    b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                    id(b);
                    var g = d.getDerivedStateFromProps;
                    "function" === typeof g && sd(b, d, g, a);
                    e.updater = vd;
                    b.stateNode = e;
                    e._reactInternals = b;
                    zd(b, d, a, c);
                    b = $e(null, b, d, !0, f, c);
                } else b.tag = 0, S(null, b, e, c), b = b.child;
                return b;
            case 16:
                e = b.elementType;
                a: {
                    null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                    a = b.pendingProps;
                    f = e._init;
                    e = f(e._payload);
                    b.type = e;
                    f = b.tag = lh(e);
                    a = Xc(e, a);
                    switch(f){
                        case 0:
                            b = Ve(null, b, e, a, c);
                            break a;
                        case 1:
                            b = Ze(null, b, e, a, c);
                            break a;
                        case 11:
                            b = Pe(null, b, e, a, c);
                            break a;
                        case 14:
                            b = Se(null, b, e, Xc(e.type, a), d, c);
                            break a;
                    }
                    throw Error(q(306, e, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), Ve(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), Ze(a, b, d, e, c);
            case 3:
                af(b);
                d = b.updateQueue;
                if (null === a || null === d) throw Error(q(282));
                d = b.pendingProps;
                e = b.memoizedState;
                e = null !== e ? e.element : null;
                jd(a, b);
                od(b, d, null, c);
                d = b.memoizedState.element;
                if (d === e) ce(), b = Re(a, b, c);
                else {
                    e = b.stateNode;
                    if (f = e.hydrate) Va ? (Vd = Kb(b.stateNode.containerInfo), Ud = b, f = Wd = !0) : f = !1;
                    if (f) {
                        if (Va && (a = e.mutableSourceEagerHydrationData, null != a)) for(e = 0; e < a.length; e += 2)f = a[e], g = a[e + 1], Sa ? f._workInProgressVersionPrimary = g : f._workInProgressVersionSecondary = g, de.push(f);
                        c = Kd(b, null, d, c);
                        for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                    } else S(a, b, d, c), ce();
                    b = b.child;
                }
                return b;
            case 5:
                return Rd(b), null === a && $d(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ma(d, e) ? g = null : null !== f && Ma(d, f) && (b.flags |= 16), Ye(a, b), S(a, b, g, c), b.child;
            case 6:
                return null === a && $d(b), null;
            case 13:
                return cf(a, b, c);
            case 4:
                return Pd(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Jd(b, null, d, c) : S(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), Pe(a, b, d, e, c);
            case 7:
                return S(a, b, b.pendingProps, c), b.child;
            case 8:
                return S(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return S(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    g = b.memoizedProps;
                    f = e.value;
                    cd(b, f);
                    if (null !== g) {
                        var h = g.value;
                        f = I(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;
                        if (0 === f) {
                            if (g.children === e.children && !D.current) {
                                b = Re(a, b, c);
                                break a;
                            }
                        } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                            var k = h.dependencies;
                            if (null !== k) {
                                g = h.child;
                                for(var l = k.firstContext; null !== l;){
                                    if (l.context === d && 0 !== (l.observedBits & f)) {
                                        1 === h.tag && (l = kd(-1, c & -c), l.tag = 2, md(h, l));
                                        h.lanes |= c;
                                        l = h.alternate;
                                        null !== l && (l.lanes |= c);
                                        ed(h.return, c);
                                        k.lanes |= c;
                                        break;
                                    }
                                    l = l.next;
                                }
                            } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                            if (null !== g) g.return = h;
                            else for(g = h; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                h = g.sibling;
                                if (null !== h) {
                                    h.return = g.return;
                                    g = h;
                                    break;
                                }
                                g = g.return;
                            }
                            h = g;
                        }
                    }
                    S(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, f = b.pendingProps, d = f.children, fd(b, c), e = J(e, f.unstable_observedBits), d = d(e), b.flags |= 1, S(a, b, d, c), b.child;
            case 14:
                return e = b.type, f = Xc(e, b.pendingProps), f = Xc(e.type, f), Se(a, b, e, f, d, c);
            case 15:
                return Ue(a, b, b.type, b.pendingProps, d, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, E(d) ? (a = !0, cc(b)) : a = !1, fd(b, c), xd(b, d, e), zd(b, d, e, c), $e(null, b, d, !0, a, c);
            case 19:
                return kf(a, b, c);
            case 23:
                return We(a, b, c);
            case 24:
                return We(a, b, c);
        }
        throw Error(q(156, b.tag));
    };
    var mh = {
        current: !1
    }, nh = m.unstable_flushAllWithoutAsserting, oh = "function" === typeof nh;
    function ph() {
        if (void 0 !== nh) return nh();
        for(var a = !1; Qg();)a = !0;
        return a;
    }
    function qh(a) {
        try {
            ph(), og(function() {
                ph() ? qh(a) : a();
            });
        } catch (b) {
            a(b);
        }
    }
    var rh = 0, sh = !1;
    function th(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.flags = 0;
        this.lastEffect = this.firstEffect = this.nextEffect = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function Yd(a, b, c, d) {
        return new th(a, b, c, d);
    }
    function Te(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function lh(a) {
        if ("function" === typeof a) return Te(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === la) return 11;
            if (a === oa) return 14;
        }
        return 2;
    }
    function Ed(a, b) {
        var c = a.alternate;
        null === c ? (c = Yd(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function Gd(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) Te(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case fa:
                return Id(c.children, e, f, b);
            case ra:
                g = 8;
                e |= 16;
                break;
            case ha:
                g = 8;
                e |= 1;
                break;
            case ia:
                return a = Yd(12, c, b, e | 8), a.elementType = ia, a.type = ia, a.lanes = f, a;
            case ma:
                return a = Yd(13, c, b, e), a.type = ma, a.elementType = ma, a.lanes = f, a;
            case na:
                return a = Yd(19, c, b, e), a.elementType = na, a.lanes = f, a;
            case sa:
                return ef(c, e, f, b);
            case ta:
                return a = Yd(24, c, b, e), a.elementType = ta, a.lanes = f, a;
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case ja:
                        g = 10;
                        break a;
                    case ka:
                        g = 9;
                        break a;
                    case la:
                        g = 11;
                        break a;
                    case oa:
                        g = 14;
                        break a;
                    case pa:
                        g = 16;
                        d = null;
                        break a;
                    case qa:
                        g = 22;
                        break a;
                }
                throw Error(q(130, null == a ? a : typeof a, ""));
        }
        b = Yd(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function Id(a, b, c, d) {
        a = Yd(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function ef(a, b, c, d) {
        a = Yd(23, a, d, b);
        a.elementType = sa;
        a.lanes = c;
        return a;
    }
    function Fd(a, b, c) {
        a = Yd(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function Hd(a, b, c) {
        b = Yd(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function uh(a, b, c) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Ra;
        this.pendingContext = this.context = null;
        this.hydrate = c;
        this.callbackNode = null;
        this.callbackPriority = 0;
        this.eventTimes = qc(0);
        this.expirationTimes = qc(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = qc(0);
        Va && (this.mutableSourceEagerHydrationData = null);
    }
    function vh(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(q(188));
            throw Error(q(268, Object.keys(a)));
        }
        a = Aa(b);
        return null === a ? null : a.stateNode;
    }
    function wh(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function xh(a, b) {
        wh(a, b);
        (a = a.alternate) && wh(a, b);
    }
    function yh(a) {
        a = Aa(a);
        return null === a ? null : a.stateNode;
    }
    function zh() {
        return null;
    }
    exports.IsThisRendererActing = mh;
    exports.act = function(a) {
        function b() {
            rh--;
            sg.current = c;
            mh.current = d;
        }
        !1 === sh && (sh = !0, console.error("act(...) is not supported in production builds of React, and might not behave as expected."));
        rh++;
        var c = sg.current, d = mh.current;
        sg.current = !0;
        mh.current = !0;
        try {
            var e = ah(a);
        } catch (f) {
            throw b(), f;
        }
        if (null !== e && "object" === typeof e && "function" === typeof e.then) return {
            then: function(a, d) {
                e.then(function() {
                    1 < rh || !0 === oh && !0 === c ? (b(), a()) : qh(function(c) {
                        b();
                        c ? d(c) : a();
                    });
                }, function(a) {
                    b();
                    d(a);
                });
            }
        };
        try {
            1 !== rh || !1 !== oh && !1 !== c || ph(), b();
        } catch (f) {
            throw b(), f;
        }
        return {
            then: function(a) {
                a();
            }
        };
    };
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = K();
            ud(a, 67108864, b);
            xh(a, 67108864);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = K(), c = td(a);
            ud(a, c, b);
            xh(a, c);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.hydrate) {
                    var c = ic(b.pendingLanes);
                    b.expiredLanes |= c & b.pendingLanes;
                    Z(b, G());
                    0 === (V & 48) && (zg(), H());
                }
                break;
            case 13:
                var d = K();
                bh(function() {
                    return ud(a, 1, d);
                });
                xh(a, 4);
        }
    };
    exports.attemptUserBlockingHydration = function(a) {
        if (13 === a.tag) {
            var b = K();
            ud(a, 4, b);
            xh(a, 4);
        }
    };
    exports.batchedEventUpdates = function(a, b) {
        var c = V;
        V |= 2;
        try {
            return a(b);
        } finally{
            V = c, 0 === V && (zg(), H());
        }
    };
    exports.batchedUpdates = ah;
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: cg,
            value: a
        };
    };
    exports.createContainer = function(a, b, c) {
        a = new uh(a, b, c);
        b = Yd(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
        a.current = b;
        b.stateNode = a;
        id(b);
        return a;
    };
    exports.createHasPsuedoClassSelector = function(a) {
        return {
            $$typeof: dg,
            value: a
        };
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: ea,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: eg,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: fg,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: gg,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        return Pc(97, a);
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = V;
        V |= 4;
        try {
            return Pc(98, a.bind(null, b, c, d, e));
        } finally{
            V = f, 0 === V && (zg(), H());
        }
    };
    exports.findAllNodes = mg;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(q(363));
        b = mg(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, n = l + k.width, t = k.y, p = t + k.height;
                if (d >= l && f >= t && e <= n && g <= p) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || p < f || t > g)) {
                    t > f && (k.height += t - f, k.y = f);
                    p < g && (k.height = g - t);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== t || c.height !== k.height || n < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    n < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = vh;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = Ba(a);
        return null === a ? null : 20 === a.tag ? a.stateNode.instance : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return vh(a);
    };
    exports.flushControlled = function(a) {
        var b = V;
        V |= 1;
        try {
            Pc(99, a);
        } finally{
            V = b, 0 === V && (zg(), H());
        }
    };
    exports.flushDiscreteUpdates = function() {
        0 === (V & 49) && ($g(), Qg());
    };
    exports.flushPassiveEffects = Qg;
    exports.flushSync = bh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(q(363));
        a = ig(a);
        b = lg(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdateLanePriority = function() {
        return hc;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(q(363));
        var c = 0, d = [];
        a = [
            ig(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (jg(f, h) && (d.push(kg(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(kg(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Da(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: ca.ReactCurrentDispatcher,
            findHostInstanceByFiber: yh,
            findFiberByHostInstance: a.findFiberByHostInstance || zh,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (!b.isDisabled && b.supportsFiber) try {
                ec = b.inject(a), fc = b;
            } catch (c) {}
            a = !0;
        }
        return a;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(q(363));
        a = mg(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = hc;
        try {
            return hc = a, b();
        } finally{
            hc = c;
        }
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.unbatchedUpdates = function(a, b) {
        var c = V;
        V &= -2;
        V |= 8;
        try {
            return a(b);
        } finally{
            V = c, 0 === V && (zg(), H());
        }
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = K(), g = td(e);
        a: if (c) {
            c = c._reactInternals;
            b: {
                if (xa(c) !== c || 1 !== c.tag) throw Error(q(170));
                var h = c;
                do {
                    switch(h.tag){
                        case 3:
                            h = h.stateNode.context;
                            break b;
                        case 1:
                            if (E(h.type)) {
                                h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                                break b;
                            }
                    }
                    h = h.return;
                }while (null !== h);
                throw Error(q(171));
            }
            if (1 === c.tag) {
                var k = c.type;
                if (E(k)) {
                    c = bc(c, k, h);
                    break a;
                }
            }
            c = h;
        } else c = Xb;
        null === b.context ? b.context = c : b.pendingContext = c;
        b = kd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        md(e, b);
        ud(e, g, f);
        return g;
    };
    return exports;
};

});
parcelRegister("b81Wb", function(module, exports) {
'use strict';

module.exports = (parcelRequire("99ijJ"));

});
parcelRegister("99ijJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6a9329bec63e1d1d$export$c4744153514ff05d; }, function (v) { return $6a9329bec63e1d1d$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6a9329bec63e1d1d$export$b5836b71941fa3ed; }, function (v) { return $6a9329bec63e1d1d$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6a9329bec63e1d1d$export$d66a1c1c77bd778b; }, function (v) { return $6a9329bec63e1d1d$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6a9329bec63e1d1d$export$3e506c1ccc9cc1a7; }, function (v) { return $6a9329bec63e1d1d$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6a9329bec63e1d1d$export$e26fe2ed2fa76875; }, function (v) { return $6a9329bec63e1d1d$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6a9329bec63e1d1d$export$502329bbf4b505b1; }, function (v) { return $6a9329bec63e1d1d$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6a9329bec63e1d1d$export$6e3807111c4874c4; }, function (v) { return $6a9329bec63e1d1d$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6a9329bec63e1d1d$export$c27134553091fb3a; }, function (v) { return $6a9329bec63e1d1d$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6a9329bec63e1d1d$export$33ee1acdc04fd2a2; }, function (v) { return $6a9329bec63e1d1d$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6a9329bec63e1d1d$export$b00a404bbd5edef2; }, function (v) { return $6a9329bec63e1d1d$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6a9329bec63e1d1d$export$8352ce38b91d0c62; }, function (v) { return $6a9329bec63e1d1d$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6a9329bec63e1d1d$export$d3dfb8e4810cb555; }, function (v) { return $6a9329bec63e1d1d$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6a9329bec63e1d1d$export$839f9183b0465a69; }, function (v) { return $6a9329bec63e1d1d$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6a9329bec63e1d1d$export$72fdf0e06517287b; }, function (v) { return $6a9329bec63e1d1d$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6a9329bec63e1d1d$export$4b844e58a3e414b4; }, function (v) { return $6a9329bec63e1d1d$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6a9329bec63e1d1d$export$816d2913ae6b83b1; }, function (v) { return $6a9329bec63e1d1d$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6a9329bec63e1d1d$export$61bcfe829111a1d0; }, function (v) { return $6a9329bec63e1d1d$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6a9329bec63e1d1d$export$7ee8c9beb337bc3f; }, function (v) { return $6a9329bec63e1d1d$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6a9329bec63e1d1d$export$cf845f2c119da08a; }, function (v) { return $6a9329bec63e1d1d$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6a9329bec63e1d1d$export$c4744153514ff05d;
var $6a9329bec63e1d1d$export$b5836b71941fa3ed;
var $6a9329bec63e1d1d$export$d66a1c1c77bd778b;
var $6a9329bec63e1d1d$export$3e506c1ccc9cc1a7;
var $6a9329bec63e1d1d$export$e26fe2ed2fa76875;
var $6a9329bec63e1d1d$export$502329bbf4b505b1;
var $6a9329bec63e1d1d$export$6e3807111c4874c4;
var $6a9329bec63e1d1d$export$c27134553091fb3a;
var $6a9329bec63e1d1d$export$33ee1acdc04fd2a2;
var $6a9329bec63e1d1d$export$b00a404bbd5edef2;
var $6a9329bec63e1d1d$export$8352ce38b91d0c62;
var $6a9329bec63e1d1d$export$d3dfb8e4810cb555;
var $6a9329bec63e1d1d$export$839f9183b0465a69;
var $6a9329bec63e1d1d$export$72fdf0e06517287b;
var $6a9329bec63e1d1d$export$4b844e58a3e414b4;
var $6a9329bec63e1d1d$export$816d2913ae6b83b1;
var $6a9329bec63e1d1d$export$61bcfe829111a1d0;
var $6a9329bec63e1d1d$export$7ee8c9beb337bc3f;
var $6a9329bec63e1d1d$export$cf845f2c119da08a;
'use strict';
var $6a9329bec63e1d1d$var$f, $6a9329bec63e1d1d$var$g, $6a9329bec63e1d1d$var$h, $6a9329bec63e1d1d$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6a9329bec63e1d1d$var$l = performance;
    $6a9329bec63e1d1d$export$c4744153514ff05d = function() {
        return $6a9329bec63e1d1d$var$l.now();
    };
} else {
    var $6a9329bec63e1d1d$var$p = Date, $6a9329bec63e1d1d$var$q = $6a9329bec63e1d1d$var$p.now();
    $6a9329bec63e1d1d$export$c4744153514ff05d = function() {
        return $6a9329bec63e1d1d$var$p.now() - $6a9329bec63e1d1d$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $6a9329bec63e1d1d$var$t = null, $6a9329bec63e1d1d$var$u = null, $6a9329bec63e1d1d$var$w = function() {
        if (null !== $6a9329bec63e1d1d$var$t) try {
            var a = $6a9329bec63e1d1d$export$c4744153514ff05d();
            $6a9329bec63e1d1d$var$t(!0, a);
            $6a9329bec63e1d1d$var$t = null;
        } catch (b) {
            throw setTimeout($6a9329bec63e1d1d$var$w, 0), b;
        }
    };
    $6a9329bec63e1d1d$var$f = function(a) {
        null !== $6a9329bec63e1d1d$var$t ? setTimeout($6a9329bec63e1d1d$var$f, 0, a) : ($6a9329bec63e1d1d$var$t = a, setTimeout($6a9329bec63e1d1d$var$w, 0));
    };
    $6a9329bec63e1d1d$var$g = function(a, b) {
        $6a9329bec63e1d1d$var$u = setTimeout(a, b);
    };
    $6a9329bec63e1d1d$var$h = function() {
        clearTimeout($6a9329bec63e1d1d$var$u);
    };
    $6a9329bec63e1d1d$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $6a9329bec63e1d1d$var$k = $6a9329bec63e1d1d$export$d66a1c1c77bd778b = function() {};
} else {
    var $6a9329bec63e1d1d$var$x = window.setTimeout, $6a9329bec63e1d1d$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $6a9329bec63e1d1d$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $6a9329bec63e1d1d$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $6a9329bec63e1d1d$var$A = !1, $6a9329bec63e1d1d$var$B = null, $6a9329bec63e1d1d$var$C = -1, $6a9329bec63e1d1d$var$D = 5, $6a9329bec63e1d1d$var$E = 0;
    $6a9329bec63e1d1d$export$b5836b71941fa3ed = function() {
        return $6a9329bec63e1d1d$export$c4744153514ff05d() >= $6a9329bec63e1d1d$var$E;
    };
    $6a9329bec63e1d1d$var$k = function() {};
    $6a9329bec63e1d1d$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6a9329bec63e1d1d$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $6a9329bec63e1d1d$var$F = new MessageChannel, $6a9329bec63e1d1d$var$G = $6a9329bec63e1d1d$var$F.port2;
    $6a9329bec63e1d1d$var$F.port1.onmessage = function() {
        if (null !== $6a9329bec63e1d1d$var$B) {
            var a = $6a9329bec63e1d1d$export$c4744153514ff05d();
            $6a9329bec63e1d1d$var$E = a + $6a9329bec63e1d1d$var$D;
            try {
                $6a9329bec63e1d1d$var$B(!0, a) ? $6a9329bec63e1d1d$var$G.postMessage(null) : ($6a9329bec63e1d1d$var$A = !1, $6a9329bec63e1d1d$var$B = null);
            } catch (b) {
                throw $6a9329bec63e1d1d$var$G.postMessage(null), b;
            }
        } else $6a9329bec63e1d1d$var$A = !1;
    };
    $6a9329bec63e1d1d$var$f = function(a) {
        $6a9329bec63e1d1d$var$B = a;
        $6a9329bec63e1d1d$var$A || ($6a9329bec63e1d1d$var$A = !0, $6a9329bec63e1d1d$var$G.postMessage(null));
    };
    $6a9329bec63e1d1d$var$g = function(a, b) {
        $6a9329bec63e1d1d$var$C = $6a9329bec63e1d1d$var$x(function() {
            a($6a9329bec63e1d1d$export$c4744153514ff05d());
        }, b);
    };
    $6a9329bec63e1d1d$var$h = function() {
        $6a9329bec63e1d1d$var$y($6a9329bec63e1d1d$var$C);
        $6a9329bec63e1d1d$var$C = -1;
    };
}
function $6a9329bec63e1d1d$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $6a9329bec63e1d1d$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6a9329bec63e1d1d$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $6a9329bec63e1d1d$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $6a9329bec63e1d1d$var$I(n, c)) void 0 !== r && 0 > $6a9329bec63e1d1d$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $6a9329bec63e1d1d$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $6a9329bec63e1d1d$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $6a9329bec63e1d1d$var$L = [], $6a9329bec63e1d1d$var$M = [], $6a9329bec63e1d1d$var$N = 1, $6a9329bec63e1d1d$var$O = null, $6a9329bec63e1d1d$var$P = 3, $6a9329bec63e1d1d$var$Q = !1, $6a9329bec63e1d1d$var$R = !1, $6a9329bec63e1d1d$var$S = !1;
function $6a9329bec63e1d1d$var$T(a) {
    for(var b = $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$M); null !== b;){
        if (null === b.callback) $6a9329bec63e1d1d$var$K($6a9329bec63e1d1d$var$M);
        else if (b.startTime <= a) $6a9329bec63e1d1d$var$K($6a9329bec63e1d1d$var$M), b.sortIndex = b.expirationTime, $6a9329bec63e1d1d$var$H($6a9329bec63e1d1d$var$L, b);
        else break;
        b = $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$M);
    }
}
function $6a9329bec63e1d1d$var$U(a) {
    $6a9329bec63e1d1d$var$S = !1;
    $6a9329bec63e1d1d$var$T(a);
    if (!$6a9329bec63e1d1d$var$R) {
        if (null !== $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$L)) $6a9329bec63e1d1d$var$R = !0, $6a9329bec63e1d1d$var$f($6a9329bec63e1d1d$var$V);
        else {
            var b = $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$M);
            null !== b && $6a9329bec63e1d1d$var$g($6a9329bec63e1d1d$var$U, b.startTime - a);
        }
    }
}
function $6a9329bec63e1d1d$var$V(a, b) {
    $6a9329bec63e1d1d$var$R = !1;
    $6a9329bec63e1d1d$var$S && ($6a9329bec63e1d1d$var$S = !1, $6a9329bec63e1d1d$var$h());
    $6a9329bec63e1d1d$var$Q = !0;
    var c = $6a9329bec63e1d1d$var$P;
    try {
        $6a9329bec63e1d1d$var$T(b);
        for($6a9329bec63e1d1d$var$O = $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$L); null !== $6a9329bec63e1d1d$var$O && (!($6a9329bec63e1d1d$var$O.expirationTime > b) || a && !$6a9329bec63e1d1d$export$b5836b71941fa3ed());){
            var d = $6a9329bec63e1d1d$var$O.callback;
            if ("function" === typeof d) {
                $6a9329bec63e1d1d$var$O.callback = null;
                $6a9329bec63e1d1d$var$P = $6a9329bec63e1d1d$var$O.priorityLevel;
                var e = d($6a9329bec63e1d1d$var$O.expirationTime <= b);
                b = $6a9329bec63e1d1d$export$c4744153514ff05d();
                "function" === typeof e ? $6a9329bec63e1d1d$var$O.callback = e : $6a9329bec63e1d1d$var$O === $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$L) && $6a9329bec63e1d1d$var$K($6a9329bec63e1d1d$var$L);
                $6a9329bec63e1d1d$var$T(b);
            } else $6a9329bec63e1d1d$var$K($6a9329bec63e1d1d$var$L);
            $6a9329bec63e1d1d$var$O = $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$L);
        }
        if (null !== $6a9329bec63e1d1d$var$O) var m = !0;
        else {
            var n = $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$M);
            null !== n && $6a9329bec63e1d1d$var$g($6a9329bec63e1d1d$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $6a9329bec63e1d1d$var$O = null, $6a9329bec63e1d1d$var$P = c, $6a9329bec63e1d1d$var$Q = !1;
    }
}
var $6a9329bec63e1d1d$var$W = $6a9329bec63e1d1d$var$k;
$6a9329bec63e1d1d$export$3e506c1ccc9cc1a7 = 5;
$6a9329bec63e1d1d$export$e26fe2ed2fa76875 = 1;
$6a9329bec63e1d1d$export$502329bbf4b505b1 = 4;
$6a9329bec63e1d1d$export$6e3807111c4874c4 = 3;
$6a9329bec63e1d1d$export$c27134553091fb3a = null;
$6a9329bec63e1d1d$export$33ee1acdc04fd2a2 = 2;
$6a9329bec63e1d1d$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6a9329bec63e1d1d$export$8352ce38b91d0c62 = function() {
    $6a9329bec63e1d1d$var$R || $6a9329bec63e1d1d$var$Q || ($6a9329bec63e1d1d$var$R = !0, $6a9329bec63e1d1d$var$f($6a9329bec63e1d1d$var$V));
};
$6a9329bec63e1d1d$export$d3dfb8e4810cb555 = function() {
    return $6a9329bec63e1d1d$var$P;
};
$6a9329bec63e1d1d$export$839f9183b0465a69 = function() {
    return $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$L);
};
$6a9329bec63e1d1d$export$72fdf0e06517287b = function(a) {
    switch($6a9329bec63e1d1d$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6a9329bec63e1d1d$var$P;
    }
    var c = $6a9329bec63e1d1d$var$P;
    $6a9329bec63e1d1d$var$P = b;
    try {
        return a();
    } finally{
        $6a9329bec63e1d1d$var$P = c;
    }
};
$6a9329bec63e1d1d$export$4b844e58a3e414b4 = function() {};
$6a9329bec63e1d1d$export$816d2913ae6b83b1 = $6a9329bec63e1d1d$var$W;
$6a9329bec63e1d1d$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6a9329bec63e1d1d$var$P;
    $6a9329bec63e1d1d$var$P = a;
    try {
        return b();
    } finally{
        $6a9329bec63e1d1d$var$P = c;
    }
};
$6a9329bec63e1d1d$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6a9329bec63e1d1d$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6a9329bec63e1d1d$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6a9329bec63e1d1d$var$H($6a9329bec63e1d1d$var$M, a), null === $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$L) && a === $6a9329bec63e1d1d$var$J($6a9329bec63e1d1d$var$M) && ($6a9329bec63e1d1d$var$S ? $6a9329bec63e1d1d$var$h() : $6a9329bec63e1d1d$var$S = !0, $6a9329bec63e1d1d$var$g($6a9329bec63e1d1d$var$U, c - d))) : (a.sortIndex = e, $6a9329bec63e1d1d$var$H($6a9329bec63e1d1d$var$L, a), $6a9329bec63e1d1d$var$R || $6a9329bec63e1d1d$var$Q || ($6a9329bec63e1d1d$var$R = !0, $6a9329bec63e1d1d$var$f($6a9329bec63e1d1d$var$V)));
    return a;
};
$6a9329bec63e1d1d$export$cf845f2c119da08a = function(a) {
    var b = $6a9329bec63e1d1d$var$P;
    return function() {
        var c = $6a9329bec63e1d1d$var$P;
        $6a9329bec63e1d1d$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6a9329bec63e1d1d$var$P = c;
        }
    };
};

});



parcelRegister("5MgdR", function(module, exports) {
/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Dispatcher
 * 
 * @preventMunge
 */ 'use strict';
module.exports.__esModule = true;
function $434e04e408aef946$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

var $bBKso = parcelRequire("bBKso");
var $434e04e408aef946$var$_prefix = 'ID_';
/**
 * Dispatcher is used to broadcast payloads to registered callbacks. This is
 * different from generic pub-sub systems in two ways:
 *
 *   1) Callbacks are not subscribed to particular events. Every payload is
 *      dispatched to every registered callback.
 *   2) Callbacks can be deferred in whole or part until other callbacks have
 *      been executed.
 *
 * For example, consider this hypothetical flight destination form, which
 * selects a default city when a country is selected:
 *
 *   var flightDispatcher = new Dispatcher();
 *
 *   // Keeps track of which country is selected
 *   var CountryStore = {country: null};
 *
 *   // Keeps track of which city is selected
 *   var CityStore = {city: null};
 *
 *   // Keeps track of the base flight price of the selected city
 *   var FlightPriceStore = {price: null}
 *
 * When a user changes the selected city, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'city-update',
 *     selectedCity: 'paris'
 *   });
 *
 * This payload is digested by `CityStore`:
 *
 *   flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'city-update') {
 *       CityStore.city = payload.selectedCity;
 *     }
 *   });
 *
 * When the user selects a country, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'country-update',
 *     selectedCountry: 'australia'
 *   });
 *
 * This payload is digested by both stores:
 *
 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       CountryStore.country = payload.selectedCountry;
 *     }
 *   });
 *
 * When the callback to update `CountryStore` is registered, we save a reference
 * to the returned token. Using this token with `waitFor()`, we can guarantee
 * that `CountryStore` is updated before the callback that updates `CityStore`
 * needs to query its data.
 *
 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       // `CountryStore.country` may not be updated.
 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
 *       // `CountryStore.country` is now guaranteed to be updated.
 *
 *       // Select the default city for the new country
 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
 *     }
 *   });
 *
 * The usage of `waitFor()` can be chained, for example:
 *
 *   FlightPriceStore.dispatchToken =
 *     flightDispatcher.register(function(payload) {
 *       switch (payload.actionType) {
 *         case 'country-update':
 *         case 'city-update':
 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
 *           FlightPriceStore.price =
 *             getFlightPriceStore(CountryStore.country, CityStore.city);
 *           break;
 *     }
 *   });
 *
 * The `country-update` payload will be guaranteed to invoke the stores'
 * registered callbacks in order: `CountryStore`, `CityStore`, then
 * `FlightPriceStore`.
 */ var $434e04e408aef946$var$Dispatcher = function() {
    function Dispatcher() {
        $434e04e408aef946$var$_classCallCheck(this, Dispatcher);
        this._callbacks = {};
        this._isDispatching = false;
        this._isHandled = {};
        this._isPending = {};
        this._lastID = 1;
    }
    /**
   * Registers a callback to be invoked with every dispatched payload. Returns
   * a token that can be used with `waitFor()`.
   */ Dispatcher.prototype.register = function register(callback) {
        var id = $434e04e408aef946$var$_prefix + this._lastID++;
        this._callbacks[id] = callback;
        return id;
    };
    /**
   * Removes a callback based on its token.
   */ Dispatcher.prototype.unregister = function unregister(id) {
        !this._callbacks[id] ? $bBKso(false) : undefined;
        delete this._callbacks[id];
    };
    /**
   * Waits for the callbacks specified to be invoked before continuing execution
   * of the current callback. This method should only be used by a callback in
   * response to a dispatched payload.
   */ Dispatcher.prototype.waitFor = function waitFor(ids) {
        !this._isDispatching ? $bBKso(false) : undefined;
        for(var ii = 0; ii < ids.length; ii++){
            var id = ids[ii];
            if (this._isPending[id]) {
                !this._isHandled[id] ? $bBKso(false) : undefined;
                continue;
            }
            !this._callbacks[id] ? $bBKso(false) : undefined;
            this._invokeCallback(id);
        }
    };
    /**
   * Dispatches a payload to all registered callbacks.
   */ Dispatcher.prototype.dispatch = function dispatch(payload) {
        !!this._isDispatching ? $bBKso(false) : undefined;
        this._startDispatching(payload);
        try {
            for(var id in this._callbacks){
                if (this._isPending[id]) continue;
                this._invokeCallback(id);
            }
        } finally{
            this._stopDispatching();
        }
    };
    /**
   * Is this Dispatcher currently dispatching.
   */ Dispatcher.prototype.isDispatching = function isDispatching() {
        return this._isDispatching;
    };
    /**
   * Call the callback stored with the given id. Also do some internal
   * bookkeeping.
   *
   * @internal
   */ Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
        this._isPending[id] = true;
        this._callbacks[id](this._pendingPayload);
        this._isHandled[id] = true;
    };
    /**
   * Set up bookkeeping needed when dispatching.
   *
   * @internal
   */ Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
        for(var id in this._callbacks){
            this._isPending[id] = false;
            this._isHandled[id] = false;
        }
        this._pendingPayload = payload;
        this._isDispatching = true;
    };
    /**
   * Clear bookkeeping used for dispatching.
   *
   * @internal
   */ Dispatcher.prototype._stopDispatching = function _stopDispatching() {
        delete this._pendingPayload;
        this._isDispatching = false;
    };
    return Dispatcher;
}();
module.exports = $434e04e408aef946$var$Dispatcher;

});
parcelRegister("bBKso", function(module, exports) {
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule invariant
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $87372fc6651ca658$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error('Invariant Violation: ' + format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $87372fc6651ca658$var$invariant;

});


parcelRegister("a04va", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $9X39E = parcelRequire("9X39E");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    var context = new $8PZpp(defaultConfig);
    var instance = $6zjya($8PZpp.prototype.request, context);
    // Copy axios.prototype to instance
    $adReO.extend(instance, $8PZpp.prototype, context);
    // Copy context to instance
    $adReO.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance($9X39E);
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = $8PZpp;
// Factory for creating new instances
$747d656b899e6115$var$axios.create = function create(instanceConfig) {
    return $747d656b899e6115$var$createInstance($adReO.merge($9X39E, instanceConfig));
};

// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.Cancel = (parcelRequire("2W85d"));

$747d656b899e6115$var$axios.CancelToken = (parcelRequire("kZZD0"));

$747d656b899e6115$var$axios.isCancel = (parcelRequire("4IsRW"));
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$747d656b899e6115$var$axios.spread = (parcelRequire("b676K"));
module.exports = $747d656b899e6115$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {
'use strict';

var $6zjya = parcelRequire("6zjya");

var $1KitT = parcelRequire("1KitT");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $77146a31cb578292$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $77146a31cb578292$var$isArray(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBuffer(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $77146a31cb578292$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $77146a31cb578292$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $77146a31cb578292$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $77146a31cb578292$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $77146a31cb578292$var$isDate(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $77146a31cb578292$var$isFile(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $77146a31cb578292$var$isBlob(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $77146a31cb578292$var$isFunction(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $77146a31cb578292$var$isStream(val) {
    return $77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $77146a31cb578292$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $77146a31cb578292$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */ function $77146a31cb578292$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $77146a31cb578292$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') result[key] = $77146a31cb578292$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $77146a31cb578292$var$extend(a, b, thisArg) {
    $77146a31cb578292$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $6zjya(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $1KitT,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isObject: $77146a31cb578292$var$isObject,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isStandardBrowserEnv: $77146a31cb578292$var$isStandardBrowserEnv,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim
};

});
parcelRegister("6zjya", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});

parcelRegister("1KitT", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($14586c46e77ba9fa$var$isBuffer(obj) || $14586c46e77ba9fa$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $14586c46e77ba9fa$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $14586c46e77ba9fa$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $14586c46e77ba9fa$var$isBuffer(obj.slice(0, 0));
}

});


parcelRegister("8PZpp", function(module, exports) {
'use strict';

var $9X39E = parcelRequire("9X39E");

var $adReO = parcelRequire("adReO");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $66f2b8a41463d1e8$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $khPLX(),
        response: new $khPLX()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $66f2b8a41463d1e8$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') config = $adReO.merge({
        url: arguments[0]
    }, arguments[1]);
    config = $adReO.merge($9X39E, {
        method: 'get'
    }, this.defaults, config);
    config.method = config.method.toLowerCase();
    // Hook up interceptors middleware
    var chain = [
        $eystn,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
// Provide aliases for supported request methods
$adReO.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request($adReO.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($adReO.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("9X39E", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9y7wC = parcelRequire("9y7wC");
var $73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $73ec122cfcba4842$var$setContentTypeIfUnset(headers, value) {
    if (!$adReO.isUndefined(headers) && $adReO.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $73ec122cfcba4842$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("3PMHb"));
    return adapter;
}
var $73ec122cfcba4842$var$defaults = {
    adapter: $73ec122cfcba4842$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9y7wC(headers, 'Content-Type');
            if ($adReO.isFormData(data) || $adReO.isArrayBuffer(data) || $adReO.isBuffer(data) || $adReO.isStream(data) || $adReO.isFile(data) || $adReO.isBlob(data)) return data;
            if ($adReO.isArrayBufferView(data)) return data.buffer;
            if ($adReO.isURLSearchParams(data)) {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($adReO.isObject(data)) {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$73ec122cfcba4842$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$adReO.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = {};
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = $adReO.merge($73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $73ec122cfcba4842$var$defaults;

});
parcelRegister("9y7wC", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $adReO.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("3PMHb", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $6nvAH = parcelRequire("6nvAH");

var $hMzvi = parcelRequire("hMzvi");

var $besJL = parcelRequire("besJL");

var $hHo9F = parcelRequire("hHo9F");

var $2cabe869ce51dbf6$var$btoa = typeof window !== 'undefined' && window.btoa && window.btoa.bind(window) || (parcelRequire("6aH5M"));

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($adReO.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        var loadEvent = 'onreadystatechange';
        var xDomain = false;
        // For IE 8/9 CORS support
        // Only supports POST and GET calls and doesn't returns the response headers.
        // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
        if (typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !$besJL(config.url)) {
            request = new window.XDomainRequest();
            loadEvent = 'onload';
            xDomain = true;
            request.onprogress = function handleProgress() {};
            request.ontimeout = function handleTimeout() {};
        }
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + $2cabe869ce51dbf6$var$btoa(username + ':' + password);
        }
        request.open(config.method.toUpperCase(), $6nvAH(config.url, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request[loadEvent] = function handleLoad() {
            if (!request || request.readyState !== 4 && !xDomain) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $hMzvi(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
                status: request.status === 1223 ? 204 : request.status,
                statusText: request.status === 1223 ? 'No Content' : request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3PfpF(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hHo9F('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            reject($hHo9F('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($adReO.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("79n0f"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $besJL(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $adReO.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (config.withCredentials) request.withCredentials = true;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {
'use strict';

var $hHo9F = parcelRequire("hHo9F");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    // Note: status is not exposed by XDomainRequest
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hHo9F('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hHo9F", function(module, exports) {
'use strict';

var $3leq5 = parcelRequire("3leq5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3leq5(error, config, code, request, response);
};

});
parcelRegister("3leq5", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    return error;
};

});



parcelRegister("6nvAH", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($adReO.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $adReO.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($adReO.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $adReO.forEach(val, function parseValue(v) {
                if ($adReO.isDate(v)) v = v.toISOString();
                else if ($adReO.isObject(v)) v = JSON.stringify(v);
                parts.push($4a4d655613ae826e$var$encode(key) + '=' + $4a4d655613ae826e$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    return url;
};

});

parcelRegister("hMzvi", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cf2275aca40d6d88$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $adReO.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $adReO.trim(line.substr(0, i)).toLowerCase();
        val = $adReO.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("besJL", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $adReO.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("6aH5M", function(module, exports) {
'use strict';
// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
var $47e51a77aee78ff3$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $47e51a77aee78ff3$var$E() {
    this.message = 'String contains an invalid character';
}
$47e51a77aee78ff3$var$E.prototype = new Error;
$47e51a77aee78ff3$var$E.prototype.code = 5;
$47e51a77aee78ff3$var$E.prototype.name = 'InvalidCharacterError';
function $47e51a77aee78ff3$var$btoa(input) {
    var str = String(input);
    var output = '';
    for(// initialize result and counter
    var block, charCode, idx = 0, map = $47e51a77aee78ff3$var$chars; // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1); // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)){
        charCode = str.charCodeAt(idx += 3 / 4);
        if (charCode > 0xFF) throw new $47e51a77aee78ff3$var$E();
        block = block << 8 | charCode;
    }
    return output;
}
module.exports = $47e51a77aee78ff3$var$btoa;

});

parcelRegister("79n0f", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($adReO.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($adReO.isString(path)) cookie.push('path=' + path);
            if ($adReO.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});



parcelRegister("khPLX", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $ec4d8e24b0699790$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $adReO.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $9X39E = parcelRequire("9X39E");

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    // Support baseURL config
    if (config.baseURL && !$1yk63(config.url)) config.url = $l45Ly(config.baseURL, config.url);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $15ANS(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $adReO.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
    $adReO.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $9X39E.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $15ANS(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$4IsRW(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $15ANS(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("15ANS", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $adReO.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("4IsRW", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("1yk63", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("l45Ly", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});



parcelRegister("2W85d", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $223744b24e5d0b4c$var$Cancel(message) {
    this.message = message;
}
$223744b24e5d0b4c$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$223744b24e5d0b4c$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $223744b24e5d0b4c$var$Cancel;

});

parcelRegister("kZZD0", function(module, exports) {
'use strict';

var $2W85d = parcelRequire("2W85d");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $f4994f37c883aea2$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $2W85d(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $f4994f37c883aea2$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $f4994f37c883aea2$var$CancelToken.source = function source() {
    var cancel;
    var token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


parcelRegister("Sd5lO", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved_;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("bS2zd", function(module, exports) {
'use strict';

var $eAyj5 = parcelRequire("eAyj5");

var $fRF8h = parcelRequire("fRF8h");

var $fcCXC = parcelRequire("fcCXC");

var $6Zyia = parcelRequire("6Zyia");
var $8a46ba959f9d773e$require$scanSchema = $6Zyia.scan;
var $8a46ba959f9d773e$var$ValidatorResult = $fcCXC.ValidatorResult;
var $8a46ba959f9d773e$var$SchemaError = $fcCXC.SchemaError;
var $8a46ba959f9d773e$var$SchemaContext = $fcCXC.SchemaContext;
//var anonymousBase = 'vnd.jsonschema:///';
var $8a46ba959f9d773e$var$anonymousBase = '/';
/**
 * Creates a new Validator object
 * @name Validator
 * @constructor
 */ var $8a46ba959f9d773e$var$Validator = function Validator() {
    // Allow a validator instance to override global custom formats or to have their
    // own custom formats.
    this.customFormats = Object.create(Validator.prototype.customFormats);
    this.schemas = {};
    this.unresolvedRefs = [];
    // Use Object.create to make this extensible without Validator instances stepping on each other's toes.
    this.types = Object.create($8a46ba959f9d773e$var$types);
    this.attributes = Object.create($fRF8h.validators);
};
// Allow formats to be registered globally.
$8a46ba959f9d773e$var$Validator.prototype.customFormats = {};
// Hint at the presence of a property
$8a46ba959f9d773e$var$Validator.prototype.schemas = null;
$8a46ba959f9d773e$var$Validator.prototype.types = null;
$8a46ba959f9d773e$var$Validator.prototype.attributes = null;
$8a46ba959f9d773e$var$Validator.prototype.unresolvedRefs = null;
/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param schema
 * @param urn
 * @return {Object}
 */ $8a46ba959f9d773e$var$Validator.prototype.addSchema = function addSchema(schema, base) {
    var self = this;
    if (!schema) return null;
    var scan = $8a46ba959f9d773e$require$scanSchema(base || $8a46ba959f9d773e$var$anonymousBase, schema);
    var ourUri = base || schema.id;
    for(var uri in scan.id)this.schemas[uri] = scan.id[uri];
    for(var uri in scan.ref)this.unresolvedRefs.push(uri);
    this.unresolvedRefs = this.unresolvedRefs.filter(function(uri) {
        return typeof self.schemas[uri] === 'undefined';
    });
    return this.schemas[ourUri];
};
$8a46ba959f9d773e$var$Validator.prototype.addSubSchemaArray = function addSubSchemaArray(baseuri, schemas) {
    if (!(schemas instanceof Array)) return;
    for(var i = 0; i < schemas.length; i++)this.addSubSchema(baseuri, schemas[i]);
};
$8a46ba959f9d773e$var$Validator.prototype.addSubSchemaObject = function addSubSchemaArray(baseuri, schemas) {
    if (!schemas || typeof schemas != 'object') return;
    for(var p in schemas)this.addSubSchema(baseuri, schemas[p]);
};
/**
 * Sets all the schemas of the Validator instance.
 * @param schemas
 */ $8a46ba959f9d773e$var$Validator.prototype.setSchemas = function setSchemas(schemas) {
    this.schemas = schemas;
};
/**
 * Returns the schema of a certain urn
 * @param urn
 */ $8a46ba959f9d773e$var$Validator.prototype.getSchema = function getSchema(urn) {
    return this.schemas[urn];
};
/**
 * Validates instance against the provided schema
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {Array}
 */ $8a46ba959f9d773e$var$Validator.prototype.validate = function validate(instance, schema, options, ctx) {
    if (!options) options = {};
    var propertyName = options.propertyName || 'instance';
    // This will work so long as the function at uri.resolve() will resolve a relative URI to a relative URI
    var base = $eAyj5.resolve(options.base || $8a46ba959f9d773e$var$anonymousBase, schema.id || '');
    if (!ctx) {
        ctx = new $8a46ba959f9d773e$var$SchemaContext(schema, options, propertyName, base, Object.create(this.schemas));
        if (!ctx.schemas[base]) ctx.schemas[base] = schema;
        var found = $8a46ba959f9d773e$require$scanSchema(base, schema);
        for(var n in found.id){
            var sch = found.id[n];
            ctx.schemas[n] = sch;
        }
    }
    if (schema) {
        var result = this.validateSchema(instance, schema, options, ctx);
        if (!result) throw new Error('Result undefined');
        return result;
    }
    throw new $8a46ba959f9d773e$var$SchemaError('no schema specified', schema);
};
/**
* @param Object schema
* @return mixed schema uri or false
*/ function $8a46ba959f9d773e$var$shouldResolve(schema) {
    var ref = typeof schema === 'string' ? schema : schema.$ref;
    if (typeof ref == 'string') return ref;
    return false;
}
/**
 * Validates an instance against the schema (the actual work horse)
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @private
 * @return {ValidatorResult}
 */ $8a46ba959f9d773e$var$Validator.prototype.validateSchema = function validateSchema(instance, schema, options, ctx) {
    var result = new $8a46ba959f9d773e$var$ValidatorResult(instance, schema, options, ctx);
    // Support for the true/false schemas
    if (typeof schema === 'boolean') {
        if (schema === true) // `true` is always valid
        schema = {};
        else if (schema === false) // `false` is always invalid
        schema = {
            type: []
        };
    } else if (!schema) // This might be a string
    throw new Error("schema is undefined");
    if (schema['extends']) {
        if (schema['extends'] instanceof Array) {
            var schemaobj = {
                schema: schema,
                ctx: ctx
            };
            schema['extends'].forEach(this.schemaTraverser.bind(this, schemaobj));
            schema = schemaobj.schema;
            schemaobj.schema = null;
            schemaobj.ctx = null;
            schemaobj = null;
        } else schema = $fcCXC.deepMerge(schema, this.superResolve(schema['extends'], ctx));
    }
    // If passed a string argument, load that schema URI
    var switchSchema;
    if (switchSchema = $8a46ba959f9d773e$var$shouldResolve(schema)) {
        var resolved = this.resolve(schema, switchSchema, ctx);
        var subctx = new $8a46ba959f9d773e$var$SchemaContext(resolved.subschema, options, ctx.propertyPath, resolved.switchSchema, ctx.schemas);
        return this.validateSchema(instance, resolved.subschema, options, subctx);
    }
    var skipAttributes = options && options.skipAttributes || [];
    // Validate each schema attribute against the instance
    for(var key in schema)if (!$fRF8h.ignoreProperties[key] && skipAttributes.indexOf(key) < 0) {
        var validatorErr = null;
        var validator = this.attributes[key];
        if (validator) validatorErr = validator.call(this, instance, schema, options, ctx);
        else if (options.allowUnknownAttributes === false) // This represents an error with the schema itself, not an invalid instance
        throw new $8a46ba959f9d773e$var$SchemaError("Unsupported attribute: " + key, schema);
        if (validatorErr) result.importErrors(validatorErr);
    }
    if (typeof options.rewrite == 'function') {
        var value = options.rewrite.call(this, instance, schema, options, ctx);
        result.instance = value;
    }
    return result;
};
/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/ $8a46ba959f9d773e$var$Validator.prototype.schemaTraverser = function schemaTraverser(schemaobj, s) {
    schemaobj.schema = $fcCXC.deepMerge(schemaobj.schema, this.superResolve(s, schemaobj.ctx));
};
/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/ $8a46ba959f9d773e$var$Validator.prototype.superResolve = function superResolve(schema, ctx) {
    var ref;
    if (ref = $8a46ba959f9d773e$var$shouldResolve(schema)) return this.resolve(schema, ref, ctx).subschema;
    return schema;
};
/**
* @private
* @param Object schema
* @param Object switchSchema
* @param SchemaContext ctx
* @return Object resolved schemas {subschema:String, switchSchema: String}
* @throws SchemaError
*/ $8a46ba959f9d773e$var$Validator.prototype.resolve = function resolve(schema, switchSchema, ctx) {
    switchSchema = ctx.resolve(switchSchema);
    // First see if the schema exists under the provided URI
    if (ctx.schemas[switchSchema]) return {
        subschema: ctx.schemas[switchSchema],
        switchSchema: switchSchema
    };
    // Else try walking the property pointer
    var parsed = $eAyj5.parse(switchSchema);
    var fragment = parsed && parsed.hash;
    var document = fragment && fragment.length && switchSchema.substr(0, switchSchema.length - fragment.length);
    if (!document || !ctx.schemas[document]) throw new $8a46ba959f9d773e$var$SchemaError("no such schema <" + switchSchema + ">", schema);
    var subschema = $fcCXC.objectGetPath(ctx.schemas[document], fragment.substr(1));
    if (subschema === undefined) throw new $8a46ba959f9d773e$var$SchemaError("no such schema " + fragment + " located in <" + document + ">", schema);
    return {
        subschema: subschema,
        switchSchema: switchSchema
    };
};
/**
 * Tests whether the instance if of a certain type.
 * @private
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @param type
 * @return {boolean}
 */ $8a46ba959f9d773e$var$Validator.prototype.testType = function validateType(instance, schema, options, ctx, type) {
    if (typeof this.types[type] == 'function') return this.types[type].call(this, instance);
    if (type && typeof type == 'object') {
        var res = this.validateSchema(instance, type, options, ctx);
        return res === undefined || !(res && res.errors.length);
    }
    // Undefined or properties not on the list are acceptable, same as not being defined
    return true;
};
var $8a46ba959f9d773e$var$types = $8a46ba959f9d773e$var$Validator.prototype.types = {};
$8a46ba959f9d773e$var$types.string = function testString(instance) {
    return typeof instance == 'string';
};
$8a46ba959f9d773e$var$types.number = function testNumber(instance) {
    // isFinite returns false for NaN, Infinity, and -Infinity
    return typeof instance == 'number' && isFinite(instance);
};
$8a46ba959f9d773e$var$types.integer = function testInteger(instance) {
    return typeof instance == 'number' && instance % 1 === 0;
};
$8a46ba959f9d773e$var$types.boolean = function testBoolean(instance) {
    return typeof instance == 'boolean';
};
$8a46ba959f9d773e$var$types.array = function testArray(instance) {
    return Array.isArray(instance);
};
$8a46ba959f9d773e$var$types['null'] = function testNull(instance) {
    return instance === null;
};
$8a46ba959f9d773e$var$types.date = function testDate(instance) {
    return instance instanceof Date;
};
$8a46ba959f9d773e$var$types.any = function testAny(instance) {
    return true;
};
$8a46ba959f9d773e$var$types.object = function testObject(instance) {
    // TODO: fix this - see #15
    return instance && typeof instance === 'object' && !(instance instanceof Array) && !(instance instanceof Date);
};
module.exports = $8a46ba959f9d773e$var$Validator;

});
parcelRegister("eAyj5", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $k9qD0 = parcelRequire("k9qD0");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $5dq8O = parcelRequire("5dq8O");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $5dq8O.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $k9qD0.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $5dq8O.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $5dq8O.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("k9qD0", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("5dq8O", function(module, exports) {
'use strict';

var $lMkYw = parcelRequire("lMkYw");

var $4iVSP = parcelRequire("4iVSP");

var $br3n2 = parcelRequire("br3n2");
module.exports = {
    formats: $br3n2,
    parse: $4iVSP,
    stringify: $lMkYw
};

});
parcelRegister("lMkYw", function(module, exports) {
'use strict';

var $1Tr1N = parcelRequire("1Tr1N");

var $2mSnl = parcelRequire("2mSnl");

var $br3n2 = parcelRequire("br3n2");
var $fdae59e8868608a5$var$has = Object.prototype.hasOwnProperty;
var $fdae59e8868608a5$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $fdae59e8868608a5$var$isArray = Array.isArray;
var $fdae59e8868608a5$var$push = Array.prototype.push;
var $fdae59e8868608a5$var$pushToArray = function(arr, valueOrArray) {
    $fdae59e8868608a5$var$push.apply(arr, $fdae59e8868608a5$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $fdae59e8868608a5$var$toISO = Date.prototype.toISOString;
var $fdae59e8868608a5$var$defaultFormat = $br3n2.default;
var $fdae59e8868608a5$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $2mSnl.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $fdae59e8868608a5$var$defaultFormat,
    formatter: $br3n2.formatters[$fdae59e8868608a5$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $fdae59e8868608a5$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $fdae59e8868608a5$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $fdae59e8868608a5$var$sentinel = {};
var $fdae59e8868608a5$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($fdae59e8868608a5$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($fdae59e8868608a5$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $fdae59e8868608a5$var$isArray(obj)) obj = $2mSnl.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $fdae59e8868608a5$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($fdae59e8868608a5$var$isNonNullishPrimitive(obj) || $2mSnl.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $fdae59e8868608a5$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $fdae59e8868608a5$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $fdae59e8868608a5$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $2mSnl.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($fdae59e8868608a5$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $fdae59e8868608a5$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $fdae59e8868608a5$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $fdae59e8868608a5$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $1Tr1N();
        valueSideChannel.set($fdae59e8868608a5$var$sentinel, sideChannel);
        $fdae59e8868608a5$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $fdae59e8868608a5$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $fdae59e8868608a5$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $fdae59e8868608a5$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $fdae59e8868608a5$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $br3n2.default;
    if (typeof opts.format !== 'undefined') {
        if (!$fdae59e8868608a5$var$has.call($br3n2.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $br3n2.formatters[format];
    var filter = $fdae59e8868608a5$var$defaults.filter;
    if (typeof opts.filter === 'function' || $fdae59e8868608a5$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $fdae59e8868608a5$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $fdae59e8868608a5$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $fdae59e8868608a5$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $fdae59e8868608a5$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $fdae59e8868608a5$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $fdae59e8868608a5$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $fdae59e8868608a5$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $fdae59e8868608a5$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $fdae59e8868608a5$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $fdae59e8868608a5$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $fdae59e8868608a5$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $fdae59e8868608a5$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $fdae59e8868608a5$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $fdae59e8868608a5$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $fdae59e8868608a5$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($fdae59e8868608a5$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $fdae59e8868608a5$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $1Tr1N();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $fdae59e8868608a5$var$pushToArray(keys, $fdae59e8868608a5$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("1Tr1N", function(module, exports) {
'use strict';

var $5Xz8R = parcelRequire("5Xz8R");

var $6xIgw = parcelRequire("6xIgw");

var $8zbyi = parcelRequire("8zbyi");

var $auXV2 = parcelRequire("auXV2");

var $2nyui = parcelRequire("2nyui");
var $160fe4adf6e4e82c$var$makeChannel = $2nyui || $auXV2 || $8zbyi;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $5Xz8R('Side channel does not contain ' + $6xIgw(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $160fe4adf6e4e82c$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("5Xz8R", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("6xIgw", function(module, exports) {
var $4c38295599b865d4$var$hasMap = typeof Map === 'function' && Map.prototype;
var $4c38295599b865d4$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $4c38295599b865d4$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $4c38295599b865d4$var$mapSize = $4c38295599b865d4$var$hasMap && $4c38295599b865d4$var$mapSizeDescriptor && typeof $4c38295599b865d4$var$mapSizeDescriptor.get === 'function' ? $4c38295599b865d4$var$mapSizeDescriptor.get : null;
var $4c38295599b865d4$var$mapForEach = $4c38295599b865d4$var$hasMap && Map.prototype.forEach;
var $4c38295599b865d4$var$hasSet = typeof Set === 'function' && Set.prototype;
var $4c38295599b865d4$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $4c38295599b865d4$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $4c38295599b865d4$var$setSize = $4c38295599b865d4$var$hasSet && $4c38295599b865d4$var$setSizeDescriptor && typeof $4c38295599b865d4$var$setSizeDescriptor.get === 'function' ? $4c38295599b865d4$var$setSizeDescriptor.get : null;
var $4c38295599b865d4$var$setForEach = $4c38295599b865d4$var$hasSet && Set.prototype.forEach;
var $4c38295599b865d4$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $4c38295599b865d4$var$weakMapHas = $4c38295599b865d4$var$hasWeakMap ? WeakMap.prototype.has : null;
var $4c38295599b865d4$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $4c38295599b865d4$var$weakSetHas = $4c38295599b865d4$var$hasWeakSet ? WeakSet.prototype.has : null;
var $4c38295599b865d4$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $4c38295599b865d4$var$weakRefDeref = $4c38295599b865d4$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $4c38295599b865d4$var$booleanValueOf = Boolean.prototype.valueOf;
var $4c38295599b865d4$var$objectToString = Object.prototype.toString;
var $4c38295599b865d4$var$functionToString = Function.prototype.toString;
var $4c38295599b865d4$var$$match = String.prototype.match;
var $4c38295599b865d4$var$$slice = String.prototype.slice;
var $4c38295599b865d4$var$$replace = String.prototype.replace;
var $4c38295599b865d4$var$$toUpperCase = String.prototype.toUpperCase;
var $4c38295599b865d4$var$$toLowerCase = String.prototype.toLowerCase;
var $4c38295599b865d4$var$$test = RegExp.prototype.test;
var $4c38295599b865d4$var$$concat = Array.prototype.concat;
var $4c38295599b865d4$var$$join = Array.prototype.join;
var $4c38295599b865d4$var$$arrSlice = Array.prototype.slice;
var $4c38295599b865d4$var$$floor = Math.floor;
var $4c38295599b865d4$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $4c38295599b865d4$var$gOPS = Object.getOwnPropertySymbols;
var $4c38295599b865d4$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $4c38295599b865d4$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $4c38295599b865d4$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $4c38295599b865d4$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $4c38295599b865d4$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $4c38295599b865d4$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $4c38295599b865d4$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $4c38295599b865d4$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$4c38295599b865d4$var$$floor(-num) : $4c38295599b865d4$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $4c38295599b865d4$var$$slice.call(str, intStr.length + 1);
            return $4c38295599b865d4$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $4c38295599b865d4$var$$replace.call($4c38295599b865d4$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $4c38295599b865d4$var$$replace.call(str, sepRegex, '$&_');
}

var $ifbub = parcelRequire("ifbub");
var $4c38295599b865d4$var$inspectCustom = $ifbub.custom;
var $4c38295599b865d4$var$inspectSymbol = $4c38295599b865d4$var$isSymbol($4c38295599b865d4$var$inspectCustom) ? $4c38295599b865d4$var$inspectCustom : null;
var $4c38295599b865d4$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $4c38295599b865d4$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($4c38295599b865d4$var$has(opts, 'quoteStyle') && !$4c38295599b865d4$var$has($4c38295599b865d4$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($4c38295599b865d4$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $4c38295599b865d4$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($4c38295599b865d4$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($4c38295599b865d4$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $4c38295599b865d4$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $4c38295599b865d4$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $4c38295599b865d4$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $4c38295599b865d4$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $4c38295599b865d4$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($4c38295599b865d4$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $4c38295599b865d4$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($4c38295599b865d4$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$4c38295599b865d4$var$isRegExp(obj)) {
        var name = $4c38295599b865d4$var$nameOf(obj);
        var keys = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $4c38295599b865d4$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($4c38295599b865d4$var$isSymbol(obj)) {
        var symString = $4c38295599b865d4$var$hasShammedSymbols ? $4c38295599b865d4$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $4c38295599b865d4$var$symToString.call(obj);
        return typeof obj === 'object' && !$4c38295599b865d4$var$hasShammedSymbols ? $4c38295599b865d4$var$markBoxed(symString) : symString;
    }
    if ($4c38295599b865d4$var$isElement(obj)) {
        var s = '<' + $4c38295599b865d4$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $4c38295599b865d4$var$wrapQuotes($4c38295599b865d4$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $4c38295599b865d4$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($4c38295599b865d4$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        if (indent && !$4c38295599b865d4$var$singleLineValues(xs)) return '[' + $4c38295599b865d4$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $4c38295599b865d4$var$$join.call(xs, ', ') + ' ]';
    }
    if ($4c38295599b865d4$var$isError(obj)) {
        var parts = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$4c38295599b865d4$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $4c38295599b865d4$var$$join.call($4c38295599b865d4$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $4c38295599b865d4$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($4c38295599b865d4$var$inspectSymbol && typeof obj[$4c38295599b865d4$var$inspectSymbol] === 'function' && $ifbub) return $ifbub(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($4c38295599b865d4$var$isMap(obj)) {
        var mapParts = [];
        if ($4c38295599b865d4$var$mapForEach) $4c38295599b865d4$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $4c38295599b865d4$var$collectionOf('Map', $4c38295599b865d4$var$mapSize.call(obj), mapParts, indent);
    }
    if ($4c38295599b865d4$var$isSet(obj)) {
        var setParts = [];
        if ($4c38295599b865d4$var$setForEach) $4c38295599b865d4$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $4c38295599b865d4$var$collectionOf('Set', $4c38295599b865d4$var$setSize.call(obj), setParts, indent);
    }
    if ($4c38295599b865d4$var$isWeakMap(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakMap');
    if ($4c38295599b865d4$var$isWeakSet(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakSet');
    if ($4c38295599b865d4$var$isWeakRef(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakRef');
    if ($4c38295599b865d4$var$isNumber(obj)) return $4c38295599b865d4$var$markBoxed(inspect(Number(obj)));
    if ($4c38295599b865d4$var$isBigInt(obj)) return $4c38295599b865d4$var$markBoxed(inspect($4c38295599b865d4$var$bigIntValueOf.call(obj)));
    if ($4c38295599b865d4$var$isBoolean(obj)) return $4c38295599b865d4$var$markBoxed($4c38295599b865d4$var$booleanValueOf.call(obj));
    if ($4c38295599b865d4$var$isString(obj)) return $4c38295599b865d4$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$4c38295599b865d4$var$isDate(obj) && !$4c38295599b865d4$var$isRegExp(obj)) {
        var ys = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        var isPlainObject = $4c38295599b865d4$var$gPO ? $4c38295599b865d4$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $4c38295599b865d4$var$toStringTag && Object(obj) === obj && $4c38295599b865d4$var$toStringTag in obj ? $4c38295599b865d4$var$$slice.call($4c38295599b865d4$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $4c38295599b865d4$var$$join.call($4c38295599b865d4$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $4c38295599b865d4$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $4c38295599b865d4$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $4c38295599b865d4$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $4c38295599b865d4$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $4c38295599b865d4$var$quote(s) {
    return $4c38295599b865d4$var$$replace.call(String(s), /"/g, '&quot;');
}
function $4c38295599b865d4$var$canTrustToString(obj) {
    return !$4c38295599b865d4$var$toStringTag || !(typeof obj === 'object' && ($4c38295599b865d4$var$toStringTag in obj || typeof obj[$4c38295599b865d4$var$toStringTag] !== 'undefined'));
}
function $4c38295599b865d4$var$isArray(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Array]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isDate(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Date]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isRegExp(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object RegExp]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isError(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Error]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isString(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object String]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isNumber(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Number]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isBoolean(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Boolean]' && $4c38295599b865d4$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $4c38295599b865d4$var$isSymbol(obj) {
    if ($4c38295599b865d4$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$4c38295599b865d4$var$symToString) return false;
    try {
        $4c38295599b865d4$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$4c38295599b865d4$var$bigIntValueOf) return false;
    try {
        $4c38295599b865d4$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $4c38295599b865d4$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $4c38295599b865d4$var$has(obj, key) {
    return $4c38295599b865d4$var$hasOwn.call(obj, key);
}
function $4c38295599b865d4$var$toStr(obj) {
    return $4c38295599b865d4$var$objectToString.call(obj);
}
function $4c38295599b865d4$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $4c38295599b865d4$var$$match.call($4c38295599b865d4$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $4c38295599b865d4$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $4c38295599b865d4$var$isMap(x) {
    if (!$4c38295599b865d4$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$mapSize.call(x);
        try {
            $4c38295599b865d4$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakMap(x) {
    if (!$4c38295599b865d4$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakMapHas.call(x, $4c38295599b865d4$var$weakMapHas);
        try {
            $4c38295599b865d4$var$weakSetHas.call(x, $4c38295599b865d4$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakRef(x) {
    if (!$4c38295599b865d4$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isSet(x) {
    if (!$4c38295599b865d4$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$setSize.call(x);
        try {
            $4c38295599b865d4$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakSet(x) {
    if (!$4c38295599b865d4$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakSetHas.call(x, $4c38295599b865d4$var$weakSetHas);
        try {
            $4c38295599b865d4$var$weakMapHas.call(x, $4c38295599b865d4$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $4c38295599b865d4$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $4c38295599b865d4$var$inspectString($4c38295599b865d4$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $4c38295599b865d4$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $4c38295599b865d4$var$$replace.call($4c38295599b865d4$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $4c38295599b865d4$var$lowbyte);
    return $4c38295599b865d4$var$wrapQuotes(s, 'single', opts);
}
function $4c38295599b865d4$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $4c38295599b865d4$var$$toUpperCase.call(n.toString(16));
}
function $4c38295599b865d4$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $4c38295599b865d4$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $4c38295599b865d4$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $4c38295599b865d4$var$indentedJoin(entries, indent) : $4c38295599b865d4$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $4c38295599b865d4$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($4c38295599b865d4$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $4c38295599b865d4$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $4c38295599b865d4$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $4c38295599b865d4$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $4c38295599b865d4$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $4c38295599b865d4$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $4c38295599b865d4$var$arrObjKeys(obj, inspect) {
    var isArr = $4c38295599b865d4$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $4c38295599b865d4$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $4c38295599b865d4$var$gOPS === 'function' ? $4c38295599b865d4$var$gOPS(obj) : [];
    var symMap;
    if ($4c38295599b865d4$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$4c38295599b865d4$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($4c38295599b865d4$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($4c38295599b865d4$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $4c38295599b865d4$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($4c38295599b865d4$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("ifbub", function(module, exports) {
"use strict";

});


parcelRegister("8zbyi", function(module, exports) {
'use strict';

var $6xIgw = parcelRequire("6xIgw");

var $5Xz8R = parcelRequire("5Xz8R");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $63ca8da40d4c4dfe$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $63ca8da40d4c4dfe$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $63ca8da40d4c4dfe$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $63ca8da40d4c4dfe$var$listSet = function(objects, key, value) {
    var node = $63ca8da40d4c4dfe$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $63ca8da40d4c4dfe$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$63ca8da40d4c4dfe$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $63ca8da40d4c4dfe$var$listDelete = function(objects, key) {
    if (objects) return $63ca8da40d4c4dfe$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $5Xz8R('Side channel does not contain ' + $6xIgw(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $63ca8da40d4c4dfe$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $63ca8da40d4c4dfe$var$listGet($o, key);
        },
        has: function(key) {
            return $63ca8da40d4c4dfe$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $63ca8da40d4c4dfe$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("auXV2", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $eC3A3 = parcelRequire("eC3A3");

var $6xIgw = parcelRequire("6xIgw");

var $5Xz8R = parcelRequire("5Xz8R");
var $7a4b2f671249ac2e$var$$Map = $hkNzn('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $7a4b2f671249ac2e$var$$mapGet = $eC3A3('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $7a4b2f671249ac2e$var$$mapSet = $eC3A3('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7a4b2f671249ac2e$var$$mapHas = $eC3A3('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7a4b2f671249ac2e$var$$mapDelete = $eC3A3('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $7a4b2f671249ac2e$var$$mapSize = $eC3A3('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$7a4b2f671249ac2e$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $5Xz8R('Side channel does not contain ' + $6xIgw(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $7a4b2f671249ac2e$var$$mapDelete($m, key);
                if ($7a4b2f671249ac2e$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $7a4b2f671249ac2e$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $7a4b2f671249ac2e$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $7a4b2f671249ac2e$var$$Map();
            $7a4b2f671249ac2e$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("hkNzn", function(module, exports) {
'use strict';
var $c9eac16840c8f75d$var$undefined1;

var $aEzGq = parcelRequire("aEzGq");

var $6xoeI = parcelRequire("6xoeI");

var $SKRnU = parcelRequire("SKRnU");

var $6iFy7 = parcelRequire("6iFy7");

var $j0Ert = parcelRequire("j0Ert");

var $bw8YX = parcelRequire("bw8YX");

var $5Xz8R = parcelRequire("5Xz8R");

var $62IVw = parcelRequire("62IVw");

var $iuXCA = parcelRequire("iuXCA");

var $57uf1 = parcelRequire("57uf1");

var $8KJjU = parcelRequire("8KJjU");

var $cmoNf = parcelRequire("cmoNf");

var $eaKh2 = parcelRequire("eaKh2");

var $13WPP = parcelRequire("13WPP");

var $g26DA = parcelRequire("g26DA");
var $c9eac16840c8f75d$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $c9eac16840c8f75d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c9eac16840c8f75d$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $gNKV7 = parcelRequire("gNKV7");

var $bKXTU = parcelRequire("bKXTU");
var $c9eac16840c8f75d$var$throwTypeError = function() {
    throw new $5Xz8R();
};
var $c9eac16840c8f75d$var$ThrowTypeError = $gNKV7 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c9eac16840c8f75d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gNKV7(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $c9eac16840c8f75d$var$throwTypeError;
        }
    }
}() : $c9eac16840c8f75d$var$throwTypeError;

var $c9eac16840c8f75d$var$hasSymbols = (parcelRequire("4qQ7b"))();

var $b7uaR = parcelRequire("b7uaR");

var $4kTCn = parcelRequire("4kTCn");

var $1Gomj = parcelRequire("1Gomj");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");
var $c9eac16840c8f75d$var$needsEval = {};
var $c9eac16840c8f75d$var$TypedArray = typeof Uint8Array === 'undefined' || !$b7uaR ? undefined : $b7uaR(Uint8Array);
var $c9eac16840c8f75d$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGenerator%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncIteratorPrototype%': $c9eac16840c8f75d$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6xoeI,
    '%eval%': eval,
    '%EvalError%': $SKRnU,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $c9eac16840c8f75d$var$$Function,
    '%GeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR($b7uaR([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $aEzGq,
    '%Object.getOwnPropertyDescriptor%': $gNKV7,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6iFy7,
    '%ReferenceError%': $j0Ert,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $c9eac16840c8f75d$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $bw8YX,
    '%ThrowTypeError%': $c9eac16840c8f75d$var$ThrowTypeError,
    '%TypedArray%': $c9eac16840c8f75d$var$TypedArray,
    '%TypeError%': $5Xz8R,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $62IVw,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $bSEx1,
    '%Function.prototype.apply%': $aYzei,
    '%Object.defineProperty%': $bKXTU,
    '%Object.getPrototypeOf%': $4kTCn,
    '%Math.abs%': $iuXCA,
    '%Math.floor%': $57uf1,
    '%Math.max%': $8KJjU,
    '%Math.min%': $cmoNf,
    '%Math.pow%': $eaKh2,
    '%Math.round%': $13WPP,
    '%Math.sign%': $g26DA,
    '%Reflect.getPrototypeOf%': $1Gomj
};
if ($b7uaR) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c9eac16840c8f75d$var$errorProto = $b7uaR($b7uaR(e));
    $c9eac16840c8f75d$var$INTRINSICS['%Error.prototype%'] = $c9eac16840c8f75d$var$errorProto;
}
var $c9eac16840c8f75d$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $b7uaR) value = $b7uaR(gen.prototype);
    }
    $c9eac16840c8f75d$var$INTRINSICS[name] = value;
    return value;
};
var $c9eac16840c8f75d$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $eQ7C3 = parcelRequire("eQ7C3");

var $8byr2 = parcelRequire("8byr2");
var $c9eac16840c8f75d$var$$concat = $eQ7C3.call($bSEx1, Array.prototype.concat);
var $c9eac16840c8f75d$var$$spliceApply = $eQ7C3.call($aYzei, Array.prototype.splice);
var $c9eac16840c8f75d$var$$replace = $eQ7C3.call($bSEx1, String.prototype.replace);
var $c9eac16840c8f75d$var$$strSlice = $eQ7C3.call($bSEx1, String.prototype.slice);
var $c9eac16840c8f75d$var$$exec = $eQ7C3.call($bSEx1, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c9eac16840c8f75d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c9eac16840c8f75d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c9eac16840c8f75d$var$stringToPath = function stringToPath(string) {
    var first = $c9eac16840c8f75d$var$$strSlice(string, 0, 1);
    var last = $c9eac16840c8f75d$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $bw8YX('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $bw8YX('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $c9eac16840c8f75d$var$$replace(string, $c9eac16840c8f75d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c9eac16840c8f75d$var$$replace(subString, $c9eac16840c8f75d$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $c9eac16840c8f75d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8byr2($c9eac16840c8f75d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c9eac16840c8f75d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicName)) {
        var value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicName];
        if (value === $c9eac16840c8f75d$var$needsEval) value = $c9eac16840c8f75d$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $5Xz8R('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bw8YX('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $5Xz8R('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $5Xz8R('"allowMissing" argument must be a boolean');
    if ($c9eac16840c8f75d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $bw8YX('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $c9eac16840c8f75d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $c9eac16840c8f75d$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c9eac16840c8f75d$var$$spliceApply(parts, $c9eac16840c8f75d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c9eac16840c8f75d$var$$strSlice(part, 0, 1);
        var last = $c9eac16840c8f75d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $bw8YX('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicRealName)) value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $5Xz8R('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gNKV7 && i + 1 >= parts.length) {
                var desc = $gNKV7(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8byr2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aEzGq", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("6xoeI", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("SKRnU", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("6iFy7", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("j0Ert", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("bw8YX", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("62IVw", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("iuXCA", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("57uf1", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("8KJjU", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("cmoNf", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("eaKh2", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("13WPP", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("g26DA", function(module, exports) {
'use strict';

var $8hbPu = parcelRequire("8hbPu");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($8hbPu(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("8hbPu", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("gNKV7", function(module, exports) {
'use strict';

var $87tme = parcelRequire("87tme");
var $c3b59e512f612c17$require$$gOPD = $87tme;
if ($c3b59e512f612c17$require$$gOPD) try {
    $c3b59e512f612c17$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c3b59e512f612c17$require$$gOPD = null;
}
module.exports = $c3b59e512f612c17$require$$gOPD;

});
parcelRegister("87tme", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("bKXTU", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $88f2749ea03868eb$var$$defineProperty = Object.defineProperty || false;
if ($88f2749ea03868eb$var$$defineProperty) try {
    $88f2749ea03868eb$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $88f2749ea03868eb$var$$defineProperty = false;
}
module.exports = $88f2749ea03868eb$var$$defineProperty;

});

parcelRegister("4qQ7b", function(module, exports) {
'use strict';
var $33a204135f6b8445$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $33a204135f6b8445$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $33a204135f6b8445$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $f2BFz();
};

});
parcelRegister("f2BFz", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("b7uaR", function(module, exports) {
'use strict';

var $1Gomj = parcelRequire("1Gomj");

var $4kTCn = parcelRequire("4kTCn");

var $2mxVo = parcelRequire("2mxVo");
/** @type {import('.')} */ module.exports = $1Gomj ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1Gomj(O);
} : $4kTCn ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4kTCn(O);
} : $2mxVo ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $2mxVo(O);
} : null;

});
parcelRegister("1Gomj", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("4kTCn", function(module, exports) {
'use strict';

var $aEzGq = parcelRequire("aEzGq");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $aEzGq.getPrototypeOf || null;

});

parcelRegister("2mxVo", function(module, exports) {
'use strict';

var $593ev = parcelRequire("593ev");

var $gNKV7 = parcelRequire("gNKV7");
var $1b87f3939656d8ea$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $1b87f3939656d8ea$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $1b87f3939656d8ea$var$desc = !!$1b87f3939656d8ea$var$hasProtoAccessor && $gNKV7 && $gNKV7(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $1b87f3939656d8ea$var$$Object = Object;
var $1b87f3939656d8ea$var$$getPrototypeOf = $1b87f3939656d8ea$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $1b87f3939656d8ea$var$desc && typeof $1b87f3939656d8ea$var$desc.get === 'function' ? $593ev([
    $1b87f3939656d8ea$var$desc.get
]) : typeof $1b87f3939656d8ea$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $1b87f3939656d8ea$var$$getPrototypeOf(value == null ? value : $1b87f3939656d8ea$var$$Object(value));
} : false;

});
parcelRegister("593ev", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $5Xz8R = parcelRequire("5Xz8R");

var $bSEx1 = parcelRequire("bSEx1");

var $04tsO = parcelRequire("04tsO");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $5Xz8R('a function is required');
    return $04tsO($eQ7C3, $bSEx1, args);
};

});
parcelRegister("eQ7C3", function(module, exports) {
'use strict';

var $gfKZG = parcelRequire("gfKZG");
module.exports = Function.prototype.bind || $gfKZG;

});
parcelRegister("gfKZG", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $bd52800b6fae4c57$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $bd52800b6fae4c57$var$toStr = Object.prototype.toString;
var $bd52800b6fae4c57$var$max = Math.max;
var $bd52800b6fae4c57$var$funcType = '[object Function]';
var $bd52800b6fae4c57$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bd52800b6fae4c57$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bd52800b6fae4c57$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $bd52800b6fae4c57$var$toStr.apply(target) !== $bd52800b6fae4c57$var$funcType) throw new TypeError($bd52800b6fae4c57$var$ERROR_MESSAGE + target);
    var args = $bd52800b6fae4c57$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bd52800b6fae4c57$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bd52800b6fae4c57$var$concatty(args, arguments));
    };
    var boundLength = $bd52800b6fae4c57$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $bd52800b6fae4c57$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("bSEx1", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("04tsO", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");

var $fYjQh = parcelRequire("fYjQh");
/** @type {import('./actualApply')} */ module.exports = $fYjQh || $eQ7C3.call($bSEx1, $aYzei);

});
parcelRegister("aYzei", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("fYjQh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("8byr2", function(module, exports) {
'use strict';
var $5f5a0fe320c1ef2a$var$call = Function.prototype.call;
var $5f5a0fe320c1ef2a$var$$hasOwn = Object.prototype.hasOwnProperty;

var $eQ7C3 = parcelRequire("eQ7C3");
/** @type {import('.')} */ module.exports = $eQ7C3.call($5f5a0fe320c1ef2a$var$call, $5f5a0fe320c1ef2a$var$$hasOwn);

});


parcelRegister("eC3A3", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $593ev = parcelRequire("593ev");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $aa3764525413497a$var$$indexOf = $593ev([
    $hkNzn('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $hkNzn(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $aa3764525413497a$var$$indexOf(name, '.prototype.') > -1) return $593ev(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("2nyui", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $eC3A3 = parcelRequire("eC3A3");

var $6xIgw = parcelRequire("6xIgw");

var $auXV2 = parcelRequire("auXV2");

var $5Xz8R = parcelRequire("5Xz8R");
var $1bb87b485acc2d8c$var$$WeakMap = $hkNzn('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $1bb87b485acc2d8c$var$$weakMapGet = $eC3A3('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $1bb87b485acc2d8c$var$$weakMapSet = $eC3A3('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $1bb87b485acc2d8c$var$$weakMapHas = $eC3A3('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $1bb87b485acc2d8c$var$$weakMapDelete = $eC3A3('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $1bb87b485acc2d8c$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $5Xz8R('Side channel does not contain ' + $6xIgw(key));
        },
        'delete': function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapDelete($wm, key);
            } else if ($auXV2) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $1bb87b485acc2d8c$var$$WeakMap();
                $1bb87b485acc2d8c$var$$weakMapSet($wm, key, value);
            } else if ($auXV2) {
                if (!$m) $m = $auXV2();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $auXV2;

});


parcelRegister("2mSnl", function(module, exports) {
'use strict';

var $br3n2 = parcelRequire("br3n2");
var $1b97d0b055bc5f8c$var$has = Object.prototype.hasOwnProperty;
var $1b97d0b055bc5f8c$var$isArray = Array.isArray;
var $1b97d0b055bc5f8c$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $1b97d0b055bc5f8c$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($1b97d0b055bc5f8c$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $1b97d0b055bc5f8c$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $1b97d0b055bc5f8c$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($1b97d0b055bc5f8c$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$1b97d0b055bc5f8c$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($1b97d0b055bc5f8c$var$isArray(target) && !$1b97d0b055bc5f8c$var$isArray(source)) mergeTarget = $1b97d0b055bc5f8c$var$arrayToObject(target, options);
    if ($1b97d0b055bc5f8c$var$isArray(target) && $1b97d0b055bc5f8c$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($1b97d0b055bc5f8c$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($1b97d0b055bc5f8c$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $1b97d0b055bc5f8c$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $1b97d0b055bc5f8c$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $1b97d0b055bc5f8c$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $1b97d0b055bc5f8c$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $1b97d0b055bc5f8c$var$limit){
        var segment = string.length >= $1b97d0b055bc5f8c$var$limit ? string.slice(j, j + $1b97d0b055bc5f8c$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $br3n2.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xC0 | c >> 6] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xE0 | c >> 12] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 6 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xF0 | c >> 18] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 12 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 6 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $1b97d0b055bc5f8c$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $1b97d0b055bc5f8c$var$compactQueue(queue);
    return value;
};
var $1b97d0b055bc5f8c$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $1b97d0b055bc5f8c$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $1b97d0b055bc5f8c$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $1b97d0b055bc5f8c$var$maybeMap = function maybeMap(val, fn) {
    if ($1b97d0b055bc5f8c$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $1b97d0b055bc5f8c$var$arrayToObject,
    assign: $1b97d0b055bc5f8c$var$assign,
    combine: $1b97d0b055bc5f8c$var$combine,
    compact: $1b97d0b055bc5f8c$var$compact,
    decode: $1b97d0b055bc5f8c$var$decode,
    encode: $1b97d0b055bc5f8c$var$encode,
    isBuffer: $1b97d0b055bc5f8c$var$isBuffer,
    isRegExp: $1b97d0b055bc5f8c$var$isRegExp,
    maybeMap: $1b97d0b055bc5f8c$var$maybeMap,
    merge: $1b97d0b055bc5f8c$var$merge
};

});
parcelRegister("br3n2", function(module, exports) {
'use strict';
var $8534d4a11448cf7e$var$replace = String.prototype.replace;
var $8534d4a11448cf7e$var$percentTwenties = /%20/g;
var $8534d4a11448cf7e$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $8534d4a11448cf7e$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $8534d4a11448cf7e$var$replace.call(value, $8534d4a11448cf7e$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $8534d4a11448cf7e$var$Format.RFC1738,
    RFC3986: $8534d4a11448cf7e$var$Format.RFC3986
};

});



parcelRegister("4iVSP", function(module, exports) {
'use strict';

var $2mSnl = parcelRequire("2mSnl");
var $3225be4cdfe13ac3$var$has = Object.prototype.hasOwnProperty;
var $3225be4cdfe13ac3$var$isArray = Array.isArray;
var $3225be4cdfe13ac3$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $2mSnl.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $3225be4cdfe13ac3$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $3225be4cdfe13ac3$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $3225be4cdfe13ac3$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $3225be4cdfe13ac3$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $3225be4cdfe13ac3$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $3225be4cdfe13ac3$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $3225be4cdfe13ac3$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $3225be4cdfe13ac3$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $3225be4cdfe13ac3$var$defaults.decoder, charset, 'key');
            val = $2mSnl.maybeMap($3225be4cdfe13ac3$var$parseArrayValue(part.slice(pos + 1), options, $3225be4cdfe13ac3$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $3225be4cdfe13ac3$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $3225be4cdfe13ac3$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $3225be4cdfe13ac3$var$isArray(val) ? [
            val
        ] : val;
        var existing = $3225be4cdfe13ac3$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $2mSnl.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $3225be4cdfe13ac3$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $3225be4cdfe13ac3$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $2mSnl.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $3225be4cdfe13ac3$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $3225be4cdfe13ac3$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $3225be4cdfe13ac3$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $3225be4cdfe13ac3$var$parseObject(keys, val, options, valuesParsed);
};
var $3225be4cdfe13ac3$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $3225be4cdfe13ac3$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $3225be4cdfe13ac3$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $3225be4cdfe13ac3$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $3225be4cdfe13ac3$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $3225be4cdfe13ac3$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $3225be4cdfe13ac3$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $3225be4cdfe13ac3$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $3225be4cdfe13ac3$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $3225be4cdfe13ac3$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $3225be4cdfe13ac3$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $3225be4cdfe13ac3$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $3225be4cdfe13ac3$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $2mSnl.isRegExp(opts.delimiter) ? opts.delimiter : $3225be4cdfe13ac3$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $3225be4cdfe13ac3$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $3225be4cdfe13ac3$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $3225be4cdfe13ac3$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $3225be4cdfe13ac3$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $3225be4cdfe13ac3$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $3225be4cdfe13ac3$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $3225be4cdfe13ac3$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $3225be4cdfe13ac3$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $3225be4cdfe13ac3$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $2mSnl.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $2mSnl.compact(obj);
};

});



parcelRegister("fRF8h", function(module, exports) {
'use strict';

var $fcCXC = parcelRequire("fcCXC");
/** @type ValidatorResult */ var $b8cbb6547bdcbcdd$var$ValidatorResult = $fcCXC.ValidatorResult;
/** @type SchemaError */ var $b8cbb6547bdcbcdd$var$SchemaError = $fcCXC.SchemaError;
var $b8cbb6547bdcbcdd$var$attribute = {};
$b8cbb6547bdcbcdd$var$attribute.ignoreProperties = {
    // informative properties
    'id': true,
    'default': true,
    'description': true,
    'title': true,
    // arguments to other properties
    'exclusiveMinimum': true,
    'exclusiveMaximum': true,
    'additionalItems': true,
    // special-handled properties
    '$schema': true,
    '$ref': true,
    'extends': true
};
/**
 * @name validators
 */ var $b8cbb6547bdcbcdd$var$validators = $b8cbb6547bdcbcdd$var$attribute.validators = {};
/**
 * Validates whether the instance if of a certain type
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */ $b8cbb6547bdcbcdd$var$validators.type = function validateType(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var types = Array.isArray(schema.type) ? schema.type : [
        schema.type
    ];
    if (!types.some(this.testType.bind(this, instance, schema, options, ctx))) {
        var list = types.map(function(v) {
            return v.id && '<' + v.id + '>' || v + '';
        });
        result.addError({
            name: 'type',
            argument: list,
            message: "is not of a type(s) " + list
        });
    }
    return result;
};
function $b8cbb6547bdcbcdd$var$testSchemaNoThrow(instance, options, ctx, callback, schema) {
    var throwError = options.throwError;
    options.throwError = false;
    var res = this.validateSchema(instance, schema, options, ctx);
    options.throwError = throwError;
    if (!res.valid && callback instanceof Function) callback(res);
    return res.valid;
}
/**
 * Validates whether the instance matches some of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */ $b8cbb6547bdcbcdd$var$validators.anyOf = function validateAnyOf(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var inner = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!Array.isArray(schema.anyOf)) throw new $b8cbb6547bdcbcdd$var$SchemaError("anyOf must be an array");
    if (!schema.anyOf.some($b8cbb6547bdcbcdd$var$testSchemaNoThrow.bind(this, instance, options, ctx, function(res) {
        inner.importErrors(res);
    }))) {
        var list = schema.anyOf.map(function(v, i) {
            return v.id && '<' + v.id + '>' || v.title && JSON.stringify(v.title) || v['$ref'] && '<' + v['$ref'] + '>' || '[subschema ' + i + ']';
        });
        if (options.nestedErrors) result.importErrors(inner);
        result.addError({
            name: 'anyOf',
            argument: list,
            message: "is not any of " + list.join(',')
        });
    }
    return result;
};
/**
 * Validates whether the instance matches every given schema
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.allOf = function validateAllOf(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    if (!Array.isArray(schema.allOf)) throw new $b8cbb6547bdcbcdd$var$SchemaError("allOf must be an array");
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var self = this;
    schema.allOf.forEach(function(v, i) {
        var valid = self.validateSchema(instance, v, options, ctx);
        if (!valid.valid) {
            var msg = v.id && '<' + v.id + '>' || v.title && JSON.stringify(v.title) || v['$ref'] && '<' + v['$ref'] + '>' || '[subschema ' + i + ']';
            result.addError({
                name: 'allOf',
                argument: {
                    id: msg,
                    length: valid.errors.length,
                    valid: valid
                },
                message: 'does not match allOf schema ' + msg + ' with ' + valid.errors.length + ' error[s]:'
            });
            result.importErrors(valid);
        }
    });
    return result;
};
/**
 * Validates whether the instance matches exactly one of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.oneOf = function validateOneOf(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    if (!Array.isArray(schema.oneOf)) throw new $b8cbb6547bdcbcdd$var$SchemaError("oneOf must be an array");
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var inner = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var count = schema.oneOf.filter($b8cbb6547bdcbcdd$var$testSchemaNoThrow.bind(this, instance, options, ctx, function(res) {
        inner.importErrors(res);
    })).length;
    var list = schema.oneOf.map(function(v, i) {
        return v.id && '<' + v.id + '>' || v.title && JSON.stringify(v.title) || v['$ref'] && '<' + v['$ref'] + '>' || '[subschema ' + i + ']';
    });
    if (count !== 1) {
        if (options.nestedErrors) result.importErrors(inner);
        result.addError({
            name: 'oneOf',
            argument: list,
            message: "is not exactly one from " + list.join(',')
        });
    }
    return result;
};
/**
 * Validates properties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $b8cbb6547bdcbcdd$var$validators.properties = function validateProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var properties = schema.properties || {};
    for(var property in properties){
        if (typeof options.preValidateProperty == 'function') options.preValidateProperty(instance, property, properties[property], options, ctx);
        var prop = Object.hasOwnProperty.call(instance, property) ? instance[property] : undefined;
        var res = this.validateSchema(prop, properties[property], options, ctx.makeChild(properties[property], property));
        if (res.instance !== result.instance[property]) result.instance[property] = res.instance;
        result.importErrors(res);
    }
    return result;
};
/**
 * Test a specific property within in instance against the additionalProperties schema attribute
 * This ignores properties with definitions in the properties schema attribute, but no other attributes.
 * If too many more types of property-existance tests pop up they may need their own class of tests (like `type` has)
 * @private
 * @return {boolean}
 */ function $b8cbb6547bdcbcdd$var$testAdditionalProperty(instance, schema, options, ctx, property, result) {
    if (!this.types.object(instance)) return;
    if (schema.properties && schema.properties[property] !== undefined) return;
    if (schema.additionalProperties === false) result.addError({
        name: 'additionalProperties',
        argument: property,
        message: "additionalProperty " + JSON.stringify(property) + " exists in instance when not allowed"
    });
    else {
        var additionalProperties = schema.additionalProperties || {};
        if (typeof options.preValidateProperty == 'function') options.preValidateProperty(instance, property, additionalProperties, options, ctx);
        var res = this.validateSchema(instance[property], additionalProperties, options, ctx.makeChild(additionalProperties, property));
        if (res.instance !== result.instance[property]) result.instance[property] = res.instance;
        result.importErrors(res);
    }
}
/**
 * Validates patternProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $b8cbb6547bdcbcdd$var$validators.patternProperties = function validatePatternProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var patternProperties = schema.patternProperties || {};
    for(var property in instance){
        var test = true;
        for(var pattern in patternProperties){
            var expr = new RegExp(pattern);
            if (!expr.test(property)) continue;
            test = false;
            if (typeof options.preValidateProperty == 'function') options.preValidateProperty(instance, property, patternProperties[pattern], options, ctx);
            var res = this.validateSchema(instance[property], patternProperties[pattern], options, ctx.makeChild(patternProperties[pattern], property));
            if (res.instance !== result.instance[property]) result.instance[property] = res.instance;
            result.importErrors(res);
        }
        if (test) $b8cbb6547bdcbcdd$var$testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
    }
    return result;
};
/**
 * Validates additionalProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $b8cbb6547bdcbcdd$var$validators.additionalProperties = function validateAdditionalProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    // if patternProperties is defined then we'll test when that one is called instead
    if (schema.patternProperties) return null;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    for(var property in instance)$b8cbb6547bdcbcdd$var$testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
    return result;
};
/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.minProperties = function validateMinProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var keys = Object.keys(instance);
    if (!(keys.length >= schema.minProperties)) result.addError({
        name: 'minProperties',
        argument: schema.minProperties,
        message: "does not meet minimum property length of " + schema.minProperties
    });
    return result;
};
/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.maxProperties = function validateMaxProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var keys = Object.keys(instance);
    if (!(keys.length <= schema.maxProperties)) result.addError({
        name: 'maxProperties',
        argument: schema.maxProperties,
        message: "does not meet maximum property length of " + schema.maxProperties
    });
    return result;
};
/**
 * Validates items when instance is an array
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $b8cbb6547bdcbcdd$var$validators.items = function validateItems(instance, schema, options, ctx) {
    var self = this;
    if (!this.types.array(instance)) return;
    if (!schema.items) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    instance.every(function(value, i) {
        var items = Array.isArray(schema.items) ? schema.items[i] || schema.additionalItems : schema.items;
        if (items === undefined) return true;
        if (items === false) {
            result.addError({
                name: 'items',
                message: "additionalItems not permitted"
            });
            return false;
        }
        var res = self.validateSchema(value, items, options, ctx.makeChild(items, i));
        if (res.instance !== result.instance[i]) result.instance[i] = res.instance;
        result.importErrors(res);
        return true;
    });
    return result;
};
/**
 * Validates minimum and exclusiveMinimum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.minimum = function validateMinimum(instance, schema, options, ctx) {
    if (!this.types.number(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var valid = true;
    if (schema.exclusiveMinimum && schema.exclusiveMinimum === true) valid = instance > schema.minimum;
    else valid = instance >= schema.minimum;
    if (!valid) result.addError({
        name: 'minimum',
        argument: schema.minimum,
        message: "must have a minimum value of " + schema.minimum
    });
    return result;
};
/**
 * Validates maximum and exclusiveMaximum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.maximum = function validateMaximum(instance, schema, options, ctx) {
    if (!this.types.number(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var valid;
    if (schema.exclusiveMaximum && schema.exclusiveMaximum === true) valid = instance < schema.maximum;
    else valid = instance <= schema.maximum;
    if (!valid) result.addError({
        name: 'maximum',
        argument: schema.maximum,
        message: "must have a maximum value of " + schema.maximum
    });
    return result;
};
/**
 * Perform validation for multipleOf and divisibleBy, which are essentially the same.
 * @param instance
 * @param schema
 * @param validationType
 * @param errorMessage
 * @returns {String|null}
 */ var $b8cbb6547bdcbcdd$var$validateMultipleOfOrDivisbleBy = function validateMultipleOfOrDivisbleBy(instance, schema, options, ctx, validationType, errorMessage) {
    if (!this.types.number(instance)) return;
    var validationArgument = schema[validationType];
    if (validationArgument == 0) throw new $b8cbb6547bdcbcdd$var$SchemaError(validationType + " cannot be zero");
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var instanceDecimals = $fcCXC.getDecimalPlaces(instance);
    var divisorDecimals = $fcCXC.getDecimalPlaces(validationArgument);
    var maxDecimals = Math.max(instanceDecimals, divisorDecimals);
    var multiplier = Math.pow(10, maxDecimals);
    if (Math.round(instance * multiplier) % Math.round(validationArgument * multiplier) !== 0) result.addError({
        name: validationType,
        argument: validationArgument,
        message: errorMessage + JSON.stringify(validationArgument)
    });
    return result;
};
/**
 * Validates divisibleBy when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.multipleOf = function validateMultipleOf(instance, schema, options, ctx) {
    return $b8cbb6547bdcbcdd$var$validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "multipleOf", "is not a multiple of (divisible by) ");
};
/**
 * Validates multipleOf when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.divisibleBy = function validateDivisibleBy(instance, schema, options, ctx) {
    return $b8cbb6547bdcbcdd$var$validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "divisibleBy", "is not divisible by (multiple of) ");
};
/**
 * Validates whether the instance value is present.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.required = function validateRequired(instance, schema, options, ctx) {
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (instance === undefined && schema.required === true) // A boolean form is implemented for reverse-compatability with schemas written against older drafts
    result.addError({
        name: 'required',
        message: "is required"
    });
    else if (this.types.object(instance) && Array.isArray(schema.required)) schema.required.forEach(function(n) {
        if (instance[n] === undefined) result.addError({
            name: 'required',
            argument: n,
            message: "requires property " + JSON.stringify(n)
        });
    });
    return result;
};
/**
 * Validates whether the instance value matches the regular expression, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.pattern = function validatePattern(instance, schema, options, ctx) {
    if (!this.types.string(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!instance.match(schema.pattern)) result.addError({
        name: 'pattern',
        argument: schema.pattern,
        message: "does not match pattern " + JSON.stringify(schema.pattern)
    });
    return result;
};
/**
 * Validates whether the instance value is of a certain defined format or a custom
 * format.
 * The following formats are supported for string types:
 *   - date-time
 *   - date
 *   - time
 *   - ip-address
 *   - ipv6
 *   - uri
 *   - color
 *   - host-name
 *   - alpha
 *   - alpha-numeric
 *   - utc-millisec
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.format = function validateFormat(instance, schema, options, ctx) {
    if (instance === undefined) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!result.disableFormat && !$fcCXC.isFormat(instance, schema.format, this)) result.addError({
        name: 'format',
        argument: schema.format,
        message: "does not conform to the " + JSON.stringify(schema.format) + " format"
    });
    return result;
};
/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.minLength = function validateMinLength(instance, schema, options, ctx) {
    if (!this.types.string(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var hsp = instance.match(/[\uDC00-\uDFFF]/g);
    var length = instance.length - (hsp ? hsp.length : 0);
    if (!(length >= schema.minLength)) result.addError({
        name: 'minLength',
        argument: schema.minLength,
        message: "does not meet minimum length of " + schema.minLength
    });
    return result;
};
/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.maxLength = function validateMaxLength(instance, schema, options, ctx) {
    if (!this.types.string(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    // TODO if this was already computed in "minLength", use that value instead of re-computing
    var hsp = instance.match(/[\uDC00-\uDFFF]/g);
    var length = instance.length - (hsp ? hsp.length : 0);
    if (!(length <= schema.maxLength)) result.addError({
        name: 'maxLength',
        argument: schema.maxLength,
        message: "does not meet maximum length of " + schema.maxLength
    });
    return result;
};
/**
 * Validates whether instance contains at least a minimum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.minItems = function validateMinItems(instance, schema, options, ctx) {
    if (!this.types.array(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!(instance.length >= schema.minItems)) result.addError({
        name: 'minItems',
        argument: schema.minItems,
        message: "does not meet minimum length of " + schema.minItems
    });
    return result;
};
/**
 * Validates whether instance contains no more than a maximum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.maxItems = function validateMaxItems(instance, schema, options, ctx) {
    if (!this.types.array(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!(instance.length <= schema.maxItems)) result.addError({
        name: 'maxItems',
        argument: schema.maxItems,
        message: "does not meet maximum length of " + schema.maxItems
    });
    return result;
};
/**
 * Validates that every item in an instance array is unique, when instance is an array
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $b8cbb6547bdcbcdd$var$validators.uniqueItems = function validateUniqueItems(instance, schema, options, ctx) {
    if (!this.types.array(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    function testArrays(v, i, a) {
        for(var j = i + 1; j < a.length; j++)if ($fcCXC.deepCompareStrict(v, a[j])) return false;
        return true;
    }
    if (!instance.every(testArrays)) result.addError({
        name: 'uniqueItems',
        message: "contains duplicate item"
    });
    return result;
};
/**
 * Deep compares arrays for duplicates
 * @param v
 * @param i
 * @param a
 * @private
 * @return {boolean}
 */ function $b8cbb6547bdcbcdd$var$testArrays(v, i, a) {
    var j, len = a.length;
    for(j = i + 1, len; j < len; j++){
        if ($fcCXC.deepCompareStrict(v, a[j])) return false;
    }
    return true;
}
/**
 * Validates whether there are no duplicates, when the instance is an Array.
 * @param instance
 * @return {String|null}
 */ $b8cbb6547bdcbcdd$var$validators.uniqueItems = function validateUniqueItems(instance, schema, options, ctx) {
    if (!this.types.array(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!instance.every($b8cbb6547bdcbcdd$var$testArrays)) result.addError({
        name: 'uniqueItems',
        message: "contains duplicate item"
    });
    return result;
};
/**
 * Validate for the presence of dependency properties, if the instance is an object.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */ $b8cbb6547bdcbcdd$var$validators.dependencies = function validateDependencies(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    for(var property in schema.dependencies){
        if (instance[property] === undefined) continue;
        var dep = schema.dependencies[property];
        var childContext = ctx.makeChild(dep, property);
        if (typeof dep == 'string') dep = [
            dep
        ];
        if (Array.isArray(dep)) dep.forEach(function(prop) {
            if (instance[prop] === undefined) result.addError({
                // FIXME there's two different "dependencies" errors here with slightly different outputs
                // Can we make these the same? Or should we create different error types?
                name: 'dependencies',
                argument: childContext.propertyPath,
                message: "property " + prop + " not found, required by " + childContext.propertyPath
            });
        });
        else {
            var res = this.validateSchema(instance, dep, options, childContext);
            if (result.instance !== res.instance) result.instance = res.instance;
            if (res && res.errors.length) {
                result.addError({
                    name: 'dependencies',
                    argument: childContext.propertyPath,
                    message: "does not meet dependency required by " + childContext.propertyPath
                });
                result.importErrors(res);
            }
        }
    }
    return result;
};
/**
 * Validates whether the instance value is one of the enumerated values.
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */ $b8cbb6547bdcbcdd$var$validators['enum'] = function validateEnum(instance, schema, options, ctx) {
    if (instance === undefined) return null;
    if (!Array.isArray(schema['enum'])) throw new $b8cbb6547bdcbcdd$var$SchemaError("enum expects an array", schema);
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!schema['enum'].some($fcCXC.deepCompareStrict.bind(null, instance))) result.addError({
        name: 'enum',
        argument: schema['enum'],
        message: "is not one of enum values: " + schema['enum'].map(String).join(',')
    });
    return result;
};
/**
 * Validates whether the instance exactly matches a given value
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */ $b8cbb6547bdcbcdd$var$validators['const'] = function validateEnum(instance, schema, options, ctx) {
    if (instance === undefined) return null;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    if (!$fcCXC.deepCompareStrict(schema['const'], instance)) result.addError({
        name: 'const',
        argument: schema['const'],
        message: "does not exactly match expected constant: " + schema['const']
    });
    return result;
};
/**
 * Validates whether the instance if of a prohibited type.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */ $b8cbb6547bdcbcdd$var$validators.not = $b8cbb6547bdcbcdd$var$validators.disallow = function validateNot(instance, schema, options, ctx) {
    var self = this;
    if (instance === undefined) return null;
    var result = new $b8cbb6547bdcbcdd$var$ValidatorResult(instance, schema, options, ctx);
    var notTypes = schema.not || schema.disallow;
    if (!notTypes) return null;
    if (!Array.isArray(notTypes)) notTypes = [
        notTypes
    ];
    notTypes.forEach(function(type) {
        if (self.testType(instance, schema, options, ctx, type)) {
            var schemaId = type && type.id && '<' + type.id + '>' || type;
            result.addError({
                name: 'not',
                argument: schemaId,
                message: "is of prohibited type " + schemaId
            });
        }
    });
    return result;
};
module.exports = $b8cbb6547bdcbcdd$var$attribute;

});
parcelRegister("fcCXC", function(module, exports) {

$parcel$export(module.exports, "ValidationError", function () { return $b11632c8bee676c4$export$2191b9da168c6cf0; }, function (v) { return $b11632c8bee676c4$export$2191b9da168c6cf0 = v; });
$parcel$export(module.exports, "ValidatorResult", function () { return $b11632c8bee676c4$export$b0184c04dbb75cbd; }, function (v) { return $b11632c8bee676c4$export$b0184c04dbb75cbd = v; });
$parcel$export(module.exports, "SchemaError", function () { return $b11632c8bee676c4$export$44dde8d2b17fc96a; }, function (v) { return $b11632c8bee676c4$export$44dde8d2b17fc96a = v; });
$parcel$export(module.exports, "SchemaContext", function () { return $b11632c8bee676c4$export$77f26f02a668a7e2; }, function (v) { return $b11632c8bee676c4$export$77f26f02a668a7e2 = v; });
$parcel$export(module.exports, "isFormat", function () { return $b11632c8bee676c4$export$674374997fba8879; }, function (v) { return $b11632c8bee676c4$export$674374997fba8879 = v; });
$parcel$export(module.exports, "deepCompareStrict", function () { return $b11632c8bee676c4$export$f99d9bd271f9a30e; }, function (v) { return $b11632c8bee676c4$export$f99d9bd271f9a30e = v; });
$parcel$export(module.exports, "deepMerge", function () { return $b11632c8bee676c4$export$6969335ea1e4e77c; }, function (v) { return $b11632c8bee676c4$export$6969335ea1e4e77c = v; });
$parcel$export(module.exports, "objectGetPath", function () { return $b11632c8bee676c4$export$d03ab7c46c3a0e16; }, function (v) { return $b11632c8bee676c4$export$d03ab7c46c3a0e16 = v; });
$parcel$export(module.exports, "getDecimalPlaces", function () { return $b11632c8bee676c4$export$4c5662d18be49e92; }, function (v) { return $b11632c8bee676c4$export$4c5662d18be49e92 = v; });
var $b11632c8bee676c4$export$2191b9da168c6cf0;
var $b11632c8bee676c4$export$b0184c04dbb75cbd;
var $b11632c8bee676c4$export$44dde8d2b17fc96a;
var $b11632c8bee676c4$export$77f26f02a668a7e2;
var $b11632c8bee676c4$export$1d8c0144df69cb55;
var $b11632c8bee676c4$export$674374997fba8879;
var $b11632c8bee676c4$export$61f60bce4af13a93;
var $b11632c8bee676c4$export$f99d9bd271f9a30e;
var $b11632c8bee676c4$export$6969335ea1e4e77c;
/**
 * Validates instance against the provided schema
 * Implements URI+JSON Pointer encoding, e.g. "%7e"="~0"=>"~", "~1"="%2f"=>"/"
 * @param o
 * @param s The path to walk o along
 * @return any
 */ var $b11632c8bee676c4$export$d03ab7c46c3a0e16;
/**
 * Accept an Array of property names and return a JSON Pointer URI fragment
 * @param Array a
 * @return {String}
 */ var $b11632c8bee676c4$export$20c03ce31e68a433;
/**
 * Calculate the number of decimal places a number uses
 * We need this to get correct results out of multipleOf and divisibleBy
 * when either figure is has decimal places, due to IEEE-754 float issues.
 * @param number
 * @returns {number}
 */ var $b11632c8bee676c4$export$4c5662d18be49e92;
'use strict';

var $eAyj5 = parcelRequire("eAyj5");
var $b11632c8bee676c4$var$ValidationError = $b11632c8bee676c4$export$2191b9da168c6cf0 = function ValidationError(message, instance, schema, propertyPath, name, argument) {
    if (propertyPath) this.property = propertyPath;
    if (message) this.message = message;
    if (schema) {
        if (schema.id) this.schema = schema.id;
        else this.schema = schema;
    }
    if (instance) this.instance = instance;
    this.name = name;
    this.argument = argument;
    this.stack = this.toString();
};
$b11632c8bee676c4$var$ValidationError.prototype.toString = function toString() {
    return this.property + ' ' + this.message;
};
var $b11632c8bee676c4$var$ValidatorResult = $b11632c8bee676c4$export$b0184c04dbb75cbd = function ValidatorResult(instance, schema, options, ctx) {
    this.instance = instance;
    this.schema = schema;
    this.propertyPath = ctx.propertyPath;
    this.errors = [];
    this.throwError = options && options.throwError;
    this.disableFormat = options && options.disableFormat === true;
};
$b11632c8bee676c4$var$ValidatorResult.prototype.addError = function addError(detail) {
    var err;
    if (typeof detail == 'string') err = new $b11632c8bee676c4$var$ValidationError(detail, this.instance, this.schema, this.propertyPath);
    else {
        if (!detail) throw new Error('Missing error detail');
        if (!detail.message) throw new Error('Missing error message');
        if (!detail.name) throw new Error('Missing validator type');
        err = new $b11632c8bee676c4$var$ValidationError(detail.message, this.instance, this.schema, this.propertyPath, detail.name, detail.argument);
    }
    if (this.throwError) throw err;
    this.errors.push(err);
    return err;
};
$b11632c8bee676c4$var$ValidatorResult.prototype.importErrors = function importErrors(res) {
    if (typeof res == 'string' || res && res.validatorType) this.addError(res);
    else if (res && res.errors) Array.prototype.push.apply(this.errors, res.errors);
};
function $b11632c8bee676c4$var$stringizer(v, i) {
    return i + ': ' + v.toString() + '\n';
}
$b11632c8bee676c4$var$ValidatorResult.prototype.toString = function toString(res) {
    return this.errors.map($b11632c8bee676c4$var$stringizer).join('');
};
Object.defineProperty($b11632c8bee676c4$var$ValidatorResult.prototype, "valid", {
    get: function() {
        return !this.errors.length;
    }
});
/**
 * Describes a problem with a Schema which prevents validation of an instance
 * @name SchemaError
 * @constructor
 */ var $b11632c8bee676c4$var$SchemaError = $b11632c8bee676c4$export$44dde8d2b17fc96a = function SchemaError(msg, schema) {
    this.message = msg;
    this.schema = schema;
    Error.call(this, msg);
    Error.captureStackTrace(this, SchemaError);
};
$b11632c8bee676c4$var$SchemaError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $b11632c8bee676c4$var$SchemaError,
        enumerable: false
    },
    name: {
        value: 'SchemaError',
        enumerable: false
    }
});
var $b11632c8bee676c4$var$SchemaContext = $b11632c8bee676c4$export$77f26f02a668a7e2 = function SchemaContext(schema, options, propertyPath, base, schemas) {
    this.schema = schema;
    this.options = options;
    this.propertyPath = propertyPath;
    this.base = base;
    this.schemas = schemas;
};
$b11632c8bee676c4$var$SchemaContext.prototype.resolve = function resolve(target) {
    return $eAyj5.resolve(this.base, target);
};
$b11632c8bee676c4$var$SchemaContext.prototype.makeChild = function makeChild(schema, propertyName) {
    var propertyPath = propertyName === undefined ? this.propertyPath : this.propertyPath + $b11632c8bee676c4$var$makeSuffix(propertyName);
    var base = $eAyj5.resolve(this.base, schema.id || '');
    var ctx = new $b11632c8bee676c4$var$SchemaContext(schema, this.options, propertyPath, base, Object.create(this.schemas));
    if (schema.id && !ctx.schemas[base]) ctx.schemas[base] = schema;
    return ctx;
};
var $b11632c8bee676c4$var$FORMAT_REGEXPS = $b11632c8bee676c4$export$1d8c0144df69cb55 = {
    'date-time': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/,
    'date': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/,
    'time': /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/,
    'email': /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
    'ip-address': /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
    'ipv6': /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,
    'uri': /^[a-zA-Z][a-zA-Z0-9+-.]*:[^\s]*$/,
    'color': /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/,
    // hostname regex from: http://stackoverflow.com/a/1420225/5628
    'hostname': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
    'host-name': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
    'alpha': /^[a-zA-Z]+$/,
    'alphanumeric': /^[a-zA-Z0-9]+$/,
    'utc-millisec': function(input) {
        return typeof input === 'string' && parseFloat(input) === parseInt(input, 10) && !isNaN(input);
    },
    'regex': function(input) {
        var result = true;
        try {
            new RegExp(input);
        } catch (e) {
            result = false;
        }
        return result;
    },
    'style': /\s*(.+?):\s*([^;]+);?/g,
    'phone': /^\+(?:[0-9] ?){6,14}[0-9]$/
};
$b11632c8bee676c4$var$FORMAT_REGEXPS.regexp = $b11632c8bee676c4$var$FORMAT_REGEXPS.regex;
$b11632c8bee676c4$var$FORMAT_REGEXPS.pattern = $b11632c8bee676c4$var$FORMAT_REGEXPS.regex;
$b11632c8bee676c4$var$FORMAT_REGEXPS.ipv4 = $b11632c8bee676c4$var$FORMAT_REGEXPS['ip-address'];
$b11632c8bee676c4$export$674374997fba8879 = function isFormat(input, format, validator) {
    if (typeof input === 'string' && $b11632c8bee676c4$var$FORMAT_REGEXPS[format] !== undefined) {
        if ($b11632c8bee676c4$var$FORMAT_REGEXPS[format] instanceof RegExp) return $b11632c8bee676c4$var$FORMAT_REGEXPS[format].test(input);
        if (typeof $b11632c8bee676c4$var$FORMAT_REGEXPS[format] === 'function') return $b11632c8bee676c4$var$FORMAT_REGEXPS[format](input);
    } else if (validator && validator.customFormats && typeof validator.customFormats[format] === 'function') return validator.customFormats[format](input);
    return true;
};
var $b11632c8bee676c4$var$makeSuffix = $b11632c8bee676c4$export$61f60bce4af13a93 = function makeSuffix(key) {
    key = key.toString();
    // This function could be capable of outputting valid a ECMAScript string, but the
    // resulting code for testing which form to use would be tens of thousands of characters long
    // That means this will use the name form for some illegal forms
    if (!key.match(/[.\s\[\]]/) && !key.match(/^[\d]/)) return '.' + key;
    if (key.match(/^\d+$/)) return '[' + key + ']';
    return '[' + JSON.stringify(key) + ']';
};
$b11632c8bee676c4$export$f99d9bd271f9a30e = function deepCompareStrict(a, b) {
    if (typeof a !== typeof b) return false;
    if (a instanceof Array) {
        if (!(b instanceof Array)) return false;
        if (a.length !== b.length) return false;
        return a.every(function(v, i) {
            return deepCompareStrict(a[i], b[i]);
        });
    }
    if (typeof a === 'object') {
        if (!a || !b) return a === b;
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(v) {
            return deepCompareStrict(a[v], b[v]);
        });
    }
    return a === b;
};
function $b11632c8bee676c4$var$deepMerger(target, dst, e, i) {
    if (typeof e === 'object') dst[i] = $b11632c8bee676c4$var$deepMerge(target[i], e);
    else if (target.indexOf(e) === -1) dst.push(e);
}
function $b11632c8bee676c4$var$copyist(src, dst, key) {
    dst[key] = src[key];
}
function $b11632c8bee676c4$var$copyistWithDeepMerge(target, src, dst, key) {
    if (typeof src[key] !== 'object' || !src[key]) dst[key] = src[key];
    else if (!target[key]) dst[key] = src[key];
    else dst[key] = $b11632c8bee676c4$var$deepMerge(target[key], src[key]);
}
function $b11632c8bee676c4$var$deepMerge(target, src) {
    var array = Array.isArray(src);
    var dst = array && [] || {};
    if (array) {
        target = target || [];
        dst = dst.concat(target);
        src.forEach($b11632c8bee676c4$var$deepMerger.bind(null, target, dst));
    } else {
        if (target && typeof target === 'object') Object.keys(target).forEach($b11632c8bee676c4$var$copyist.bind(null, target, dst));
        Object.keys(src).forEach($b11632c8bee676c4$var$copyistWithDeepMerge.bind(null, target, src, dst));
    }
    return dst;
}
$b11632c8bee676c4$export$6969335ea1e4e77c = $b11632c8bee676c4$var$deepMerge;
$b11632c8bee676c4$export$d03ab7c46c3a0e16 = function objectGetPath(o, s) {
    var parts = s.split('/').slice(1);
    var k;
    while(typeof (k = parts.shift()) == 'string'){
        var n = decodeURIComponent(k.replace(/~0/, '~').replace(/~1/g, '/'));
        if (!(n in o)) return;
        o = o[n];
    }
    return o;
};
function $b11632c8bee676c4$var$pathEncoder(v) {
    return '/' + encodeURIComponent(v).replace(/~/g, '%7E');
}
$b11632c8bee676c4$export$20c03ce31e68a433 = function encodePointer(a) {
    // ~ must be encoded explicitly because hacks
    // the slash is encoded by encodeURIComponent
    return a.map($b11632c8bee676c4$var$pathEncoder).join('');
};
$b11632c8bee676c4$export$4c5662d18be49e92 = function getDecimalPlaces(number) {
    var decimalPlaces = 0;
    if (isNaN(number)) return decimalPlaces;
    if (typeof number !== 'number') number = Number(number);
    var parts = number.toString().split('e');
    if (parts.length === 2) {
        if (parts[1][0] !== '-') return decimalPlaces;
        else decimalPlaces = Number(parts[1].slice(1));
    }
    var decimalParts = parts[0].split('.');
    if (decimalParts.length === 2) decimalPlaces += decimalParts[1].length;
    return decimalPlaces;
};

});


parcelRegister("6Zyia", function(module, exports) {

$parcel$export(module.exports, "SchemaScanResult", function () { return $51730a415dfc2c6a$export$fa2f6d6458e494ac; }, function (v) { return $51730a415dfc2c6a$export$fa2f6d6458e494ac = v; });
$parcel$export(module.exports, "scan", function () { return $51730a415dfc2c6a$export$c87d910e63d22ed6; }, function (v) { return $51730a415dfc2c6a$export$c87d910e63d22ed6 = v; });
var $51730a415dfc2c6a$export$fa2f6d6458e494ac;
/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param string uri
 * @param object schema
 * @return {Object}
 */ var $51730a415dfc2c6a$export$c87d910e63d22ed6;

var $eAyj5 = parcelRequire("eAyj5");

var $fcCXC = parcelRequire("fcCXC");
$51730a415dfc2c6a$export$fa2f6d6458e494ac = $51730a415dfc2c6a$var$SchemaScanResult;
function $51730a415dfc2c6a$var$SchemaScanResult(found, ref) {
    this.id = found;
    this.ref = ref;
}
$51730a415dfc2c6a$export$c87d910e63d22ed6 = function scan(base, schema) {
    function scanSchema(baseuri, schema) {
        if (!schema || typeof schema != 'object') return;
        // Mark all referenced schemas so we can tell later which schemas are referred to, but never defined
        if (schema.$ref) {
            var resolvedUri = $eAyj5.resolve(baseuri, schema.$ref);
            ref[resolvedUri] = ref[resolvedUri] ? ref[resolvedUri] + 1 : 0;
            return;
        }
        var ourBase = schema.id ? $eAyj5.resolve(baseuri, schema.id) : baseuri;
        if (ourBase) {
            // If there's no fragment, append an empty one
            if (ourBase.indexOf('#') < 0) ourBase += '#';
            if (found[ourBase]) {
                if (!$fcCXC.deepCompareStrict(found[ourBase], schema)) throw new Error('Schema <' + schema + '> already exists with different definition');
                return found[ourBase];
            }
            found[ourBase] = schema;
            // strip trailing fragment
            if (ourBase[ourBase.length - 1] == '#') found[ourBase.substring(0, ourBase.length - 1)] = schema;
        }
        scanArray(ourBase + '/items', schema.items instanceof Array ? schema.items : [
            schema.items
        ]);
        scanArray(ourBase + '/extends', schema.extends instanceof Array ? schema.extends : [
            schema.extends
        ]);
        scanSchema(ourBase + '/additionalItems', schema.additionalItems);
        scanObject(ourBase + '/properties', schema.properties);
        scanSchema(ourBase + '/additionalProperties', schema.additionalProperties);
        scanObject(ourBase + '/definitions', schema.definitions);
        scanObject(ourBase + '/patternProperties', schema.patternProperties);
        scanObject(ourBase + '/dependencies', schema.dependencies);
        scanArray(ourBase + '/disallow', schema.disallow);
        scanArray(ourBase + '/allOf', schema.allOf);
        scanArray(ourBase + '/anyOf', schema.anyOf);
        scanArray(ourBase + '/oneOf', schema.oneOf);
        scanSchema(ourBase + '/not', schema.not);
    }
    function scanArray(baseuri, schemas) {
        if (!(schemas instanceof Array)) return;
        for(var i = 0; i < schemas.length; i++)scanSchema(baseuri + '/' + i, schemas[i]);
    }
    function scanObject(baseuri, schemas) {
        if (!schemas || typeof schemas != 'object') return;
        for(var p in schemas)scanSchema(baseuri + '/' + p, schemas[p]);
    }
    var found = {};
    var ref = {};
    var schemaUri = base;
    scanSchema(base, schema);
    return new $51730a415dfc2c6a$var$SchemaScanResult(found, ref);
};

});


parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2fad1f91101d4119$export$2b8d127b894957b9; }, function (v) { return $2fad1f91101d4119$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2fad1f91101d4119$export$cea3a54a6425200c; }, function (v) { return $2fad1f91101d4119$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$2b8d127b894957b9;
var $2fad1f91101d4119$export$cea3a54a6425200c;
var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = "function" === typeof Symbol && Symbol.for, $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$b ? Symbol.for("react.element") : 60103, $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$b ? Symbol.for("react.portal") : 60106, $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$b ? Symbol.for("react.fragment") : 60107, $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$b ? Symbol.for("react.strict_mode") : 60108, $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$b ? Symbol.for("react.profiler") : 60114, $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$b ? Symbol.for("react.provider") : 60109, $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$b ? Symbol.for("react.context") : 60110, $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$b ? Symbol.for("react.async_mode") : 60111, $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$b ? Symbol.for("react.forward_ref") : 60112, $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense") : 60113, $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense_list") : 60120, $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$b ? Symbol.for("react.memo") : 60115, $2fad1f91101d4119$var$t = $2fad1f91101d4119$var$b ? Symbol.for("react.lazy") : 60116, $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$b ? Symbol.for("react.block") : 60121, $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$b ? Symbol.for("react.fundamental") : 60117, $2fad1f91101d4119$var$x = $2fad1f91101d4119$var$b ? Symbol.for("react.responder") : 60118, $2fad1f91101d4119$var$y = $2fad1f91101d4119$var$b ? Symbol.for("react.scope") : 60119;
function $2fad1f91101d4119$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2fad1f91101d4119$var$c:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$g:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$t:
                            case $2fad1f91101d4119$var$r:
                            case $2fad1f91101d4119$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2fad1f91101d4119$var$d:
                return u;
        }
    }
}
function $2fad1f91101d4119$var$A(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$m;
}
$2fad1f91101d4119$export$2b8d127b894957b9 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$cea3a54a6425200c = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$k;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$t;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$r;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$92387174baf9b227 = function(a) {
    return $2fad1f91101d4119$var$A(a) || $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$t;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$r;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$g || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$p || a === $2fad1f91101d4119$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$t || a.$$typeof === $2fad1f91101d4119$var$r || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$w || a.$$typeof === $2fad1f91101d4119$var$x || a.$$typeof === $2fad1f91101d4119$var$y || a.$$typeof === $2fad1f91101d4119$var$v);
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$z;

});

parcelRegister("72UbZ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $52144eecca097422$export$306c0aa65ff9ec16; }, function (v) { return $52144eecca097422$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $52144eecca097422$export$306c0aa65ff9ec16;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
function $52144eecca097422$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $52144eecca097422$var$k = "function" === typeof Object.is ? Object.is : $52144eecca097422$var$h, $52144eecca097422$var$l = $7fPBF.useState, $52144eecca097422$var$m = $7fPBF.useEffect, $52144eecca097422$var$n = $7fPBF.useLayoutEffect, $52144eecca097422$var$p = $7fPBF.useDebugValue;
function $52144eecca097422$var$q(a, b) {
    var d = b(), f = $52144eecca097422$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $52144eecca097422$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $52144eecca097422$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $52144eecca097422$var$m(function() {
        $52144eecca097422$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $52144eecca097422$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $52144eecca097422$var$p(d);
    return d;
}
function $52144eecca097422$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$52144eecca097422$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $52144eecca097422$var$t(a, b) {
    return b();
}
var $52144eecca097422$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $52144eecca097422$var$t : $52144eecca097422$var$q;
$52144eecca097422$export$306c0aa65ff9ec16 = void 0 !== $7fPBF.useSyncExternalStore ? $7fPBF.useSyncExternalStore : $52144eecca097422$var$u;

});


var $7fPBF = parcelRequire("7fPBF");
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $1e216dc96a46c373$exports = {};
'use strict';
Object.defineProperty($1e216dc96a46c373$exports, "__esModule", {
    value: true
});
$1e216dc96a46c373$exports.Effect = undefined;
var $d4ccafa471eaf08e$exports = {};
'use strict';
var $d4ccafa471eaf08e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
Object.defineProperty($d4ccafa471eaf08e$exports, "__esModule", {
    value: true
});
$d4ccafa471eaf08e$exports.ModalManager = $d4ccafa471eaf08e$exports.Modal = undefined;

var $7fPBF = parcelRequire("7fPBF");
var $d4ccafa471eaf08e$var$_react2 = $d4ccafa471eaf08e$var$_interopRequireDefault($7fPBF);

var $d4ccafa471eaf08e$var$_reactDom2 = $d4ccafa471eaf08e$var$_interopRequireDefault($b4ba1c853f6e1116$exports);
var $a9fb7b344ae28f55$exports = {};
/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $cf7e837fa437c7d9$exports = {};
/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $d4bcf9cbca00d491$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */ function $d4bcf9cbca00d491$var$baseCopy(source, props, object) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        object[key] = source[key];
    }
    return object;
}
$d4bcf9cbca00d491$exports = $d4bcf9cbca00d491$var$baseCopy;


var $6332cb0ec7e99137$exports = {};
/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $283e490168fa01a9$exports = {};
/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $283e490168fa01a9$var$funcTag = '[object Function]';
/** Used to detect host constructors (Safari > 5). */ var $283e490168fa01a9$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $283e490168fa01a9$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/** Used for native method references. */ var $283e490168fa01a9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $283e490168fa01a9$var$fnToString = Function.prototype.toString;
/** Used to check objects for own properties. */ var $283e490168fa01a9$var$hasOwnProperty = $283e490168fa01a9$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $283e490168fa01a9$var$objToString = $283e490168fa01a9$var$objectProto.toString;
/** Used to detect if a method is native. */ var $283e490168fa01a9$var$reIsNative = RegExp('^' + $283e490168fa01a9$var$fnToString.call($283e490168fa01a9$var$hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $283e490168fa01a9$var$getNative(object, key) {
    var value = object == null ? undefined : object[key];
    return $283e490168fa01a9$var$isNative(value) ? value : undefined;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $283e490168fa01a9$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in older versions of Chrome and Safari which return 'function' for regexes
    // and Safari 8 equivalents which return 'object' for typed array constructors.
    return $283e490168fa01a9$var$isObject(value) && $283e490168fa01a9$var$objToString.call(value) == $283e490168fa01a9$var$funcTag;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $283e490168fa01a9$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */ function $283e490168fa01a9$var$isNative(value) {
    if (value == null) return false;
    if ($283e490168fa01a9$var$isFunction(value)) return $283e490168fa01a9$var$reIsNative.test($283e490168fa01a9$var$fnToString.call(value));
    return $283e490168fa01a9$var$isObjectLike(value) && $283e490168fa01a9$var$reIsHostCtor.test(value);
}
$283e490168fa01a9$exports = $283e490168fa01a9$var$getNative;


var $f751ffb4c285c39d$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $f751ffb4c285c39d$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $f751ffb4c285c39d$var$argsTag = '[object Arguments]', $f751ffb4c285c39d$var$funcTag = '[object Function]', $f751ffb4c285c39d$var$genTag = '[object GeneratorFunction]';
/** Used for built-in method references. */ var $f751ffb4c285c39d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f751ffb4c285c39d$var$hasOwnProperty = $f751ffb4c285c39d$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f751ffb4c285c39d$var$objectToString = $f751ffb4c285c39d$var$objectProto.toString;
/** Built-in value references. */ var $f751ffb4c285c39d$var$propertyIsEnumerable = $f751ffb4c285c39d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $f751ffb4c285c39d$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $f751ffb4c285c39d$var$isArrayLikeObject(value) && $f751ffb4c285c39d$var$hasOwnProperty.call(value, 'callee') && (!$f751ffb4c285c39d$var$propertyIsEnumerable.call(value, 'callee') || $f751ffb4c285c39d$var$objectToString.call(value) == $f751ffb4c285c39d$var$argsTag);
}
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $f751ffb4c285c39d$var$isArrayLike(value) {
    return value != null && $f751ffb4c285c39d$var$isLength(value.length) && !$f751ffb4c285c39d$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $f751ffb4c285c39d$var$isArrayLikeObject(value) {
    return $f751ffb4c285c39d$var$isObjectLike(value) && $f751ffb4c285c39d$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $f751ffb4c285c39d$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $f751ffb4c285c39d$var$isObject(value) ? $f751ffb4c285c39d$var$objectToString.call(value) : '';
    return tag == $f751ffb4c285c39d$var$funcTag || tag == $f751ffb4c285c39d$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $f751ffb4c285c39d$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $f751ffb4c285c39d$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f751ffb4c285c39d$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f751ffb4c285c39d$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
$f751ffb4c285c39d$exports = $f751ffb4c285c39d$var$isArguments;


var $dcf662f0ab0d55c4$exports = {};
/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $dcf662f0ab0d55c4$var$arrayTag = '[object Array]', $dcf662f0ab0d55c4$var$funcTag = '[object Function]';
/** Used to detect host constructors (Safari > 5). */ var $dcf662f0ab0d55c4$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $dcf662f0ab0d55c4$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/** Used for native method references. */ var $dcf662f0ab0d55c4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $dcf662f0ab0d55c4$var$fnToString = Function.prototype.toString;
/** Used to check objects for own properties. */ var $dcf662f0ab0d55c4$var$hasOwnProperty = $dcf662f0ab0d55c4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dcf662f0ab0d55c4$var$objToString = $dcf662f0ab0d55c4$var$objectProto.toString;
/** Used to detect if a method is native. */ var $dcf662f0ab0d55c4$var$reIsNative = RegExp('^' + $dcf662f0ab0d55c4$var$fnToString.call($dcf662f0ab0d55c4$var$hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/* Native method references for those with the same name as other `lodash` methods. */ var $dcf662f0ab0d55c4$var$nativeIsArray = $dcf662f0ab0d55c4$var$getNative(Array, 'isArray');
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $dcf662f0ab0d55c4$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $dcf662f0ab0d55c4$var$getNative(object, key) {
    var value = object == null ? undefined : object[key];
    return $dcf662f0ab0d55c4$var$isNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $dcf662f0ab0d55c4$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $dcf662f0ab0d55c4$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */ var $dcf662f0ab0d55c4$var$isArray = $dcf662f0ab0d55c4$var$nativeIsArray || function(value) {
    return $dcf662f0ab0d55c4$var$isObjectLike(value) && $dcf662f0ab0d55c4$var$isLength(value.length) && $dcf662f0ab0d55c4$var$objToString.call(value) == $dcf662f0ab0d55c4$var$arrayTag;
};
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $dcf662f0ab0d55c4$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in older versions of Chrome and Safari which return 'function' for regexes
    // and Safari 8 equivalents which return 'object' for typed array constructors.
    return $dcf662f0ab0d55c4$var$isObject(value) && $dcf662f0ab0d55c4$var$objToString.call(value) == $dcf662f0ab0d55c4$var$funcTag;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $dcf662f0ab0d55c4$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */ function $dcf662f0ab0d55c4$var$isNative(value) {
    if (value == null) return false;
    if ($dcf662f0ab0d55c4$var$isFunction(value)) return $dcf662f0ab0d55c4$var$reIsNative.test($dcf662f0ab0d55c4$var$fnToString.call(value));
    return $dcf662f0ab0d55c4$var$isObjectLike(value) && $dcf662f0ab0d55c4$var$reIsHostCtor.test(value);
}
$dcf662f0ab0d55c4$exports = $dcf662f0ab0d55c4$var$isArray;


/** Used to detect unsigned integer values. */ var $6332cb0ec7e99137$var$reIsUint = /^\d+$/;
/** Used for native method references. */ var $6332cb0ec7e99137$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6332cb0ec7e99137$var$hasOwnProperty = $6332cb0ec7e99137$var$objectProto.hasOwnProperty;
/* Native method references for those with the same name as other `lodash` methods. */ var $6332cb0ec7e99137$var$nativeKeys = $283e490168fa01a9$exports(Object, 'keys');
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $6332cb0ec7e99137$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function $6332cb0ec7e99137$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var $6332cb0ec7e99137$var$getLength = $6332cb0ec7e99137$var$baseProperty('length');
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function $6332cb0ec7e99137$var$isArrayLike(value) {
    return value != null && $6332cb0ec7e99137$var$isLength($6332cb0ec7e99137$var$getLength(value));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $6332cb0ec7e99137$var$isIndex(value, length) {
    value = typeof value == 'number' || $6332cb0ec7e99137$var$reIsUint.test(value) ? +value : -1;
    length = length == null ? $6332cb0ec7e99137$var$MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $6332cb0ec7e99137$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $6332cb0ec7e99137$var$MAX_SAFE_INTEGER;
}
/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6332cb0ec7e99137$var$shimKeys(object) {
    var props = $6332cb0ec7e99137$var$keysIn(object), propsLength = props.length, length = propsLength && object.length;
    var allowIndexes = !!length && $6332cb0ec7e99137$var$isLength(length) && ($dcf662f0ab0d55c4$exports(object) || $f751ffb4c285c39d$exports(object));
    var index = -1, result = [];
    while(++index < propsLength){
        var key = props[index];
        if (allowIndexes && $6332cb0ec7e99137$var$isIndex(key, length) || $6332cb0ec7e99137$var$hasOwnProperty.call(object, key)) result.push(key);
    }
    return result;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $6332cb0ec7e99137$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ var $6332cb0ec7e99137$var$keys = !$6332cb0ec7e99137$var$nativeKeys ? $6332cb0ec7e99137$var$shimKeys : function(object) {
    var Ctor = object == null ? undefined : object.constructor;
    if (typeof Ctor == 'function' && Ctor.prototype === object || typeof object != 'function' && $6332cb0ec7e99137$var$isArrayLike(object)) return $6332cb0ec7e99137$var$shimKeys(object);
    return $6332cb0ec7e99137$var$isObject(object) ? $6332cb0ec7e99137$var$nativeKeys(object) : [];
};
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $6332cb0ec7e99137$var$keysIn(object) {
    if (object == null) return [];
    if (!$6332cb0ec7e99137$var$isObject(object)) object = Object(object);
    var length = object.length;
    length = length && $6332cb0ec7e99137$var$isLength(length) && ($dcf662f0ab0d55c4$exports(object) || $f751ffb4c285c39d$exports(object)) && length || 0;
    var Ctor = object.constructor, index = -1, isProto = typeof Ctor == 'function' && Ctor.prototype === object, result = Array(length), skipIndexes = length > 0;
    while(++index < length)result[index] = index + '';
    for(var key in object)if (!(skipIndexes && $6332cb0ec7e99137$var$isIndex(key, length)) && !(key == 'constructor' && (isProto || !$6332cb0ec7e99137$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$6332cb0ec7e99137$exports = $6332cb0ec7e99137$var$keys;


/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $cf7e837fa437c7d9$var$baseAssign(object, source) {
    return source == null ? object : $d4bcf9cbca00d491$exports(source, $6332cb0ec7e99137$exports(source), object);
}
$cf7e837fa437c7d9$exports = $cf7e837fa437c7d9$var$baseAssign;


var $368f5b96355cb14e$exports = {};
/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $a5c45d01e0c3aac1$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */ function $a5c45d01e0c3aac1$var$bindCallback(func, thisArg, argCount) {
    if (typeof func != 'function') return $a5c45d01e0c3aac1$var$identity;
    if (thisArg === undefined) return func;
    switch(argCount){
        case 1:
            return function(value) {
                return func.call(thisArg, value);
            };
        case 3:
            return function(value, index, collection) {
                return func.call(thisArg, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(thisArg, accumulator, value, index, collection);
            };
        case 5:
            return function(value, other, key, object, source) {
                return func.call(thisArg, value, other, key, object, source);
            };
    }
    return function() {
        return func.apply(thisArg, arguments);
    };
}
/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */ function $a5c45d01e0c3aac1$var$identity(value) {
    return value;
}
$a5c45d01e0c3aac1$exports = $a5c45d01e0c3aac1$var$bindCallback;


var $3dd25b5cf6a3f3b6$exports = {};
/**
 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** Used to detect unsigned integer values. */ var $3dd25b5cf6a3f3b6$var$reIsUint = /^\d+$/;
/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $3dd25b5cf6a3f3b6$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function $3dd25b5cf6a3f3b6$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var $3dd25b5cf6a3f3b6$var$getLength = $3dd25b5cf6a3f3b6$var$baseProperty('length');
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function $3dd25b5cf6a3f3b6$var$isArrayLike(value) {
    return value != null && $3dd25b5cf6a3f3b6$var$isLength($3dd25b5cf6a3f3b6$var$getLength(value));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $3dd25b5cf6a3f3b6$var$isIndex(value, length) {
    value = typeof value == 'number' || $3dd25b5cf6a3f3b6$var$reIsUint.test(value) ? +value : -1;
    length = length == null ? $3dd25b5cf6a3f3b6$var$MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */ function $3dd25b5cf6a3f3b6$var$isIterateeCall(value, index, object) {
    if (!$3dd25b5cf6a3f3b6$var$isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $3dd25b5cf6a3f3b6$var$isArrayLike(object) && $3dd25b5cf6a3f3b6$var$isIndex(index, object.length) : type == 'string' && index in object) {
        var other = object[index];
        return value === value ? value === other : other !== other;
    }
    return false;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $3dd25b5cf6a3f3b6$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $3dd25b5cf6a3f3b6$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $3dd25b5cf6a3f3b6$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$3dd25b5cf6a3f3b6$exports = $3dd25b5cf6a3f3b6$var$isIterateeCall;


var $755900870f9c0a22$exports = {};
/**
 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $755900870f9c0a22$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Native method references for those with the same name as other `lodash` methods. */ var $755900870f9c0a22$var$nativeMax = Math.max;
/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */ function $755900870f9c0a22$var$restParam(func, start) {
    if (typeof func != 'function') throw new TypeError($755900870f9c0a22$var$FUNC_ERROR_TEXT);
    start = $755900870f9c0a22$var$nativeMax(start === undefined ? func.length - 1 : +start || 0, 0);
    return function() {
        var args = arguments, index = -1, length = $755900870f9c0a22$var$nativeMax(args.length - start, 0), rest = Array(length);
        while(++index < length)rest[index] = args[start + index];
        switch(start){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, args[0], rest);
            case 2:
                return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
    };
}
$755900870f9c0a22$exports = $755900870f9c0a22$var$restParam;


/**
 * Creates a function that assigns properties of source object(s) to a given
 * destination object.
 *
 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $368f5b96355cb14e$var$createAssigner(assigner) {
    return $755900870f9c0a22$exports(function(object, sources) {
        var index = -1, length = object == null ? 0 : sources.length, customizer = length > 2 ? sources[length - 2] : undefined, guard = length > 2 ? sources[2] : undefined, thisArg = length > 1 ? sources[length - 1] : undefined;
        if (typeof customizer == 'function') {
            customizer = $a5c45d01e0c3aac1$exports(customizer, thisArg, 5);
            length -= 2;
        } else {
            customizer = typeof thisArg == 'function' ? thisArg : undefined;
            length -= customizer ? 1 : 0;
        }
        if (guard && $3dd25b5cf6a3f3b6$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, customizer);
        }
        return object;
    });
}
$368f5b96355cb14e$exports = $368f5b96355cb14e$var$createAssigner;



/**
 * A specialized version of `_.assign` for customizing assigned values without
 * support for argument juggling, multiple sources, and `this` binding `customizer`
 * functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 */ function $a9fb7b344ae28f55$var$assignWith(object, source, customizer) {
    var index = -1, props = $6332cb0ec7e99137$exports(source), length = props.length;
    while(++index < length){
        var key = props[index], value = object[key], result = customizer(value, source[key], key, object, source);
        if ((result === result ? result !== value : value === value) || value === undefined && !(key in object)) object[key] = result;
    }
    return object;
}
/**
 * Assigns own enumerable properties of source object(s) to the destination
 * object. Subsequent sources overwrite property assignments of previous sources.
 * If `customizer` is provided it is invoked to produce the assigned values.
 * The `customizer` is bound to `thisArg` and invoked with five arguments:
 * (objectValue, sourceValue, key, object, source).
 *
 * **Note:** This method mutates `object` and is based on
 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
 *
 * @static
 * @memberOf _
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
 * // => { 'user': 'fred', 'age': 40 }
 *
 * // using a customizer callback
 * var defaults = _.partialRight(_.assign, function(value, other) {
 *   return _.isUndefined(value) ? other : value;
 * });
 *
 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
 * // => { 'user': 'barney', 'age': 36 }
 */ var $a9fb7b344ae28f55$var$assign = $368f5b96355cb14e$exports(function(object, source, customizer) {
    return customizer ? $a9fb7b344ae28f55$var$assignWith(object, source, customizer) : $cf7e837fa437c7d9$exports(object, source);
});
$a9fb7b344ae28f55$exports = $a9fb7b344ae28f55$var$assign;


var $d4ccafa471eaf08e$var$_lodash2 = $d4ccafa471eaf08e$var$_interopRequireDefault($a9fb7b344ae28f55$exports);
function $d4ccafa471eaf08e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d4ccafa471eaf08e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d4ccafa471eaf08e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d4ccafa471eaf08e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9b92781bc1f9c373$exports = {};
'use strict';
var $9b92781bc1f9c373$var$el;
if (!!$parcel$global.document) $9b92781bc1f9c373$var$el = $parcel$global.document.createElement('div');
var $9b92781bc1f9c373$var$prefixes = [
    "ms",
    "Moz",
    "Webkit",
    "O"
];
var $9b92781bc1f9c373$var$properties = [
    'userSelect',
    'transform',
    'transition',
    'transformOrigin',
    'transformStyle',
    'transitionProperty',
    'transitionDuration',
    'transitionTimingFunction',
    'transitionDelay',
    'borderImage',
    'borderImageSlice',
    'boxShadow',
    'backgroundClip',
    'backfaceVisibility',
    'perspective',
    'perspectiveOrigin',
    'animation',
    'animationDuration',
    'animationName',
    'animationDelay',
    'animationDirection',
    'animationIterationCount',
    'animationTimingFunction',
    'animationPlayState',
    'animationFillMode',
    'appearance'
];
function $9b92781bc1f9c373$var$GetVendorPrefix(property) {
    if ($9b92781bc1f9c373$var$properties.indexOf(property) == -1 || !$parcel$global.document || typeof $9b92781bc1f9c373$var$el.style[property] !== 'undefined') return property;
    property = property[0].toUpperCase() + property.slice(1);
    var temp;
    for(var i = 0; i < $9b92781bc1f9c373$var$prefixes.length; i++){
        temp = $9b92781bc1f9c373$var$prefixes[i] + property;
        if (typeof $9b92781bc1f9c373$var$el.style[temp] !== 'undefined') {
            $9b92781bc1f9c373$var$prefixes = [
                $9b92781bc1f9c373$var$prefixes[i]
            ]; // we only need to check this one prefix from now on.
            return temp;
        }
    }
    return property[0].toLowerCase() + property.slice(1);
}
$9b92781bc1f9c373$exports = function() {
    var cache = {};
    return function(obj) {
        if (!$parcel$global.document) return obj;
        var result = {};
        for(var key in obj){
            if (cache[key] === undefined) cache[key] = $9b92781bc1f9c373$var$GetVendorPrefix(key);
            result[cache[key]] = obj[key];
        }
        return result;
    };
}();


var $d4ccafa471eaf08e$var$defaultStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999999,
        overflow: 'hidden',
        perspective: 1300,
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
    },
    content: {
        position: 'relative',
        margin: '15% auto',
        width: '60%',
        border: '1px solid rgba(0, 0, 0, .2)',
        background: '#fff',
        overflow: 'auto',
        borderRadius: '4px',
        outline: 'none',
        boxShadow: '0 5px 10px rgba(0, 0, 0, .3)'
    }
};
var $d4ccafa471eaf08e$var$defaultTransition = {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
};
var $d4ccafa471eaf08e$var$stopPropagation = function stopPropagation(e) {
    return e.stopPropagation();
};
var $d4ccafa471eaf08e$var$onClose = void 0;
var $d4ccafa471eaf08e$var$Modal = $d4ccafa471eaf08e$exports.Modal = function(_Component) {
    $d4ccafa471eaf08e$var$_inherits(Modal, _Component);
    function Modal(props) {
        $d4ccafa471eaf08e$var$_classCallCheck(this, Modal);
        var _this = $d4ccafa471eaf08e$var$_possibleConstructorReturn(this, Object.getPrototypeOf(Modal).call(this, props));
        _this.state = {
            open: false
        };
        return _this;
    }
    $d4ccafa471eaf08e$var$_createClass(Modal, [
        {
            key: 'close',
            value: function close() {
                if (!this.props.onRequestClose || this.props.onRequestClose()) $d4ccafa471eaf08e$var$ModalManager.close();
            }
        },
        {
            key: 'handleKeyDown',
            value: function handleKeyDown(event) {
                if (event.keyCode == 27 /*esc*/ ) this.close();
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;
                var transitionTimeMS = this.getTransitionDuration();
                setTimeout(function() {
                    return _this2.setState({
                        open: true
                    });
                }, 0);
                $d4ccafa471eaf08e$var$onClose = function onClose(callback) {
                    _this2.setState({
                        open: false
                    }, function() {
                        _this2.closeTimer = setTimeout(callback, transitionTimeMS);
                    });
                };
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                $d4ccafa471eaf08e$var$onClose = null;
                clearTimeout(this.closeTimer);
            }
        },
        {
            key: 'getTransitionDuration',
            value: function getTransitionDuration() {
                var effect = this.props.effect;
                if (!effect.transition) return $d4ccafa471eaf08e$var$defaultTransition.duration;
                return effect.transition.duration || $d4ccafa471eaf08e$var$defaultTransition.duration;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props;
                var style = _props.style;
                var effect = _props.effect;
                var open = this.state.open;
                var transition = effect.transition;
                if (!transition) transition = $d4ccafa471eaf08e$var$defaultTransition;
                else transition = (0, $d4ccafa471eaf08e$var$_lodash2.default)({}, $d4ccafa471eaf08e$var$defaultTransition, transition);
                var transition_style = {
                    'transition': transition.property + ' ' + transition.duration / 1000 + 's' + ' ' + transition.timingfunction
                };
                return $d4ccafa471eaf08e$var$_react2.default.createElement('div', {
                    ref: 'overlay',
                    style: $9b92781bc1f9c373$exports((0, $d4ccafa471eaf08e$var$_lodash2.default)({}, $d4ccafa471eaf08e$var$defaultStyles.overlay, style ? style.overlay ? style.overlay : {} : {}, {
                        transition: 'opacity ' + transition.duration / 1000 + 's' + ' linear',
                        opacity: open ? 1 : 0
                    })),
                    onClick: this.close.bind(this)
                }, $d4ccafa471eaf08e$var$_react2.default.createElement('div', {
                    ref: 'content',
                    style: $9b92781bc1f9c373$exports((0, $d4ccafa471eaf08e$var$_lodash2.default)({}, $d4ccafa471eaf08e$var$defaultStyles.content, style ? style.content ? style.content : {} : {}, transition_style, open ? effect.end : effect.begin)),
                    onClick: $d4ccafa471eaf08e$var$stopPropagation,
                    onKeyDown: this.handleKeyDown.bind(this)
                }, this.props.children));
            }
        }
    ]);
    return Modal;
}($7fPBF.Component);
var $d4ccafa471eaf08e$var$node;
var $d4ccafa471eaf08e$var$modals = [];
var $d4ccafa471eaf08e$var$renderModal = function renderModal() {
    if ($d4ccafa471eaf08e$var$modals.length == 0) return;
    var component = $d4ccafa471eaf08e$var$modals.shift();
    if (!$d4ccafa471eaf08e$var$node) {
        $d4ccafa471eaf08e$var$node = document.createElement('div');
        document.body.appendChild($d4ccafa471eaf08e$var$node);
    }
    $d4ccafa471eaf08e$var$_reactDom2.default.render(component, $d4ccafa471eaf08e$var$node);
};
var $d4ccafa471eaf08e$var$ModalManager = $d4ccafa471eaf08e$exports.ModalManager = {
    open: function open(component) {
        $d4ccafa471eaf08e$var$modals.push(component);
        if ($d4ccafa471eaf08e$var$modals.length == 1) // render the modal only if there is no other showing modals
        $d4ccafa471eaf08e$var$renderModal();
    },
    close: function close() {
        $d4ccafa471eaf08e$var$onClose && $d4ccafa471eaf08e$var$onClose(function() {
            $d4ccafa471eaf08e$var$_reactDom2.default.unmountComponentAtNode($d4ccafa471eaf08e$var$node);
            $d4ccafa471eaf08e$var$renderModal(); // render the other modals which are waiting.
        });
    }
};


var $1e216dc96a46c373$var$_loop = function _loop(_key2) {
    if (_key2 === "default") return 'continue';
    Object.defineProperty($1e216dc96a46c373$exports, _key2, {
        enumerable: true,
        get: function get() {
            return $d4ccafa471eaf08e$exports[_key2];
        }
    });
};
for(var $1e216dc96a46c373$var$_key2 in $d4ccafa471eaf08e$exports){
    var $1e216dc96a46c373$var$_ret = $1e216dc96a46c373$var$_loop($1e216dc96a46c373$var$_key2);
    if ($1e216dc96a46c373$var$_ret === 'continue') continue;
}
var $ba723ca8532d6fa3$exports = {};
'use strict';
Object.defineProperty($ba723ca8532d6fa3$exports, "__esModule", {
    value: true
});
var $ba723ca8532d6fa3$var$ScaleUp = $ba723ca8532d6fa3$exports.ScaleUp = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transform': 'scale(0.7)',
        'opacity': 0
    },
    end: {
        'transform': 'scale(1)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$SlideFromRight = $ba723ca8532d6fa3$exports.SlideFromRight = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'cubic-bezier(0.25, 0.5, 0.5, 0.9)'
    },
    begin: {
        'transform': 'translateX(35%)',
        'opacity': 0
    },
    end: {
        'transform': 'translateX(0)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$SlideFromBottom = $ba723ca8532d6fa3$exports.SlideFromBottom = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transform': 'translateY(35%)',
        'opacity': 0
    },
    end: {
        'transform': 'translateY(0)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$Newspaper = $ba723ca8532d6fa3$exports.Newspaper = {
    transition: {
        property: 'all',
        duration: 500,
        timingfunction: 'linear'
    },
    begin: {
        'transform': 'scale(0) rotate(720deg)',
        'opacity': 0
    },
    end: {
        'transform': 'scale(1) rotate(0deg)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$Fall = $ba723ca8532d6fa3$exports.Fall = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'ease-in'
    },
    begin: {
        'transformStyle': 'preserve-3d',
        'transform': 'translateZ(600px) rotateX(20deg)',
        'opacity': 0
    },
    end: {
        'transformStyle': 'preserve-3d',
        'transform': 'translateZ(0px) rotateX(0deg)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$SideFall = $ba723ca8532d6fa3$exports.SideFall = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transformStyle': 'preserve-3d',
        'transform': 'translate(30%) translateZ(600px) rotate(10deg)',
        'opacity': 0
    },
    end: {
        'transformStyle': 'preserve-3d',
        'transform': 'translate(0%) translateZ(0) rotate(0deg)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$FlipHorizontal3D = $ba723ca8532d6fa3$exports.FlipHorizontal3D = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transformStyle': 'preserve-3d',
        'transform': 'rotateY(-70deg)',
        'opacity': 0
    },
    end: {
        'transformStyle': 'preserve-3d',
        'transform': 'rotateY(0deg)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$FlipVertical3D = $ba723ca8532d6fa3$exports.FlipVertical3D = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transformStyle': 'preserve-3d',
        'transform': 'rotateX(-70deg)',
        'opacity': 0
    },
    end: {
        'transformStyle': 'preserve-3d',
        'transform': 'rotateX(0deg)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$Sign3D = $ba723ca8532d6fa3$exports.Sign3D = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transformStyle': 'preserve-3d',
        'transformOrigin': '50% 0',
        'transform': 'rotateX(-60deg)',
        'opacity': 0
    },
    end: {
        'transformStyle': 'preserve-3d',
        'transformOrigin': '50% 0',
        'transform': 'rotateX(0deg)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$SuperScaled = $ba723ca8532d6fa3$exports.SuperScaled = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transform': 'scale(2)',
        'opacity': 0
    },
    end: {
        'transform': 'scale(1)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$RotateFromBottom3D = $ba723ca8532d6fa3$exports.RotateFromBottom3D = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'ease-out'
    },
    begin: {
        'transformStyle': 'preserve-3d',
        'transformOrigin': '0 100%',
        'transform': 'translateY(100%) rotateX(90deg)',
        'opacity': 0
    },
    end: {
        'transformStyle': 'preserve-3d',
        'transformOrigin': '0 100%',
        'transform': 'translateY(0%) rotateX(0deg)',
        'opacity': 1
    }
};
var $ba723ca8532d6fa3$var$RotateFromLeft3D = $ba723ca8532d6fa3$exports.RotateFromLeft3D = {
    transition: {
        property: 'all',
        duration: 300,
        timingfunction: 'linear'
    },
    begin: {
        'transformStyle': 'preserve-3d',
        'transformOrigin': '0 100%',
        'transform': 'translateZ(100px) translateX(-30%) rotateY(90deg)',
        'opacity': 0
    },
    end: {
        'transformStyle': 'preserve-3d',
        'transformOrigin': '0 100%',
        'transform': 'translateZ(0px) translateX(0%) rotateY(0deg)',
        'opacity': 1
    }
};


var $1e216dc96a46c373$var$_Effect = $1e216dc96a46c373$var$_interopRequireWildcard($ba723ca8532d6fa3$exports);
function $1e216dc96a46c373$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $1e216dc96a46c373$var$Effect = $1e216dc96a46c373$exports.Effect = $1e216dc96a46c373$var$_Effect;


// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
var $45295b0236c6430f$exports = {};

$parcel$defineInteropFlag($45295b0236c6430f$exports);

$parcel$export($45295b0236c6430f$exports, "VERSION", function () { return $0e938e6b04276893$export$a4ad2735b021c132; });
$parcel$export($45295b0236c6430f$exports, "restArguments", function () { return $8a8c9cc20e487167$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isObject", function () { return $bf1d867e545d3fb6$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isNull", function () { return $2f441e33725420d9$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isUndefined", function () { return $9b1bfb18ecb2a807$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isBoolean", function () { return $96980f2387a3b961$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isElement", function () { return $ed3f483f28b02162$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isString", function () { return $bda08f9543102302$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isNumber", function () { return $7bf33585fbc4c3c8$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isDate", function () { return $6bf5f5b33745cb81$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isRegExp", function () { return $c767f42c9caf0ee7$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isError", function () { return $7eecfa7b564df6f7$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isSymbol", function () { return $1a2d2ca3b832ab49$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isArrayBuffer", function () { return $8831466dda8e5c9e$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isDataView", function () { return $fd7bf72b82c7cf7c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isArray", function () { return $914f4fbd82b9e30a$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isFunction", function () { return $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isArguments", function () { return $58f8802939fe206e$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isFinite", function () { return $2ec93fe907d5492a$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isNaN", function () { return $3491db8508f3c2d5$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isTypedArray", function () { return $9b79577878b6dd27$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isEmpty", function () { return $dbb963033a688f80$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isMatch", function () { return $0727790293abbcdf$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isEqual", function () { return $5434f46632a6ecfc$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isMap", function () { return $4ecddb1e683dfdeb$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isWeakMap", function () { return $3438fd06ea9144a8$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isSet", function () { return $a653c2c9d570eb04$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "isWeakSet", function () { return $610edbf1bff6415d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "keys", function () { return $25ad19560c799e80$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "allKeys", function () { return $71849bec6b3a9511$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "values", function () { return $6cf62a3ef8f44584$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "pairs", function () { return $a8bc1db98a2b0c87$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "invert", function () { return $592d479cda06cbf9$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "functions", function () { return $dc29ab65aa352cfb$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "methods", function () { return $dc29ab65aa352cfb$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "extend", function () { return $44813af09636fd1b$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "extendOwn", function () { return $b93cf54187b34470$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "assign", function () { return $b93cf54187b34470$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "defaults", function () { return $dc4156e5ec58c0a1$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "create", function () { return $0dd2e3c2b4597369$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "clone", function () { return $c34f4a23a0f78e7f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "tap", function () { return $1171627b890f37be$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "get", function () { return $7549c2ddfc766e20$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "has", function () { return $2a95915c7ea1eed7$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "mapObject", function () { return $ced0931013853adf$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "identity", function () { return $8fb3c905581122ab$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "constant", function () { return $459b299372b7b7ed$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "noop", function () { return $f44139645f81f9cc$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "toPath", function () { return $72853dd9eaad1116$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "property", function () { return $9d233fba05a3951d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "propertyOf", function () { return $f1e24df4d85a113f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "matcher", function () { return $8a4481a8a0175e70$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "matches", function () { return $8a4481a8a0175e70$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "times", function () { return $56174adfefbf1335$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "random", function () { return $2f6b7e74b7c05d15$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "now", function () { return $86e025e96ed24924$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "escape", function () { return $5886da3f291859fc$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "unescape", function () { return $50007d30b23af606$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "templateSettings", function () { return $3423361ea7c08630$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "template", function () { return $f9db131ee33526ae$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "result", function () { return $98b88b06cb1f5c54$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "uniqueId", function () { return $29ac5985ec5ba409$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "chain", function () { return $5b4f214c0b24962f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "iteratee", function () { return $facff365f2b041c5$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "partial", function () { return $ea66f9edab17030f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "bind", function () { return $c626fe03ff5f2d5d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "bindAll", function () { return $965d94ad8e8f2f0f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "memoize", function () { return $4b2f27e7277e2af7$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "delay", function () { return $aa2b7a53302e85b3$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "defer", function () { return $440e854b2a25aa15$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "throttle", function () { return $14a21f64bc5a243d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "debounce", function () { return $d7728597bc64c1f2$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "wrap", function () { return $c68b4bb932ef45b9$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "negate", function () { return $33fe06284996d1a1$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "compose", function () { return $5ca36717aa24151a$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "after", function () { return $b244e5d738d3282b$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "before", function () { return $173ac76230a122c4$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "once", function () { return $17f13b041884a2ce$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "findKey", function () { return $66015e472e2ffccd$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "findIndex", function () { return $b6342a046fa55125$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "findLastIndex", function () { return $31cae579b95ab68c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "sortedIndex", function () { return $1047fb0f12a21a6d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "indexOf", function () { return $6f048641980f807e$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "lastIndexOf", function () { return $e022129700d0ffd7$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "find", function () { return $a4ef4612853bff0d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "detect", function () { return $a4ef4612853bff0d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "findWhere", function () { return $f4e6e64ceebd8a3f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "each", function () { return $667e59b41088399c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "forEach", function () { return $667e59b41088399c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "map", function () { return $6b2ac926e9dc3130$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "collect", function () { return $6b2ac926e9dc3130$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "reduce", function () { return $833596192a16450c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "foldl", function () { return $833596192a16450c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "inject", function () { return $833596192a16450c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "reduceRight", function () { return $19c1ed87c51fe518$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "foldr", function () { return $19c1ed87c51fe518$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "filter", function () { return $149cfed39c5c7c77$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "select", function () { return $149cfed39c5c7c77$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "reject", function () { return $d0dd067251f951eb$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "every", function () { return $bda1937069d7bf52$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "all", function () { return $bda1937069d7bf52$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "some", function () { return $60370e281c9ad0f6$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "any", function () { return $60370e281c9ad0f6$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "contains", function () { return $29d866ca41d2a758$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "includes", function () { return $29d866ca41d2a758$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "include", function () { return $29d866ca41d2a758$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "invoke", function () { return $3c4fb8357e83d437$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "pluck", function () { return $8b966e0502fdfb39$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "where", function () { return $305b98e19b132e17$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "max", function () { return $ef289128c6fc8166$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "min", function () { return $dd65a9697133916b$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "shuffle", function () { return $05f86149f1efd2ef$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "sample", function () { return $ff50cc5acb19a7dd$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "sortBy", function () { return $4735f3d74cc517a7$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "groupBy", function () { return $e4a1332265e8c25d$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "indexBy", function () { return $dcda7b3431a9b9de$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "countBy", function () { return $223bce443955948c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "partition", function () { return $754257c05802a1a8$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "toArray", function () { return $94c7f12fbea6be02$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "size", function () { return $ed90973c039e5340$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "pick", function () { return $399790bfbe950f87$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "omit", function () { return $d0f816305c6493f8$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "first", function () { return $ffe05363e92e6955$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "head", function () { return $ffe05363e92e6955$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "take", function () { return $ffe05363e92e6955$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "initial", function () { return $2ed3535d36e0e299$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "last", function () { return $5fc93661f862c1fb$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "rest", function () { return $8786a6c17d39a38f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "tail", function () { return $8786a6c17d39a38f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "drop", function () { return $8786a6c17d39a38f$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "compact", function () { return $70e9e64dbe2db757$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "flatten", function () { return $ef60d40737909de5$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "without", function () { return $7707f1b0e9dc4a15$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "uniq", function () { return $881c94c97039e92b$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "unique", function () { return $881c94c97039e92b$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "union", function () { return $f46648a41223c055$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "intersection", function () { return $8087ac4b37206265$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "difference", function () { return $cf1a4dde706e4c7c$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "unzip", function () { return $64decdbc218efa78$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "transpose", function () { return $64decdbc218efa78$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "zip", function () { return $746ca928e9bb10ee$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "object", function () { return $0468522dcbf720eb$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "range", function () { return $ef75f5b5dfeff538$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "chunk", function () { return $0a9542f9e1460320$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "mixin", function () { return $61a5f07bd9576f6b$export$2e2bcd8739ae039; });
$parcel$export($45295b0236c6430f$exports, "default", function () { return $0e1572bfdf784be3$export$2e2bcd8739ae039; });
// Named Exports
// =============
//     Underscore.js 1.13.6
//     https://underscorejs.org
//     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.
// Current version.
var $0e938e6b04276893$export$a4ad2735b021c132 = '1.13.6';
var $0e938e6b04276893$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $0e938e6b04276893$export$aabeece9448a227a = Array.prototype, $0e938e6b04276893$export$e77bb59b5e655b3d = Object.prototype;
var $0e938e6b04276893$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $0e938e6b04276893$export$4cbf152802aa238 = $0e938e6b04276893$export$aabeece9448a227a.push, $0e938e6b04276893$export$58adb3bec8346d0f = $0e938e6b04276893$export$aabeece9448a227a.slice, $0e938e6b04276893$export$f84e8e69fd4488a5 = $0e938e6b04276893$export$e77bb59b5e655b3d.toString, $0e938e6b04276893$export$5a15a386532a5ea4 = $0e938e6b04276893$export$e77bb59b5e655b3d.hasOwnProperty;
var $0e938e6b04276893$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $0e938e6b04276893$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $0e938e6b04276893$export$552cf9b635cef256 = Array.isArray, $0e938e6b04276893$export$e676cf06d7fd2114 = Object.keys, $0e938e6b04276893$export$5b53dc95b548c58c = Object.create, $0e938e6b04276893$export$35fc70fc5e80d5a7 = $0e938e6b04276893$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $0e938e6b04276893$export$a739ba33a90be0a1 = isNaN, $0e938e6b04276893$export$8b48b92f6c9d5ad = isFinite;
var $0e938e6b04276893$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $0e938e6b04276893$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $0e938e6b04276893$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;


// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $8a8c9cc20e487167$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}


// Is a given variable an object?
function $bf1d867e545d3fb6$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}


// Is a given value equal to null?
function $2f441e33725420d9$export$2e2bcd8739ae039(obj) {
    return obj === null;
}


// Is a given variable undefined?
function $9b1bfb18ecb2a807$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}



function $96980f2387a3b961$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $0e938e6b04276893$export$f84e8e69fd4488a5).call(obj) === '[object Boolean]';
}


// Is a given value a DOM element?
function $ed3f483f28b02162$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}



function $b88245c4d4d33515$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $0e938e6b04276893$export$f84e8e69fd4488a5).call(obj) === tag;
    };
}


var $bda08f9543102302$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('String');



var $7bf33585fbc4c3c8$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Number');



var $6bf5f5b33745cb81$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Date');



var $c767f42c9caf0ee7$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('RegExp');



var $7eecfa7b564df6f7$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Error');



var $1a2d2ca3b832ab49$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Symbol');



var $8831466dda8e5c9e$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('ArrayBuffer');





var $dbba5b1bc4d8ff0f$var$isFunction = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $dbba5b1bc4d8ff0f$var$nodelist = (0, $0e938e6b04276893$export$e8e78c978b129247).document && (0, $0e938e6b04276893$export$e8e78c978b129247).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $dbba5b1bc4d8ff0f$var$nodelist != 'function') $dbba5b1bc4d8ff0f$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039 = $dbba5b1bc4d8ff0f$var$isFunction;





var $6f849cde85efe555$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Object');


var $2244955280a466a6$export$834f1807c25991c1 = (0, $0e938e6b04276893$export$a2e478ad34dac33e) && (0, $6f849cde85efe555$export$2e2bcd8739ae039)(new DataView(new ArrayBuffer(8))), $2244955280a466a6$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $6f849cde85efe555$export$2e2bcd8739ae039)(new Map);


var $fd7bf72b82c7cf7c$var$isDataView = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function $fd7bf72b82c7cf7c$var$ie10IsDataView(obj) {
    return obj != null && (0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(obj.getInt8) && (0, $8831466dda8e5c9e$export$2e2bcd8739ae039)(obj.buffer);
}
var $fd7bf72b82c7cf7c$export$2e2bcd8739ae039 = (0, $2244955280a466a6$export$834f1807c25991c1) ? $fd7bf72b82c7cf7c$var$ie10IsDataView : $fd7bf72b82c7cf7c$var$isDataView;




var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$914f4fbd82b9e30a$export$2e2bcd8739ae039 = (0, $0e938e6b04276893$export$552cf9b635cef256) || (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Array');





function $f0d3393a83155781$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $0e938e6b04276893$export$5a15a386532a5ea4).call(obj, key);
}


var $58f8802939fe206e$var$isArguments = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$58f8802939fe206e$var$isArguments(arguments)) $58f8802939fe206e$var$isArguments = function(obj) {
        return (0, $f0d3393a83155781$export$2e2bcd8739ae039)(obj, 'callee');
    };
})();
var $58f8802939fe206e$export$2e2bcd8739ae039 = $58f8802939fe206e$var$isArguments;




function $2ec93fe907d5492a$export$2e2bcd8739ae039(obj) {
    return !(0, $1a2d2ca3b832ab49$export$2e2bcd8739ae039)(obj) && (0, $0e938e6b04276893$export$8b48b92f6c9d5ad)(obj) && !isNaN(parseFloat(obj));
}




function $3491db8508f3c2d5$export$2e2bcd8739ae039(obj) {
    return (0, $7bf33585fbc4c3c8$export$2e2bcd8739ae039)(obj) && (0, $0e938e6b04276893$export$a739ba33a90be0a1)(obj);
}




// Predicate-generating function. Often useful outside of Underscore.
function $459b299372b7b7ed$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}



function $b8a9f9a0522ccc0f$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $0e938e6b04276893$export$63b3abc5cd28bc48);
    };
}


// Internal helper to generate a function to obtain property `key` from `obj`.
function $4c5a70e26d674b48$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}


var // Internal helper to obtain the `byteLength` property of an object.
$5b9df4a5c22f2da6$export$2e2bcd8739ae039 = (0, $4c5a70e26d674b48$export$2e2bcd8739ae039)('byteLength');


var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$cf11e4c17413524e$export$2e2bcd8739ae039 = (0, $b8a9f9a0522ccc0f$export$2e2bcd8739ae039)((0, $5b9df4a5c22f2da6$export$2e2bcd8739ae039));


// Is a given value a typed array?
var $9b79577878b6dd27$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $9b79577878b6dd27$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $0e938e6b04276893$export$35fc70fc5e80d5a7) ? (0, $0e938e6b04276893$export$35fc70fc5e80d5a7)(obj) && !(0, $fd7bf72b82c7cf7c$export$2e2bcd8739ae039)(obj) : (0, $cf11e4c17413524e$export$2e2bcd8739ae039)(obj) && $9b79577878b6dd27$var$typedArrayPattern.test((0, $0e938e6b04276893$export$f84e8e69fd4488a5).call(obj));
}
var $9b79577878b6dd27$export$2e2bcd8739ae039 = (0, $0e938e6b04276893$export$20eaf89d899ede58) ? $9b79577878b6dd27$var$isTypedArray : (0, $459b299372b7b7ed$export$2e2bcd8739ae039)(false);



var // Internal helper to obtain the `length` property of an object.
$3605892512a788ac$export$2e2bcd8739ae039 = (0, $4c5a70e26d674b48$export$2e2bcd8739ae039)('length');











// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $336115b69da21d45$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $336115b69da21d45$export$2e2bcd8739ae039(obj, keys) {
    keys = $336115b69da21d45$var$emulatedSet(keys);
    var nonEnumIdx = (0, $0e938e6b04276893$export$f8fa596d5e31cb19).length;
    var constructor = obj.constructor;
    var proto = (0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(constructor) && constructor.prototype || (0, $0e938e6b04276893$export$e77bb59b5e655b3d);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $f0d3393a83155781$export$2e2bcd8739ae039)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $0e938e6b04276893$export$f8fa596d5e31cb19)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}


function $25ad19560c799e80$export$2e2bcd8739ae039(obj) {
    if (!(0, $bf1d867e545d3fb6$export$2e2bcd8739ae039)(obj)) return [];
    if (0, $0e938e6b04276893$export$e676cf06d7fd2114) return (0, $0e938e6b04276893$export$e676cf06d7fd2114)(obj);
    var keys = [];
    for(var key in obj)if ((0, $f0d3393a83155781$export$2e2bcd8739ae039)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $0e938e6b04276893$export$7dcea4d27900b116) (0, $336115b69da21d45$export$2e2bcd8739ae039)(obj, keys);
    return keys;
}


function $dbb963033a688f80$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(obj);
    if (typeof length == 'number' && ((0, $914f4fbd82b9e30a$export$2e2bcd8739ae039)(obj) || (0, $bda08f9543102302$export$2e2bcd8739ae039)(obj) || (0, $58f8802939fe206e$export$2e2bcd8739ae039)(obj))) return length === 0;
    return (0, $3605892512a788ac$export$2e2bcd8739ae039)((0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj)) === 0;
}



function $0727790293abbcdf$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}



function $db7cf745deae84d8$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $db7cf745deae84d8$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $db7cf745deae84d8$export$2e2bcd8739ae039)) return new $db7cf745deae84d8$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$db7cf745deae84d8$export$2e2bcd8739ae039.VERSION = (0, $0e938e6b04276893$export$a4ad2735b021c132);
// Extracts the result from a wrapped and chained object.
$db7cf745deae84d8$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$db7cf745deae84d8$export$2e2bcd8739ae039.prototype.valueOf = $db7cf745deae84d8$export$2e2bcd8739ae039.prototype.toJSON = $db7cf745deae84d8$export$2e2bcd8739ae039.prototype.value;
$db7cf745deae84d8$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};











function $f5805031bc91a1c2$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $5b9df4a5c22f2da6$export$2e2bcd8739ae039)(bufferSource));
}


// We use this string twice, so give it a name for minification.
var $5434f46632a6ecfc$var$tagDataView = '[object DataView]';
// Internal recursive comparison function for `_.isEqual`.
function $5434f46632a6ecfc$var$eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return $5434f46632a6ecfc$var$deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `_.isEqual`.
function $5434f46632a6ecfc$var$deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof (0, $db7cf745deae84d8$export$2e2bcd8739ae039)) a = a._wrapped;
    if (b instanceof (0, $db7cf745deae84d8$export$2e2bcd8739ae039)) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = (0, $0e938e6b04276893$export$f84e8e69fd4488a5).call(a);
    if (className !== (0, $0e938e6b04276893$export$f84e8e69fd4488a5).call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if ((0, $2244955280a466a6$export$834f1807c25991c1) && className == '[object Object]' && (0, $fd7bf72b82c7cf7c$export$2e2bcd8739ae039)(a)) {
        if (!(0, $fd7bf72b82c7cf7c$export$2e2bcd8739ae039)(b)) return false;
        className = $5434f46632a6ecfc$var$tagDataView;
    }
    switch(className){
        // These types are compared by value.
        case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case '[object String]':
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return '' + a === '' + b;
        case '[object Number]':
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case '[object Date]':
        case '[object Boolean]':
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case '[object Symbol]':
            return (0, $0e938e6b04276893$export$e229dcb397ceea81).valueOf.call(a) === (0, $0e938e6b04276893$export$e229dcb397ceea81).valueOf.call(b);
        case '[object ArrayBuffer]':
        case $5434f46632a6ecfc$var$tagDataView:
            // Coerce to typed array so we can fall through.
            return $5434f46632a6ecfc$var$deepEq((0, $f5805031bc91a1c2$export$2e2bcd8739ae039)(a), (0, $f5805031bc91a1c2$export$2e2bcd8739ae039)(b), aStack, bStack);
    }
    var areArrays = className === '[object Array]';
    if (!areArrays && (0, $9b79577878b6dd27$export$2e2bcd8739ae039)(a)) {
        var byteLength = (0, $5b9df4a5c22f2da6$export$2e2bcd8739ae039)(a);
        if (byteLength !== (0, $5b9df4a5c22f2da6$export$2e2bcd8739ae039)(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
        if (typeof a != 'object' || typeof b != 'object') return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !((0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(aCtor) && aCtor instanceof aCtor && (0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$5434f46632a6ecfc$var$eq(a[length], b[length], aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(a), key;
        length = _keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if ((0, $25ad19560c799e80$export$2e2bcd8739ae039)(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = _keys[length];
            if (!((0, $f0d3393a83155781$export$2e2bcd8739ae039)(b, key) && $5434f46632a6ecfc$var$eq(a[key], b[key], aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $5434f46632a6ecfc$export$2e2bcd8739ae039(a, b) {
    return $5434f46632a6ecfc$var$eq(a, b);
}









function $71849bec6b3a9511$export$2e2bcd8739ae039(obj) {
    if (!(0, $bf1d867e545d3fb6$export$2e2bcd8739ae039)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $0e938e6b04276893$export$7dcea4d27900b116) (0, $336115b69da21d45$export$2e2bcd8739ae039)(obj, keys);
    return keys;
}


function $dbdf5d17188cc8cb$export$15230eca1f400e40(methods) {
    var length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $71849bec6b3a9511$export$2e2bcd8739ae039)(obj);
        if ((0, $3605892512a788ac$export$2e2bcd8739ae039)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $dbdf5d17188cc8cb$export$2f74b890a72cf48 || !(0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(obj[$dbdf5d17188cc8cb$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $dbdf5d17188cc8cb$var$forEachName = 'forEach', $dbdf5d17188cc8cb$var$hasName = 'has', $dbdf5d17188cc8cb$var$commonInit = [
    'clear',
    'delete'
], $dbdf5d17188cc8cb$var$mapTail = [
    'get',
    $dbdf5d17188cc8cb$var$hasName,
    'set'
];
var $dbdf5d17188cc8cb$export$de9acb94190bb764 = $dbdf5d17188cc8cb$var$commonInit.concat($dbdf5d17188cc8cb$var$forEachName, $dbdf5d17188cc8cb$var$mapTail), $dbdf5d17188cc8cb$export$2f74b890a72cf48 = $dbdf5d17188cc8cb$var$commonInit.concat($dbdf5d17188cc8cb$var$mapTail), $dbdf5d17188cc8cb$export$60e14a5e2a057f78 = [
    'add'
].concat($dbdf5d17188cc8cb$var$commonInit, $dbdf5d17188cc8cb$var$forEachName, $dbdf5d17188cc8cb$var$hasName);


var $4ecddb1e683dfdeb$export$2e2bcd8739ae039 = (0, $2244955280a466a6$export$f7bad96d83325a34) ? (0, $dbdf5d17188cc8cb$export$15230eca1f400e40)((0, $dbdf5d17188cc8cb$export$de9acb94190bb764)) : (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Map');





var $3438fd06ea9144a8$export$2e2bcd8739ae039 = (0, $2244955280a466a6$export$f7bad96d83325a34) ? (0, $dbdf5d17188cc8cb$export$15230eca1f400e40)((0, $dbdf5d17188cc8cb$export$2f74b890a72cf48)) : (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('WeakMap');





var $a653c2c9d570eb04$export$2e2bcd8739ae039 = (0, $2244955280a466a6$export$f7bad96d83325a34) ? (0, $dbdf5d17188cc8cb$export$15230eca1f400e40)((0, $dbdf5d17188cc8cb$export$60e14a5e2a057f78)) : (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('Set');



var $610edbf1bff6415d$export$2e2bcd8739ae039 = (0, $b88245c4d4d33515$export$2e2bcd8739ae039)('WeakSet');





function $6cf62a3ef8f44584$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}



function $a8bc1db98a2b0c87$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}



function $592d479cda06cbf9$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}



function $dc29ab65aa352cfb$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(obj[key])) names.push(key);
    return names.sort();
}


// An internal function for creating assigner functions.
function $dd0fb9dc11b0fc14$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}



var // Extend a given object with all the properties in passed-in object(s).
$44813af09636fd1b$export$2e2bcd8739ae039 = (0, $dd0fb9dc11b0fc14$export$2e2bcd8739ae039)((0, $71849bec6b3a9511$export$2e2bcd8739ae039));




var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$b93cf54187b34470$export$2e2bcd8739ae039 = (0, $dd0fb9dc11b0fc14$export$2e2bcd8739ae039)((0, $25ad19560c799e80$export$2e2bcd8739ae039));




var // Fill in a given object with default properties.
$dc4156e5ec58c0a1$export$2e2bcd8739ae039 = (0, $dd0fb9dc11b0fc14$export$2e2bcd8739ae039)((0, $71849bec6b3a9511$export$2e2bcd8739ae039), true);




// Create a naked function reference for surrogate-prototype-swapping.
function $600dd84f7709925d$var$ctor() {
    return function() {};
}
function $600dd84f7709925d$export$2e2bcd8739ae039(prototype) {
    if (!(0, $bf1d867e545d3fb6$export$2e2bcd8739ae039)(prototype)) return {};
    if (0, $0e938e6b04276893$export$5b53dc95b548c58c) return (0, $0e938e6b04276893$export$5b53dc95b548c58c)(prototype);
    var Ctor = $600dd84f7709925d$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}



function $0dd2e3c2b4597369$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $600dd84f7709925d$export$2e2bcd8739ae039)(prototype);
    if (props) (0, $b93cf54187b34470$export$2e2bcd8739ae039)(result, props);
    return result;
}





function $c34f4a23a0f78e7f$export$2e2bcd8739ae039(obj) {
    if (!(0, $bf1d867e545d3fb6$export$2e2bcd8739ae039)(obj)) return obj;
    return (0, $914f4fbd82b9e30a$export$2e2bcd8739ae039)(obj) ? obj.slice() : (0, $44813af09636fd1b$export$2e2bcd8739ae039)({}, obj);
}


// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $1171627b890f37be$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}





function $72853dd9eaad1116$export$2e2bcd8739ae039(path) {
    return (0, $914f4fbd82b9e30a$export$2e2bcd8739ae039)(path) ? path : [
        path
    ];
}
(0, $db7cf745deae84d8$export$2e2bcd8739ae039).toPath = $72853dd9eaad1116$export$2e2bcd8739ae039;


function $bf97a380d0325b6e$export$2e2bcd8739ae039(path) {
    return (0, $db7cf745deae84d8$export$2e2bcd8739ae039).toPath(path);
}


// Internal function to obtain a nested property in `obj` along `path`.
function $e23ffd46acdfb8ae$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}



function $7549c2ddfc766e20$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $e23ffd46acdfb8ae$export$2e2bcd8739ae039)(object, (0, $bf97a380d0325b6e$export$2e2bcd8739ae039)(path));
    return (0, $9b1bfb18ecb2a807$export$2e2bcd8739ae039)(value) ? defaultValue : value;
}




function $2a95915c7ea1eed7$export$2e2bcd8739ae039(obj, path) {
    path = (0, $bf97a380d0325b6e$export$2e2bcd8739ae039)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $f0d3393a83155781$export$2e2bcd8739ae039)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}



// Keep the identity function around for default iteratees.
function $8fb3c905581122ab$export$2e2bcd8739ae039(value) {
    return value;
}







function $8a4481a8a0175e70$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $b93cf54187b34470$export$2e2bcd8739ae039)({}, attrs);
    return function(obj) {
        return (0, $0727790293abbcdf$export$2e2bcd8739ae039)(obj, attrs);
    };
}




function $9d233fba05a3951d$export$2e2bcd8739ae039(path) {
    path = (0, $bf97a380d0325b6e$export$2e2bcd8739ae039)(path);
    return function(obj) {
        return (0, $e23ffd46acdfb8ae$export$2e2bcd8739ae039)(obj, path);
    };
}


// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $fcfc45b4d195b965$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}


function $8b1f801421f2383b$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $8fb3c905581122ab$export$2e2bcd8739ae039;
    if ((0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(value)) return (0, $fcfc45b4d195b965$export$2e2bcd8739ae039)(value, context, argCount);
    if ((0, $bf1d867e545d3fb6$export$2e2bcd8739ae039)(value) && !(0, $914f4fbd82b9e30a$export$2e2bcd8739ae039)(value)) return (0, $8a4481a8a0175e70$export$2e2bcd8739ae039)(value);
    return (0, $9d233fba05a3951d$export$2e2bcd8739ae039)(value);
}




function $facff365f2b041c5$export$2e2bcd8739ae039(value, context) {
    return (0, $8b1f801421f2383b$export$2e2bcd8739ae039)(value, context, Infinity);
}
(0, $db7cf745deae84d8$export$2e2bcd8739ae039).iteratee = $facff365f2b041c5$export$2e2bcd8739ae039;


function $02efba45424ec726$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $db7cf745deae84d8$export$2e2bcd8739ae039).iteratee !== (0, $facff365f2b041c5$export$2e2bcd8739ae039)) return (0, $db7cf745deae84d8$export$2e2bcd8739ae039).iteratee(value, context);
    return (0, $8b1f801421f2383b$export$2e2bcd8739ae039)(value, context, argCount);
}



function $ced0931013853adf$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context);
    var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}




// Predicate-generating function. Often useful outside of Underscore.
function $f44139645f81f9cc$export$2e2bcd8739ae039() {}






function $f1e24df4d85a113f$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $f44139645f81f9cc$export$2e2bcd8739ae039;
    return function(path) {
        return (0, $7549c2ddfc766e20$export$2e2bcd8739ae039)(obj, path);
    };
}




function $56174adfefbf1335$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $fcfc45b4d195b965$export$2e2bcd8739ae039)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}


// Return a random integer between `min` and `max` (inclusive).
function $2f6b7e74b7c05d15$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}


// A (possibly faster) way to get the current timestamp as an integer.
var $86e025e96ed24924$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};



function $c0f28d2984ae570f$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $25ad19560c799e80$export$2e2bcd8739ae039)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}


// Internal list of HTML entities for escaping.
var $6779ed8533c133d3$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};


var // Function for escaping strings to HTML interpolation.
$5886da3f291859fc$export$2e2bcd8739ae039 = (0, $c0f28d2984ae570f$export$2e2bcd8739ae039)((0, $6779ed8533c133d3$export$2e2bcd8739ae039));





var // Internal list of HTML entities for unescaping.
$26330438810ba58c$export$2e2bcd8739ae039 = (0, $592d479cda06cbf9$export$2e2bcd8739ae039)((0, $6779ed8533c133d3$export$2e2bcd8739ae039));


var // Function for unescaping strings from HTML interpolation.
$50007d30b23af606$export$2e2bcd8739ae039 = (0, $c0f28d2984ae570f$export$2e2bcd8739ae039)((0, $26330438810ba58c$export$2e2bcd8739ae039));



var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$3423361ea7c08630$export$2e2bcd8739ae039 = (0, $db7cf745deae84d8$export$2e2bcd8739ae039).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};





// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $f9db131ee33526ae$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $f9db131ee33526ae$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $f9db131ee33526ae$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $f9db131ee33526ae$var$escapeChar(match) {
    return '\\' + $f9db131ee33526ae$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $f9db131ee33526ae$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $f9db131ee33526ae$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $dc4156e5ec58c0a1$export$2e2bcd8739ae039)({}, settings, (0, $db7cf745deae84d8$export$2e2bcd8739ae039).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $f9db131ee33526ae$var$noMatch).source,
        (settings.interpolate || $f9db131ee33526ae$var$noMatch).source,
        (settings.evaluate || $f9db131ee33526ae$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($f9db131ee33526ae$var$escapeRegExp, $f9db131ee33526ae$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$f9db131ee33526ae$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $db7cf745deae84d8$export$2e2bcd8739ae039));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}




function $98b88b06cb1f5c54$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $bf97a380d0325b6e$export$2e2bcd8739ae039)(path);
    var length = path.length;
    if (!length) return (0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}


// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $29ac5985ec5ba409$var$idCounter = 0;
function $29ac5985ec5ba409$export$2e2bcd8739ae039(prefix) {
    var id = ++$29ac5985ec5ba409$var$idCounter + '';
    return prefix ? prefix + id : id;
}



function $5b4f214c0b24962f$export$2e2bcd8739ae039(obj) {
    var instance = (0, $db7cf745deae84d8$export$2e2bcd8739ae039)(obj);
    instance._chain = true;
    return instance;
}






function $24f87b4460d49cb7$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $600dd84f7709925d$export$2e2bcd8739ae039)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $bf1d867e545d3fb6$export$2e2bcd8739ae039)(result)) return result;
    return self;
}



// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $ea66f9edab17030f$var$partial = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(func, boundArgs) {
    var placeholder = $ea66f9edab17030f$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $24f87b4460d49cb7$export$2e2bcd8739ae039)(func, bound, this, this, args);
    };
    return bound;
});
$ea66f9edab17030f$var$partial.placeholder = (0, $db7cf745deae84d8$export$2e2bcd8739ae039);
var $ea66f9edab17030f$export$2e2bcd8739ae039 = $ea66f9edab17030f$var$partial;





var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$c626fe03ff5f2d5d$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(func, context, args) {
    if (!(0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(callArgs) {
        return (0, $24f87b4460d49cb7$export$2e2bcd8739ae039)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});






var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$a5ef0cd3d86c916b$export$2e2bcd8739ae039 = (0, $b8a9f9a0522ccc0f$export$2e2bcd8739ae039)((0, $3605892512a788ac$export$2e2bcd8739ae039));




function $a3a9f979efa8d2b1$export$2e2bcd8739ae039(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) depth = Infinity;
    else if (depth <= 0) return output.concat(input);
    var idx = output.length;
    for(var i = 0, length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(input); i < length; i++){
        var value = input[i];
        if ((0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(value) && ((0, $914f4fbd82b9e30a$export$2e2bcd8739ae039)(value) || (0, $58f8802939fe206e$export$2e2bcd8739ae039)(value))) {
            // Flatten current level of array or arguments object.
            if (depth > 1) {
                $a3a9f979efa8d2b1$export$2e2bcd8739ae039(value, depth - 1, strict, output);
                idx = output.length;
            } else {
                var j = 0, len = value.length;
                while(j < len)output[idx++] = value[j++];
            }
        } else if (!strict) output[idx++] = value;
    }
    return output;
}



var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$965d94ad8e8f2f0f$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(obj, keys) {
    keys = (0, $a3a9f979efa8d2b1$export$2e2bcd8739ae039)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $c626fe03ff5f2d5d$export$2e2bcd8739ae039)(obj[key], obj);
    }
    return obj;
});



function $4b2f27e7277e2af7$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $f0d3393a83155781$export$2e2bcd8739ae039)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}



var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$aa2b7a53302e85b3$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});





var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$440e854b2a25aa15$export$2e2bcd8739ae039 = (0, $ea66f9edab17030f$export$2e2bcd8739ae039)((0, $aa2b7a53302e85b3$export$2e2bcd8739ae039), (0, $db7cf745deae84d8$export$2e2bcd8739ae039), 1);



function $14a21f64bc5a243d$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $86e025e96ed24924$export$2e2bcd8739ae039)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $86e025e96ed24924$export$2e2bcd8739ae039)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}




function $d7728597bc64c1f2$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $86e025e96ed24924$export$2e2bcd8739ae039)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $86e025e96ed24924$export$2e2bcd8739ae039)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}



function $c68b4bb932ef45b9$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $ea66f9edab17030f$export$2e2bcd8739ae039)(wrapper, func);
}


// Returns a negated version of the passed-in predicate.
function $33fe06284996d1a1$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}


// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $5ca36717aa24151a$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}


// Returns a function that will only be executed on and after the Nth call.
function $b244e5d738d3282b$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}


// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $173ac76230a122c4$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}




var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$17f13b041884a2ce$export$2e2bcd8739ae039 = (0, $ea66f9edab17030f$export$2e2bcd8739ae039)((0, $173ac76230a122c4$export$2e2bcd8739ae039), 2);




function $66015e472e2ffccd$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $02efba45424ec726$export$2e2bcd8739ae039)(predicate, context);
    var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}




function $15fb4b69f393ddc8$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $02efba45424ec726$export$2e2bcd8739ae039)(predicate, context);
        var length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}


var // Returns the first index on an array-like that passes a truth test.
$b6342a046fa55125$export$2e2bcd8739ae039 = (0, $15fb4b69f393ddc8$export$2e2bcd8739ae039)(1);



var // Returns the last index on an array-like that passes a truth test.
$31cae579b95ab68c$export$2e2bcd8739ae039 = (0, $15fb4b69f393ddc8$export$2e2bcd8739ae039)(-1);




function $1047fb0f12a21a6d$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $3605892512a788ac$export$2e2bcd8739ae039)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}







function $bcdcf1bebcb4051c$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $0e938e6b04276893$export$58adb3bec8346d0f).call(array, i, length), (0, $3491db8508f3c2d5$export$2e2bcd8739ae039));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}


var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$6f048641980f807e$export$2e2bcd8739ae039 = (0, $bcdcf1bebcb4051c$export$2e2bcd8739ae039)(1, (0, $b6342a046fa55125$export$2e2bcd8739ae039), (0, $1047fb0f12a21a6d$export$2e2bcd8739ae039));




var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$e022129700d0ffd7$export$2e2bcd8739ae039 = (0, $bcdcf1bebcb4051c$export$2e2bcd8739ae039)(-1, (0, $31cae579b95ab68c$export$2e2bcd8739ae039));





function $a4ef4612853bff0d$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) ? (0, $b6342a046fa55125$export$2e2bcd8739ae039) : (0, $66015e472e2ffccd$export$2e2bcd8739ae039);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}




function $f4e6e64ceebd8a3f$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $a4ef4612853bff0d$export$2e2bcd8739ae039)(obj, (0, $8a4481a8a0175e70$export$2e2bcd8739ae039)(attrs));
}





function $667e59b41088399c$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $fcfc45b4d195b965$export$2e2bcd8739ae039)(iteratee, context);
    var i, length;
    if ((0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}





function $6b2ac926e9dc3130$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context);
    var _keys = !(0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) && (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}





function $260f13e1521f33a1$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) && (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $fcfc45b4d195b965$export$2e2bcd8739ae039)(iteratee, context, 4), memo, initial);
    };
}


var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$833596192a16450c$export$2e2bcd8739ae039 = (0, $260f13e1521f33a1$export$2e2bcd8739ae039)(1);



var // The right-associative version of reduce, also known as `foldr`.
$19c1ed87c51fe518$export$2e2bcd8739ae039 = (0, $260f13e1521f33a1$export$2e2bcd8739ae039)(-1);




function $149cfed39c5c7c77$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $02efba45424ec726$export$2e2bcd8739ae039)(predicate, context);
    (0, $667e59b41088399c$export$2e2bcd8739ae039)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}





function $d0dd067251f951eb$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $149cfed39c5c7c77$export$2e2bcd8739ae039)(obj, (0, $33fe06284996d1a1$export$2e2bcd8739ae039)((0, $02efba45424ec726$export$2e2bcd8739ae039)(predicate)), context);
}





function $bda1937069d7bf52$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $02efba45424ec726$export$2e2bcd8739ae039)(predicate, context);
    var _keys = !(0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) && (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}





function $60370e281c9ad0f6$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $02efba45424ec726$export$2e2bcd8739ae039)(predicate, context);
    var _keys = !(0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) && (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}





function $29d866ca41d2a758$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj)) obj = (0, $6cf62a3ef8f44584$export$2e2bcd8739ae039)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $6f048641980f807e$export$2e2bcd8739ae039)(obj, item, fromIndex) >= 0;
}







var // Invoke a method (with arguments) on every item in a collection.
$3c4fb8357e83d437$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(path)) func = path;
    else {
        path = (0, $bf97a380d0325b6e$export$2e2bcd8739ae039)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $6b2ac926e9dc3130$export$2e2bcd8739ae039)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $e23ffd46acdfb8ae$export$2e2bcd8739ae039)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});




function $8b966e0502fdfb39$export$2e2bcd8739ae039(obj, key) {
    return (0, $6b2ac926e9dc3130$export$2e2bcd8739ae039)(obj, (0, $9d233fba05a3951d$export$2e2bcd8739ae039)(key));
}




function $305b98e19b132e17$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $149cfed39c5c7c77$export$2e2bcd8739ae039)(obj, (0, $8a4481a8a0175e70$export$2e2bcd8739ae039)(attrs));
}






function $ef289128c6fc8166$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) ? obj : (0, $6cf62a3ef8f44584$export$2e2bcd8739ae039)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context);
        (0, $667e59b41088399c$export$2e2bcd8739ae039)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}






function $dd65a9697133916b$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) ? obj : (0, $6cf62a3ef8f44584$export$2e2bcd8739ae039)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context);
        (0, $667e59b41088399c$export$2e2bcd8739ae039)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}













// Safely create a real, live array from anything iterable.
var $94c7f12fbea6be02$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $94c7f12fbea6be02$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $914f4fbd82b9e30a$export$2e2bcd8739ae039)(obj)) return (0, $0e938e6b04276893$export$58adb3bec8346d0f).call(obj);
    if ((0, $bda08f9543102302$export$2e2bcd8739ae039)(obj)) // Keep surrogate pair characters together.
    return obj.match($94c7f12fbea6be02$var$reStrSymbol);
    if ((0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj)) return (0, $6b2ac926e9dc3130$export$2e2bcd8739ae039)(obj, (0, $8fb3c905581122ab$export$2e2bcd8739ae039));
    return (0, $6cf62a3ef8f44584$export$2e2bcd8739ae039)(obj);
}


function $ff50cc5acb19a7dd$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj)) obj = (0, $6cf62a3ef8f44584$export$2e2bcd8739ae039)(obj);
        return obj[(0, $2f6b7e74b7c05d15$export$2e2bcd8739ae039)(obj.length - 1)];
    }
    var sample = (0, $94c7f12fbea6be02$export$2e2bcd8739ae039)(obj);
    var length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $2f6b7e74b7c05d15$export$2e2bcd8739ae039)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}


function $05f86149f1efd2ef$export$2e2bcd8739ae039(obj) {
    return (0, $ff50cc5acb19a7dd$export$2e2bcd8739ae039)(obj, Infinity);
}






function $4735f3d74cc517a7$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context);
    return (0, $8b966e0502fdfb39$export$2e2bcd8739ae039)((0, $6b2ac926e9dc3130$export$2e2bcd8739ae039)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}




function $a4f40e3781fec09f$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context);
        (0, $667e59b41088399c$export$2e2bcd8739ae039)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}



var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$e4a1332265e8c25d$export$2e2bcd8739ae039 = (0, $a4f40e3781fec09f$export$2e2bcd8739ae039)(function(result, value, key) {
    if ((0, $f0d3393a83155781$export$2e2bcd8739ae039)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});



var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$dcda7b3431a9b9de$export$2e2bcd8739ae039 = (0, $a4f40e3781fec09f$export$2e2bcd8739ae039)(function(result, value, key) {
    result[key] = value;
});




var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$223bce443955948c$export$2e2bcd8739ae039 = (0, $a4f40e3781fec09f$export$2e2bcd8739ae039)(function(result, value, key) {
    if ((0, $f0d3393a83155781$export$2e2bcd8739ae039)(result, key)) result[key]++;
    else result[key] = 1;
});



var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$754257c05802a1a8$export$2e2bcd8739ae039 = (0, $a4f40e3781fec09f$export$2e2bcd8739ae039)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);





function $ed90973c039e5340$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $a5ef0cd3d86c916b$export$2e2bcd8739ae039)(obj) ? obj.length : (0, $25ad19560c799e80$export$2e2bcd8739ae039)(obj).length;
}






// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $cdd27e2b5e4a0afe$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}



var // Return a copy of the object only containing the allowed properties.
$399790bfbe950f87$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $fcfc45b4d195b965$export$2e2bcd8739ae039)(iteratee, keys[1]);
        keys = (0, $71849bec6b3a9511$export$2e2bcd8739ae039)(obj);
    } else {
        iteratee = (0, $cdd27e2b5e4a0afe$export$2e2bcd8739ae039);
        keys = (0, $a3a9f979efa8d2b1$export$2e2bcd8739ae039)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});









var // Return a copy of the object without the disallowed properties.
$d0f816305c6493f8$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $dbba5b1bc4d8ff0f$export$2e2bcd8739ae039)(iteratee)) {
        iteratee = (0, $33fe06284996d1a1$export$2e2bcd8739ae039)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $6b2ac926e9dc3130$export$2e2bcd8739ae039)((0, $a3a9f979efa8d2b1$export$2e2bcd8739ae039)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $29d866ca41d2a758$export$2e2bcd8739ae039)(keys, key);
        };
    }
    return (0, $399790bfbe950f87$export$2e2bcd8739ae039)(obj, iteratee, context);
});



function $2ed3535d36e0e299$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $0e938e6b04276893$export$58adb3bec8346d0f).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}


function $ffe05363e92e6955$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $2ed3535d36e0e299$export$2e2bcd8739ae039)(array, array.length - n);
}




function $8786a6c17d39a38f$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $0e938e6b04276893$export$58adb3bec8346d0f).call(array, n == null || guard ? 1 : n);
}


function $5fc93661f862c1fb$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $8786a6c17d39a38f$export$2e2bcd8739ae039)(array, Math.max(0, array.length - n));
}




function $70e9e64dbe2db757$export$2e2bcd8739ae039(array) {
    return (0, $149cfed39c5c7c77$export$2e2bcd8739ae039)(array, Boolean);
}



function $ef60d40737909de5$export$2e2bcd8739ae039(array, depth) {
    return (0, $a3a9f979efa8d2b1$export$2e2bcd8739ae039)(array, depth, false);
}







var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$cf1a4dde706e4c7c$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(array, rest) {
    rest = (0, $a3a9f979efa8d2b1$export$2e2bcd8739ae039)(rest, true, true);
    return (0, $149cfed39c5c7c77$export$2e2bcd8739ae039)(array, function(value) {
        return !(0, $29d866ca41d2a758$export$2e2bcd8739ae039)(rest, value);
    });
});


var // Return a version of the array that does not contain the specified value(s).
$7707f1b0e9dc4a15$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(array, otherArrays) {
    return (0, $cf1a4dde706e4c7c$export$2e2bcd8739ae039)(array, otherArrays);
});






function $881c94c97039e92b$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $96980f2387a3b961$export$2e2bcd8739ae039)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $02efba45424ec726$export$2e2bcd8739ae039)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $29d866ca41d2a758$export$2e2bcd8739ae039)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $29d866ca41d2a758$export$2e2bcd8739ae039)(result, value)) result.push(value);
    }
    return result;
}





var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$f46648a41223c055$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)(function(arrays) {
    return (0, $881c94c97039e92b$export$2e2bcd8739ae039)((0, $a3a9f979efa8d2b1$export$2e2bcd8739ae039)(arrays, true, true));
});




function $8087ac4b37206265$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(array); i < length; i++){
        var item = array[i];
        if ((0, $29d866ca41d2a758$export$2e2bcd8739ae039)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $29d866ca41d2a758$export$2e2bcd8739ae039)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}






function $64decdbc218efa78$export$2e2bcd8739ae039(array) {
    var length = array && (0, $ef289128c6fc8166$export$2e2bcd8739ae039)(array, (0, $3605892512a788ac$export$2e2bcd8739ae039)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $8b966e0502fdfb39$export$2e2bcd8739ae039)(array, index);
    return result;
}




var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$746ca928e9bb10ee$export$2e2bcd8739ae039 = (0, $8a8c9cc20e487167$export$2e2bcd8739ae039)((0, $64decdbc218efa78$export$2e2bcd8739ae039));



function $0468522dcbf720eb$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $3605892512a788ac$export$2e2bcd8739ae039)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}


// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $ef75f5b5dfeff538$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}



function $0a9542f9e1460320$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $0e938e6b04276893$export$58adb3bec8346d0f).call(array, i, i += count));
    return result;
}







function $59cbc058ac6cbec7$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $db7cf745deae84d8$export$2e2bcd8739ae039)(obj).chain() : obj;
}


function $61a5f07bd9576f6b$export$2e2bcd8739ae039(obj) {
    (0, $667e59b41088399c$export$2e2bcd8739ae039)((0, $dc29ab65aa352cfb$export$2e2bcd8739ae039)(obj), function(name) {
        var func = (0, $db7cf745deae84d8$export$2e2bcd8739ae039)[name] = obj[name];
        (0, $db7cf745deae84d8$export$2e2bcd8739ae039).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $0e938e6b04276893$export$4cbf152802aa238).apply(args, arguments);
            return (0, $59cbc058ac6cbec7$export$2e2bcd8739ae039)(this, func.apply((0, $db7cf745deae84d8$export$2e2bcd8739ae039), args));
        };
    });
    return 0, $db7cf745deae84d8$export$2e2bcd8739ae039;
}






// Add all mutator `Array` functions to the wrapper.
(0, $667e59b41088399c$export$2e2bcd8739ae039)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $0e938e6b04276893$export$aabeece9448a227a)[name];
    (0, $db7cf745deae84d8$export$2e2bcd8739ae039).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $59cbc058ac6cbec7$export$2e2bcd8739ae039)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $667e59b41088399c$export$2e2bcd8739ae039)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $0e938e6b04276893$export$aabeece9448a227a)[name];
    (0, $db7cf745deae84d8$export$2e2bcd8739ae039).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $59cbc058ac6cbec7$export$2e2bcd8739ae039)(this, obj);
    };
});
var $0e1572bfdf784be3$export$2e2bcd8739ae039 = (0, $db7cf745deae84d8$export$2e2bcd8739ae039);




// Add all of the Underscore functions to the wrapper object.
var $0c98ba8e5ffb6ee3$var$_ = (0, $61a5f07bd9576f6b$export$2e2bcd8739ae039)($45295b0236c6430f$exports);
// Legacy Node.js API.
$0c98ba8e5ffb6ee3$var$_._ = $0c98ba8e5ffb6ee3$var$_;
var // Export the Underscore API.
$0c98ba8e5ffb6ee3$export$2e2bcd8739ae039 = $0c98ba8e5ffb6ee3$var$_;






var $7fPBF = parcelRequire("7fPBF");
var $1bfc5778dcd4841a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1bfc5778dcd4841a$exports = (parcelRequire("iDep4"))();


/**
 * Created by ivo on 27.01.17.
 */ /* global window, exports, define */ var $6fdc011cedd7e530$export$63151d8bb18a49f9;
var $6fdc011cedd7e530$export$790fb69b1a2884f9;
!function() {
    'use strict';
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[\+\-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, match, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === 'string') output += parse_tree[i];
            else if (Array.isArray(parse_tree[i])) {
                match = parse_tree[i] // convenience purposes only
                ;
                if (match[2]) {
                    arg = argv[cursor];
                    for(k = 0; k < match[2].length; k++){
                        if (!arg.hasOwnProperty(match[2][k])) throw new Error(sprintf('[sprintf] property "%s" does not exist', match[2][k]));
                        arg = arg[match[2][k]];
                    }
                } else if (match[1]) arg = argv[match[1]];
                else arg = argv[cursor++];
                if (re.not_type.test(match[8]) && re.not_primitive.test(match[8]) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(match[8]) && typeof arg !== 'number' && isNaN(arg)) throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg));
                if (re.number.test(match[8])) is_positive = arg >= 0;
                switch(match[8]){
                    case 'b':
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10);
                        break;
                    case 'j':
                        arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0);
                        break;
                    case 'e':
                        arg = match[7] ? parseFloat(arg).toExponential(match[7]) : parseFloat(arg).toExponential();
                        break;
                    case 'f':
                        arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg);
                        break;
                    case 'g':
                        arg = match[7] ? String(Number(arg.toPrecision(match[7]))) : parseFloat(arg);
                        break;
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case 's':
                        arg = String(arg);
                        arg = match[7] ? arg.substring(0, match[7]) : arg;
                        break;
                    case 't':
                        arg = String(!!arg);
                        arg = match[7] ? arg.substring(0, match[7]) : arg;
                        break;
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = match[7] ? arg.substring(0, match[7]) : arg;
                        break;
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case 'v':
                        arg = arg.valueOf();
                        arg = match[7] ? arg.substring(0, match[7]) : arg;
                        break;
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(match[8])) output += arg;
                else {
                    if (re.number.test(match[8]) && (!is_positive || match[3])) {
                        sign = is_positive ? '+' : '-';
                        arg = arg.toString().replace(re.sign, '');
                    } else sign = '';
                    pad_character = match[4] ? match[4] === '0' ? '0' : match[4].charAt(1) : ' ';
                    pad_length = match[6] - (sign + arg).length;
                    pad = match[6] ? pad_length > 0 ? pad_character.repeat(pad_length) : '' : '';
                    output += match[5] ? sign + arg + pad : pad_character === '0' ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push('%');
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ''){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError('[sprintf] failed to parse named argument key');
                        }
                    } else throw new SyntaxError('[sprintf] failed to parse named argument key');
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported');
                parse_tree.push(match);
            } else throw new SyntaxError('[sprintf] unexpected placeholder');
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $6fdc011cedd7e530$export$63151d8bb18a49f9 = sprintf;
    $6fdc011cedd7e530$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf;
        window['vsprintf'] = vsprintf;
        if (typeof define === 'function' && define['amd']) define(function() {
            return {
                'sprintf': sprintf,
                'vsprintf': vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }();


var $03277cb1bca63048$export$2e2bcd8739ae039 = window;
const $03277cb1bca63048$export$c31045a889981f00 = window.menu_translate;
const $03277cb1bca63048$export$b0c1cba25cb0c370 = window.clear_old_page;
const $03277cb1bca63048$export$7a4a0cd5f0766c02 = window.trans_table;
const $03277cb1bca63048$export$79bfeae2f91c13c1 = window.lang_decimalSep;
const $03277cb1bca63048$export$9bdf5f3cf3933620 = window.load_conf;
const $03277cb1bca63048$export$fe7ddefb28e95f52 = window.limit_strlen;
const $03277cb1bca63048$export$5ea928c9faf85bd3 = window.alert;
const $03277cb1bca63048$export$5711a0d2f3413f29 = window.recorrect_all_grid_rows;
const $03277cb1bca63048$export$bf0f39e0389ca517 = window.make_a_results_page;
const $03277cb1bca63048$export$3e3e3b72c058f99 = window.make_a_measurement_page;
const $03277cb1bca63048$export$2eda0396a2eaa113 = window.getWagonInfo;


// Global language setting:
let $865532d99f221026$var$lang_idx = 0;
function $865532d99f221026$export$63f71167c6a02e5f(idx) {
    $865532d99f221026$var$lang_idx = idx;
}
function $865532d99f221026$export$2ece3fedefe44bb9() {
    return $865532d99f221026$var$lang_idx;
}
function $865532d99f221026$export$fb8a20568f22b931() {
    let sep = (0, $03277cb1bca63048$export$79bfeae2f91c13c1)[$865532d99f221026$var$lang_idx];
    if (!sep) return '.';
    return sep;
}
function $865532d99f221026$export$4fa6d59685552a7c(s) {
    try {
        if ((0, $03277cb1bca63048$export$7a4a0cd5f0766c02)[s]) {
            let tt = (0, $03277cb1bca63048$export$7a4a0cd5f0766c02)[s][$865532d99f221026$var$lang_idx];
            if (tt) return tt;
            return s;
        } else return s;
    } catch (err) {
        return s;
    }
}
function $865532d99f221026$var$t(arg1, ...args) {
    return args.length > 0 ? (0, $6fdc011cedd7e530$export$790fb69b1a2884f9)($865532d99f221026$export$4fa6d59685552a7c(arg1), args) : $865532d99f221026$export$4fa6d59685552a7c(arg1);
}
var $865532d99f221026$export$2e2bcd8739ae039 = $865532d99f221026$var$t;


const $e9899d828d65283a$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
};
const $e9899d828d65283a$var$defaultProps = {};
class $e9899d828d65283a$var$T extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    trans(text) {
        return (0, $865532d99f221026$export$2e2bcd8739ae039)(text);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", null, this.trans(this.props.children));
    }
}
$e9899d828d65283a$var$T.propTypes = $e9899d828d65283a$var$propTypes;
$e9899d828d65283a$var$T.defaultProps = $e9899d828d65283a$var$defaultProps;
var $e9899d828d65283a$export$2e2bcd8739ae039 = $e9899d828d65283a$var$T;



var $7fPBF = parcelRequire("7fPBF");


const $1851c71e1097d083$var$propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
};
const $1851c71e1097d083$var$defaultProps = {};
class $1851c71e1097d083$var$Tlabel extends (0, $e9899d828d65283a$export$2e2bcd8739ae039) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            className: this.props.className,
            style: this.props.style
        }, this.trans(this.props.children));
    }
}
$1851c71e1097d083$var$Tlabel.propTypes = $1851c71e1097d083$var$propTypes;
$1851c71e1097d083$var$Tlabel.defaultProps = $1851c71e1097d083$var$defaultProps;
var $1851c71e1097d083$export$2e2bcd8739ae039 = $1851c71e1097d083$var$Tlabel;



var $7fPBF = parcelRequire("7fPBF");


const $37d2586b3195e7c1$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node.isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    /**
   * onClick(onClickParam, value);
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onClickParam: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
};
const $37d2586b3195e7c1$var$defaultProps = {
    className: 'btn btn-default btn-sm',
    type: "submit"
};
class $37d2586b3195e7c1$var$Tbutton extends (0, $e9899d828d65283a$export$2e2bcd8739ae039) {
    onClick() {
        if (this.props.onClick) this.props.onClick(this.props.onClickParam, this.props.value);
    }
    render() {
        let buttonStyle = {};
        if (this.props.width) buttonStyle.width = this.props.width;
        let children = this.props.children;
        if (typeof children !== 'object') children = this.trans(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: this.props.type,
            className: this.props.className,
            value: this.props.value == null ? "" : this.props.value,
            onClick: this.onClick,
            style: buttonStyle
        }, children);
    }
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
}
$37d2586b3195e7c1$var$Tbutton.propTypes = $37d2586b3195e7c1$var$propTypes;
$37d2586b3195e7c1$var$Tbutton.defaultProps = $37d2586b3195e7c1$var$defaultProps;
var $37d2586b3195e7c1$export$2e2bcd8739ae039 = $37d2586b3195e7c1$var$Tbutton;



var $7fPBF = parcelRequire("7fPBF");

var $5fe6799c90391c08$exports = {};
'use strict';
Object.defineProperty($5fe6799c90391c08$exports, "__esModule", {
    value: true
});
var $5fe6799c90391c08$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5fe6799c90391c08$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $5fe6799c90391c08$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $5fe6799c90391c08$var$React = $5fe6799c90391c08$var$_interopRequireWildcard($7fPBF);

var $5fe6799c90391c08$var$_reactDom2 = $5fe6799c90391c08$var$_interopRequireDefault($b4ba1c853f6e1116$exports);
function $5fe6799c90391c08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5fe6799c90391c08$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $5fe6799c90391c08$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5fe6799c90391c08$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5fe6799c90391c08$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5fe6799c90391c08$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5fe6799c90391c08$var$FileInput = function(_React$Component) {
    $5fe6799c90391c08$var$_inherits(FileInput, _React$Component);
    function FileInput(props) {
        $5fe6799c90391c08$var$_classCallCheck(this, FileInput);
        var _this = $5fe6799c90391c08$var$_possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call(this, props));
        // FileReader compatibility warning.
        _this.handleChange = function(e) {
            var files = Array.prototype.slice.call(e.target.files); // Convert into Array
            var readAs = (_this.props.as || 'url').toLowerCase();
            // Build Promise List, each promise resolved by FileReader.onload.
            Promise.all(files.map(function(file) {
                return new Promise(function(resolve, reject) {
                    var reader = new FileReader();
                    reader.onload = function(result) {
                        // Resolve both the FileReader result and its original file.
                        resolve([
                            result,
                            file
                        ]);
                    };
                    // Read the file with format based on this.props.as.
                    switch(readAs){
                        case 'binary':
                            reader.readAsBinaryString(file);
                            break;
                        case 'buffer':
                            reader.readAsArrayBuffer(file);
                            break;
                        case 'text':
                            reader.readAsText(file);
                            break;
                        case 'url':
                            reader.readAsDataURL(file);
                            break;
                    }
                });
            })).then(function(zippedResults) {
                // Run the callback after all files have been read.
                _this.props.onChange(e, zippedResults);
            });
        };
        _this.triggerInput = function() {
            var input = $5fe6799c90391c08$var$_reactDom2.default.findDOMNode(_this._reactFileReaderInput);
            if (input) input.click();
        };
        var win = (typeof window === 'undefined' ? 'undefined' : $5fe6799c90391c08$var$_typeof(window)) === 'object' ? window : {};
        if (!win.File || !win.FileReader || !win.FileList || !win.Blob) console.warn("[react-file-reader-input] Some file APIs detected as not supported. File reader functionality may not fully work.");
        return _this;
    }
    $5fe6799c90391c08$var$_createClass(FileInput, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, as = _props.as, children = _props.children, style = _props.style, props = $5fe6799c90391c08$var$_objectWithoutProperties(_props, [
                    'as',
                    'children',
                    'style'
                ]);
                var hiddenInputStyle = children ? {
                    // If user passes in children, display children and hide input.
                    position: 'absolute',
                    top: '-9999px'
                } : {};
                return $5fe6799c90391c08$var$React.createElement('div', {
                    className: '_react-file-reader-input',
                    onClick: this.triggerInput,
                    style: style
                }, $5fe6799c90391c08$var$React.createElement('input', $5fe6799c90391c08$var$_extends({}, props, {
                    type: 'file',
                    ref: function ref(c) {
                        _this2._reactFileReaderInput = c;
                    },
                    onChange: this.handleChange,
                    onClick: function onClick() {
                        _this2._reactFileReaderInput.value = null;
                    },
                    style: hiddenInputStyle
                })), children);
            }
        }
    ]);
    return FileInput;
}($5fe6799c90391c08$var$React.Component);
$5fe6799c90391c08$exports.default = $5fe6799c90391c08$var$FileInput;



const $2c6d4165bfc0f946$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node.isRequired,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
        'binary',
        'buffer',
        'text',
        'url'
    ]),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    accept: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    button: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * onClick(onClickParam, fileData, fileName);
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onClickParam: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any
};
const $2c6d4165bfc0f946$var$defaultProps = {
    as: 'binary',
    button: false
};
class $2c6d4165bfc0f946$var$Tfile extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    onChange(e, results) {
        if (this.props.onClick && results.length > 0) {
            const [pe, file] = results[0];
            this.props.onClick(this.props.onClickParam, pe.target.result, file.name);
            this.setState({
                fileName: file.name
            });
        }
    }
    onClick(e) {
        e.target.value = null;
    }
    renderButton() {
        if (!this.props.button) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: this.props.className,
            width: this.props.width
        }, this.props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "input-group " + this.props.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "input-group-addon",
            style: {
                cursor: "pointer"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
            className: "input-group-text"
        }, this.props.children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
            type: "text",
            className: "form-control",
            value: this.state.fileName || "",
            readOnly: true,
            style: {
                cursor: "pointer"
            }
        }));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5fe6799c90391c08$exports))), {
            as: this.props.as,
            accept: this.props.accept,
            onChange: this.onChange,
            onClick: this.onClick
        }, this.renderButton());
    }
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.state = {
            fileName: null
        };
    }
}
$2c6d4165bfc0f946$var$Tfile.propTypes = $2c6d4165bfc0f946$var$propTypes;
$2c6d4165bfc0f946$var$Tfile.defaultProps = $2c6d4165bfc0f946$var$defaultProps;
var $2c6d4165bfc0f946$export$2e2bcd8739ae039 = $2c6d4165bfc0f946$var$Tfile;


function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}



var $7fPBF = parcelRequire("7fPBF");



const $22201bd6542c8dbc$var$propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Väärtuse andmetüüp:
   * string - string
   * number - number (teisendatakse väärtus reaalarvuks ja tagasi)
   * integer - täisarv (teisendatakse väärtus täisarvuks ja tagasi)
   */ valueType: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    valueDecimals: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any
};
const $22201bd6542c8dbc$var$defaultProps = {
    valueType: 'string',
    value: null
};
class $22201bd6542c8dbc$var$Tvalue extends (0, $e9899d828d65283a$export$2e2bcd8739ae039) {
    componentWillReceiveProps(newProps) {
        this.setState({
            value: this.valueToString(newProps.value),
            isValid: this.isValid(newProps.value)
        });
    }
    isValid(value) {
        if (value == null || value === '') return true;
        value = value.toString();
        value = value.trim();
        let result;
        switch(this.props.valueType){
            case 'number':
                value = value.replace(',', '.').replace(' ', '');
                result = Number.parseFloat(value);
                return !Number.isNaN(result);
            case 'integer':
                result = Number.parseInt(value);
                return !Number.isNaN(result);
            default:
                return true;
        }
    }
    valueToString(value) {
        if (value == null || Number.isNaN(value)) return '';
        switch(this.props.valueType){
            case 'number':
                value = this.round(value, this.props.valueDecimals);
                if (value === undefined || value === null) return '';
                let converted = value.toString();
                let sep = (0, $865532d99f221026$export$fb8a20568f22b931)();
                if (sep === '.') return converted;
                return converted.replace('.', ',');
            case 'integer':
                if (Number.isNaN(value)) return '';
            // eslint-disable-next-line no-fallthrough
            default:
                return value.toString();
        }
    }
    round(value, decimals) {
        if (decimals === undefined || decimals === null || decimals === '') decimals = 0;
        return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    // return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    }
    valueFromString(value) {
        if (value == null) return null;
        value = value.trim();
        switch(this.props.valueType){
            case 'number':
                if (value === '') return null;
                value = value.replace(',', '.').replace(' ', '');
                let r1 = Number.parseFloat(value);
                if (Number.isNaN(r1)) return null;
                return r1;
            case 'integer':
                if (value === '') return null;
                let r2 = Number.parseInt(value);
                if (Number.isNaN(r2)) return null;
                return r2;
            default:
                return value;
        }
    }
    render() {
        let style = {};
        if (this.props.style) style = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.props.style);
        if (this.props.width) {
            if (!style.float) style.float = 'left';
            style.width = this.props.width;
        }
        let classname = '';
        if (this.props.className) classname += ' ' + this.props.className;
        if (!this.state.isValid) classname += ' invalid';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
            id: this.props.id,
            className: classname,
            style: style
        }, this.state.value == null ? "" : this.state.value);
    }
    constructor(props){
        super(props);
        this.state = {
            value: this.valueToString(props.value),
            isValid: this.isValid(props.value)
        };
    }
}
$22201bd6542c8dbc$var$Tvalue.propTypes = $22201bd6542c8dbc$var$propTypes;
$22201bd6542c8dbc$var$Tvalue.defaultProps = $22201bd6542c8dbc$var$defaultProps;
var $22201bd6542c8dbc$export$2e2bcd8739ae039 = $22201bd6542c8dbc$var$Tvalue;



var $7fPBF = parcelRequire("7fPBF");


//import Legacy from '../Legacy';
const $909670d6855077c9$var$propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    /**
   * Input välja väärtuse andmetüüp:
   * string - string
   * number - number (teisendatakse väärtus reaalarvuks ja tagasi)
   * integer - täisarv (teisendatakse väärtus täisarvuks ja tagasi)
   */ valueType: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    valueDecimals: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * onChange(onChangeParam, value)
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onChangeParam: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool
};
const $909670d6855077c9$var$defaultProps = {
    type: 'text',
    valueType: 'string',
    value: null,
    className: "smallinput",
    disabled: false
};
class $909670d6855077c9$var$Tinput extends (0, $22201bd6542c8dbc$export$2e2bcd8739ae039) {
    componentWillReceiveProps(newProps) {
        let numValue = this.valueFromString(this.state.value);
        if (numValue !== newProps.value) this.setState({
            value: this.valueToString(newProps.value),
            isValid: this.isValid(newProps.value)
        });
    }
    onChange(e) {
        e.preventDefault();
        let isValid = this.isValid(e.target.value);
        if (this.props.onChange) {
            let value = this.valueFromString(e.target.value);
            this.setState({
                value: e.target.value,
                isValid: isValid
            }, (function() {
                this.props.onChange(this.props.onChangeParam, value);
            }).bind(this));
        } else this.setState({
            value: e.target.value,
            isValid: isValid
        });
    }
    onBlur(e) {
        e.preventDefault();
        let value = this.valueFromString(e.target.value);
        if (this.props.onChange) this.props.onChange(this.props.onChangeParam, value);
    }
    onKeyUp(e) {
        if (e.keyCode == 13 && this.props.onEnter) this.props.onEnter(e);
    }
    render() {
        let style = {};
        if (this.props.style) style = this.props.style;
        if (this.props.width) style.width = this.props.width;
        let classname = 'form-control';
        if (this.props.className) classname += ' ' + this.props.className;
        if (!this.state.isValid) classname += ' invalid';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
            id: this.props.id,
            type: this.props.type,
            className: classname,
            style: style,
            value: this.state.value == null ? "" : this.state.value,
            onBlur: this.onBlur,
            onChange: this.onChange,
            onKeyUp: this.props.onEnter == null ? null : this.onKeyUp,
            disabled: this.props.disabled
        });
    }
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }
}
$909670d6855077c9$var$Tinput.propTypes = $909670d6855077c9$var$propTypes;
$909670d6855077c9$var$Tinput.defaultProps = $909670d6855077c9$var$defaultProps;
var $909670d6855077c9$export$2e2bcd8739ae039 = $909670d6855077c9$var$Tinput;



var $7fPBF = parcelRequire("7fPBF");


const $a37cdf8f481b7468$var$propTypes = {
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * onClick(onClickParam, value);
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onClickParam: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any
};
const $a37cdf8f481b7468$var$defaultProps = {};
class $a37cdf8f481b7468$var$Tradio extends (0, $e9899d828d65283a$export$2e2bcd8739ae039) {
    onChange(e) {
        // e.preventDefault();
        if (this.props.onClick) this.props.onClick(this.props.onClickParam, this.props.value);
    }
    render() {
        let className = '';
        if (this.props.inline) className = "radio-inline";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
            type: "radio",
            name: this.props.name,
            checked: this.props.checked,
            value: this.props.value == null ? "" : this.props.value,
            onChange: this.onChange
        }), " ", this.trans(this.props.children));
    }
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
    }
}
$a37cdf8f481b7468$var$Tradio.propTypes = $a37cdf8f481b7468$var$propTypes;
$a37cdf8f481b7468$var$Tradio.defaultProps = $a37cdf8f481b7468$var$defaultProps;
var $a37cdf8f481b7468$export$2e2bcd8739ae039 = $a37cdf8f481b7468$var$Tradio;



var $7fPBF = parcelRequire("7fPBF");


const $74065ae0ba4bb816$var$propTypes = {
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    /**
   * onClick(onClickParam, value);
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onClickParam: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any
};
const $74065ae0ba4bb816$var$defaultProps = {};
class $74065ae0ba4bb816$var$Tcheckbox extends (0, $e9899d828d65283a$export$2e2bcd8739ae039) {
    onChange(e) {
        // e.preventDefault();
        if (this.props.onClick) this.props.onClick(this.props.onClickParam, e.target.checked ? this.props.value : null);
    }
    render() {
        let className = '';
        if (this.props.inline) className = "checkbox-inline";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
            type: "checkbox",
            name: this.props.name,
            checked: this.props.checked,
            value: this.props.value == null ? "" : this.props.value,
            onChange: this.onChange
        }), " ", this.trans(this.props.children));
    }
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
    }
}
$74065ae0ba4bb816$var$Tcheckbox.propTypes = $74065ae0ba4bb816$var$propTypes;
$74065ae0ba4bb816$var$Tcheckbox.defaultProps = $74065ae0ba4bb816$var$defaultProps;
var $74065ae0ba4bb816$export$2e2bcd8739ae039 = $74065ae0ba4bb816$var$Tcheckbox;



var $7fPBF = parcelRequire("7fPBF");


/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ var $32592e4cfd3024bd$var$PI_OVER_180 = Math.PI / 180;
function $32592e4cfd3024bd$var$detectBrowser() {
    return typeof window !== 'undefined' && (({}).toString.call(window) === '[object Window]' || ({}).toString.call(window) === '[object global]');
}
const $32592e4cfd3024bd$export$442f1a04865e4790 = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : {};
const $32592e4cfd3024bd$export$b9f99057a3c7692 = {
    _global: $32592e4cfd3024bd$export$442f1a04865e4790,
    version: '8.4.3',
    isBrowser: $32592e4cfd3024bd$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $32592e4cfd3024bd$export$b9f99057a3c7692.angleDeg ? angle * $32592e4cfd3024bd$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    pixelRatio: typeof window !== 'undefined' && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $32592e4cfd3024bd$export$b9f99057a3c7692['DD'].isDragging;
    },
    isDragReady () {
        return !!$32592e4cfd3024bd$export$b9f99057a3c7692['DD'].node;
    },
    releaseCanvasOnDestroy: true,
    document: $32592e4cfd3024bd$export$442f1a04865e4790.document,
    _injectGlobal (Konva) {
        $32592e4cfd3024bd$export$442f1a04865e4790.Konva = Konva;
    }
};
const $32592e4cfd3024bd$export$f7a70d87a5e829eb = (NodeClass)=>{
    $32592e4cfd3024bd$export$b9f99057a3c7692[NodeClass.prototype.getClassName()] = NodeClass;
};
$32592e4cfd3024bd$export$b9f99057a3c7692._injectGlobal($32592e4cfd3024bd$export$b9f99057a3c7692);



class $3a91387846844890$export$563a914cafbdc389 {
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $3a91387846844890$export$563a914cafbdc389(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        var m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        var c = Math.cos(rad);
        var s = Math.sin(rad);
        var m11 = this.m[0] * c + this.m[2] * s;
        var m12 = this.m[1] * c + this.m[3] * s;
        var m21 = this.m[0] * -s + this.m[2] * c;
        var m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        var m11 = this.m[0] + this.m[2] * sy;
        var m12 = this.m[1] + this.m[3] * sy;
        var m21 = this.m[2] + this.m[0] * sx;
        var m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        var m0 = this.m[3] * d;
        var m1 = -this.m[1] * d;
        var m2 = -this.m[2] * d;
        var m3 = this.m[0] * d;
        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        var a = this.m[0];
        var b = this.m[1];
        var c = this.m[2];
        var d = this.m[3];
        var e = this.m[4];
        var f = this.m[5];
        var delta = a * d - b * c;
        let result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            var r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            var s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $3a91387846844890$export$f8f26dd395d7e1bd._getRotation(result.rotation);
        return result;
    }
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
}
var $3a91387846844890$var$OBJECT_ARRAY = '[object Array]', $3a91387846844890$var$OBJECT_NUMBER = '[object Number]', $3a91387846844890$var$OBJECT_STRING = '[object String]', $3a91387846844890$var$OBJECT_BOOLEAN = '[object Boolean]', $3a91387846844890$var$PI_OVER_DEG180 = Math.PI / 180, $3a91387846844890$var$DEG180_OVER_PI = 180 / Math.PI, $3a91387846844890$var$HASH = '#', $3a91387846844890$var$EMPTY_STRING = '', $3a91387846844890$var$ZERO = '0', $3a91387846844890$var$KONVA_WARNING = 'Konva warning: ', $3a91387846844890$var$KONVA_ERROR = 'Konva error: ', $3a91387846844890$var$RGB_PAREN = 'rgb(', $3a91387846844890$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $3a91387846844890$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, $3a91387846844890$var$animQueue = [];
const $3a91387846844890$var$req = typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
const $3a91387846844890$export$f8f26dd395d7e1bd = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $3a91387846844890$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $3a91387846844890$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $3a91387846844890$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $3a91387846844890$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== 'string') return false;
        var firstChar = selector[0];
        return firstChar === '#' || firstChar === '.' || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $3a91387846844890$var$animQueue.push(callback);
        if ($3a91387846844890$var$animQueue.length === 1) $3a91387846844890$var$req(function() {
            const queue = $3a91387846844890$var$animQueue;
            $3a91387846844890$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        var canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        return document.createElement('img');
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        var imageObj = $3a91387846844890$export$f8f26dd395d7e1bd.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($3a91387846844890$var$HASH, $3a91387846844890$var$EMPTY_STRING);
        var bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        var randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $3a91387846844890$var$ZERO + randColor;
        return $3a91387846844890$var$HASH + randColor;
    },
    getRGB (color) {
        var rgb;
        if (color in $3a91387846844890$var$COLORS) {
            rgb = $3a91387846844890$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $3a91387846844890$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $3a91387846844890$var$RGB_PAREN) {
            rgb = $3a91387846844890$var$RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || 'black';
        return $3a91387846844890$export$f8f26dd395d7e1bd._namedColorToRBA(str) || $3a91387846844890$export$f8f26dd395d7e1bd._hex3ColorToRGBA(str) || $3a91387846844890$export$f8f26dd395d7e1bd._hex4ColorToRGBA(str) || $3a91387846844890$export$f8f26dd395d7e1bd._hex6ColorToRGBA(str) || $3a91387846844890$export$f8f26dd395d7e1bd._hex8ColorToRGBA(str) || $3a91387846844890$export$f8f26dd395d7e1bd._rgbColorToRGBA(str) || $3a91387846844890$export$f8f26dd395d7e1bd._rgbaColorToRGBA(str) || $3a91387846844890$export$f8f26dd395d7e1bd._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        var c = $3a91387846844890$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === '%') return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        var retObj = {};
        for(var key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $3a91387846844890$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $3a91387846844890$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $3a91387846844890$export$f8f26dd395d7e1bd.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
        return $3a91387846844890$export$f8f26dd395d7e1bd.degToRad(deg);
    },
    _radToDeg (rad) {
        $3a91387846844890$export$f8f26dd395d7e1bd.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
        return $3a91387846844890$export$f8f26dd395d7e1bd.radToDeg(rad);
    },
    _getRotation (radians) {
        return (0, $32592e4cfd3024bd$export$b9f99057a3c7692).angleDeg ? $3a91387846844890$export$f8f26dd395d7e1bd.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($3a91387846844890$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($3a91387846844890$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!(0, $32592e4cfd3024bd$export$b9f99057a3c7692).showWarnings) return;
        console.warn($3a91387846844890$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(var key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        var x, y, dist;
        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        var pc = $3a91387846844890$export$f8f26dd395d7e1bd.cloneObject(pt);
        var dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            var p2 = line[(i + 1) % line.length];
            var proj = $3a91387846844890$export$f8f26dd395d7e1bd._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            var px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        var n, start = [], end = [];
        if (startArray.length > endArray.length) {
            var temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        var newStart = [];
        end.forEach(function(point) {
            var pr = $3a91387846844890$export$f8f26dd395d7e1bd._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        var desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(var key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $3a91387846844890$export$f8f26dd395d7e1bd._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($3a91387846844890$export$f8f26dd395d7e1bd._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(var key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!(0, $32592e4cfd3024bd$export$b9f99057a3c7692).releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(topLeft, 0);
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    }
};






function $7b17b5b00aa2cb10$var$_formatValue(val) {
    if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === '[object Number]') return val;
    if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $7b17b5b00aa2cb10$export$af51e4581c640b27(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $7b17b5b00aa2cb10$export$7078afdc21938e7(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
function $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c() {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $3a91387846844890$export$f8f26dd395d7e1bd)._isNumber(val)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $7b17b5b00aa2cb10$export$7d4ab1842c1b264b(noOfElements) {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        let isNumber = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._isNumber(val);
        let isValidArray = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
        return val;
    };
}
function $7b17b5b00aa2cb10$export$3b7df2720ef33404() {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isNumber = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._isNumber(val);
        var isAuto = val === 'auto';
        if (!(isNumber || isAuto)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $7b17b5b00aa2cb10$export$5837c5b6cc5b4d63() {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $3a91387846844890$export$f8f26dd395d7e1bd)._isString(val)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $7b17b5b00aa2cb10$export$9c72f966a828cc68() {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isString = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._isString(val);
        const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' || val && val.addColorStop;
        if (!(isString || isGradient)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $7b17b5b00aa2cb10$export$61d6863134de1cd() {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $3a91387846844890$export$f8f26dd395d7e1bd)._isFunction(val)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
function $7b17b5b00aa2cb10$export$42b6f8f340e9a165() {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!(0, $3a91387846844890$export$f8f26dd395d7e1bd)._isArray(val)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!(0, $3a91387846844890$export$f8f26dd395d7e1bd)._isNumber(item)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('"' + attr + '" attribute has non numeric element ' + item + '. Make sure that all elements are numbers.');
        });
        return val;
    };
}
function $7b17b5b00aa2cb10$export$147fc8b6cd20fda1() {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isBool = val === true || val === false;
        if (!isBool) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $7b17b5b00aa2cb10$export$5c1978fb8431d4a1(components) {
    if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!(0, $3a91387846844890$export$f8f26dd395d7e1bd).isObject(val)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($7b17b5b00aa2cb10$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


var $45295774f0983e19$var$GET = 'get', $45295774f0983e19$var$SET = 'set';
const $45295774f0983e19$export$8354032f3852ec50 = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $45295774f0983e19$export$8354032f3852ec50.addGetter(constructor, attr, def);
        $45295774f0983e19$export$8354032f3852ec50.addSetter(constructor, attr, validator, after);
        $45295774f0983e19$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        var method = $45295774f0983e19$var$GET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        var method = $45295774f0983e19$var$SET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(attr);
        if (!constructor.prototype[method]) $45295774f0983e19$export$8354032f3852ec50.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        var method = $45295774f0983e19$var$SET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        var len = components.length, capitalize = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize, getter = $45295774f0983e19$var$GET + capitalize(attr), setter = $45295774f0983e19$var$SET + capitalize(attr), n, component;
        constructor.prototype[getter] = function() {
            var ret = {};
            for(n = 0; n < len; n++){
                component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        var basicValidator = (0, $7b17b5b00aa2cb10$export$5c1978fb8431d4a1)(components);
        constructor.prototype[setter] = function(val) {
            var oldVal = this.attrs[attr], key;
            if (validator) val = validator.call(this, val);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $45295774f0983e19$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        var capitalizedAttr = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(attr), setter = $45295774f0983e19$var$SET + capitalizedAttr, getter = $45295774f0983e19$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Adding deprecated ' + attr);
        var method = $45295774f0983e19$var$GET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(attr);
        var message = attr + ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function() {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).error(message);
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $45295774f0983e19$export$8354032f3852ec50.addSetter(constructor, attr, validator, function() {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).error(message);
        });
        $45295774f0983e19$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).each(methods, function(oldMethodName, newMethodName) {
            var method = constructor.prototype[newMethodName];
            var oldGetter = $45295774f0983e19$var$GET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            var oldSetter = $45295774f0983e19$var$SET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





function $c1663d221052256b$var$simplifyArray(arr) {
    var retArr = [], len = arr.length, util = (0, $3a91387846844890$export$f8f26dd395d7e1bd), n, val;
    for(n = 0; n < len; n++){
        val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + '';
        retArr.push(val);
    }
    return retArr;
}
var $c1663d221052256b$var$COMMA = ',', $c1663d221052256b$var$OPEN_PAREN = '(', $c1663d221052256b$var$CLOSE_PAREN = ')', $c1663d221052256b$var$OPEN_PAREN_BRACKET = '([', $c1663d221052256b$var$CLOSE_BRACKET_PAREN = '])', $c1663d221052256b$var$SEMICOLON = ';', $c1663d221052256b$var$DOUBLE_PAREN = '()', $c1663d221052256b$var$EQUALS = '=', $c1663d221052256b$var$CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate'
];
var $c1663d221052256b$var$CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled'
];
const $c1663d221052256b$var$traceArrMax = 100;
class $c1663d221052256b$export$841858b892ce1f4c {
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        var traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $c1663d221052256b$var$DOUBLE_PAREN;
                else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isArray(args[0])) str += $c1663d221052256b$var$OPEN_PAREN_BRACKET + args.join($c1663d221052256b$var$COMMA) + $c1663d221052256b$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === 'number' ? Math.floor(a) : a);
                    str += $c1663d221052256b$var$OPEN_PAREN + args.join($c1663d221052256b$var$COMMA) + $c1663d221052256b$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $c1663d221052256b$var$EQUALS + trace.val;
            }
            str += $c1663d221052256b$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        var traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $c1663d221052256b$var$traceArrMax) traceArr.shift();
    }
    reset() {
        var pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        var canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr('lineCap', lineCap);
    }
    _applyOpacity(shape) {
        var absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr('globalAlpha', absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr('lineJoin', lineJoin);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(a0, a1, a2, a3, a4, a5) {
        this._context.arc(a0, a1, a2, a3, a4, a5);
    }
    arcTo(a0, a1, a2, a3, a4) {
        this._context.arcTo(a0, a1, a2, a3, a4);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(a0, a1, a2, a3, a4, a5) {
        this._context.bezierCurveTo(a0, a1, a2, a3, a4, a5);
    }
    clearRect(a0, a1, a2, a3) {
        this._context.clearRect(a0, a1, a2, a3);
    }
    clip() {
        this._context.clip();
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(a0, a1) {
        var a = arguments;
        if (a.length === 2) return this._context.createImageData(a0, a1);
        else if (a.length === 1) return this._context.createImageData(a0);
    }
    createLinearGradient(a0, a1, a2, a3) {
        return this._context.createLinearGradient(a0, a1, a2, a3);
    }
    createPattern(a0, a1) {
        return this._context.createPattern(a0, a1);
    }
    createRadialGradient(a0, a1, a2, a3, a4, a5) {
        return this._context.createRadialGradient(a0, a1, a2, a3, a4, a5);
    }
    drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        var a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(a0, a1, a2);
        else if (a.length === 5) _context.drawImage(a0, a1, a2, a3, a4);
        else if (a.length === 9) _context.drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8);
    }
    ellipse(a0, a1, a2, a3, a4, a5, a6, a7) {
        this._context.ellipse(a0, a1, a2, a3, a4, a5, a6, a7);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(path2d) {
        if (path2d) this._context.fill(path2d);
        else this._context.fill();
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(a0, a1, a2, a3) {
        return this._context.getImageData(a0, a1, a2, a3);
    }
    lineTo(a0, a1) {
        this._context.lineTo(a0, a1);
    }
    moveTo(a0, a1) {
        this._context.moveTo(a0, a1);
    }
    rect(a0, a1, a2, a3) {
        this._context.rect(a0, a1, a2, a3);
    }
    putImageData(a0, a1, a2) {
        this._context.putImageData(a0, a1, a2);
    }
    quadraticCurveTo(a0, a1, a2, a3) {
        this._context.quadraticCurveTo(a0, a1, a2, a3);
    }
    restore() {
        this._context.restore();
    }
    rotate(a0) {
        this._context.rotate(a0);
    }
    save() {
        this._context.save();
    }
    scale(a0, a1) {
        this._context.scale(a0, a1);
    }
    setLineDash(a0) {
        if (this._context.setLineDash) this._context.setLineDash(a0);
        else if ('mozDash' in this._context) this._context['mozDash'] = a0;
        else if ('webkitLineDash' in this._context) this._context['webkitLineDash'] = a0;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a0, a1, a2, a3, a4, a5) {
        this._context.setTransform(a0, a1, a2, a3, a4, a5);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(a0, a1, a2, a3) {
        this._context.strokeText(a0, a1, a2, a3);
    }
    transform(a0, a1, a2, a3, a4, a5) {
        this._context.transform(a0, a1, a2, a3, a4, a5);
    }
    translate(a0, a1) {
        this._context.translate(a0, a1);
    }
    _enableTrace() {
        var that = this, len = $c1663d221052256b$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        var func = function(methodName) {
            var origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $c1663d221052256b$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($c1663d221052256b$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            var prop = arguments[0];
            var val = arguments[1];
            if (prop === 'shadowOffsetX' || prop === 'shadowOffsetY' || prop === 'shadowBlur') val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        var def = !op || op === 'source-over';
        if (!def) this.setAttr('globalCompositeOperation', op);
    }
    constructor(canvas){
        this.canvas = canvas;
        if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
}
$c1663d221052256b$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($c1663d221052256b$export$841858b892ce1f4c.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $c1663d221052256b$export$576380cfa99ddf20 extends $c1663d221052256b$export$841858b892ce1f4c {
    _fillColor(shape) {
        var fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        var grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr('strokeStyle', grd);
        }
    }
    _stroke(shape) {
        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr('strokeStyle', shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        var color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d');
    }
}
class $c1663d221052256b$export$85eec7ef35542dce extends $c1663d221052256b$export$841858b892ce1f4c {
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            var hitStrokeWidth = shape.hitStrokeWidth();
            var strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true
        });
    }
}





var $fd8819955318e6fb$var$_pixelRatio;
function $fd8819955318e6fb$var$getDevicePixelRatio() {
    if ($fd8819955318e6fb$var$_pixelRatio) return $fd8819955318e6fb$var$_pixelRatio;
    var canvas = (0, $3a91387846844890$export$f8f26dd395d7e1bd).createCanvasElement();
    var context = canvas.getContext('2d');
    $fd8819955318e6fb$var$_pixelRatio = function() {
        var devicePixelRatio = (0, $32592e4cfd3024bd$export$b9f99057a3c7692)._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    (0, $3a91387846844890$export$f8f26dd395d7e1bd).releaseCanvas(canvas);
    return $fd8819955318e6fb$var$_pixelRatio;
}
class $fd8819955318e6fb$export$8d01c972ee8b14a9 {
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        var previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Unable to get data URL. ' + err.message + ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    }
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        var conf = config || {};
        var pixelRatio = conf.pixelRatio || (0, $32592e4cfd3024bd$export$b9f99057a3c7692).pixelRatio || $fd8819955318e6fb$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = (0, $3a91387846844890$export$f8f26dd395d7e1bd).createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
}
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($fd8819955318e6fb$export$8d01c972ee8b14a9, 'pixelRatio', undefined, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
class $fd8819955318e6fb$export$ee612225bd2e63be extends $fd8819955318e6fb$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.context = new (0, $c1663d221052256b$export$576380cfa99ddf20)(this);
        this.setSize(config.width, config.height);
    }
}
class $fd8819955318e6fb$export$43a2e1456e27dc84 extends $fd8819955318e6fb$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new (0, $c1663d221052256b$export$85eec7ef35542dce)(this);
        this.setSize(config.width, config.height);
    }
}





const $8d5bdba314ebc763$export$e34f1b340034d7f = {
    get isDragging () {
        var flag = false;
        $8d5bdba314ebc763$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging') flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        var node;
        $8d5bdba314ebc763$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $8d5bdba314ebc763$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== 'dragging') {
                var dragDistance = node.dragDistance();
                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $8d5bdba314ebc763$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                $8d5bdba314ebc763$export$e34f1b340034d7f.justDragged = true;
                (0, $32592e4cfd3024bd$export$b9f99057a3c7692)._mouseListenClick = false;
                (0, $32592e4cfd3024bd$export$b9f99057a3c7692)._touchListenClick = false;
                (0, $32592e4cfd3024bd$export$b9f99057a3c7692)._pointerListenClick = false;
                elem.dragStatus = 'stopped';
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof (0, $32592e4cfd3024bd$export$b9f99057a3c7692)['Stage'] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $8d5bdba314ebc763$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === 'stopped') elem.node.fire('dragend', {
                type: 'dragend',
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== 'dragging') $8d5bdba314ebc763$export$e34f1b340034d7f._dragElements.delete(key);
        });
    }
};
if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isBrowser) {
    window.addEventListener('mouseup', $8d5bdba314ebc763$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('touchend', $8d5bdba314ebc763$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('mousemove', $8d5bdba314ebc763$export$e34f1b340034d7f._drag);
    window.addEventListener('touchmove', $8d5bdba314ebc763$export$e34f1b340034d7f._drag);
    window.addEventListener('mouseup', $8d5bdba314ebc763$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener('touchend', $8d5bdba314ebc763$export$e34f1b340034d7f._endDragAfter, false);
}



var $ea18721d8bce411b$var$ABSOLUTE_OPACITY = 'absoluteOpacity', $ea18721d8bce411b$var$ALL_LISTENERS = 'allEventListeners', $ea18721d8bce411b$var$ABSOLUTE_TRANSFORM = 'absoluteTransform', $ea18721d8bce411b$var$ABSOLUTE_SCALE = 'absoluteScale', $ea18721d8bce411b$var$CANVAS = 'canvas', $ea18721d8bce411b$var$CHANGE = 'Change', $ea18721d8bce411b$var$CHILDREN = 'children', $ea18721d8bce411b$var$KONVA = 'konva', $ea18721d8bce411b$var$LISTENING = 'listening', $ea18721d8bce411b$var$MOUSEENTER = 'mouseenter', $ea18721d8bce411b$var$MOUSELEAVE = 'mouseleave', $ea18721d8bce411b$var$NAME = 'name', $ea18721d8bce411b$var$SET = 'set', $ea18721d8bce411b$var$SHAPE = 'Shape', $ea18721d8bce411b$var$SPACE = ' ', $ea18721d8bce411b$var$STAGE = 'stage', $ea18721d8bce411b$var$TRANSFORM = 'transform', $ea18721d8bce411b$var$UPPER_STAGE = 'Stage', $ea18721d8bce411b$var$VISIBLE = 'visible', $ea18721d8bce411b$var$TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
].join($ea18721d8bce411b$var$SPACE);
let $ea18721d8bce411b$var$idCounter = 1;
class $ea18721d8bce411b$export$85c928794f8d04d4 {
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $ea18721d8bce411b$var$TRANSFORM || attr === $ea18721d8bce411b$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        var cache = this._cache.get(attr);
        var isTransform = attr === $ea18721d8bce411b$var$TRANSFORM || attr === $ea18721d8bce411b$var$ABSOLUTE_TRANSFORM;
        var invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + 'Change.konva').join($ea18721d8bce411b$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($ea18721d8bce411b$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $ea18721d8bce411b$var$ABSOLUTE_TRANSFORM) this.fire('absoluteTransformChange');
    }
    clearCache() {
        if (this._cache.has($ea18721d8bce411b$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit } = this._cache.get($ea18721d8bce411b$var$CANVAS);
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).releaseCanvas(scene, filter, hit);
            this._cache.delete($ea18721d8bce411b$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        var conf = config || {};
        var rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent()
        });
        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        width += offset * 2 + 1;
        height += offset * 2 + 1;
        x -= offset;
        y -= offset;
        var cachedSceneCanvas = new (0, $fd8819955318e6fb$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new (0, $fd8819955318e6fb$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0
        }), cachedHitCanvas = new (0, $fd8819955318e6fb$export$43a2e1456e27dc84)({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($ea18721d8bce411b$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($ea18721d8bce411b$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($ea18721d8bce411b$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        var points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        var minX, minY, maxX, maxY;
        var trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            var transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        var cacheCanvas = this._getCachedSceneCanvas();
        var ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                var ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for(n = 0; n < len; n++){
                        filter = filters[n];
                        if (typeof filter !== 'function') {
                            (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Filter should be type of function, but got ' + typeof filter + ' instead. Please check correct filters');
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                } catch (e) {
                    (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Unable to apply filter. ' + e.message + ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    }
    on(evtStr, handler) {
        this._cache && this._cache.delete($ea18721d8bce411b$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        var events = evtStr.split($ea18721d8bce411b$var$SPACE), len = events.length, n, event, parts, baseEvent, name;
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        var events = (evtStr || '').split($ea18721d8bce411b$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($ea18721d8bce411b$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        var e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        var stopNode = this;
        this.on(event, function(evt) {
            var targets = evt.target.findAncestors(selector, true, stopNode);
            for(var i = 0; i < targets.length; i++){
                evt = (0, $3a91387846844890$export$f8f26dd395d7e1bd).cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$STAGE);
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$VISIBLE);
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        var parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        var method = 'get' + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(attr);
        if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        var parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            var key, method;
            if (!config) return this;
            for(key in config){
                if (key === $ea18721d8bce411b$var$CHILDREN) continue;
                method = $ea18721d8bce411b$var$SET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(key);
                if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($ea18721d8bce411b$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($ea18721d8bce411b$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        var layer = this.getLayer();
        var layerUnderDrag = false;
        (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== 'dragging') return;
            else if (elem.node.nodeType === 'Stage') layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        var dragSkip = !skipDragCheck && !(0, $32592e4cfd3024bd$export$b9f99057a3c7692).hitOnDragEnabled && layerUnderDrag;
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $ea18721d8bce411b$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        if (that.nodeType !== $ea18721d8bce411b$var$UPPER_STAGE) addChildren(that.getStage().getChildren());
        return index;
    }
    getDepth() {
        var depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($ea18721d8bce411b$var$TRANSFORM);
            this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        if (!this.getStage()) return null;
        var pos = this.getStage().getPointerPosition();
        if (!pos) return null;
        var transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new (0, $3a91387846844890$export$563a914cafbdc389)(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        var origTrans = this._clearTransform();
        this.attrs.x = origTrans.x;
        this.attrs.y = origTrans.y;
        delete origTrans.x;
        delete origTrans.y;
        this._clearCache($ea18721d8bce411b$var$TRANSFORM);
        var it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($ea18721d8bce411b$var$TRANSFORM);
        this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        var key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        var trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        var family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Unexpected value ' + zIndex + ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' + (this.parent.children.length - 1) + '.');
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($ea18721d8bce411b$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        var absOpacity = this.opacity();
        var parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        obj.attrs = {};
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = (0, $3a91387846844890$export$f8f26dd395d7e1bd).isObject(val) && !(0, $3a91387846844890$export$f8f26dd395d7e1bd)._isPlainObject(val) && !(0, $3a91387846844890$export$f8f26dd395d7e1bd)._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        obj.className = this.getClassName();
        return (0, $3a91387846844890$export$f8f26dd395d7e1bd)._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        var res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        var ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === 'function') return selector(this);
        var selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!(0, $3a91387846844890$export$f8f26dd395d7e1bd).isValidSelector(sel)) {
                (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        var parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($ea18721d8bce411b$var$STAGE, this._getStage);
    }
    _getStage() {
        var parent = this.getParent();
        if (parent) return parent.getStage();
        else return undefined;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($ea18721d8bce411b$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        var at;
        if (top) {
            at = new (0, $3a91387846844890$export$563a914cafbdc389)();
            this._eachAncestorReverse(function(node) {
                var transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') at.multiply(node.getTransform());
                else if (transformsEnabled === 'position') at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($ea18721d8bce411b$var$ABSOLUTE_TRANSFORM) || new (0, $3a91387846844890$export$563a914cafbdc389)();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            var transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') at.multiply(this.getTransform());
            else if (transformsEnabled === 'position') {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        var parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($ea18721d8bce411b$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        var m = this._cache.get($ea18721d8bce411b$var$TRANSFORM) || new (0, $3a91387846844890$export$563a914cafbdc389)();
        m.reset();
        var x = this.x(), y = this.y(), rotation = (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        var attrs = (0, $3a91387846844890$export$f8f26dd395d7e1bd).cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        var node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($ea18721d8bce411b$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        var box = this.getClientRect();
        var stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new (0, $fd8819955318e6fb$export$ee612225bd2e63be)({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        var mimeType = config.mimeType || null, quality = config.quality || null;
        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                (0, $3a91387846844890$export$f8f26dd395d7e1bd)._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return (0, $32592e4cfd3024bd$export$b9f99057a3c7692).dragDistance;
    }
    _off(type, name, callback) {
        var evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $ea18721d8bce411b$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            var oldName = this.name();
            var newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        var names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        var names = (this.name() || '').split(/\s/g);
        var index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    setAttr(attr, val) {
        var func = this[$ea18721d8bce411b$var$SET + (0, $3a91387846844890$export$f8f26dd395d7e1bd)._capitalize(attr)];
        if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        var oldVal = this.attrs[key];
        if (oldVal === val && !(0, $3a91387846844890$export$f8f26dd395d7e1bd).isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        var oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $ea18721d8bce411b$var$SHAPE) evt.target = this;
        var shouldStop = (eventType === $ea18721d8bce411b$var$MOUSEENTER || eventType === $ea18721d8bce411b$var$MOUSELEAVE) && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === 'Stage' && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            var stopBubble = (eventType === $ea18721d8bce411b$var$MOUSEENTER || eventType === $ea18721d8bce411b$var$MOUSELEAVE) && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        let listeners = this._cache.get($ea18721d8bce411b$var$ALL_LISTENERS);
        if (!listeners) {
            listeners = {};
            let obj = Object.getPrototypeOf(this);
            while(obj){
                if (!obj.eventListeners) {
                    obj = Object.getPrototypeOf(obj);
                    continue;
                }
                for(var event in obj.eventListeners){
                    const newEvents = obj.eventListeners[event];
                    const oldEvents = listeners[event] || [];
                    listeners[event] = newEvents.concat(oldEvents);
                }
                obj = Object.getPrototypeOf(obj);
            }
            this._cache.set($ea18721d8bce411b$var$ALL_LISTENERS, listeners);
        }
        return listeners[eventType];
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(var i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(var i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        var pointerId = evt ? evt.pointerId : undefined;
        var stage = this.getStage();
        var ap = this.getAbsolutePosition();
        var pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: 'ready',
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!(0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        var newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        var dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.get(this._id);
        if (elem) elem.dragStatus = 'stopped';
        (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._endDragBefore(evt);
        (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function(evt) {
            var shouldCheckButton = evt.evt['button'] !== undefined;
            var canDrag = !shouldCheckButton || (0, $32592e4cfd3024bd$export$b9f99057a3c7692).dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            var hasDraggingChild = false;
            (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            var stage = this.getStage();
            if (!stage) return;
            const dragElement = (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) this.stopDrag();
            else if (isReady) (0, $8d5bdba314ebc763$export$e34f1b340034d7f)._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return (0, $3a91387846844890$export$f8f26dd395d7e1bd).haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        var className = $ea18721d8bce411b$export$85c928794f8d04d4.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!(0, $32592e4cfd3024bd$export$b9f99057a3c7692)[className]) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = (0, $32592e4cfd3024bd$export$b9f99057a3c7692)[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($ea18721d8bce411b$export$85c928794f8d04d4._createNode(children[n]));
        }
        return no;
    }
    constructor(config){
        this._id = $ea18721d8bce411b$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
}
$ea18721d8bce411b$export$85c928794f8d04d4.prototype.nodeType = 'Node';
$ea18721d8bce411b$export$85c928794f8d04d4.prototype._attrsAffectingSize = [];
$ea18721d8bce411b$export$85c928794f8d04d4.prototype.eventListeners = {};
$ea18721d8bce411b$export$85c928794f8d04d4.prototype.on.call($ea18721d8bce411b$export$85c928794f8d04d4.prototype, $ea18721d8bce411b$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($ea18721d8bce411b$var$TRANSFORM);
    this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_TRANSFORM);
});
$ea18721d8bce411b$export$85c928794f8d04d4.prototype.on.call($ea18721d8bce411b$export$85c928794f8d04d4.prototype, 'visibleChange.konva', function() {
    this._clearSelfAndDescendantCache($ea18721d8bce411b$var$VISIBLE);
});
$ea18721d8bce411b$export$85c928794f8d04d4.prototype.on.call($ea18721d8bce411b$export$85c928794f8d04d4.prototype, 'listeningChange.konva', function() {
    this._clearSelfAndDescendantCache($ea18721d8bce411b$var$LISTENING);
});
$ea18721d8bce411b$export$85c928794f8d04d4.prototype.on.call($ea18721d8bce411b$export$85c928794f8d04d4.prototype, 'opacityChange.konva', function() {
    this._clearSelfAndDescendantCache($ea18721d8bce411b$var$ABSOLUTE_OPACITY);
});
const $ea18721d8bce411b$var$addGetterSetter = (0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter;
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'zIndex');
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'absolutePosition');
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'position');
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'x', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'y', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'globalCompositeOperation', 'source-over', (0, $7b17b5b00aa2cb10$export$5837c5b6cc5b4d63)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'opacity', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'name', '', (0, $7b17b5b00aa2cb10$export$5837c5b6cc5b4d63)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'id', '', (0, $7b17b5b00aa2cb10$export$5837c5b6cc5b4d63)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'rotation', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'scale', [
    'x',
    'y'
]);
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'scaleX', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'scaleY', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'skew', [
    'x',
    'y'
]);
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'skewX', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'skewY', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'offset', [
    'x',
    'y'
]);
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'offsetX', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'offsetY', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'dragDistance', null, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'width', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'height', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'listening', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'preventDefault', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'filters', null, function(val) {
    this._filterUpToDate = false;
    return val;
});
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'visible', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'transformsEnabled', 'all', (0, $7b17b5b00aa2cb10$export$5837c5b6cc5b4d63)());
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'size');
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'dragBoundFunc');
$ea18721d8bce411b$var$addGetterSetter($ea18721d8bce411b$export$85c928794f8d04d4, 'draggable', false, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
(0, $45295774f0983e19$export$8354032f3852ec50).backCompat($ea18721d8bce411b$export$85c928794f8d04d4, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
});





class $04c4a0c97d375591$export$42a852a2b6b56249 extends (0, $ea18721d8bce411b$export$85c928794f8d04d4) {
    getChildren(filterFunc) {
        if (!filterFunc) return this.children || [];
        const children = this.children || [];
        var results = [];
        children.forEach(function(child) {
            if (filterFunc(child)) results.push(child);
        });
        return results;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(var i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire('add', {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        var result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        var retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        var obj = (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        var parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        var node = (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        var arr = [];
        this.find('Shape').forEach(function(shape) {
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        var caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren('drawScene', canvas, top);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren('drawHit', canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top) {
        var _a;
        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = clipWidth && clipHeight || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            var transform = this.getAbsoluteTransform(top);
            var m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            if (clipFunc) clipFunc.call(this, context, this);
            else {
                var clipX = this.clipX();
                var clipY = this.clipY();
                context.rect(clipX, clipY, clipWidth, clipHeight);
            }
            context.clip();
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        var hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config) {
        var _a;
        config = config || {};
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        var that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            var rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        var shapes = this.find('Shape');
        var hasVisible = false;
        for(var i = 0; i < shapes.length; i++){
            var shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
    constructor(){
        super(...arguments);
        this.children = [];
    }
}
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($04c4a0c97d375591$export$42a852a2b6b56249, 'clip', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($04c4a0c97d375591$export$42a852a2b6b56249, 'clipX', undefined, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($04c4a0c97d375591$export$42a852a2b6b56249, 'clipY', undefined, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($04c4a0c97d375591$export$42a852a2b6b56249, 'clipWidth', undefined, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($04c4a0c97d375591$export$42a852a2b6b56249, 'clipHeight', undefined, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($04c4a0c97d375591$export$42a852a2b6b56249, 'clipFunc');









const $b161d2b4cc4d6a8a$var$Captures = new Map();
const $b161d2b4cc4d6a8a$var$SUPPORT_POINTER_EVENTS = (0, $32592e4cfd3024bd$export$b9f99057a3c7692)._global['PointerEvent'] !== undefined;
function $b161d2b4cc4d6a8a$export$a55e3aaa85f15b00(pointerId) {
    return $b161d2b4cc4d6a8a$var$Captures.get(pointerId);
}
function $b161d2b4cc4d6a8a$export$c30017717ce2168e(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
function $b161d2b4cc4d6a8a$export$3b42bc7c43025bad(pointerId, shape) {
    return $b161d2b4cc4d6a8a$var$Captures.get(pointerId) === shape;
}
function $b161d2b4cc4d6a8a$export$1cab177b65f17c5a(pointerId, shape) {
    $b161d2b4cc4d6a8a$export$50f687f23c43e4d9(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $b161d2b4cc4d6a8a$var$Captures.set(pointerId, shape);
    if ($b161d2b4cc4d6a8a$var$SUPPORT_POINTER_EVENTS) shape._fire('gotpointercapture', $b161d2b4cc4d6a8a$export$c30017717ce2168e(new PointerEvent('gotpointercapture')));
}
function $b161d2b4cc4d6a8a$export$50f687f23c43e4d9(pointerId, target) {
    const shape = $b161d2b4cc4d6a8a$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $b161d2b4cc4d6a8a$var$Captures.delete(pointerId);
    if ($b161d2b4cc4d6a8a$var$SUPPORT_POINTER_EVENTS) shape._fire('lostpointercapture', $b161d2b4cc4d6a8a$export$c30017717ce2168e(new PointerEvent('lostpointercapture')));
}


var $b16db84796d64696$var$STAGE = 'Stage', $b16db84796d64696$var$STRING = 'string', $b16db84796d64696$var$PX = 'px', $b16db84796d64696$var$MOUSEOUT = 'mouseout', $b16db84796d64696$var$MOUSELEAVE = 'mouseleave', $b16db84796d64696$var$MOUSEOVER = 'mouseover', $b16db84796d64696$var$MOUSEENTER = 'mouseenter', $b16db84796d64696$var$MOUSEMOVE = 'mousemove', $b16db84796d64696$var$MOUSEDOWN = 'mousedown', $b16db84796d64696$var$MOUSEUP = 'mouseup', $b16db84796d64696$var$POINTERMOVE = 'pointermove', $b16db84796d64696$var$POINTERDOWN = 'pointerdown', $b16db84796d64696$var$POINTERUP = 'pointerup', $b16db84796d64696$var$POINTERCANCEL = 'pointercancel', $b16db84796d64696$var$LOSTPOINTERCAPTURE = 'lostpointercapture', $b16db84796d64696$var$POINTEROUT = 'pointerout', $b16db84796d64696$var$POINTERLEAVE = 'pointerleave', $b16db84796d64696$var$POINTEROVER = 'pointerover', $b16db84796d64696$var$POINTERENTER = 'pointerenter', $b16db84796d64696$var$CONTEXTMENU = 'contextmenu', $b16db84796d64696$var$TOUCHSTART = 'touchstart', $b16db84796d64696$var$TOUCHEND = 'touchend', $b16db84796d64696$var$TOUCHMOVE = 'touchmove', $b16db84796d64696$var$TOUCHCANCEL = 'touchcancel', $b16db84796d64696$var$WHEEL = 'wheel', $b16db84796d64696$var$MAX_LAYERS_NUMBER = 5, $b16db84796d64696$var$EVENTS = [
    [
        $b16db84796d64696$var$MOUSEENTER,
        '_pointerenter'
    ],
    [
        $b16db84796d64696$var$MOUSEDOWN,
        '_pointerdown'
    ],
    [
        $b16db84796d64696$var$MOUSEMOVE,
        '_pointermove'
    ],
    [
        $b16db84796d64696$var$MOUSEUP,
        '_pointerup'
    ],
    [
        $b16db84796d64696$var$MOUSELEAVE,
        '_pointerleave'
    ],
    [
        $b16db84796d64696$var$TOUCHSTART,
        '_pointerdown'
    ],
    [
        $b16db84796d64696$var$TOUCHMOVE,
        '_pointermove'
    ],
    [
        $b16db84796d64696$var$TOUCHEND,
        '_pointerup'
    ],
    [
        $b16db84796d64696$var$TOUCHCANCEL,
        '_pointercancel'
    ],
    [
        $b16db84796d64696$var$MOUSEOVER,
        '_pointerover'
    ],
    [
        $b16db84796d64696$var$WHEEL,
        '_wheel'
    ],
    [
        $b16db84796d64696$var$CONTEXTMENU,
        '_contextmenu'
    ],
    [
        $b16db84796d64696$var$POINTERDOWN,
        '_pointerdown'
    ],
    [
        $b16db84796d64696$var$POINTERMOVE,
        '_pointermove'
    ],
    [
        $b16db84796d64696$var$POINTERUP,
        '_pointerup'
    ],
    [
        $b16db84796d64696$var$POINTERCANCEL,
        '_pointercancel'
    ],
    [
        $b16db84796d64696$var$LOSTPOINTERCAPTURE,
        '_lostpointercapture'
    ]
];
const $b16db84796d64696$var$EVENTS_MAP = {
    mouse: {
        [$b16db84796d64696$var$POINTEROUT]: $b16db84796d64696$var$MOUSEOUT,
        [$b16db84796d64696$var$POINTERLEAVE]: $b16db84796d64696$var$MOUSELEAVE,
        [$b16db84796d64696$var$POINTEROVER]: $b16db84796d64696$var$MOUSEOVER,
        [$b16db84796d64696$var$POINTERENTER]: $b16db84796d64696$var$MOUSEENTER,
        [$b16db84796d64696$var$POINTERMOVE]: $b16db84796d64696$var$MOUSEMOVE,
        [$b16db84796d64696$var$POINTERDOWN]: $b16db84796d64696$var$MOUSEDOWN,
        [$b16db84796d64696$var$POINTERUP]: $b16db84796d64696$var$MOUSEUP,
        [$b16db84796d64696$var$POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
    },
    touch: {
        [$b16db84796d64696$var$POINTEROUT]: 'touchout',
        [$b16db84796d64696$var$POINTERLEAVE]: 'touchleave',
        [$b16db84796d64696$var$POINTEROVER]: 'touchover',
        [$b16db84796d64696$var$POINTERENTER]: 'touchenter',
        [$b16db84796d64696$var$POINTERMOVE]: $b16db84796d64696$var$TOUCHMOVE,
        [$b16db84796d64696$var$POINTERDOWN]: $b16db84796d64696$var$TOUCHSTART,
        [$b16db84796d64696$var$POINTERUP]: $b16db84796d64696$var$TOUCHEND,
        [$b16db84796d64696$var$POINTERCANCEL]: $b16db84796d64696$var$TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
    },
    pointer: {
        [$b16db84796d64696$var$POINTEROUT]: $b16db84796d64696$var$POINTEROUT,
        [$b16db84796d64696$var$POINTERLEAVE]: $b16db84796d64696$var$POINTERLEAVE,
        [$b16db84796d64696$var$POINTEROVER]: $b16db84796d64696$var$POINTEROVER,
        [$b16db84796d64696$var$POINTERENTER]: $b16db84796d64696$var$POINTERENTER,
        [$b16db84796d64696$var$POINTERMOVE]: $b16db84796d64696$var$POINTERMOVE,
        [$b16db84796d64696$var$POINTERDOWN]: $b16db84796d64696$var$POINTERDOWN,
        [$b16db84796d64696$var$POINTERUP]: $b16db84796d64696$var$POINTERUP,
        [$b16db84796d64696$var$POINTERCANCEL]: $b16db84796d64696$var$POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
    }
};
const $b16db84796d64696$var$getEventType = (type)=>{
    if (type.indexOf('pointer') >= 0) return 'pointer';
    if (type.indexOf('touch') >= 0) return 'touch';
    return 'mouse';
};
const $b16db84796d64696$var$getEventsMap = (eventType)=>{
    const type = $b16db84796d64696$var$getEventType(eventType);
    if (type === 'pointer') return (0, $32592e4cfd3024bd$export$b9f99057a3c7692).pointerEventsEnabled && $b16db84796d64696$var$EVENTS_MAP.pointer;
    if (type === 'touch') return $b16db84796d64696$var$EVENTS_MAP.touch;
    if (type === 'mouse') return $b16db84796d64696$var$EVENTS_MAP.mouse;
};
function $b16db84796d64696$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    return attrs;
}
const $b16db84796d64696$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const $b16db84796d64696$export$1bfcff8d7c4bf05 = [];
class $b16db84796d64696$export$208cd1682bd0e4b6 extends (0, $04c4a0c97d375591$export$42a852a2b6b56249) {
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) (0, $3a91387846844890$export$f8f26dd395d7e1bd).throw('You may only add layers to the stage.');
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $b16db84796d64696$var$STRING) {
            if (container.charAt(0) === '.') {
                var className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                var id;
                if (container.charAt(0) !== '#') id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw 'Can not find container in document with id ' + id;
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        var layers = this.children, len = layers.length, n;
        for(n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== 'undefined' && document.createElement('div');
        return (0, $04c4a0c97d375591$export$42a852a2b6b56249).prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        var content = this.content;
        if (content && (0, $3a91387846844890$export$f8f26dd395d7e1bd)._isInDocument(content)) this.container().removeChild(content);
        var index = $b16db84796d64696$export$1bfcff8d7c4bf05.indexOf(this);
        if (index > -1) $b16db84796d64696$export$1bfcff8d7c4bf05.splice(index, 1);
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn($b16db84796d64696$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        var canvas = new (0, $fd8819955318e6fb$export$ee612225bd2e63be)({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        var _context = canvas.getContext()._context;
        var layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            var layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        var layers = this.children, len = layers.length, end = len - 1, n;
        for(n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        var width = this.width();
        var height = this.height();
        if (this.content) {
            this.content.style.width = width + $b16db84796d64696$var$PX;
            this.content.style.height = height + $b16db84796d64696$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        var length = this.children.length;
        if (length > $b16db84796d64696$var$MAX_LAYERS_NUMBER) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('The stage has ' + length + ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $b161d2b4cc4d6a8a$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $b161d2b4cc4d6a8a$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $b161d2b4cc4d6a8a$export$50f687f23c43e4d9(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!(0, $32592e4cfd3024bd$export$b9f99057a3c7692).isBrowser) return;
        $b16db84796d64696$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $b16db84796d64696$var$getEventsMap(evt.type);
        this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $b16db84796d64696$var$getEventsMap(evt.type);
        this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + 'targetShape'];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $b16db84796d64696$var$getEventsMap(evt.type);
        const eventType = $b16db84796d64696$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var targetShape = this._getTargetShape(eventType);
        var eventsEnabled = !(0, $8d5bdba314ebc763$export$e34f1b340034d7f).isDragging || (0, $32592e4cfd3024bd$export$b9f99057a3c7692).hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + 'targetShape'] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = undefined;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $b16db84796d64696$var$getEventsMap(evt.type);
        const eventType = $b16db84796d64696$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var shape = this.getIntersection(pos);
            (0, $8d5bdba314ebc763$export$e34f1b340034d7f).justDragged = false;
            (0, $32592e4cfd3024bd$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = true;
            const hasShape = shape && shape.isListening();
            if (!hasShape) return;
            if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + 'ClickStartShape'] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $b16db84796d64696$var$getEventsMap(evt.type);
        const eventType = $b16db84796d64696$var$getEventType(evt.type);
        if (!events) return;
        if ((0, $8d5bdba314ebc763$export$e34f1b340034d7f).isDragging && (0, $8d5bdba314ebc763$export$e34f1b340034d7f).node.preventDefault() && evt.cancelable) evt.preventDefault();
        this.setPointersPositions(evt);
        var eventsEnabled = !(0, $8d5bdba314ebc763$export$e34f1b340034d7f).isDragging || (0, $32592e4cfd3024bd$export$b9f99057a3c7692).hitOnDragEnabled;
        if (!eventsEnabled) return;
        var processedShapesIds = {};
        let triggeredOnShape = false;
        var targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $b161d2b4cc4d6a8a$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            var differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, Object.assign({}, event), shape);
                targetShape._fireAndBubble(events.pointerleave, Object.assign({}, event), shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, Object.assign({}, event), targetShape);
                    shape._fireAndBubble(events.pointerenter, Object.assign({}, event), targetShape);
                    this[eventType + 'targetShape'] = shape;
                }
                shape._fireAndBubble(events.pointermove, Object.assign({}, event));
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + 'targetShape'] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $b16db84796d64696$var$getEventsMap(evt.type);
        const eventType = $b16db84796d64696$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + 'ClickStartShape'];
        const clickEndShape = this[eventType + 'ClickEndShape'];
        var processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $b161d2b4cc4d6a8a$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow']) {
                fireDblClick = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            } else if (!(0, $8d5bdba314ebc763$export$e34f1b340034d7f).justDragged) {
                (0, $32592e4cfd3024bd$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            this[eventType + 'DblTimeout'] = setTimeout(function() {
                (0, $32592e4cfd3024bd$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = false;
            }, (0, $32592e4cfd3024bd$export$b9f99057a3c7692).dblClickWindow);
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                this[eventType + 'ClickEndShape'] = shape;
                shape._fireAndBubble(events.pointerup, Object.assign({}, event));
                if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, Object.assign({}, event));
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, Object.assign({}, event));
                }
            } else {
                this[eventType + 'ClickEndShape'] = null;
                if ((0, $32592e4cfd3024bd$export$b9f99057a3c7692)['_' + eventType + 'ListenClick']) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!triggeredOnShape) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        (0, $32592e4cfd3024bd$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = false;
        if (evt.cancelable && eventType !== 'touch') evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($b16db84796d64696$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($b16db84796d64696$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($b16db84796d64696$var$WHEEL, {
            evt: evt
        });
        else this._fire($b16db84796d64696$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $b161d2b4cc4d6a8a$export$a55e3aaa85f15b00(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($b16db84796d64696$var$POINTERUP, $b161d2b4cc4d6a8a$export$c30017717ce2168e(evt));
        $b161d2b4cc4d6a8a$export$50f687f23c43e4d9(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $b161d2b4cc4d6a8a$export$50f687f23c43e4d9(evt.pointerId);
    }
    setPointersPositions(evt) {
        var contentPosition = this._getContentPosition(), x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $3a91387846844890$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $3a91387846844890$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        var rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new (0, $fd8819955318e6fb$export$ee612225bd2e63be)({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new (0, $fd8819955318e6fb$export$43a2e1456e27dc84)({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!(0, $32592e4cfd3024bd$export$b9f99057a3c7692).isBrowser) return;
        var container = this.container();
        if (!container) throw 'Stage has no container. A container is required.';
        container.innerHTML = '';
        this.content = document.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
    constructor(config){
        super($b16db84796d64696$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $b16db84796d64696$export$1bfcff8d7c4bf05.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', ()=>{
            $b16db84796d64696$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
}
$b16db84796d64696$export$208cd1682bd0e4b6.prototype.nodeType = $b16db84796d64696$var$STAGE;
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($b16db84796d64696$export$208cd1682bd0e4b6);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($b16db84796d64696$export$208cd1682bd0e4b6, 'container');














var $1275e92f472dac5e$var$HAS_SHADOW = 'hasShadow';
var $1275e92f472dac5e$var$SHADOW_RGBA = 'shadowRGBA';
var $1275e92f472dac5e$var$patternImage = 'patternImage';
var $1275e92f472dac5e$var$linearGradient = 'linearGradient';
var $1275e92f472dac5e$var$radialGradient = 'radialGradient';
let $1275e92f472dac5e$var$dummyContext;
function $1275e92f472dac5e$var$getDummyContext() {
    if ($1275e92f472dac5e$var$dummyContext) return $1275e92f472dac5e$var$dummyContext;
    $1275e92f472dac5e$var$dummyContext = (0, $3a91387846844890$export$f8f26dd395d7e1bd).createCanvasElement().getContext('2d');
    return $1275e92f472dac5e$var$dummyContext;
}
const $1275e92f472dac5e$export$4ff7fc6f1af248b5 = {};
function $1275e92f472dac5e$var$_fillFunc(context) {
    context.fill();
}
function $1275e92f472dac5e$var$_strokeFunc(context) {
    context.stroke();
}
function $1275e92f472dac5e$var$_fillFuncHit(context) {
    context.fill();
}
function $1275e92f472dac5e$var$_strokeFuncHit(context) {
    context.stroke();
}
function $1275e92f472dac5e$var$_clearHasShadowCache() {
    this._clearCache($1275e92f472dac5e$var$HAS_SHADOW);
}
function $1275e92f472dac5e$var$_clearGetShadowRGBACache() {
    this._clearCache($1275e92f472dac5e$var$SHADOW_RGBA);
}
function $1275e92f472dac5e$var$_clearFillPatternCache() {
    this._clearCache($1275e92f472dac5e$var$patternImage);
}
function $1275e92f472dac5e$var$_clearLinearGradientCache() {
    this._clearCache($1275e92f472dac5e$var$linearGradient);
}
function $1275e92f472dac5e$var$_clearRadialGradientCache() {
    this._clearCache($1275e92f472dac5e$var$radialGradient);
}
class $1275e92f472dac5e$export$6428a7f2611ef1fa extends (0, $ea18721d8bce411b$export$85c928794f8d04d4) {
    getContext() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    getCanvas() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    hasShadow() {
        return this._getCache($1275e92f472dac5e$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($1275e92f472dac5e$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            var ctx = $1275e92f472dac5e$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            if (pattern && pattern.setTransform) {
                const tr = new (0, $3a91387846844890$export$563a914cafbdc389)();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate((0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === 'undefined' ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($1275e92f472dac5e$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        var colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            var ctx = $1275e92f472dac5e$var$getDummyContext();
            var start = this.fillLinearGradientStartPoint();
            var end = this.fillLinearGradientEndPoint();
            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($1275e92f472dac5e$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        var colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            var ctx = $1275e92f472dac5e$var$getDummyContext();
            var start = this.fillRadialGradientStartPoint();
            var end = this.fillRadialGradientEndPoint();
            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($1275e92f472dac5e$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        var rgba = (0, $3a91387846844890$export$f8f26dd395d7e1bd).colorToRGBA(this.shadowColor());
        if (rgba) return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a * (this.shadowOpacity() || 1) + ')';
    }
    hasFill() {
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops'
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops'
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === 'auto') return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, null, true);
        p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.destroy.call(this);
        delete $1275e92f472dac5e$export$4ff7fc6f1af248b5[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        if (!this.getStage()) return false;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) this.hitStrokeWidth('auto');
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        var size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
        var skipBuffer = canvas.isCache;
        var cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            bufferCanvas = stage.bufferCanvas;
            bufferContext = bufferCanvas.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            var o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            var ratio = bufferCanvas.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
        } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                var o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        const selfCache = this === top;
        if (!selfCache) {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            hitData = hitImageData.data;
            len = hitData.length;
            rgbColorKey = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._hexToRgb(this.colorKey);
            for(i = 0; i < len; i += 4){
                alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $b161d2b4cc4d6a8a$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $b161d2b4cc4d6a8a$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $b161d2b4cc4d6a8a$export$50f687f23c43e4d9(pointerId, this);
    }
    constructor(config){
        super(config);
        let key;
        while(true){
            key = (0, $3a91387846844890$export$f8f26dd395d7e1bd).getRandomColor();
            if (key && !(key in $1275e92f472dac5e$export$4ff7fc6f1af248b5)) break;
        }
        this.colorKey = key;
        $1275e92f472dac5e$export$4ff7fc6f1af248b5[key] = this;
    }
}
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype._fillFunc = $1275e92f472dac5e$var$_fillFunc;
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype._strokeFunc = $1275e92f472dac5e$var$_strokeFunc;
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype._fillFuncHit = $1275e92f472dac5e$var$_fillFuncHit;
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype._strokeFuncHit = $1275e92f472dac5e$var$_strokeFuncHit;
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype._centroid = false;
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype.nodeType = 'Shape';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($1275e92f472dac5e$export$6428a7f2611ef1fa);
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype.eventListeners = {};
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype.on.call($1275e92f472dac5e$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $1275e92f472dac5e$var$_clearHasShadowCache);
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype.on.call($1275e92f472dac5e$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $1275e92f472dac5e$var$_clearGetShadowRGBACache);
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype.on.call($1275e92f472dac5e$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', $1275e92f472dac5e$var$_clearFillPatternCache);
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype.on.call($1275e92f472dac5e$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', $1275e92f472dac5e$var$_clearLinearGradientCache);
$1275e92f472dac5e$export$6428a7f2611ef1fa.prototype.on.call($1275e92f472dac5e$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', $1275e92f472dac5e$var$_clearRadialGradientCache);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'stroke', undefined, (0, $7b17b5b00aa2cb10$export$9c72f966a828cc68)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeWidth', 2, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillAfterStrokeEnabled', false);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'hitStrokeWidth', 'auto', (0, $7b17b5b00aa2cb10$export$3b7df2720ef33404)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeHitEnabled', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'perfectDrawEnabled', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowForStrokeEnabled', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'lineJoin');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'lineCap');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'sceneFunc');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'hitFunc');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'dash');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'dashOffset', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowColor', undefined, (0, $7b17b5b00aa2cb10$export$5837c5b6cc5b4d63)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowBlur', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowOpacity', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowOffset', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowOffsetX', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowOffsetY', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternImage');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fill', undefined, (0, $7b17b5b00aa2cb10$export$9c72f966a828cc68)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternX', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternY', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillLinearGradientColorStops');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeLinearGradientColorStops');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientStartRadius', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientEndRadius', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientColorStops');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternRepeat', 'repeat');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'shadowEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'dashEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeScaleEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPriority', 'color');
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternOffset', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternOffsetX', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternOffsetY', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternScale', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternScaleX', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternScaleY', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointX', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointX', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointY', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointY', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointX', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointX', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointY', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointY', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientStartPoint', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointX', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointY', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientEndPoint', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointX', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointY', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1275e92f472dac5e$export$6428a7f2611ef1fa, 'fillPatternRotation', 0);
(0, $45295774f0983e19$export$8354032f3852ec50).backCompat($1275e92f472dac5e$export$6428a7f2611ef1fa, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
});



var $f57485b12a956304$var$HASH = '#', $f57485b12a956304$var$BEFORE_DRAW = 'beforeDraw', $f57485b12a956304$var$DRAW = 'draw', $f57485b12a956304$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $f57485b12a956304$var$INTERSECTION_OFFSETS_LEN = $f57485b12a956304$var$INTERSECTION_OFFSETS.length;
class $f57485b12a956304$export$936d0764594b6eb3 extends (0, $04c4a0c97d375591$export$42a852a2b6b56249) {
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.moveToTop.call(this);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        var moved = (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.moveUp.call(this);
        if (!moved) return false;
        var stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ((0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.moveDown.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ((0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.moveToBottom.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        var _canvas = this.getNativeCanvasElement();
        (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && (0, $3a91387846844890$export$f8f26dd395d7e1bd)._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $3a91387846844890$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to a layer.');
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = 'block';
        else this.canvas._canvas.style.display = 'none';
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        var spiralSearchDistance = 1;
        var continueSearch = false;
        while(true){
            for(let i = 0; i < $f57485b12a956304$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $f57485b12a956304$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._rgbToHex(p[0], p[1], p[2]);
            const shape = (0, $1275e92f472dac5e$export$4ff7fc6f1af248b5)[$f57485b12a956304$var$HASH + colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($f57485b12a956304$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        (0, $04c4a0c97d375591$export$42a852a2b6b56249).prototype.drawScene.call(this, canvas, top);
        this._fire($f57485b12a956304$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        (0, $04c4a0c97d375591$export$42a852a2b6b56249).prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) return;
        var parent = this.parent;
        var added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
    constructor(config){
        super(config);
        this.canvas = new (0, $fd8819955318e6fb$export$ee612225bd2e63be)();
        this.hitCanvas = new (0, $fd8819955318e6fb$export$43a2e1456e27dc84)({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
}
$f57485b12a956304$export$936d0764594b6eb3.prototype.nodeType = 'Layer';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($f57485b12a956304$export$936d0764594b6eb3);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($f57485b12a956304$export$936d0764594b6eb3, 'imageSmoothingEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($f57485b12a956304$export$936d0764594b6eb3, 'clearBeforeDraw', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($f57485b12a956304$export$936d0764594b6eb3, 'hitGraphEnabled', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());





class $324acd4237b118bb$export$92d64f29192d1118 extends (0, $f57485b12a956304$export$936d0764594b6eb3) {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$324acd4237b118bb$export$92d64f29192d1118.prototype.nodeType = 'FastLayer';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($324acd4237b118bb$export$92d64f29192d1118);





class $ac9d66236665b670$export$eb2fcfdbd7ba97d4 extends (0, $04c4a0c97d375591$export$42a852a2b6b56249) {
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $3a91387846844890$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to groups.');
    }
}
$ac9d66236665b670$export$eb2fcfdbd7ba97d4.prototype.nodeType = 'Group';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($ac9d66236665b670$export$eb2fcfdbd7ba97d4);






var $d530f066ded8069b$var$now = function() {
    if ((0, $32592e4cfd3024bd$export$442f1a04865e4790).performance && (0, $32592e4cfd3024bd$export$442f1a04865e4790).performance.now) return function() {
        return (0, $32592e4cfd3024bd$export$442f1a04865e4790).performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $d530f066ded8069b$export$c35d437ae5945fcd {
    setLayers(layers) {
        var lays = [];
        if (!layers) lays = [];
        else if (layers.length > 0) lays = layers;
        else lays = [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        var layers = this.layers, len = layers.length, n;
        for(n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        var a = $d530f066ded8069b$export$c35d437ae5945fcd, animations = a.animations, len = animations.length, n;
        for(n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $d530f066ded8069b$var$now();
        $d530f066ded8069b$export$c35d437ae5945fcd._addAnimation(this);
        return this;
    }
    stop() {
        $d530f066ded8069b$export$c35d437ae5945fcd._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        var id = anim.id, animations = this.animations, len = animations.length, n;
        for(n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        var layerHash = {}, animations = this.animations, anim, layers, func, n, i, layersLen, layer, key, needRedraw;
        for(n = 0; n < animations.length; n++){
            anim = animations[n];
            layers = anim.layers;
            func = anim.func;
            anim._updateFrameObject($d530f066ded8069b$var$now());
            layersLen = layers.length;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(i = 0; i < layersLen; i++){
                layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        var Anim = $d530f066ded8069b$export$c35d437ae5945fcd;
        if (Anim.animations.length) {
            Anim._runFrames();
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).requestAnimFrame(this._animationLoop);
        }
    }
    constructor(func, layers){
        this.id = $d530f066ded8069b$export$c35d437ae5945fcd.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $d530f066ded8069b$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
}
$d530f066ded8069b$export$c35d437ae5945fcd.animations = [];
$d530f066ded8069b$export$c35d437ae5945fcd.animIdCounter = 0;
$d530f066ded8069b$export$c35d437ae5945fcd.animRunning = false;






var $52121b2d31074483$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $52121b2d31074483$var$PAUSED = 1, $52121b2d31074483$var$PLAYING = 2, $52121b2d31074483$var$REVERSING = 3, $52121b2d31074483$var$idCounter = 0, $52121b2d31074483$var$colorAttrs = [
    'fill',
    'stroke',
    'shadowColor'
];
class $52121b2d31074483$var$TweenEngine {
    fire(str) {
        var handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $52121b2d31074483$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    }
    reverse() {
        this.state = $52121b2d31074483$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        var t = this.getTimer() - this._startTime;
        if (this.state === $52121b2d31074483$var$PLAYING) this.setTime(t);
        else if (this.state === $52121b2d31074483$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $52121b2d31074483$var$PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return new Date().getTime();
    }
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
}
class $52121b2d31074483$export$208a41d6b4e37b97 {
    _addAttr(key, end) {
        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
        tweenId = $52121b2d31074483$export$208a41d6b4e37b97.tweens[nodeId][key];
        if (tweenId) delete $52121b2d31074483$export$208a41d6b4e37b97.attrs[nodeId][tweenId][key];
        start = node.getAttr(key);
        if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for(n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    var startRGBA = (0, $3a91387846844890$export$f8f26dd395d7e1bd).colorToRGBA(start[n]);
                    endRGBA = (0, $3a91387846844890$export$f8f26dd395d7e1bd).colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($52121b2d31074483$var$colorAttrs.indexOf(key) !== -1) {
            start = (0, $3a91387846844890$export$f8f26dd395d7e1bd).colorToRGBA(start);
            endRGBA = (0, $3a91387846844890$export$f8f26dd395d7e1bd).colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $52121b2d31074483$export$208a41d6b4e37b97.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $52121b2d31074483$export$208a41d6b4e37b97.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        var node = this.node, attrs = $52121b2d31074483$export$208a41d6b4e37b97.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push('rgba(' + Math.round(start[n].r + diff[n].r * i) + ',' + Math.round(start[n].g + diff[n].g * i) + ',' + Math.round(start[n].b + diff[n].b * i) + ',' + (start[n].a + diff[n].a * i) + ')');
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($52121b2d31074483$var$colorAttrs.indexOf(key) !== -1) newVal = 'rgba(' + Math.round(start.r + diff.r * i) + ',' + Math.round(start.g + diff.g * i) + ',' + Math.round(start.b + diff.b * i) + ',' + (start.a + diff.a * i) + ')';
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            var node = this.node;
            var attrs = $52121b2d31074483$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr('points', attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            var node = this.node;
            var attrs = $52121b2d31074483$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        var nodeId = this.node._id, thisId = this._id, attrs = $52121b2d31074483$export$208a41d6b4e37b97.tweens[nodeId], key;
        this.pause();
        for(key in attrs)delete $52121b2d31074483$export$208a41d6b4e37b97.tweens[nodeId][key];
        delete $52121b2d31074483$export$208a41d6b4e37b97.attrs[nodeId][thisId];
    }
    constructor(config){
        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || $52121b2d31074483$export$ade85cc9682adcc5.Linear, yoyo = !!config.yoyo, key;
        if (typeof config.duration === 'undefined') duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $52121b2d31074483$var$idCounter++;
        var layers = node.getLayer() || (node instanceof (0, $32592e4cfd3024bd$export$b9f99057a3c7692)['Stage'] ? node.getLayers() : null);
        if (!layers) (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        this.anim = new (0, $d530f066ded8069b$export$c35d437ae5945fcd)(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $52121b2d31074483$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$52121b2d31074483$export$208a41d6b4e37b97.attrs[nodeId]) $52121b2d31074483$export$208a41d6b4e37b97.attrs[nodeId] = {};
        if (!$52121b2d31074483$export$208a41d6b4e37b97.attrs[nodeId][this._id]) $52121b2d31074483$export$208a41d6b4e37b97.attrs[nodeId][this._id] = {};
        if (!$52121b2d31074483$export$208a41d6b4e37b97.tweens[nodeId]) $52121b2d31074483$export$208a41d6b4e37b97.tweens[nodeId] = {};
        for(key in config)if ($52121b2d31074483$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
}
$52121b2d31074483$export$208a41d6b4e37b97.attrs = {};
$52121b2d31074483$export$208a41d6b4e37b97.tweens = {};
(0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.to = function(params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    var tween = new $52121b2d31074483$export$208a41d6b4e37b97(params);
    tween.play();
};
const $52121b2d31074483$export$ade85cc9682adcc5 = {
    BackEaseIn (t, b, c, d) {
        var s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        var s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        var s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $52121b2d31074483$export$ade85cc9682adcc5.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $52121b2d31074483$export$ade85cc9682adcc5.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $52121b2d31074483$export$ade85cc9682adcc5.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




const $0dcd1e29b1067eec$export$b9f99057a3c7692 = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._assign((0, $32592e4cfd3024bd$export$b9f99057a3c7692), {
    Util: $3a91387846844890$export$f8f26dd395d7e1bd,
    Transform: $3a91387846844890$export$563a914cafbdc389,
    Node: $ea18721d8bce411b$export$85c928794f8d04d4,
    Container: $04c4a0c97d375591$export$42a852a2b6b56249,
    Stage: $b16db84796d64696$export$208cd1682bd0e4b6,
    stages: $b16db84796d64696$export$1bfcff8d7c4bf05,
    Layer: $f57485b12a956304$export$936d0764594b6eb3,
    FastLayer: $324acd4237b118bb$export$92d64f29192d1118,
    Group: $ac9d66236665b670$export$eb2fcfdbd7ba97d4,
    DD: $8d5bdba314ebc763$export$e34f1b340034d7f,
    Shape: $1275e92f472dac5e$export$6428a7f2611ef1fa,
    shapes: $1275e92f472dac5e$export$4ff7fc6f1af248b5,
    Animation: $d530f066ded8069b$export$c35d437ae5945fcd,
    Tween: $52121b2d31074483$export$208a41d6b4e37b97,
    Easings: $52121b2d31074483$export$ade85cc9682adcc5,
    Context: $c1663d221052256b$export$841858b892ce1f4c,
    Canvas: $fd8819955318e6fb$export$8d01c972ee8b14a9
});
var $0dcd1e29b1067eec$export$2e2bcd8739ae039 = $0dcd1e29b1067eec$export$b9f99057a3c7692;






class $5b046fe46e56b30c$export$6ef80ffb606dd232 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var angle = (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$5b046fe46e56b30c$export$6ef80ffb606dd232.prototype._centroid = true;
$5b046fe46e56b30c$export$6ef80ffb606dd232.prototype.className = 'Arc';
$5b046fe46e56b30c$export$6ef80ffb606dd232.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($5b046fe46e56b30c$export$6ef80ffb606dd232);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($5b046fe46e56b30c$export$6ef80ffb606dd232, 'innerRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($5b046fe46e56b30c$export$6ef80ffb606dd232, 'outerRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($5b046fe46e56b30c$export$6ef80ffb606dd232, 'angle', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($5b046fe46e56b30c$export$6ef80ffb606dd232, 'clockwise', false, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());







function $9192a33efb816c74$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $9192a33efb816c74$var$expandPoints(p, tension) {
    var len = p.length, allPoints = [], n, cp;
    for(n = 2; n < len - 2; n += 2){
        cp = $9192a33efb816c74$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
class $9192a33efb816c74$export$17d680238e50603e extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
        if (!length) return;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            tp = this.getTensionPoints();
            len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache('tensionPoints', this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $9192a33efb816c74$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $9192a33efb816c74$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $9192a33efb816c74$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $9192a33efb816c74$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        var points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    constructor(config){
        super(config);
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function() {
            this._clearCache('tensionPoints');
        });
    }
}
$9192a33efb816c74$export$17d680238e50603e.prototype.className = 'Line';
$9192a33efb816c74$export$17d680238e50603e.prototype._attrsAffectingSize = [
    'points',
    'bezier',
    'tension'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($9192a33efb816c74$export$17d680238e50603e);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($9192a33efb816c74$export$17d680238e50603e, 'closed', false);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($9192a33efb816c74$export$17d680238e50603e, 'bezier', false);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($9192a33efb816c74$export$17d680238e50603e, 'tension', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($9192a33efb816c74$export$17d680238e50603e, 'points', [], (0, $7b17b5b00aa2cb10$export$42b6f8f340e9a165)());







class $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var ca = this.dataArray;
        context.beginPath();
        var isClosed = false;
        for(var n = 0; n < ca.length; n++){
            var c = ca[n].command;
            var p = ca[n].points;
            switch(c){
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        var points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === 'A') {
                var start = data.points[4];
                var dTheta = data.points[5];
                var end = data.points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === 'C') for(let t = 0.0; t <= 1; t += 0.01){
                const point = $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        var point, i = 0, ii = this.dataArray.length;
        if (!ii) return null;
        while(i < ii && length > this.dataArray[i].pathLength){
            length -= this.dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            point = this.dataArray[i - 1].points.slice(-2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        if (length < 0.01) {
            point = this.dataArray[i].points.slice(0, 2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        var cp = this.dataArray[i];
        var p = cp.points;
        switch(cp.command){
            case 'L':
                return $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.getPointOnCubicBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.getPointOnQuadraticBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
                theta += dTheta * length / cp.pathLength;
                return $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        if (fromX === undefined) fromX = P1x;
        if (fromY === undefined) fromY = P1y;
        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
        var run = Math.sqrt(dist * dist / (1 + m * m));
        if (P2x < P1x) run *= -1;
        var rise = m * run;
        var pt;
        if (P2x === P1x) pt = {
            x: fromX,
            y: fromY + rise
        };
        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) pt = {
            x: fromX + run,
            y: fromY + rise
        };
        else {
            var ix, iy;
            var len = this.getLineLength(P1x, P1y, P2x, P2y);
            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
            u = u / (len * len);
            ix = P1x + u * (P2x - P1x);
            iy = P1y + u * (P2y - P1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m * m));
            if (P2x < P1x) run *= -1;
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        var cs = data;
        var cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for(var n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        var arr = cs.split('|');
        var ca = [];
        var coords = [];
        var cpx = 0;
        var cpy = 0;
        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        var match;
        for(n = 1; n < arr.length; n++){
            var str = arr[n];
            var c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            var p = [];
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                if (coords[j] === '00') {
                    p.push(0, 0);
                    continue;
                }
                var parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) p.push(parsed);
                else p.push(0);
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                var cmd = null;
                var points = [];
                var startX = cpx, startY = cpy;
                var prevCmd, ctlPtx, ctlPty;
                var rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        var dx = p.shift();
                        var dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for(var idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === 'M') {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') ca.push({
                command: 'z',
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        var len, p1, p2, t;
        var path = $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9;
        switch(cmd){
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                len = 0.0;
                p1 = path.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'Q':
                len = 0.0;
                p1 = path.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'A':
                len = 0.0;
                var start = points[4];
                var dTheta = points[5];
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        var psi = psiDeg * (Math.PI / 180.0);
        var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        var vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        var vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        var vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        var theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this.dataArray = $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.parsePathData(this.data());
        this.pathLength = 0;
        for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        this.on('dataChange.konva', function() {
            this.dataArray = $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.parsePathData(this.data());
            this.pathLength = 0;
            for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        });
    }
}
$8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.prototype.className = 'Path';
$8f8dd0e504bb7b08$export$4b2950bdac9b6ee9.prototype._attrsAffectingSize = [
    'data'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($8f8dd0e504bb7b08$export$4b2950bdac9b6ee9);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($8f8dd0e504bb7b08$export$4b2950bdac9b6ee9, 'data');


class $d1a789a3dcf0723a$export$21b07c8f274aebd5 extends (0, $9192a33efb816c74$export$17d680238e50603e) {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        var PI2 = Math.PI * 2;
        var points = this.points();
        var tp = points;
        var fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        var length = this.pointerLength();
        var n = points.length;
        var dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
            const previous = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        var radians = (Math.atan2(dy, dx) + PI2) % PI2;
        var width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        var isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x - offset,
            y: lineRect.y - offset,
            width: lineRect.width + offset * 2,
            height: lineRect.height + offset * 2
        };
    }
}
$d1a789a3dcf0723a$export$21b07c8f274aebd5.prototype.className = 'Arrow';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($d1a789a3dcf0723a$export$21b07c8f274aebd5);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($d1a789a3dcf0723a$export$21b07c8f274aebd5, 'pointerLength', 10, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($d1a789a3dcf0723a$export$21b07c8f274aebd5, 'pointerWidth', 10, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($d1a789a3dcf0723a$export$21b07c8f274aebd5, 'pointerAtBeginning', false);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($d1a789a3dcf0723a$export$21b07c8f274aebd5, 'pointerAtEnding', true);






class $1cc065d38411c6bd$export$c89a927ffc67e6fa extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$1cc065d38411c6bd$export$c89a927ffc67e6fa.prototype._centroid = true;
$1cc065d38411c6bd$export$c89a927ffc67e6fa.prototype.className = 'Circle';
$1cc065d38411c6bd$export$c89a927ffc67e6fa.prototype._attrsAffectingSize = [
    'radius'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($1cc065d38411c6bd$export$c89a927ffc67e6fa);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($1cc065d38411c6bd$export$c89a927ffc67e6fa, 'radius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());






class $879bf57f6e6d0636$export$80b0269ab108fa11 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$879bf57f6e6d0636$export$80b0269ab108fa11.prototype.className = 'Ellipse';
$879bf57f6e6d0636$export$80b0269ab108fa11.prototype._centroid = true;
$879bf57f6e6d0636$export$80b0269ab108fa11.prototype._attrsAffectingSize = [
    'radiusX',
    'radiusY'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($879bf57f6e6d0636$export$80b0269ab108fa11);
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($879bf57f6e6d0636$export$80b0269ab108fa11, 'radius', [
    'x',
    'y'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($879bf57f6e6d0636$export$80b0269ab108fa11, 'radiusX', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($879bf57f6e6d0636$export$80b0269ab108fa11, 'radiusY', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());







class $2f9e9e440dbbfc39$export$3e431a229df88919 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image['addEventListener']) image['addEventListener']('load', ()=>{
            this._requestDraw();
        });
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? (0, $3a91387846844890$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        var width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $3a91387846844890$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
    getHeight() {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
    static fromURL(url, callback, onError = null) {
        var img = (0, $3a91387846844890$export$f8f26dd395d7e1bd).createImageElement();
        img.onload = function() {
            var image = new $2f9e9e440dbbfc39$export$3e431a229df88919({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
    constructor(attrs){
        super(attrs);
        this.on('imageChange.konva', ()=>{
            this._setImageLoad();
        });
        this._setImageLoad();
    }
}
$2f9e9e440dbbfc39$export$3e431a229df88919.prototype.className = 'Image';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($2f9e9e440dbbfc39$export$3e431a229df88919);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($2f9e9e440dbbfc39$export$3e431a229df88919, 'cornerRadius', 0, (0, $7b17b5b00aa2cb10$export$7d4ab1842c1b264b)(4));
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($2f9e9e440dbbfc39$export$3e431a229df88919, 'image');
(0, $45295774f0983e19$export$8354032f3852ec50).addComponentsGetterSetter($2f9e9e440dbbfc39$export$3e431a229df88919, 'crop', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($2f9e9e440dbbfc39$export$3e431a229df88919, 'cropX', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($2f9e9e440dbbfc39$export$3e431a229df88919, 'cropY', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($2f9e9e440dbbfc39$export$3e431a229df88919, 'cropWidth', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($2f9e9e440dbbfc39$export$3e431a229df88919, 'cropHeight', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());







var $a829d6b5cf33badb$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'padding',
    'lineHeight',
    'text',
    'width',
    'height',
    'pointerDirection',
    'pointerWidth',
    'pointerHeight'
], $a829d6b5cf33badb$var$CHANGE_KONVA = 'Change.konva', $a829d6b5cf33badb$var$NONE = 'none', $a829d6b5cf33badb$var$UP = 'up', $a829d6b5cf33badb$var$RIGHT = 'right', $a829d6b5cf33badb$var$DOWN = 'down', $a829d6b5cf33badb$var$LEFT = 'left', $a829d6b5cf33badb$var$attrChangeListLen = $a829d6b5cf33badb$var$ATTR_CHANGE_LIST.length;
class $a829d6b5cf33badb$export$b04be29aa201d4f5 extends (0, $ac9d66236665b670$export$eb2fcfdbd7ba97d4) {
    getText() {
        return this.find('Text')[0];
    }
    getTag() {
        return this.find('Tag')[0];
    }
    _addListeners(text) {
        var that = this, n;
        var func = function() {
            that._sync();
        };
        for(n = 0; n < $a829d6b5cf33badb$var$attrChangeListLen; n++)text.on($a829d6b5cf33badb$var$ATTR_CHANGE_LIST[n] + $a829d6b5cf33badb$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $a829d6b5cf33badb$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $a829d6b5cf33badb$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $a829d6b5cf33badb$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $a829d6b5cf33badb$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
    constructor(config){
        super(config);
        this.on('add.konva', function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
}
$a829d6b5cf33badb$export$b04be29aa201d4f5.prototype.className = 'Label';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($a829d6b5cf33badb$export$b04be29aa201d4f5);
class $a829d6b5cf33badb$export$3288d34c523a1192 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $a829d6b5cf33badb$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $a829d6b5cf33badb$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $a829d6b5cf33badb$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $a829d6b5cf33badb$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $a829d6b5cf33badb$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $a829d6b5cf33badb$var$DOWN) height += pointerHeight;
        else if (direction === $a829d6b5cf33badb$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $a829d6b5cf33badb$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
$a829d6b5cf33badb$export$3288d34c523a1192.prototype.className = 'Tag';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($a829d6b5cf33badb$export$3288d34c523a1192);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a829d6b5cf33badb$export$3288d34c523a1192, 'pointerDirection', $a829d6b5cf33badb$var$NONE);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a829d6b5cf33badb$export$3288d34c523a1192, 'pointerWidth', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a829d6b5cf33badb$export$3288d34c523a1192, 'pointerHeight', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a829d6b5cf33badb$export$3288d34c523a1192, 'cornerRadius', 0, (0, $7b17b5b00aa2cb10$export$7d4ab1842c1b264b)(4));









class $a7065b56b2538e00$export$c79fc6492f3af13d extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $3a91387846844890$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$a7065b56b2538e00$export$c79fc6492f3af13d.prototype.className = 'Rect';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($a7065b56b2538e00$export$c79fc6492f3af13d);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a7065b56b2538e00$export$c79fc6492f3af13d, 'cornerRadius', 0, (0, $7b17b5b00aa2cb10$export$7d4ab1842c1b264b)(4));






class $f2287352e80bd232$export$e2ee866164812ecd extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const points = this._getPoints();
        context.beginPath();
        context.moveTo(points[0].x, points[0].y);
        for(var n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(var n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        var minX = points[0].x;
        var maxX = points[0].y;
        var minY = points[0].x;
        var maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$f2287352e80bd232$export$e2ee866164812ecd.prototype.className = 'RegularPolygon';
$f2287352e80bd232$export$e2ee866164812ecd.prototype._centroid = true;
$f2287352e80bd232$export$e2ee866164812ecd.prototype._attrsAffectingSize = [
    'radius'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($f2287352e80bd232$export$e2ee866164812ecd);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($f2287352e80bd232$export$e2ee866164812ecd, 'radius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($f2287352e80bd232$export$e2ee866164812ecd, 'sides', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());






var $ec5c2dac777e7bdc$var$PIx2 = Math.PI * 2;
class $ec5c2dac777e7bdc$export$a6e3577650b6d6d7 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $ec5c2dac777e7bdc$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $ec5c2dac777e7bdc$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$ec5c2dac777e7bdc$export$a6e3577650b6d6d7.prototype.className = 'Ring';
$ec5c2dac777e7bdc$export$a6e3577650b6d6d7.prototype._centroid = true;
$ec5c2dac777e7bdc$export$a6e3577650b6d6d7.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($ec5c2dac777e7bdc$export$a6e3577650b6d6d7);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($ec5c2dac777e7bdc$export$a6e3577650b6d6d7, 'innerRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($ec5c2dac777e7bdc$export$a6e3577650b6d6d7, 'outerRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());







class $a6ddf182d8231d34$export$3075603db8e6204c extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                var offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            var offset = offsets[anim];
            var ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        var that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        var layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new (0, $d530f066ded8069b$export$c35d437ae5945fcd)(()=>{
            var updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on('animationChange.konva', function() {
            this.frameIndex(0);
        });
        this.on('frameIndexChange.konva', function() {
            this._updated = true;
        });
        this.on('frameRateChange.konva', function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
}
$a6ddf182d8231d34$export$3075603db8e6204c.prototype.className = 'Sprite';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($a6ddf182d8231d34$export$3075603db8e6204c);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a6ddf182d8231d34$export$3075603db8e6204c, 'animation');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a6ddf182d8231d34$export$3075603db8e6204c, 'animations');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a6ddf182d8231d34$export$3075603db8e6204c, 'frameOffsets');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a6ddf182d8231d34$export$3075603db8e6204c, 'image');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a6ddf182d8231d34$export$3075603db8e6204c, 'frameIndex', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($a6ddf182d8231d34$export$3075603db8e6204c, 'frameRate', 17, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).backCompat($a6ddf182d8231d34$export$3075603db8e6204c, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex'
});






class $4a2dc01a56fe75b8$export$1644ba17714857f1 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(var n = 1; n < numPoints * 2; n++){
            var radius = n % 2 === 0 ? outerRadius : innerRadius;
            var x = radius * Math.sin(n * Math.PI / numPoints);
            var y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$4a2dc01a56fe75b8$export$1644ba17714857f1.prototype.className = 'Star';
$4a2dc01a56fe75b8$export$1644ba17714857f1.prototype._centroid = true;
$4a2dc01a56fe75b8$export$1644ba17714857f1.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($4a2dc01a56fe75b8$export$1644ba17714857f1);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($4a2dc01a56fe75b8$export$1644ba17714857f1, 'numPoints', 5, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($4a2dc01a56fe75b8$export$1644ba17714857f1, 'innerRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($4a2dc01a56fe75b8$export$1644ba17714857f1, 'outerRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());







function $001f8beaca3f4a36$export$b9ca061da17f2d30(string) {
    return Array.from(string);
}
var $001f8beaca3f4a36$var$AUTO = 'auto', $001f8beaca3f4a36$var$CENTER = 'center', $001f8beaca3f4a36$var$JUSTIFY = 'justify', $001f8beaca3f4a36$var$CHANGE_KONVA = 'Change.konva', $001f8beaca3f4a36$var$CONTEXT_2D = '2d', $001f8beaca3f4a36$var$DASH = '-', $001f8beaca3f4a36$var$LEFT = 'left', $001f8beaca3f4a36$var$TEXT = 'text', $001f8beaca3f4a36$var$TEXT_UPPER = 'Text', $001f8beaca3f4a36$var$TOP = 'top', $001f8beaca3f4a36$var$BOTTOM = 'bottom', $001f8beaca3f4a36$var$MIDDLE = 'middle', $001f8beaca3f4a36$var$NORMAL = 'normal', $001f8beaca3f4a36$var$PX_SPACE = 'px ', $001f8beaca3f4a36$var$SPACE = ' ', $001f8beaca3f4a36$var$RIGHT = 'right', $001f8beaca3f4a36$var$WORD = 'word', $001f8beaca3f4a36$var$CHAR = 'char', $001f8beaca3f4a36$var$NONE = 'none', $001f8beaca3f4a36$var$ELLIPSIS = "\u2026", $001f8beaca3f4a36$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing'
], $001f8beaca3f4a36$var$attrChangeListLen = $001f8beaca3f4a36$var$ATTR_CHANGE_LIST.length;
function $001f8beaca3f4a36$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(',').map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(' ') >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(', ');
}
var $001f8beaca3f4a36$var$dummyContext;
function $001f8beaca3f4a36$var$getDummyContext() {
    if ($001f8beaca3f4a36$var$dummyContext) return $001f8beaca3f4a36$var$dummyContext;
    $001f8beaca3f4a36$var$dummyContext = (0, $3a91387846844890$export$f8f26dd395d7e1bd).createCanvasElement().getContext($001f8beaca3f4a36$var$CONTEXT_2D);
    return $001f8beaca3f4a36$var$dummyContext;
}
function $001f8beaca3f4a36$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $001f8beaca3f4a36$var$_strokeFunc(context) {
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $001f8beaca3f4a36$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || 'black';
    return config;
}
class $001f8beaca3f4a36$export$5f1af8db9871e1d6 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        var translateY = 0;
        var translateY = lineHeightPx / 2;
        var lineTranslateX = 0;
        var lineTranslateY = 0;
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', $001f8beaca3f4a36$var$MIDDLE);
        context.setAttr('textAlign', $001f8beaca3f4a36$var$LEFT);
        if (verticalAlign === $001f8beaca3f4a36$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $001f8beaca3f4a36$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            var lineTranslateX = 0;
            var lineTranslateY = 0;
            var obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph, spacesNumber, oneWord, lineWidth;
            context.save();
            if (align === $001f8beaca3f4a36$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $001f8beaca3f4a36$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $001f8beaca3f4a36$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY);
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $001f8beaca3f4a36$var$JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (letterSpacing !== 0 || align === $001f8beaca3f4a36$var$JUSTIFY) {
                spacesNumber = text.split(' ').length - 1;
                var array = $001f8beaca3f4a36$export$b9ca061da17f2d30(text);
                for(var li = 0; li < array.length; li++){
                    var letter = array[li];
                    if (letter === ' ' && !lastLine && align === $001f8beaca3f4a36$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    context.fillStrokeShape(this);
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        var width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        var str = (0, $3a91387846844890$export$f8f26dd395d7e1bd)._isString(text) ? text : text === null || text === undefined ? '' : text + '';
        this._setAttr($001f8beaca3f4a36$var$TEXT, str);
        return this;
    }
    getWidth() {
        var isAuto = this.attrs.width === $001f8beaca3f4a36$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        var isAuto = this.attrs.height === $001f8beaca3f4a36$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    measureSize(text) {
        var _context = $001f8beaca3f4a36$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $001f8beaca3f4a36$var$SPACE + this.fontVariant() + $001f8beaca3f4a36$var$SPACE + (this.fontSize() + $001f8beaca3f4a36$var$PX_SPACE) + $001f8beaca3f4a36$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $001f8beaca3f4a36$var$JUSTIFY) line = line.trim();
        var width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        var letterSpacing = this.letterSpacing();
        var length = text.length;
        return $001f8beaca3f4a36$var$getDummyContext().measureText(text).width + (length ? letterSpacing * (length - 1) : 0);
    }
    _setTextData() {
        var lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $001f8beaca3f4a36$var$AUTO && width !== undefined, fixedHeight = height !== $001f8beaca3f4a36$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $001f8beaca3f4a36$var$NONE, wrapAtWord = wrap !== $001f8beaca3f4a36$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $001f8beaca3f4a36$var$getDummyContext().font = this._getContextFont();
        var additionalWidth = shouldAddEllipsis ? this._getTextWidth($001f8beaca3f4a36$var$ELLIPSIS) : 0;
        for(var i = 0, max = lines.length; i < max; ++i){
            var line = lines[i];
            var lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                var low = 0, high = line.length, match = '', matchWidth = 0;
                while(low < high){
                    var mid = low + high >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
                    if (substrWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        var wrapIndex;
                        var nextChar = line[match.length];
                        var nextIsSpaceOrDash = nextChar === $001f8beaca3f4a36$var$SPACE || nextChar === $001f8beaca3f4a36$var$DASH;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = match.length;
                        else wrapIndex = Math.max(match.lastIndexOf($001f8beaca3f4a36$var$SPACE), match.lastIndexOf($001f8beaca3f4a36$var$DASH)) + 1;
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = match.slice(0, low);
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    var shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    line = line.slice(low);
                    line = line.trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        var fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $001f8beaca3f4a36$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $001f8beaca3f4a36$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        var width = this.attrs.width, fixedWidth = width !== $001f8beaca3f4a36$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        var lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            var haveSpace = this._getTextWidth(lastLine.text + $001f8beaca3f4a36$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $001f8beaca3f4a36$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
    constructor(config){
        super($001f8beaca3f4a36$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(var n = 0; n < $001f8beaca3f4a36$var$attrChangeListLen; n++)this.on($001f8beaca3f4a36$var$ATTR_CHANGE_LIST[n] + $001f8beaca3f4a36$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
}
$001f8beaca3f4a36$export$5f1af8db9871e1d6.prototype._fillFunc = $001f8beaca3f4a36$var$_fillFunc;
$001f8beaca3f4a36$export$5f1af8db9871e1d6.prototype._strokeFunc = $001f8beaca3f4a36$var$_strokeFunc;
$001f8beaca3f4a36$export$5f1af8db9871e1d6.prototype.className = $001f8beaca3f4a36$var$TEXT_UPPER;
$001f8beaca3f4a36$export$5f1af8db9871e1d6.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'padding',
    'wrap',
    'lineHeight',
    'letterSpacing'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($001f8beaca3f4a36$export$5f1af8db9871e1d6);
(0, $45295774f0983e19$export$8354032f3852ec50).overWriteSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'width', (0, $7b17b5b00aa2cb10$export$3b7df2720ef33404)());
(0, $45295774f0983e19$export$8354032f3852ec50).overWriteSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'height', (0, $7b17b5b00aa2cb10$export$3b7df2720ef33404)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'fontFamily', 'Arial');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'fontSize', 12, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'fontStyle', $001f8beaca3f4a36$var$NORMAL);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'fontVariant', $001f8beaca3f4a36$var$NORMAL);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'padding', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'align', $001f8beaca3f4a36$var$LEFT);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'verticalAlign', $001f8beaca3f4a36$var$TOP);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'lineHeight', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'wrap', $001f8beaca3f4a36$var$WORD);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'ellipsis', false, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'letterSpacing', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'text', '', (0, $7b17b5b00aa2cb10$export$5837c5b6cc5b4d63)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($001f8beaca3f4a36$export$5f1af8db9871e1d6, 'textDecoration', '');









var $390fc0024532694e$var$EMPTY_STRING = '', $390fc0024532694e$var$NORMAL = 'normal';
function $390fc0024532694e$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $390fc0024532694e$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $390fc0024532694e$export$f7e34a95cc06fac7 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        var textDecoration = this.textDecoration();
        var fill = this.fill();
        var fontSize = this.fontSize();
        var glyphInfo = this.glyphInfo;
        if (textDecoration === 'underline') context.beginPath();
        for(var i = 0; i < glyphInfo.length; i++){
            context.save();
            var p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (textDecoration === 'underline') {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(fontSize, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (textDecoration === 'underline') {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        var glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            var p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(var i = 0; i < glyphInfo.length; i++){
            var p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    setText(text) {
        return (0, $001f8beaca3f4a36$export$5f1af8db9871e1d6).prototype.setText.call(this, text);
    }
    _getContextFont() {
        return (0, $001f8beaca3f4a36$export$5f1af8db9871e1d6).prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        var dummyCanvas = this.dummyCanvas;
        var _context = dummyCanvas.getContext('2d');
        _context.save();
        _context.font = this._getContextFont();
        var metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(this.attrs.fontSize, 10)
        };
    }
    _setTextData() {
        var that = this;
        var size = this._getTextSize(this.attrs.text);
        var letterSpacing = this.letterSpacing();
        var align = this.align();
        var kerningFunc = this.kerningFunc();
        this.textWidth = size.width;
        this.textHeight = size.height;
        var textFullWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
        this.glyphInfo = [];
        var fullPathWidth = 0;
        for(var l = 0; l < that.dataArray.length; l++)if (that.dataArray[l].pathLength > 0) fullPathWidth += that.dataArray[l].pathLength;
        var offset = 0;
        if (align === 'center') offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
        if (align === 'right') offset = Math.max(0, fullPathWidth - textFullWidth);
        var charArr = (0, $001f8beaca3f4a36$export$b9ca061da17f2d30)(this.text());
        var spacesNumber = this.text().split(' ').length - 1;
        var p0, p1, pathCmd;
        var pIndex = -1;
        var currentT = 0;
        var getNextPathSegment = function() {
            currentT = 0;
            var pathData = that.dataArray;
            for(var j = pIndex + 1; j < pathData.length; j++){
                if (pathData[j].pathLength > 0) {
                    pIndex = j;
                    return pathData[j];
                } else if (pathData[j].command === 'M') p0 = {
                    x: pathData[j].points[0],
                    y: pathData[j].points[1]
                };
            }
            return {};
        };
        var findSegmentToFitCharacter = function(c) {
            var glyphWidth = that._getTextSize(c).width + letterSpacing;
            if (c === ' ' && align === 'justify') glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
            var currLen = 0;
            var attempts = 0;
            p1 = undefined;
            while(Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 && attempts < 20){
                attempts++;
                var cumulativePathLength = currLen;
                while(pathCmd === undefined){
                    pathCmd = getNextPathSegment();
                    if (pathCmd && cumulativePathLength + pathCmd.pathLength < glyphWidth) {
                        cumulativePathLength += pathCmd.pathLength;
                        pathCmd = undefined;
                    }
                }
                if (Object.keys(pathCmd).length === 0 || p0 === undefined) return undefined;
                var needNewSegment = false;
                switch(pathCmd.command){
                    case 'L':
                        if ((0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, pathCmd.points[0], pathCmd.points[1]) > glyphWidth) p1 = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getPointOnLine(glyphWidth, p0.x, p0.y, pathCmd.points[0], pathCmd.points[1], p0.x, p0.y);
                        else pathCmd = undefined;
                        break;
                    case 'A':
                        var start = pathCmd.points[4];
                        var dTheta = pathCmd.points[5];
                        var end = pathCmd.points[4] + dTheta;
                        if (currentT === 0) currentT = start + 0.00000001;
                        else if (glyphWidth > currLen) currentT += Math.PI / 180.0 * dTheta / Math.abs(dTheta);
                        else currentT -= Math.PI / 360.0 * dTheta / Math.abs(dTheta);
                        if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
                            currentT = end;
                            needNewSegment = true;
                        }
                        p1 = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getPointOnEllipticalArc(pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], currentT, pathCmd.points[6]);
                        break;
                    case 'C':
                        if (currentT === 0) {
                            if (glyphWidth > pathCmd.pathLength) currentT = 0.00000001;
                            else currentT = glyphWidth / pathCmd.pathLength;
                        } else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength / 2;
                        else currentT = Math.max(currentT - (currLen - glyphWidth) / pathCmd.pathLength / 2, 0);
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getPointOnCubicBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], pathCmd.points[4], pathCmd.points[5]);
                        break;
                    case 'Q':
                        if (currentT === 0) currentT = glyphWidth / pathCmd.pathLength;
                        else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength;
                        else currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3]);
                        break;
                }
                if (p1 !== undefined) currLen = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
                if (needNewSegment) {
                    needNewSegment = false;
                    pathCmd = undefined;
                }
            }
        };
        var testChar = 'C';
        var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
        var lettersInOffset = offset / glyphWidth - 1;
        for(var k = 0; k < lettersInOffset; k++){
            findSegmentToFitCharacter(testChar);
            if (p0 === undefined || p1 === undefined) break;
            p0 = p1;
        }
        for(var i = 0; i < charArr.length; i++){
            findSegmentToFitCharacter(charArr[i]);
            if (p0 === undefined || p1 === undefined) break;
            var width = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
            var kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            p0.x += kern;
            p1.x += kern;
            this.textWidth += kern;
            var midpoint = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).getPointOnLine(kern + width / 2.0, p0.x, p0.y, p1.x, p1.y);
            var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: p0,
                p1: p1
            });
            p0 = p1;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        var points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        var minX = points[0] || 0;
        var maxX = points[0] || 0;
        var minY = points[1] || 0;
        var maxY = points[1] || 0;
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        var fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
    constructor(config){
        super(config);
        this.dummyCanvas = (0, $3a91387846844890$export$f8f26dd395d7e1bd).createCanvasElement();
        this.dataArray = [];
        this.dataArray = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
        this.on('dataChange.konva', function() {
            this.dataArray = (0, $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
            this._setTextData();
        });
        this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva', this._setTextData);
        this._setTextData();
    }
}
$390fc0024532694e$export$f7e34a95cc06fac7.prototype._fillFunc = $390fc0024532694e$var$_fillFunc;
$390fc0024532694e$export$f7e34a95cc06fac7.prototype._strokeFunc = $390fc0024532694e$var$_strokeFunc;
$390fc0024532694e$export$f7e34a95cc06fac7.prototype._fillFuncHit = $390fc0024532694e$var$_fillFunc;
$390fc0024532694e$export$f7e34a95cc06fac7.prototype._strokeFuncHit = $390fc0024532694e$var$_strokeFunc;
$390fc0024532694e$export$f7e34a95cc06fac7.prototype.className = 'TextPath';
$390fc0024532694e$export$f7e34a95cc06fac7.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'data'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($390fc0024532694e$export$f7e34a95cc06fac7);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'data');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'fontFamily', 'Arial');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'fontSize', 12, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'fontStyle', $390fc0024532694e$var$NORMAL);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'align', 'left');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'letterSpacing', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'textBaseline', 'middle');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'fontVariant', $390fc0024532694e$var$NORMAL);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'text', $390fc0024532694e$var$EMPTY_STRING);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'textDecoration', null);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($390fc0024532694e$export$f7e34a95cc06fac7, 'kerningFunc', null);










var $3f07afe35e8ec636$var$EVENTS_NAME = 'tr-konva';
var $3f07afe35e8ec636$var$ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange'
].map((e)=>e + `.${$3f07afe35e8ec636$var$EVENTS_NAME}`).join(' ');
var $3f07afe35e8ec636$var$NODES_RECT = 'nodesRect';
var $3f07afe35e8ec636$var$TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange'
];
var $3f07afe35e8ec636$var$ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135
};
const $3f07afe35e8ec636$var$TOUCH_DEVICE = 'ontouchstart' in (0, $32592e4cfd3024bd$export$b9f99057a3c7692)._global;
function $3f07afe35e8ec636$var$getCursor(anchorName, rad) {
    if (anchorName === 'rotater') return 'crosshair';
    rad += (0, $3a91387846844890$export$f8f26dd395d7e1bd).degToRad($3f07afe35e8ec636$var$ANGLES[anchorName] || 0);
    var angle = ((0, $3a91387846844890$export$f8f26dd395d7e1bd).radToDeg(rad) % 360 + 360) % 360;
    if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 337.5, 360) || (0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 0, 22.5)) return 'ns-resize';
    else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 22.5, 67.5)) return 'nesw-resize';
    else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 67.5, 112.5)) return 'ew-resize';
    else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 112.5, 157.5)) return 'nwse-resize';
    else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 157.5, 202.5)) return 'ns-resize';
    else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 202.5, 247.5)) return 'nesw-resize';
    else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 247.5, 292.5)) return 'ew-resize';
    else if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(angle, 292.5, 337.5)) return 'nwse-resize';
    else {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
var $3f07afe35e8ec636$var$ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
];
var $3f07afe35e8ec636$var$MAX_SAFE_INTEGER = 100000000;
function $3f07afe35e8ec636$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $3f07afe35e8ec636$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return Object.assign(Object.assign({}, shape), {
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    });
}
function $3f07afe35e8ec636$var$rotateAroundCenter(shape, deltaRad) {
    const center = $3f07afe35e8ec636$var$getCenter(shape);
    return $3f07afe35e8ec636$var$rotateAroundPoint(shape, deltaRad, center);
}
function $3f07afe35e8ec636$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
class $3f07afe35e8ec636$export$f993aef960936087 extends (0, $ac9d66236665b670$export$eb2fcfdbd7ba97d4) {
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $3f07afe35e8ec636$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const filteredNodes = nodes.filter((node)=>{
            if (node.isAncestorOf(this)) {
                (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Konva.Transformer cannot be an a child of the node you are trying to attach');
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + 'Change.' + this._getEventNamespace()).join(' ');
            node.on(additionalEvents, onChange);
            node.on($3f07afe35e8ec636$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(' '), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        var elementsCreated = !!this.findOne('.top-left');
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne('.back')) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off('.' + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($3f07afe35e8ec636$var$NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    }
    _getNodeRect() {
        return this._getCache($3f07afe35e8ec636$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        var rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        var absScale = node.getAbsoluteScale(relative);
        var absPos = node.getAbsolutePosition(relative);
        var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ((0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $3f07afe35e8ec636$var$rotateAroundPoint(box, -(0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        var node = this.getNode();
        if (!node) return {
            x: -$3f07afe35e8ec636$var$MAX_SAFE_INTEGER,
            y: -$3f07afe35e8ec636$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            var points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            var trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                var transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new (0, $3a91387846844890$export$563a914cafbdc389)();
        tr.rotate(-(0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotation()));
        var minX, minY, maxX, maxY;
        totalPoints.forEach(function(point) {
            var transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $3f07afe35e8ec636$var$ANCHORS_NAMES.forEach((function(name) {
            this._createAnchor(name);
        }).bind(this));
        this._createAnchor('rotater');
    }
    _createAnchor(name) {
        var anchor = new (0, $a7065b56b2538e00$export$c79fc6492f3af13d)({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' _anchor',
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $3f07afe35e8ec636$var$TOUCH_DEVICE ? 10 : 'auto'
        });
        var self = this;
        anchor.on('mousedown touchstart', function(e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        anchor.on('mouseenter', ()=>{
            var rad = (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotation());
            var cursor = $3f07afe35e8ec636$var$getCursor(name, rad);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on('mouseout', ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = '');
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        var back = new (0, $1275e92f472dac5e$export$6428a7f2611ef1fa)({
            name: 'back',
            width: 0,
            height: 0,
            draggable: true,
            sceneFunc (ctx) {
                var tr = this.getParent();
                var padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, this.width() + padding * 2, this.height() + padding * 2);
                ctx.moveTo(this.width() / 2, -padding);
                if (tr.rotateEnabled()) ctx.lineTo(this.width() / 2, -tr.rotateAnchorOffset() * (0, $3a91387846844890$export$f8f26dd395d7e1bd)._sign(this.height()) - padding);
                ctx.fillStrokeShape(this);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                var padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on('dragstart', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragmove', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        this.on('dragmove', (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        this._movingAnchorName = e.target.name().split(' ')[0];
        var attrs = this._getNodeRect();
        var width = attrs.width;
        var height = attrs.height;
        var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== 'undefined') {
            window.addEventListener('mousemove', this._handleMouseMove);
            window.addEventListener('touchmove', this._handleMouseMove);
            window.addEventListener('mouseup', this._handleMouseUp, true);
            window.addEventListener('touchend', this._handleMouseUp, true);
        }
        this._transforming = true;
        var ap = e.target.getAbsolutePosition();
        var pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        this._fire('transformstart', {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire('transformstart', {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        var x, y, newHypotenuse;
        var anchorNode = this.findOne('.' + this._movingAnchorName);
        var stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === 'rotater') {
            var attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            let delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) delta -= Math.PI;
            var oldRotation = (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotationSnapTolerance());
            const snappedRot = $3f07afe35e8ec636$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $3f07afe35e8ec636$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        var keepProportion = this.keepRatio() || e.shiftKey;
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-right').x(),
                    y: this.findOne('.bottom-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-left').x(comparePoint.x - x);
                this.findOne('.top-left').y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === 'top-center') this.findOne('.top-left').y(anchorNode.y());
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-left').x(),
                    y: this.findOne('.bottom-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-right').x(comparePoint.x + x);
                this.findOne('.top-right').y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne('.top-left').y(pos.y);
            this.findOne('.bottom-right').x(pos.x);
        } else if (this._movingAnchorName === 'middle-left') this.findOne('.top-left').x(anchorNode.x());
        else if (this._movingAnchorName === 'middle-right') this.findOne('.bottom-right').x(anchorNode.x());
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-right').x(),
                    y: this.findOne('.top-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne('.top-left').x(pos.x);
            this.findOne('.bottom-right').y(pos.y);
        } else if (this._movingAnchorName === 'bottom-center') this.findOne('.bottom-right').y(anchorNode.y());
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-left').x(),
                    y: this.findOne('.top-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.bottom-right').x(comparePoint.x + x);
                this.findOne('.bottom-right').y(comparePoint.y + y);
            }
        } else console.error(new Error('Wrong position argument of selection resizer: ' + this._movingAnchorName));
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            var topLeft = this.findOne('.top-left');
            var bottomRight = this.findOne('.bottom-right');
            var topOffsetX = topLeft.x();
            var topOffsetY = topLeft.y();
            var bottomOffsetX = this.getWidth() - bottomRight.x();
            var bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        var absPos = this.findOne('.top-left').getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        var width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
        var height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== 'undefined') {
                window.removeEventListener('mousemove', this._handleMouseMove);
                window.removeEventListener('touchmove', this._handleMouseMove);
                window.removeEventListener('mouseup', this._handleMouseUp, true);
                window.removeEventListener('touchend', this._handleMouseUp, true);
            }
            var node = this.getNode();
            this._fire('transformend', {
                evt: e,
                target: node
            });
            if (node) this._nodes.forEach((target)=>{
                target._fire('transformend', {
                    evt: e,
                    target: target
                });
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        var oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ((0, $3a91387846844890$export$f8f26dd395d7e1bd)._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const allowNegativeScale = this.flipEnabled();
        var t = new (0, $3a91387846844890$export$563a914cafbdc389)();
        t.rotate((0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('left') >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('right') >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('top') >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('bottom') >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
        }
        const baseSize = 10000000;
        const oldTr = new (0, $3a91387846844890$export$563a914cafbdc389)();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new (0, $3a91387846844890$export$563a914cafbdc389)();
        newTr.translate(newAttrs.x, newAttrs.y);
        newTr.rotate(newAttrs.rotation);
        newTr.scale(newAttrs.width / baseSize, newAttrs.height / baseSize);
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new (0, $3a91387846844890$export$563a914cafbdc389)();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            this._fire('transform', {
                evt: evt,
                target: node
            });
            node._fire('transform', {
                evt: evt,
                target: node
            });
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation((0, $3a91387846844890$export$f8f26dd395d7e1bd)._getRotation(newAttrs.rotation));
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        var attrs = this._getNodeRect();
        this.rotation((0, $3a91387846844890$export$f8f26dd395d7e1bd)._getRotation(attrs.rotation));
        var width = attrs.width;
        var height = attrs.height;
        var enabledAnchors = this.enabledAnchors();
        var resizeEnabled = this.resizeEnabled();
        var padding = this.padding();
        var anchorSize = this.anchorSize();
        this.find('._anchor').forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild('.top-left', {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0
        });
        this._batchChangeChild('.top-center', {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0
        });
        this._batchChangeChild('.top-right', {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0
        });
        this._batchChangeChild('.middle-left', {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0
        });
        this._batchChangeChild('.middle-right', {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0
        });
        this._batchChangeChild('.bottom-left', {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0
        });
        this._batchChangeChild('.bottom-center', {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0
        });
        this._batchChangeChild('.bottom-right', {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0
        });
        this._batchChangeChild('.rotater', {
            x: width / 2,
            y: -this.rotateAnchorOffset() * (0, $3a91387846844890$export$f8f26dd395d7e1bd)._sign(height) - padding,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild('.back', {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            var anchorNode = this.findOne('.' + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = '');
        (0, $ac9d66236665b670$export$eb2fcfdbd7ba97d4).prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    toObject() {
        return (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.toObject.call(this);
    }
    clone(obj) {
        var node = (0, $ea18721d8bce411b$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
    constructor(config){
        super(config);
        this._transforming = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($3f07afe35e8ec636$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
}
function $3f07afe35e8ec636$var$validateAnchors(val) {
    if (!(val instanceof Array)) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('enabledAnchors value should be an array');
    if (val instanceof Array) val.forEach(function(name) {
        if ($3f07afe35e8ec636$var$ANCHORS_NAMES.indexOf(name) === -1) (0, $3a91387846844890$export$f8f26dd395d7e1bd).warn('Unknown anchor name: ' + name + '. Available names are: ' + $3f07afe35e8ec636$var$ANCHORS_NAMES.join(', '));
    });
    return val || [];
}
$3f07afe35e8ec636$export$f993aef960936087.prototype.className = 'Transformer';
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($3f07afe35e8ec636$export$f993aef960936087);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'enabledAnchors', $3f07afe35e8ec636$var$ANCHORS_NAMES, $3f07afe35e8ec636$var$validateAnchors);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'flipEnabled', true, (0, $7b17b5b00aa2cb10$export$147fc8b6cd20fda1)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'resizeEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'anchorSize', 10, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'rotateEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'rotationSnaps', []);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'rotateAnchorOffset', 50, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'rotationSnapTolerance', 5, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'borderEnabled', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'anchorStroke', 'rgb(0, 161, 255)');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'anchorStrokeWidth', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'anchorFill', 'white');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'anchorCornerRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'borderStroke', 'rgb(0, 161, 255)');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'borderStrokeWidth', 1, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'borderDash');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'keepRatio', true);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'centeredScaling', false);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'ignoreStroke', false);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'padding', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'node');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'nodes');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'boundBoxFunc');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'anchorDragBoundFunc');
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'shouldOverdrawWholeArea', false);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($3f07afe35e8ec636$export$f993aef960936087, 'useSingleNodeRotation', true);
(0, $45295774f0983e19$export$8354032f3852ec50).backCompat($3f07afe35e8ec636$export$f993aef960936087, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors'
});






class $933c0a9d147ac418$export$28718c7785907330 extends (0, $1275e92f472dac5e$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, (0, $32592e4cfd3024bd$export$b9f99057a3c7692).getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$933c0a9d147ac418$export$28718c7785907330.prototype.className = 'Wedge';
$933c0a9d147ac418$export$28718c7785907330.prototype._centroid = true;
$933c0a9d147ac418$export$28718c7785907330.prototype._attrsAffectingSize = [
    'radius'
];
(0, $32592e4cfd3024bd$export$f7a70d87a5e829eb)($933c0a9d147ac418$export$28718c7785907330);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($933c0a9d147ac418$export$28718c7785907330, 'radius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($933c0a9d147ac418$export$28718c7785907330, 'angle', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)());
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter($933c0a9d147ac418$export$28718c7785907330, 'clockwise', false);
(0, $45295774f0983e19$export$8354032f3852ec50).backCompat($933c0a9d147ac418$export$28718c7785907330, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
});





function $349da5dfc8c331dc$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
var $349da5dfc8c331dc$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
var $349da5dfc8c331dc$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $349da5dfc8c331dc$var$filterGaussBlurRGBA(imageData, radius) {
    var pixels = imageData.data, width = imageData.width, height = imageData.height;
    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $349da5dfc8c331dc$var$BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = $349da5dfc8c331dc$var$mul_table[radius], shg_sum = $349da5dfc8c331dc$var$shg_table[radius];
    for(i = 1; i < div; i++){
        stack = stack.next = new $349da5dfc8c331dc$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        yp = width;
        for(i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $349da5dfc8c331dc$export$975a268f2c733e4 = function Blur(imageData) {
    var radius = Math.round(this.blurRadius());
    if (radius > 0) $349da5dfc8c331dc$var$filterGaussBlurRGBA(imageData, radius);
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'blurRadius', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





const $10d6d07b52dd788d$export$a2d0d82739cac11f = function(imageData) {
    var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'brightness', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





const $3c393a728c9e1297$export$656ae42051d0ca86 = function(imageData) {
    var adjust = Math.pow((this.contrast() + 100) / 100, 2);
    var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
    for(i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'contrast', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);






const $5659523dc4c4e753$export$3c8699b389eb838 = function(imageData) {
    var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    switch(direction){
        case 'top-left':
            dirY = -1;
            dirX = -1;
            break;
        case 'top':
            dirY = -1;
            dirX = 0;
            break;
        case 'top-right':
            dirY = -1;
            dirX = 1;
            break;
        case 'right':
            dirY = 0;
            dirX = 1;
            break;
        case 'bottom-right':
            dirY = 1;
            dirX = 1;
            break;
        case 'bottom':
            dirY = 1;
            dirX = 0;
            break;
        case 'bottom-left':
            dirY = 1;
            dirX = -1;
            break;
        case 'left':
            dirY = 0;
            dirX = -1;
            break;
        default:
            (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('Unknown emboss direction: ' + direction);
    }
    do {
        var offsetY = (y - 1) * w4;
        var otherY = dirY;
        if (y + otherY < 1) otherY = 0;
        if (y + otherY > h) otherY = 0;
        var offsetYOther = (y - 1 + otherY) * w * 4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var otherX = dirX;
            if (x + otherX < 1) otherX = 0;
            if (x + otherX > w) otherX = 0;
            var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
            var dR = data[offset] - data[offsetOther];
            var dG = data[offset + 1] - data[offsetOther + 1];
            var dB = data[offset + 2] - data[offsetOther + 2];
            var dif = dR;
            var absDif = dif > 0 ? dif : -dif;
            var absG = dG > 0 ? dG : -dG;
            var absB = dB > 0 ? dB : -dB;
            if (absG > absDif) dif = dG;
            if (absB > absDif) dif = dB;
            dif *= strength;
            if (blend) {
                var r = data[offset] + dif;
                var g = data[offset + 1] + dif;
                var b = data[offset + 2] + dif;
                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
            } else {
                var grey = greyLevel - dif;
                if (grey < 0) grey = 0;
                else if (grey > 255) grey = 255;
                data[offset] = data[offset + 1] = data[offset + 2] = grey;
            }
        }while (--x);
    }while (--y);
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'embossStrength', 0.5, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'embossWhiteLevel', 0.5, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'embossDirection', 'top-left', null, (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'embossBlend', false, null, (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





function $0fb0d7a85f3eb195$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $0fb0d7a85f3eb195$export$5cb8e8388f951d6f = function(imageData) {
    var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
    var enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $0fb0d7a85f3eb195$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $0fb0d7a85f3eb195$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $0fb0d7a85f3eb195$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'enhance', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);


const $41b9ca027bd34223$export$e2b0a794e83ca071 = function(imageData) {
    var data = imageData.data, len = data.length, i, brightness;
    for(i = 0; i < len; i += 4){
        brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};





(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'hue', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'saturation', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'luminance', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
const $5737932dea910229$export$46d8b0f9bc8f87a2 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};





const $e81ef5bf1dc962c8$export$d2edaecd208aed43 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'hue', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'saturation', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'value', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);


const $7cf2e3d4473eb4ca$export$1073348d81b17440 = function(imageData) {
    var data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};






var $acd884867d282a08$var$ToPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta;
    var conversion = 360 / tSize * Math.PI / 180, sin, cos;
    for(theta = 0; theta < tSize; theta += 1){
        sin = Math.sin(theta * conversion);
        cos = Math.cos(theta * conversion);
        for(radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            i = (y * xSize + x) * 4;
            r = srcPixels[i + 0];
            g = srcPixels[i + 1];
            b = srcPixels[i + 2];
            a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
var $acd884867d282a08$var$FromPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta, phaseShift = opt.polarRotation || 0;
    var x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        dx = x - xMid;
        dy = y - yMid;
        radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        i = (y1 * xSize + x1) * 4;
        r = srcPixels[i + 0];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $acd884867d282a08$export$e731e8a0fd067155 = function(imageData) {
    var xSize = imageData.width, ySize = imageData.height;
    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    var power = Math.round(this.kaleidoscopePower());
    var angle = Math.round(this.kaleidoscopeAngle());
    var offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    var tempCanvas = (0, $3a91387846844890$export$f8f26dd395d7e1bd).createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    var scratchData = tempCanvas.getContext('2d').getImageData(0, 0, xSize, ySize);
    (0, $3a91387846844890$export$f8f26dd395d7e1bd).releaseCanvas(tempCanvas);
    $acd884867d282a08$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    var minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    var sectionSize = minSectionSize;
    var xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $acd884867d282a08$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'kaleidoscopePower', 2, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'kaleidoscopeAngle', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





function $7b75fe74627c8db6$var$pixelAt(idata, x, y) {
    var idx = (y * idata.width + x) * 4;
    var d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $7b75fe74627c8db6$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $7b75fe74627c8db6$var$rgbMean(pTab) {
    var m = [
        0,
        0,
        0
    ];
    for(var i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $7b75fe74627c8db6$var$backgroundMask(idata, threshold) {
    var rgbv_no = $7b75fe74627c8db6$var$pixelAt(idata, 0, 0);
    var rgbv_ne = $7b75fe74627c8db6$var$pixelAt(idata, idata.width - 1, 0);
    var rgbv_so = $7b75fe74627c8db6$var$pixelAt(idata, 0, idata.height - 1);
    var rgbv_se = $7b75fe74627c8db6$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    var thres = threshold || 10;
    if ($7b75fe74627c8db6$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $7b75fe74627c8db6$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $7b75fe74627c8db6$var$rgbDistance(rgbv_se, rgbv_so) < thres && $7b75fe74627c8db6$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        var mean = $7b75fe74627c8db6$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        var mask = [];
        for(var i = 0; i < idata.width * idata.height; i++){
            var d = $7b75fe74627c8db6$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $7b75fe74627c8db6$var$applyMask(idata, mask) {
    for(var i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $7b75fe74627c8db6$var$erodeMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $7b75fe74627c8db6$var$dilateMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $7b75fe74627c8db6$var$smoothEdgeMask(mask, sw, sh) {
    var weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $7b75fe74627c8db6$export$991dcf7284de63d = function(imageData) {
    var threshold = this.threshold(), mask = $7b75fe74627c8db6$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $7b75fe74627c8db6$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $7b75fe74627c8db6$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $7b75fe74627c8db6$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $7b75fe74627c8db6$var$applyMask(imageData, mask);
    }
    return imageData;
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'threshold', 0, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





const $cfe08e11830b14e0$export$484d33a0500a4ce1 = function(imageData) {
    var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
    for(i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'noise', 0.2, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);






const $3fc0e0d4256ba55c$export$63396595bf5aeaa7 = function(imageData) {
    var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
    if (pixelSize <= 0) {
        (0, $3a91387846844890$export$f8f26dd395d7e1bd).error('pixelSize value can not be <= 0');
        return;
    }
    for(xBin = 0; xBin < nBinsX; xBin += 1)for(yBin = 0; yBin < nBinsY; yBin += 1){
        red = 0;
        green = 0;
        blue = 0;
        alpha = 0;
        xBinStart = xBin * pixelSize;
        xBinEnd = xBinStart + pixelSize;
        yBinStart = yBin * pixelSize;
        yBinEnd = yBinStart + pixelSize;
        pixelsInBin = 0;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'pixelSize', 8, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





const $265f198f3e01d5e5$export$ccda2563bc5d1354 = function(imageData) {
    var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
    for(i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'levels', 0.5, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





const $d0190d388260138d$export$8f9ece5a47764b93 = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
    for(i = 0; i < nPixels; i += 4){
        brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'blue', 0, (0, $7b17b5b00aa2cb10$export$af51e4581c640b27), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);





const $35a1f812a216e6bb$export$f50470518fe8f14a = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
    for(i = 0; i < nPixels; i += 4){
        ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'blue', 0, (0, $7b17b5b00aa2cb10$export$af51e4581c640b27), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'alpha', 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});


const $de37ab422de88dc6$export$1eeb4741c69006fa = function(imageData) {
    var data = imageData.data, nPixels = data.length, i, r, g, b;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


const $d7fc7c8d93e6ebc5$export$d60d51c3865bca60 = function(imageData) {
    var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    do {
        var offsetY = (y - 1) * w4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var r = data[offset];
            var g = data[offset + 1];
            var b = data[offset + 2];
            if (r > 127) r = 255 - r;
            if (g > 127) g = 255 - g;
            if (b > 127) b = 255 - b;
            data[offset] = r;
            data[offset + 1] = g;
            data[offset + 2] = b;
        }while (--x);
    }while (--y);
};





const $f305efc02fc12690$export$14f770b2ce0bb8ad = function(imageData) {
    var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
(0, $45295774f0983e19$export$8354032f3852ec50).addGetterSetter((0, $ea18721d8bce411b$export$85c928794f8d04d4), 'threshold', 0.5, (0, $7b17b5b00aa2cb10$export$6b1205b9fbe7de2c)(), (0, $45295774f0983e19$export$8354032f3852ec50).afterSetFilter);


const $b69cfce759125aad$export$b9f99057a3c7692 = (0, $0dcd1e29b1067eec$export$b9f99057a3c7692).Util._assign((0, $0dcd1e29b1067eec$export$b9f99057a3c7692), {
    Arc: $5b046fe46e56b30c$export$6ef80ffb606dd232,
    Arrow: $d1a789a3dcf0723a$export$21b07c8f274aebd5,
    Circle: $1cc065d38411c6bd$export$c89a927ffc67e6fa,
    Ellipse: $879bf57f6e6d0636$export$80b0269ab108fa11,
    Image: $2f9e9e440dbbfc39$export$3e431a229df88919,
    Label: $a829d6b5cf33badb$export$b04be29aa201d4f5,
    Tag: $a829d6b5cf33badb$export$3288d34c523a1192,
    Line: $9192a33efb816c74$export$17d680238e50603e,
    Path: $8f8dd0e504bb7b08$export$4b2950bdac9b6ee9,
    Rect: $a7065b56b2538e00$export$c79fc6492f3af13d,
    RegularPolygon: $f2287352e80bd232$export$e2ee866164812ecd,
    Ring: $ec5c2dac777e7bdc$export$a6e3577650b6d6d7,
    Sprite: $a6ddf182d8231d34$export$3075603db8e6204c,
    Star: $4a2dc01a56fe75b8$export$1644ba17714857f1,
    Text: $001f8beaca3f4a36$export$5f1af8db9871e1d6,
    TextPath: $390fc0024532694e$export$f7e34a95cc06fac7,
    Transformer: $3f07afe35e8ec636$export$f993aef960936087,
    Wedge: $933c0a9d147ac418$export$28718c7785907330,
    Filters: {
        Blur: $349da5dfc8c331dc$export$975a268f2c733e4,
        Brighten: $10d6d07b52dd788d$export$a2d0d82739cac11f,
        Contrast: $3c393a728c9e1297$export$656ae42051d0ca86,
        Emboss: $5659523dc4c4e753$export$3c8699b389eb838,
        Enhance: $0fb0d7a85f3eb195$export$5cb8e8388f951d6f,
        Grayscale: $41b9ca027bd34223$export$e2b0a794e83ca071,
        HSL: $5737932dea910229$export$46d8b0f9bc8f87a2,
        HSV: $e81ef5bf1dc962c8$export$d2edaecd208aed43,
        Invert: $7cf2e3d4473eb4ca$export$1073348d81b17440,
        Kaleidoscope: $acd884867d282a08$export$e731e8a0fd067155,
        Mask: $7b75fe74627c8db6$export$991dcf7284de63d,
        Noise: $cfe08e11830b14e0$export$484d33a0500a4ce1,
        Pixelate: $3fc0e0d4256ba55c$export$63396595bf5aeaa7,
        Posterize: $265f198f3e01d5e5$export$ccda2563bc5d1354,
        RGB: $d0190d388260138d$export$8f9ece5a47764b93,
        RGBA: $35a1f812a216e6bb$export$f50470518fe8f14a,
        Sepia: $de37ab422de88dc6$export$1eeb4741c69006fa,
        Solarize: $d7fc7c8d93e6ebc5$export$d60d51c3865bca60,
        Threshold: $f305efc02fc12690$export$14f770b2ce0bb8ad
    }
});


var $450acd8d7cf682c4$export$2e2bcd8739ae039 = (0, $b69cfce759125aad$export$b9f99057a3c7692);


/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $4f7608581cc85635$export$2e2bcd8739ae039 = (0, $0dcd1e29b1067eec$export$b9f99057a3c7692);


var $983067fdc6272337$exports = {};
'use strict';

$983067fdc6272337$exports = (parcelRequire("7IJ3O"));


var $21fa29ac3cd4a396$exports = {};

$parcel$export($21fa29ac3cd4a396$exports, "appendInitialChild", function () { return $21fa29ac3cd4a396$export$b1cefef778e97ee8; });
$parcel$export($21fa29ac3cd4a396$exports, "createInstance", function () { return $21fa29ac3cd4a396$export$99152e8d49ca4e7d; });
$parcel$export($21fa29ac3cd4a396$exports, "createTextInstance", function () { return $21fa29ac3cd4a396$export$d1ef805cf7083486; });
$parcel$export($21fa29ac3cd4a396$exports, "finalizeInitialChildren", function () { return $21fa29ac3cd4a396$export$7bb0b211bcb5abfd; });
$parcel$export($21fa29ac3cd4a396$exports, "getPublicInstance", function () { return $21fa29ac3cd4a396$export$d2475cc200518c86; });
$parcel$export($21fa29ac3cd4a396$exports, "prepareForCommit", function () { return $21fa29ac3cd4a396$export$ba5994afaabfdb0c; });
$parcel$export($21fa29ac3cd4a396$exports, "preparePortalMount", function () { return $21fa29ac3cd4a396$export$e15c8ecd0a0092b2; });
$parcel$export($21fa29ac3cd4a396$exports, "prepareUpdate", function () { return $21fa29ac3cd4a396$export$c885331d842f22b5; });
$parcel$export($21fa29ac3cd4a396$exports, "resetAfterCommit", function () { return $21fa29ac3cd4a396$export$683e88f306512aed; });
$parcel$export($21fa29ac3cd4a396$exports, "resetTextContent", function () { return $21fa29ac3cd4a396$export$2119d6fc5d6f51aa; });
$parcel$export($21fa29ac3cd4a396$exports, "shouldDeprioritizeSubtree", function () { return $21fa29ac3cd4a396$export$70ab89a99d11d186; });
$parcel$export($21fa29ac3cd4a396$exports, "getRootHostContext", function () { return $21fa29ac3cd4a396$export$dce2ca0b0f5feeb5; });
$parcel$export($21fa29ac3cd4a396$exports, "getChildHostContext", function () { return $21fa29ac3cd4a396$export$1236a84b6992d37a; });
$parcel$export($21fa29ac3cd4a396$exports, "scheduleTimeout", function () { return $21fa29ac3cd4a396$export$5f4d6617421d489b; });
$parcel$export($21fa29ac3cd4a396$exports, "cancelTimeout", function () { return $21fa29ac3cd4a396$export$f78ec70d8091ca88; });
$parcel$export($21fa29ac3cd4a396$exports, "noTimeout", function () { return $21fa29ac3cd4a396$export$78506abae4a4951d; });
$parcel$export($21fa29ac3cd4a396$exports, "shouldSetTextContent", function () { return $21fa29ac3cd4a396$export$c82139d6d374ec34; });
$parcel$export($21fa29ac3cd4a396$exports, "isPrimaryRenderer", function () { return $21fa29ac3cd4a396$export$a5fcb8abea5b71a4; });
$parcel$export($21fa29ac3cd4a396$exports, "warnsIfNotActing", function () { return $21fa29ac3cd4a396$export$2516db7323c01bd5; });
$parcel$export($21fa29ac3cd4a396$exports, "supportsMutation", function () { return $21fa29ac3cd4a396$export$20f97ad47f9ebeb; });
$parcel$export($21fa29ac3cd4a396$exports, "appendChild", function () { return $21fa29ac3cd4a396$export$1b8e57c9ea42f1d2; });
$parcel$export($21fa29ac3cd4a396$exports, "appendChildToContainer", function () { return $21fa29ac3cd4a396$export$5e391de19acdf645; });
$parcel$export($21fa29ac3cd4a396$exports, "insertBefore", function () { return $21fa29ac3cd4a396$export$86b68c7dbeb53c22; });
$parcel$export($21fa29ac3cd4a396$exports, "insertInContainerBefore", function () { return $21fa29ac3cd4a396$export$7ec3655259385e44; });
$parcel$export($21fa29ac3cd4a396$exports, "removeChild", function () { return $21fa29ac3cd4a396$export$7ae609f7af59e4f7; });
$parcel$export($21fa29ac3cd4a396$exports, "removeChildFromContainer", function () { return $21fa29ac3cd4a396$export$2e4ef5d75a473f1a; });
$parcel$export($21fa29ac3cd4a396$exports, "commitTextUpdate", function () { return $21fa29ac3cd4a396$export$50a92d0155bee474; });
$parcel$export($21fa29ac3cd4a396$exports, "commitMount", function () { return $21fa29ac3cd4a396$export$fe90794743fbfeb0; });
$parcel$export($21fa29ac3cd4a396$exports, "commitUpdate", function () { return $21fa29ac3cd4a396$export$fd8222818e57ec6; });
$parcel$export($21fa29ac3cd4a396$exports, "hideInstance", function () { return $21fa29ac3cd4a396$export$6db9fd2b8188b8b7; });
$parcel$export($21fa29ac3cd4a396$exports, "hideTextInstance", function () { return $21fa29ac3cd4a396$export$17ed9cbd9cb3aad2; });
$parcel$export($21fa29ac3cd4a396$exports, "unhideInstance", function () { return $21fa29ac3cd4a396$export$933e25c2090d1941; });
$parcel$export($21fa29ac3cd4a396$exports, "unhideTextInstance", function () { return $21fa29ac3cd4a396$export$8ff685cdcb7326ff; });
$parcel$export($21fa29ac3cd4a396$exports, "clearContainer", function () { return $21fa29ac3cd4a396$export$28e08eff11ac64f6; });
$parcel$export($21fa29ac3cd4a396$exports, "now", function () { return (parcelRequire("b81Wb")).unstable_now; });
$parcel$export($21fa29ac3cd4a396$exports, "idlePriority", function () { return (parcelRequire("b81Wb")).unstable_IdlePriority; });
$parcel$export($21fa29ac3cd4a396$exports, "run", function () { return (parcelRequire("b81Wb")).unstable_runWithPriority; });


var $332e888cc82c69fe$var$propsToSkip = {
    children: true,
    ref: true,
    key: true,
    style: true,
    forwardedRef: true,
    unstable_applyCache: true,
    unstable_applyDrawHitFromCache: true
};
var $332e888cc82c69fe$var$zIndexWarningShowed = false;
var $332e888cc82c69fe$var$dragWarningShowed = false;
var $332e888cc82c69fe$export$3a20cc353cdae1b2 = '.react-konva-event';
var $332e888cc82c69fe$var$useStrictMode = false;
function $332e888cc82c69fe$export$5a38dcef855281ce(value) {
    $332e888cc82c69fe$var$useStrictMode = value;
}
var $332e888cc82c69fe$var$DRAGGABLE_WARNING = 'ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.\nPosition of a node will be changed during drag&drop, so you should update state of the react app as well.\nConsider to add onDragMove or onDragEnd events.\nFor more info see: https://github.com/konvajs/react-konva/issues/256\n';
var $332e888cc82c69fe$var$Z_INDEX_WARNING = 'ReactKonva: You are using "zIndex" attribute for a Konva node.\nreact-konva may get confused with ordering. Just define correct order of elements in your render function of a component.\nFor more info see: https://github.com/konvajs/react-konva/issues/194\n';
var $332e888cc82c69fe$var$EMPTY_PROPS = {};
function $332e888cc82c69fe$export$25d4dd8d7c7a61f6(instance, props) {
    var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $332e888cc82c69fe$var$EMPTY_PROPS;
    if (props === oldProps) console.error('same props');
    // don't use zIndex in react-konva
    if (!$332e888cc82c69fe$var$zIndexWarningShowed && 'zIndex' in props) {
        console.warn($332e888cc82c69fe$var$Z_INDEX_WARNING);
        $332e888cc82c69fe$var$zIndexWarningShowed = true;
    }
    // check correct draggable usage
    if (!$332e888cc82c69fe$var$dragWarningShowed && props.draggable) {
        var hasPosition = props.x !== undefined || props.y !== undefined;
        var hasEvents = props.onDragEnd || props.onDragMove;
        if (hasPosition && !hasEvents) {
            console.warn($332e888cc82c69fe$var$DRAGGABLE_WARNING);
            $332e888cc82c69fe$var$dragWarningShowed = true;
        }
    }
    // check old props
    // we need to unset properties that are not in new props
    // and remove all events
    for(var key in oldProps){
        if ($332e888cc82c69fe$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === 'on';
        var propChanged = oldProps[key] !== props[key];
        // if that is a changed event, we need to remvoe it
        if (isEvent && propChanged) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            instance.off(eventName, oldProps[key]);
        }
        var toRemove = !props.hasOwnProperty(key);
        if (toRemove) instance.setAttr(key, undefined);
    }
    var strictUpdate = $332e888cc82c69fe$var$useStrictMode || props._useStrictMode;
    var updatedProps = {};
    var hasUpdates = false;
    var newEvents = {};
    for(var key in props){
        if ($332e888cc82c69fe$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === 'on';
        var toAdd = oldProps[key] !== props[key];
        if (isEvent && toAdd) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            // check that event is not undefined
            if (props[key]) newEvents[eventName] = props[key];
        }
        if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
            hasUpdates = true;
            updatedProps[key] = props[key];
        }
    }
    if (hasUpdates) {
        instance.setAttrs(updatedProps);
        $332e888cc82c69fe$export$8d64f55d8bab80d4(instance);
    }
    // subscribe to events AFTER we set attrs
    // we need it to fix https://github.com/konvajs/react-konva/issues/471
    // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
    for(var eventName in newEvents)instance.on(eventName + $332e888cc82c69fe$export$3a20cc353cdae1b2, newEvents[eventName]);
}
function $332e888cc82c69fe$export$8d64f55d8bab80d4(node) {
    if (!(0, $32592e4cfd3024bd$export$b9f99057a3c7692).autoDrawEnabled) {
        var drawingNode = node.getLayer() || node.getStage();
        drawingNode && drawingNode.batchDraw();
    }
}



var $b81Wb = parcelRequire("b81Wb");
var $21fa29ac3cd4a396$var$NO_CONTEXT = {};
var $21fa29ac3cd4a396$var$UPDATE_SIGNAL = {};
// for react-spring capability
(0, $4f7608581cc85635$export$2e2bcd8739ae039).Node.prototype._applyProps = (0, $332e888cc82c69fe$export$25d4dd8d7c7a61f6);
function $21fa29ac3cd4a396$export$b1cefef778e97ee8(parentInstance, child) {
    if (typeof child === 'string') {
        // Noop for string children of Text (eg <Text>foo</Text>)
        console.error('Do not use plain text as child of Konva.Node. You are using text: ' + child);
        return;
    }
    parentInstance.add(child);
    (0, $332e888cc82c69fe$export$8d64f55d8bab80d4)(parentInstance);
}
function $21fa29ac3cd4a396$export$99152e8d49ca4e7d(type, props, internalInstanceHandle) {
    var NodeClass = (0, $4f7608581cc85635$export$2e2bcd8739ae039)[type];
    if (!NodeClass) {
        console.error('Konva has no node with the type ' + type + '. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/' + type + '"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html');
        NodeClass = (0, $4f7608581cc85635$export$2e2bcd8739ae039).Group;
    }
    // we need to split props into events and non events
    // we we can pass non events into constructor directly
    // that way the performance should be better
    // we we apply change "applyNodeProps"
    // then it will trigger change events on first run
    // but we don't need them!
    var propsWithoutEvents = {};
    var propsWithOnlyEvents = {};
    for(var key in props){
        var isEvent = key.slice(0, 2) === 'on';
        if (isEvent) propsWithOnlyEvents[key] = props[key];
        else propsWithoutEvents[key] = props[key];
    }
    var instance = new NodeClass(propsWithoutEvents);
    (0, $332e888cc82c69fe$export$25d4dd8d7c7a61f6)(instance, propsWithOnlyEvents);
    return instance;
}
function $21fa29ac3cd4a396$export$d1ef805cf7083486(text, rootContainerInstance, internalInstanceHandle) {
    console.error('Text components are not supported for now in ReactKonva. Your text is: "' + text + '"');
}
function $21fa29ac3cd4a396$export$7bb0b211bcb5abfd(domElement, type, props) {
    return false;
}
function $21fa29ac3cd4a396$export$d2475cc200518c86(instance) {
    return instance;
}
function $21fa29ac3cd4a396$export$ba5994afaabfdb0c() {
    return null;
}
function $21fa29ac3cd4a396$export$e15c8ecd0a0092b2() {
    return null;
}
function $21fa29ac3cd4a396$export$c885331d842f22b5(domElement, type, oldProps, newProps) {
    return $21fa29ac3cd4a396$var$UPDATE_SIGNAL;
}
function $21fa29ac3cd4a396$export$683e88f306512aed() {
// Noop
}
function $21fa29ac3cd4a396$export$2119d6fc5d6f51aa(domElement) {
// Noop
}
function $21fa29ac3cd4a396$export$70ab89a99d11d186(type, props) {
    return false;
}
function $21fa29ac3cd4a396$export$dce2ca0b0f5feeb5() {
    return $21fa29ac3cd4a396$var$NO_CONTEXT;
}
function $21fa29ac3cd4a396$export$1236a84b6992d37a() {
    return $21fa29ac3cd4a396$var$NO_CONTEXT;
}
var $21fa29ac3cd4a396$export$5f4d6617421d489b = setTimeout;
var $21fa29ac3cd4a396$export$f78ec70d8091ca88 = clearTimeout;
var $21fa29ac3cd4a396$export$78506abae4a4951d = -1;
function $21fa29ac3cd4a396$export$c82139d6d374ec34(type, props) {
    return false;
}
var $21fa29ac3cd4a396$export$a5fcb8abea5b71a4 = false;
var $21fa29ac3cd4a396$export$2516db7323c01bd5 = true;
var $21fa29ac3cd4a396$export$20f97ad47f9ebeb = true;
function $21fa29ac3cd4a396$export$1b8e57c9ea42f1d2(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $332e888cc82c69fe$export$8d64f55d8bab80d4)(parentInstance);
}
function $21fa29ac3cd4a396$export$5e391de19acdf645(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $332e888cc82c69fe$export$8d64f55d8bab80d4)(parentInstance);
}
function $21fa29ac3cd4a396$export$86b68c7dbeb53c22(parentInstance, child, beforeChild) {
    // child._remove() will not stop dragging
    // but child.remove() will stop it, but we don't need it
    // removing will reset zIndexes
    child._remove();
    parentInstance.add(child);
    child.setZIndex(beforeChild.getZIndex());
    (0, $332e888cc82c69fe$export$8d64f55d8bab80d4)(parentInstance);
}
function $21fa29ac3cd4a396$export$7ec3655259385e44(parentInstance, child, beforeChild) {
    $21fa29ac3cd4a396$export$86b68c7dbeb53c22(parentInstance, child, beforeChild);
}
function $21fa29ac3cd4a396$export$7ae609f7af59e4f7(parentInstance, child) {
    child.destroy();
    child.off((0, $332e888cc82c69fe$export$3a20cc353cdae1b2));
    (0, $332e888cc82c69fe$export$8d64f55d8bab80d4)(parentInstance);
}
function $21fa29ac3cd4a396$export$2e4ef5d75a473f1a(parentInstance, child) {
    child.destroy();
    child.off((0, $332e888cc82c69fe$export$3a20cc353cdae1b2));
    (0, $332e888cc82c69fe$export$8d64f55d8bab80d4)(parentInstance);
}
function $21fa29ac3cd4a396$export$50a92d0155bee474(textInstance, oldText, newText) {
    console.error('Text components are not yet supported in ReactKonva. You text is: "' + newText + '"');
}
function $21fa29ac3cd4a396$export$fe90794743fbfeb0(instance, type, newProps) {
// Noop
}
function $21fa29ac3cd4a396$export$fd8222818e57ec6(instance, updatePayload, type, oldProps, newProps) {
    (0, $332e888cc82c69fe$export$25d4dd8d7c7a61f6)(instance, newProps, oldProps);
}
function $21fa29ac3cd4a396$export$6db9fd2b8188b8b7(instance) {
    instance.hide();
    (0, $332e888cc82c69fe$export$8d64f55d8bab80d4)(instance);
}
function $21fa29ac3cd4a396$export$17ed9cbd9cb3aad2(textInstance) {
// Noop
}
function $21fa29ac3cd4a396$export$933e25c2090d1941(instance, props) {
    if (props.visible == null || props.visible) instance.show();
}
function $21fa29ac3cd4a396$export$8ff685cdcb7326ff(textInstance, text) {
// Noop
}
function $21fa29ac3cd4a396$export$28e08eff11ac64f6(container) {
// Noop
}



'use strict';
var $7fa422475e31a5a1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7fa422475e31a5a1$var$usePrevious(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect(function() {
        ref.current = value;
    });
    return ref.current;
}
var $7fa422475e31a5a1$var$StageWrap = function StageWrap(props) {
    var container = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var stage = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var fiberRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var oldProps = $7fa422475e31a5a1$var$usePrevious(props);
    var _setRef = function _setRef(stage) {
        var forwardedRef = props.forwardedRef;
        if (!forwardedRef) return;
        if (typeof forwardedRef === 'function') forwardedRef(stage);
        else forwardedRef.current = stage;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect(function() {
        stage.current = new (0, $4f7608581cc85635$export$2e2bcd8739ae039).Stage({
            width: props.width,
            height: props.height,
            container: container.current
        });
        _setRef(stage.current);
        fiberRef.current = $7fa422475e31a5a1$export$1998d71d1bc35390.createContainer(stage.current);
        $7fa422475e31a5a1$export$1998d71d1bc35390.updateContainer(props.children, fiberRef.current);
        return function() {
            if (!(0, $4f7608581cc85635$export$2e2bcd8739ae039).isBrowser) return;
            _setRef(null);
            $7fa422475e31a5a1$export$1998d71d1bc35390.updateContainer(null, fiberRef.current, null);
            stage.current.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect(function() {
        _setRef(stage.current);
        (0, $332e888cc82c69fe$export$25d4dd8d7c7a61f6)(stage.current, props, oldProps);
        $7fa422475e31a5a1$export$1998d71d1bc35390.updateContainer(props.children, fiberRef.current, null);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('div', {
        ref: container,
        accessKey: props.accessKey,
        className: props.className,
        role: props.role,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    });
};
var $7fa422475e31a5a1$export$936d0764594b6eb3 = 'Layer';
var $7fa422475e31a5a1$export$92d64f29192d1118 = 'FastLayer';
var $7fa422475e31a5a1$export$eb2fcfdbd7ba97d4 = 'Group';
var $7fa422475e31a5a1$export$b04be29aa201d4f5 = 'Label';
var $7fa422475e31a5a1$export$c79fc6492f3af13d = 'Rect';
var $7fa422475e31a5a1$export$c89a927ffc67e6fa = 'Circle';
var $7fa422475e31a5a1$export$80b0269ab108fa11 = 'Ellipse';
var $7fa422475e31a5a1$export$28718c7785907330 = 'Wedge';
var $7fa422475e31a5a1$export$17d680238e50603e = 'Line';
var $7fa422475e31a5a1$export$3075603db8e6204c = 'Sprite';
var $7fa422475e31a5a1$export$3e431a229df88919 = 'Image';
var $7fa422475e31a5a1$export$5f1af8db9871e1d6 = 'Text';
var $7fa422475e31a5a1$export$f7e34a95cc06fac7 = 'TextPath';
var $7fa422475e31a5a1$export$1644ba17714857f1 = 'Star';
var $7fa422475e31a5a1$export$a6e3577650b6d6d7 = 'Ring';
var $7fa422475e31a5a1$export$6ef80ffb606dd232 = 'Arc';
var $7fa422475e31a5a1$export$3288d34c523a1192 = 'Tag';
var $7fa422475e31a5a1$export$4b2950bdac9b6ee9 = 'Path';
var $7fa422475e31a5a1$export$e2ee866164812ecd = 'RegularPolygon';
var $7fa422475e31a5a1$export$21b07c8f274aebd5 = 'Arrow';
var $7fa422475e31a5a1$export$6428a7f2611ef1fa = 'Shape';
var $7fa422475e31a5a1$export$f993aef960936087 = 'Transformer';
var $7fa422475e31a5a1$export$1998d71d1bc35390 = (0, (/*@__PURE__*/$parcel$interopDefault($983067fdc6272337$exports)))($21fa29ac3cd4a396$exports);
$7fa422475e31a5a1$export$1998d71d1bc35390.injectIntoDevTools({
    findHostInstanceByFiber: function findHostInstanceByFiber() {
        return null;
    },
    bundleType: 0,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).version,
    rendererPackageName: 'react-konva'
});
var $7fa422475e31a5a1$export$208cd1682bd0e4b6 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7fa422475e31a5a1$var$StageWrap, $7fa422475e31a5a1$var$_extends({}, props, {
        forwardedRef: ref
    }));
});
var $7fa422475e31a5a1$export$2e548393fba9b338 = (0, $332e888cc82c69fe$export$5a38dcef855281ce);


'use strict';


const $fc4a095999ffdfc8$var$propTypes = {
    // ProductInfo objekt:
    product: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    // Pildi laius
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    // Pildi kõrgus
    height: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    // Abijoonte värvus
    lineColor: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    // Abijoonte paksus
    lineStrokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    // Klaasi joone värvus
    glassColor: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    // Klaasi joone paksus
    glassStrokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    // E-punktide värvus
    ePointColor: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    // P-punktide värvus
    pPointColor: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    // HUD punktide värvus
    hudPointColor: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    // Punktide ringjoone paksus
    pointStrokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    // Punktide fondi suurus
    pointFontSize: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    // Punktide raadius
    pointRadius: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    // Punktide teksti font
    pointFont: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
};
const $fc4a095999ffdfc8$var$defaultProps = {
    lineColor: 'rgb(150,150,150)',
    lineStrokeWidth: 1,
    glassColor: 'rgb(0,0,0)',
    glassStrokeWidth: 2,
    ePointColor: 'rgb(255,0,0)',
    pPointColor: 'rgb(0,0,255)',
    hudPointColor: 'rgb(0,255,255)',
    textColor: 'rgb(150,150,150)',
    pointStrokeWidth: 1,
    pointFontSize: 12,
    pointFont: 'Calibri',
    pointRadius: 5
};
class $fc4a095999ffdfc8$var$GlassImage extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    renderProduct() {
        /**
     * @type {ProductInfo}
     */ let pr = this.props.product;
        if (!pr || !pr.glass) return [];
        let ncp = pr.glass;
        if (!ncp.tahvelx) return [];
        let modx = this.props.width / ncp.tahvelx;
        let mody = this.props.height / ncp.tahvely;
        if (mody < modx) modx = mody;
        let height = Math.round(ncp.tahvely * modx);
        //let width = Math.round(ncp.tahvelx*modx);
        let ph = height - Math.round(modx);
        let jminx = Math.round(ncp.minx * modx);
        let jminy = Math.round(ncp.miny * modx);
        let jmaxx = Math.round(ncp.maxx * modx);
        let jmaxy = Math.round(ncp.maxy * modx);
        let offsetx = Math.round((this.props.width - (jmaxx - jminx)) / 2);
        let offsety = Math.round((this.props.height - (jmaxy - jminy)) / 2);
        let el = [];
        // Kast:
        let points = [
            offsetx + jminx,
            offsety + ph - jminy,
            offsetx + jminx,
            offsety + ph - jmaxy,
            offsetx + jmaxx,
            offsety + ph - jmaxy,
            offsetx + jmaxx,
            offsety + ph - jminy,
            offsetx + jminx,
            offsety + ph - jminy
        ];
        el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
            key: "rect",
            points: points,
            stroke: this.props.lineColor,
            strokeWidth: this.props.lineStrokeWidth
        }));
        // Ristjoon:
        points = [
            offsetx + jminx,
            offsety + ph - Math.round(ncp.kesky * modx),
            offsetx + jmaxx,
            offsety + ph - Math.round(ncp.kesky * modx)
        ];
        el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
            key: "mid",
            points: points,
            stroke: this.props.lineColor,
            strokeWidth: this.props.lineStrokeWidth
        }));
        // Mõõtejoonte asukohtadele vastavad püstjooned:
        for(let i = 0; i < pr.lineCount; i++){
            points = [
                offsetx + Math.round((pr.joona[i] + ncp.keskx) * modx),
                offsety + ph - jminy,
                offsetx + Math.round((pr.joony[i] + ncp.keskx) * modx),
                offsety + ph - jmaxy
            ];
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
                key: 'hline_' + i.toString(),
                points: points,
                stroke: this.props.lineColor,
                strokeWidth: this.props.lineStrokeWidth
            }));
        }
        // Klaasi kontuur:
        for(let i = 0; i < ncp.ridu; i++){
            points = [
                offsetx + Math.round((ncp.joonx1[i] + ncp.keskx) * modx),
                offsety + ph - Math.round((ncp.joony1[i] + ncp.kesky) * modx),
                offsetx + Math.round((ncp.joonx2[i] + ncp.keskx) * modx),
                offsety + ph - Math.round((ncp.joony2[i] + ncp.kesky) * modx)
            ];
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
                key: 'glass_' + i,
                points: points,
                stroke: this.props.glassColor,
                strokeWidth: this.props.glassStrokeWidth
            }));
        }
        // E-punktid ja kõrgused (H=) (vt rida 4635):
        for(let i = 0; i < pr.lineCount * 2; i++){
            // Punkt ise
            let abiX = offsetx + Math.round((pr.ex[i] + ncp.keskx) * modx);
            let abiY = offsety + ph - Math.round((pr.ey[i] + ncp.kesky) * modx);
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$c89a927ffc67e6fa), {
                key: 'e_' + i,
                x: abiX,
                y: abiY,
                radius: this.props.pointRadius,
                stroke: this.props.ePointColor,
                strokeWidth: this.props.pointStrokeWidth
            }));
            // Punkti juures kuvatav tekst
            // TODO: Vaja leida õiged offsetid
            abiX += this.props.pointRadius + 2;
            if (i % 2 == 0) abiY += this.props.pointRadius + 2;
            else abiY -= this.props.pointRadius + 2 + 10;
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$5f1af8db9871e1d6), {
                key: 'en_' + i,
                x: abiX,
                y: abiY,
                text: 'E' + (i + 1).toString(),
                fontSize: this.props.pointFontSize,
                fontFamily: this.props.pointFont,
                fill: this.props.textColor
            }));
            // Punkti kõrgus "H="
            // TODO: Vaja leida õiged offsetid
            if (i % 2 == 0) abiY += 15;
            else abiY -= 15;
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$5f1af8db9871e1d6), {
                key: 'h_' + i,
                x: abiX,
                y: abiY,
                text: 'H=' + (pr.ez[i] ? pr.ez[i].toString() : ''),
                fontSize: this.props.pointFontSize,
                fontFamily: this.props.pointFont,
                fill: this.props.textColor
            }));
        }
        // P-punktid:
        for(let i = 0; i < pr.pNimi.length; i++){
            if (pr.px == null || pr.py == null || !pr.pOlemas[i]) continue;
            // Punkt ise
            let abiX = offsetx + Math.round((pr.px[i] + ncp.keskx) * modx);
            let abiY = offsety + ph - Math.round((pr.py[i] + ncp.kesky) * modx);
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$c89a927ffc67e6fa), {
                key: 'p_' + i,
                x: abiX,
                y: abiY,
                radius: this.props.pointRadius,
                stroke: this.props.pPointColor,
                strokeWidth: this.props.pointStrokeWidth
            }));
            // Punkti juures kuvatav tekst
            // TODO: Vaja leida õiged offsetid
            if (i < pr.lineCount * 3) abiX += this.props.pointRadius + 2;
            else abiX -= this.props.pointRadius + 22;
            if (i % 3 == 0 && i < pr.lineCount * 3) abiY += this.props.pointRadius + 2;
            else abiY -= this.props.pointRadius + 2 + 10;
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$5f1af8db9871e1d6), {
                key: 'pn_' + i,
                x: abiX,
                y: abiY,
                text: pr.pNimi[i],
                fontSize: this.props.pointFontSize,
                fontFamily: this.props.pointFont,
                fill: this.props.textColor
            }));
        }
        // HUD punktid:
        for(let i = 0; i < pr.hudPoints; i++){
            if (pr.hudx == null || pr.hudy == null || pr.hudx.length <= i || pr.hudy.length <= i) break;
            // Punkt ise
            let abiX = offsetx + Math.round((pr.hudx[i] + ncp.keskx) * modx);
            let abiY = offsety + ph - Math.round((pr.hudy[i] + ncp.kesky) * modx);
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$c89a927ffc67e6fa), {
                key: 'hud_' + i,
                x: abiX,
                y: abiY,
                radius: this.props.pointRadius,
                stroke: this.props.hudPointColor,
                strokeWidth: this.props.pointStrokeWidth
            }));
            // Punkti juures kuvatav tekst
            // TODO: Vaja leida õiged offsetid
            //if (i < pr.lineCount*3) abiX += this.props.pointRadius + 2;
            //else
            abiX -= this.props.pointRadius + 40;
            // if (i % 3 == 0 && i < pr.lineCount*3) abiY += this.props.pointRadius + 2;
            // else
            abiY -= Math.round(this.props.pointRadius / 2);
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$5f1af8db9871e1d6), {
                key: 'hudn_' + i,
                x: abiX,
                y: abiY,
                text: "HUD" + (i + 1),
                fontSize: this.props.pointFontSize,
                fontFamily: this.props.pointFont,
                fill: this.props.textColor
            }));
        }
        // S-punktid (trükiserv):
        for(let i = 0; i < pr.lineCount * 2; i++){
            if (pr.s.length <= i || !(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNumber(pr.s[i]) || pr.s[i] === 0) continue;
            let base = Math.floor(i / 2) * 2;
            let v = pr.s[i] / Math.sqrt(Math.pow(pr.ex[base + 1] - pr.ex[base], 2) + Math.pow(pr.ey[base + 1] - pr.ey[base], 2));
            let tx = pr.ex[base + 1] - (pr.ex[base + 1] - pr.ex[base]) * v;
            let ty = pr.ey[base + 1] - (pr.ey[base + 1] - pr.ey[base]) * v;
            let abiX = offsetx + Math.round((tx + ncp.keskx) * modx) + 10;
            let abiY = offsety + ph - Math.round((ty + ncp.kesky) * modx);
            points = [
                offsetx + Math.round((tx + ncp.keskx) * modx) - 10,
                offsety + ph - Math.round((ty + ncp.kesky) * modx),
                abiX,
                abiY
            ];
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
                key: 's_' + i,
                points: points,
                stroke: this.props.lineColor,
                strokeWidth: this.props.lineStrokeWidth
            }));
            abiX -= 5;
            abiY -= 10;
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$5f1af8db9871e1d6), {
                key: 'sn_' + i,
                x: abiX,
                y: abiY,
                text: 'S' + (i + 1).toString(),
                fontSize: this.props.pointFontSize,
                fontFamily: this.props.pointFont,
                fill: this.props.textColor
            }));
        }
        // Kui on nihutatud, siis nihke asukoht:
        if (pr.xnihe != 0 || pr.ynihe != 0) {
            let aax = -pr.xnihe;
            let aay = -pr.ynihe;
            // Väike rasvane rist 45 kraadi all:
            points = [
                offsetx + Math.round((aax + ncp.keskx) * modx) - 5,
                offsety + ph - Math.round((aay + ncp.kesky) * modx) - 5,
                offsetx + Math.round((aax + ncp.keskx) * modx) + 5,
                offsety + ph - Math.round((aay + ncp.kesky) * modx) + 5
            ];
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
                key: "r_1",
                points: points,
                stroke: this.props.lineColor,
                strokeWidth: this.props.glassStrokeWidth
            }));
            points = [
                offsetx + Math.round((aax + ncp.keskx) * modx) - 5,
                offsety + ph - Math.round((aay + ncp.kesky) * modx) + 5,
                offsetx + Math.round((aax + ncp.keskx) * modx) + 5,
                offsety + ph - Math.round((aay + ncp.kesky) * modx) - 5
            ];
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
                key: "r_2",
                points: points,
                stroke: this.props.lineColor,
                strokeWidth: this.props.glassStrokeWidth
            }));
            // Suur peenikeste joontega rist:
            points = [
                offsetx + Math.round((aax + ncp.keskx) * modx) - 20,
                offsety + ph - Math.round((aay + ncp.kesky) * modx),
                offsetx + Math.round((aax + ncp.keskx) * modx) + 20,
                offsety + ph - Math.round((aay + ncp.kesky) * modx)
            ];
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
                key: "r_3",
                points: points,
                stroke: this.props.lineColor,
                strokeWidth: this.props.lineStrokeWidth
            }));
            points = [
                offsetx + Math.round((aax + ncp.keskx) * modx),
                offsety + ph - Math.round((aay + ncp.kesky) * modx) - 20,
                offsetx + Math.round((aax + ncp.keskx) * modx),
                offsety + ph - Math.round((aay + ncp.kesky) * modx) + 20
            ];
            el.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$17d680238e50603e), {
                key: "r_4",
                points: points,
                stroke: this.props.lineColor,
                strokeWidth: this.props.lineStrokeWidth
            }));
        }
        return el;
    }
    render() {
        let elements = this.renderProduct();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$208cd1682bd0e4b6), {
            width: this.props.width,
            height: this.props.height
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa422475e31a5a1$export$936d0764594b6eb3), null, elements));
    }
}
$fc4a095999ffdfc8$var$GlassImage.propTypes = $fc4a095999ffdfc8$var$propTypes;
$fc4a095999ffdfc8$var$GlassImage.defaultProps = $fc4a095999ffdfc8$var$defaultProps;
var $fc4a095999ffdfc8$export$2e2bcd8739ae039 = $fc4a095999ffdfc8$var$GlassImage;


/* global window */ /**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ var $221e6a129b353ed4$export$ab054a1ef92eeb01;

$221e6a129b353ed4$export$ab054a1ef92eeb01 = (parcelRequire("5MgdR"));


const $cceeb32949d536a7$export$f6e2535fb5126e54 = (x)=>typeof x === 'function';
function $cceeb32949d536a7$export$30c6d0ab2ba54115(target) {
    const Ctor = target.constructor;
    return !!target && Object.prototype.toString.call(target) === '[object Object]' && $cceeb32949d536a7$export$f6e2535fb5126e54(Ctor) && !Object.isFrozen(target) && (Ctor instanceof Ctor || target.type === 'AltStore');
}
function $cceeb32949d536a7$export$1b8ac1d3a07c9372(f, o) {
    o.forEach((from)=>{
        Object.keys(Object(from)).forEach((key)=>{
            f(key, from[key]);
        });
    });
}
function $cceeb32949d536a7$export$e6e34fd1f2686227(target, ...source) {
    $cceeb32949d536a7$export$1b8ac1d3a07c9372((key, value)=>target[key] = value, source);
    return target;
}


function $a6ef17ef9fd8408f$export$8921d147d4d1b7(instance, data, onStore) {
    const obj = instance.deserialize(data);
    $cceeb32949d536a7$export$1b8ac1d3a07c9372((key, value)=>{
        const store = instance.stores[key];
        if (store) {
            const { config: config } = store.StoreModel;
            const state = store.state;
            if (config.onDeserialize) obj[key] = config.onDeserialize(value) || value;
            if ($cceeb32949d536a7$export$30c6d0ab2ba54115(state)) {
                $cceeb32949d536a7$export$1b8ac1d3a07c9372((k)=>delete state[k], [
                    state
                ]);
                $cceeb32949d536a7$export$e6e34fd1f2686227(state, obj[key]);
            } else store.state = obj[key];
            onStore(store, store.state);
        }
    }, [
        obj
    ]);
}
function $a6ef17ef9fd8408f$export$b8801ea43165ed7d(instance, storeNames = []) {
    const stores = storeNames.length ? storeNames : Object.keys(instance.stores);
    return stores.reduce((obj, storeHandle)=>{
        const storeName = storeHandle.displayName || storeHandle;
        const store = instance.stores[storeName];
        const { config: config } = store.StoreModel;
        store.lifecycle('snapshot');
        const customSnapshot = config.onSerialize && config.onSerialize(store.state);
        obj[storeName] = customSnapshot ? customSnapshot : store.getState();
        return obj;
    }, {});
}
function $a6ef17ef9fd8408f$export$59cc8d1728e9350d(instance, key) {
    const state = instance.deserialize(instance.serialize(instance.stores[key].state));
    instance._initSnapshot[key] = state;
    instance._lastSnapshot[key] = state;
}
function $a6ef17ef9fd8408f$export$d1936d9f5737af92(instance, state, stores) {
    return stores.reduce((obj, store)=>{
        const storeName = store.displayName || store;
        if (!state[storeName]) throw new ReferenceError(`${storeName} is not a valid store`);
        obj[storeName] = state[storeName];
        return obj;
    }, {});
}





/*eslint-disable*/ const $d6622cdbe8c6b3bc$var$builtIns = Object.getOwnPropertyNames($d6622cdbe8c6b3bc$var$NoopClass);
const $d6622cdbe8c6b3bc$var$builtInProto = Object.getOwnPropertyNames($d6622cdbe8c6b3bc$var$NoopClass.prototype);
function $d6622cdbe8c6b3bc$export$3051ee4ce6c19b20(Obj, isProto) {
    const excluded = isProto ? $d6622cdbe8c6b3bc$var$builtInProto : $d6622cdbe8c6b3bc$var$builtIns;
    const obj = isProto ? Obj.prototype : Obj;
    return Object.getOwnPropertyNames(obj).reduce((value, m)=>{
        if (excluded.indexOf(m) !== -1) return value;
        value[m] = obj[m];
        return value;
    }, {});
}
function $d6622cdbe8c6b3bc$export$7c47c5639795d55c(Obj, methods = {}) {
    return Obj === Function.prototype ? methods : $d6622cdbe8c6b3bc$export$7c47c5639795d55c(Object.getPrototypeOf(Obj), $cceeb32949d536a7$export$e6e34fd1f2686227($d6622cdbe8c6b3bc$export$3051ee4ce6c19b20(Obj, true), methods));
}
function $d6622cdbe8c6b3bc$export$c106dd0671a0fc2d(msg) {
    /* istanbul ignore else */ /*eslint-disable*/ if (typeof console !== 'undefined') console.warn(new ReferenceError(msg));
/*eslint-enable*/ }
function $d6622cdbe8c6b3bc$export$e2a22331486dcca0(container, name) {
    let count = 0;
    let key = name;
    while(Object.hasOwnProperty.call(container, key))key = name + String(++count);
    return key;
}
function $d6622cdbe8c6b3bc$export$778a1ace022a1664(name) {
    return name.replace(/[a-z]([A-Z])/g, (i)=>{
        return `${i[0]}_${i[1].toLowerCase()}`;
    }).toUpperCase();
}
function $d6622cdbe8c6b3bc$export$53c9d27a775f6c50(x, ...a) {
    if (x === undefined) return null;
    return a.length ? [
        x
    ].concat(a) : x;
}
function $d6622cdbe8c6b3bc$export$fb971ecb744e6dc9(id, type, payload, details) {
    return {
        type: type,
        payload: payload,
        meta: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            dispatchId: id
        }, details),
        id: id,
        action: type,
        data: payload,
        details: details
    };
}
function $d6622cdbe8c6b3bc$export$635e15bbd66f01ea(id, actionObj, payload, alt) {
    const data = actionObj.dispatch(payload);
    if (data === undefined) return null;
    const type = actionObj.id;
    const namespace = type;
    const name = type;
    const details = {
        id: type,
        namespace: namespace,
        name: name
    };
    const dispatchLater = (x)=>alt.dispatch(type, x, details);
    if ($cceeb32949d536a7$export$f6e2535fb5126e54(data)) return data(dispatchLater, alt);
    // XXX standardize this
    return alt.dispatcher.dispatch($d6622cdbe8c6b3bc$export$fb971ecb744e6dc9(id, type, data, details));
}
/* istanbul ignore next */ function $d6622cdbe8c6b3bc$var$NoopClass() {}




var $bec409da24643a31$exports = {};
"use strict";
function $bec409da24643a31$var$transmitter() {
    var subscriptions = [];
    var nowDispatching = false;
    var toUnsubscribe = {};
    var unsubscribe = function unsubscribe(onChange) {
        var id = subscriptions.indexOf(onChange);
        if (id < 0) return;
        if (nowDispatching) {
            toUnsubscribe[id] = onChange;
            return;
        }
        subscriptions.splice(id, 1);
    };
    var subscribe = function subscribe(onChange) {
        var id = subscriptions.push(onChange);
        var dispose = function dispose() {
            return unsubscribe(onChange);
        };
        return {
            dispose: dispose
        };
    };
    var publish = function publish() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        nowDispatching = true;
        try {
            subscriptions.forEach(function(subscription, id) {
                return toUnsubscribe[id] || subscription.apply(undefined, args);
            });
        } finally{
            nowDispatching = false;
            Object.keys(toUnsubscribe).forEach(function(id) {
                return unsubscribe(toUnsubscribe[id]);
            });
            toUnsubscribe = {};
        }
    };
    return {
        publish: publish,
        subscribe: subscribe,
        $subscriptions: subscriptions
    };
}
$bec409da24643a31$exports = $bec409da24643a31$var$transmitter;


class $be5fe92cb76d4d19$var$AltStore {
    listen(cb) {
        if (!$cceeb32949d536a7$export$f6e2535fb5126e54(cb)) throw new TypeError('listen expects a function');
        const { dispose: dispose } = this.transmitter.subscribe(cb);
        this.subscriptions.push({
            cb: cb,
            dispose: dispose
        });
        return ()=>{
            this.lifecycle('unlisten');
            dispose();
        };
    }
    unlisten(cb) {
        this.lifecycle('unlisten');
        this.subscriptions.filter((subscription)=>subscription.cb === cb).forEach((subscription)=>subscription.dispose());
    }
    getState() {
        return this.StoreModel.config.getState.call(this, this.state);
    }
    constructor(alt, model, state, StoreModel){
        const lifecycleEvents = model.lifecycleEvents;
        this.transmitter = (0, (/*@__PURE__*/$parcel$interopDefault($bec409da24643a31$exports)))();
        this.lifecycle = (event, x)=>{
            if (lifecycleEvents[event]) lifecycleEvents[event].publish(x);
        };
        this.state = state;
        this.alt = alt;
        this.preventDefault = false;
        this.displayName = model.displayName;
        this.boundListeners = model.boundListeners;
        this.StoreModel = StoreModel;
        this.reduce = model.reduce || ((x)=>x);
        this.subscriptions = [];
        const output = model.output || ((x)=>x);
        this.emitChange = ()=>this.transmitter.publish(output(this.state));
        const handleDispatch = (f, payload)=>{
            try {
                return f();
            } catch (e) {
                if (model.handlesOwnErrors) {
                    this.lifecycle('error', {
                        error: e,
                        payload: payload,
                        state: this.state
                    });
                    return false;
                }
                throw e;
            }
        };
        $cceeb32949d536a7$export$e6e34fd1f2686227(this, model.publicMethods);
        // Register dispatcher
        this.dispatchToken = alt.dispatcher.register((payload)=>{
            this.preventDefault = false;
            this.lifecycle('beforeEach', {
                payload: payload,
                state: this.state
            });
            const actionHandlers = model.actionListeners[payload.action];
            if (actionHandlers || model.otherwise) {
                let result;
                if (actionHandlers) result = handleDispatch(()=>{
                    return actionHandlers.filter(Boolean).every((handler)=>{
                        return handler.call(model, payload.data, payload.action) !== false;
                    });
                }, payload);
                else result = handleDispatch(()=>{
                    return model.otherwise(payload.data, payload.action);
                }, payload);
                if (result !== false && !this.preventDefault) this.emitChange();
            }
            if (model.reduce) {
                handleDispatch(()=>{
                    const value = model.reduce(this.state, payload);
                    if (value !== undefined) this.state = value;
                }, payload);
                if (!this.preventDefault) this.emitChange();
            }
            this.lifecycle('afterEach', {
                payload: payload,
                state: this.state
            });
        });
        this.lifecycle('init');
    }
}
var $be5fe92cb76d4d19$export$2e2bcd8739ae039 = $be5fe92cb76d4d19$var$AltStore;




const $985f5ccd812f27d8$var$StoreMixin = {
    waitFor (...sources) {
        if (!sources.length) throw new ReferenceError('Dispatch tokens not provided');
        let sourcesArray = sources;
        if (sources.length === 1) sourcesArray = Array.isArray(sources[0]) ? sources[0] : sources;
        const tokens = sourcesArray.map((source)=>{
            return source.dispatchToken || source;
        });
        this.dispatcher.waitFor(tokens);
    },
    exportAsync (asyncMethods) {
        this.registerAsync(asyncMethods);
    },
    registerAsync (asyncDef) {
        let loadCounter = 0;
        const asyncMethods = $cceeb32949d536a7$export$f6e2535fb5126e54(asyncDef) ? asyncDef(this.alt) : asyncDef;
        const toExport = Object.keys(asyncMethods).reduce((publicMethods, methodName)=>{
            const desc = asyncMethods[methodName];
            const spec = $cceeb32949d536a7$export$f6e2535fb5126e54(desc) ? desc(this) : desc;
            const validHandlers = [
                'success',
                'error',
                'loading'
            ];
            validHandlers.forEach((handler)=>{
                if (spec[handler] && !spec[handler].id) throw new Error(`${handler} handler must be an action function`);
            });
            publicMethods[methodName] = (...args)=>{
                const state = this.getInstance().getState();
                const value = spec.local && spec.local(state, ...args);
                const shouldFetch = spec.shouldFetch ? spec.shouldFetch(state, ...args) : value == null;
                /*eslint-enable*/ const intercept = spec.interceptResponse || ((x)=>x);
                const makeActionHandler = (action, isError)=>{
                    return (x)=>{
                        const fire = ()=>{
                            loadCounter -= 1;
                            action(intercept(x, action, args));
                            if (isError) throw x;
                            return x;
                        };
                        return this.alt.trapAsync ? ()=>fire() : fire();
                    };
                };
                // if we don't have it in cache then fetch it
                if (shouldFetch) {
                    loadCounter += 1;
                    /* istanbul ignore else */ if (spec.loading) spec.loading(intercept(null, spec.loading, args));
                    return spec.remote(state, ...args).then(makeActionHandler(spec.success), makeActionHandler(spec.error, 1));
                }
                // otherwise emit the change now
                this.emitChange();
                return value;
            };
            return publicMethods;
        }, {});
        this.exportPublicMethods(toExport);
        this.exportPublicMethods({
            isLoading: ()=>loadCounter > 0
        });
    },
    exportPublicMethods (methods) {
        $cceeb32949d536a7$export$1b8ac1d3a07c9372((methodName, value)=>{
            if (!$cceeb32949d536a7$export$f6e2535fb5126e54(value)) throw new TypeError('exportPublicMethods expects a function');
            this.publicMethods[methodName] = value;
        }, [
            methods
        ]);
    },
    emitChange () {
        this.getInstance().emitChange();
    },
    on (lifecycleEvent, handler) {
        if (lifecycleEvent === 'error') this.handlesOwnErrors = true;
        const bus = this.lifecycleEvents[lifecycleEvent] || (0, (/*@__PURE__*/$parcel$interopDefault($bec409da24643a31$exports)))();
        this.lifecycleEvents[lifecycleEvent] = bus;
        return bus.subscribe(handler.bind(this));
    },
    bindAction (symbol, handler) {
        if (!symbol) throw new ReferenceError('Invalid action reference passed in');
        if (!$cceeb32949d536a7$export$f6e2535fb5126e54(handler)) throw new TypeError('bindAction expects a function');
        // You can pass in the constant or the function itself
        const key = symbol.id ? symbol.id : symbol;
        this.actionListeners[key] = this.actionListeners[key] || [];
        this.actionListeners[key].push(handler.bind(this));
        this.boundListeners.push(key);
    },
    bindActions (actions) {
        $cceeb32949d536a7$export$1b8ac1d3a07c9372((action, symbol)=>{
            const matchFirstCharacter = /./;
            const assumedEventHandler = action.replace(matchFirstCharacter, (x)=>{
                return `on${x[0].toUpperCase()}`;
            });
            if (this[action] && this[assumedEventHandler]) // If you have both action and onAction
            throw new ReferenceError(`You have multiple action handlers bound to an action: ` + `${action} and ${assumedEventHandler}`);
            const handler = this[action] || this[assumedEventHandler];
            if (handler) this.bindAction(symbol, handler);
        }, [
            actions
        ]);
    },
    bindListeners (obj) {
        $cceeb32949d536a7$export$1b8ac1d3a07c9372((methodName, symbol)=>{
            const listener = this[methodName];
            if (!listener) throw new ReferenceError(`${methodName} defined but does not exist in ${this.displayName}`);
            if (Array.isArray(symbol)) symbol.forEach((action)=>{
                this.bindAction(action, listener);
            });
            else this.bindAction(symbol, listener);
        }, [
            obj
        ]);
    }
};
var $985f5ccd812f27d8$export$2e2bcd8739ae039 = $985f5ccd812f27d8$var$StoreMixin;


function $9ffb98cbc21eb7d8$var$doSetState(store, storeInstance, state) {
    if (!state) return;
    const { config: config } = storeInstance.StoreModel;
    const nextState = $cceeb32949d536a7$export$f6e2535fb5126e54(state) ? state(storeInstance.state) : state;
    storeInstance.state = config.setState.call(store, storeInstance.state, nextState);
    if (!store.alt.dispatcher.isDispatching()) store.emitChange();
}
function $9ffb98cbc21eb7d8$var$createPrototype(proto, alt, key, extras) {
    return $cceeb32949d536a7$export$e6e34fd1f2686227(proto, (0, $985f5ccd812f27d8$export$2e2bcd8739ae039), {
        displayName: key,
        alt: alt,
        dispatcher: alt.dispatcher,
        preventDefault () {
            this.getInstance().preventDefault = true;
        },
        boundListeners: [],
        lifecycleEvents: {},
        actionListeners: {},
        publicMethods: {},
        handlesOwnErrors: false
    }, extras);
}
function $9ffb98cbc21eb7d8$export$38f83545859efe33(globalConfig, StoreModel) {
    StoreModel.config = $cceeb32949d536a7$export$e6e34fd1f2686227({
        getState (state) {
            if (Array.isArray(state)) return state.slice();
            else if ($cceeb32949d536a7$export$30c6d0ab2ba54115(state)) return $cceeb32949d536a7$export$e6e34fd1f2686227({}, state);
            return state;
        },
        setState (currentState, nextState) {
            if ($cceeb32949d536a7$export$30c6d0ab2ba54115(nextState)) return $cceeb32949d536a7$export$e6e34fd1f2686227(currentState, nextState);
            return nextState;
        }
    }, globalConfig, StoreModel.config);
}
function $9ffb98cbc21eb7d8$export$ed4c1b64eeee732c(transforms, StoreModel) {
    return transforms.reduce((Store, transform)=>transform(Store), StoreModel);
}
function $9ffb98cbc21eb7d8$export$f03ab220ca87fb3c(alt, StoreModel, key) {
    let storeInstance;
    const StoreProto = $9ffb98cbc21eb7d8$var$createPrototype({}, alt, key, $cceeb32949d536a7$export$e6e34fd1f2686227({
        getInstance () {
            return storeInstance;
        },
        setState (nextState) {
            $9ffb98cbc21eb7d8$var$doSetState(this, storeInstance, nextState);
        }
    }, StoreModel));
    // bind the store listeners
    /* istanbul ignore else */ if (StoreProto.bindListeners) (0, $985f5ccd812f27d8$export$2e2bcd8739ae039).bindListeners.call(StoreProto, StoreProto.bindListeners);
    /* istanbul ignore else */ if (StoreProto.observe) (0, $985f5ccd812f27d8$export$2e2bcd8739ae039).bindListeners.call(StoreProto, StoreProto.observe(alt));
    // bind the lifecycle events
    /* istanbul ignore else */ if (StoreProto.lifecycle) $cceeb32949d536a7$export$1b8ac1d3a07c9372((eventName, event)=>{
        (0, $985f5ccd812f27d8$export$2e2bcd8739ae039).on.call(StoreProto, eventName, event);
    }, [
        StoreProto.lifecycle
    ]);
    // create the instance and fn.assign the public methods to the instance
    storeInstance = $cceeb32949d536a7$export$e6e34fd1f2686227(new (0, $be5fe92cb76d4d19$export$2e2bcd8739ae039)(alt, StoreProto, StoreProto.state !== undefined ? StoreProto.state : {}, StoreModel), StoreProto.publicMethods, {
        displayName: key,
        config: StoreModel.config
    });
    return storeInstance;
}
function $9ffb98cbc21eb7d8$export$5c8ed64162b31366(alt, StoreModel, key, ...argsForClass) {
    let storeInstance;
    const { config: config } = StoreModel;
    // Creating a class here so we don't overload the provided store's
    // prototype with the mixin behaviour and I'm extending from StoreModel
    // so we can inherit any extensions from the provided store.
    class Store extends StoreModel {
        constructor(...args){
            super(...args);
        }
    }
    $9ffb98cbc21eb7d8$var$createPrototype(Store.prototype, alt, key, {
        type: 'AltStore',
        getInstance () {
            return storeInstance;
        },
        setState (nextState) {
            $9ffb98cbc21eb7d8$var$doSetState(this, storeInstance, nextState);
        }
    });
    const store = new Store(...argsForClass);
    /* istanbul ignore next */ if (config.bindListeners) store.bindListeners(config.bindListeners);
    /* istanbul ignore next */ if (config.datasource) store.registerAsync(config.datasource);
    storeInstance = $cceeb32949d536a7$export$e6e34fd1f2686227(new (0, $be5fe92cb76d4d19$export$2e2bcd8739ae039)(alt, store, store.state !== undefined ? store.state : store, StoreModel), $d6622cdbe8c6b3bc$export$3051ee4ce6c19b20(StoreModel), config.publicMethods, {
        displayName: key
    });
    return storeInstance;
}





var $78c955fab3ef13f6$exports = {};
$78c955fab3ef13f6$exports = $78c955fab3ef13f6$var$isPromise;
function $78c955fab3ef13f6$var$isPromise(obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


function $83ac4385323c57ef$export$2e2bcd8739ae039(alt, namespace, name, implementation, obj) {
    const id = $d6622cdbe8c6b3bc$export$e2a22331486dcca0(alt._actionsRegistry, `${namespace}.${name}`);
    alt._actionsRegistry[id] = 1;
    const data = {
        id: id,
        namespace: namespace,
        name: name
    };
    const dispatch = (payload)=>alt.dispatch(id, payload, data);
    // the action itself
    const action = (...args)=>{
        const invocationResult = implementation.apply(obj, args);
        let actionResult = invocationResult;
        // async functions that return promises should not be dispatched
        if (invocationResult !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($78c955fab3ef13f6$exports)))(invocationResult)) {
            if ($cceeb32949d536a7$export$f6e2535fb5126e54(invocationResult)) // inner function result should be returned as an action result
            actionResult = invocationResult(dispatch, alt);
            else dispatch(invocationResult);
        }
        if (invocationResult === undefined) $d6622cdbe8c6b3bc$export$c106dd0671a0fc2d('An action was called but nothing was dispatched');
        return actionResult;
    };
    action.defer = (...args)=>setTimeout(()=>action.apply(null, args));
    action.id = id;
    action.data = data;
    // ensure each reference is unique in the namespace
    const container = alt.actions[namespace];
    const namespaceId = $d6622cdbe8c6b3bc$export$e2a22331486dcca0(container, name);
    container[namespaceId] = action;
    // generate a constant
    const constant = $d6622cdbe8c6b3bc$export$778a1ace022a1664(namespaceId);
    container[constant] = id;
    return action;
}


class $67372371ef4e4b08$var$Alt {
    dispatch(action, data, details) {
        this.batchingFunction(()=>{
            const id = Math.random().toString(18).substr(2, 16);
            // support straight dispatching of FSA-style actions
            if (action.hasOwnProperty('type') && action.hasOwnProperty('payload')) {
                const fsaDetails = {
                    id: action.type,
                    namespace: action.type,
                    name: action.type
                };
                return this.dispatcher.dispatch($d6622cdbe8c6b3bc$export$fb971ecb744e6dc9(id, action.type, action.payload, fsaDetails));
            }
            if (action.id && action.dispatch) return $d6622cdbe8c6b3bc$export$635e15bbd66f01ea(id, action, data, this);
            return this.dispatcher.dispatch($d6622cdbe8c6b3bc$export$fb971ecb744e6dc9(id, action, data, details));
        });
    }
    createUnsavedStore(StoreModel, ...args) {
        const key = StoreModel.displayName || '';
        $9ffb98cbc21eb7d8$export$38f83545859efe33(this.config, StoreModel);
        const Store = $9ffb98cbc21eb7d8$export$ed4c1b64eeee732c(this.storeTransforms, StoreModel);
        return $cceeb32949d536a7$export$f6e2535fb5126e54(Store) ? $9ffb98cbc21eb7d8$export$5c8ed64162b31366(this, Store, key, ...args) : $9ffb98cbc21eb7d8$export$f03ab220ca87fb3c(this, Store, key);
    }
    createStore(StoreModel, iden, ...args) {
        let key = iden || StoreModel.displayName || StoreModel.name || '';
        $9ffb98cbc21eb7d8$export$38f83545859efe33(this.config, StoreModel);
        const Store = $9ffb98cbc21eb7d8$export$ed4c1b64eeee732c(this.storeTransforms, StoreModel);
        /* istanbul ignore next */ if (null) delete this.stores[key];
        if (this.stores[key] || !key) {
            if (this.stores[key]) $d6622cdbe8c6b3bc$export$c106dd0671a0fc2d(`A store named ${key} already exists, double check your store ` + `names or pass in your own custom identifier for each store`);
            else $d6622cdbe8c6b3bc$export$c106dd0671a0fc2d('Store name was not specified');
            key = $d6622cdbe8c6b3bc$export$e2a22331486dcca0(this.stores, key);
        }
        const storeInstance = $cceeb32949d536a7$export$f6e2535fb5126e54(Store) ? $9ffb98cbc21eb7d8$export$5c8ed64162b31366(this, Store, key, ...args) : $9ffb98cbc21eb7d8$export$f03ab220ca87fb3c(this, Store, key);
        this.stores[key] = storeInstance;
        $a6ef17ef9fd8408f$export$59cc8d1728e9350d(this, key);
        return storeInstance;
    }
    generateActions(...actionNames) {
        const actions = {
            name: 'global'
        };
        return this.createActions(actionNames.reduce((obj, action)=>{
            obj[action] = $d6622cdbe8c6b3bc$export$53c9d27a775f6c50;
            return obj;
        }, actions));
    }
    createAction(name, implementation, obj) {
        return (0, $83ac4385323c57ef$export$2e2bcd8739ae039)(this, 'global', name, implementation, obj);
    }
    createActions(ActionsClass, exportObj = {}, ...argsForConstructor) {
        const actions = {};
        const key = $d6622cdbe8c6b3bc$export$e2a22331486dcca0(this._actionsRegistry, ActionsClass.displayName || ActionsClass.name || 'Unknown');
        if ($cceeb32949d536a7$export$f6e2535fb5126e54(ActionsClass)) {
            $cceeb32949d536a7$export$e6e34fd1f2686227(actions, $d6622cdbe8c6b3bc$export$7c47c5639795d55c(ActionsClass));
            class ActionsGenerator extends ActionsClass {
                generateActions(...actionNames) {
                    actionNames.forEach((actionName)=>{
                        actions[actionName] = $d6622cdbe8c6b3bc$export$53c9d27a775f6c50;
                    });
                }
                constructor(...args){
                    super(...args);
                }
            }
            $cceeb32949d536a7$export$e6e34fd1f2686227(actions, new ActionsGenerator(...argsForConstructor));
        } else $cceeb32949d536a7$export$e6e34fd1f2686227(actions, ActionsClass);
        this.actions[key] = this.actions[key] || {};
        $cceeb32949d536a7$export$1b8ac1d3a07c9372((actionName, action)=>{
            if (!$cceeb32949d536a7$export$f6e2535fb5126e54(action)) {
                exportObj[actionName] = action;
                return;
            }
            // create the action
            exportObj[actionName] = (0, $83ac4385323c57ef$export$2e2bcd8739ae039)(this, key, actionName, action, exportObj);
            // generate a constant
            const constant = $d6622cdbe8c6b3bc$export$778a1ace022a1664(actionName);
            exportObj[constant] = exportObj[actionName].id;
        }, [
            actions
        ]);
        return exportObj;
    }
    takeSnapshot(...storeNames) {
        const state = $a6ef17ef9fd8408f$export$b8801ea43165ed7d(this, storeNames);
        $cceeb32949d536a7$export$e6e34fd1f2686227(this._lastSnapshot, state);
        return this.serialize(state);
    }
    rollback() {
        $a6ef17ef9fd8408f$export$8921d147d4d1b7(this, this.serialize(this._lastSnapshot), (storeInst)=>{
            storeInst.lifecycle('rollback');
            storeInst.emitChange();
        });
    }
    recycle(...storeNames) {
        const initialSnapshot = storeNames.length ? $a6ef17ef9fd8408f$export$d1936d9f5737af92(this, this._initSnapshot, storeNames) : this._initSnapshot;
        $a6ef17ef9fd8408f$export$8921d147d4d1b7(this, this.serialize(initialSnapshot), (storeInst)=>{
            storeInst.lifecycle('init');
            storeInst.emitChange();
        });
    }
    flush() {
        const state = this.serialize($a6ef17ef9fd8408f$export$b8801ea43165ed7d(this));
        this.recycle();
        return state;
    }
    bootstrap(data) {
        $a6ef17ef9fd8408f$export$8921d147d4d1b7(this, data, (storeInst, state)=>{
            storeInst.lifecycle('bootstrap', state);
            storeInst.emitChange();
        });
    }
    prepare(storeInst, payload) {
        const data = {};
        if (!storeInst.displayName) throw new ReferenceError('Store provided does not have a name');
        data[storeInst.displayName] = payload;
        return this.serialize(data);
    }
    // Instance type methods for injecting alt into your application as context
    addActions(name, ActionsClass, ...args) {
        this.actions[name] = Array.isArray(ActionsClass) ? this.generateActions.apply(this, ActionsClass) : this.createActions(ActionsClass, ...args);
    }
    addStore(name, StoreModel, ...args) {
        this.createStore(StoreModel, name, ...args);
    }
    getActions(name) {
        return this.actions[name];
    }
    getStore(name) {
        return this.stores[name];
    }
    static debug(name, alt, win) {
        const key = 'alt.js.org';
        let context = win;
        if (!context && typeof window !== 'undefined') context = window;
        if (typeof context !== 'undefined') {
            context[key] = context[key] || [];
            context[key].push({
                name: name,
                alt: alt
            });
        }
        return alt;
    }
    constructor(config = {}){
        this.config = config;
        this.serialize = config.serialize || JSON.stringify;
        this.deserialize = config.deserialize || JSON.parse;
        this.dispatcher = config.dispatcher || new (0, $221e6a129b353ed4$export$ab054a1ef92eeb01)();
        this.batchingFunction = config.batchingFunction || ((callback)=>callback());
        this.actions = {
            global: {}
        };
        this.stores = {};
        this.storeTransforms = config.storeTransforms || [];
        this.trapAsync = false;
        this._actionsRegistry = {};
        this._initSnapshot = {};
        this._lastSnapshot = {};
    }
}
var $67372371ef4e4b08$export$2e2bcd8739ae039 = $67372371ef4e4b08$var$Alt;


/*
export enum lifeCycleEvents {
    Bootstrap,
    Snapshot,
    Init,
    Rollback,
    Error
}
*/ let $a00e419f736658e2$var$alt = new (0, $67372371ef4e4b08$export$2e2bcd8739ae039)();
var $a00e419f736658e2$export$2e2bcd8739ae039 = $a00e419f736658e2$var$alt;


class $c148c8994a598409$var$ProductActions {
    uploadNcpFile(fileName, fileData, fileType) {
        return {
            name: fileName,
            data: fileData,
            ncpType: fileType
        };
    }
    uploadGrFile(fileName, fileData) {
        return {
            name: fileName,
            data: fileData
        };
    }
    calcPoints() {
        return null;
    }
    downloadGrFile() {
        return null;
    }
    mirror() {
        return null;
    }
    mirrorShape() {
        return null;
    }
    rotate() {
        return null;
    }
    rotate90() {
        return null;
    }
    changeValue(field, value, idx) {
        return {
            field: field,
            value: value,
            idx: idx
        };
    }
    moveE(direction) {
        return direction;
    }
    moveP(direction) {
        return direction;
    }
    moveHud(direction) {
        return direction;
    }
    removeP() {
        return null;
    }
    assignP() {
        return null;
    }
    /**
   * NCP info ja GR2 tooteinfo lugemine
   */ readProductData(code, type) {
        return {
            code: code,
            type: type
        };
    }
    /**
   * NCP info ja GR2 tooteinfo salvestamine
   */ saveProductData(code) {
        return code;
    }
    /**
   * NCP ja GR2 tooteinfo kustutamine serverist
   */ deleteProduct(code) {
        return code;
    }
    deleteProductFailed(error) {
        return error;
    }
    deleteProductDone() {
        return null;
    }
    /**
   * Algatatakse toote laadimine serverist
   */ fetchProduct(code) {
        return code;
    }
    /**
   * Toote laadimine ebaõnnestus
   */ fetchProductFailed(error) {
        return error;
    }
    /**
   * Toode sai laetud
   */ fetchProductDone(data) {
        return data;
    }
    /**
   * Toote salvestamine serverisse
   */ saveProduct(code) {
        return code;
    }
    /**
   * Toote salvestamine ebaõnnestus
   */ saveProductFailed(error) {
        return error;
    }
    /**
   * Toode sai salvestatud
   */ saveProductDone() {
        return null;
    }
    /**
   * Algatatakse NCP faili laadimine serverist
   */ fetchNcp(code, type) {
        return {
            code: code,
            type: type
        };
    }
    /**
   * NCP faili laadimine ebaõnnestus
   */ fetchNcpFailed(response) {
        return response;
    }
    /**
   * NCP fail sai laetud
   */ fetchNcpDone(response) {
        return response;
    }
    /**
   * NCP faili salvestamine serverisse
   */ saveNcp() {
        return null;
    }
    /**
   * NCP faili salvestamine ebaõnnestus
   */ saveNcpFailed(error) {
        return error;
    }
    /**
   * NCP fail sai salvestatud
   */ saveNcpDone() {
        return null;
    }
    setSchema(schema) {
        return schema;
    }
}
var $c148c8994a598409$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($c148c8994a598409$var$ProductActions);



/**
 * Teadete kuvamise tegevused.
 * Kasutamine:
 * 
 *  import NotificationActions from './actions/NotificationActions';
 *  NotificationActions.error(message);
 *  
 */ class $26a241f40377239c$var$NotificationActions {
    constructor(){
        this.generateActions('info', 'warning', 'success', 'error', 'dismiss', 'clear');
    }
}
var $26a241f40377239c$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($26a241f40377239c$var$NotificationActions);





class $b1b3b27ecff41190$var$SettingsActions {
    settingsUpdated(settings) {
        return settings;
    }
}
var $b1b3b27ecff41190$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($b1b3b27ecff41190$var$SettingsActions);





class $540451a9382377f9$export$2e2bcd8739ae039 {
    isEqual(other) {
        return this.lineCount === other.lineCount && this.hudPoints === other.hudPoints && this.addPoints === other.addPoints && this.adasAreasCount === other.adasAreasCount && this.angleCount === other.angleCount;
    }
    /**
   * Joonte arv
   */ /**
   * HUD punktide arv
   */ /**
   * Täiendavate punktide arv keskmisel joonel
   */ /**
   * ADAS piirkondade arv
   * @type {IntegerType}
   */ /**
   * Nurganominaalide arv
   * @type {IntegerType}
   */ constructor(state){
        this.lineCount = state.lineCount ? state.lineCount : 3;
        this.hudPoints = state.hudPoints ? state.hudPoints : 0;
        this.addPoints = state.addPoints ? state.addPoints : 0;
        this.adasAreasCount = state.adasAreasCount ? state.adasAreasCount : 0;
        this.angleCount = state.angleCount ? state.angleCount : 1;
    }
}


const $487b7e0315c147c0$var$AppConfig = {
    // Base URL to where UI should make REST requests
    BASE_URL: 'KlpmsData.svc',
    // Set true if API requests are cross-domain
    USE_CROSSDOMAIN: false,
    // Number of HUD points
    // Default HUD points line (first line is 1)
    HUD_DEFAULT_LINE: 1,
    // Default fist HUD point offset from the edge (mm)
    HUD_DEFAULT_OFFSET: 300,
    // Default step between HUD points (mm)
    HUD_DEFAULT_STEP: 50,
    // How many angles to display on the wagons screen
    ANGLE_COUNT: 1,
    // Default line count
    DEFAULT_LINE_COUNT: 3,
    // Default HUD points
    DEFAULT_HUD_POINTS: 0,
    /// Default additional points
    DEFAULT_ADD_POINTS: 0,
    // Default ADAS areas count
    DEFAULT_ADAS_AREAS: 0,
    // Default tolerances: [1k, 2k, 1s, 2s, 1l, 2l, 1h, 2h]
    DEFAULT_TOLERANCES: [
        1.7,
        2.2,
        1.2,
        1.7,
        1.5,
        2.1,
        1.5,
        1.5
    ]
};
var $487b7e0315c147c0$export$2e2bcd8739ae039 = $487b7e0315c147c0$var$AppConfig;


/**
 * Wrapper klass vanale settings objektile
 */ class $25b5d8d272d0fdf3$var$SettingsStore {
    onSettingsUpdated(settings) {
        this.setState(settings);
    }
    getLineCount() {
        var _this_state_conf_measurement_line_count;
        return (_this_state_conf_measurement_line_count = this.state.conf_measurement_line_count) !== null && _this_state_conf_measurement_line_count !== void 0 ? _this_state_conf_measurement_line_count : 3;
    }
    getCenterAddPoints() {
        var _this_state_conf_center_add_points;
        return (_this_state_conf_center_add_points = this.state.conf_center_add_points) !== null && _this_state_conf_center_add_points !== void 0 ? _this_state_conf_center_add_points : 0;
    }
    getHudPoints() {
        var _this_state_conf_hud_points;
        return (_this_state_conf_hud_points = this.state.conf_hud_points) !== null && _this_state_conf_hud_points !== void 0 ? _this_state_conf_hud_points : 0;
    }
    getAdasAreasCount() {
        var _this_state_conf_adas_area_count;
        return (_this_state_conf_adas_area_count = this.state.conf_adas_area_count) !== null && _this_state_conf_adas_area_count !== void 0 ? _this_state_conf_adas_area_count : 6;
    }
    getAnglePoints() {
        var _this_state_conf_angle_points;
        return (_this_state_conf_angle_points = this.state.conf_angle_points) !== null && _this_state_conf_angle_points !== void 0 ? _this_state_conf_angle_points : 1;
    }
    isNcpRotated() {
        var _this_state_ncpRotated;
        return (_this_state_ncpRotated = this.state.ncpRotated) !== null && _this_state_ncpRotated !== void 0 ? _this_state_ncpRotated : false;
    }
    isSimpleUi() {
        var _this_state_conf_simple_ui;
        return (_this_state_conf_simple_ui = this.state.conf_simple_ui) !== null && _this_state_conf_simple_ui !== void 0 ? _this_state_conf_simple_ui : false;
    }
    getGlassFileType() {
        var _this_state_conf_glass_file_type;
        return (_this_state_conf_glass_file_type = this.state.conf_glass_file_type) !== null && _this_state_conf_glass_file_type !== void 0 ? _this_state_conf_glass_file_type : "dat,ncp";
    }
    getYshiftOffset() {
        var _this_state_conf_yshift_offset;
        return (_this_state_conf_yshift_offset = this.state.conf_yshift_offset) !== null && _this_state_conf_yshift_offset !== void 0 ? _this_state_conf_yshift_offset : 763;
    }
    isRotatedMeasurementAllowed() {
        return this.state.conf_rotated_measurement_allowed;
    }
    getProductConfig() {
        return new (0, $540451a9382377f9$export$2e2bcd8739ae039)({
            lineCount: this.getLineCount(),
            addPoints: this.getCenterAddPoints(),
            hudPoints: this.getHudPoints(),
            adasAreasCount: this.getAdasAreasCount(),
            angleCount: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).ANGLE_COUNT
        });
    }
    constructor(){
        this.state = {};
        this.bindActions((0, $b1b3b27ecff41190$export$2e2bcd8739ae039));
        this.exportPublicMethods({
            getLineCount: this.getLineCount,
            getCenterAddPoints: this.getCenterAddPoints,
            getHudPoints: this.getHudPoints,
            getAdasAreasCount: this.getAdasAreasCount,
            isNcpRotated: this.isNcpRotated,
            isSimpleUi: this.isSimpleUi,
            getGlassFileType: this.getGlassFileType,
            getYshiftOffset: this.getYshiftOffset,
            isRotatedMeasurementAllowed: this.isRotatedMeasurementAllowed,
            getProductConfig: this.getProductConfig
        });
    }
}
var $25b5d8d272d0fdf3$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($25b5d8d272d0fdf3$var$SettingsStore, 'SettingsStore');




/**
 * WebApi - back-endiga suhtlemise klass. Kasutamine:
 * 
 * WebApi = require('/api/WebApi');
 * WebApi
 *  	.get(table, id)
 *  	.then(function (response) {
 *  		// Päring õnnestus, parameetri response ülesehitus vt allpool
 *  	})
 *  	.catch(function (reason) {
 *  		// Juhtus viga, parameetri reason ülesehitus on järgnev:
 *  		// reason.response - response objekt (eksisteerib juhul, kui tegemist serveri vastusega indikeeritud veaga)
 *  		// reason.message - veateate tekst, täidetud juhul, kui response objekti pole
 *  	});
 *  
 *  Response objekt on järgmise struktuuriga:
 *  response = {
 *  	data - serveri poolt tagastatud data
 *  	status - serveri poolt tagastatud staatuskood
 *  	statusText - serveri poolt tagastatud staatuskoodile järgnenud tekst
 *  	headers - serveri poolt tagastatud päised objektina
 *  	config - päringu konfiguratsioon
 *  }
 *  
 * Kasutada saab järgmisi meetodeid:
 * 
 *  WebApi.url(url)
 *  WebApi.authorization(token)
 *  
 *  WebApi.find(table, queryObject)
 *  WebApi.get(table, id)
 *  WebApi.put(table, id, object)
 *  WebApi.post(table, object)
 *  WebApi.delete(table, id)
 * 
 */ var $c6ba0193c6fadd6f$exports = {};

$c6ba0193c6fadd6f$exports = (parcelRequire("a04va"));





var $Sd5lO = parcelRequire("Sd5lO");

/**
 * Converts object to URL query parameters string.
 * Array values will be converted to comma-separated values
 * @param params Parameters object. Values can be numbers, strings or arrays
 * @returns {string} Query string
 */ function $6ccea4b9e4a830cb$export$e5768b31beb12e6c(params) {
    if (params == null) return "";
    params = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).omitBy(params, (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isUndefined);
    params = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).omitBy(params, (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNull);
    let fixedParams = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).mapValues(params, function(value) {
        if (value && value.constructor === Array) return value.join(",");
        return value;
    });
    return new URLSearchParams(Object.entries(fixedParams)).toString();
}


class $59639b2051a49c08$var$ServiceError extends Error {
    constructor(response){
        super(response.statusText);
        this.response = response;
    }
}
var $59639b2051a49c08$export$2e2bcd8739ae039 = $59639b2051a49c08$var$ServiceError;


class $bd4d723925db9569$var$BaseService {
    async makeRequest(method, service, params, body) {
        let options = {
            method: method
        };
        if (body != null) {
            options.body = JSON.stringify({
                data: body
            });
            options.headers = {
                "Content-Type": "application/json; charset=UTF-8"
            };
        }
        const urlParams = (0, $6ccea4b9e4a830cb$export$e5768b31beb12e6c)(params);
        const request = new Request(this.baseUrl + "/" + service + (params == null ? "" : "?" + urlParams), options);
        const response = await fetch(request, {
            signal: this.controller.signal
        }).catch((error)=>{
            console.error(error);
            throw new Error(error);
        });
        if (!response.ok) throw new (0, $59639b2051a49c08$export$2e2bcd8739ae039)(response);
        return response.json();
    }
    async getData(service, params = null) {
        return this.makeRequest("GET", service, params);
    }
    async postData(service, body) {
        return this.makeRequest("POST", service, null, body);
    }
    async putData(service, body) {
        return this.makeRequest("PUT", service, null, body);
    }
    async deleteData(service, params = null) {
        return this.makeRequest("DELETE", service, params);
    }
    abort() {
        this.controller.abort();
    }
    constructor(baseUrl){
        this.baseUrl = baseUrl;
        this.controller = new AbortController();
    }
}
var $bd4d723925db9569$export$2e2bcd8739ae039 = $bd4d723925db9569$var$BaseService;



/**
 * Services class for making KLPMS REST API requests.
 * Use like:
 * ```javascript
 * let service = new KlpmsService();
 * try {
 *     const data = await service.logon(username, password);
 * } catch (error: Error) {
 *     if (error instanceof ServiceError) {
 *         // HTTP-level error (that is - HTTP status code 4xx or 5xx)
 *         let response: Response = error.response;
 *     } else {
 *         // Low-level error (e.g. unable to connect)
 *         let name: string = error.name;
 *         let message: string = error.message;
 *         let stack: string = error.stack;
 *     }
 * }
 * ```
 */ class $7ab5470b2f751726$var$KlpmsService extends (0, $bd4d723925db9569$export$2e2bcd8739ae039) {
    async getProductVersions(codeVariant) {
        return this.getData("productVersions/" + codeVariant);
    }
    async getWagon(nr) {
        return this.getData("wagons/" + nr.toString());
    }
    async getWagonCurrent() {
        return this.getData("wagons/current");
    }
    async getWagonManual() {
        return this.getData("wagons/manual");
    }
    async postManualMeasuring(codeVariant) {
        return this.postData("manualMeasuring", {
            kood: codeVariant
        });
    }
    /**
   * Logs the user in
   * @param username Username
   * @param password Password
   * @returns {Promise<SessionResultType>}
   */ async logon(username, password) {
        const userInfo = {
            username: username,
            password: password
        };
        return this.postData("logon", userInfo);
    }
    async logoff() {
        return this.postData("logoff", null);
    }
    constructor(){
        super((0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL);
    }
}
var $7ab5470b2f751726$export$2e2bcd8739ae039 = $7ab5470b2f751726$var$KlpmsService;





/**
 * Session store
 *
 * Used for keeping track logged-in status.
 *
 * Status changes:
 *   logoff - user is logged off
 *   in_progress - logon or logoff is in progress
 *   logon - user is logged on
 *   error - logon or logoff failed
 * Required roles can be:
 *      user
 *      archive
 *      admin
 *      adminPassword
 */ class $5e4143938ffd9baf$var$SessionStore {
    async logon(username, password, role = null) {
        try {
            if (this.status === "in_progress") return;
            this.status = "in_progress";
            if (role != null) this.setRequiredRole(role);
            const response = await this.klpmsService.logon(username, password);
            (0, $Sd5lO.runInAction)(()=>{
                this.status = "logon";
                this.session = response.logonResult;
                this.password = password;
                if (!this.hasRequiredRole()) {
                    this.session = null;
                    this.password = null;
                    console.log("logon: invalidating local session because of role mismatch");
                    this.storeSessionToLocalStorage(null);
                    this.status = "error";
                    console.log("Invalid role: " + role);
                    (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid role"));
                } else this.storeSessionToLocalStorage(response.logonResult);
            });
        } catch (error) {
            (0, $Sd5lO.runInAction)(()=>{
                this.session = null;
                this.password = null;
                this.storeSessionToLocalStorage(null);
                this.status = "error";
                console.log("Error executing sessionService.logon: " + error.message);
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid user name or password"));
            });
        }
    }
    async logoff() {
        try {
            if (this.status === "in_progress") return;
            this.status = "in_progress";
            await this.klpmsService.logoff();
            (0, $Sd5lO.runInAction)(()=>{
                this.session = null;
                this.password = null;
                console.log("logoff: invalidating local session");
                this.storeSessionToLocalStorage(null);
                this.status = "logoff";
            });
        } catch (error) {
            (0, $Sd5lO.runInAction)(()=>{
                this.session = null;
                this.password = null;
                console.log("logoff: invalidating local session because of an error");
                this.storeSessionToLocalStorage(null);
                this.status = "error";
                console.log("Error executing sessionService.logoff: " + error.message);
            });
        }
    }
    isLoggedOn() {
        return this.status == "logon";
    }
    hasRole(role) {
        if (this.status != "logon") return false;
        if (role == null) return true;
        switch(role){
            case "adminPassword":
                return this.session.role == "admin" && this.getPassword() != null;
            case "admin":
                return this.session.role == "admin";
            case "archive":
                return this.session.role == "archive" || this.session.role == "admin";
            case "user":
                return true;
            default:
                // Invalid role specification:
                return false;
        }
    }
    hasRequiredRole() {
        return this.hasRole(this.requiredRole);
    }
    setRequiredRole(requiredRole) {
        this.requiredRole = requiredRole;
    }
    getRequiredRoleName() {
        if (this.requiredRole == "adminPassword") return "admin";
        return this.requiredRole;
    }
    /**
   * Empties cached data
   */ invalidate() {
        console.log("invalidate: Invalidating local session");
        this.session = null;
        this.storeSessionToLocalStorage(null);
        this.status = "logoff";
    }
    getSession() {
        return (0, $Sd5lO.toJS)(this.session);
    }
    getToken() {
        return this.session == null ? null : this.session.token;
    }
    getUsername() {
        return this.session == null ? null : this.session.user;
    }
    getPassword() {
        return this.password == null || this.password == "" ? null : "" + this.password;
    }
    getExpires(expires = null) {
        if (expires == null) {
            if (this.session == null || this.session.expires == null) return null;
            expires = this.session.expires;
        }
        return new Date(expires);
    }
    storeSessionToLocalStorage(session) {
        if (session == null) localStorage.removeItem("session");
        else localStorage.setItem("session", JSON.stringify(session));
    }
    readSessionFromLocalStorage() {
        let sessionStr = localStorage.getItem("session");
        if (sessionStr == null) return null;
        let sessionObject = JSON.parse(sessionStr);
        // Parse expires date:
        let expires = this.getExpires(sessionObject.expires);
        if (expires <= new Date()) {
            // If session is expired OR expires soon, then remove it immediately:
            localStorage.removeItem("session");
            return null;
        }
        return sessionObject;
    }
    constructor(){
        // Minimum number of seconds the existing session should be valid when session store is created:
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "INITIAL_MIN_SESSION_EXPIRES", 10);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "status", "logoff");
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "session", null);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "password", null);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "requiredRole", null);
        this.klpmsService = new (0, $7ab5470b2f751726$export$2e2bcd8739ae039)();
        (0, $Sd5lO.makeObservable)(this, {
            session: (0, $Sd5lO.observable),
            status: (0, $Sd5lO.observable),
            password: (0, $Sd5lO.observable),
            requiredRole: (0, $Sd5lO.observable),
            logon: (0, $Sd5lO.action),
            logoff: (0, $Sd5lO.action),
            setRequiredRole: (0, $Sd5lO.action),
            invalidate: (0, $Sd5lO.action)
        });
        let localSession = this.readSessionFromLocalStorage();
        if (localSession != null && this.getExpires(localSession.expires).getTime() > Date.now() + this.INITIAL_MIN_SESSION_EXPIRES * 1000) {
            this.session = localSession;
            this.status = "logon";
        } else {
            this.session = null;
            console.log("SessionStore.constructor: invalidating local session");
            this.storeSessionToLocalStorage(null);
            this.status = "logoff";
        }
    }
}
var $5e4143938ffd9baf$export$2e2bcd8739ae039 = $5e4143938ffd9baf$var$SessionStore;


class $1a271afb525e8cfa$export$5b19c597f1926e87 {
    constructor(){
        this.sessionStore = new (0, $5e4143938ffd9baf$export$2e2bcd8739ae039)();
    }
}
const $1a271afb525e8cfa$var$rootStore = new $1a271afb525e8cfa$export$5b19c597f1926e87();
var $1a271afb525e8cfa$export$2e2bcd8739ae039 = $1a271afb525e8cfa$var$rootStore;


//import NotificationActions from './actions/NotificationActions';
class $2d56dcdc0f2f4752$var$WebApi {
    static url(baseUrl) {
        (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).defaults.baseURL = baseUrl;
    }
    static authorization(token) {
        (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).defaults.headers.common['Authorization'] = token;
    }
    static handleError(error) {
        if (error.response) console.log('Error', 'Response status: ' + error.response.status.toString());
        else // Internal error:
        console.log('Error', error.message);
        throw error;
    }
    static getResource(url, query, config = null) {
        let c = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).defaults({
            params: query
        }, config);
        if (!c.auth) c.headers = {
            "Authorization": "Bearer " + (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getToken()
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).get(url, c).catch($2d56dcdc0f2f4752$var$WebApi.handleError);
    }
    static putResource(url, data, config = null) {
        let c = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).defaults({}, config);
        if (!c.auth) c.headers = {
            "Authorization": "Bearer " + (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getToken()
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).put(url, {
            data: data
        }, c).catch($2d56dcdc0f2f4752$var$WebApi.handleError);
    }
    static postResource(url, data, config = null) {
        let c = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).defaults({}, config);
        if (!c.auth) c.headers = {
            "Authorization": "Bearer " + (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getToken()
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).post(url, {
            data: data
        }, c).catch($2d56dcdc0f2f4752$var$WebApi.handleError);
    }
    static deleteResource(url, config = null) {
        let c = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).defaults({}, config);
        if (!c.auth) c.headers = {
            "Authorization": "Bearer " + (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getToken()
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).delete(url, c).catch($2d56dcdc0f2f4752$var$WebApi.handleError);
    }
    static getData(url, config = null) {
        let c = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).defaults({
            responseType: 'text'
        }, config);
        if (!c.auth) c.headers = {
            "Authorization": "Bearer " + (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getToken()
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).get(url, c).catch($2d56dcdc0f2f4752$var$WebApi.handleError);
    }
    static putData(url, data, config = null) {
        let c = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).defaults({
            headers: {
                'Content-Type': 'text/plain'
            }
        }, config);
        if (!c.auth) c.headers["Authorization"] = "Bearer " + (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getToken();
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).put(url, data, c).catch($2d56dcdc0f2f4752$var$WebApi.handleError);
    }
    /**
   * Toote lugemine
   * @param {string} code Toote kood
   */ static getProduct(code) {
        return this.getResource('/products/' + code);
    }
    /**
   * Toote salvestamine
   * @param {string} code Toote kood
   * @param {object} data Toote andmed
   */ static postProduct(code, data) {
        return this.postResource('/products/' + code, data);
    }
    static deleteProduct(code) {
        return this.deleteResource('/products/' + code);
    }
    /**
   * NCP faili lugemine
   * @param {string} code Toote kood
   * @param {string} type Faili tüüp (kas 'ncp' või 'dat')
   */ static getNcp(code, type) {
        return this.getData('/ncp/' + code + "." + type);
    }
    /**
   * NCP faili salvestamine
   * @param {string} code Toote kood
   * @param {string} type Faili tüüp (kas 'ncp' või 'dat')
   * @param {string} data Toote andmed
   */ static putNcp(code, type, data) {
        return this.putData('/ncp/' + code + "." + type, data);
    }
    static getConfig() {
        return this.getResource("/configuration", null);
    }
    static putConfig(data) {
        return this.putResource("/configuration", data);
    }
    static getActiveConfig() {
        return this.getResource("/configuration/active", null);
    }
    static getSchema(schema) {
        return this.getResource("../schema/" + encodeURIComponent(schema) + ".json").then(function(result) {
            result.schema = schema;
            return result;
        }).catch(function(error) {
            error.schema = schema;
            throw error;
        });
    }
    static getSoftwareInfo(user, passwd) {
        return this.getResource("/firmware/info", null, {
            auth: {
                username: user,
                password: passwd
            }
        });
    }
    static postSoftwareUpdate(file, user, passwd) {
        return this.postResource("/firmware/update", {
            file: file
        }, {
            auth: {
                username: user,
                password: passwd
            }
        });
    }
    static postSoftwareRestore(user, passwd) {
        return this.postResource("/firmware/restore", null, {
            auth: {
                username: user,
                password: passwd
            }
        });
    }
    static getDiagnostics() {
        return this.getResource("/diagnostics", null);
    }
    static createQueryString(obj) {
        let str = [];
        for(let p in obj)if (obj.hasOwnProperty(p)) str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
    }
}
var $2d56dcdc0f2f4752$export$2e2bcd8739ae039 = $2d56dcdc0f2f4752$var$WebApi;







/**
 * Klass kajastab klaasi andmeid, mis on sisse parsitud NCP failist.
 * Kasutamine:
 *  var g = new GlassInfo(isRotated);
 *  g.parseNcp(data);
 *  
 *  Parsitud info paigutatakse:
 *  
 *  g.joonx1 - massiiv lõikude x1 koordinaatidest
 *  g.joonx2 - massiiv lõikude x2 koordinaatidest
 *  g.joony1 - massiiv lõikude y1 koordinaatidest
 *  g.joony2 - massiiv lõikude y2 koordinaatidest
 *
 *  Lisaks arvutatakse juurde:
 *
 *  g.tahvelx - kujundit ümbritseva ristküliku x-laius
 *  g.tahvely - kujundit ümbritseva ristküliky y-laius
 *  g.maxx - kujundi maksimaalne x koordinaat
 *  g.maxy - kujundi maksimaalne y koordinaat
 *  g.minx - kujundi minimaalne x koordinaat
 *  g.miny - kujundi minimaalne y koordinaat
 *  g.keskx - kujundi keskpunkti x koordinaat
 *  g.kesky - kujundi keskpunkti y koordinaat
 *
 */ class $33d2aa29355d2916$var$GlassInfo {
    extend(data) {
        for (let item of (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).keys(data)){
            if (!(item in this)) continue;
            if (Array.isArray(data[item])) this[item] = data[item].slice();
            else this[item] = data[item];
        }
    }
    /**
   * loefail:
   * 		kaaresta
   * 		arvutakeskpunkt
   * 		arvuta_e
   * 			arvuta_p
   * 			koordinaadid
   * 		arvuta_p
   * 		koordinaadid
   * 			arvuta_Kalle
   * 		joonista
   */ loadGlassData(data, rotated) {
        // Väärtustame:
        this.rotated = rotated;
        this.keeratud = false;
        this.peegeldatud = false;
        this.extend(data);
        this.calcShape();
    }
    calcShape() {
        this.tahvelx = 2000;
        this.tahvely = 2000;
        this.maxx = 0;
        this.maxy = 0;
        this.minx = this.tahvelx;
        this.miny = this.tahvely;
        for(let i = 0; i < this.ridu; i++){
            if (this.joonx2[i] < this.minx) this.minx = this.joonx2[i];
            if (this.joony2[i] < this.miny) this.miny = this.joony2[i];
            if (this.joonx2[i] > this.maxx) this.maxx = this.joonx2[i];
            if (this.joony2[i] > this.maxy) this.maxy = this.joony2[i];
        }
        for(let i = 0; i < this.ridu; i++){
            this.joonx1[i] += Math.abs(this.minx) + 10.111;
            this.joonx2[i] += Math.abs(this.minx) + 10.111;
            this.joony1[i] += Math.abs(this.miny) + 10.111;
            this.joony2[i] += Math.abs(this.miny) + 10.111;
        }
        this.maxx = this.maxx + Math.abs(this.minx) + 10;
        this.maxy = this.maxy + Math.abs(this.miny) + 10;
        this.minx = this.minx + Math.abs(this.minx) + 10;
        this.miny = this.miny + Math.abs(this.miny) + 10;
        this.tahvelx = this.maxx + 10;
        this.tahvely = this.maxy + 10;
        this.arvutaKeskpunkt();
    }
    arvutaKeskpunkt() {
        this.keskx = (this.maxx - this.minx) / 2 + this.minx;
        this.kesky = (this.maxy - this.miny) / 2 + this.miny;
        for(let i = 0; i < this.ridu; i++){
            this.joonx1[i] = this.joonx1[i] - this.keskx;
            this.joonx2[i] = this.joonx2[i] - this.keskx;
            this.joony1[i] = this.joony1[i] - this.kesky;
            this.joony2[i] = this.joony2[i] - this.kesky;
        }
    }
    rotate90() {
        for(let i = 0; i < this.ridu; i++){
            let tmp = this.joonx2[i];
            this.joonx2[i] = this.joony2[i];
            this.joony2[i] = tmp;
            tmp = this.joonx1[i];
            this.joonx1[i] = this.joony1[i];
            this.joony1[i] = tmp;
        }
        this.rotated = !this.rotated;
        this.calcShape();
    }
    rotate180() {
        for(let i = 0; i < this.ridu; i++){
            this.joonx1[i] = this.joonx1[i] > 0 ? 0 - this.joonx1[i] : Math.abs(this.joonx1[i]);
            this.joonx2[i] = this.joonx2[i] > 0 ? 0 - this.joonx2[i] : Math.abs(this.joonx2[i]);
            this.joony1[i] = this.joony1[i] > 0 ? 0 - this.joony1[i] : Math.abs(this.joony1[i]);
            this.joony2[i] = this.joony2[i] > 0 ? 0 - this.joony2[i] : Math.abs(this.joony2[i]);
        }
        this.keeratud = !this.keeratud;
    }
    mirror() {
        let abimaxx = -10000;
        let abiminx = 10000;
        for(let i = 0; i < this.ridu; i++){
            if (this.joonx1[i] > abimaxx) abimaxx = this.joonx1[i];
            if (this.joonx1[i] < abiminx) abiminx = this.joonx1[i];
        }
        for(let i = 0; i < this.ridu; i++){
            this.joonx1[i] = abimaxx - this.joonx1[i] + abiminx;
            this.joonx2[i] = abimaxx - this.joonx2[i] + abiminx;
        }
        this.peegeldatud = !this.peegeldatud;
    }
    /**
   * Kas klaas on 90 kraadi keeratud
   */ /**
   * Kas klaas on 180 kraadi keeratud
   */ /**
   * Kas klaas on peegeldatud
   */ /**
   * kujundit ümbritseva ristküliku x-laius
   */ /**
   * kujundit ümbritseva ristküliky y-laius
   */ /**
   * kujundi maksimaalne x koordinaat
   */ /**
   * kujundi maksimaalne y koordinaat
   */ /**
   * kujundi minimaalne x koordinaat
   */ /**
   * kujundi minimaalne y koordinaat
   */ /**
   * massiiv lõikude x1 koordinaatidest
   */ /**
   * massiiv lõikude x2 koordinaatidest
   */ /**
   * massiiv lõikude y1 koordinaatidest
   */ /**
   * massiiv lõikude y2 koordinaatidest
   */ /**
   * Ridade arv
   */ /**
   * kujundi keskpunkti x koordinaat
   */ /**
   * kujundi keskpunkti y koordinaat
   */ /**
   *
   * @param data
   */ constructor(data){
        this.rotated = false;
        this.keeratud = false;
        this.peegeldatud = false;
        this.tahvelx = 0;
        this.tahvely = 0;
        this.maxx = 0;
        this.maxy = 0;
        this.minx = 0;
        this.miny = 0;
        this.joonx1 = [];
        this.joonx2 = [];
        this.joony1 = [];
        this.joony2 = [];
        this.ridu = 0;
        this.keskx = 0;
        this.kesky = 0;
        if (data) this.extend(data);
    }
}
var $33d2aa29355d2916$export$2e2bcd8739ae039 = $33d2aa29355d2916$var$GlassInfo;



var $30071e4d8f83fdfd$exports = {};

$parcel$export($30071e4d8f83fdfd$exports, "calcAngle", function () { return $30071e4d8f83fdfd$export$11a7b5abbf8340a; });
$parcel$export($30071e4d8f83fdfd$exports, "limit_timestamp", function () { return $30071e4d8f83fdfd$export$719af6d430903ba6; });
$parcel$export($30071e4d8f83fdfd$exports, "jsonAjax", function () { return $30071e4d8f83fdfd$export$46e8075064842a03; });
$parcel$export($30071e4d8f83fdfd$exports, "activateMenuItem", function () { return $30071e4d8f83fdfd$export$3c47130985814430; });
$parcel$export($30071e4d8f83fdfd$exports, "htmlEncode", function () { return $30071e4d8f83fdfd$export$acafce1f52201e8f; });
$parcel$export($30071e4d8f83fdfd$exports, "is_numeric", function () { return $30071e4d8f83fdfd$export$5fe1d4742c8a41e2; });
$parcel$export($30071e4d8f83fdfd$exports, "getURLParameter", function () { return $30071e4d8f83fdfd$export$d945b34716c152fb; });
$parcel$export($30071e4d8f83fdfd$exports, "getCurrentPage", function () { return $30071e4d8f83fdfd$export$7945ba8eb1c827e6; });
$parcel$export($30071e4d8f83fdfd$exports, "getProductCode", function () { return $30071e4d8f83fdfd$export$b396c2481bedae58; });
$parcel$export($30071e4d8f83fdfd$exports, "asNumber", function () { return $30071e4d8f83fdfd$export$37576b9ba69b50db; });
$parcel$export($30071e4d8f83fdfd$exports, "asBoolean", function () { return $30071e4d8f83fdfd$export$ffde277b1072591c; });
$parcel$export($30071e4d8f83fdfd$exports, "asString", function () { return $30071e4d8f83fdfd$export$590567be997858b6; });
$parcel$export($30071e4d8f83fdfd$exports, "getInt", function () { return $30071e4d8f83fdfd$export$c47d79b712795940; });
$parcel$export($30071e4d8f83fdfd$exports, "getDecimal", function () { return $30071e4d8f83fdfd$export$9cf8f5ff7b34d6ff; });
$parcel$export($30071e4d8f83fdfd$exports, "getBoolean", function () { return $30071e4d8f83fdfd$export$11811c4d2c6a473d; });

function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


var $2679c250f7f84a9c$export$2e2bcd8739ae039 = window.$;




var $9af90d56d541a368$export$2e2bcd8739ae039 = window.bootbox;



class $3bbe070f9dec5e64$var$Popup {
    static show_err(s, callback) {
        (0, $9af90d56d541a368$export$2e2bcd8739ae039).alert(s, callback);
    }
    static show_success(s, callback) {
        (0, $9af90d56d541a368$export$2e2bcd8739ae039).alert(s, callback);
    }
    static ask_passwd(callbackFunc) {
        (0, $9af90d56d541a368$export$2e2bcd8739ae039).prompt({
            title: (0, $865532d99f221026$export$4fa6d59685552a7c)("Enter password"),
            inputType: "password",
            callback: function(result) {
                callbackFunc(result);
            }
        });
    }
    static ask_input(message, defaultValue, callbackFunc) {
        (0, $9af90d56d541a368$export$2e2bcd8739ae039).prompt({
            title: message,
            value: defaultValue,
            callback: function(result) {
                callbackFunc(result);
            }
        });
    }
}
var $3bbe070f9dec5e64$export$2e2bcd8739ae039 = $3bbe070f9dec5e64$var$Popup;




function $30071e4d8f83fdfd$export$11a7b5abbf8340a(x1, y1, x2, y2) {
    // Division by zero check:
    if (y2 === y1) return 0;
    if (x1 > x2) {
        let tmp = x2;
        x2 = x1;
        x1 = tmp;
    }
    let x0 = (y2 * x1 - y1 * x2) / (y2 - y1);
    if (x2 === x0) return 90;
    let tanAlpha = y2 / (x2 - x0);
    let alpha = Math.atan(tanAlpha);
    return Math.round(10 * alpha * 180 / Math.PI) / 10;
}
function $30071e4d8f83fdfd$export$719af6d430903ba6(str) {
    let n = 19;
    if (!str) return "";
    if (str.length > n) return str.substring(0, n).replace("T", " "); //+"...";
    return str;
}
function $30071e4d8f83fdfd$export$46e8075064842a03(options) {
    options = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        statusCode: {
            401: function() {
                // Authentication required
                console.log("jsonAjax(): STATUS 401: invalidating session, url: " + options.url);
                (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
            },
            403: function() {
                // Need to reauthenticate
                console.log("jsonAjax(): STATUS 403: invalidating session, url: " + options.url);
                (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
            }
        }
    }, options), {
        dataType: "json",
        cache: false,
        crossDomain: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).USE_CROSSDOMAIN,
        contentType: "application/json",
        beforeSend: function(xhr) {
            let session = (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getSession();
            if (session != null && session.token != null) xhr.setRequestHeader('Authorization', 'Bearer ' + session.token);
        }
    });
    if (typeof options.data === "object") options.data = JSON.stringify(options.data);
    (0, $2679c250f7f84a9c$export$2e2bcd8739ae039).ajax(options);
}
function $30071e4d8f83fdfd$export$3c47130985814430(item) {
    (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("ul.nav > li").removeClass("active");
    (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#" + item + "_li").addClass("active");
}
function $30071e4d8f83fdfd$export$acafce1f52201e8f(value) {
    //create an in-memory div, set its inner text(which jQuery automatically encodes)
    //then grab the encoded contents back out.  The div never exists on the page.
    return (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('<div/>').text(value).html();
}
function $30071e4d8f83fdfd$export$5fe1d4742c8a41e2(num) {
    //return (num >=0 || num < 0);
    return typeof num === 'number' && isFinite(num);
}
function $30071e4d8f83fdfd$export$d945b34716c152fb(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(window.location.search) || [
        null,
        ""
    ])[1].replace(/\+/g, '%20')) || null;
}
function $30071e4d8f83fdfd$export$7945ba8eb1c827e6() {
    let page = window.location.href.substring(window.location.href.lastIndexOf("/") + 1);
    let i = page.indexOf("#");
    if (i >= 0) page = page.substring(0, i);
    i = page.indexOf("?");
    if (i >= 0) page = page.substring(0, i);
    return page;
}
function $30071e4d8f83fdfd$export$b396c2481bedae58(codeVariant) {
    if (codeVariant == null) return null;
    let arr = codeVariant.split('_');
    return arr[0];
}
function $30071e4d8f83fdfd$export$37576b9ba69b50db(val, def = 0) {
    if (val == null || !(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNumber(val) || isNaN(val)) return def;
    return val;
}
function $30071e4d8f83fdfd$export$ffde277b1072591c(val, def = false) {
    if (val == null || !(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isBoolean(val)) return def;
    return val;
}
function $30071e4d8f83fdfd$export$590567be997858b6(val, def = "") {
    if (val == null) return def;
    if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(val)) return val.toString();
    return val;
}
function $30071e4d8f83fdfd$export$c47d79b712795940(val) {
    if (val == null) return null;
    let res = parseInt(val);
    if (isNaN(res)) return null;
    return res;
}
function $30071e4d8f83fdfd$export$9cf8f5ff7b34d6ff(val) {
    if (val == null) return null;
    let res = parseFloat(val);
    if (isNaN(res)) return null;
    return res;
}
function $30071e4d8f83fdfd$export$11811c4d2c6a473d(val) {
    if (val == null) return null;
    if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isBoolean(val)) return val;
    if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNumber(val)) return val > 0;
    if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(val)) switch(val.toLowerCase()){
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
    return null;
}







// Global objects







/**
 * Vagunite konfiguratsiooni haldav objekt
 */ class $e201fb47f21e9b8a$var$WagonConf {
    /**
   * Vagunite info, vastab serverist loetud struktuurile
   */ /**
   * @returns {WagonConf}
   */ static getInstance() {
        if ($e201fb47f21e9b8a$var$WagonConf.wagonConfInstance == null) $e201fb47f21e9b8a$var$WagonConf.wagonConfInstance = new $e201fb47f21e9b8a$var$WagonConf();
        return $e201fb47f21e9b8a$var$WagonConf.wagonConfInstance;
    }
    isMootmine(n) {
        if (!this.wagons[n]) return true;
        return !this.wagons[n].m;
    }
    isServaotsing(n) {
        if (!this.wagons[n]) return false;
        return this.wagons[n].e;
    }
    isForcedServaotsing(n) {
        if (!this.wagons[n]) return false;
        return this.wagons[n].fe;
    }
    getRaamiNr(n) {
        if (!this.wagons[n] || this.wagons[n].s == null) return "";
        return this.wagons[n].s;
    }
    getKood(n) {
        if (!this.wagons[n] || this.wagons[n].pc == null) return "";
        return this.wagons[n].pc;
    }
    setMootmine(n, mootmine) {
        if (!this.wagons[n]) this.wagons[n] = {
            n: n == 0 ? -1 : n
        };
        this.wagons[n].m = !mootmine;
        this.save(n);
    }
    setServaotsing(n, servaotsing) {
        if (!this.wagons[n]) this.wagons[n] = {
            n: n == 0 ? -1 : n
        };
        this.wagons[n].e = servaotsing ? true : false;
        this.save(n);
    }
    setForcedServaotsing(n, servaotsing) {
        if (!this.wagons[n]) this.wagons[n] = {
            n: n == 0 ? -1 : n
        };
        this.wagons[n].fe = servaotsing ? true : false;
        this.save(n);
    }
    setRaamiNr(n, raam) {
        if (!this.wagons[n]) this.wagons[n] = {
            n: n == 0 ? -1 : n
        };
        this.wagons[n].s = raam + "";
        this.save(n);
    }
    setKood(n, kood) {
        if (!this.wagons[n]) this.wagons[n] = {
            n: n == 0 ? -1 : n
        };
        this.wagons[n].pc = kood;
        this.save(n);
    }
    save(n) {
        if (n == null) (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "POST",
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/wagonConf",
            data: JSON.stringify({
                data: this.wagons
            })
        });
        else (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "PUT",
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/wagonConf/" + n,
            data: JSON.stringify({
                data: this.wagons[n]
            })
        });
    }
    load(callbackFunc) {
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/wagonConf",
            success: (function(data) {
                this.wagons = [];
                if (data && data.wagonConfResult) {
                    let response = data.wagonConfResult;
                    for(let i = 0; i < response.length; i++)this.wagons[response[i].n == -1 ? 0 : response[i].n] = response[i];
                }
                if (callbackFunc) callbackFunc();
            }).bind(this),
            error: function(a, b, c) {
            // show_err(t("Error saving wagon conf"));
            }
        });
    }
    constructor(){
        this.wagons = [];
    }
}
/**
   * @private
   * @type {?WagonConf}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($e201fb47f21e9b8a$var$WagonConf, "wagonConfInstance", null);
var $e201fb47f21e9b8a$export$2e2bcd8739ae039 = $e201fb47f21e9b8a$var$WagonConf;





var $fc8bd42aaf4e9d29$exports = {};
// Generated by CoffeeScript 1.10.0
(function() {
    var AnimatedText, AnimatedTextFactory, Bar, BaseDonut, BaseGauge, Donut, Gauge, GaugePointer, TextRenderer, ValueUpdater, addCommas, cutHex, formatNumber, mergeObjects, secondsToString, slice = [].slice, hasProp = {}.hasOwnProperty, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    };
    (function() {
        var browserRequestAnimationFrame, isCancelled, j, lastId, len, vendor, vendors;
        vendors = [
            'ms',
            'moz',
            'webkit',
            'o'
        ];
        for(j = 0, len = vendors.length; j < len; j++){
            vendor = vendors[j];
            if (window.requestAnimationFrame) break;
            window.requestAnimationFrame = window[vendor + 'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
        }
        browserRequestAnimationFrame = null;
        lastId = 0;
        isCancelled = {};
        if (!requestAnimationFrame) {
            window.requestAnimationFrame = function(callback, element) {
                var currTime, id, lastTime, timeToCall;
                currTime = new Date().getTime();
                timeToCall = Math.max(0, 16 - (currTime - lastTime));
                id = window.setTimeout(function() {
                    return callback(currTime + timeToCall);
                }, timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
            return window.cancelAnimationFrame = function(id) {
                return clearTimeout(id);
            };
        } else if (!window.cancelAnimationFrame) {
            browserRequestAnimationFrame = window.requestAnimationFrame;
            window.requestAnimationFrame = function(callback, element) {
                var myId;
                myId = ++lastId;
                browserRequestAnimationFrame(function() {
                    if (!isCancelled[myId]) return callback();
                }, element);
                return myId;
            };
            return window.cancelAnimationFrame = function(id) {
                return isCancelled[id] = true;
            };
        }
    })();
    secondsToString = function(sec) {
        var hr, min;
        hr = Math.floor(sec / 3600);
        min = Math.floor((sec - hr * 3600) / 60);
        sec -= hr * 3600 + min * 60;
        sec += '';
        min += '';
        while(min.length < 2)min = '0' + min;
        while(sec.length < 2)sec = '0' + sec;
        hr = hr ? hr + ':' : '';
        return hr + min + ':' + sec;
    };
    formatNumber = function() {
        var digits, num, value;
        num = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        value = num[0];
        digits = num[1];
        return addCommas(value.toFixed(digits));
    };
    mergeObjects = function(obj1, obj2) {
        var key, out, val;
        out = {};
        for(key in obj1){
            if (!hasProp.call(obj1, key)) continue;
            val = obj1[key];
            out[key] = val;
        }
        for(key in obj2){
            if (!hasProp.call(obj2, key)) continue;
            val = obj2[key];
            out[key] = val;
        }
        return out;
    };
    addCommas = function(nStr) {
        var rgx, x, x1, x2;
        nStr += '';
        x = nStr.split('.');
        x1 = x[0];
        x2 = '';
        if (x.length > 1) x2 = '.' + x[1];
        rgx = /(\d+)(\d{3})/;
        while(rgx.test(x1))x1 = x1.replace(rgx, "$1,$2");
        return x1 + x2;
    };
    cutHex = function(nStr) {
        if (nStr.charAt(0) === "#") return nStr.substring(1, 7);
        return nStr;
    };
    ValueUpdater = function() {
        ValueUpdater.prototype.animationSpeed = 32;
        function ValueUpdater(addToAnimationQueue, clear) {
            if (addToAnimationQueue == null) addToAnimationQueue = true;
            this.clear = clear != null ? clear : true;
            if (addToAnimationQueue) AnimationUpdater.add(this);
        }
        ValueUpdater.prototype.update = function(force) {
            var diff;
            if (force == null) force = false;
            if (force || this.displayedValue !== this.value) {
                if (this.ctx && this.clear) this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                diff = this.value - this.displayedValue;
                if (Math.abs(diff / this.animationSpeed) <= 0.001) this.displayedValue = this.value;
                else this.displayedValue = this.displayedValue + diff / this.animationSpeed;
                this.render();
                return true;
            }
            return false;
        };
        return ValueUpdater;
    }();
    BaseGauge = function(superClass) {
        extend(BaseGauge, superClass);
        function BaseGauge() {
            return BaseGauge.__super__.constructor.apply(this, arguments);
        }
        BaseGauge.prototype.displayScale = 1;
        BaseGauge.prototype.forceUpdate = true;
        BaseGauge.prototype.setTextField = function(textField, fractionDigits) {
            return this.textField = textField instanceof TextRenderer ? textField : new TextRenderer(textField, fractionDigits);
        };
        BaseGauge.prototype.setMinValue = function(minValue, updateStartValue) {
            var gauge, j, len, ref, results;
            this.minValue = minValue;
            if (updateStartValue == null) updateStartValue = true;
            if (updateStartValue) {
                this.displayedValue = this.minValue;
                ref = this.gp || [];
                results = [];
                for(j = 0, len = ref.length; j < len; j++){
                    gauge = ref[j];
                    results.push(gauge.displayedValue = this.minValue);
                }
                return results;
            }
        };
        BaseGauge.prototype.setOptions = function(options) {
            if (options == null) options = null;
            this.options = mergeObjects(this.options, options);
            if (this.textField) this.textField.el.style.fontSize = options.fontSize + 'px';
            if (this.options.angle > .5) this.options.angle = .5;
            this.configDisplayScale();
            return this;
        };
        BaseGauge.prototype.configDisplayScale = function() {
            var backingStorePixelRatio, devicePixelRatio, height, prevDisplayScale, width;
            prevDisplayScale = this.displayScale;
            if (this.options.highDpiSupport === false) delete this.displayScale;
            else {
                devicePixelRatio = window.devicePixelRatio || 1;
                backingStorePixelRatio = this.ctx.webkitBackingStorePixelRatio || this.ctx.mozBackingStorePixelRatio || this.ctx.msBackingStorePixelRatio || this.ctx.oBackingStorePixelRatio || this.ctx.backingStorePixelRatio || 1;
                this.displayScale = devicePixelRatio / backingStorePixelRatio;
            }
            if (this.displayScale !== prevDisplayScale) {
                width = this.canvas.G__width || this.canvas.width;
                height = this.canvas.G__height || this.canvas.height;
                this.canvas.width = width * this.displayScale;
                this.canvas.height = height * this.displayScale;
                this.canvas.style.width = width + "px";
                this.canvas.style.height = height + "px";
                this.canvas.G__width = width;
                this.canvas.G__height = height;
            }
            return this;
        };
        BaseGauge.prototype.parseValue = function(value) {
            value = parseFloat(value) || Number(value);
            if (isFinite(value)) return value;
            else return 0;
        };
        return BaseGauge;
    }(ValueUpdater);
    TextRenderer = function() {
        function TextRenderer(el, fractionDigits1) {
            this.el = el;
            this.fractionDigits = fractionDigits1;
        }
        TextRenderer.prototype.render = function(gauge) {
            return this.el.innerHTML = formatNumber(gauge.displayedValue, this.fractionDigits);
        };
        return TextRenderer;
    }();
    AnimatedText = function(superClass) {
        extend(AnimatedText, superClass);
        AnimatedText.prototype.displayedValue = 0;
        AnimatedText.prototype.value = 0;
        AnimatedText.prototype.setVal = function(value) {
            return this.value = 1 * value;
        };
        function AnimatedText(elem1, text) {
            this.elem = elem1;
            this.text = text != null ? text : false;
            AnimatedText.__super__.constructor.call(this);
            if (this.elem === void 0) throw new Error('The element isn\'t defined.');
            this.value = 1 * this.elem.innerHTML;
            if (this.text) this.value = 0;
        }
        AnimatedText.prototype.render = function() {
            var textVal;
            if (this.text) textVal = secondsToString(this.displayedValue.toFixed(0));
            else textVal = addCommas(formatNumber(this.displayedValue));
            return this.elem.innerHTML = textVal;
        };
        return AnimatedText;
    }(ValueUpdater);
    AnimatedTextFactory = {
        create: function(objList) {
            var elem, j, len, out;
            out = [];
            for(j = 0, len = objList.length; j < len; j++){
                elem = objList[j];
                out.push(new AnimatedText(elem));
            }
            return out;
        }
    };
    GaugePointer = function(superClass) {
        extend(GaugePointer, superClass);
        GaugePointer.prototype.displayedValue = 0;
        GaugePointer.prototype.value = 0;
        GaugePointer.prototype.options = {
            strokeWidth: 0.035,
            length: 0.1,
            color: "#000000",
            iconPath: null,
            iconScale: 1.0,
            iconAngle: 0
        };
        GaugePointer.prototype.img = null;
        function GaugePointer(gauge1) {
            this.gauge = gauge1;
            if (this.gauge === void 0) throw new Error('The element isn\'t defined.');
            this.ctx = this.gauge.ctx;
            this.canvas = this.gauge.canvas;
            GaugePointer.__super__.constructor.call(this, false, false);
            this.setOptions();
        }
        GaugePointer.prototype.setOptions = function(options) {
            if (options == null) options = null;
            this.options = mergeObjects(this.options, options);
            this.length = 2 * this.gauge.radius * this.gauge.options.radiusScale * this.options.length;
            this.strokeWidth = this.canvas.height * this.options.strokeWidth;
            this.maxValue = this.gauge.maxValue;
            this.minValue = this.gauge.minValue;
            this.animationSpeed = this.gauge.animationSpeed;
            this.options.angle = this.gauge.options.angle;
            if (this.options.iconPath) {
                this.img = new Image();
                return this.img.src = this.options.iconPath;
            }
        };
        GaugePointer.prototype.render = function() {
            var angle, endX, endY, imgX, imgY, startX, startY, x, y;
            angle = this.gauge.getAngle.call(this, this.displayedValue);
            x = Math.round(this.length * Math.cos(angle));
            y = Math.round(this.length * Math.sin(angle));
            startX = Math.round(this.strokeWidth * Math.cos(angle - Math.PI / 2));
            startY = Math.round(this.strokeWidth * Math.sin(angle - Math.PI / 2));
            endX = Math.round(this.strokeWidth * Math.cos(angle + Math.PI / 2));
            endY = Math.round(this.strokeWidth * Math.sin(angle + Math.PI / 2));
            this.ctx.beginPath();
            this.ctx.fillStyle = this.options.color;
            this.ctx.arc(0, 0, this.strokeWidth, 0, Math.PI * 2, false);
            this.ctx.fill();
            this.ctx.beginPath();
            this.ctx.moveTo(startX, startY);
            this.ctx.lineTo(x, y);
            this.ctx.lineTo(endX, endY);
            this.ctx.fill();
            if (this.img) {
                imgX = Math.round(this.img.width * this.options.iconScale);
                imgY = Math.round(this.img.height * this.options.iconScale);
                this.ctx.save();
                this.ctx.translate(x, y);
                this.ctx.rotate(angle + Math.PI / 180.0 * (90 + this.options.iconAngle));
                this.ctx.drawImage(this.img, -imgX / 2, -imgY / 2, imgX, imgY);
                return this.ctx.restore();
            }
        };
        return GaugePointer;
    }(ValueUpdater);
    Bar = function() {
        function Bar(elem1) {
            this.elem = elem1;
        }
        Bar.prototype.updateValues = function(arrValues) {
            this.value = arrValues[0];
            this.maxValue = arrValues[1];
            this.avgValue = arrValues[2];
            return this.render();
        };
        Bar.prototype.render = function() {
            var avgPercent, valPercent;
            if (this.textField) this.textField.text(formatNumber(this.value));
            if (this.maxValue === 0) this.maxValue = this.avgValue * 2;
            valPercent = this.value / this.maxValue * 100;
            avgPercent = this.avgValue / this.maxValue * 100;
            $(".bar-value", this.elem).css({
                "width": valPercent + "%"
            });
            return $(".typical-value", this.elem).css({
                "width": avgPercent + "%"
            });
        };
        return Bar;
    }();
    Gauge = function(superClass) {
        extend(Gauge, superClass);
        Gauge.prototype.elem = null;
        Gauge.prototype.value = [
            20
        ];
        Gauge.prototype.maxValue = 80;
        Gauge.prototype.minValue = 0;
        Gauge.prototype.displayedAngle = 0;
        Gauge.prototype.displayedValue = 0;
        Gauge.prototype.lineWidth = 40;
        Gauge.prototype.paddingTop = 0.1;
        Gauge.prototype.paddingBottom = 0.1;
        Gauge.prototype.percentColors = null;
        Gauge.prototype.options = {
            colorStart: "#6fadcf",
            colorStop: void 0,
            gradientType: 0,
            strokeColor: "#e0e0e0",
            pointer: {
                length: 0.8,
                strokeWidth: 0.035,
                iconScale: 1.0
            },
            angle: 0.15,
            lineWidth: 0.44,
            radiusScale: 1.0,
            fontSize: 40,
            limitMax: false,
            limitMin: false
        };
        function Gauge(canvas) {
            var h, w;
            this.canvas = canvas;
            Gauge.__super__.constructor.call(this);
            this.percentColors = null;
            if (typeof G_vmlCanvasManager !== 'undefined') this.canvas = window.G_vmlCanvasManager.initElement(this.canvas);
            this.ctx = this.canvas.getContext('2d');
            h = this.canvas.clientHeight;
            w = this.canvas.clientWidth;
            this.canvas.height = h;
            this.canvas.width = w;
            this.gp = [
                new GaugePointer(this)
            ];
            this.setOptions();
        }
        Gauge.prototype.setOptions = function(options) {
            var gauge, j, len, phi, ref;
            if (options == null) options = null;
            Gauge.__super__.setOptions.call(this, options);
            this.configPercentColors();
            this.extraPadding = 0;
            if (this.options.angle < 0) {
                phi = Math.PI * (1 + this.options.angle);
                this.extraPadding = Math.sin(phi);
            }
            this.availableHeight = this.canvas.height * (1 - this.paddingTop - this.paddingBottom);
            this.lineWidth = this.availableHeight * this.options.lineWidth;
            this.radius = (this.availableHeight - this.lineWidth / 2) / (1.0 + this.extraPadding);
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            ref = this.gp;
            for(j = 0, len = ref.length; j < len; j++){
                gauge = ref[j];
                gauge.setOptions(this.options.pointer);
                gauge.render();
            }
            this.render();
            return this;
        };
        Gauge.prototype.configPercentColors = function() {
            var bval, gval, i, j, ref, results, rval;
            this.percentColors = null;
            if (this.options.percentColors !== void 0) {
                this.percentColors = new Array();
                results = [];
                for(i = j = 0, ref = this.options.percentColors.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j){
                    rval = parseInt(cutHex(this.options.percentColors[i][1]).substring(0, 2), 16);
                    gval = parseInt(cutHex(this.options.percentColors[i][1]).substring(2, 4), 16);
                    bval = parseInt(cutHex(this.options.percentColors[i][1]).substring(4, 6), 16);
                    results.push(this.percentColors[i] = {
                        pct: this.options.percentColors[i][0],
                        color: {
                            r: rval,
                            g: gval,
                            b: bval
                        }
                    });
                }
                return results;
            }
        };
        Gauge.prototype.set = function(value) {
            var gp, i, j, k, l, len, ref, ref1, val;
            if (!(value instanceof Array)) value = [
                value
            ];
            for(i = j = 0, ref = value.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j)value[i] = this.parseValue(value[i]);
            if (value.length > this.gp.length) for(i = k = 0, ref1 = value.length - this.gp.length; 0 <= ref1 ? k < ref1 : k > ref1; i = 0 <= ref1 ? ++k : --k){
                gp = new GaugePointer(this);
                gp.setOptions(this.options.pointer);
                this.gp.push(gp);
            }
            else if (value.length < this.gp.length) this.gp = this.gp.slice(this.gp.length - value.length);
            i = 0;
            for(l = 0, len = value.length; l < len; l++){
                val = value[l];
                if (val > this.maxValue) {
                    if (this.options.limitMax) val = this.maxValue;
                    else this.maxValue = val + 1;
                } else if (val < this.minValue) {
                    if (this.options.limitMin) val = this.minValue;
                    else this.minValue = val - 1;
                }
                this.gp[i].value = val;
                this.gp[i++].setOptions({
                    minValue: this.minValue,
                    maxValue: this.maxValue,
                    angle: this.options.angle
                });
            }
            this.value = Math.max(Math.min(value[value.length - 1], this.maxValue), this.minValue);
            AnimationUpdater.run(this.forceUpdate);
            return this.forceUpdate = false;
        };
        Gauge.prototype.getAngle = function(value) {
            return (1 + this.options.angle) * Math.PI + (value - this.minValue) / (this.maxValue - this.minValue) * (1 - this.options.angle * 2) * Math.PI;
        };
        Gauge.prototype.getColorForPercentage = function(pct, grad) {
            var color, endColor, i, j, rangePct, ref, startColor;
            if (pct === 0) color = this.percentColors[0].color;
            else {
                color = this.percentColors[this.percentColors.length - 1].color;
                for(i = j = 0, ref = this.percentColors.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j)if (pct <= this.percentColors[i].pct) {
                    if (grad === true) {
                        startColor = this.percentColors[i - 1] || this.percentColors[0];
                        endColor = this.percentColors[i];
                        rangePct = (pct - startColor.pct) / (endColor.pct - startColor.pct);
                        color = {
                            r: Math.floor(startColor.color.r * (1 - rangePct) + endColor.color.r * rangePct),
                            g: Math.floor(startColor.color.g * (1 - rangePct) + endColor.color.g * rangePct),
                            b: Math.floor(startColor.color.b * (1 - rangePct) + endColor.color.b * rangePct)
                        };
                    } else color = this.percentColors[i].color;
                    break;
                }
            }
            return 'rgb(' + [
                color.r,
                color.g,
                color.b
            ].join(',') + ')';
        };
        Gauge.prototype.getColorForValue = function(val, grad) {
            var pct;
            pct = (val - this.minValue) / (this.maxValue - this.minValue);
            return this.getColorForPercentage(pct, grad);
        };
        Gauge.prototype.renderStaticLabels = function(staticLabels, w, h, radius) {
            var font, fontsize, j, len, match, re, ref, rest, rotationAngle, value;
            this.ctx.save();
            this.ctx.translate(w, h);
            font = staticLabels.font || "10px Times";
            re = /\d+\.?\d?/;
            match = font.match(re)[0];
            rest = font.slice(match.length);
            fontsize = parseFloat(match) * this.displayScale;
            this.ctx.font = fontsize + rest;
            this.ctx.fillStyle = staticLabels.color || "#000000";
            this.ctx.textBaseline = "bottom";
            this.ctx.textAlign = "center";
            ref = staticLabels.labels;
            for(j = 0, len = ref.length; j < len; j++){
                value = ref[j];
                if (value.label !== void 0) {
                    if ((!this.options.limitMin || value >= this.minValue) && (!this.options.limitMax || value <= this.maxValue)) {
                        font = value.font || staticLabels.font;
                        match = font.match(re)[0];
                        rest = font.slice(match.length);
                        fontsize = parseFloat(match) * this.displayScale;
                        this.ctx.font = fontsize + rest;
                        rotationAngle = this.getAngle(value.label) - 3 * Math.PI / 2;
                        this.ctx.rotate(rotationAngle);
                        this.ctx.fillText(formatNumber(value.label, staticLabels.fractionDigits), 0, -radius - this.lineWidth / 2);
                        this.ctx.rotate(-rotationAngle);
                    }
                } else if ((!this.options.limitMin || value >= this.minValue) && (!this.options.limitMax || value <= this.maxValue)) {
                    rotationAngle = this.getAngle(value) - 3 * Math.PI / 2;
                    this.ctx.rotate(rotationAngle);
                    this.ctx.fillText(formatNumber(value, staticLabels.fractionDigits), 0, -radius - this.lineWidth / 2);
                    this.ctx.rotate(-rotationAngle);
                }
            }
            return this.ctx.restore();
        };
        Gauge.prototype.renderTicks = function(ticksOptions, w, h, radius) {
            var currentDivision, currentSubDivision, divColor, divLength, divWidth, divisionCount, j, lineWidth, range, rangeDivisions, ref, results, scaleMutate, st, subColor, subDivisions, subLength, subWidth, subdivisionCount, t, tmpRadius;
            if (ticksOptions !== {}) {
                divisionCount = ticksOptions.divisions || 0;
                subdivisionCount = ticksOptions.subDivisions || 0;
                divColor = ticksOptions.divColor || '#fff';
                subColor = ticksOptions.subColor || '#fff';
                divLength = ticksOptions.divLength || 0.7;
                subLength = ticksOptions.subLength || 0.2;
                range = parseFloat(this.maxValue) - parseFloat(this.minValue);
                rangeDivisions = parseFloat(range) / parseFloat(ticksOptions.divisions);
                subDivisions = parseFloat(rangeDivisions) / parseFloat(ticksOptions.subDivisions);
                currentDivision = parseFloat(this.minValue);
                currentSubDivision = 0.0 + subDivisions;
                lineWidth = range / 400;
                divWidth = lineWidth * (ticksOptions.divWidth || 1);
                subWidth = lineWidth * (ticksOptions.subWidth || 1);
                results = [];
                for(t = j = 0, ref = divisionCount + 1; j < ref; t = j += 1){
                    this.ctx.lineWidth = this.lineWidth * divLength;
                    scaleMutate = this.lineWidth / 2 * (1 - divLength);
                    tmpRadius = this.radius * this.options.radiusScale + scaleMutate;
                    this.ctx.strokeStyle = divColor;
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, tmpRadius, this.getAngle(currentDivision - divWidth), this.getAngle(currentDivision + divWidth), false);
                    this.ctx.stroke();
                    currentSubDivision = currentDivision + subDivisions;
                    currentDivision += rangeDivisions;
                    if (t !== ticksOptions.divisions && subdivisionCount > 0) results.push((function() {
                        var k, ref1, results1;
                        results1 = [];
                        for(st = k = 0, ref1 = subdivisionCount - 1; k < ref1; st = k += 1){
                            this.ctx.lineWidth = this.lineWidth * subLength;
                            scaleMutate = this.lineWidth / 2 * (1 - subLength);
                            tmpRadius = this.radius * this.options.radiusScale + scaleMutate;
                            this.ctx.strokeStyle = subColor;
                            this.ctx.beginPath();
                            this.ctx.arc(0, 0, tmpRadius, this.getAngle(currentSubDivision - subWidth), this.getAngle(currentSubDivision + subWidth), false);
                            this.ctx.stroke();
                            results1.push(currentSubDivision += subDivisions);
                        }
                        return results1;
                    }).call(this));
                    else results.push(void 0);
                }
                return results;
            }
        };
        Gauge.prototype.render = function() {
            var displayedAngle, fillStyle, gauge, h, j, k, len, len1, max, min, radius, ref, ref1, scaleMutate, tmpRadius, w, zone;
            w = this.canvas.width / 2;
            h = this.canvas.height * this.paddingTop + this.availableHeight - (this.radius + this.lineWidth / 2) * this.extraPadding;
            displayedAngle = this.getAngle(this.displayedValue);
            if (this.textField) this.textField.render(this);
            this.ctx.lineCap = "butt";
            radius = this.radius * this.options.radiusScale;
            if (this.options.staticLabels) this.renderStaticLabels(this.options.staticLabels, w, h, radius);
            if (this.options.staticZones) {
                this.ctx.save();
                this.ctx.translate(w, h);
                this.ctx.lineWidth = this.lineWidth;
                ref = this.options.staticZones;
                for(j = 0, len = ref.length; j < len; j++){
                    zone = ref[j];
                    min = zone.min;
                    if (this.options.limitMin && min < this.minValue) min = this.minValue;
                    max = zone.max;
                    if (this.options.limitMax && max > this.maxValue) max = this.maxValue;
                    tmpRadius = this.radius * this.options.radiusScale;
                    if (zone.height) {
                        this.ctx.lineWidth = this.lineWidth * zone.height;
                        scaleMutate = this.lineWidth / 2 * (zone.offset || 1 - zone.height);
                        tmpRadius = this.radius * this.options.radiusScale + scaleMutate;
                    }
                    this.ctx.strokeStyle = zone.strokeStyle;
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, tmpRadius, this.getAngle(min), this.getAngle(max), false);
                    this.ctx.stroke();
                }
            } else {
                if (this.options.customFillStyle !== void 0) fillStyle = this.options.customFillStyle(this);
                else if (this.percentColors !== null) fillStyle = this.getColorForValue(this.displayedValue, this.options.generateGradient);
                else if (this.options.colorStop !== void 0) {
                    if (this.options.gradientType === 0) fillStyle = this.ctx.createRadialGradient(w, h, 9, w, h, 70);
                    else fillStyle = this.ctx.createLinearGradient(0, 0, w, 0);
                    fillStyle.addColorStop(0, this.options.colorStart);
                    fillStyle.addColorStop(1, this.options.colorStop);
                } else fillStyle = this.options.colorStart;
                this.ctx.strokeStyle = fillStyle;
                this.ctx.beginPath();
                this.ctx.arc(w, h, radius, (1 + this.options.angle) * Math.PI, displayedAngle, false);
                this.ctx.lineWidth = this.lineWidth;
                this.ctx.stroke();
                this.ctx.strokeStyle = this.options.strokeColor;
                this.ctx.beginPath();
                this.ctx.arc(w, h, radius, displayedAngle, (2 - this.options.angle) * Math.PI, false);
                this.ctx.stroke();
                this.ctx.save();
                this.ctx.translate(w, h);
            }
            if (this.options.renderTicks) this.renderTicks(this.options.renderTicks, w, h, radius);
            this.ctx.restore();
            this.ctx.translate(w, h);
            ref1 = this.gp;
            for(k = 0, len1 = ref1.length; k < len1; k++){
                gauge = ref1[k];
                gauge.update(true);
            }
            return this.ctx.translate(-w, -h);
        };
        return Gauge;
    }(BaseGauge);
    BaseDonut = function(superClass) {
        extend(BaseDonut, superClass);
        BaseDonut.prototype.lineWidth = 15;
        BaseDonut.prototype.displayedValue = 0;
        BaseDonut.prototype.value = 33;
        BaseDonut.prototype.maxValue = 80;
        BaseDonut.prototype.minValue = 0;
        BaseDonut.prototype.options = {
            lineWidth: 0.10,
            colorStart: "#6f6ea0",
            colorStop: "#c0c0db",
            strokeColor: "#eeeeee",
            shadowColor: "#d5d5d5",
            angle: 0.35,
            radiusScale: 1.0
        };
        function BaseDonut(canvas) {
            this.canvas = canvas;
            BaseDonut.__super__.constructor.call(this);
            if (typeof G_vmlCanvasManager !== 'undefined') this.canvas = window.G_vmlCanvasManager.initElement(this.canvas);
            this.ctx = this.canvas.getContext('2d');
            this.setOptions();
            this.render();
        }
        BaseDonut.prototype.getAngle = function(value) {
            return (1 - this.options.angle) * Math.PI + (value - this.minValue) / (this.maxValue - this.minValue) * (2 + this.options.angle - (1 - this.options.angle)) * Math.PI;
        };
        BaseDonut.prototype.setOptions = function(options) {
            if (options == null) options = null;
            BaseDonut.__super__.setOptions.call(this, options);
            this.lineWidth = this.canvas.height * this.options.lineWidth;
            this.radius = this.options.radiusScale * (this.canvas.height / 2 - this.lineWidth / 2);
            return this;
        };
        BaseDonut.prototype.set = function(value) {
            this.value = this.parseValue(value);
            if (this.value > this.maxValue) {
                if (this.options.limitMax) this.value = this.maxValue;
                else this.maxValue = this.value;
            } else if (this.value < this.minValue) {
                if (this.options.limitMin) this.value = this.minValue;
                else this.minValue = this.value;
            }
            AnimationUpdater.run(this.forceUpdate);
            return this.forceUpdate = false;
        };
        BaseDonut.prototype.render = function() {
            var displayedAngle, grdFill, h, start, stop, w;
            displayedAngle = this.getAngle(this.displayedValue);
            w = this.canvas.width / 2;
            h = this.canvas.height / 2;
            if (this.textField) this.textField.render(this);
            grdFill = this.ctx.createRadialGradient(w, h, 39, w, h, 70);
            grdFill.addColorStop(0, this.options.colorStart);
            grdFill.addColorStop(1, this.options.colorStop);
            start = this.radius - this.lineWidth / 2;
            stop = this.radius + this.lineWidth / 2;
            this.ctx.strokeStyle = this.options.strokeColor;
            this.ctx.beginPath();
            this.ctx.arc(w, h, this.radius, (1 - this.options.angle) * Math.PI, (2 + this.options.angle) * Math.PI, false);
            this.ctx.lineWidth = this.lineWidth;
            this.ctx.lineCap = "round";
            this.ctx.stroke();
            this.ctx.strokeStyle = grdFill;
            this.ctx.beginPath();
            this.ctx.arc(w, h, this.radius, (1 - this.options.angle) * Math.PI, displayedAngle, false);
            return this.ctx.stroke();
        };
        return BaseDonut;
    }(BaseGauge);
    Donut = function(superClass) {
        extend(Donut, superClass);
        function Donut() {
            return Donut.__super__.constructor.apply(this, arguments);
        }
        Donut.prototype.strokeGradient = function(w, h, start, stop) {
            var grd;
            grd = this.ctx.createRadialGradient(w, h, start, w, h, stop);
            grd.addColorStop(0, this.options.shadowColor);
            grd.addColorStop(0.12, this.options._orgStrokeColor);
            grd.addColorStop(0.88, this.options._orgStrokeColor);
            grd.addColorStop(1, this.options.shadowColor);
            return grd;
        };
        Donut.prototype.setOptions = function(options) {
            var h, start, stop, w;
            if (options == null) options = null;
            Donut.__super__.setOptions.call(this, options);
            w = this.canvas.width / 2;
            h = this.canvas.height / 2;
            start = this.radius - this.lineWidth / 2;
            stop = this.radius + this.lineWidth / 2;
            this.options._orgStrokeColor = this.options.strokeColor;
            this.options.strokeColor = this.strokeGradient(w, h, start, stop);
            return this;
        };
        return Donut;
    }(BaseDonut);
    window.AnimationUpdater = {
        elements: [],
        animId: null,
        addAll: function(list) {
            var elem, j, len, results;
            results = [];
            for(j = 0, len = list.length; j < len; j++){
                elem = list[j];
                results.push(AnimationUpdater.elements.push(elem));
            }
            return results;
        },
        add: function(object) {
            return AnimationUpdater.elements.push(object);
        },
        run: function(force) {
            var elem, finished, isCallback, j, len, ref;
            if (force == null) force = false;
            isCallback = isFinite(parseFloat(force));
            if (isCallback || force === true) {
                finished = true;
                ref = AnimationUpdater.elements;
                for(j = 0, len = ref.length; j < len; j++){
                    elem = ref[j];
                    if (elem.update(force === true)) finished = false;
                }
                return AnimationUpdater.animId = finished ? null : requestAnimationFrame(AnimationUpdater.run);
            } else if (force === false) {
                if (AnimationUpdater.animId === true) cancelAnimationFrame(AnimationUpdater.animId);
                return AnimationUpdater.animId = requestAnimationFrame(AnimationUpdater.run);
            }
        }
    };
    if (typeof window.define === 'function' && window.define.amd != null) define(function() {
        return {
            Gauge: Gauge,
            Donut: Donut,
            BaseDonut: BaseDonut,
            TextRenderer: TextRenderer
        };
    });
    else if ($fc8bd42aaf4e9d29$exports != null) $fc8bd42aaf4e9d29$exports = {
        Gauge: Gauge,
        Donut: Donut,
        BaseDonut: BaseDonut,
        TextRenderer: TextRenderer
    };
    else {
        window.Gauge = Gauge;
        window.Donut = Donut;
        window.BaseDonut = BaseDonut;
        window.TextRenderer = TextRenderer;
    }
}).call($fc8bd42aaf4e9d29$exports);



/**
 * Usage:
 *  let g = new AngleChart(parentId, class, nominalInfo);
 *  g.setValue(v);
 */ class $b7034771a0a6a1dc$var$AngleChart {
    getAbsOffset() {
        let maxOffset = Math.max(this.nominalInfo[3], this.nominalInfo[4]);
        // Suurendame max offseti täiendavalt 50%:
        return Math.round(maxOffset * 150 / 100);
    }
    /**
   *
   * @param {number} value Gauge hetkeväärtuse seadmine
   */ setValue(value) {
        let v = value / 10;
        this.gauge.set(v);
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(`#angleChart-${this.chartId}-value`).text(v);
    }
    /**
   *
   * @param {string} parentId Vanemelemendi Id, mille alla lisada
   * @param {string} className CSS klassi nimi, mis tuleb elemendile omistada
   * @param {NominalInfo} nominalInfo Nominaali info: [v, t1p, t1m, t2p, t2m], kus v - nominaalväärtus, t1p - ülemine 1. tolerants, t1m - alumine 1. tolerants, t2p - ülemine 2. tolerants, t2m - alumine 2. tolerants
   */ constructor(parentId, className, nominalInfo){
        $b7034771a0a6a1dc$var$AngleChart.angleChartLast++;
        this.chartId = $b7034771a0a6a1dc$var$AngleChart.angleChartLast;
        /**
     * @type {NominalInfo}
     */ this.nominalInfo = nominalInfo;
        this.className = className;
        let placeholder = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#" + parentId);
        placeholder.append(`<div class="${className}"><canvas id="angleChart-${this.chartId}" class="${className}-chart"></canvas><div class="${className}-value"><div id="angleChart-${this.chartId}-value"></div></div></div>`);
        let el = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(`#angleChart-${this.chartId}`).get(0);
        let absOffset = this.getAbsOffset();
        let v = nominalInfo[0];
        this.gaugeOpts = {
            angle: 0,
            lineWidth: 0.2,
            radiusScale: 0.75,
            highDpiSupport: true,
            limitMin: true,
            limitMax: true,
            pointer: {
                length: 0.6,
                strokeWidth: 0.03
            },
            staticLabels: {
                font: "12px sans-serif",
                labels: [
                    (v - nominalInfo[4]) / 10,
                    (v - nominalInfo[2]) / 10,
                    v / 10,
                    (v + nominalInfo[1]) / 10,
                    (v + nominalInfo[3]) / 10
                ],
                color: "#000000",
                fractionDigits: 1
            },
            staticZones: [
                {
                    strokeStyle: "rgb(255,0,0)",
                    min: (v - absOffset) / 10,
                    max: (v - nominalInfo[4]) / 10
                },
                {
                    strokeStyle: "rgb(255,128,0)",
                    min: (v - nominalInfo[4]) / 10,
                    max: (v - nominalInfo[2]) / 10
                },
                {
                    strokeStyle: "rgb(0,255,0)",
                    min: (v - nominalInfo[2]) / 10,
                    max: (v + nominalInfo[1]) / 10
                },
                {
                    strokeStyle: "rgb(255,128,0)",
                    min: (v + nominalInfo[1]) / 10,
                    max: (v + nominalInfo[3]) / 10
                },
                {
                    strokeStyle: "rgb(255,0,0)",
                    min: (v + nominalInfo[3]) / 10,
                    max: (v + absOffset) / 10
                }
            ]
        };
        this.gauge = new (0, $fc8bd42aaf4e9d29$exports.Gauge)(el).setOptions(this.gaugeOpts);
        this.gauge.animationSpeed = 1;
        this.gauge.maxValue = (v + absOffset) / 10;
        this.gauge.setMinValue((v - absOffset) / 10);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($b7034771a0a6a1dc$var$AngleChart, "angleChartLast", 0);
var $b7034771a0a6a1dc$export$2e2bcd8739ae039 = $b7034771a0a6a1dc$var$AngleChart;














/**
 * Vana KLPMS UI koodi kapseldus uue jaoks
 */ class $b5ea4b23f7aaa130$var$Legacy {
    static setGlobal(name, value) {
        window[name] = value;
    }
    static getGlobal(name) {
        return window[name];
    }
    static getDrow(wagonNr) {
        return window.getDrow(wagonNr);
    }
    static debug(message) {
        return window.debug(message);
    }
}
var $b5ea4b23f7aaa130$export$2e2bcd8739ae039 = $b5ea4b23f7aaa130$var$Legacy;


/**
 * Nominaalgraafiku haldamise objekt
 */ class $82412e69ca9e99a5$var$NominalGraph {
    /**
   * Tootekood, mille nominaalgraafikut antud objekt kajastab. Kui nominaalgraafikut pole laetud, on selle väätus null.
   * Kui nominaalgraafiku laadimine on hetkel pooleli, siis väätuseks on laetava toote kood ning "points" element on null.
   */ /**
   * Nominaalgraafiku punktide massiiv kujul:
   * points[i] - mõõtejoon (i+1) väärtuste massiiv, kus i = 0..2
   * Kui nominaalgraafikut pole laetud, on selle elemendi väärtus null
   */ /**
   * @returns {NominalGraph}
   */ static getInstance() {
        if ($82412e69ca9e99a5$var$NominalGraph.nominalGraphInstance == null) $82412e69ca9e99a5$var$NominalGraph.nominalGraphInstance = new $82412e69ca9e99a5$var$NominalGraph();
        return $82412e69ca9e99a5$var$NominalGraph.nominalGraphInstance;
    }
    /**
   * Nominaalgraafiku sisselaadmine
   * @param {string} product - toote kood, mis sisse laadida
   */ load(product) {
        if (this.productNo == product) return;
        this.points = null;
        this.productNo = product;
        let baseProduct = (0, $30071e4d8f83fdfd$export$b396c2481bedae58)(product);
        // Loeme sisse nominaalgraafiku:
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/nominalGraphs/" + baseProduct,
            success: (function(data) {
                this.loadFinished(data);
            }).bind(this),
            error: (function(a, b, c) {
                this.productNo = null;
                this.points = null;
                (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_err((0, $865532d99f221026$export$2e2bcd8739ae039)("Nominal graph was not found"));
            }).bind(this)
        });
    }
    /**
   * Meetod kutsutakse välja automaatselt peale nominaalgraafiku edukat sisselaadimist.
   * Väärtustab nominaalgraafiku punktide massiivi ning kutsub välja graafiku refresh'i, et see vajadusel graafikul kuvataks.
   */ loadFinished(data) {
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("nnnn.loadFinished");
        if (!data || !data.nominalGraphsResult) {
            this.productNo = null;
            this.points = null;
            return;
        }
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug(data.nominalGraphsResult.toote_variant);
        this.points = [];
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let mootejoon = data.nominalGraphsResult.mootejoon;
        if (mootejoon) for(let i = 0; i < settings.getMeasurementLineCount(); i++){
            if (!mootejoon[i]) break;
            this.points[i] = mootejoon[i][0];
        }
        this.productNo = data.nominalGraphsResult.toote_variant;
        if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#graph0').length > 0) {
            let graph = (0, $b2a0945f49afb6e5$export$2e2bcd8739ae039).getInstance();
            graph.refreshGraphs();
        }
    }
    /**
   * Salvestab etteantud jooned näidatud toote nominaalgraafikuks
   */ save(product, lines) {
        (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).ask_passwd((function(passwd) {
            if (!passwd) return;
            //let baseProduct: string = getProductCode(product);
            let s = {
                'password': passwd,
                'toote_variant': product,
                "mootejoon": []
            };
            for(let i = 0; i < lines.length; i++)s.mootejoon[i] = [
                lines[i][0]
            ];
            (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
                type: "POST",
                url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/nominalGraphs",
                data: JSON.stringify({
                    data: s
                }),
                success: (function() {
                    if (product == this.productNo) {
                        this.points = [];
                        for(let i = 0; i < lines.length; i++)this.points[i] = lines[i][0];
                        if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#graph0').length > 0) {
                            let graph = (0, $b2a0945f49afb6e5$export$2e2bcd8739ae039).getInstance();
                            graph.refreshGraphs();
                        }
                    }
                    (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_success((0, $865532d99f221026$export$2e2bcd8739ae039)('Nominal graph saved'));
                }).bind(this),
                error: function() {
                    (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_err((0, $865532d99f221026$export$2e2bcd8739ae039)("Error saving nominal graph"));
                },
                statusCode: {
                    403: function() {
                        (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_err("Invalid password");
                    }
                }
            });
        }).bind(this));
    }
    constructor(){
        /**
     * Tootekood, mille nominaalgraafikut antud objekt kajastab. Kui nominaalgraafikut pole laetud, on selle väätus null.
     * Kui nominaalgraafiku laadimine on hetkel pooleli, siis väätuseks on laetava toote kood ning "points" element on null.
     */ this.productNo = null;
        /**
     * Nominaalgraafiku punktide massiiv kujul:
     * points[i] - mõõtejoon (i+1) väärtuste massiiv, kus i = 0..2
     * Kui nominaalgraafikut pole laetud, on selle elemendi väärtus null
     */ this.points = null;
    }
}
/**
   * @type {?NominalGraph}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($82412e69ca9e99a5$var$NominalGraph, "nominalGraphInstance", null);
var $82412e69ca9e99a5$export$2e2bcd8739ae039 = $82412e69ca9e99a5$var$NominalGraph;






/**
 * Graafikute lehe joonistamise klass
 *
 */ class $b2a0945f49afb6e5$var$Graph {
    /**
   *
   * @returns {Graph}
   */ static getInstance() {
        if ($b2a0945f49afb6e5$var$Graph.graphInstance == null) $b2a0945f49afb6e5$var$Graph.graphInstance = new $b2a0945f49afb6e5$var$Graph();
        return $b2a0945f49afb6e5$var$Graph.graphInstance;
    }
    /**
   * Graafiku lehe tekitamine
   *
   * @param {number} [n]
   */ make_graph_page(n) {
        (0, $03277cb1bca63048$export$c31045a889981f00)();
        (0, $03277cb1bca63048$export$b0c1cba25cb0c370)();
        if (n == null || n < 0) {
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon < 0) (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon = (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon;
            n = (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon;
        } else (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon = n;
        this.show_analyze(n);
        //$("#content").html(s);
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('.selectpicker').selectpicker();
        (0, $30071e4d8f83fdfd$export$3c47130985814430)("graph");
    }
    /**
   * Avatakse graafiku leht näidatud vaguni graafikuga
   * @param {number} n
   */ goto_graph_page(n) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.nominalButtonOn = settings.getNominalGraph();
        this.make_graph_page(n);
    }
    /**
   * Funktsioon tagastab graafiku kõrguse, arvestades ekraani suurust ning kuvatavate graafikute arvu.
   */ getGraphHeight(n) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        if (this.zoomedGraph == n) return this.big_graph_height;
        let graphCount = settings.getMeasurementLineCount();
        return Math.round((window.innerHeight - 100) / graphCount) - this.graph_padding;
    }
    show_analyze(n) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.zoomedGraph = -1;
        let s = "";
        let drow = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow();
        if (drow) {
            if (!(0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon = n;
            //if (graph_mode) {
            s += "<span class='' id='wagonInfo' style='margin-bottom: 10px;'>";
            s += (0, $03277cb1bca63048$export$2e2bcd8739ae039).getWagonInfo(drow);
            s += "</span>";
            //}
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#topy").css("height", "50px");
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").css("margin-top", "10px");
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").css("margin-left", "40px");
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").html(s);
            s = this.make_analyze_buttons();
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop1").html(s);
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(".mbtn").button("toggle");
            if (this.nominalButtonOn) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#mnb").addClass("active");
            s = this.make_graphs(n);
            if (!(0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#content").html(s);
            else {
                (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#a_measurement_content").html(s);
                let rowNo = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement ? (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"] : 0;
                if (rowNo > 0) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#btnnavprev').css('visibility', 'visible');
                else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#btnnavprev').css('visibility', 'hidden');
                if (rowNo < (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results.length - 1) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#btnnavnext').css('visibility', 'visible');
                else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#btnnavnext').css('visibility', 'hidden');
            }
            for(let i = 0; i < settings.getMeasurementLineCount(); i++){
                // Set up clicking into graph:
                // s += "<div id='" + "graph" + nr + "' class='' style='" + gs + "' onclick=\"graph.show_single_graph('" + nr + "');\"></div>";
                let that = this;
                (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#graph' + i).mousemove(i, function(e) {
                    if (e.which == 1) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(this).data('move', true);
                }).mouseup(i, function(e) {
                    if (e.which == 1) {
                        if (!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(this).data('move')) that.show_single_graph(e.data);
                        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(this).data('move', false);
                    }
                });
                this.draw_graph(drow, i);
            }
        }
    }
    make_analyze_buttons() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let s = "";
        s += "<button class='btn btn-default graphbtn' onclick='graph.graph_refresh();'><span class='glyphicon glyphicon-refresh'></span></button>";
        s += "<span style='margin-right: 10px;'>&nbsp;</span>";
        if (!(0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_mode) {
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_zoom_in();'><span class='glyphicon glyphicon-plus'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_zoom_out();'><span class='glyphicon glyphicon-minus'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_left();'><span class='glyphicon glyphicon-chevron-left'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_right();'><span class='glyphicon glyphicon-chevron-right'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_up();'><span class='glyphicon glyphicon-chevron-up'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_down();'><span class='glyphicon glyphicon-chevron-down'></span></button>";
            s += "<span style='margin-right: 10px;'>&nbsp;</span>";
        }
        //if (archive_mode) {
        //    s += "<button class='btn btn-default graphbtn mbtn' id='m2b'  onclick='graph.graph_toggle(2)'><span class='btntxt'>m2</span></button>";
        //    s += "<button class='btn btn-default graphbtn mbtn' id='m3b'  onclick='graph.graph_toggle(3)'><span class='btntxt'>m3</span></button>";
        //} else {
        //s += make_m_button(1);
        if (!settings.isSimpleUi() || (0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) {
            s += "<button class='btn btn-default graphbtn mbtn toggle' class-toggle='btn-inverse' id='m1b'  onclick='graph.graph_toggle(1)'><span class='btntxt'>m1</span></button>";
            s += this.make_m_button(2);
            s += this.make_m_button(3);
        } else s += "<button class='btn btn-default graphbtn mbtn toggle hidden' class-toggle='btn-inverse' id='m1b'  onclick='graph.graph_toggle(1)'><span class='btntxt'>m1</span></button>";
        //}
        if (!(0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_mode) {
            s += "<button class='btn btn-default graphbtn rbtn' id='rawb'  onclick='graph.raw_toggle()'><span class='btntxt'>T</span></button>";
            s += '<button class="btn btn-default graphbtn" id="mnb"  onclick="graph.graph_toggle(\'n\')"><span class="btntxt">N</span></button>';
            s += "<span style='margin-right: 10px;'>&nbsp;</span>";
            s += '<button class="btn btn-default graphbtn" onclick="graph.graph_save_nominal()"><span class="btntxt">' + (0, $865532d99f221026$export$2e2bcd8739ae039)("Save as nominal graph") + '</span></button>';
        } else s += '<button class="btn btn-default graphbtn hide" id="mnb"><span class="btntxt">N</span></button>';
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) {
            // Kuvame navigeerimisnupud:
            let activeRow = -1;
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement && (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"] !== undefined) activeRow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"];
            s += "<span style='margin-right: 50px;'>&nbsp;</span>";
            s += "<button class='btn btn-primary graphbtn' onclick='graph.graph_select_item(-1);' id='btnnavprev'><span class='glyphicon glyphicon-chevron-left'></span>" + (0, $865532d99f221026$export$2e2bcd8739ae039)('Previous') + "</button>";
            s += "<button class='btn btn-primary graphbtn' onclick='graph.graph_select_item(+1);' id='btnnavnext'><span class='glyphicon glyphicon-chevron-right'></span>" + (0, $865532d99f221026$export$2e2bcd8739ae039)('Next') + "</button>";
            s += "<span style='margin-right: 10px;'>&nbsp;</span>";
            if (activeRow >= 0) s += "<span>" + (activeRow + 1) + " / " + (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results.length + "</span>\n";
        }
        return s;
    }
    make_m_button(n) {
        let s = '<div class="btn-group">';
        s += '<button type="button" class="btn btn-default mbtn" id="m' + n + 'b" onclick="graph.graph_toggle(' + n + ')"><span class="btntxt" id="m' + n + 't">m' + n + '</span></button>';
        s += '<button type="button" class="btn btn-default mbtn graphbtn dropdown-toggle" id="m' + n + 'bd" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">';
        s += '<span class="caret"></span>';
        // s += '<span class="sr-only">Toggle Dropdown</span>';
        s += '</button>';
        s += '<ul class="dropdown-menu">';
        s += '<li><a href="#" onclick="graph.graph_change_wagon(' + n + ', 0)">m' + n + '</a></li>';
        //s += '<li role="separator" class="divider"></li>';
        let data;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) data = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_converted_results;
        else data = (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data;
        for(let i = 0; i < data.length; i++)if (data[i]) s += '<li><a href="#" onclick="graph.graph_change_wagon(' + n + ',' + ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode ? i + 1 : i) + ')">' + ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode ? "R" + (i + 1) : "W" + i) + ": " + (0, $03277cb1bca63048$export$2e2bcd8739ae039).getWagonTitle(data[i]) + '</a></li>';
        s += '</ul></div>';
        return s;
    }
    make_graphs(n) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let s = "";
        for(let i = settings.getMeasurementLineCount() - 1; i >= 0; i--)s += this.make_graph(n, i);
        return s;
    }
    make_graph(n, nr) {
        let gs = "width: " + this.graph_width + "px; height: " + this.getGraphHeight(nr) + "px;";
        // gs += " min-height: " + "200" + "px;";
        gs += " min-height: 150px;";
        let s = '<div class="graph">';
        // s += "<div id='" + "graph" + nr + "' class='' style='" + gs + "' onclick=\"graph.show_single_graph('" + nr + "');\"></div>";
        s += "<div id='graph" + nr + "' class='' style='" + gs + "'></div>";
        s += "</div>";
        return s;
    }
    /**
   * Funkstioon värskendab kõikide graafikute sisud
   */ refreshGraphs() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#wagonInfo').html((0, $03277cb1bca63048$export$2e2bcd8739ae039).getWagonInfo((0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow()));
        for(let n = 0; n < settings.getMeasurementLineCount(); n++)this.drawGraph(n);
    }
    /**
   * Funktsioon joonistab etteantud numbriga graafiku, kasutades sellele graafikule valitud vaguni numbrit ning serva numbrit.
   */ drawGraph(nr) {
        //var wagonNr = $('#graphWagonSelect' + nr).val();
        //var edgeNr = $('#graphEdgeSelect' + nr).val();
        let drow = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow();
        // Kui edgeNr === undefined, siis kasutab draw_graph selleks nr välja.
        this.draw_graph(drow, nr);
    }
    /**
   * Funktsioon lülitab kuvatavat graafikut suureks/väikeseks
   */ show_single_graph(x) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        /*
    let drow;
    if (!global.archive_mode) {
        if (x >= global.grid_data.length) return;
        if (global.current_shown_wagon < 0) return;
        drow = global.grid_data[global.current_shown_wagon];
    } else {
        drow = global.a_measurement;
    }
    */ if (this.zoomedGraph === x) this.zoomedGraph = -1;
        else this.zoomedGraph = x;
        for(let n = 0; n < settings.getMeasurementLineCount(); n++)if (n == this.zoomedGraph || this.zoomedGraph === -1) {
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph" + n).css("height", this.getGraphHeight(n));
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph" + n).show();
            this.drawGraph(n);
        } else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph" + n).hide();
    }
    /*
  drawArrow: function (ctx, x, y, radius) {
      ctx.beginPath();
      ctx.moveTo(x + radius, y + radius);
      ctx.lineTo(x, y);
      ctx.lineTo(x - radius, y + radius);
      ctx.stroke();
  },*/ /*drawSemiCircle: function (ctx, x, y, radius) {
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI, false);
      ctx.moveTo(x - radius, y);
      ctx.lineTo(x + radius, y);
      ctx.stroke();
      //console.log(l2+":"+u2);
  },*/ draw_limit_u(ctx, x, y, radius) {
        //var d2=radius*3;
        ctx.beginPath();
        ctx.moveTo(x - radius, y);
        ctx.lineTo(x + radius, y);
        ctx.stroke();
    }
    draw_limit_d(ctx, x, y, radius) {
        //var d2=radius*3;
        ctx.beginPath();
        ctx.moveTo(x - radius, y);
        ctx.lineTo(x + radius, y);
        ctx.stroke();
    }
    tick_formatter(val, axis) {
        return val / 10 + ""; //val.toFixed(axis.tickDecimals);
    }
    /**
   * Graafiku joonestamine. Joonestab etteantud andmestiku baasilt graafiku.
   * @param {ConvertedMeasurementType} drow Graafiku andmestik
   * @param {number} graphNr Graafiku asukoha jrknr (0 - alumine, 1 - keskmine, 2 - ülemine)
   * @param {number} [line] joonistamiseks kasutatava mõõtmise number (0..2), vaikimisi võetakse sama, mis graphNr
   */ draw_graph(drow, graphNr, line) {
        let nominalGraph = (0, $82412e69ca9e99a5$export$2e2bcd8739ae039).getInstance();
        let linepoints, lineinfo, required, nominals, line_end, pointcount, rawstatus, rawnominals;
        let warn, np, wp, rn, serie, seriepoints, serieoptions;
        let minx, miny, maxx, maxy, colors, bid;
        let measurement_step, placeholder, l1, l2, slen;
        let nominalpoints;
        let adasPoint = null;
        let adasPointX = null;
        let LINE_START_X = 0;
        //if (graph_wagons[graphNr]) drow = Legacy.getDrow(graph_wagons[graphNr]);
        let drow2 = null;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_wagons[2]) drow2 = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow((0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_wagons[2]);
        let drow3 = null;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_wagons[3]) drow3 = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow((0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_wagons[3]);
        if (!drow) return;
        if (line === undefined) line = graphNr;
        lineinfo = drow.lineinfo;
        linepoints = drow["linepoints"];
        required = drow["corr_required"];
        //required=drow["required"];
        /*
    Legacy.debug("linepoints");
    Legacy.debug(linepoints);
    Legacy.debug("required");
    Legacy.debug(required);
    Legacy.debug("corr_shifts");
    Legacy.debug(drow["corr_shifts"]);
    */ if (!linepoints || !required || !drow["corr_shifts"] || !drow["series"][line]) return;
        nominals = [];
        rawnominals = [];
        warn = [];
        // fetch required values for the nominals and combine with distances
        for(let x = 0; x < linepoints.length && x < required.length && x < lineinfo.length; x++){
            if (lineinfo[x][0] != line) continue;
            line_end = drow["lineends"][line];
            np = [
                line_end - linepoints[x],
                required[x][0],
                required[x][1],
                required[x][2]
            ];
            nominals.push(np);
            wp = [
                line_end - linepoints[x],
                required[x][0],
                required[x][3],
                required[x][4]
            ];
            warn.push(wp);
            rn = [
                line_end - linepoints[x],
                drow["required"][x][0]
            ];
            //Legacy.debug(x); 0 1 2 ... 8
            //if (x != 1 && x != 4 && x != 7) rawnominals.push(rn);
            if (!(0, $d02c132c9fe52fc9$export$2e2bcd8739ae039).isCenterPoint(lineinfo[x][1])) rawnominals.push(rn);
            if (lineinfo[x][2]) {
                // See on ADAS akna punkt, selle koha peale tuleb joonistada püstine sinine joon
                adasPointX = line_end - linepoints[x];
                adasPoint = x;
            }
        }
        //Legacy.debug(nominals);
        let nominals_options = {
            show: true,
            radius: 3,
            errorbars: "y",
            yerr: {
                show: true,
                radius: 4,
                asymmetric: true,
                upperCap: this.draw_limit_u,
                lowerCap: this.draw_limit_d
            }
        };
        let warn_options = {
            show: true,
            radius: 3,
            errorbars: "y",
            yerr: {
                show: true,
                radius: 4,
                asymmetric: true,
                upperCap: this.draw_limit_u,
                lowerCap: this.draw_limit_d
            }
        };
        // fetch measurement series values
        seriepoints = [];
        serieoptions = [];
        serie = [];
        if (drow["corr_series"] && drow["corr_series"].length > line) {
            if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#rawb").hasClass('active') && drow["rawdata"]) {
                if (!drow["rawdata"][line]) return;
                rawstatus = true;
                serie = [
                    drow["rawdata"][line]
                ];
                //Legacy.debug("serie of len "+serie.length);
                //Legacy.debug(serie);
                slen = 1;
            } else {
                rawstatus = false;
                //serie = drow["corr_series"][line].slice(0);    // select serie for the given line
                serie = [];
                if (drow["corr_series"][line] && drow["corr_series"][line][0]) serie.push(drow["corr_series"][line][0]);
                if (drow2) {
                    if (drow2["corr_series"] && drow2["corr_series"][line] && drow2["corr_series"][line][0]) serie.push(drow2["corr_series"][line][0]);
                } else if (drow["corr_series"][line] && drow["corr_series"][line][1]) serie.push(drow["corr_series"][line][1]);
                if (drow3) {
                    if (drow3["corr_series"] && drow3["corr_series"][line] && drow3["corr_series"][line][0]) serie.push(drow3["corr_series"][line][0]);
                } else if (drow["corr_series"][line] && drow["corr_series"][line][2]) serie.push(drow["corr_series"][line][2]);
                slen = serie.length;
            }
            // loop over three (max) tries in each serie
            for(let v = 0; v < slen; v++){
                if (rawstatus) pointcount = drow["rawdata"][line].length;
                else pointcount = serie[v].length;
                measurement_step = (drow["lineends"][line] - LINE_START_X) / pointcount;
                let x = 0;
                np = [];
                for(let i = 0; i < serie[v].length; i++){
                    np.push([
                        x,
                        serie[v][i]
                    ]);
                    x += measurement_step;
                }
                seriepoints.push(np);
                let opts = {
                    show: true,
                    lines: {
                        show: true
                    },
                    points: {
                        show: true
                    },
                    radius: 2
                };
                serieoptions.push(opts);
            }
        }
        // Leiame nominaalgraafiku:
        if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#mnb").hasClass("active")) {
            if (drow['codeVariant'] == nominalGraph.productNo && nominalGraph.points != null && nominalGraph.points.length > line) {
                // Nominaalgraafik on juba sisse laetud:
                nominalpoints = [];
                let x = 0;
                for(let i = 0; i < nominalGraph.points[line].length; i++){
                    nominalpoints.push([
                        x,
                        nominalGraph.points[line][i]
                    ]);
                    x += measurement_step;
                }
            } else {
                // Laeme nominaalgraafiku sisse:
                nominalGraph.load(drow.codeVariant);
                nominalpoints = null;
            }
        }
        // get max and min vals for the area
        minx = 0;
        miny = -90;
        maxx = -100000;
        maxy = -100000;
        for(let i = 0; i < warn.length && i < 3; i++){
            if (warn[i][0] > maxx) maxx = warn[i][0];
            if (warn[i][1] > maxy) maxy = warn[i][1];
            if (warn[i][1] < miny) miny = warn[i][1];
        }
        for(let v = 0; v < seriepoints.length; v++)for(let i = 0; i < seriepoints[v].length; i++){
            if (seriepoints[v][i][0] > maxx) maxx = seriepoints[v][i][0];
            if (seriepoints[v][i][1] > maxy) maxy = seriepoints[v][i][1];
            if (seriepoints[v][i][1] < miny) miny = seriepoints[v][i][1];
        }
        if (nominalpoints) for(let i = 0; i < nominalpoints.length; i++){
            if (nominalpoints[i][0] > maxx) maxx = nominalpoints[i][0];
            if (nominalpoints[i][1] > maxy) maxy = nominalpoints[i][1];
            if (nominalpoints[i][1] < miny) miny = nominalpoints[i][1];
        }
        maxy = Math.floor(maxy + (maxy - miny) * 0.1);
        // miny = Math.floor(miny - ((maxy - miny) * 0.1));
        if (miny > -100) miny -= 10;
        else miny = Math.floor(miny - (maxy - miny) * 0.1);
        // maxx=Math.floor(maxx+((maxx-minx)*0.1));
        let data = [];
        if (!rawstatus) {
            data.push({
                color: "#ff8000",
                points: warn_options,
                data: warn
            }); // label: "nb!"
            data.push({
                color: "green",
                points: nominals_options,
                data: nominals
            }); // label: "ok"
        }
        // Nominaalgraafiku kuvamine:
        if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#mnb").hasClass("active") && !rawstatus && nominalpoints) // Kuvame nominaalgraafiku
        data.push({
            color: "#FFFF00",
            points: {
                show: true,
                lines: {
                    show: true
                },
                points: {
                    show: true
                },
                radius: 2
            },
            data: nominalpoints,
            lines: {
                show: true,
                lineWidth: 2
            },
            label: "N",
            shadowSize: 3
        });
        // loop backwards from the last series
        colors = [
            "#0000ff",
            "#6666ff",
            "#aaaaff"
        ];
        for(let c = 0, n = seriepoints.length - 1; n >= 0 && c < 3; n--, c++){
            bid = "#m" + (n + 1) + "b";
            //Legacy.debug(bid);
            //Legacy.debug($(bid).hasClass("active"));
            if (!seriepoints || seriepoints[n].length < 10) continue;
            if (!rawstatus && !(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(bid).hasClass("active")) continue; // do not show if button not active
            let serieLabel = "m" + (n + 1);
            if (seriepoints.length == 1) serieLabel = '';
            if (n == 1 && drow2) serieLabel = ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode ? "R" : "W") + (0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_wagons[2] + ": " + (0, $03277cb1bca63048$export$2e2bcd8739ae039).getWagonTitle(drow2);
            if (n == 2 && drow3) serieLabel = ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode ? "R" : "W") + (0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_wagons[3] + ": " + (0, $03277cb1bca63048$export$2e2bcd8739ae039).getWagonTitle(drow3);
            data.push({
                color: colors[c],
                points: serieoptions[n],
                data: seriepoints[n],
                lines: {
                    show: true,
                    lineWidth: 2
                },
                label: serieLabel,
                shadowSize: 3
            });
        }
        // show non-normalized tolerances
        if (!rawstatus) data.push({
            color: "#ff0000",
            data: rawnominals,
            //  [[0,0],[10,0.2],[50,1],[100,4],[150,4.5],[200,10],[300,20]],
            lines: {
                show: false,
                lineWidth: 1
            },
            points: {
                show: true,
                radius: 2
            },
            label: null,
            shadowSize: 3
        });
        let adasPointMarkings = null;
        if (adasPoint != null) adasPointMarkings = [
            {
                color: "#6666ff",
                lineWidth: 3,
                xaxis: {
                    from: adasPointX,
                    to: adasPointX
                }
            }
        ];
        // plot stuff
        let plotOptions = {
            grid: {
                // backgroundColor: "white"
                // clickable: true,
                hoverable: true,
                autoHighlight: true
            },
            xaxis: {
                min: minx,
                max: maxx,
                position: "bottom",
                tickFormatter: this.tick_formatter
            },
            yaxis: {
                min: miny,
                max: maxy,
                /* tickLength: 0, */ tickSize: 100,
                tickFormatter: this.tick_formatter,
                transform: function(v) {
                    return -v;
                },
                inverseTransform: function(v) {
                    return -v;
                }
            },
            zoom: {
                // Set true to enable zoom with mouse
                interactive: true
            },
            pan: {
                // Set true to enable pan with mouse
                interactive: true
            },
            legend: {
                show: true,
                /*
        labelFormatter: null or (fn: string, series object -> string)
        labelBoxBorderColor: color
        noColumns: number
        position: "ne" or "nw" or "se" or "sw"
        margin: number of pixels or [x margin, y margin]
        backgroundColor: null or color
        backgroundOpacity: number between 0 and 1
        container: null or jQuery object/DOM element/jQuery expression
        */ position: "nw",
                backgroundOpacity: 0.1
            }
        };
        if (!rawstatus) plotOptions.grid.markings = adasPointMarkings;
        let current_plot = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039).plot("#graph" + graphNr, data, plotOptions);
        this.current_plots[graphNr] = current_plot;
        placeholder = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph" + graphNr);
        //placeholder.append("<div style='position:absolute;left:" + (o.left + 4) + "px;top:" + o.top + "px;color:#666;font-size:smaller'>Warming up</div>");
        l1 = "E" + (line * 2 + 1);
        l2 = "E" + (line * 2 + 2);
        //if (line == 0) { l1 = "E1"; l2 = "E2" }
        //else if (line == 1) { l1 = "E3"; l2 = "E4" }
        //else if (line == 2) { l1 = "E5"; l2 = "E6" };
        placeholder.append("<div style='position:absolute;left:0px;top:30px;color:#f00;'>" + l1 + "</div><div style='position:absolute;left:" + 1198 + "px;top:" + 30 + "px;color:#f00;'>" + l2 + "</div>");
        // Lisame NURK gauge:
        if (!rawstatus && graphNr == 1 && drow.angles && drow.angles.length > 0 && drow.angles[0].length > 0 && drow.angles[0][0] != null && drow.analyzed_angles && drow.analyzed_angles.length > 0) {
            let angleChart = new (0, $b7034771a0a6a1dc$export$2e2bcd8739ae039)("graph" + graphNr, "angleChart", drow.angles[0]);
            angleChart.setValue(drow.analyzed_angles[0][2]);
        }
        // graph.html lehel kuvatakse keskel kast:
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_mode && drow["analyzed"]) {
            // Teeme graafiku keskele üles serva kasti, mis näitab värviga keskmise punkti täpsust
            // Leiame keskmise punkti väärtuse:
            placeholder.append(this.getGraphBox(drow, "middle", graphNr * 3 + 1));
            // ADAS punkti kast:
            if (adasPoint) placeholder.append(this.getGraphBox(drow, "adas", adasPoint));
        }
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#graph' + graphNr).on('plothover', (function(event, pos, item) {
            //console.log("hover recognized");
            if (this.hoverTip) this.hoverTip.remove();
            if (item) {
                this.hoverTip = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(this.toolTipHTML(item.series.data[item.dataIndex][1], item.series.label));
                if (this.hoverTip) {
                    (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('.graph').parent().append(this.hoverTip);
                    let ofsh = this.hoverTip.outerHeight();
                    let ofsw = this.hoverTip.outerWidth();
                    this.hoverTip.offset({
                        left: item.pageX - ofsw / 2,
                        top: item.pageY - ofsh - 15
                    });
                }
            }
        }).bind(this));
    }
    /**
   * Tagastab graafikule kasti, mille värv vastab antud punktiga määratud tolerantisvahemikule.
   * Kasti asukoht sõltub id parameetrist
   * @param {ConvertedMeasurementType} drow Mõõteinfo struktuur
   * @param {string} id Punkti liik: "middle" või "adas"
   * @param point
   * @returns {string}
   */ getGraphBox(drow, id, point) {
        let boxStyle = 'middleBoxRed';
        switch(drow["analyzed"][point][1]){
            case 3:
                // Punane
                boxStyle = 'middleBoxRed';
                break;
            case 2:
                // Kollane
                boxStyle = 'middleBoxYellow';
                break;
            case 1:
                // Roheline
                boxStyle = 'middleBoxGreen';
                break;
            default:
                break;
        }
        let position = "";
        switch(id){
            case "middle":
                // center
                position = "left:570px;top:8px;";
                break;
            case "adas":
                // [ceneter, 150] keskele:
                position = "left:805px;top:8px;";
                break;
            default:
                break;
        }
        return "<div id='" + id + "PointBox' class='" + boxStyle + "' style='position:absolute;" + position + "width:80px;height:40px'></div>";
    }
    toolTipHTML(a, b) {
        let s, x;
        if (!(0, $30071e4d8f83fdfd$export$5fe1d4742c8a41e2)(a)) return false;
        x = Math.round(a * 10) / 100;
        s = "<i>" + x + "</i>";
        return s;
    }
    graph_refresh() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.nominalButtonOn = settings.getNominalGraph();
        this.make_graph_page();
    }
    graph_zoom_in() {
        for(let l = 0; l < this.current_plots.length; l++)this.current_plots[l].zoom();
    }
    graph_zoom_out() {
        for(let l = 0; l < this.current_plots.length; l++)this.current_plots[l].zoomOut();
    }
    graph_pan_left() {
        for(let l = 0; l < this.current_plots.length; l++)this.current_plots[l].pan({
            left: 100,
            top: 0
        });
    }
    graph_pan_right() {
        for(let l = 0; l < this.current_plots.length; l++)this.current_plots[l].pan({
            left: -100,
            top: 0
        });
    }
    graph_pan_up() {
        for(let l = 0; l < this.current_plots.length; l++)this.current_plots[l].pan({
            right: 0,
            top: 50
        });
    }
    graph_pan_down() {
        for(let l = 0; l < this.current_plots.length; l++)this.current_plots[l].pan({
            right: 0,
            top: -50
        });
    }
    graph_select_item(n) {
        let activeRow = -1;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement && (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"] !== undefined) activeRow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"];
        activeRow += n;
        if (activeRow >= 0 && activeRow < (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results.length) this.show_a_measurement(activeRow);
    }
    show_a_measurement(r) {
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug(r);
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_converted_results[r];
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"] = r;
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement);
        (0, $03277cb1bca63048$export$3e3e3b72c058f99)();
    }
    graph_toggle(m) {
        let status;
        let id = '#m' + m + 'b';
        //console.log("graph_toggle "+m+" id "+id);
        status = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).hasClass('active');
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).button("toggle");
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id + 'd').button("toggle");
        if (status) {
            // Väljalülitamine
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).css("background-color", "white");
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id + 'd').css("background-color", "white");
        } else {
            // Sisselülitamine
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).css("background-color", "999999");
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id + 'd').css("background-color", "999999");
        }
        //$(id).css("background-color","yellow");
        //console.log($(id).hasClass('active'));
        if (m == "n") {
            let nominalGraph = (0, $82412e69ca9e99a5$export$2e2bcd8739ae039).getInstance();
            this.nominalButtonOn = !status;
            if (status) // Lülitame nominaalgraafiku välja:
            this.refreshGraphs();
            else {
                // Laeme nominaalgraafiku sisse
                let drow = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow();
                // load() kutsub ise refreshGraphs() välja!
                nominalGraph.load(drow.codeVariant);
                this.refreshGraphs();
            }
        } else this.refreshGraphs();
    }
    graph_change_wagon(n, w) {
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).graph_wagons[n] = w;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) {
            if (w > 0) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#m' + n + 't').text("R" + w);
            else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#m' + n + 't').text("m" + n);
        } else if (w > 0) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#m' + n + 't').text("W" + w);
        else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#m' + n + 't').text("m" + n);
        this.refreshGraphs();
    }
    graph_save_nominal() {
        let nominalGraph = (0, $82412e69ca9e99a5$export$2e2bcd8739ae039).getInstance();
        //let points = [];
        let drow = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow();
        if (!drow) return;
        let series = drow.corr_series;
        if (!series) return;
        nominalGraph.save(drow['codeVariant'], series);
    }
    raw_toggle() {
        let id = '#rawb';
        let status = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).hasClass('active');
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).button("toggle");
        if (status) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).css("background-color", "white");
        else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).css("background-color", "999999");
        this.refreshGraphs();
    }
    constructor(){
        this.hoverTip = null;
        this.graph_height = 250;
        this.small_graph_height = 250;
        this.big_graph_height = 600;
        this.graph_width = 1200;
        // padding kahe graafiku vahel
        this.graph_padding = 30;
        // Hetkel zoomituna kuvatava graafiku number (0..n), -1 tähendab, et zoom on väljas
        this.zoomedGraph = -1;
        this.nominalButtonOn = false;
        this.current_plots = [
            null,
            null,
            null
        ];
    }
}
/**
   * @private
   * @type {?Graph}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($b2a0945f49afb6e5$var$Graph, "graphInstance", null);
var $b2a0945f49afb6e5$export$2e2bcd8739ae039 = $b2a0945f49afb6e5$var$Graph;








class $90a202b862875a28$var$Alarms {
    /**
   * @returns {Alarms}
   */ static getInstance() {
        if ($90a202b862875a28$var$Alarms.alarmsInstance == null) $90a202b862875a28$var$Alarms.alarmsInstance = new $90a202b862875a28$var$Alarms();
        return $90a202b862875a28$var$Alarms.alarmsInstance;
    }
    load_errors() {
        let wurl = this.conf_errors_url;
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("loading errors " + wurl);
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: wurl,
            success: (function(data) {
                this.errorscall(data);
            }).bind(this)
        });
    }
    errorscall(data) {
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("errorscall called");
        let errors_data = [];
        if (!data) {
            this.draw_alarms_page([]);
            return;
        }
        let l = data["errorsResult"];
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug(l);
        if (!l) {
            this.draw_alarms_page([]);
            return;
        }
        for(let i = 0; i < l.length; i++){
            if (!l[i]) continue;
            errors_data.push(l[i]);
        }
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("errors_data : ");
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug(errors_data);
        this.draw_alarms_page(errors_data);
    }
    make_alarms_page() {
        (0, $03277cb1bca63048$export$c31045a889981f00)();
        (0, $03277cb1bca63048$export$b0c1cba25cb0c370)();
        (0, $30071e4d8f83fdfd$export$3c47130985814430)("alarms");
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("alarms page being created");
        let s = "<div style='margin-left: 60px; height: 800px; overflow-y: scroll'>";
        s += "</div>";
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#content").html(s);
        this.load_errors();
    }
    draw_alarms_page(errors) {
        let s = "<div style='margin-left: 60px; height: 800px; overflow-y: scroll'>";
        if (!errors || errors == []) s += "Vigu ei ole esinenud.";
        else {
            errors.sort();
            errors.reverse();
            for(let i = 0; i < errors.length; i++){
                if (!errors[i]) continue;
                s += this.process_errstr(errors[i]) + "<br>";
            }
        }
        s += "</div>";
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#content").html(s);
    }
    process_errstr(s) {
        if (!s) return s;
        let j = s.indexOf("]");
        if (j <= 0 || s.length < 21) return s.replace("/", "//");
        else {
            let p1 = s.substring(1, 20);
            p1 = p1.replace("T", " ");
            p1 = p1.replace("/", "//");
            let p2 = s.substring(j + 1);
            s = p1 + " " + p2;
        }
        return s;
    }
    constructor(){
        this.conf_errors_url = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/errors";
    }
}
/**
   * @type {?Alarms}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($90a202b862875a28$var$Alarms, "alarmsInstance", null);
var $90a202b862875a28$export$2e2bcd8739ae039 = $90a202b862875a28$var$Alarms;











/**
 * Tekitab korrigeeritud andmed drow objektile.
 * Juurde tekivad elemendid:
 * drow["corr_required"] - drow["required"] korrigeeritud väärtused
 * drow["corr_series"] - drow["series"] korrigeeritud väärtused
 * drow["corr_shifts"] - iga rea korrigeerimiseks kasutatud diff väärtused
 */ function $2f5d8207b6c7af36$export$4479559953567eb6(drow) {
    let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
    let LINE_START_X = 0;
    //var LINE_POINTS = settings.getMeasurementPoints();
    //    'linepoints': [1,5,...,2], // len 9, nominaalpunktide kaugus klaasi servast, each num is INT
    //  'required': [[VAL1,TOLERANCE1Y,TOLERANCE1A,TOLERANCE2Y,TOLERANCE2A],...,[VAL9,...]] // len 9, each num is INT
    // series - massiiv joontest, iga joon 1..3 mõõtmist
    let series = drow.series;
    let c_series = [];
    let s_series = [];
    let c_required = [];
    for(let l = 0; l < series.length; l++){
        let line = series[l];
        if (!line) continue;
        let c_line = [];
        let s_line = [];
        // looping over lines
        for(let m = 0; m < line.length; m++){
            let single = line[m];
            if (!single) continue;
            let LINE_POINTS = single.length;
            // looping over measurements in a singe test of a line
            // first pick the linepoint distance from left and requested value
            let lx, ly;
            try {
                lx = drow.linepoints[l * 3 + 1];
                ly = drow.required[l * 3 + 1][0];
            } catch (e) {
                continue;
            }
            // loop over measure points finding the central required point
            let d = LINE_START_X;
            let line_end = drow.lineends[l];
            lx = line_end - lx; // measure point distance is from right
            let line_step = (line_end - LINE_START_X) / LINE_POINTS;
            let x1 = -1;
            let y1 = -1000; // point to the left
            let x2 = -1;
            let y2 = -1000; // point to the right
            //Legacy.debug("single.length: "+single.length);
            for(let x = 0; x < single.length; x++){
                if (d > lx) {
                    x1 = d - line_step;
                    y1 = single[x - 1];
                    x2 = d;
                    y2 = single[x];
                    break; // fire just once
                }
                d += line_step;
            }
            // calculate linear interpolant of two points
            // eslint-disable-next-line eqeqeq
            let ymedium;
            if (x2 != x1) ymedium = y1 + (y2 - y1) * ((lx - x1) / (x2 - x1));
            else ymedium = (y1 + y2) / 2; // non-interpolation medium
            //ymedium=(y1+y2)/2; // non-interpolation medium
            let ydiff = ly - ymedium; // simplest ydiff
            // correct nominals
            let n0 = drow.required[l * 3];
            let n1 = drow.required[l * 3 + 1];
            let n2 = drow.required[l * 3 + 2];
            let c0 = n0[0] / n1[0];
            let c2 = n2[0] / n1[0];
            let k0, k2;
            // eslint-disable-next-line eqeqeq
            if (ymedium != 0) {
                k0 = (ymedium - n1[0]) * c0;
                k2 = (ymedium - n1[0]) * c2;
            } else {
                k0 = 0;
                k2 = 0;
            }
            let cn0, cn1, cn2;
            if (settings.isToleranceCompensation()) {
                cn0 = [
                    n0[0] == null ? null : n0[0] + k0,
                    n0[1],
                    n0[2],
                    n0[3],
                    n0[4]
                ];
                cn1 = n1;
                cn2 = [
                    n2[0] == null ? null : n2[0] + k2,
                    n2[1],
                    n2[2],
                    n2[3],
                    n2[4]
                ];
            } else {
                cn0 = n0;
                cn1 = n1;
                cn2 = n2;
            }
            c_required.push(cn0);
            c_required.push(cn1);
            c_required.push(cn2);
            // correct the line
            ydiff = 0; // no correction of actual measurements
            let c_single = [];
            for(let x = 0; x < single.length; x++)c_single.push(single[x] + ydiff);
            c_line.push(c_single);
            s_line.push(ydiff);
        }
        c_series.push(c_line);
        s_series.push(s_line);
    }
    // Copy additional points:
    if (drow.required.length > c_required.length) c_required = c_required.concat(drow.required.slice(c_required.length));
    // store
    drow.corr_required = c_required;
    drow.corr_series = c_series;
    drow.corr_shifts = s_series;
}
/**
 * Returns array:
 * [
 * 		[diff, status, y, x],
 * 		...
 * ]
 *
 * Iga nominaali kohta üks element, mis kajastab:
 * 		diff - nominaalpunktis mõõdetud väärtuse ja ettenähtud väärtuse vahe
 * 		status - üks järgmistest:
 * 		    1 - ok (diff < alumine viga),
 * 		    2 - warning (diff < ülemine viga),
 * 		    3 - error (diff > ülemine viga)
 * 		y - nominaalpunktis mõõdetud väärtus
 * 	    x - nominaali x koordinaat
 *
 */ function $2f5d8207b6c7af36$var$analyze_grid_row(drow) {
    let LINE_START_X = 0;
    //var LINE_POINTS = settings.getMeasurementPoints();
    let req = drow.corr_required;
    //req=drow["required"];
    //Legacy.debug("drow[required]: "+drow["required"]);
    if (!req) return false;
    let t = [];
    for(let i = 0; i < req.length; i++){
        let rp = req[i]; // requirement point with value and 4 tolerances
        let ly = rp[0]; // required value
        let lx = drow.linepoints[i]; // x coord of requirement point
        //Legacy.debug("i, lx: "+i+" "+lx);
        // get corresponding line and measurement series
        //'series': [ [[0,...,99],..,[0,...,99]], ... ,[[0,...,99]] ]
        // lnum = Math.floor(i / 3);
        let lnum = drow.lineinfo[i][0];
        let line = drow.corr_series[lnum];
        let single = line != null ? line[line.length - 1] : null;
        let LINE_POINTS = 0;
        if (single) LINE_POINTS = single.length;
        // find corresponding point
        let d = LINE_START_X;
        let line_end = drow.lineends[lnum];
        lx = line_end - lx; // measure points are from right end
        let line_step = (line_end - LINE_START_X) / LINE_POINTS;
        let x1 = -1;
        let y1 = -1000; // point to the left
        let x2 = -1;
        let y2 = -1000; // point to the right
        if (single) for(let x = 0; x < single.length; x++){
            if (d > lx) {
                x1 = d - line_step;
                y1 = single[x - 1];
                x2 = d;
                y2 = single[x];
                break; // fire just once
            }
            d += line_step;
        }
        // calculate linear interpolant of two points
        //Legacy.debug("y2, y1: "+y2+" "+y1);
        //Legacy.debug("lx, x1: "+lx+" "+x1);
        //Legacy.debug("x2, x1: "+x2+" "+x1);
        let ymedium;
        if (x2 != x1) ymedium = y1 + (y2 - y1) * ((lx - x1) / (x2 - x1));
        else ymedium = (y1 + y2) / 2; // non-interpolation medium
        // diff is difference between required and real value
        //Legacy.debug("ly: "+ly);
        //Legacy.debug("ymedium: "+ymedium);
        let diff = Math.round(Math.abs(ly - ymedium));
        let s = $2f5d8207b6c7af36$var$getNominalStatus(rp, diff);
        let t1 = [
            diff,
            s,
            ymedium,
            x2 != x1 ? (x2 + x1) / 2 : x1
        ]; // error, status, averaged measurement, x
        //Legacy.debug("t1: "+t1);
        t.push(t1); // create a list of value,status pairs: status 1 ok, 2, warn, 3 wrong
    }
    return t;
}
/**
 *
 * @param {ConvertedMeasurementType} drow
 */ function $2f5d8207b6c7af36$var$analyze_grid_row_angles(drow) {
    if (drow.angles == null || drow.analyzed == null) return null;
    let t = [];
    for(let i = 0; i < drow.angles.length; i++){
        /*
     * [v, t1p, t1m, t2p, t2m, point1, point2], kus v - nominaalväärtus, t1p - ülemine 1. tolerants, t1m - alumine 1. tolerants, t2p - ülemine 2. tolerants, t2m - alumine 2. tolerants
     */ let a = drow.angles[i];
        // drow.lineinfo = [lineNo, pointName, isAdas]
        let pi = [];
        for(let j = 0; j < drow.lineinfo.length; j++)if (drow.lineinfo[j][1] === a[5] || drow.lineinfo[j][1] === a[6]) pi.push(drow.analyzed[j]);
        if (pi.length != 2) continue;
        // [diff, status, y, x]
        let angle = (0, $30071e4d8f83fdfd$export$11a7b5abbf8340a)(pi[0][3], pi[0][2], pi[1][3], pi[1][2]) * 10;
        let diff = Math.round(Math.abs(a[0] - angle));
        let s = $2f5d8207b6c7af36$var$getNominalStatus(a, diff);
        t.push([
            diff,
            s,
            angle,
            null
        ]);
    }
    return t;
}
/**
 *
 * @param nominal
 * @param diff Difference between actual value and nominal value (absolute value!)
 * @returns {number} Status: 1 - ok, 2 - warning, 3 - wrong
 */ function $2f5d8207b6c7af36$var$getNominalStatus(nominal, diff) {
    if (diff >= nominal[4] || diff >= nominal[3]) return 3; // really wrong
    else if (diff >= nominal[2] || diff >= nominal[1]) return 2; // warning
    return 1; // ok
}
/**
 * Rakendab sisendmassiivi kõigile ridadele convert_data_row() meetodit
 * @param indata
 * @returns {ConvertedMeasurementType[]}
 */ function $2f5d8207b6c7af36$export$71d161edb28ff086(indata) {
    let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
    let res = new Array(settings.getWagonCount() + 1);
    for(let i = 0; i <= settings.getWagonCount(); i++)res[i] = null;
    for(let i = 0; i < indata.length; i++){
        let orow = indata[i];
        let nrow = $2f5d8207b6c7af36$export$63550c27588333c3(orow);
        if (nrow && (nrow.wagon || nrow.wagon === 0)) //Legacy.debug("wagon found "+nrow["wagon"]);
        {
            if (nrow.wagon >= 0 && nrow.wagon <= settings.getWagonCount()) res[nrow.wagon] = nrow;
        //Legacy.debug("wagon stored "+nrow["wagon"]);
        }
    //res.push(nrow);
    }
    return res;
}
/**
 * Teisendab JSON struktuurina antud mõõteandmed sisemiseks stuktuuriks järgmisel kujul:
 * <pre>
 * nrow = {
 *   "wagon" : vaguni_number,	// 0 -> manual, 1 ... n
 *   "skeleton" : vaguni_raam,
 *   "codeVariant" : toote_variant,
 *   "description1" : kirjeldus1,
 *   "description2" : kirjeldus2,
 *   "timestamp" : algus_aeg,
 *   "end_timestamp": lopp_aeg,
 *   // Joone pikkused iga joone kohta, kokku 5 tk
 *   "lineends" : [joone_pikkus[0], ..., joone_pikkus[4]],
 *   // Nominaalide kaugused otspunktidest: 5 joont x 3 nominaali = kokku 15 nominaali kaugust + täiendavate punktide omad
 *   "linepoints" : [nominaali_kaugus[0], ...],     // [1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C, 2P50, 2P100, ...]
 *   // Nominaalid
 *   "required" : [
 *   	// Iga joone kohta 3 nominaali, kokku 15 tk + täiendavate punktide omad
 *   	// Iga nominaali korral: väärtus, ülemine tolerants 1, alumine tolerants 1, ülemine tolerants 2, alumine tolerants 2
 *   	[nominaal[0]["v"], nominaal[0]["t1p"], nominaal[0]["t1m"], nominaal[0]["t2p"], nominaal[0]["t2m"]],
 *   	...
 *   ],
 *   "angles: [
 *      // Nurga info
 *   	[nominaal[0]["v"], nominaal[0]["t1p"], nominaal[0]["t1m"], nominaal[0]["t2p"], nominaal[0]["t2m"]],
 *   ],
 *   // Jooned
 *   "series" : [
 *   	// Jooni kokku 5
 *   	[
 *   		// Max 3 mõõtmist, iga mõõtmine 100 punkti
 *   		[mootejoon_1_1[0], ..., mootejoon_1_1[99]],
 *   		...
 *   	],
 *   	...
 *   ],
 *   // Toormõõtmised
 *   "rawdata" : [
 *   	// Toormõõtmisi kokku 5 (1 iga joone kohta), iga mõõtmine 500 punkti
 *   	[mootejoon1_toor[0], ..., mootejoon1_toor[499]],
 *   	...
 *   ],
 *   // Veateated
 *   "error" : [ viga[0], ... ],
 *
 *   // Korrigeeritud jooned. Esineb juhul, kui on lastud läbi funktsiooni correct_grid_row()
 *   "corr_series" : [...],
 *   "corr_required": [...],
 *   "corr_shifts": [...],
 *   // Analüüsitud andmed. Funktsiooni analyze_grid_row() välund - iga nominaalpunkti kohta
 *   "analyzed": [[diff, status, y, x], ...]
 *   // Nurkade analüüsitud andmed
 *   "analyzed_angles": [[diff, status, y], ...]
 *   // Joonte punktide info (st - mis punktid on linepoints, required ja analyzed massiivides)
 *   lineinfo: [[lineNo, pointName, isAdas], ...]   // lineNo = 0, ..., 5; pointName = "Ai", "Bi", "Ci", "P50", "P100", ...
 * }
 * </pre>
 * @param orow
 * @returns {ConvertedMeasurementType}
 */ function $2f5d8207b6c7af36$export$63550c27588333c3(orow) {
    if (!orow) return {};
    let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
    let productTransformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)((0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getProductConfig());
    let nrow = {};
    if (orow.vaguni_number || orow.vaguni_number === 0) nrow.wagon = orow.vaguni_number;
    else nrow.wagon = "?";
    if (orow.vaguni_number == -1) nrow.wagon = 0;
    if (orow.vaguni_raam) nrow.skeleton = orow.vaguni_raam;
    else nrow.skeleton = "?";
    if (orow.toote_variant || orow.toote_variant === "") nrow.codeVariant = orow.toote_variant;
    else nrow.codeVariant = "?";
    if (orow.kirjeldus1) nrow.description1 = orow.kirjeldus1;
    else nrow.description1 = "?";
    if (orow.kirjeldus2) nrow.description2 = orow.kirjeldus2;
    else nrow.description2 = "?";
    if (orow.algus_aeg) nrow.timestamp = (0, $30071e4d8f83fdfd$export$719af6d430903ba6)(orow.algus_aeg);
    else nrow.timestamp = "?";
    if (orow.lopp_aeg) nrow.end_timestamp = (0, $30071e4d8f83fdfd$export$719af6d430903ba6)(orow.lopp_aeg);
    else nrow.end_timestamp = "?";
    if (orow.ahju_ring) nrow.furnaceRing = orow.ahju_ring;
    else nrow.furnaceRing = "?";
    if (orow.klaasi_id) nrow.glassId = orow.klaasi_id;
    else nrow.glassId = "?";
    nrow.lineinfo = [];
    nrow.lineends = [];
    nrow.linepoints = [];
    nrow.required = [];
    nrow.angles = [];
    if (orow.tooteinfo) {
        for(let i = 0; i < orow.tooteinfo.length; i++)nrow.lineends.push(orow.tooteinfo[i].lineLength);
        let nominals = productTransformer.getOrderedNominals(orow.tooteinfo);
        for (let n of nominals)switch(n.name == null ? "" : n.name.substring(0, 1)){
            case "A":
                // ANGLE:
                nrow.angles.push([
                    n.value,
                    n.upperTolerance1,
                    n.lowerTolerance1,
                    n.upperTolerance2,
                    n.lowerTolerance2,
                    n.point1,
                    n.point2
                ]);
                break;
            case "P":
            case "H":
            default:
                nrow.lineinfo.push([
                    n.line,
                    n.name,
                    n.isAdas
                ]);
                nrow.linepoints.push(n.distance);
                nrow.required.push([
                    n.value,
                    n.upperTolerance1,
                    n.lowerTolerance1,
                    n.upperTolerance2,
                    n.lowerTolerance2
                ]);
                break;
        }
    }
    let series = [];
    // TODO: noData kasutamine on väga küsitav - potentsiaalne probleemide koht...
    let isEmpty = true;
    let lineCount = settings.getMeasurementLineCount();
    if (orow.joonte_arv) lineCount = 0 + orow.joonte_arv;
    if (orow.mootejoon) {
        for(let i = 0; i < lineCount; i++)if (orow.mootejoon[i] && orow.mootejoon[i].length > 0) {
            series.push(orow.mootejoon[i]);
            isEmpty = false;
        } else series.push(null);
    }
    if (isEmpty) series = []; // AA clear empty lines
    nrow.series = series;
    series = [];
    if (orow.mootejoon_toor) {
        for(let i = 0; i < lineCount; i++)if (orow.mootejoon_toor[i] && orow.mootejoon_toor[i].length > 0) series.push(orow.mootejoon_toor[i]);
        else series.push(null);
    }
    nrow.rawdata = series;
    if (orow.viga && (0, $2679c250f7f84a9c$export$2e2bcd8739ae039).isArray(orow.viga) && orow.viga.length > 0) //Legacy.debug("len "+orow["viga"].length);
    //nrow["description2"]="<b>Viga!</b> "+nrow["description2"];
    nrow.error = orow.viga;
    // Teeme kohe ära analüüsi:
    $2f5d8207b6c7af36$var$analyze_drow(nrow);
    return nrow;
}
function $2f5d8207b6c7af36$var$analyze_drow(drow) {
    if (!drow.corr_series || (0, $03277cb1bca63048$export$2e2bcd8739ae039).force_correct) $2f5d8207b6c7af36$export$4479559953567eb6(drow);
    if (!drow.analyzed) {
        let tmp = false;
        try {
            tmp = $2f5d8207b6c7af36$var$analyze_grid_row(drow);
        } catch (err) {
            (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("catched :" + err);
        }
        if (tmp) drow.analyzed = tmp;
        drow.analyzed_angles = $2f5d8207b6c7af36$var$analyze_grid_row_angles(drow);
    }
}








/**
 * Vagunite lehte haldav moodul
 *
 */ class $f9a0e15f8468a3bd$var$Wagons {
    /**
   * @returns {Wagons}
   */ static getInstance() {
        if ($f9a0e15f8468a3bd$var$Wagons.wagonsInstance == null) $f9a0e15f8468a3bd$var$Wagons.wagonsInstance = new $f9a0e15f8468a3bd$var$Wagons();
        return $f9a0e15f8468a3bd$var$Wagons.wagonsInstance;
    }
    /**
   * Vagunite lehe tekitamine
   */ make_wagons_page() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.productTransformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)((0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getProductConfig());
        this.remember_manual_mode_bar();
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).menu_translate();
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).clear_old_page();
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").css("margin-top", "");
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").css("margin-left", "");
        if (settings.isManualModeAllowed() && settings.isManualMode()) this.make_manual_mode_bar();
        // Tekita vagunite tabel
        this.make_grid();
        (0, $30071e4d8f83fdfd$export$3c47130985814430)("wagons");
        if (settings.isManualModeAllowed() && settings.isManualMode()) {
            this.restore_manual_mode_bar();
            this.init_manual_mode_bar();
        }
        this.productTransformer = null;
    }
    /**
   * Vagunite tabeli tekitamine vagunite lehe sisse
   * @returns {String}
   */ make_grid() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let s = "<table id='gridtable'>";
        // Vagunite tabeli päis
        s += this.make_grid_titlerow();
        if (settings.isManualMode() && (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[0]) // Tekitame manuaalse mõõtmise rea:
        //analyze_drow(global.grid_data[0]);
        s += this.make_grid_row(0, (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[0]);
        for(let y = 1; y <= settings.getWagonCount(); y++){
            let drow = {};
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data.length > y && (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[y]) drow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[y];
            // Vagunite tabeli rida
            s += this.make_grid_row(y, drow);
        }
        s += "</table>";
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).force_correct = false;
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#content").html(s);
    }
    /**
   * Vagunite tabeli päisrea tekitamine.
   * @returns {String}
   */ make_grid_titlerow() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let s = "";
        let isSimple = settings.isSimpleUi();
        s += "<tr class='gridtr gridtrhead'>\n";
        let nominalNames = this.productTransformer.getOrderedNominalNames();
        for(let x = 0; x < this.grid_cols.length; x++){
            // loop over cols
            let cclasses = "";
            let cstyle = "";
            let cvalue = "";
            let colmeta = this.grid_cols[x];
            if (colmeta[3] == 2 && !isSimple || colmeta[3] == 1 && isSimple) continue;
            if (colmeta) {
                if (colmeta[0] > 0) cstyle = "width: " + colmeta[0] + "px;";
                cclasses = "gridtd_" + colmeta[1];
                if ((0, $30071e4d8f83fdfd$export$5fe1d4742c8a41e2)(colmeta[1]) || colmeta[1] == 'wagon') cclasses += " numeric";
                if (colmeta[1] !== 0 && colmeta[4]) cclasses += " gridthsep";
                cvalue = (0, $865532d99f221026$export$2e2bcd8739ae039)(colmeta[2]);
            }
            if (!cvalue && cvalue !== 0) cvalue = "";
            if (colmeta[1] == 0) {
                // P1 - P9/P15
                let showCenter = settings.showOnlyCenterPoints();
                let first = true;
                for(let i = 1; i <= settings.getMeasurementLineCount() * 3; i++){
                    if (showCenter && i % 3 != 2) continue;
                    s += this.make_grid_titlerow_td(cclasses + (first ? " gridthsep" : ""), cstyle, cvalue + "" + i);
                    first = false;
                }
                // P300 - P50
                first = true;
                for(let i = settings.getCenterAddPoints() - 1; i >= 0; i--){
                    let pName = (i + 1) * 50;
                    s += this.make_grid_titlerow_td(cclasses + (first ? " gridthsep" : ""), cstyle, cvalue + "" + pName);
                    first = false;
                }
                // ANGLE
                s += this.make_grid_titlerow_td(cclasses, cstyle, (0, $865532d99f221026$export$2e2bcd8739ae039)("angle"));
                // H1 - H5
                first = true;
                cvalue = (0, $865532d99f221026$export$2e2bcd8739ae039)("H");
                for(let i = 0; i < settings.getHudPoints(); i++){
                    s += this.make_grid_titlerow_td(cclasses + (first ? " gridthsep" : ""), cstyle, cvalue + "" + (i + 1));
                    first = false;
                }
            } else s += this.make_grid_titlerow_td(cclasses, cstyle, cvalue);
        }
        s += "</tr>\n";
        return s;
    }
    make_grid_titlerow_td(cclasses, cstyle, cvalue) {
        return "<td class='gridheadtd " + cclasses + "' style='" + cstyle + "'>" + cvalue + "</td>";
    }
    /**
   * Vagunite tabeli ühe vagunirea tekitamine.
   * @param y Vagunirea number (algusega 1st, st 1. vaguni järjekorranumber on 1)
   * @param drow Antud vaguni mõõtmisinfo struktuur (massiivi global.grid_data vastava rea element)
   * @returns {String} Koostatud tabeli rida
   */ make_grid_row(y, drow) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let isSimple = settings.isSimpleUi();
        let rclasses = "gridtr" + y;
        if (y == 0) rclasses += " manual_row";
        if (!isSimple) {
            if (y == (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon) rclasses += " current_row"; // Oranži värvi rida
            if (this.isBendingWagon(y)) rclasses += " current_row_14"; // Punast värvi rida
            if (this.isLoadingWagon(y)) rclasses += " current_row_31"; // Rohelist värvi rida
        }
        let s = "";
        for(let x = 0; x < this.grid_cols.length; x++){
            // loop over cols
            let colmeta = this.grid_cols[x];
            if (colmeta[3] == 2 && !isSimple || colmeta[3] == 1 && isSimple) continue;
            if (colmeta[1] == 0) {
                // P-punktid:
                let showCenter = settings.showOnlyCenterPoints();
                // P1 - P9/P15
                let i = 0;
                let first = true;
                for(; i < settings.getMeasurementLineCount() * 3; i++){
                    if (showCenter && i % 3 != 1) continue;
                    s += this.make_grid_col(y, drow, i, colmeta[0], first ? colmeta[4] : false);
                    first = false;
                }
                // P300 - P50
                let centerPoints = settings.getCenterAddPoints();
                first = true;
                for(let j = centerPoints - 1; j >= 0; j--){
                    s += this.make_grid_col(y, drow, i + j, colmeta[0], first ? colmeta[4] : false);
                    first = false;
                }
                i += centerPoints;
                // ANGLE
                s += this.make_grid_col(y, drow, "angle", colmeta[0], false);
                // HUD1 - HUD5
                first = true;
                for(let j = 0; j < settings.getHudPoints(); j++){
                    s += this.make_grid_col(y, drow, i + j, colmeta[0], first ? colmeta[4] : false);
                    first = false;
                }
            } else s += this.make_grid_col(y, drow, colmeta[1], colmeta[0], colmeta[4]);
        }
        return "<tr class='gridtr " + rclasses + "'>\n" + s + "</tr>\n";
    }
    isLoadingWagon(y) {
        return this.isWagonAtOffset(y, (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance().getWagonOffsetLoading());
    }
    isBendingWagon(y) {
        return this.isWagonAtOffset(y, (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance().getWagonOffsetBending());
    }
    isWagonAtOffset(wagonNo, offset) {
        if (offset == 0) return false;
        let wagonCount = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance().getWagonCount();
        let offsetWagonNo = (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon + offset;
        if (offsetWagonNo < 0) offsetWagonNo += wagonCount;
        else if (offsetWagonNo > wagonCount) offsetWagonNo -= wagonCount;
        return offsetWagonNo === wagonNo;
    }
    /**
   *
   * @param {number} y
   * @param {ConvertedMeasurementType} drow
   * @param {string} columnName
   * @param {number} width
   * @param {boolean} colsep
   * @returns {string}
   */ make_grid_col(y, drow, columnName, width, colsep) {
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        let tmp;
        let cvalue = "";
        let cstyle = "";
        let cclasses = "";
        if (colsep) cclasses = "gridsep";
        if (!drow || !drow.required) {
            cclasses += " gridtd";
            return '<td class="' + cclasses + '"></td>';
        }
        if (width > 0) cstyle = "width: " + width + "px;";
        else cstyle = "";
        cclasses += " gridtd_" + columnName;
        if ((0, $30071e4d8f83fdfd$export$5fe1d4742c8a41e2)(columnName) || columnName == 'wagon' || columnName == 'angle') cclasses += " numeric";
        // Is content clickable?
        let clickable = false;
        if ((0, $30071e4d8f83fdfd$export$5fe1d4742c8a41e2)(columnName)) {
            if (drow.required && drow.required[columnName] != null && drow.required[columnName].length > 0 && drow.required[columnName][0] != null && drow.analyzed && drow.analyzed[columnName]) {
                let cstatus = "";
                try {
                    if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).gridShowErr) cvalue = drow["analyzed"][columnName][0];
                    else {
                        cvalue = drow["analyzed"][columnName][2];
                        cvalue = Math.round(cvalue) / 10;
                    }
                    // AA: -100 is a result of missing data; TODO: raw data should be set null earlier
                    if (cvalue == -100) cvalue = "";
                    cstatus = drow["analyzed"][columnName][1];
                    // if ((columnName % 3 == 1) && (cvalue || cvalue === 0)) {
                    if ((0, $d02c132c9fe52fc9$export$2e2bcd8739ae039).isCenterPoint(drow.lineinfo[columnName][1].substring(0, 1)) || drow.lineinfo[columnName][2]) cclasses += " gridtd_imp ";
                     // else cclasses+=" gridtd_unimp ";
                } catch (e) {
                    cstatus = "";
                    (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("catched 2: " + e);
                //Legacy.debug("colmeta 1: "+columnName);
                //Legacy.debug("drow[analyzed]: "+drow["analyzed"]);
                }
                cclasses += " row_status_" + cstatus;
            }
        /* df = "" */ } else if (columnName == "angle") {
            if (drow.angles && drow.angles.length > 0 && drow.angles[0].length > 0 && drow.angles[0][0] != null && drow.analyzed_angles && drow.analyzed_angles.length > 0) {
                if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).gridShowErr) cvalue = drow["analyzed_angles"][0][0];
                else {
                    cvalue = drow["analyzed_angles"][0][2];
                    cvalue = Math.round(cvalue) / 10;
                }
                // AA: -100 is a result of missing data; TODO: raw data should be set null earlier
                if (cvalue == -100) cvalue = "";
                let cstatus = drow["analyzed_angles"][0][1];
                cclasses += " row_status_" + cstatus;
            }
        } else if (columnName == "wagon") {
            //cvalue=drow[columnName]+1;
            //cvalue=drow[columnName];
            if (y == "0") cvalue = (0, $865532d99f221026$export$2e2bcd8739ae039)("manual");
            else cvalue = y;
        } else if (columnName == "skeleton") // Mitteklikitav painutusraami number:
        //cvalue = "" + wagonConf.getRaamiNr(y) + "\n";
        cvalue = "" + (drow["skeleton"] == null ? "" : drow["skeleton"]) + "\n";
        else if (columnName == "xskeleton") {
            // Painutusraami number on eraldi klikitav - sellega tuleb popup raami numbri muutmiseks:
            //var raamiNr = wagonConf.getRaamiNr(y) + "";
            let raamiNr = drow["skeleton"] == null ? "" : drow["skeleton"];
            cvalue = '<button class="btn btn-default btn-xs btn-block sbtn" type="submit" id="skeleton' + y + '" onclick="wagons.change_skeleton(' + y + ')">' + raamiNr + '</button>\n';
            clickable = true;
        } else if (columnName == "code") {
            // Lihtne koodi väli
            cvalue = drow.codeVariant == null ? "" : drow.codeVariant;
            if (cvalue === undefined) cvalue = "";
        } else if (columnName == "xcode") {
            // Koodi väli on link, mis avab koodi versiooni sisestamise:
            let codeVariant = this.getKoodVariant(y);
            let color = "";
            if (codeVariant != drow["codeVariant"]) color = ';color: red';
            cvalue = '<button class="btn btn-xs btn-link" id="code' + y + '" onclick="wagons.change_code(' + y + ')" style="font-size: 14px' + color + '">' + (codeVariant == null ? "" : codeVariant) + '</button>\n';
            clickable = true;
        } else if (columnName == "edge") {
            if (wagonConf.isServaotsing(y)) tmp = "active";
            else tmp = "passive";
            //cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='measure"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn " + tmp + "\" id='edge" + y + "' ";
            cvalue += "onclick=\"wagons.edge_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "fedge") {
            // Forced edge detection
            if (wagonConf.isForcedServaotsing(y)) tmp = "active";
            else tmp = "passive";
            //cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='measure"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn " + tmp + "\" id='fedge" + y + "' ";
            cvalue += "onclick=\"wagons.fedge_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "measure") {
            let disabled = " ";
            //if (wagonConf.isServaotsing(y)) disabled = "disabled='disabled' ";
            if (wagonConf.isMootmine(y)) tmp = "active";
            else tmp = "passive";
            //cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='measure"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn " + tmp + "\" id='measure" + y + "' " + disabled;
            cvalue += "onclick=\"wagons.measure_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "repeat") {
            let disabled = " ";
            //if (wagonConf.isServaotsing(y) || !wagonConf.isMootmine(y)) disabled = "disabled='disabled' ";
            if (!wagonConf.isMootmine(y)) disabled = "disabled='disabled' ";
            //cvalue="<input type='checkbox' onclick='alert('"+y+")' id='repeat'"+y+"' checked>";
            // cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='repeat"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn active\" id='repeat" + y + "' " + disabled;
            cvalue += "onclick=\"wagons.repeat_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "description1" && drow) cvalue = (0, $03277cb1bca63048$export$fe7ddefb28e95f52)(drow[columnName], 13);
        else if (columnName == "description2" && drow) cvalue = (0, $03277cb1bca63048$export$fe7ddefb28e95f52)(drow[columnName], 40);
        else if (drow) cvalue = drow[columnName];
        let s = "<td class='gridtd " + cclasses + "' style='" + cstyle + "' ";
        if (!clickable) s += "onclick='graph.goto_graph_page(" + y + ")'";
        s += ">" + cvalue + "</td>";
        return s;
    }
    remember_manual_mode_bar() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let val = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#productNo').val();
        if (val === undefined) val = "";
        settings.setManualMeasuringTooteKood(val);
    }
    restore_manual_mode_bar() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let val = settings.getManualMeasuringTooteKood();
        if (val === "0") val = "";
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#productNo').val(val);
    }
    make_manual_mode_bar() {
        let s = "";
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#topy").css("height", "40px");
        // $("#intop2").css("margin-top", "10px");
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").css("margin-left", "40px");
        s = this.make_mode_buttons();
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").html(s);
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#m_start").on('click', (function() {
            this.start_measuring();
        }).bind(this));
    }
    init_manual_mode_bar() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        // let row = global.grid_data[0];
        if (settings.isMeasuringInProgress() || settings.isManualMeasuringRequested()) this.measuring_started(settings.getManualMeasuringTooteKood());
        else this.measuring_finished(settings.getManualMeasuringTooteKood());
    }
    make_mode_buttons() {
        let s = '<form class="form-inline" onsubmit="return false;"><div class="row" style="display: flex; align-items: center">';
        s += '<div class="form-group col-md-5"><label>' + (0, $865532d99f221026$export$2e2bcd8739ae039)('Manual measuring mode') + '</label></div>';
        s += '<div class="form-group col-md-3"><input type="text" size="10" class="form-control" id="productNo" placeholder="' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)('code')) + '"></div>';
        s += '<div class="form-group col-md-4"><button type="submit" class="btn btn-primary" autocomplete="off" id="m_start">' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Start measurement")) + '</button></div>';
        s += '</div></form>';
        return s;
    }
    /**
   * NB! Vale "this" väärtus?
   */ start_measuring() {
        let codeVariant = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#productNo').val();
        if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#m_start').hasClass('btn-danger')) {
            // Katkestame:
            codeVariant = "0";
            this.measuring_finished();
        } else {
            // Alustame mõõtmist:
            if (!codeVariant || codeVariant.trim() === "") {
                (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_err((0, $865532d99f221026$export$2e2bcd8739ae039)("Please enter product code!"));
                (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#productNo').val('');
                return;
            }
            this.measuring_started();
        }
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: 'POST',
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/manualMeasuring",
            data: {
                kood: codeVariant
            },
            success: function() {}
        });
    }
    measuring_finished(tooteKood) {
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#productNo').prop('disabled', false);
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#m_start').removeClass('btn-danger').addClass('btn-primary').html((0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)('Start measurement')));
    }
    measuring_started(tooteKood) {
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#productNo').prop('disabled', true);
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#m_start').removeClass('btn-primary').addClass('btn-danger').html((0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)('Cancel measurement')));
    }
    /**
   * Returns point indexes in order as needed to show in UI
   * @returns {Number[]}
   */ getPointNumbers() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let points = [];
        let i = 0;
        // P1 - P9/P15
        for(; i < settings.getMeasurementLineCount() * 3; i++)points.push(i);
        // P300 - P50
        for(let j = settings.getCenterAddPoints() - 1; j >= 0; j--)points.push(i + j);
        // H1 - H5
        i = points.length;
        for(let j = 0; j < settings.getHudPoints(); j++)points.push(i + j);
        return points;
    }
    /**
   * Uuendab hetkel käsil oleva vaguni info
   */ wagon_update() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.load_wagon();
        settings.load_settings();
    }
    /**
   * Uuendab kõigi vagunite info
   */ wagon_update_all() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.wagon_load_count = 0;
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).load_conf();
        for(let i = this.min_wagon_urlnr; i <= settings.getWagonCount(); i++)this.load_wagon(i);
    }
    load_wagon(nr) {
        if (nr != null && nr <= 0) {
            // Wagon not defined. Clear current info:
            this.wagoncall(null, nr);
            return;
        }
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let wagon = nr == null ? settings.isManualMode() ? "manual" : "current" : nr.toString();
        let wurl = this.wagon_urlbase + wagon;
        // Legacy.debug("loading " + wurl);
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: wurl,
            success: (function(data) {
                if (wagon === "current") this.currentwagoncall(data);
                else if (wagon === "manual") this.manualwagoncall(data);
                else this.wagoncall(data, nr);
            }).bind(this)
        });
    }
    currentwagoncall(data) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.productTransformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)((0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getProductConfig());
        let graph = (0, $b2a0945f49afb6e5$export$2e2bcd8739ae039).getInstance();
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("currentwagoncall: current");
        if (data && data.wagonsResult) {
            // Legacy.debug(data.wagonsResult.kirjeldus1 + " " + data.wagonsResult.vaguni_number);
            let nrow = data.wagonsResult;
            let wn = nrow.vaguni_number;
            let orow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).original_grid_data[wn] || {};
            let cnrow = (0, $2f5d8207b6c7af36$export$63550c27588333c3)(nrow);
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).original_grid_data[wn] = nrow;
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[wn] = cnrow;
            // let updated = false;
            let old_cw = (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon;
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon = wn;
            if (wn || wn === 0) {
                if (!nrow.algus_aeg || nrow.algus_aeg !== orow.algus_aeg || nrow.lopp_aeg !== orow.lopp_aeg || old_cw !== wn) {
                    // updated = true;
                    (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("updated current");
                    if (settings.isNoWagons() && nrow.algus_aeg !== orow.algus_aeg && (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#wagons_li").hasClass("active")) // Kui mõõtmise algusaeg erineb vanal ja uuel kirjel, siis tuleb kõik vagunid sisse laadida:
                    this.wagon_update_all();
                    else {
                        if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#wagons_li").hasClass("active")) {
                            (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("updated current row wagons page: new time");
                            this.make_grid();
                        } else if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph_li").hasClass("active")) {
                            (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("updated graph page: new time");
                            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon == (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon) {
                                let status = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#rawb").hasClass('active');
                                graph.make_graph_page();
                                if (status) graph.raw_toggle();
                            }
                        }
                    }
                }
            }
            // handle error showing
            this.handleError(cnrow.error);
        }
        this.productTransformer = null;
    }
    manualwagoncall(data) {
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("manualwagoncall: manual");
        this.productTransformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)((0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getProductConfig());
        let graph = (0, $b2a0945f49afb6e5$export$2e2bcd8739ae039).getInstance();
        if (data && data.wagonsResult) {
            // Legacy.debug(data.wagonsResult.kirjeldus1 + " " + data.wagonsResult.vaguni_number);
            //Legacy.debug(data["wagonsResult"]);
            let nrow = data.wagonsResult;
            nrow.vaguni_number = 0;
            let cnrow = (0, $2f5d8207b6c7af36$export$63550c27588333c3)(nrow);
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).original_grid_data[0] = nrow;
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[0] = cnrow;
            if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#wagons_li").hasClass("active")) {
                (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("updated current row wagons page: new time");
                //this.make_wagons_page();
                this.make_grid();
            } else if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph_li").hasClass("active")) {
                (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("updated graph page: new time");
                if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon == (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon) {
                    let status = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#rawb").hasClass('active');
                    //this.make_wagons_page();
                    this.make_grid();
                    graph.make_graph_page();
                    if (status) graph.raw_toggle();
                }
            }
            // handle error showing
            this.handleError(cnrow.error);
        }
        this.productTransformer = null;
    }
    handleError(error) {
        let alarms = (0, $90a202b862875a28$export$2e2bcd8739ae039).getInstance();
        if (error && error.length > 0) {
            (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("found err " + error);
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#errbar").html((0, $03277cb1bca63048$export$fe7ddefb28e95f52)(alarms.process_errstr(error[0]), 190));
        }
    }
    wagoncall(data, wagon) {
        // Legacy.debug("wagoncall: " + wagon);
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.productTransformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)((0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getProductConfig());
        if (data && data.wagonsResult) {
            // Legacy.debug(data.wagonsResult.kirjeldus1 + " " + data.wagonsResult.vaguni_number);
            //Legacy.debug(data["wagonsResult"]);
            data.wagonsResult.vaguni_number = wagon;
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).original_grid_data[wagon] = data.wagonsResult;
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[wagon] = (0, $2f5d8207b6c7af36$export$63550c27588333c3)((0, $03277cb1bca63048$export$2e2bcd8739ae039).original_grid_data[wagon]);
        } else {
            // Mingi viga vaguni info laadimisel. Teeme tühjaks:
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).original_grid_data[wagon] = {};
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[wagon] = {};
        }
        this.wagon_load_count++;
        // Legacy.debug("wagon_load_count: " + this.wagon_load_count);
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).showAsRead) {
            // do not redraw if some other tab active
            if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#wagons_li").hasClass("active")) this.make_grid();
            else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph_li").hasClass("active");
        } else if (this.wagon_load_count >= settings.getWagonCount() - this.min_wagon_urlnr) {
            (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("found enough: " + this.wagon_load_count + " : now drawing");
            // do not redraw if some other tab active
            if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#wagons_li").hasClass("active")) // this.make_wagons_page();
            this.make_grid();
            else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#graph_li").hasClass("active");
        }
        this.productTransformer = null;
    }
    /**
   * Meetod uuendab wagonConf andmed grid'i
   */ update_wagon_flags() {
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        for(let i = 0; i < (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data.length; i++){
            this.turn_flag_onoff(i, "m", wagonConf.isMootmine(i));
            this.turn_flag_onoff(i, "e", wagonConf.isServaotsing(i));
            this.turn_flag_onoff(i, "fe", wagonConf.isForcedServaotsing(i));
            //turn_flag_enabled_disabled(i, "m", !servaotsingOn);
            //turn_flag_enabled_disabled(i, "r", !servaotsingOn && mootmineOn);
            // this.turn_flag_enabled_disabled(i, "r", mootmineOn);
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#skeleton" + i).text(wagonConf.getRaamiNr(i) + "");
        }
    }
    /**
   * NB! Funktsioonis on "this" vale?
   * @param y
   */ measure_btn(y) {
        //Legacy.debug("measure_btn "+y);
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        if (!this.is_flag_enabled(y, "m")) return;
        let turnOn = !wagonConf.isMootmine(y);
        this.turn_flag_onoff(y, "m", turnOn);
        this.turn_flag_enabled_disabled(y, "r", turnOn);
        wagonConf.setMootmine(y, turnOn);
    }
    /**
   * NB! Funktsioonis on "this" vale?
   * @param y
   */ repeat_btn(y) {
    //Legacy.debug("repeat_btn "+y);
    /*
    if (!wagons.is_flag_enabled(y, "r")) return;
     let turnOn = !wagonConf.isKordusmootmine(y);
    this.turn_flag_onoff(y, "r", turnOn);
    wagonConf.setKordusmootmine(y, turnOn);
    */ }
    edge_btn(y) {
        //Legacy.debug("edge_btn "+y);
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        let turnOn = !wagonConf.isServaotsing(y);
        this.turn_flag_onoff(y, "e", turnOn);
        //turn_flag_enabled_disabled(y, "m", !turnOn);
        //turn_flag_enabled_disabled(y, "r", !turnOn);
        wagonConf.setServaotsing(y, turnOn);
    }
    fedge_btn(y) {
        //Legacy.debug("fedge_btn "+y);
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        let turnOn = !wagonConf.isForcedServaotsing(y);
        this.turn_flag_onoff(y, "fe", turnOn);
        //turn_flag_enabled_disabled(y, "m", !turnOn);
        //turn_flag_enabled_disabled(y, "r", !turnOn);
        wagonConf.setForcedServaotsing(y, turnOn);
    }
    is_flag_enabled(y, flag) {
        let id;
        if (flag == "e") id = "#edge";
        else if (flag == "m") id = "#measure";
        else id = "#repeat";
        id += y;
        if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).prop('disabled')) return false;
        return true;
    }
    turn_flag_onoff(y, flag, on) {
        let id;
        if (flag == "e") id = "#edge";
        else if (flag == "fe") id = "#fedge";
        else if (flag == "m") id = "#measure";
        else id = "#repeat";
        id += y;
        if (on) {
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).removeClass('passive');
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).addClass('active');
        } else {
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).removeClass('active');
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).addClass('passive');
        }
    }
    turn_flag_enabled_disabled(y, flag, enabled) {
        let id;
        if (flag == "e") id = "#edge";
        else if (flag == "m") id = "#measure";
        else id = "#repeat";
        id += y;
        if (enabled) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).prop('disabled', false);
        else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(id).prop('disabled', true);
    }
    /**
   * Vaguni raami numbri muutmine.
   * NB! Funktsioonis on "this" vale!
   */ change_skeleton(w) {
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        // Avame popup-akna numbri muutmiseks:
        (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).ask_input((0, $865532d99f221026$export$2e2bcd8739ae039)("Enter new skeleton number (max 4 characters)"), wagonConf.getRaamiNr(w), function(result) {
            // Kui määramata, siis vajutati cancel:
            if (result == null) return;
            // Salvestame raami numbri serverisse:
            if (result.length > 4) result = result.substring(0, 4);
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#skeleton" + w).text(result);
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).grid_data[w].skeleton = result;
            wagonConf.setRaamiNr(w, result);
        });
    }
    /**
   * Vaguniga seotud toote koodile versiooni valimine
   * NB! Funktsioonis on "this" vale!
   */ change_code(w) {
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        let drow = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow(w);
        let baseCode = drow.codeVariant + "";
        let codeVariant = this.getKoodVariant(w);
        (0, $9af90d56d541a368$export$2e2bcd8739ae039).dialog({
            title: (0, $865532d99f221026$export$2e2bcd8739ae039)("Select code variant"),
            message: '<form> <select name="codeVariant" id="codeVariant"><option>' + codeVariant + '</option></select></form>',
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: "btn-default"
                },
                confirm: {
                    label: "OK",
                    className: "btn-primary",
                    callback: (function() {
                        let newCode = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#codeVariant").val();
                        if (newCode != codeVariant) {
                            wagonConf.setKood(w, newCode);
                            this.setGridKood(w, newCode);
                        }
                    }).bind(this)
                }
            }
        });
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#codeVariant").selectpicker();
        this.getProductVersions(baseCode, function(data) {
            let options = "";
            for(let i = 0; i < data.length; i++){
                let selected = '';
                if (data[i] == codeVariant) selected = ' selected="selected"';
                options += '<option' + selected + '>' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(data[i]) + '</option>\n';
            }
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#codeVariant").html(options);
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#codeVariant").selectpicker('refresh');
        });
    }
    /**
   * Leiab toote versioonide nimekirja
   *
   * @param kood
   *            Toote kood
   * @param callbackFunc
   *            Funktsioon, mis kutsutakse resultaadiga välja
   */ getProductVersions(kood, callbackFunc) {
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/productVersions/" + kood,
            success: function(data) {
                if (data && data.productVersionsResult && callbackFunc) callbackFunc(data.productVersionsResult);
            },
            error: function(a, b, c) {
            // show_err(t("Error saving wagon conf"));
            }
        });
    }
    /**
   * Meetod tagastab näidatud gridi rea kohta sellele määratud toote koodi koos variandi infoga
   */ getKoodVariant(n) {
        let wagonConf = (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance();
        let drow = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow(n);
        if (!drow) return "";
        let codeVariant = (drow.codeVariant == null ? "" : drow.codeVariant) + "";
        if (!codeVariant) return codeVariant;
        // Leiame, kas variant on määratud:
        let wagonCode = wagonConf.getKood(n) + "";
        if (!wagonCode) return codeVariant;
        if ((0, $30071e4d8f83fdfd$export$b396c2481bedae58)(codeVariant) == (0, $30071e4d8f83fdfd$export$b396c2481bedae58)(wagonCode)) return wagonCode;
        return codeVariant;
    }
    setGridKood(n, kood) {
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#code" + n).text(kood);
        if (kood != this.getKoodVariant(n)) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#code" + n).css('color', 'red');
        else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#code" + n).css('color', null);
    }
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "productTransformer", null);
        // @formatter:off
        this.grid_cols = [
            // suurus px,
            // väli,
            // pealkiri,
            // kas esineb lihtsas UIs: 0 või null - mõlemal juhul, 1 - ainult keerukas, 2 - ainult lihtne
            // kas tuleb joonistada vertikaalne eraldusjoon enne antud veergu true/false
            [
                30,
                'wagon',
                'wgn',
                1,
                false
            ],
            [
                60,
                'xskeleton',
                'skeleton',
                1,
                false
            ],
            [
                60,
                'skeleton',
                'skeleton',
                2,
                false
            ],
            [
                50,
                'xcode',
                'code',
                1,
                false
            ],
            [
                50,
                'code',
                'code',
                2,
                false
            ],
            [
                50,
                'description1',
                'product',
                1,
                false
            ],
            [
                -1,
                'description2',
                'description',
                0,
                false
            ],
            [
                40,
                0,
                'P',
                0,
                true
            ],
            [
                40,
                'edge',
                'edg',
                1,
                true
            ],
            [
                40,
                'measure',
                'msr',
                1,
                false
            ],
            [
                60,
                'fedge',
                'fedg',
                1,
                false
            ]
        ];
        // @formatter:on
        /**
     * Base URL for wagons query
     * @type {string}
     */ this.wagon_urlbase = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/wagons/";
        this.min_wagon_urlnr = 1;
        this.wagon_load_count = 0;
        this.edge_btn = this.edge_btn.bind(this);
        this.fedge_btn = this.fedge_btn.bind(this);
    }
}
/**
   * @private
   * @type {?Wagons}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($f9a0e15f8468a3bd$var$Wagons, "wagonsInstance", null);
var $f9a0e15f8468a3bd$export$2e2bcd8739ae039 = $f9a0e15f8468a3bd$var$Wagons;



var $1d42b61e7917058c$exports = {};
$1d42b61e7917058c$exports = JSON.parse("{\"title\":\"JSON schema for KLPMS config file\",\"$schema\":\"https://degeetia.ee/schema/klpms/config\",\"type\":\"object\",\"properties\":{\"conf_type\":{\"type\":\"string\",\"title\":\"Configuration type\",\"description\":\"Configuration type\",\"default\":\"global\",\"enum\":[\"global\",\"estonia\",\"finland\",\"poland\"]},\"debug\":{\"type\":\"boolean\",\"title\":\"Debug mode\",\"description\":\"Debug mode. NB! Turns off automatic wagon info update, click to current time for manual update\",\"default\":false},\"dir_app\":{\"type\":\"string\",\"title\":\"App base directory\",\"description\":\"Base directory for KLPMS Web and Service application components. Automatically assigned by components themselves, values from the configuration files will be overwritten\",\"readOnly\":true},\"dir_base\":{\"type\":\"string\",\"title\":\"KLPMS base directory\",\"description\":\"Base directory for KLPMS, relative to the {dir_app} directory\",\"default\":\"..\"},\"dir_conf\":{\"type\":\"string\",\"title\":\"Base directory for config\",\"description\":\"Base directory for KLPMS configuration files, relative to the {dir_base} directory\",\"default\":\"conf\"},\"dir_data\":{\"type\":\"string\",\"title\":\"Base directory for data\",\"description\":\"Base directory for KLPMS data files, relative to the {dir_base} directory\",\"default\":\"data\"},\"dir_schema\":{\"type\":\"string\",\"title\":\"Schema files directory\",\"description\":\"Schema files directory\",\"default\":\"schema\"},\"dir_products\":{\"type\":\"string\",\"title\":\"Product files directory\",\"description\":\"Product files directory\",\"default\":\"products\"},\"dir_measurements\":{\"type\":\"string\",\"title\":\"Measurement files directory\",\"description\":\"Directory, where to put measurement files\",\"default\":\"measurements\"},\"dir_nominalGraphs\":{\"type\":\"string\",\"title\":\"Nominal graph files directory\",\"description\":\"Directory for storing nominal graph files\",\"default\":\"nominalGraphs\"},\"max_records\":{\"type\":\"integer\",\"title\":\"Max records in archive search\",\"description\":\"Maximum number of records in archive search results\",\"default\":1200},\"user_password\":{\"type\":\"string\",\"title\":\"User password\",\"description\":\"Password for web environment (use username 'user')\",\"default\":\"1234\"},\"password\":{\"type\":\"string\",\"title\":\"Archive password\",\"description\":\"Password for archive page (use username 'archive')\",\"default\":\"1234\"},\"session_file\":{\"type\":\"string\",\"title\":\"Session file\",\"description\":\"Session file location\",\"default\":\"sessions.json\"},\"session_expiry\":{\"type\":\"integer\",\"title\":\"Session expiry time\",\"description\":\"Session expiry time in seconds (default 7 days)\",\"default\":604800},\"conf_wagons\":{\"type\":\"string\",\"title\":\"Wagons config file\",\"description\":\"Wagon configuration file location\",\"default\":\"wagons.json\"},\"conf_settings\":{\"type\":\"string\",\"title\":\"Settings file\",\"description\":\"Settings configuration file location\",\"default\":\"settings.json\"},\"loading_wagon\":{\"type\":\"string\",\"title\":\"Loading wagon file\",\"description\":\"Currently loading wagon file\",\"default\":\"loading.json\"},\"ads_net_id\":{\"type\":\"string\",\"title\":\"ADS network ID\",\"description\":\"ADS network ID of PLC controller. Default is \\\"\\\", i.e. PLC resides on the same machine\",\"default\":\"\"},\"ads_port\":{\"type\":\"integer\",\"title\":\"ADS port\",\"description\":\"ADS port for PLC controller. Default is 851\",\"default\":851},\"plc_cycle_time\":{\"type\":\"integer\",\"title\":\"PLC cycle time\",\"description\":\"PLC cycle time (wait time) in ms used by TwinCAT API for checking PLC variables\",\"default\":100},\"poll_cycle_time\":{\"type\":\"integer\",\"title\":\"Polling cycle time\",\"description\":\"Polling cycle time (wait time) in ms, before checking again PLC flag variable values\",\"default\":100},\"error_log\":{\"type\":\"string\",\"title\":\"PLC error file\",\"description\":\"PLC error log location\",\"default\":\"error.log\"},\"error_log_lines\":{\"type\":\"integer\",\"title\":\"Max PLC error count\",\"description\":\"PLC error log lines\",\"default\":100},\"logfile_web\":{\"type\":\"string\",\"title\":\"Web log file\",\"description\":\"KLPMS Web component log file\",\"default\":\"web.log\"},\"logfile_service\":{\"type\":\"string\",\"title\":\"Service log file\",\"description\":\"KLPMS Service component log file\",\"default\":\"service.log\"},\"log_level\":{\"type\":\"string\",\"title\":\"Log level\",\"description\":\"Logging level for KLPMS Web and Service components\",\"default\":\"info\",\"enum\":[\"trace\",\"debug\",\"info\",\"warn\",\"error\",\"fatal\",\"none\"]},\"csv_number_format\":{\"type\":\"string\",\"title\":\"CSV locale\",\"description\":\"Locale used for CSV number formatting\",\"default\":\"et-EE\"},\"csv_encoding\":{\"type\":\"integer\",\"title\":\"CSV codepage\",\"description\":\"Windows codepage used for CSV file encoding\",\"default\":1257},\"save_raw_measurements\":{\"type\":\"boolean\",\"title\":\"Save raw measurements\",\"description\":\"Save raw measurements into database\",\"default\":true},\"wagon_count\":{\"type\":\"integer\",\"title\":\"Wagons count\",\"description\":\"Wagons count (22/24/30/34), default 34\",\"enum\":[22,24,30,34],\"default\":34},\"wagon_offset_loading\":{\"type\":\"integer\",\"title\":\"Wagon offset loading\",\"description\":\"Offset of the number of the wagon in loading with respect to the active wagon\",\"default\":-3},\"wagon_offset_bending\":{\"type\":\"integer\",\"title\":\"Wagon offset bending\",\"description\":\"Offset of the number of the wagon in bending with respect to the active wagon\",\"default\":14},\"measurement_line_count\":{\"type\":\"integer\",\"title\":\"Measurement lines count\",\"description\":\"Measurement lines count (3/5), default 3\",\"enum\":[3,5],\"default\":3},\"simple_ui\":{\"type\":\"boolean\",\"title\":\"Simple UI\",\"description\":\"Show simplified UI without some fields\",\"default\":false},\"glass_file_type\":{\"type\":\"string\",\"title\":\"Allowed glass file types\",\"description\":\"Allowed glass file types, separated by comma. Supported types: \\\"dat\\\", \\\"ncp\\\"\",\"default\":\"dat,ncp\"},\"no_wagons\":{\"type\":\"boolean\",\"title\":\"No wagons\",\"description\":\"Measurements without wagons\",\"default\":false},\"manual_mode_allowed\":{\"type\":\"boolean\",\"title\":\"Manual mode allowed\",\"description\":\"Manual mode allowed\",\"default\":true},\"mode_file\":{\"type\":\"string\",\"title\":\"Manual mode file\",\"description\":\"Manual mode file name\",\"default\":\"mode.json\"},\"complex_filter\":{\"type\":\"boolean\",\"title\":\"Use alternative filter\",\"description\":\"PLC uses alternative filter parameters\",\"default\":true},\"edge_search_allowed\":{\"type\":\"boolean\",\"title\":\"Edge search allowed\",\"description\":\"Edge search allowed\",\"default\":false},\"slope_factor\":{\"type\":\"number\",\"title\":\"Slope factor\",\"description\":\"Slope factor for calculating slopes\",\"default\":2},\"debug_mode_allowed\":{\"type\":\"boolean\",\"title\":\"Measuring debug mode allowed\",\"description\":\"Debug mode allowed for measuring\",\"default\":false},\"rotated_measurement_allowed\":{\"type\":\"boolean\",\"title\":\"Rotated measurement allowed\",\"description\":\"Rotated measurement allowed\",\"default\":false},\"measurement_points\":{\"type\":\"integer\",\"title\":\"Measurement point count\",\"description\":\"Measurement point count\",\"default\":200},\"raw_measurement_points\":{\"type\":\"integer\",\"title\":\"Raw measurement point count\",\"description\":\"Raw measurement point count\",\"default\":1000},\"center_add_points\":{\"type\":\"integer\",\"title\":\"Additional Px points\",\"description\":\"Use additional Px points in center line (P50, P100, P150, etc)\",\"default\":0},\"hud_points\":{\"type\":\"integer\",\"title\":\"HUD points\",\"description\":\"HUD points\",\"default\":5},\"adas_area_count\":{\"type\":\"integer\",\"title\":\"ADAS area count\",\"description\":\"ADAS area count\",\"default\":6},\"angle_points\":{\"type\":\"integer\",\"title\":\"Angle points\",\"description\":\"Angle points\",\"default\":1},\"yshift_offset\":{\"type\":\"integer\",\"title\":\"Yshift offset\",\"description\":\"Additional offset added to ynihe\",\"default\":763},\"db_connection\":{\"type\":\"string\",\"title\":\"Database connection\",\"description\":\"Database connection string\",\"default\":\"Server=.;Database=klpms;User ID=klpms;Password=klpms\"}},\"order\":[\"conf_type\",\"debug\",\"dir_app\",\"dir_base\",\"dir_conf\",\"dir_data\",\"dir_products\",\"dir_measurements\",\"dir_nominalGraphs\",\"max_records\",\"user_password\",\"password\",\"session_file\",\"session_expiry\",\"conf_wagons\",\"conf_settings\",\"loading_wagon\",\"ads_net_id\",\"ads_port\",\"plc_cycle_time\",\"poll_cycle_time\",\"error_log\",\"error_log_lines\",\"logfile_web\",\"logfile_service\",\"log_level\",\"csv_number_format\",\"csv_encoding\",\"save_raw_measurements\",\"wagon_count\",\"wagon_offset_loading\",\"wagon_offset_bending\",\"measurement_line_count\",\"simple_ui\",\"glass_file_type\",\"no_wagons\",\"manual_mode_allowed\",\"mode_file\",\"complex_filter\",\"edge_search_allowed\",\"slope_factor\",\"debug_mode_allowed\",\"rotated_measurement_allowed\",\"measurement_points\",\"raw_measurement_points\",\"center_add_points\",\"hud_points\",\"adas_area_count\",\"yshift_offset\",\"db_connection\"]}");


var $282049f978a136e5$exports = {};
$282049f978a136e5$exports = JSON.parse("{\"title\":\"JSON schema for KLPMS product\",\"$schema\":\"https://degeetia.ee/schema/klpms/product\",\"type\":\"object\",\"properties\":{\"version\":{\"type\":\"integer\",\"title\":\"Product file version\",\"enum\":[3]},\"lineCount\":{\"type\":\"integer\",\"title\":\"Line count\",\"enum\":[4,5]},\"codeVariant\":{\"type\":\"string\",\"title\":\"Product code and variant\"},\"scanCode\":{\"type\":\"string\",\"title\":\"Product SCAN code\"},\"description\":{\"type\":\"string\",\"title\":\"Product description\"},\"measurementLines\":{\"type\":\"array\",\"title\":\"Measurement lines\",\"items\":{\"minItems\":3,\"maxItems\":5,\"type\":\"object\",\"properties\":{\"lineLength\":{\"type\":\"integer\",\"title\":\"Line length\"},\"endpoints\":{\"type\":\"array\",\"title\":\"Endpoints\",\"items\":{\"minItems\":2,\"maxItems\":2,\"type\":\"object\",\"properties\":{\"x\":{\"type\":\"integer\",\"title\":\"X coordinate\"},\"y\":{\"type\":\"integer\",\"title\":\"Y coordinate\"},\"z\":{\"type\":\"integer\",\"title\":\"Z coordinate\"},\"slopeX\":{\"type\":\"integer\",\"title\":\"Measuring angle in X-axis\"},\"slopeY\":{\"type\":\"integer\",\"title\":\"Measuring angle in Y-axis\"},\"printOffset\":{\"type\":\"integer\",\"title\":\"Print offset from the edge\"}}}},\"nominals\":{\"type\":\"array\",\"title\":\"Nominal points\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"title\":\"Name\",\"enum\":[\"A1\",\"B1\",\"C1\",\"A2\",\"B2\",\"C2\",\"A3\",\"B3\",\"C3\",\"A4\",\"B4\",\"C4\",\"A5\",\"B5\",\"C5\",\"P50\",\"P100\",\"P150\",\"P200\",\"P250\",\"P300\"]},\"value\":{\"type\":\"integer\",\"title\":\"Nominal value\"},\"upperTolerance1\":{\"type\":\"integer\",\"title\":\"Upper tolerance 1\"},\"upperTolerance2\":{\"type\":\"integer\",\"title\":\"Upper tolerance 2\"},\"lowerTolerance1\":{\"type\":\"integer\",\"title\":\"Lower tolerance 1\"},\"lowerTolerance2\":{\"type\":\"integer\",\"title\":\"Lower tolerance 2\"},\"distance\":{\"type\":\"integer\",\"title\":\"Distance from the glass edge\"},\"correction\":{\"type\":\"integer\",\"title\":\"Correction\"},\"isAdas\":{\"type\":\"boolean\",\"title\":\"Is ADAS window point\"},\"show\":{\"type\":\"boolean\",\"title\":\"Show nominal in measurements screen\"}}}},\"angles\":{\"type\":\"array\",\"title\":\"Nominal angles\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"title\":\"Name\",\"enum\":[\"ANGLE\"]},\"value\":{\"type\":\"integer\",\"title\":\"Nominal value\"},\"upperTolerance1\":{\"type\":\"integer\",\"title\":\"Upper tolerance 1\"},\"upperTolerance2\":{\"type\":\"integer\",\"title\":\"Upper tolerance 2\"},\"lowerTolerance1\":{\"type\":\"integer\",\"title\":\"Lower tolerance 1\"},\"lowerTolerance2\":{\"type\":\"integer\",\"title\":\"Lower tolerance 2\"},\"point1\":{\"type\":\"string\",\"title\":\"First point name\",\"enum\":[\"C2\",\"C3\",\"P50\",\"P100\",\"P150\",\"P200\",\"P250\",\"P300\"]},\"point2\":{\"type\":\"string\",\"title\":\"Second point name\",\"enum\":[\"C2\",\"C3\",\"P50\",\"P100\",\"P150\",\"P200\",\"P250\",\"P300\"]}}}}}}},\"glassThickness\":{\"type\":\"integer\",\"title\":\"Glass thickness\"},\"measuringProfileClass\":{\"type\":\"integer\"},\"measuringProfilePrint\":{\"type\":\"integer\"},\"diffX\":{\"type\":\"integer\"},\"diffY\":{\"type\":\"integer\"},\"offsetX\":{\"type\":\"integer\"},\"offsetY\":{\"type\":\"integer\"},\"distance\":{\"type\":\"integer\"},\"offsetE\":{\"type\":\"integer\"},\"lineUpper\":{\"type\":\"array\",\"items\":{\"type\":\"integer\"}},\"lineLower\":{\"type\":\"array\",\"items\":{\"type\":\"integer\"}},\"pX\":{\"type\":\"array\",\"items\":{\"type\":\"integer\"}},\"pY\":{\"type\":\"array\",\"items\":{\"type\":\"integer\"}},\"rotatedLine\":{\"type\":\"boolean\"},\"toleranceMiddle1\":{\"type\":\"integer\"},\"toleranceMiddle2\":{\"type\":\"integer\"},\"toleranceEdge1\":{\"type\":\"integer\"},\"toleranceEdge2\":{\"type\":\"integer\"},\"mirrored\":{\"type\":\"boolean\"},\"rotatedFirst\":{\"type\":\"boolean\"},\"rotatedLast\":{\"type\":\"boolean\"},\"rotated\":{\"type\":\"boolean\"},\"angle\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"title\":\"Name\"},\"value\":{\"type\":\"integer\",\"title\":\"Nominal value\"},\"upperTolerance1\":{\"type\":\"integer\",\"title\":\"Upper tolerance 1\"},\"upperTolerance2\":{\"type\":\"integer\",\"title\":\"Upper tolerance 2\"},\"lowerTolerance1\":{\"type\":\"integer\",\"title\":\"Lower tolerance 1\"},\"lowerTolerance2\":{\"type\":\"integer\",\"title\":\"Lower tolerance 2\"}}},\"adasAreas\":{\"type\":\"array\",\"title\":\"ADASA Area definitions\",\"items\":{\"type\":\"object\",\"properties\":{\"distance\":{\"type\":\"integer\",\"title\":\"ADAS area definition distnce from the edge of glass (mm, scaled 10x)\"},\"type\":{\"type\":\"integer\",\"title\":\"ADAS area definition type (0=Glass, 1=Print, 2=Raster (for future use), 3=Heatwire (for future use))\",\"enum\":[0,1,2,3]}}}}}}");


var $e22fbc9b3947aac2$exports = {};
$e22fbc9b3947aac2$exports = JSON.parse("{\"title\":\"JSON schema for KLPMS settings\",\"$schema\":\"https://degeetia.ee/schema/klpms/settings\",\"type\":\"object\",\"properties\":{\"lang\":{\"type\":\"string\"},\"toleranceCompensation\":{\"type\":\"boolean\"},\"nominalGraph\":{\"type\":\"boolean\"},\"filter\":{\"type\":\"boolean\",\"title\":\"Use filter 1\"},\"filterRepeatCount\":{\"type\":\"integer\",\"title\":\"Filter 1 window width\",\"minimum\":5,\"maximum\":20},\"filterCoef\":{\"type\":\"number\",\"title\":\"Filter 1 maximum error (scaled 100x)\",\"minimum\":20,\"maximum\":200},\"filterMaxError\":{\"type\":\"integer\",\"title\":\"Filter 1 ignored edge\",\"minimum\":1,\"maximum\":20},\"filter2\":{\"type\":\"boolean\",\"title\":\"Use filter 2\"},\"filter2RepeatCount\":{\"type\":\"integer\",\"title\":\"Filter 2 window width\",\"minimum\":5,\"maximum\":20},\"filter2Coef\":{\"type\":\"number\",\"title\":\"Filter 2 maximum error (scaled 100x)\",\"minimum\":20,\"maximum\":200},\"filter2MaxError\":{\"type\":\"integer\",\"title\":\"Filter 2 ignored edge\",\"minimum\":1,\"maximum\":20},\"ncpRotated\":{\"type\":\"boolean\"},\"mode\":{\"type\":\"integer\",\"enum\":[0,1],\"enumNames\":[\"automatic\",\"manual\"]},\"edgeSearch\":{\"type\":\"boolean\"},\"debugModeMeasuring\":{\"type\":\"boolean\"},\"showOnlyCenterPoints\":{\"type\":\"boolean\"},\"isGlobalCompensation\":{\"type\":\"boolean\",\"title\":\"Is global compensation activated\"},\"globalCompensation\":{\"type\":\"array\",\"title\":\"Global compensation for each line\",\"maxItems\":5,\"items\":{\"type\":\"number\",\"title\":\"Global compensation (mm, scaled 10x)\",\"minimum\":-10,\"maximum\":10}}}}");


class $f82be28e3e6281b5$var$SchemaFactory {
    /**
   *
   * @returns {SchemaFactory}
   */ static getInstance() {
        if ($f82be28e3e6281b5$var$SchemaFactory.schemaFactoryInstance == null) $f82be28e3e6281b5$var$SchemaFactory.schemaFactoryInstance = new $f82be28e3e6281b5$var$SchemaFactory();
        return $f82be28e3e6281b5$var$SchemaFactory.schemaFactoryInstance;
    }
    addSchema(schemaName, schema) {
        this.schemas[schemaName] = schema;
    }
    getSchema(schemaName) {
        return this.schemas[schemaName];
    }
    constructor(){
        this.schemas = {
            config: (0, (/*@__PURE__*/$parcel$interopDefault($1d42b61e7917058c$exports))),
            product: (0, (/*@__PURE__*/$parcel$interopDefault($282049f978a136e5$exports))),
            settings: (0, (/*@__PURE__*/$parcel$interopDefault($e22fbc9b3947aac2$exports)))
        };
    }
}
/**
   * @type {?SchemaFactory}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($f82be28e3e6281b5$var$SchemaFactory, "schemaFactoryInstance", null);
var $f82be28e3e6281b5$export$2e2bcd8739ae039 = $f82be28e3e6281b5$var$SchemaFactory;


var $7df676ca66572aa8$export$9eeb22c0bba4ed5e;
var $7df676ca66572aa8$export$b0184c04dbb75cbd;
var $7df676ca66572aa8$export$2191b9da168c6cf0;
var $7df676ca66572aa8$export$44dde8d2b17fc96a;
var $7df676ca66572aa8$export$fa2f6d6458e494ac;
var $7df676ca66572aa8$export$c87d910e63d22ed6;
var $7df676ca66572aa8$export$a22775fa5e2eebd9;
'use strict';

var $7df676ca66572aa8$var$Validator = $7df676ca66572aa8$export$9eeb22c0bba4ed5e = (parcelRequire("bS2zd"));

$7df676ca66572aa8$export$b0184c04dbb75cbd = (parcelRequire("fcCXC")).ValidatorResult;

$7df676ca66572aa8$export$2191b9da168c6cf0 = (parcelRequire("fcCXC")).ValidationError;

$7df676ca66572aa8$export$44dde8d2b17fc96a = (parcelRequire("fcCXC")).SchemaError;

$7df676ca66572aa8$export$fa2f6d6458e494ac = (parcelRequire("6Zyia")).SchemaScanResult;

$7df676ca66572aa8$export$c87d910e63d22ed6 = (parcelRequire("6Zyia")).scan;
$7df676ca66572aa8$export$a22775fa5e2eebd9 = function(instance, schema, options) {
    var v = new $7df676ca66572aa8$var$Validator();
    return v.validate(instance, schema, options);
};


class $ded17bccfc06d62f$var$SchemaValidator {
    /**
   *
   * @param {object} instance
   * @returns {boolean}
   */ validate(instance) {
        this.result = this.validator.validate(instance, this.schema);
        return this.result.valid;
    }
    /**
   *
   * @returns {boolean}
   */ isValid() {
        return this.result.valid;
    }
    /**
   *
   * @returns {ValidationError[]}
   */ errors() {
        return this.result.errors;
    }
    /**
   *
   * @param {object} schema
   */ constructor(schema){
        this.schema = schema;
        /**
     * @type {Validator}
     */ this.validator = new (0, $7df676ca66572aa8$export$9eeb22c0bba4ed5e)();
        /**
     * @type {ValidatorResult}
     */ this.result = null;
    }
}
var $ded17bccfc06d62f$export$2e2bcd8739ae039 = $ded17bccfc06d62f$var$SchemaValidator;



class $6b994e94efab8cbe$var$SchemaActions {
    changeValue(field, value) {
        return {
            field: field,
            value: value
        };
    }
    /**
   * Algatatakse schema laadimine serverist
   */ fetchSchema(schema) {
        return schema;
    }
    /**
   * Schema laadimine ebaõnnestus
   */ fetchSchemaFailed(error) {
        return error;
    }
    /**
   * Schema sai laetud
   */ fetchSchemaDone(data) {
        return data;
    }
}
var $6b994e94efab8cbe$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($6b994e94efab8cbe$var$SchemaActions);








let $fb6d22c0bcd9a886$var$SchemaSource = {
    fetchSchema (schema) {
        return {
            remote (state, schema) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).getSchema(schema);
            },
            local () {
                return null;
            },
            success: (0, $6b994e94efab8cbe$export$2e2bcd8739ae039).fetchSchemaDone,
            error: (0, $6b994e94efab8cbe$export$2e2bcd8739ae039).fetchSchemaFailed
        };
    }
};
var $fb6d22c0bcd9a886$export$2e2bcd8739ae039 = $fb6d22c0bcd9a886$var$SchemaSource;




/**
 * Konfiguratsiooni haldamise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */ class $ff339c2931a3cc1b$var$SchemaStore {
    /**
   * Toote laadimise käivitamine
   */ onFetchSchema(schema) {
        if (this.state.schemas[schema] != null) return;
        this.setState({
            state: "PROCESSING",
            loadingSchema: schema
        });
        let p = this.getInstance().fetchSchema(schema);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote laadimine ebaõnnestus
   */ onFetchConfigFailed(error) {
        this.processError(error);
    }
    processError(error) {
        let message = (0, $865532d99f221026$export$2e2bcd8739ae039)('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) message = error.response.data.error.message;
            else {
                error.response.status;
                message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            }
            error.response.status;
            this.setState({
                state: "FAIL",
                loadingSchema: error.schema
            });
        } else this.setState({
            state: "FAIL",
            loadingSchema: error.schema
        });
        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(message);
    }
    onFetchSchemaDone(response) {
        try {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).has(response.data, '$schema')) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            let newSchemas = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(this.state.schemas);
            newSchemas[response.schema] = response.data;
            this.setState({
                schemas: newSchemas,
                state: "OK",
                loadingSchema: response.schema
            });
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Server error"));
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
            this.setState({
                state: "FAIL",
                loadingSchema: response.schema
            });
        }
    }
    constructor(){
        this.state = {
            schemas: {},
            state: "OK",
            loadingSchema: null
        };
        this.bindActions((0, $6b994e94efab8cbe$export$2e2bcd8739ae039));
        this.exportAsync((0, $fb6d22c0bcd9a886$export$2e2bcd8739ae039));
    }
}
var $ff339c2931a3cc1b$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($ff339c2931a3cc1b$var$SchemaStore, 'SchemaStore');





/**
 * Seadete objekt.
 * Seaded on kasutaja poolt seadete lehel väärtustatavad parameetrid, mida hoitakse serveris meeles.
 *
 */ class $0c8a072ce56f6e2d$var$Settings {
    /**
   * @returns {Settings}
   */ static getInstance() {
        if ($0c8a072ce56f6e2d$var$Settings.settingsInstance == null) $0c8a072ce56f6e2d$var$Settings.settingsInstance = new $0c8a072ce56f6e2d$var$Settings();
        return $0c8a072ce56f6e2d$var$Settings.settingsInstance;
    }
    onSchemaChanged(status) {
        if (status.schemas.settings != null) this.schema = status.schemas.settings;
    }
    getCompactedValues() {
        // Skip fields with null value and skip configuration items (they are read-only)
        let allValues = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).omit(this.values, function(v, k) {
            return v == null || (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNumber(v) && isNaN(v) || v === "" || k.startsWith("conf_");
        });
        if (allValues.globalCompensation != null) {
            allValues.globalCompensation = [
                ...allValues.globalCompensation
            ];
            let nonZero = false;
            for (let v of allValues.globalCompensation)if (v != null && v != 0) nonZero = true;
            if (!nonZero) delete allValues.globalCompensation;
        }
        return allValues;
    }
    getLang() {
        return (0, $30071e4d8f83fdfd$export$590567be997858b6)(this.values.lang, "en");
    }
    /**
   * Kas serveri konfiguratsioon on debug režiimis
   * @returns {boolean}
   */ isDebug() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_debug);
    }
    /**
   * Süsteemis kasutusel olevate vagunite arv
   * @returns {number}
   */ getWagonCount() {
        let count = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_wagon_count);
        return count == 0 ? 34 : count;
    }
    /**
   * Laadimises oleva vaguni numbri offset jooksva vaguni suhtes
   * @returns {number}
   */ getWagonOffsetLoading() {
        let count = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_wagon_offset_loading);
        return count == 0 ? 0 : count;
    }
    /**
   * Painutuses oleva vaguni numbri offset jooksva vaguni suhtes
   * @returns {number}
   */ getWagonOffsetBending() {
        let count = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_wagon_offset_bending);
        return count == 0 ? 0 : count;
    }
    /**
   *
   * @returns {boolean}
   */ isNoWagons() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_no_wagons);
    }
    /**
   *
   * @returns {number}
   */ getMeasurementLineCount() {
        let count = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_measurement_line_count);
        if (count == 0) return 3;
        return count;
    }
    /**
   *
   * @returns {number}
   */ getMeasurementPoints() {
        let count = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_measurement_points);
        if (count == 0) return 200;
        return count;
    }
    /**
   *
   * @returns {number}
   */ getRawMeasurementPoints() {
        let count = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_raw_measurement_points);
        if (count == 0) return 1000;
        return count;
    }
    /**
   * Arhiivi poolt tagastatavate kirjete maks arv
   * @returns {number}
   */ getMaxRecords() {
        let count = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_max_records);
        if (count == 0) return 100;
        return count;
    }
    /**
   * Kas tegemist on lihtsustatud kasutajaliidesega
   * @returns {boolean}
   */ isSimpleUi() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_simple_ui);
    }
    /**
   *
   * @returns {boolean}
   */ isManualModeAllowed() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_manual_mode_allowed, true);
    }
    /**
   *
   * @returns {boolean}
   */ isDebugModeAllowed() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_debug_mode_allowed);
    }
    /**
   *
   * @returns {boolean}
   */ isRotatedMeasurementAllowed() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_rotated_measurement_allowed);
    }
    /**
   *
   * @returns {boolean}
   */ isEdgeSearchAllowed() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_edge_search_allowed);
    }
    /**
   *
   * @returns {number}
   */ getSlopeFactor() {
        let factor = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_slope_factor, 0.0);
        if (factor == 0.0) return 2.0;
        return factor;
    }
    /**
   *
   * @returns {number}
   */ getCenterAddPoints() {
        let points = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_center_add_points);
        if (points < 0) points = 0;
        return points;
    }
    /**
   *
   * @returns {number}
   */ getHudPoints() {
        let points = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_hud_points);
        if (points < 0) points = 0;
        return points;
    }
    /**
   * ADAS alade arv
   * @returns {IntegerType}
   */ getAdasAreasCount() {
        let areas = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_adas_area_count);
        return areas < 0 ? 0 : areas;
    }
    /**
   *
   * @returns {number}
   */ getYshiftOffset() {
        let i = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.conf_yshift_offset);
        // Vt ynihe
        if (i == null) i = 763;
        return i;
    }
    /**
   * Kas tuleb kuvada seadetes alternatiivne filtrite loogika
   *
   * @returns {boolean}
   */ isComplexFilter() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.conf_complex_filter, true);
    }
    /**
   * Tagstab true, kui ollakse manuaalrežiimis
   * @returns {boolean}
   */ isManualMode() {
        return this.getMode() == 1;
    }
    /**
   *
   * @returns {boolean}
   */ isManualMeasuringRequested() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.manualMeasuringRequested);
    }
    /**
   *
   * @returns {string}
   */ getManualMeasuringTooteKood() {
        return (0, $30071e4d8f83fdfd$export$590567be997858b6)(this.values.manualMeasuringTooteKood, "");
    }
    /**
   *
   * @param kood
   */ setManualMeasuringTooteKood(kood) {
        this.values.manualMeasuringTooteKood = kood;
    }
    /**
   *
   * @returns {boolean}
   */ isMeasuringInProgress() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.measuringInProgress);
    }
    /**
   *
   * @returns {boolean}
   */ isToleranceCompensation() {
        if (this.isSimpleUi()) return false;
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.toleranceCompensation);
    }
    /**
   *
   * @returns {boolean}
   */ isNcpRotated() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.ncpRotated);
    }
    /**
   *
   * @returns {boolean}
   */ isEdgeSearch() {
        if (!this.isEdgeSearchAllowed()) return false;
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.edgeSearch);
    }
    /**
   *
   * @returns {boolean}
   */ isDebugModeMeasuring() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.debugModeMeasuring);
    }
    /**
   *
   * @returns {boolean}
   */ showOnlyCenterPoints() {
        if (this.isSimpleUi()) return false;
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.showOnlyCenterPoints);
    }
    /**
   *
   * @returns {number}
   */ getMode() {
        return (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.mode);
    }
    /**
   *
   * @param {number} mode
   */ setMode(mode) {
        this.values.mode = mode;
        this.save_settings();
    }
    getNominalGraph() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.nominalGraph);
    }
    /**
   *
   * @returns {string}
   */ getGlassFileType() {
        return (0, $30071e4d8f83fdfd$export$590567be997858b6)(this.values.conf_glass_file_type, "dat,ncp");
    }
    isGlobalCompensation() {
        return (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.isGlobalCompensation);
    }
    setIsGlobalCompensation(isGlobalCompensation) {
        this.values.isGlobalCompensation = isGlobalCompensation;
    }
    getGlobalCompensation(lineNo) {
        let c = this.values.globalCompensation;
        return c == null || c.length < lineNo ? 0 : c[lineNo];
    }
    setGlobalCompensation(lineNo, value) {
        if (this.values.globalCompensation == null) this.values.globalCompensation = [];
        this.values.globalCompensation[lineNo] = value;
    }
    setLang(lang) {
        this.values.lang = lang;
    }
    /**
   * Settings lehe aktiveerimine ja kuvamine
   */ make_settings_page() {
        (0, $03277cb1bca63048$export$c31045a889981f00)();
        (0, $03277cb1bca63048$export$b0c1cba25cb0c370)();
        let s = '<form onsubmit="return false;" class="form-horizontal" style="padding-left: 10px;">';
        s += '<div id="errors"></div>';
        s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
        s += '<input type="checkbox" id="nominalGraph"> ';
        s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Show nominal graph")) + '</label></div></div></div>\n';
        if (!this.isSimpleUi()) {
            s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
            s += '<input type="checkbox" id="showOnlyCenterPoints"> ';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Show only center points")) + '</label></div></div></div>\n';
            s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
            s += '<input type="checkbox" id="toleranceCompensation"> ';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Tolerance compensation")) + '</label></div></div></div>\n';
        }
        if (this.isComplexFilter()) {
            s += '<div class="panel panel-default"><div class="panel-body">'; // Panel start
            s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
            s += '<input type="checkbox" id="filter">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Use filter 1")) + '</label></div></div></div>\n';
            s += '<div class="form-group"><label for="filterRepeatCount" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter 1 windows width")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filterRepeatCount" min="5" max="20"> ';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filterRepeatCount)) + ')';
            s += '</div></div>';
            s += '<div class="form-group"><label for="filterCoef" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter 1 maximum error")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filterCoef" min="0.2" max="2.0">';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filterCoef, 100, 1)) + ')';
            s += '</div></div>';
            s += '<div class="form-group"><label for="filterMaxError" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter 1 ignored edge")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filterMaxError" min="1" max="20">';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filterMaxError)) + ')';
            s += '</div></div>';
            s += '</div></div>'; // Panel end
            s += '<div class="panel panel-default"><div class="panel-body">'; // Panel start
            s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
            s += '<input type="checkbox" id="filter2">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Use filter 2")) + '</label></div></div></div>\n';
            s += '<div class="form-group"><label for="filter2RepeatCount" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter 2 windows width")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filter2RepeatCount" min="5" max="20"> ';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filter2RepeatCount))) + ')';
            s += '</div></div>';
            s += '<div class="form-group"><label for="filter2Coef" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter 2 maximum error")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filter2Coef" min="0.2" max="2.0">';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filter2Coef, 100, 1)) + ')';
            s += '</div></div>';
            s += '<div class="form-group"><label for="filter2MaxError" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter 2 ignored edge")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filter2MaxError" min="1" max="20">';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filter2MaxError)) + ')';
            s += '</div></div>';
            s += '</div></div>'; // Panel end
        } else {
            s += '<div class="panel panel-default"><div class="panel-body">'; // Panel start
            s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
            s += '<input type="checkbox" id="filter">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Use filter")) + '</label></div></div></div>\n';
            s += '<div class="form-group"><label for="filterRepeatCount" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter repeat count")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filterRepeatCount" min="1" max="5"> ';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filterRepeatCount)) + ')';
            s += '</div></div>';
            s += '<div class="form-group"><label for="filterCoef" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter coefficient")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filterCoef" min="0" max="300">';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filterCoef, 100)) + ')';
            s += '</div></div>';
            s += '<div class="form-group"><label for="filterMaxError" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Filter max permissible number of deviations")) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="filterMaxError" min="0" max="200">';
            s += '(' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.filterMaxError)) + ')';
            s += '</div></div>';
            s += '</div></div>'; // Panel end
        }
        s += '<div class="panel panel-default"><div class="panel-body">'; // Panel start
        s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
        s += '<input type="checkbox" id="isGlobalCompensation">';
        s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Use global glass thickness compensation")) + '</label></div></div></div>\n';
        for(let line = 0; line < this.getMeasurementLineCount(); line++){
            s += '<div class="form-group"><label for="globalCompensation[' + line + ']" class="col-xs-2 control-label">';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Compensation for line") + " " + (line + 1)) + '</label>';
            s += '<div class="col-xs-4"><input type="number" class="form-control" id="globalCompensation_' + line + '"> ';
            s += '(mm, ' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)(this.getSchemaRestriction(this.schema.properties.globalCompensation.items, 10, 1)) + ')';
            s += '</div></div>';
        }
        s += '</div></div>'; // Panel end
        s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
        s += '<input type="checkbox" id="ncpRotated"> ';
        s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("NCP file is rotated")) + '</label></div></div></div>\n';
        if (this.isManualModeAllowed()) {
            s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
            s += '<input type="checkbox" id="mode"> ';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Manual measuring mode")) + '</label></div></div></div>\n';
            if (this.isEdgeSearchAllowed()) {
                s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
                s += '<input type="checkbox" id="edgeSearch"> ';
                s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Edge search")) + '</label></div></div></div>\n';
            }
        }
        if (this.isDebugModeAllowed()) {
            s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><div class="checkbox"><label>';
            s += '<input type="checkbox" id="debugModeMeasuring"> ';
            s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Debug mode for measuring")) + '</label></div></div></div>\n';
        }
        s += '<div class="form-group"><div class="col-xs-offset-2 col-xs-4"><button type="button" class="btn btn-primary" onclick="settings.save_settings_form()">';
        s += (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)('Save'));
        s += '</button></div></div>';
        s += "</form><br>";
        s += '<p class="bg-success" id="success">' + (0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)('Settings saved')) + '</p>';
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#topy").css("height", "50px");
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#content").html(s);
        this.load_settings_form();
        (0, $30071e4d8f83fdfd$export$3c47130985814430)("settings");
    }
    getSchemaRestriction(schema, koef = null, decimals = null) {
        if (schema.minimum != null && schema.maximum != null) return (0, $865532d99f221026$export$2e2bcd8739ae039)("between") + " " + this.formatNumber(koef ? schema.minimum / koef : schema.minimum, decimals) + ".." + this.formatNumber(koef ? schema.maximum / koef : schema.maximum, decimals);
        if (schema.minimum != null) return (0, $865532d99f221026$export$2e2bcd8739ae039)("over") + " " + this.formatNumber(koef ? schema.minimum / koef : schema.minimum, decimals);
        if (schema.maximum != null) return (0, $865532d99f221026$export$2e2bcd8739ae039)("below") + " " + this.formatNumber(koef ? schema.minimum / koef : schema.minimum, decimals);
        return "";
    }
    formatNumber(value, decimals) {
        if (decimals == null) return value.toString();
        let strvalue = value.toFixed(decimals);
        let sep = (0, $865532d99f221026$export$fb8a20568f22b931)();
        return strvalue.replace(".", sep);
    }
    /**
   * Seadete hashi baasilt seadete vormi väätustamine. Eeldab, et seadete vorm on ekraanil.
   *
   * Arvestama peab, et teatud seaded on meil sisemiselt skaleeritud üles:
   *    * filterCoef - 100x
   *    * filter2Coef - 100x
   *    * globalCompensation - 10x
   */ load_settings_form() {
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#nominalGraph').attr('checked', this.getNominalGraph());
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#showOnlyCenterPoints').attr('checked', this.showOnlyCenterPoints());
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#toleranceCompensation').attr('checked', (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.toleranceCompensation));
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter').attr('checked', (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.filter));
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filterRepeatCount').val((0, $30071e4d8f83fdfd$export$590567be997858b6)(this.values.filterRepeatCount));
        let v = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.filterCoef, null);
        if (v != null) v /= 100;
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filterCoef').val((0, $30071e4d8f83fdfd$export$590567be997858b6)(v));
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filterMaxError').val((0, $30071e4d8f83fdfd$export$590567be997858b6)(this.values.filterMaxError));
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2').attr('checked', (0, $30071e4d8f83fdfd$export$ffde277b1072591c)(this.values.filter2));
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2RepeatCount').val((0, $30071e4d8f83fdfd$export$590567be997858b6)(this.values.filter2RepeatCount));
        v = (0, $30071e4d8f83fdfd$export$37576b9ba69b50db)(this.values.filter2Coef, null);
        if (v != null) v /= 100;
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2Coef').val((0, $30071e4d8f83fdfd$export$590567be997858b6)(v));
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2MaxError').val((0, $30071e4d8f83fdfd$export$590567be997858b6)(this.values.filter2MaxError));
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#isGlobalCompensation').attr('checked', this.isGlobalCompensation());
        for(let line = 0; line < this.getMeasurementLineCount(); line++)(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#globalCompensation_' + line).val(this.getGlobalCompensation(line) / 10);
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#ncpRotated').attr('checked', this.isNcpRotated());
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#debugModeMeasuring').attr('checked', this.isDebugModeMeasuring());
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#mode').attr('checked', this.getMode() == 1);
        if (this.getMode() == 1) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#edgeSearch').attr('checked', this.isEdgeSearch());
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#success').hide();
    }
    /**
   * Seadete vormi sisu kandmine seadete hashi ning seadete salvestamine. Salvestamise õnnestumisel kuvatakse vastav teade.
   */ save_settings_form() {
        this.values.nominalGraph = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#nominalGraph').is(':checked');
        this.values.showOnlyCenterPoints = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#showOnlyCenterPoints').is(':checked');
        let oldToleranceCompensation = this.values.toleranceCompensation;
        this.values.toleranceCompensation = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#toleranceCompensation').is(':checked');
        this.values.filter = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter').is(':checked');
        this.values.filterRepeatCount = (0, $30071e4d8f83fdfd$export$c47d79b712795940)((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filterRepeatCount').val());
        let v = (0, $30071e4d8f83fdfd$export$9cf8f5ff7b34d6ff)((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filterCoef').val());
        if (v != null) v = Math.round(v * 100);
        this.values.filterCoef = v;
        this.values.filterMaxError = (0, $30071e4d8f83fdfd$export$c47d79b712795940)((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filterMaxError').val());
        this.values.filter2 = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2').is(':checked');
        this.values.filter2RepeatCount = (0, $30071e4d8f83fdfd$export$c47d79b712795940)((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2RepeatCount').val());
        v = (0, $30071e4d8f83fdfd$export$9cf8f5ff7b34d6ff)((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2Coef').val());
        if (v != null) v = Math.round(v * 100);
        this.values.filter2Coef = v;
        this.values.filter2MaxError = (0, $30071e4d8f83fdfd$export$c47d79b712795940)((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#filter2MaxError').val());
        this.setIsGlobalCompensation(!!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#isGlobalCompensation').is(':checked'));
        for(let line = 0; line < this.getMeasurementLineCount(); line++){
            let v = (0, $30071e4d8f83fdfd$export$9cf8f5ff7b34d6ff)((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#globalCompensation_' + line).val());
            if (v != null) v = Math.round(v * 10);
            else v = 0;
            this.setGlobalCompensation(line, v);
        }
        this.values.ncpRotated = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#ncpRotated').is(':checked');
        this.values.mode = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#mode').is(':checked') ? 1 : 0;
        this.values.edgeSearch = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#edgeSearch').is(':checked');
        this.values.debugModeMeasuring = !!(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#debugModeMeasuring').is(':checked');
        if (this.values.toleranceCompensation != oldToleranceCompensation) (0, $03277cb1bca63048$export$5711a0d2f3413f29)();
        if (this.validateSettings()) this.save_settings();
        else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#success').hide();
    }
    /**
   *
   * @param {?function} callback
   */ load_settings(callback, errorCallback) {
        let wurl = this.settings_get_url;
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("loading settings " + wurl);
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: wurl,
            success: (function(data) {
                this.settingscall(data);
                if (Object.keys(this.schema).length === 0) (0, $6b994e94efab8cbe$export$2e2bcd8739ae039).fetchSchema("settings");
                if (callback) callback();
            }).bind(this),
            error: function() {
                if (errorCallback) errorCallback();
            }
        });
    }
    save_settings() {
        let u = this.settings_save_url;
        let r = {
            data: this.getCompactedValues()
        };
        let s = JSON.stringify(r);
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("Settings data: " + s);
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "POST",
            url: u,
            data: r,
            success: (function() {
                this.save_settings_success();
            }).bind(this)
        });
        return false;
    }
    save_settings_success() {
        this.load_settings();
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#success').show();
    }
    validateSettings() {
        // Internally the following fields are scaled up:
        // filterCoef - 100x
        // filter2Coef - 100x
        // globalCompensation[i] - 10x
        let allSettings = this.getCompactedValues();
        let validator = new (0, $ded17bccfc06d62f$export$2e2bcd8739ae039)(this.schema);
        if (!validator.validate(allSettings)) // Errors, do not save:
        this.errors = validator.errors();
        else this.errors = [];
        this.showErrors();
        return this.errors.length == 0;
    }
    showErrors() {
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#errors").empty();
        if (this.errors && this.errors.length > 0) {
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#errors").append(`<div class="row"><div class="col-md-12 text-danger">${(0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $865532d99f221026$export$2e2bcd8739ae039)("Some fields contain invalid values"))}:</div></div>`);
            for (let e of this.errors)(0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#errors").append(`<div class="row"><div class="col-md-11 col-md-offset-1 text-danger">${(0, $30071e4d8f83fdfd$export$acafce1f52201e8f)("'" + e.schema.title + "' " + e.message)}</div></div>`);
        }
    }
    /**
   *
   * @param {object} data
   */ settingscall(data) {
        if (data == null) return;
        let r = data.settingsResult;
        if (r == null) return;
        // If no changes, then return:
        if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isMatch(this.values, r)) return;
        // Nullime vanad seadingud:
        let oldValues = this.values;
        this.values = r;
        // TODO: Testida, et miks tolernaceCompensation settingute lugemisel vaikimisi sisse lülitatakse
        //this.set('toleranceCompensation', true);
        if (oldValues.toleranceCompensation != this.values.toleranceCompensation) (0, $03277cb1bca63048$export$5711a0d2f3413f29)();
        if (this.isManualMode()) {
            // TODO: Get rid of calling Wagons from Settings!
            let wagons = (0, $f9a0e15f8468a3bd$export$2e2bcd8739ae039).getInstance();
            wagons.make_manual_mode_bar();
            wagons.restore_manual_mode_bar();
            wagons.init_manual_mode_bar();
        }
        // Et GrobotSettings store saaks uuemad seadingud
        (0, $b1b3b27ecff41190$export$2e2bcd8739ae039).settingsUpdated(this.values);
    }
    get_manual_measuring() {
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: 'GET',
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + '/manualMeasuring',
            success: (function(data) {
                let r = data.manualMeasuringResult;
                this.values.mode = r.mode;
                // TODO: Get rid of calling Wagons from Settings!
                let wagons = (0, $f9a0e15f8468a3bd$export$2e2bcd8739ae039).getInstance();
                if (r.measuringRequested > 0 || r.measuringInProgress > 0) wagons.measuring_started(r.tooteKood);
                else wagons.measuring_finished();
            }).bind(this)
        });
    }
    reset_horn() {
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: 'POST',
            url: (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + '/hornReset',
            data: {
                reset: true
            },
            success: function() {
            // Nothing to do
            }
        });
    }
    constructor(){
        this.settings_get_url = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/settings";
        this.settings_save_url = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/settings";
        this.values = {
            'toleranceCompensation': true
        };
        this.errors = [];
        let schemaFactory = (0, $f82be28e3e6281b5$export$2e2bcd8739ae039).getInstance();
        this.schema = schemaFactory.getSchema("settings");
        this.onSchemaChanged = this.onSchemaChanged.bind(this);
        (0, $ff339c2931a3cc1b$export$2e2bcd8739ae039).listen(this.onSchemaChanged);
    }
}
/**
   * @type {?Settings}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($0c8a072ce56f6e2d$var$Settings, "settingsInstance", null);
var $0c8a072ce56f6e2d$export$2e2bcd8739ae039 = $0c8a072ce56f6e2d$var$Settings;





/**
 * Nurga tolerantsid
 */ /**
 * Tooteinfo struktuur
 */ /**
 * Tooteinfo klass
 */ class $a96c27223eb4a3af$var$ProductInfo extends (0, $540451a9382377f9$export$2e2bcd8739ae039) {
    /**
   * Initsialiseerib algoleku
   */ initState(state) {
        if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isObject(state)) this.extend(state);
        if (this.lineCount == null) this.lineCount = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_LINE_COUNT;
        if (this.hudPoints == null) this.hudPoints = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_HUD_POINTS;
        if (this.addPoints == null) this.addPoints = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_ADD_POINTS;
        if (this.adasAreasCount == null) this.adasAreasCount = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_ADAS_AREAS;
        if (this.angleCount == null) this.angleCount = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).ANGLE_COUNT;
        let productTransformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)(this);
        if (this.xnihe == null) this.xnihe = 0;
        if (this.ynihe == null) this.ynihe = 0;
        if (this.distants == null) this.distants = 0;
        if (this.valitud_e == null) this.valitud_e = 0;
        if (this.valitud_p == null) this.valitud_p = 0;
        if (this.valitud_hud == null) this.valitud_hud = 0;
        if (this.klaasiPaksus == null) this.klaasiPaksus = 0;
        if (this.profiilKlaasil == null) this.profiilKlaasil = 0;
        if (this.profiilTrykil == null) this.profiilTrykil = 0;
        if (this.keeratud == null) this.keeratud = false;
        if (this.peegeldatud == null) this.peegeldatud = false;
        if (this.keeratud_esimene == null) this.keeratud_esimene = false;
        if (this.keeratud_viimane == null) this.keeratud_viimane = false;
        if (this.angle == null) this.angle = {};
        if (this.tolerants1k == null) this.tolerants1k = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[0]; // Keskmise punkti (P2, P5, P8) vaikimisi tolerants 1
        if (this.tolerants2k == null) this.tolerants2k = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[1]; // Keskmise punkti (P2, P5, P8) vaikimisi tolerants 2
        if (this.tolerants1s == null) this.tolerants1s = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[2]; // Otspunkti (P1, P3, P4, P6, P7, P9) vaikimisi tolerants 1
        if (this.tolerants2s == null) this.tolerants2s = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[3]; // Otspunkti (P1, P3, P4, P6, P7, P9) vaikimisi tolerants 2
        if (this.tolerants1l == null) this.tolerants1l = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[4]; // Lisapunkti (P50, P100, ...) vaikimisi tolerants 1
        if (this.tolerants2l == null) this.tolerants2l = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[5]; // Lisapunkti (P50, P100, ...) vaikimisi tolerants 2
        if (this.tolerants1h == null) this.tolerants1h = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[6]; // HUD punkti (H1, ...) vaikimisi tolerants 1
        if (this.tolerants2h == null) this.tolerants2h = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).DEFAULT_TOLERANCES[7]; // HUD punkti (H1, ...) vaikimisi tolerants 2
        for(let i = 0; i < this.lineCount * 3 + this.addPoints; i++){
            if (this.pNominaal.length <= i) this.pNominaal[i] = 10;
            if (this.pKorrektsioon.length <= i) this.pKorrektsioon[i] = 0;
            if (i < this.lineCount * 3) {
                if (i % 3 == 1) {
                    // Keskmised punktid
                    if (this.pYlemineTolerants1.length <= i) this.pYlemineTolerants1[i] = this.tolerants1k;
                    if (this.pAlumineTolerants1.length <= i) this.pAlumineTolerants1[i] = this.tolerants1k;
                    if (this.pYlemineTolerants2.length <= i) this.pYlemineTolerants2[i] = this.tolerants2k;
                    if (this.pAlumineTolerants2.length <= i) this.pAlumineTolerants2[i] = this.tolerants2k;
                } else {
                    // Otsapunktid
                    if (this.pYlemineTolerants1.length <= i) this.pYlemineTolerants1[i] = this.tolerants1s;
                    if (this.pAlumineTolerants1.length <= i) this.pAlumineTolerants1[i] = this.tolerants1s;
                    if (this.pYlemineTolerants2.length <= i) this.pYlemineTolerants2[i] = this.tolerants2s;
                    if (this.pAlumineTolerants2.length <= i) this.pAlumineTolerants2[i] = this.tolerants2s;
                }
            } else {
                // Lisapunktid
                if (this.pYlemineTolerants1.length <= i) this.pYlemineTolerants1[i] = this.tolerants1l;
                if (this.pAlumineTolerants1.length <= i) this.pAlumineTolerants1[i] = this.tolerants1l;
                if (this.pYlemineTolerants2.length <= i) this.pYlemineTolerants2[i] = this.tolerants2l;
                if (this.pAlumineTolerants2.length <= i) this.pAlumineTolerants2[i] = this.tolerants2l;
            }
            if (this.pNimi.length <= i) this.pNimi[i] = productTransformer.getPointName(i);
            if (this.pJoon.length <= i) this.pJoon[i] = this.getLineNo(i);
            if (this.pOlemas.length <= i) this.pOlemas[i] = true;
        }
        for(let i = 0; i < this.hudPoints; i++){
            if (this.hudNominaal.length <= i) this.hudNominaal[i] = 10;
            if (this.hudKorrektsioon.length <= i) this.hudKorrektsioon[i] = 0;
            if (this.hudYlemineTolerants1.length <= i) this.hudYlemineTolerants1[i] = this.tolerants1h;
            if (this.hudAlumineTolerants1.length <= i) this.hudAlumineTolerants1[i] = this.tolerants1h;
            if (this.hudYlemineTolerants2.length <= i) this.hudYlemineTolerants2[i] = this.tolerants2h;
            if (this.hudAlumineTolerants2.length <= i) this.hudAlumineTolerants2[i] = this.tolerants2h;
        }
        for(let i = 0; i < this.lineCount * 2; i++){
            if (this.ez.length <= i) this.ez[i] = 0;
            if (this.s.length <= i) this.s[i] = 0;
        }
        for(let i = 0; i < this.lineCount; i++)if (this.pikkus.length <= i) this.pikkus[i] = 0;
        for(let i = 0; i < this.adasAreasCount; i++){
            if (this.adasarea_distance.length <= i) this.adasarea_distance[i] = 0;
            if (this.adasarea_type.length <= i) this.adasarea_type[i] = 0;
        }
    }
    /**
   * Väärtustab objekti elemendid etteantud struktuuri baasilt
   * @param data
   */ extend(data) {
        for (let item of (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).keys(data)){
            if (item === 'glass') this.glass.extend(data.glass);
            else if (Array.isArray(data[item])) this[item] = data[item].slice();
            else this[item] = data[item];
        }
    }
    /**
   * Tagastab punkti joone numbri offseti baasilt
   * @protected
   * @param {number} offset
   * @returns {number}
   */ getLineNo(offset) {
        if (offset < this.lineCount * 3) return Math.floor(offset / 3);
        else // Middle line:
        return Math.floor(this.lineCount / 2);
    }
    calcGlass() {
        if (this.glass.tahvelx === 0) return;
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(this.joony) || this.joony.length == 0) this.calcJoonAY();
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(this.ex) || this.ex.length == 0) this.calcE();
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(this.px) || this.px.length == 0) this.calcP();
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(this.pikkus) || this.pikkus.length == 0) this.calcLengthE();
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(this.pv) || this.pv.length == 0) this.calcOffsetP();
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(this.hudv) || this.hudv.length == 0) this.calcOffsetHud();
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(this.hudx) || this.hudx.length == 0) this.calcHudV();
    }
    calcJoonAY() {
        let ncp = this.glass;
        let step = 1 / (this.lineCount + 1);
        let current = step;
        this.joona = [];
        this.joony = [];
        for(let i = 0; i < this.lineCount; i++){
            this.joona[i] = this.joony[i] = (ncp.maxx - ncp.minx) * current + ncp.minx - ncp.keskx;
            current += step;
        }
    }
    calcE() {
        let ncp = this.glass;
        this.ex = [];
        this.ey = [];
        let abiex = [];
        let abiey = [];
        for(let i = 0; i < this.lineCount * 2; i++){
            abiex[i] = 0;
            abiey[i] = 0;
        }
        for(let l = 0; l < this.lineCount; l++){
            let e_loendur = l * 2;
            let x3 = this.joony[l];
            let y3 = ncp.maxy - ncp.kesky + 1;
            let x4 = this.joona[l];
            let y4 = ncp.miny - ncp.kesky - 1;
            for(let i = 0; i < ncp.ridu; i++){
                let X1 = ncp.joonx1[i];
                let Y1 = ncp.joony1[i];
                let X2 = ncp.joonx2[i];
                let Y2 = ncp.joony2[i];
                let dx = X2 - X1;
                let dy = Y2 - Y1;
                let da = x4 - x3;
                let db = y4 - y3;
                if (da * dy - db * dx != 0.0) {
                    let s = (dx * (y3 - Y1) + dy * (X1 - x3)) / (da * dy - db * dx);
                    let t = (da * (Y1 - y3) + db * (x3 - X1)) / (db * dx - da * dy);
                    if (s >= 0.0 && s <= 1.0 && t >= 0.0 && t <= 1.0) {
                        abiex[e_loendur] = X1 + t * dx;
                        abiey[e_loendur] = Y1 + t * dy;
                        e_loendur++;
                    }
                }
            }
            if (abiey[e_loendur - 2] > abiey[e_loendur - 1]) {
                this.ex[l * 2] = abiex[l * 2];
                this.ey[l * 2] = abiey[l * 2];
                this.ex[l * 2 + 1] = abiex[l * 2 + 1];
                this.ey[l * 2 + 1] = abiey[l * 2 + 1];
            } else {
                this.ex[l * 2] = abiex[l * 2 + 1];
                this.ey[l * 2] = abiey[l * 2 + 1];
                this.ex[l * 2 + 1] = abiex[l * 2];
                this.ey[l * 2 + 1] = abiey[l * 2];
            }
        }
        for(let i = 0; i < this.lineCount * 2; i++){
            if (abiex[i] == 0 && abiey[i] == 0) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Error calculating E-points");
        }
    }
    calcLengthE() {
        this.pikkus = [];
        for(let l = 0; l < this.lineCount; l++)this.pikkus[l] = Math.round(Math.sqrt(Math.pow(this.ex[2 * l + 1] - this.ex[2 * l], 2) + Math.pow(this.ey[2 * l + 1] - this.ey[2 * l], 2)));
    }
    /**
   * Arvutame punktid P, kasutades alusena ex, ey ja paigutades punktid P algolekusse
   */ calcP() {
        this.px = [];
        this.py = [];
        let defaultOffset = this.getDefaultOffsetP();
        for(let l = 0; l < this.lineCount; l++){
            this.px[3 * l] = (this.ex[2 * l] + this.ex[2 * l + 1]) / 2 + (this.ex[2 * l] - this.ex[2 * l + 1]) / 3;
            //this.py[3*l+0] = this.ey[2*l+0] - ((this.ey[2*l+0] + Math.abs(this.ey[2*l+1])) / 6);
            this.py[3 * l] = this.ey[2 * l] - defaultOffset;
            this.px[3 * l + 1] = (this.ex[2 * l] + this.ex[2 * l + 1]) / 2;
            this.py[3 * l + 1] = (this.ey[2 * l] + this.ey[2 * l + 1]) / 2;
            this.px[3 * l + 2] = (this.ex[2 * l] + this.ex[2 * l + 1]) / 2 + (this.ex[2 * l + 1] - this.ex[2 * l]) / 3;
            //this.py[3*l+2] = this.ey[2*l+1] + ((this.ey[2*l+0] + Math.abs(this.ey[2*l+1])) / 6);
            this.py[3 * l + 2] = this.ey[2 * l + 1] + defaultOffset;
        }
        this.calcPi();
    }
    calcPi() {
        if (!this.addPoints) return;
        let l = Math.floor(this.lineCount / 2);
        let lineX = this.ex[2 * l] - this.ex[2 * l + 1];
        let lineY = this.ey[2 * l] - this.ey[2 * l + 1];
        let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));
        for(let i = this.lineCount * 3, offset = 50; i < this.lineCount * 3 + this.addPoints; i++, offset += 50){
            //let pv = lineLen - offset;
            let pv = offset;
            this.pv[i] = pv;
            this.px[i] = Math.round(this.ex[2 * l + 1] + pv * lineX / lineLen);
            this.py[i] = Math.round(this.ey[2 * l + 1] + pv * lineY / lineLen);
        }
    }
    /**
   * Arvutame punktid HUD, kasutades alusena ex, ey ja paigutades punktid HUD algolekusse
   */ calcHud() {
        if (this.hudLine == null) return;
        this.hudx = [];
        this.hudy = [];
        this.hudv = [];
        let l = this.hudLine - 1;
        let lineX = this.ex[2 * l] - this.ex[2 * l + 1];
        let lineY = this.ey[2 * l] - this.ey[2 * l + 1];
        let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));
        for(let i = 0, offset = Math.round(lineLen - (0, $487b7e0315c147c0$export$2e2bcd8739ae039).HUD_DEFAULT_OFFSET); i < this.hudPoints; i++, offset -= (0, $487b7e0315c147c0$export$2e2bcd8739ae039).HUD_DEFAULT_STEP){
            let pv = offset;
            this.hudv[i] = pv;
            this.hudx[i] = Math.round(this.ex[2 * l + 1] + pv * lineX / lineLen);
            this.hudy[i] = Math.round(this.ey[2 * l + 1] + pv * lineY / lineLen);
        }
    }
    getDefaultOffsetP() {
        let centerLine = Math.floor(this.lineCount / 2);
        let centerLen = this.getLineLen(centerLine);
        return centerLen >= 700 ? 200 : 150;
    }
    getLineLen(l) {
        let lineX = this.ex[2 * l + 1] - this.ex[2 * l];
        let lineY = this.ey[2 * l + 1] - this.ey[2 * l];
        return Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));
    }
    /**
   * Arvutame punktid P, kasutades alusena ex, ey, pv
   */ calcPV() {
        // Arvutame px, py, kasutades alusena pv, ex, ey infot:
        this.px = [];
        this.py = [];
        let ex = this.ex;
        let ey = this.ey;
        let pv = this.pv;
        for(let i = 0; i < this.px.length; i++){
            let l = this.pJoon[i];
            let lineX = ex[2 * l] - ex[2 * l + 1];
            let lineY = ey[2 * l] - ey[2 * l + 1];
            let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));
            this.px[i] = Math.round(ex[2 * l + 1] + pv[i] * lineX / lineLen);
            this.py[i] = Math.round(ey[2 * l + 1] + pv[i] * lineY / lineLen);
        }
    }
    /**
   * Arvutame punktid HUD, kasutades alusena ex, ey, hudv
   */ calcHudV() {
        if (this.hudLine == null) return;
        // Arvutame hudx, hudy, kasutades alusena hudv, ex, ey infot:
        this.hudx = [];
        this.hudy = [];
        let ex = this.ex;
        let ey = this.ey;
        let hudv = this.hudv;
        let l = this.hudLine - 1;
        for(let i = 0; i < hudv.length; i++){
            let lineX = ex[2 * l] - ex[2 * l + 1];
            let lineY = ey[2 * l] - ey[2 * l + 1];
            let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));
            this.hudx[i] = Math.round(ex[2 * l + 1] + hudv[i] * lineX / lineLen);
            this.hudy[i] = Math.round(ey[2 * l + 1] + hudv[i] * lineY / lineLen);
        }
    }
    calcOffsetP() {
        this.pv = [];
        for(let i = 0; i < this.px.length; i++){
            let l = this.pJoon[i];
            this.pv[i] = Math.round(Math.sqrt(Math.pow(this.px[i] - this.ex[2 * l + 1], 2) + Math.pow(this.py[i] - this.ey[2 * l + 1], 2)));
        }
    }
    calcOffsetHud() {
        if (this.hudLine == null) return;
        this.hudv = [];
        let l = this.hudLine - 1;
        for(let i = 0; i < this.hudx.length; i++)this.hudv[i] = Math.round(Math.sqrt(Math.pow(this.hudx[i] - this.ex[2 * l + 1], 2) + Math.pow(this.hudy[i] - this.ey[2 * l + 1], 2)));
    }
    /**
  * Call koordinaadid
  */ calcKoord(kalle) {
        this.calcOffsetP();
        this.calcOffsetHud();
        if (kalle === undefined || kalle !== false) this.calcKalle();
        this.pikkus = [];
        for(let i = 0; i < this.lineCount; i++)this.pikkus[i] = Math.round(Math.sqrt(Math.pow(this.ex[i * 2 + 1] - this.ex[i * 2], 2) + Math.pow(this.ey[i * 2 + 1] - this.ey[i * 2], 2)));
    }
    /**
   * Sub arvuta_Kalle
   */ calcKalle() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let KALDE_TEGUR = settings.getSlopeFactor();
        // eKalleA - x-telje suunaline (keskmisel joonel 0)
        // eKalleB - y-telje suunaline
        let eKalleA = [];
        let eKalleB = [];
        for(let i = 0; i < this.lineCount * 2; i++){
            // KalleA
            if (i == this.lineCount - 1 || i == this.lineCount) // Keskmisel joonel on kalle A 0
            // TODO: Nihutatud keskmise joone korral enam ei ole kalle 0...
            eKalleA[i] = 0;
            else {
                let p1 = i > this.lineCount ? i : i + 2;
                let p2 = i > this.lineCount ? i - 2 : i;
                let a = this.ez[p1] - this.ez[p2];
                let b = Math.sqrt(Math.pow(this.ex[p1] - this.ex[p2], 2) + Math.pow(this.ey[p1] - this.ey[p2], 2));
                let tmp = a / b;
                let atan = Math.atan(tmp);
                eKalleA[i] = Math.round(atan * 180.0 / Math.PI * 10.0) * KALDE_TEGUR / 10.0;
            }
            if (i % 2 == 0) {
                // KalleB (1,3,5) -> (2,5,8) | (0,2,4) -> (1,4,7) i -> i/2*3+1
                let pi = i / 2 * 3 + 1;
                let tmp = this.pNominaal[pi] / Math.sqrt(Math.pow(this.px[pi] - this.ex[i], 2) + Math.pow(this.py[pi] - this.ey[i], 2));
                eKalleB[i] = Math.round(Math.atan(tmp) * 180 / Math.PI * 10.0) * KALDE_TEGUR / 10.0;
            } else eKalleB[i] = eKalleB[i - 1] * -1;
        }
        this.eKalleA = eKalleA;
        this.eKalleB = eKalleB;
    }
    copyKalle() {
        for(let i = 0; i < Math.floor(this.lineCount / 2); i++){
            let mirroredLine = this.lineCount - i - 1;
            this.eKalleA[mirroredLine * 2] = -this.eKalleA[i * 2];
            this.eKalleA[mirroredLine * 2 + 1] = -this.eKalleA[i * 2 + 1];
            this.eKalleB[mirroredLine * 2] = this.eKalleB[i * 2];
            this.eKalleB[mirroredLine * 2 + 1] = this.eKalleB[i * 2 + 1];
        }
    }
    mirror() {
        for(let i = 0; i < Math.floor(this.lineCount / 2); i++){
            this.joona[this.lineCount - i - 1] = Math.abs(this.joona[i]);
            this.joony[this.lineCount - i - 1] = Math.abs(this.joony[i]);
            this.ez[2 * (this.lineCount - i) - 2] = this.ez[2 * i];
            this.ez[2 * (this.lineCount - i) - 1] = this.ez[2 * i + 1];
            this.s[2 * (this.lineCount - i) - 2] = this.s[2 * i];
            this.s[2 * (this.lineCount - i) - 1] = this.s[2 * i + 1];
            this.pv[3 * (this.lineCount - i) - 3] = this.pv[3 * i];
            this.pv[3 * (this.lineCount - i) - 2] = this.pv[3 * i + 1];
            this.pv[3 * (this.lineCount - i) - 1] = this.pv[3 * i + 2];
        }
        // TODO: Miks see nii tehakse? Vt ncp2gr-fi.frm rida 3773 (Sub Command7_Click)
        /*
    let mid = Math.floor(this.lineCount*3 / 2);
    this.px[mid] = Math.abs(this.px[0]);
    this.py[mid] = this.py[0];
    */ this.calcE();
        this.calcPfromOffset();
        this.calcHudFromOffset();
    }
    mirrorShape() {
        this.glass.mirror();
    }
    moveE(point, offset) {
        // Paaritud on ülemised, paaris on alumised:
        let joon = point % 2 == 0 ? this.joony : this.joona;
        // Joone indeks on punkti nr / 2:
        let idx = Math.floor(point / 2);
        joon[idx] += offset;
        // Kontrollime, et jooned ei liiguks üle üksteise ega üle servade:
        let minx = this.glass.minx - this.glass.keskx;
        let maxx = this.glass.maxx - this.glass.keskx;
        if (idx > 0) minx = joon[idx - 1];
        if (idx < this.lineCount - 1) maxx = joon[idx + 1];
        if (joon[idx] < minx) joon[idx] = minx;
        if (joon[idx] > maxx) joon[idx] = maxx;
        this.calcE();
        this.calcPfromOffset();
        this.calcHudFromOffset();
    }
    moveP(point, offset) {
        // Keskmisi punkte nihutada ei luba:
        //if (point % 3 == 1) return;
        // Leiame x vahemiku, mille sees tohib muutuda:
        let line = this.pJoon[point];
        // let line = Math.floor(point / 3);
        let maxy = this.ey[line * 2];
        let miny = this.ey[line * 2 + 1];
        let minx = this.ex[line * 2 + 1];
        if (point < this.lineCount * 3) {
            if (point % 3 != 0) maxy = this.py[point - 1];
            else {
                miny = this.py[point + 1];
                minx = this.px[point + 1];
            }
        }
        if (this.py[point] == null || this.py[point] < miny) {
            this.py[point] = miny;
            this.px[point] = minx;
        }
        if (this.py[point] + offset > miny && this.py[point] + offset < maxy) {
            this.py[point] += offset;
            this.px[point] = this.px[point] + (this.ex[line * 2] - this.ex[line * 2 + 1]) / (this.ey[line * 2] - this.ey[line * 2 + 1]) * offset;
        }
    }
    moveHud(point, offset) {
        if (this.hudLine == null) return;
        // Leiame x vahemiku, mille sees tohib muutuda:
        let line = this.hudLine - 1;
        let maxy = this.ey[line * 2];
        let miny = this.ey[line * 2 + 1];
        let minx = this.ex[line * 2 + 1];
        if (this.hudy[point] == null || this.hudy[point] < miny) {
            this.hudy[point] = miny;
            this.hudx[point] = minx;
        }
        if (this.hudy[point] + offset > miny && this.hudy[point] + offset < maxy) {
            this.hudy[point] += offset;
            this.hudx[point] = this.hudx[point] + (this.ex[line * 2] - this.ex[line * 2 + 1]) / (this.ey[line * 2] - this.ey[line * 2 + 1]) * offset;
        }
    }
    removeP(point) {
        this.pOlemas[point] = !this.pOlemas[point];
    }
    assignP() {
        // punkti P200 järgi, kui joon E3-E4 >= 700 mm,
        // punkti P150 järgi, kui joon E3-E4 < 700 mm.
        let centerLine = Math.floor(this.lineCount / 2);
        let pointName = this.getLineLen(centerLine) >= 700 ? "P200" : "P150";
        for(let i = 0; i < this.pNimi.length; i++)if (this.pNimi[i] == pointName) {
            let centerLineLastPoint = 3 * Math.floor(this.lineCount / 2 + 1) - 1;
            this.px[centerLineLastPoint] = this.px[i];
            this.py[centerLineLastPoint] = this.py[i];
            this.pNominaal[centerLineLastPoint] = this.pNominaal[i];
            this.pAlumineTolerants1[centerLineLastPoint] = this.pAlumineTolerants1[i];
            this.pAlumineTolerants2[centerLineLastPoint] = this.pAlumineTolerants2[i];
            this.pYlemineTolerants1[centerLineLastPoint] = this.pYlemineTolerants1[i];
            this.pYlemineTolerants2[centerLineLastPoint] = this.pYlemineTolerants2[i];
            this.pv[centerLineLastPoint] = this.pv[i];
            break;
        }
    }
    calcPfromOffset() {
        this.px = [];
        this.py = [];
        for(let i = 0; i < this.pJoon.length; i++){
            let l = this.pJoon[i];
            let ev = Math.sqrt((this.ex[2 * l] - this.ex[2 * l + 1]) * (this.ex[2 * l] - this.ex[2 * l + 1]) + (this.ey[2 * l] - this.ey[2 * l + 1]) * (this.ey[2 * l] - this.ey[2 * l + 1]));
            this.px[i] = this.ex[2 * l + 1] + Math.round(this.pv[i] * (this.ex[2 * l] - this.ex[2 * l + 1]) / ev);
            this.py[i] = this.ey[2 * l + 1] + Math.round(this.pv[i] * (this.ey[2 * l] - this.ey[2 * l + 1]) / ev);
        }
    }
    calcHudFromOffset() {
        if (this.hudLine == null) {
            if (this.hudv.length > 0) {
                this.hudx = [];
                this.hudy = [];
                this.hudv = [];
            }
            return;
        }
        this.hudx = [];
        this.hudy = [];
        if (this.hudv.length == 0) this.calcHud();
        else {
            let l = this.hudLine - 1;
            for(let i = 0; i < this.hudPoints; i++){
                let ev = Math.sqrt((this.ex[2 * l] - this.ex[2 * l + 1]) * (this.ex[2 * l] - this.ex[2 * l + 1]) + (this.ey[2 * l] - this.ey[2 * l + 1]) * (this.ey[2 * l] - this.ey[2 * l + 1]));
                this.hudx[i] = this.ex[2 * l + 1] + Math.round(this.hudv[i] * (this.ex[2 * l] - this.ex[2 * l + 1]) / ev);
                this.hudy[i] = this.ey[2 * l + 1] + Math.round(this.hudv[i] * (this.ey[2 * l] - this.ey[2 * l + 1]) / ev);
            }
        }
    }
    calcPointsAngle(i, j) {
        // Meil on vaja teada mõlema punkti (y, z) koordinaate.
        if (this.pv[i] == null || this.pv[j] == null || this.pNominaal[i] == null || this.pNominaal[j] == null) {
            this.angleValue = null;
            return;
        }
        this.angleValue = (0, $30071e4d8f83fdfd$export$11a7b5abbf8340a)(this.pv[i], this.pNominaal[i], this.pv[j], this.pNominaal[j]);
    }
    /**
   * HUD punktide jaoks kasutatav joon (1..n)
   */ /**
   * Sisseloetud NCP faili nimi
   */ /**
   * Sisseloetud NCP faili sisu
   */ /**
   * Sisseloetud NCP faili tüüp - kas dat või ncp.
   */ /**
   * Sisseloetud GR2 faili nimi
   */ /**
   * Mudeli nimi
   */ // mudeliNimi (4920, 330, w: 4695)
    /**
   * SCAN
   */ // SCAN (9960, 330, w:1935)
    /**
   * kood = programm + versioon
   */ // kood = programm + versioon
    /**
   * X nihe
   */ // Text49 (1080, 3600, w:495)
    /**
   * Y nihe
   */ // Text50 (1080, 3960, w:495)
    /**
   * Klaasi joone max ja min x koordinaatide vahe. Ei edastata PLCsse
   */ /**
   * Klaasi joone max ja min y koordinaatide vahe. Ei edastata PLCsse
   */ /**
   * GR2 faili enihe parameeter. Ignoreeritakse, ei edastata PLCsse
   */ /**
   * Distants
   */ // Text61 (1080, 4440, w:495)
    /**
   * Raadionupud e1, e2, e5, e6
   */ // raadionupud e1, e2, e5, e6
    /**
   * Raadionupud 1, 3, 4, 6, 7, 9
   */ // raadionupud 1, 3, 4, 6, 7, 9
    /**
   * HUD raadionupud
   */ /**
   * Tolerants 1 punktidele 2, 5, 8, 11, 14
   */ // Text51 (1440, 5160, w:495)
    /**
   * Tolerants 2 punktidele 2, 5, 8, 11, 14
   */ // Text52 (1440, 5520, w:495)
    /**
   * Tolerants 1 punktidele 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
   */ // Text60 (3720, 5160, w:495)
    /**
   * Tolerants 2 punktidele 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
   */ // Text59 (3720, 5520, w:495)
    /**
   * Tolerants 1 lisapunktidele
   */ /**
   * Tolerants 2 lisapunktidele
   */ /**
   * Tolerants 1 HUD punktidele
   */ /**
   * Tolerants 2 HUD punktidele
   */ // pKoordY
    /**
   * Punktide P offsetid klaasi ülemisest servast (punktidest e2, e4, e6)
   */ // PkoordY (960, 6240, w:495) - (960, 8160, w:495) 9tk
    /**
   * Punktide P korrektsioonid
   */ // korrektsioon (2040, 6240, w:495) - (2040, 8160, w: 495) 9tk
    /**
   * HUD punktide korrektsioonid
   */ /**
   * Klaasi paksus
   */ // klPaksus (4080, 6480, w:495)
    /**
   * Profiil klaasil
   */ // profiilKlaasil (4080, 7080, w:495)
    /**
   * Profiil trükil
   */ /**
   * Servade X koordinaadid (eKoordX = ex + xnihe)
   */ // EkoordX, ex  (480, 8760, w:495) -  (480, 9960, w:495) 6tk
    /**
   * Servade Y koordinaadid (eKoordY = ey + ynihe)
   */ // EkoordY, ey  (960, 8760, w:495) -  (960, 9960, w:495) 6tk
    // EkoordZ, ez (1440, 8760, w:495) - (1440, 9960, w:495) 6tk
    /**
   * Servade Z koordinaadid (eKoordZ = eKoordK = ez)
   */ // EkoordK (2040, 8760, w:495) - (2040, 9960, w:495) 6tk
    /**
   * KalleA
   */ // KalleA  (2670, 8760, w:495) - (2670, 9960, w:495) 6tk
    /**
   * KalleB
   */ // KalleB  (3150, 8760, w:495) - (3150, 9960, w:495) 6tk
    /**
   * eTrykk
   */ // Trykk   (3750, 8760, w:495) - (3750, 9960, w:495) 6tk
    /**
   * ePikkus = pikkus
   */ // Pikkus  (4350, 8760, w:495) - (4350, 9720, w:495) 3tk
    /**
   * Kas antud P punkt on kasutuses
   */ /**
   * P punktide x koordinaadid
   */ /**
   * P punktide y koordinaadid
   */ /**
   * P punktide nimed (P1 ... P9/P15, [P50, P100, P150, P200, P250])
   */ /**
   * P punktide asukohajooned (0 ... 3/5)
   */ /**
   * Ülemine tolerants 2
   */ // PtolYla2 (720, 10560, w:495) - (4200, 10560, w:495) 9tk
    /**
   * Ülemine tolerants 1
   */ // PtolYla1 (720, 10800, w:495) - (4200, 10800, w:495) 9tk
    /**
   * Nominaalid
   */ // PtolNom  (720, 11040, w:495) - (4200, 11040, w:495) 9tk
    /**
   * Alumine tolerants 1
   */ /**
   * Alumine tolerants 2
   */ // PtolAll2 (720, 11520, w:495) - (4200, 11520, w:495) 9tk
    /**
   * HUD Ülemine tolerants 2
   */ /**
   * HUD Ülemine tolerants 1
   */ /**
   * HUD Nominaalid
   */ /**
   * HUD Alumine tolerants 1
   */ /**
   * HUD Alumine tolerants 2
   */ /**
   * Nurga tolerantsid
   */ /**
   * Kas punkt on valitud nurga arvutamiseks
   */ /**
   * Kahe valitud punkti vahele tõmmatud joone nurk (arvutatud anglePoints punktide andmetest), kui null - siis pole täpselt kahte punkti valitud
   */ /**
   * ADAS punkti indeks
   */ /**
   * Joonte alumised koordinaadid
   */ /**
   * Joonte ülemised koordinaadid
   */ /**
   * Kas on keeratud 180 kraadi
   */ /**
   * Kas on peegeldatud
   */ /**
   * Kas on keeratud 90 kraadi
   */ /**
   * Kas esimese mõõtejoone mõõtmisel tuleb sensorit pöörata
   */ /**
   * Kas viimase mõõtejoone mõõtmisel tuleb sensorit pöörata
   */ /**
   * ADAS ala punktide distantsid klaasi servast
   * @type {Array[number]}
   */ /**
   * ADAS ala punkti tüüp: 0 - klaas, 1 - print
   * @type {Array[string]}
   */ /**
      *
      * @param state
      */ constructor(state){
        super(state);
        this.glass = new (0, $33d2aa29355d2916$export$2e2bcd8739ae039)();
        this.failiNimi = '';
        this.ncpData = null;
        this.ncpType = null;
        this.grFailiNimi = '';
        this.mudeliNimi = ''; // mudeliNimi (4920, 330, w: 4695)
        this.scan = ''; // SCAN (9960, 330, w:1935)
        this.kood = ''; // kood = programm + versioon
        this.xnihe = null; // Text49 (1080, 3600, w:495)
        this.ynihe = null; // Text50 (1080, 3960, w:495)
        this.xdiff = null;
        this.ydiff = null;
        this.enihe = null;
        this.distants = null; // Text61 (1080, 4440, w:495)
        this.valitud_e = null; // raadionupud e1, e2, e5, e6
        this.valitud_p = null; // raadionupud 1, 3, 4, 6, 7, 9
        this.valitud_hud = null;
        this.tolerants1k = null; // Text51 (1440, 5160, w:495)
        this.tolerants2k = null; // Text52 (1440, 5520, w:495)
        this.tolerants1s = null; // Text60 (3720, 5160, w:495)
        this.tolerants2s = null; // Text59 (3720, 5520, w:495)
        this.tolerants1l = null;
        this.tolerants2l = null;
        this.tolerants1h = null;
        this.tolerants2h = null;
        this.pv = []; // PkoordY (960, 6240, w:495) - (960, 8160, w:495) 9tk
        this.hudv = [];
        this.pKorrektsioon = []; // korrektsioon (2040, 6240, w:495) - (2040, 8160, w: 495) 9tk
        this.hudKorrektsioon = [];
        this.klaasiPaksus = null; // klPaksus (4080, 6480, w:495)
        this.profiilKlaasil = null; // profiilKlaasil (4080, 7080, w:495)
        this.profiilTrykil = null;
        this.ex = []; // EkoordX, ex  (480, 8760, w:495) -  (480, 9960, w:495) 6tk
        this.ey = []; // EkoordY, ey  (960, 8760, w:495) -  (960, 9960, w:495) 6tk
        this.ez = []; // EkoordK (2040, 8760, w:495) - (2040, 9960, w:495) 6tk
        this.eKalleA = []; // KalleA  (2670, 8760, w:495) - (2670, 9960, w:495) 6tk
        this.eKalleB = []; // KalleB  (3150, 8760, w:495) - (3150, 9960, w:495) 6tk
        this.s = []; // Trykk   (3750, 8760, w:495) - (3750, 9960, w:495) 6tk
        this.pikkus = []; // Pikkus  (4350, 8760, w:495) - (4350, 9720, w:495) 3tk
        this.pOlemas = [];
        this.px = [];
        this.py = [];
        this.hudx = [];
        this.hudy = [];
        this.pNimi = [];
        this.pJoon = [];
        this.pYlemineTolerants2 = [];
        this.pYlemineTolerants1 = [];
        this.pNominaal = [];
        this.pAlumineTolerants1 = [];
        this.pAlumineTolerants2 = [];
        this.hudYlemineTolerants2 = [];
        this.hudYlemineTolerants1 = [];
        this.hudNominaal = [];
        this.hudAlumineTolerants1 = [];
        this.hudAlumineTolerants2 = [];
        this.angle = {};
        this.anglePoints = [];
        this.angleValue = null;
        this.adas = null;
        this.joona = [];
        this.joony = [];
        this.keeratud = false;
        this.peegeldatud = false;
        this.rotated = false;
        this.keeratud_esimene = false;
        this.keeratud_viimane = false;
        this.adasarea_distance = [];
        this.adasarea_type = [];
        this.initState(state);
    }
}
var $a96c27223eb4a3af$export$2e2bcd8739ae039 = $a96c27223eb4a3af$var$ProductInfo;



/**
 * Mõõtejoone otspunkti klass
 */ class $02b06578fcb6b8be$export$ca3bb03eef24f110 {
    /**
   * X koordinaat
   */ /**
   * Y koordinaat
   */ /**
   * Z koordinaat
   */ /**
   * Otspunkti mõõtmise kalle x teljel
   */ /**
   * Otspunkti mõõtmise kalle y teljel
   */ /**
   * Prindi kaugus klaasi servast
   */ constructor(params){
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.slopeX = 0;
        this.slopeY = 0;
        this.printOffset = 0;
        if (params) (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).extend(this, params);
    }
}
class $02b06578fcb6b8be$export$2b3bbd0605b6f8ff {
    /**
   * Tolerantsi nimi. Peab olema üks järgnevatest:
   *                  Ai - joone alguses olev nominaalpunkt (i on 1, 2, 3, ...)
   *                  Bi - joone keskel olev nominaalpunkt (i on 1, 2, 3, ...)
   *                  Ci - jooone lõpus olev nominaalpunkt (i on 1, 2, 3, ...)
   *                  Pi (i = 1 .. 9/15) - asendavad A, B, C, kus i = jooneNr*3 +1 (joone algses oleva punkti korral), +2 (joone keskel oleva punkti korral) või +3 (joone lõpus oleva punkti korral) ; kus joone Nr on 0 .. 2/4
   *                  Pj (j = 300 .. 50) - keskmise joone peal asuv peeglialuse ala nominaalpunkt, siin j on sammuga 50 ja näitab kaugust klaasi ülaservast
   *                  ANGLE - Nurk kahe valitud punkti vahel
   *                  Hi (i = 1 .. 5) - HUD punkt, järjestatud kasvavalt klaasi alaserva suhtes
   */ /**
   * Nominaali ettenähtud mõõteväärtus
   */ // Nominaali ettenähtud mõõteväärtus
    /**
   * ülemine 1. tolerants
   */ // ülemine 1. tolerants
    /**
   * alumine 1. tolerants
   */ // alumine 1. tolerants
    /**
   * ülemine 2. tolerants
   */ // ülemine 2. tolerants
    /**
   * alumine 2. tolerants
   */ // alumine 2. tolerants
    constructor(params){
        this.name = "";
        this.value = null;
        this.upperTolerance1 = null;
        this.lowerTolerance1 = null;
        this.upperTolerance2 = null;
        this.lowerTolerance2 = null;
        if (params) (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).extend(this, params);
    }
}
/**
 * Mõõtepunkti klass
 */ class $02b06578fcb6b8be$export$b80053ee3576378f extends $02b06578fcb6b8be$export$2b3bbd0605b6f8ff {
    /**
   * Joone number (1..3/5)
   * @type {IntegerType}
   */ /**
   * Kaugus klaasi servast
   */ // Kaugus klaasi servast
    /**
   * Korrektsioon
   */ // Korrektsioon
    /**
   * Kas on "ADAS akna punkt"
   */ /**
   * Kas punkt kuvatakse mõõtmise ekraanil
   */ // Kas punkt kuvatakse mõõtmise ekraanil
    constructor(params){
        super(null);
        this.distance = null;
        this.correction = null;
        this.isAdas = false;
        this.show = false;
        if (params) (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).extend(this, params);
    }
}
/**
 * Nurga määramise klass
 */ class $02b06578fcb6b8be$export$34d194eb3f4b4115 extends $02b06578fcb6b8be$export$2b3bbd0605b6f8ff {
    /**
   * First point name
   */ /**
   * Second point name
   */ constructor(params){
        super(null);
        this.point1 = null;
        this.point2 = null;
        if (params) (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).extend(this, params);
    }
}
/**
 * Mõõtejoone klass
 */ class $02b06578fcb6b8be$export$8d82331306cb3c9 {
    /**
   * Mõõtejoone pikkus
   */ /**
   * Otspunktid, 2tk
   */ // 2 tk
    /**
   * Nominaalid
   */ /**
   * Nurgad
   */ constructor(params){
        this.lineLength = 0;
        this.endpoints = []; // 2 tk
        this.nominals = [];
        this.angles = [];
        if (params) (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).extend(this, params);
    }
}
class $02b06578fcb6b8be$export$22c3bf686f4e628e {
    /**
   * ADAS ala distants klaasi servast
   * @type {IntegerType}
   */ /**
   * ADAS ala tüüüp. Üks järgmistest:
   *  0 - Klaas
   *  1 - Print
   *  2 - Raster (ei kasutata hetkel)
   *  3 - Soojendusjuhe (ei kasutata hetkel)
   * @type {0|1|2|3}
   */ constructor(params){
        this.distance = 0;
        this.type = 0;
        if (params) (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).extend(this, params);
    }
}
/**
 * Universaalse JSON tootefaili esitus
 */ class $02b06578fcb6b8be$export$2e2bcd8739ae039 {
    /**
   * Versioon
   */ /**
   * Mõõtejoonte arv
   */ /**
   * Toote kood ja variant. Ei edastata PLCsse
   */ /**
   * Toote SCAN kood. Ei edastata PLCsse
   */ // Toote SCAN kood. Ei edastata PLCsse
    /**
   * Toote nimetus (description). Ei edastata PLCsse
   */ // Toote nimetus (description). Ei edastata PLCsse
    /**
   * Mõõtejooned
   */ // Iga element vastab ühele mõõtejoonele, kuni viis mõõtejoont
    /**
   * Klaasi paksus
   */ // Klaasi paksus
    /**
   * Lasersersensori mõõteprofiil klaasi jaoks
   */ // Lasersersensori mõõteprofiil klaasi jaoks
    /**
   * Lasersersensori mõõteprofiil prindi jaoks
   */ // Lasersersensori mõõteprofiil prindi jaoks
    /**
   * Klaasi joone max ja min x koordinaatide vahe. Ei edastata PLCsse
   */ // Klaasi joone max ja min x koordinaatide vahe. Ei edastata PLCsse
    /**
   * Klaasi joone max ja min y koordinaatide vahe. Ei edastata PLCsse
   */ // Klaasi joone max ja min y koordinaatide vahe. Ei edastata PLCsse
    /**
   * Klaasijoone nihutus x-teljel. Nihkeväärtus liidetakse juurde kõikide otspunktide x-väärtustele
   */ // Klaasijoone nihutus x-teljel. Nihkeväärtus liidetakse juurde kõikide otspunktide x-väärtustele
    /**
   * Klaasijoone nihutus y-teljel. Nihkeväärtus liidetakse juurde kõikide otspunktide y-väärtustele
   */ // Klaasijoone nihutus y-teljel. Nihkeväärtus liidetakse juurde kõikide otspunktide y-väärtustele
    /**
   * Distance
   * @type {IntegerType}
   */ /**
   * GR2 faili enihe parameeter. Ignoreeritakse, ei edastata PLCsse
   */ // GR2 faili enihe parameeter. Ignoreeritakse, ei edastata PLCsse
    /**
   * Mõõtejoonte ülemise otsa X-koordinaadid. Ei edastata PLCsse
   */ // Mõõtejoonte ülemised koordinaadid. Ei edastata PLCsse
    /**
   * Mõõtejoonte alumise osa X-koordinaadid. Ei edastata PLCsse
   */ // Mõõtejoonte alumised koordinaadid. Ei edastata PLCsse
    /**
   * Mõõtepunktide x-koordinaadid. Ei edastata PLCsse
   */ // Mõõtepunktide x-koordinaadid. Ei edastata PLCsse
    /**
   * Mõõtepunktide y-koordinaadid. Ei edastata PLCsse
   */ // Mõõtepunktide y-koordinaadid. Ei edastata PLCsse
    /**
   * Kas mõõtejoonte failis on mõõtejoon keeratud 180 kraadi
   */ // Kas mõõtejoonte failis on mõõtejoon keeratud
    /**
   * Keskmiste mõõtepunktide 1. tolerants
   */ // Keskmiste mõõtepunktide 1. tolerants
    /**
   * Keskmiste mõõtepunktide 2. tolerants
   */ // Keskmiste mõõtepunktide 2. tolerants
    /**
   * Serva mõõtepunktide 1. tolerants
   */ // Serva mõõtepunktide 1. tolerants
    /**
   * Serva mõõtepunktide 2. tolerants
   */ // Serva mõõtepunktide 2. tolerants
    /**
   * Kas mõõtejoon tuleb esitada peegeldatuna
   */ // Kas mõõtejoon tuleb esitada peegeldatuna
    /**
   * Edastatakse PLCsse, kui konfiguratsioonis on "rotated_measurements_allowed" tõene
   */ // Edastatakse PLCsse, kui konfiguratsioonis on "rotated_measurements_allowed" tõene
    /**
   * Edastatakse PLCsse, kui konfiguratsioonis on "rotated_measurements_allowed" tõene
   */ // Edastatakse PLCsse, kui konfiguratsioonis on "rotated_measurements_allowed" tõene
    /**
   * Kas on keeratud 90 kraadi
   */ /**
   * ADAS alade kirjeldused (kuni 6 ala)
   * @type {Array<AdasArea>}
   */ constructor(params){
        this.version = 3;
        this.lineCount = 3;
        this.codeVariant = "";
        this.scanCode = ""; // Toote SCAN kood. Ei edastata PLCsse
        this.description = ""; // Toote nimetus (description). Ei edastata PLCsse
        this.measurementLines = []; // Iga element vastab ühele mõõtejoonele, kuni viis mõõtejoont
        this.glassThickness = 0; // Klaasi paksus
        this.measuringProfileGlass = 0; // Lasersersensori mõõteprofiil klaasi jaoks
        this.measuringProfilePrint = 0; // Lasersersensori mõõteprofiil prindi jaoks
        this.diffX = 0; // Klaasi joone max ja min x koordinaatide vahe. Ei edastata PLCsse
        this.diffY = 0; // Klaasi joone max ja min y koordinaatide vahe. Ei edastata PLCsse
        this.offsetX = 0; // Klaasijoone nihutus x-teljel. Nihkeväärtus liidetakse juurde kõikide otspunktide x-väärtustele
        this.offsetY = 0; // Klaasijoone nihutus y-teljel. Nihkeväärtus liidetakse juurde kõikide otspunktide y-väärtustele
        this.offsetE = 0; // GR2 faili enihe parameeter. Ignoreeritakse, ei edastata PLCsse
        this.distance = 0;
        this.lineUpper = []; // Mõõtejoonte ülemised koordinaadid. Ei edastata PLCsse
        this.lineLower = []; // Mõõtejoonte alumised koordinaadid. Ei edastata PLCsse
        this.pX = []; // Mõõtepunktide x-koordinaadid. Ei edastata PLCsse
        this.pY = []; // Mõõtepunktide y-koordinaadid. Ei edastata PLCsse
        this.rotatedLine = false; // Kas mõõtejoonte failis on mõõtejoon keeratud
        this.toleranceMiddle1 = 0; // Keskmiste mõõtepunktide 1. tolerants
        this.toleranceMiddle2 = 0; // Keskmiste mõõtepunktide 2. tolerants
        this.toleranceEdge1 = 0; // Serva mõõtepunktide 1. tolerants
        this.toleranceEdge2 = 0; // Serva mõõtepunktide 2. tolerants
        this.mirrored = false; // Kas mõõtejoon tuleb esitada peegeldatuna
        this.rotatedFirst = false; // Edastatakse PLCsse, kui konfiguratsioonis on "rotated_measurements_allowed" tõene
        this.rotatedLast = false; // Edastatakse PLCsse, kui konfiguratsioonis on "rotated_measurements_allowed" tõene
        this.rotated = false;
        this.adasAreas = [];
        if (params) (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).extend(this, params);
    }
}



/**
 * Klass, mis teisendab tooteinfot erinevate esituste vahet.
 */ class $d02c132c9fe52fc9$var$ProductTransformer {
    /**
   *
   * @param {GlassProduct} g
   * @returns {ProductInfo}
   */ glassProductToState(g) {
        /**
     * @type {ProductInfo}
     */ let state = new (0, $a96c27223eb4a3af$export$2e2bcd8739ae039)(this.productConfig);
        // Nominaalide info
        for(let i = 0; i < g.measurementLines.length; i++){
            /**
       * @type {MeasurementLine}
       */ let line = g.measurementLines[i];
            for (let n of line.nominals){
                let name = this.fixPointName(n.name, i);
                let pointType = this.getPointType(name);
                let k = this.getPointOffset(name);
                switch(pointType){
                    case "H":
                        if (k < 0 || k >= state.hudPoints) continue;
                        state.hudLine = i + 1;
                        state.hudYlemineTolerants2[k] = this.div10(n.upperTolerance2);
                        state.hudYlemineTolerants1[k] = this.div10(n.upperTolerance1);
                        state.hudNominaal[k] = this.div10(n.value);
                        state.hudAlumineTolerants1[k] = this.div10(n.lowerTolerance1);
                        state.hudAlumineTolerants2[k] = this.div10(n.lowerTolerance2);
                        state.hudv[k] = this.div10(n.distance);
                        state.hudKorrektsioon[k] = this.div10(n.correction);
                        break;
                    case "P":
                        state.pYlemineTolerants2[k] = this.div10(n.upperTolerance2);
                        state.pYlemineTolerants1[k] = this.div10(n.upperTolerance1);
                        state.pNominaal[k] = this.div10(n.value);
                        state.pAlumineTolerants1[k] = this.div10(n.lowerTolerance1);
                        state.pAlumineTolerants2[k] = this.div10(n.lowerTolerance2);
                        if (n.isAdas) state.adas = k;
                        state.pv[k] = this.div10(n.distance);
                        state.pKorrektsioon[k] = this.div10(n.correction);
                        state.pJoon[k] = i;
                        state.pNimi[k] = this.getPointName(k);
                        state.pOlemas[k] = true;
                        break;
                    default:
                        break;
                }
            }
            if (line.angles && line.angles.length > 0) {
                /**
         * @type {NominalAngle}
         */ let angle = line.angles[0];
                state.angle = {
                    pYlemineTolerants2: this.div10(angle.upperTolerance2),
                    pYlemineTolerants1: this.div10(angle.upperTolerance1),
                    pNominaal: this.div10(angle.value),
                    pAlumineTolerants1: this.div10(angle.lowerTolerance1),
                    pAlumineTolerants2: this.div10(angle.lowerTolerance2)
                };
                let pointOffsets = [
                    this.getPointOffset(this.fixPointName(angle.point1, i), i),
                    this.getPointOffset(this.fixPointName(angle.point2, i), i)
                ];
                for (let p of pointOffsets)if (p != null) state.anglePoints[p] = true;
            }
        }
        // Otspunktide info
        // Joonte info
        let k = 0;
        for(let i = 0; i < state.lineCount; i++){
            for(let j = 0; j < 2; j++){
                state.ex[k] = this.div10(g.measurementLines[i].endpoints[j].x);
                state.ey[k] = this.div10(g.measurementLines[i].endpoints[j].y);
                state.ez[k] = this.div10(g.measurementLines[i].endpoints[j].z);
                state.eKalleA[k] = this.div10(g.measurementLines[i].endpoints[j].slopeX);
                state.eKalleB[k] = this.div10(g.measurementLines[i].endpoints[j].slopeY);
                state.s[k] = this.div10(g.measurementLines[i].endpoints[j].printOffset);
                k++;
            }
            state.pikkus[i] = this.div10(g.measurementLines[i].lineLength);
        }
        state.scan = g.scanCode;
        state.mudeliNimi = g.description;
        state.klaasiPaksus = this.div10(g.glassThickness);
        state.profiilKlaasil = g.measuringProfileGlass;
        state.profiilTrykil = g.measuringProfilePrint;
        state.xnihe = state.ynihe = state.distants = 0;
        if (!isNaN(g.offsetX)) state.xnihe = this.div10(g.offsetX);
        if (!isNaN(g.offsetY)) state.ynihe = this.div10(g.offsetY);
        if (!isNaN(g.distance)) state.distants = this.div10(g.distance);
        state.xdiff = this.div10(g.diffX);
        state.ydiff = this.div10(g.diffY);
        state.enihe = this.div10(g.offsetE);
        state.joona = this.dupDivArray(g.lineLower);
        state.joony = this.dupDivArray(g.lineUpper);
        state.px = this.dupDivArray(g.pX);
        state.py = this.dupDivArray(g.pY);
        state.keeratud = g.rotatedLine;
        state.tolerants1k = this.div10(g.toleranceMiddle1);
        state.tolerants2k = this.div10(g.toleranceMiddle2);
        state.tolerants1s = this.div10(g.toleranceEdge1);
        state.tolerants2s = this.div10(g.toleranceEdge2);
        state.kood = g.codeVariant;
        state.peegeldatud = g.mirrored;
        state.rotated = g.rotated;
        if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(state.px) || state.px.length == 0) state.calcPV();
        state.hudx = state.calcHudV();
        //if (!_.isArray(state.joona) || state.joona.length == 0) ProductTransformer.calcJoonAY();
        state.keeratud_esimene = g.rotatedFirst;
        state.keeratud_viimane = g.rotatedLast;
        for(let i = 0; i < Math.min(state.adasAreasCount, g.adasAreas != null ? g.adasAreas.length : 0); i++){
            state.adasarea_type[i] = $d02c132c9fe52fc9$var$ProductTransformer.numberToString(g.adasAreas[i].type);
            state.adasarea_distance[i] = this.div10(g.adasAreas[i].distance);
        }
        return state;
    }
    /**
   *
   * @param {ProductInfo} state
   * @returns {GlassProduct}
   */ stateToGlassProduct(state) {
        /**
     * @type {GlassProduct}
     */ let g = new (0, $02b06578fcb6b8be$export$2e2bcd8739ae039)();
        g.lineCount = state.lineCount;
        g.measurementLines = [];
        for(let k = 0; k < state.pNominaal.length; k++){
            if (!state.pOlemas[k]) continue;
            let n = new (0, $02b06578fcb6b8be$export$b80053ee3576378f)();
            n.upperTolerance2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pYlemineTolerants2[k]);
            n.upperTolerance1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pYlemineTolerants1[k]);
            n.value = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pNominaal[k]);
            n.lowerTolerance1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pAlumineTolerants1[k]);
            n.lowerTolerance2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pAlumineTolerants2[k]);
            n.isAdas = state.adas === k;
            n.distance = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pv[k]);
            n.correction = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pKorrektsioon[k]);
            n.name = this.getPointName(k);
            let i = state.pJoon[k];
            if (!g.measurementLines[i]) {
                g.measurementLines[i] = new (0, $02b06578fcb6b8be$export$8d82331306cb3c9)();
                g.measurementLines[i].lineLength = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pikkus[i]);
            }
            g.measurementLines[i].nominals.push(n);
        }
        for(let k = 0; k < state.hudPoints; k++){
            if (state.hudLine == null || state.hudv == null || state.hudv.length <= k) break;
            if (state.hudNominaal[k] == null) continue;
            let n = new (0, $02b06578fcb6b8be$export$b80053ee3576378f)();
            n.upperTolerance2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.hudYlemineTolerants2[k]);
            n.upperTolerance1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.hudYlemineTolerants1[k]);
            n.value = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.hudNominaal[k]);
            n.lowerTolerance1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.hudAlumineTolerants1[k]);
            n.lowerTolerance2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.hudAlumineTolerants2[k]);
            n.isAdas = false;
            n.distance = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.hudv[k]);
            n.correction = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.hudKorrektsioon[k]);
            n.name = "H" + (k + 1);
            let i = state.hudLine - 1;
            if (!g.measurementLines[i]) {
                g.measurementLines[i] = new (0, $02b06578fcb6b8be$export$8d82331306cb3c9)();
                g.measurementLines[i].lineLength = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.pikkus[i]);
            }
            g.measurementLines[i].nominals.push(n);
        }
        if (state.angle) {
            let a = new (0, $02b06578fcb6b8be$export$34d194eb3f4b4115)();
            a.upperTolerance2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.angle.pYlemineTolerants2);
            a.upperTolerance1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.angle.pYlemineTolerants1);
            a.value = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.angle.pNominaal);
            a.lowerTolerance1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.angle.pAlumineTolerants1);
            a.lowerTolerance2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.angle.pAlumineTolerants2);
            a.name = "ANGLE";
            let anglePoints = [];
            for(let i = 0; i < state.anglePoints.length; i++)if (state.anglePoints[i]) anglePoints.push(i);
            if (anglePoints.length > 0) a.point1 = this.getPointName(anglePoints[0]);
            if (anglePoints.length > 1) a.point2 = this.getPointName(anglePoints[1]);
            // Find out middle line number:
            let middleLine = Math.floor(state.lineCount / 2);
            g.measurementLines[middleLine].angles = [
                a
            ];
        }
        let k = 0;
        for(let i = 0; i < state.lineCount; i++)for(let j = 0; j < 2; j++){
            let e = new (0, $02b06578fcb6b8be$export$ca3bb03eef24f110)();
            e.x = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.ex[k]);
            e.y = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.ey[k]);
            e.z = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.ez[k]);
            e.slopeX = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.eKalleA[k]);
            e.slopeY = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.eKalleB[k]);
            e.printOffset = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.s[k]);
            g.measurementLines[i].endpoints.push(e);
            k++;
        }
        g.scanCode = state.scan;
        g.description = state.mudeliNimi;
        g.glassThickness = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.klaasiPaksus);
        g.measuringProfileGlass = state.profiilKlaasil;
        g.measuringProfilePrint = state.profiilTrykil;
        // (CStr(Round(maxx - minx, 1)) + ";" + CStr(Round(maxy - miny, 1)) + ";")
        g.diffX = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.glass.maxx - state.glass.minx);
        g.diffY = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.glass.maxy - state.glass.miny);
        g.offsetX = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.xnihe);
        g.offsetY = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.ynihe);
        g.distance = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.distants);
        g.offsetE = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.enihe);
        g.lineLower = $d02c132c9fe52fc9$var$ProductTransformer.round10Array(state.joona);
        g.lineUpper = $d02c132c9fe52fc9$var$ProductTransformer.round10Array(state.joony);
        g.pX = $d02c132c9fe52fc9$var$ProductTransformer.round10Array(state.px);
        g.pY = $d02c132c9fe52fc9$var$ProductTransformer.round10Array(state.py);
        g.rotatedLine = state.keeratud;
        g.toleranceMiddle1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.tolerants1k);
        g.toleranceMiddle2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.tolerants2k);
        g.toleranceEdge1 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.tolerants1s);
        g.toleranceEdge2 = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.tolerants2s);
        g.codeVariant = state.kood;
        g.mirrored = state.peegeldatud;
        g.rotated = state.rotated;
        g.rotatedFirst = state.keeratud_esimene;
        g.rotatedLast = state.keeratud_viimane;
        for(let i = 0; i < state.adasAreasCount; i++){
            g.adasAreas[i] = new (0, $02b06578fcb6b8be$export$22c3bf686f4e628e)();
            g.adasAreas[i].type = $d02c132c9fe52fc9$var$ProductTransformer.stringToInteger(state.adasarea_type[i]);
            g.adasAreas[i].distance = $d02c132c9fe52fc9$var$ProductTransformer.round10(state.adasarea_distance[i]);
        }
        return g;
    }
    /**
   * @private
   * @param {Array} arr
   * @param {number} mult
   * @returns {Array}
   */ static dupArray(arr, mult) {
        return (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).map(arr, function(val) {
            if (val == null || (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNaN(val)) return null;
            return val * mult;
        });
    }
    dupDivArray(arr) {
        return (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).map(arr, (function(val) {
            return this.div10(val);
        }).bind(this));
    }
    div10(val) {
        if (val == null || (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNaN(val)) return val;
        return +(Math.round(val / 10 + "e+1") + "e-1");
    }
    /**
   * @private
   * @param val
   * @returns {number}
   */ static round10(val) {
        if (val == null || (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNaN(val)) return null;
        return Math.round(val * 10);
    }
    /**
   * @private
   * @param {Array} arr
   * @returns {Array}
   */ static round10Array(arr) {
        return (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).map(arr, function(val) {
            return $d02c132c9fe52fc9$var$ProductTransformer.round10(val);
        });
    }
    /**
   * Returns a point type based by its name.
   *
   * Mapping:
   *  * "Pi" -> "P"
   *  * "Hi" -> "H"
   *  * "ANGLE" -> "A"
   * @param name
   * @returns {string|null}
   */ getPointType(name) {
        if (name == null) return null;
        return name.substring(0, 1);
    }
    /**
   * Tagastab punkti offseti massiivides selle punkti joone ja nime baasilt
   * @protected
   * @param {string} name Punkti nimi: Pi, Hi, ANGLE
   * @returns {?number} Punkti offset punkti massiivides
   */ getPointOffset(name) {
        if (name == null) return null;
        let pointType = this.getPointType(name);
        switch(pointType){
            case "P":
                // Pi
                let pName = name.substring(1);
                let d = parseInt(pName, 10);
                let i = 0;
                if (d < 50) i = d - 1;
                else i = this.productConfig.lineCount * 3 + Math.floor(d / 50) - 1;
                return i;
            case "H":
                // Hi
                return parseInt(name.substring(1), 10) - 1;
            case "A":
                // ANGLE / ANGLEi
                if (name === "ANGLE") return 0;
                return parseInt(name.substring(5), 10) - 1;
            default:
                return null;
        }
    }
    fixPointName(name, line) {
        if (name == null) return null;
        switch(name.substring(0, 1)){
            case "A":
                if (name.startsWith("ANGLE")) return name;
                return "P" + (line * 3 + 1).toString();
            case "B":
                return "P" + (line * 3 + 2).toString();
            case "C":
                return "P" + (line * 3 + 3).toString();
            case "H":
                if (name.substring(0, 3) === "HUD") return "H" + name.substring(3);
            // Intentional fallthrough
            default:
                return name;
        }
    }
    /**
   * Tagastab punkti ametliku nime offseti baasilt.
   * Eeldatud on, et punktid on järjestatud: [P1, P2, P3, ..., P7/13, P8/14, P9/15, P50, P100, ..., P300], kus n on joonte arv.
   * @param {number} offset Punkti asukoht kõikide nominaalide sorteeritud massiivis
   * @returns {string}
   */ getPointName(offset) {
        if (offset < this.productConfig.lineCount * 3) return "P" + (offset + 1).toString();
        else {
            let shift = offset - this.productConfig.lineCount * 3;
            return "P" + (shift * 50 + 50).toString();
        }
    }
    getOrderedNominals(lines) {
        lines = this.fixNominals(lines);
        let names = this.getOrderedNominalNames();
        let namesMap = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).object((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).map(names, function(v, i) {
            return [
                v,
                i
            ];
        }));
        let items = [];
        for (let l of lines){
            if (l.nominals != null) {
                for (let n of l.nominals)if (n.name in namesMap) items[namesMap[n.name]] = n;
            }
            if (l.angles != null) {
                for (let a of l.angles)if (a.name in namesMap) items[namesMap[a.name]] = a;
            }
        }
        for(let i = 0; i < names.length; i++)if (items[i] == null) {
            if (names[i] === "ANGLE") items[i] = new (0, $02b06578fcb6b8be$export$34d194eb3f4b4115)({
                name: "ANGLE"
            });
            else items[i] = new (0, $02b06578fcb6b8be$export$b80053ee3576378f)({
                name: names[i]
            });
        }
        return items;
    }
    /**
   * Tagastab nominaalide nimed järgmises järjestuses:
   *  * P1, P2, P3
   *  * P4, P5, P6
   *  * P7, P8, P9
   *  * P10, P11, P12 - kui on konfis määratud 5 rida
   *  * P13, P14, P15 - kui on konfis määratud 5 rida
   *  * P50, P100, ..., P300 - kui on konfis määratud lisapunktid
   *  * H1, H2, ..., H5 - kui on konfis määratud HUD punktid
   *  * ANGLE, ..., ANGLE - kui on konfis määratud nurgad
   */ getOrderedNominalNames() {
        let names = [];
        for(let i = 1; i <= this.productConfig.lineCount * 3; i++)names.push("P" + i.toString());
        for(let i = 50; i <= this.productConfig.addPoints * 50; i += 50)names.push("P" + i.toString());
        for(let i = 1; i <= this.productConfig.hudPoints; i++)names.push("H" + i.toString());
        for(let i = 1; i <= this.productConfig.angleCount; i++)names.push("ANGLE");
        return names;
    }
    fixNominals(lines) {
        for(let i = 0; i < lines.length; i++)for (let m of lines[i].nominals){
            switch(m.name.substring(0, 1)){
                case "A":
                    m.name = "P" + (i * 3 + 1).toString();
                    break;
                case "B":
                    m.name = "P" + (i * 3 + 2).toString();
                    break;
                case "C":
                    m.name = "P" + (i * 3 + 3).toString();
                    break;
                default:
                    break;
            }
            m.line = i;
        }
        return lines;
    }
    static isCenterPoint(name) {
        if (name.substring(0, 1) === "B") return true;
        if (name.substring(0, 1) !== "P") return false;
        let pnum = parseInt(name.substring(1), 10);
        return pnum < 50 && (pnum - 1) % 3 === 1;
    }
    static stringToInteger(value) {
        if (value == null || value == "") return null;
        let numval = parseInt(value);
        return (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isNaN(numval) ? null : numval;
    }
    static numberToString(value) {
        return value == null ? null : value.toString();
    }
    constructor(productConfig){
        this.productConfig = productConfig;
    }
}
var $d02c132c9fe52fc9$export$2e2bcd8739ae039 = $d02c132c9fe52fc9$var$ProductTransformer;


//import Legacy from "../Legacy";
let $6ccb96d500665de3$var$ProductSource = {
    fetchProduct (code) {
        return {
            remote (state, code) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).getProduct(code);
            },
            local () {
                return null;
            },
            success: (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchProductDone,
            error: (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchProductFailed
        };
    },
    saveProduct () {
        return {
            remote (state) {
                try {
                    // TODO: Lisada joonte arv ja P-punktide arv parameetriteks
                    let transformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)(state);
                    let data = transformer.stateToGlassProduct(state);
                    return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).postProduct(data.codeVariant, data);
                } catch (e) {
                    if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                        console.log(e.toString());
                        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Internal error"));
                    } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
                    return new Promise((resolve, reject)=>{
                        reject(e);
                    });
                }
            },
            local () {
                return null;
            },
            success: (0, $c148c8994a598409$export$2e2bcd8739ae039).saveProductDone,
            error: (0, $c148c8994a598409$export$2e2bcd8739ae039).saveProductFailed
        };
    },
    deleteProduct (code) {
        return {
            remote (state, code) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).deleteProduct(code);
            },
            local () {
                return null;
            },
            success: (0, $c148c8994a598409$export$2e2bcd8739ae039).deleteProductDone,
            error: (0, $c148c8994a598409$export$2e2bcd8739ae039).deleteProductFailed
        };
    },
    fetchNcp (code, type) {
        return {
            remote (state, code, type) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).getNcp(code, type);
            },
            local () {
                return null;
            },
            success: (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchNcpDone,
            error: (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchNcpFailed
        };
    },
    saveNcp () {
        return {
            remote (state) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).putNcp(state.kood, state.ncpType, state.ncpData);
            },
            local () {
                return null;
            },
            success: (0, $c148c8994a598409$export$2e2bcd8739ae039).saveNcpDone,
            error: (0, $c148c8994a598409$export$2e2bcd8739ae039).saveNcpFailed
        };
    }
};
var $6ccb96d500665de3$export$2e2bcd8739ae039 = $6ccb96d500665de3$var$ProductSource;






const $ae7147190905e1cb$var$allowedParams = {
    // csvParamName: [productFieldName, dataType]
    rotated: [
        "rotated",
        'boolean'
    ],
    keeratud_esimene: [
        "rotatedFirst",
        'boolean'
    ],
    keeratud_viimane: [
        "rotatedLast",
        'boolean'
    ]
};
/**
 * Parsib GR2 faili sisse ja tekitab sellest mälustrkutuuri
 */ class $ae7147190905e1cb$var$GrFileParser {
    /**
   * Parses product data in CSV form and returns product in internal state form
   * @param data
   * @param isOld
   * @returns {GlassProduct}
   */ parse(data, isOld) {
        let klpmsData = this.parseData(data, isOld);
        if (klpmsData == null) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid data");
        return klpmsData;
    }
    /**
   * Parsib GR2 faili sisse ning tekitab serveri poolt kasutatava tooteinfo JSON struktuuri
   * @param {string} data CSV formaadis GR2 faili andmed
   * @returns {GlassProduct} Tooteinfo esitus
   */ parseData(data) {
        let version = 1;
        let lineCount = 3;
        let lines = data.split(/\r?\n/);
        let res = new (0, $02b06578fcb6b8be$export$2e2bcd8739ae039)();
        // Nominaalid
        let atmp = [];
        if (lines.length == 0) return null;
        let curLine = lines.shift();
        let els = curLine.split(";");
        if (els.length < 5) {
            // Uus failiversioon:
            version = this.pn(els[0]);
            if (lines.length == 0) return null;
            curLine = lines.shift();
            els = curLine.split(";");
            lineCount = this.pn(els[0]);
            curLine = lines.shift();
        }
        while(typeof curLine !== "undefined"){
            els = curLine.split(";");
            if (els.length < 5) break;
            atmp.push(new (0, $02b06578fcb6b8be$export$b80053ee3576378f)({
                value: this.pgn(els[0]),
                upperTolerance1: this.pgn(els[1]),
                upperTolerance2: this.pgn(els[2]),
                lowerTolerance1: this.pgn(els[3]),
                lowerTolerance2: this.pgn(els[4])
            }));
            curLine = lines.shift();
        }
        if (typeof curLine === "undefined") return null;
        if (atmp.length % 3 != 0) return null;
        if (version === 1) lineCount = atmp.length / 3;
        res.version = version;
        res.lineCount = lineCount;
        res.measurementLines = [];
        let k = 0;
        // Mõõtepunktide nominaalväärtused
        for(let i = 0; i < lineCount; i++){
            let l = new (0, $02b06578fcb6b8be$export$8d82331306cb3c9)();
            for(let j = 0; j < 3; j++){
                switch(j){
                    case 0:
                        atmp[k].name = "A" + (i + 1).toString();
                        break;
                    case 1:
                        atmp[k].name = "B" + (i + 1).toString();
                        break;
                    case 2:
                        atmp[k].name = "C" + (i + 1).toString();
                        break;
                    default:
                        break;
                }
                l.nominals.push(atmp[k++]);
            }
            res.measurementLines.push(l);
        }
        // Mõõtepunktide kaugused ja korrektsioonid
        for(let i = 0; i < lineCount; i++)for(let j = 0; j < 3; j++){
            els = curLine.split(";");
            res.measurementLines[i].nominals[j].distance = this.pgn(els[0]);
            res.measurementLines[i].nominals[j].correction = this.pgn(els[1]);
            curLine = lines.shift();
            if (typeof curLine === "undefined") return null;
        }
        // Otspunktid ja trüki kaugused
        for(let i = 0; i < lineCount; i++)for(let j = 0; j < 2; j++){
            els = curLine.split(";");
            res.measurementLines[i].endpoints[j] = new (0, $02b06578fcb6b8be$export$ca3bb03eef24f110)({
                x: this.pgn(els[0]),
                y: this.pgn(els[1]),
                z: this.pgn(els[2]),
                slopeX: this.pgn(els[3]),
                slopeY: this.pgn(els[4]),
                printOffset: this.pgn(els[5])
            });
            curLine = lines.shift();
            if (typeof curLine === "undefined") return null;
        }
        // Joonte pikkused
        atmp = curLine.split(";");
        for(let i = 0; i < lineCount; i++)res.measurementLines[i].lineLength = this.pgn(atmp[i]);
        // Kirjeldused
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["scanCode"] = this.pgs(els[0]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["description"] = this.pgs(els[0]);
        // Klaasi paksus, profiil, trüki profiil:
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["glassThickness"] = this.pgn(els[0]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["measuringProfileGlass"] = this.pgs(els[0]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res["measuringProfilePrint"] = this.pgs(els[0]);
        // Omaloomingulised asjad GR2 faili lõpus:
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['diffX'] = this.pgn(els[0]);
        res['diffY'] = this.pgn(els[1]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['offsetX'] = this.pgn(els[0]);
        res['offsetY'] = this.pgn(els[1]);
        if (res['offsetX'] != 0) {
            // Arvutame otspunktide x koordinaadid nihke baasilt ümber:
            for(let i = 0; i < lineCount; i++)for(let j = 0; j < 2; j++)res.measurementLines[i].endpoints[j].x -= res.offsetX;
        }
        if (res['offsetY'] != 0) {
            // Arvutame otspunktide y koordinaadid nihke baasilt ümber:
            for(let i = 0; i < lineCount; i++)for(let j = 0; j < 2; j++)res.measurementLines[i].endpoints[j].y -= res.offsetY;
        }
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['offsetE'] = this.pgn(els[0]);
        res.lineLower = [];
        res.lineUpper = [];
        for(let i = 0; i < lineCount; i++){
            if (version < 2 && i == Math.floor(lineCount / 2)) {
                res.lineUpper[i] = 0;
                res.lineLower[i] = 0;
                continue;
            }
            if (lines.length === 0) return res;
            curLine = lines.shift();
            if (typeof curLine === "undefined") return res;
            els = curLine.split(";");
            res.lineUpper[i] = this.pgn(els[0]);
            res.lineLower[i] = this.pgn(els[1]);
        }
        res.pX = [];
        res.pY = [];
        for(let i = 0; i < lineCount * 3; i++){
            curLine = lines.shift();
            if (typeof curLine === "undefined") return res;
            els = curLine.split(";");
            res.pX[i] = this.pgn(els[0]);
            res.pY[i] = this.pgn(els[1]);
        }
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['rotatedLine'] = els[0] == 0 ? false : true;
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        res['toleranceMiddle1'] = this.pgn(els[0]);
        res['toleranceMiddle2'] = this.pgn(els[1]);
        res['toleranceEdge1'] = this.pgn(els[2]);
        res['toleranceEdge2'] = this.pgn(els[3]);
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        let kood = this.pgs(els[0]);
        res['mirrored'] = false;
        if (kood !== "mirrored") {
            res.codeVariant = kood;
            curLine = lines.shift();
            if (typeof curLine === "undefined") return res;
            els = curLine.split(";");
        }
        if (this.pgs(els[0]) === "mirrored") res['mirrored'] = true;
        else res['mirrored'] = false;
        curLine = lines.shift();
        if (typeof curLine === "undefined") return res;
        els = curLine.split(";");
        if (els[0] === "PARAMS") this.parseParams(res, lines);
        return res;
    }
    parseParams(res, lines) {
        if (lines === null) return;
        while(lines.length > 0){
            let curLine = lines.shift();
            let els = curLine.split(";");
            let param = els[0];
            let value = els[1];
            if (param === null || param.length == 0 || value === null || value === "") continue;
            if ($ae7147190905e1cb$var$allowedParams[param]) res[$ae7147190905e1cb$var$allowedParams[param][0]] = this.getParamValue(param, value);
        }
    }
    getParamValue(param, value) {
        switch($ae7147190905e1cb$var$allowedParams[param][1]){
            case 'boolean':
                if (value === null) return false;
                value = value.toLowerCase();
                return value === "true";
            case 'integer':
                if (value === null) return 0;
                return Number.parseInt(value);
            case 'number':
                if (value === null) return 0;
                value = value.replace(',', '.');
                return Number.parseFloat(value);
            default:
                return value;
        }
    }
    /**
   * Tekitab GR2 faili sisu ja tagastab selle. Sisenduks tuleb esitada JSON tooteinfo objekt.
   * @param {GlassProduct} data
   * @returns {string}
   */ write(data) {
        this.lines = [];
        this.writeCsv([
            this.version
        ]);
        this.writeCsv([
            data.lineCount
        ]);
        for(let i = 0; i < data.lineCount; i++)for(let j = 0; j < 3; j++){
            let n = data.measurementLines[i].nominals[j];
            this.writeCsv([
                this.wgn(n.value),
                this.wgn(n.upperTolerance1),
                this.wgn(n.upperTolerance2),
                this.wgn(n.lowerTolerance1),
                this.wgn(n.lowerTolerance2)
            ]);
        }
        for(let i = 0; i < data.lineCount; i++)for(let j = 0; j < 3; j++){
            let n = data.measurementLines[i].nominals[j];
            this.writeCsv([
                this.wgn(n.distance),
                this.wgn(n.correction)
            ]);
        }
        if (data.diffX === undefined || data.diffX === null) data.diffX = 0;
        if (data.diffY === undefined || data.diffY === null) data.diffY = 0;
        for(let i = 0; i < data.lineCount * 2; i++)for(let j = 0; j < 2; j++){
            let o = data.measurementLines[i].endpoints[j];
            this.writeCsv([
                this.wgn(o.x + data.diffX),
                this.wgn(o.y + data.diffY),
                this.wgn(o.z),
                this.wgn(o.slopeX),
                this.wgn(o.slopeY),
                this.wgn(o.printOffset)
            ]);
        }
        let a = [];
        for(let i = 0; i < data.lineCount; i++)a[i] = this.wgn(data.measurementLines[i].lineLength);
        this.writeCsv(a);
        this.writeCsv([
            this.wgs(data.scanCode)
        ]); // SCAN
        this.writeCsv([
            this.wgs(data.description)
        ]); // Kirjeldus
        this.writeCsv([
            this.wgn(data.glassThickness)
        ]);
        this.writeCsv([
            this.wgs(data.measuringProfileGlass)
        ]);
        this.writeCsv([
            this.wgs(data.measuringProfilePrint)
        ]);
        // Laiendused:
        this.writeCsv([
            this.wgn(data.diffX),
            this.wgn(data.diffY)
        ]);
        this.writeCsv([
            this.wgn(data.offsetX),
            this.wgn(data.offsetY)
        ]);
        this.writeCsv([
            this.wgn(data.offsetE)
        ]);
        for(let i = 0; i < data.lineCount; i++)this.writeCsv([
            this.wgn(data.lineUpper[i]),
            this.wgn(data.lineLower[i])
        ]);
        for(let i = 0; i < data.lineCount * 3; i++)this.writeCsv([
            this.wgn(data.pX[i]),
            this.wgn(data.pY[i])
        ]);
        this.writeCsv([
            this.wgs(data.rotatedLine ? '1' : '0')
        ]);
        this.writeCsv([
            this.wgn(data.toleranceMiddle1),
            this.wgn(data.toleranceMiddle2),
            this.wgn(data.toleranceEdge1),
            this.wgn(data.toleranceEdge2)
        ]);
        this.writeCsv([
            data.codeVariant
        ]);
        if (data.mirrored) this.writeCsv([
            'mirrored'
        ]);
        this.writeCsv([
            ''
        ]);
        this.writeCsv([
            'PARAMS'
        ]);
        this.writeParams(data);
        let res = this.lines.join("\r\n") + "\r\n";
        this.lines = [];
        return res;
    }
    writeParams(data) {
        for (let param of (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).keys($ae7147190905e1cb$var$allowedParams)){
            let name = $ae7147190905e1cb$var$allowedParams[param][0];
            if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).has(data, name) && data[name] !== null && data[name] !== "") this.writeCsv([
                param,
                data[name]
            ]);
        }
    }
    writeCsv(data) {
        // NB! Windowsi GR2 tarkvara nõuab, et rea lõpus on ';'
        this.lines.push(data.join(';') + ";");
    }
    pn(s) {
        if (!s) return 0;
        s = s.replace(",", ".");
        s = s.replace("\n", "");
        s = s.replace("\r", "");
        return Number.parseFloat(s);
    }
    pgn(s) {
        return Math.round(this.pn(s) * 10);
    }
    pgs(s) {
        if (!s) return s;
        s = s.replace("\n", "");
        s = s.replace("\r", "");
        return s;
    }
    wgn(s) {
        if (!s) return "0";
        s = Math.round(s) / 10;
        return s.toString().replace(".", ",");
    }
    wgs(s) {
        if (s === undefined || s === null || Number.isNaN(s)) return '';
        return s.toString();
    }
    constructor(){
        this.version = 2;
    }
}
var $ae7147190905e1cb$export$2e2bcd8739ae039 = $ae7147190905e1cb$var$GrFileParser;


/**
 * Created by ivo on 08.01.17.
 *
 * NCP files parser
 */ /**
 * Created by ivo on 08.01.17.
 *
 */ 
let $07d0e999e7d9c0a7$var$PARSED_FIELDS = [
    "ridu",
    "joonx1",
    "joonx2",
    "joony1",
    "joony2"
];
/**
 *
 * Common abstract class for parsing Glass data files
 */ class $07d0e999e7d9c0a7$var$GlassFileParser {
    /**
   * Parse glass info file and return parsed structure
   * @param {string} data Glass info file content as string
   * @returns {{}} Glass info structure as follows:
   *      {
   *          "ridu": intVal
   *          "joonx1": array,
   *          "joonx2": array,
   *          "joony1": array,
   *          "joony2": array,
   *      }
   */ parse(data) {
        this.resetParser();
        this.setInputData(data);
        this.parseData();
        this.resetInputData();
        return this.getParsedData();
    }
    /**
   * Child classes should overwrite this method and implement actual file parsing here.
   * Class should read data with the help of method this.readLine() (this method throws when trying to read
   * over the file end) and assign appropriate values for object fields.
   * @returns {{}}
   */ parseData() {
        // Child classes should overwrite this method
        return {};
    }
    resetParser() {
        // Ajutine sisseloetava faili ridade massiiv
        this.lines = null;
        // Hetkel parsitava faili rea number
        this.lineno = 0;
        this.joonx1 = [];
        this.joonx2 = [];
        this.joony1 = [];
        this.joony2 = [];
        this.ridu = 0;
    }
    getParsedData() {
        let result = {};
        for (let item of $07d0e999e7d9c0a7$var$PARSED_FIELDS)result[item] = this[item];
        return result;
    }
    setInputData(data) {
        this.lines = data.split(/\r?\n/);
        this.lineno = 0;
    }
    resetInputData() {
        this.lines = null;
    }
    readLine() {
        if (this.lines.length == 0) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Unexpected end of data");
        let l = this.lines.shift();
        this.lineno++;
        return l;
    }
    constructor(isRotated){
        this.resetParser();
    }
}
var $07d0e999e7d9c0a7$export$2e2bcd8739ae039 = $07d0e999e7d9c0a7$var$GlassFileParser;



/**
 * NCP file parser
 *
 * Supports the following commands in this G-file:
 * G01 - Linear Feed Move (X, Y, Z)
 * G02 - Clockwise Arc Feed Move (X, Y, Z, R)
 * G03 - Counter Clockwise Arc Feed Move (X, Y, Z, R)
 * G05 - ???
 */ class $cd53ff756e192b16$var$NcpFileParser extends (0, $07d0e999e7d9c0a7$export$2e2bcd8739ae039) {
    /**
   * Parses glass data file
   */ parseData() {
        // Vt rida 4061 failis ncp2gr.frm
        // Esimene rida on '%'
        let l = this.readLine();
        if (l !== "%") throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid data, missing start signature on line %s", this.lineno);
        // Teine rida on nimetus (alates teisest positsioonist);
        l = this.readLine();
        this.label = l.substring(1);
        // Igonreerime kõiki ridu, mis ei oma rea alguses "G05":
        l = this.readLine();
        while(l.substring(0, 3) !== "G05")l = this.readLine();
        let i = 0;
        this.joonsuund = [];
        this.raadius = [];
        this.joonx1 = [];
        this.joonx2 = [];
        this.joony1 = [];
        this.joony2 = [];
        l = this.readLine();
        this.joonsuund[i] = l.substring(0, 3);
        let re01 = /^G01 ?X([-0-9.]+) ?Y([-0-9.]+) ?Z([-0-9.]+)/i;
        let re02 = /^G0[2-3] ?X([-0-9.]+) ?Y([-0-9.]+) ?Z([-0-9.]+) ?R([-0-9.]+)$/i;
        while(this.joonsuund[i] !== "G05"){
            if (this.joonsuund[i] == "G01" || this.joonsuund[i] == "G02" || this.joonsuund[i] == "G03") {
                let info = l.match(this.joonsuund[i] === "G01" ? re01 : re02);
                if (!info) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid data on line %s", this.lineno);
                if (this.rotated) {
                    this.joonx2[i] = Number.parseFloat(info[1]);
                    this.joonx1[i + 1] = this.joonx2[i];
                    this.joony2[i] = Number.parseFloat(info[2]);
                    this.joony1[i + 1] = this.joony2[i];
                } else {
                    this.joony2[i] = Number.parseFloat(info[1]);
                    this.joony1[i + 1] = this.joony2[i];
                    this.joonx2[i] = Number.parseFloat(info[2]);
                    this.joonx1[i + 1] = this.joonx2[i];
                }
                if (this.joonsuund[i] !== "G01") {
                    this.raadius[i] = Number.parseFloat(info[4]);
                    // NB! Seda tuleb teha ainult Poola failide korral:
                    if (this.rotated) {
                        if (this.joonsuund[i] === "G02") this.joonsuund[i] = "G03";
                        else this.joonsuund[i] = "G02";
                    }
                }
                i++;
            }
            l = this.readLine();
            this.joonsuund[i] = l.substring(0, 3);
        }
        this.ridu = i;
        // Laseme faili sisu hoidva mälu lahti:
        this.resetInputData();
        this.joonx1[0] = this.joonx2[this.ridu - 1];
        this.joony1[0] = this.joony2[this.ridu - 1];
        this.kandiline = true;
        while(this.kandiline)this.kaaresta();
    }
    kaaresta() {
        this.kandiline = false;
        let ajutx1 = [];
        let ajuty1 = [];
        let ajutx2 = [];
        let ajuty2 = [];
        let ajutr = [];
        let ajutsuund = [];
        let ajut_i = 0;
        for(let i = 0; i < this.ridu; i++)if (this.joonsuund[i] !== "G01") {
            let abia = (this.joonx2[i] - this.joonx1[i]) * (this.joonx2[i] - this.joonx1[i]) + (this.joony2[i] - this.joony1[i]) * (this.joony2[i] - this.joony1[i]);
            let a = Math.sqrt(abia) / 2;
            if (a > 10) {
                this.kandiline = true;
                let x3 = (this.joonx1[i] + this.joonx2[i]) / 2;
                let y3 = (this.joony1[i] + this.joony2[i]) / 2;
                let d = this.raadius[i] - Math.sqrt(this.raadius[i] * this.raadius[i] - a * a);
                let alfa = 0;
                if (this.joonx1[i] == this.joonx2[i]) alfa = Math.PI / 4;
                else alfa = Math.atan(Math.abs((this.joony2[i] - this.joony1[i]) / (this.joonx2[i] - this.joonx1[i])));
                let x4 = 0;
                let y4 = 0;
                if (this.joonx2[i] >= this.joonx1[i] && this.joony2[i] >= this.joony1[i]) {
                    if (this.joonsuund[i] == "G03") {
                        x4 = x3 - d * Math.sin(alfa);
                        y4 = y3 + d * Math.cos(alfa);
                    } else {
                        x4 = x3 + d * Math.sin(alfa);
                        y4 = y3 - d * Math.cos(alfa);
                    }
                }
                if (this.joonx2[i] < this.joonx1[i] && this.joony2[i] > this.joony1[i]) {
                    if (this.joonsuund[i] == "G03") {
                        x4 = x3 - d * Math.sin(alfa);
                        y4 = y3 - d * Math.cos(alfa);
                    } else {
                        x4 = x3 + d * Math.sin(alfa);
                        y4 = y3 + d * Math.cos(alfa);
                    }
                }
                if (this.joonx2[i] <= this.joonx1[i] && this.joony2[i] <= this.joony1[i]) {
                    if (this.joonsuund[i] == "G03") {
                        x4 = x3 + d * Math.sin(alfa);
                        y4 = y3 - d * Math.cos(alfa);
                    } else {
                        x4 = x3 - d * Math.sin(alfa);
                        y4 = y3 + d * Math.cos(alfa);
                    }
                }
                if (this.joonx2[i] > this.joonx1[i] && this.joony2[i] < this.joony1[i]) {
                    if (this.joonsuund[i] == "G03") {
                        x4 = x3 + d * Math.sin(alfa);
                        y4 = y3 + d * Math.cos(alfa);
                    } else {
                        x4 = x3 - d * Math.sin(alfa);
                        y4 = y3 - d * Math.cos(alfa);
                    }
                }
                ajutx1[ajut_i] = this.joonx1[i];
                ajuty1[ajut_i] = this.joony1[i];
                ajutx2[ajut_i] = x4;
                ajuty2[ajut_i] = y4;
                ajutr[ajut_i] = this.raadius[i];
                ajutsuund[ajut_i] = this.joonsuund[i];
                ajut_i = ajut_i + 1;
                ajutx1[ajut_i] = x4;
                ajuty1[ajut_i] = y4;
                ajutx2[ajut_i] = this.joonx2[i];
                ajuty2[ajut_i] = this.joony2[i];
                ajutr[ajut_i] = this.raadius[i];
                ajutsuund[ajut_i] = this.joonsuund[i];
                ajut_i = ajut_i + 1;
            } else {
                ajutx1[ajut_i] = this.joonx1[i];
                ajuty1[ajut_i] = this.joony1[i];
                ajutx2[ajut_i] = this.joonx2[i];
                ajuty2[ajut_i] = this.joony2[i];
                ajutr[ajut_i] = this.raadius[i];
                ajutsuund[ajut_i] = this.joonsuund[i];
                ajut_i = ajut_i + 1;
            }
        } else {
            ajutx1[ajut_i] = this.joonx1[i];
            ajuty1[ajut_i] = this.joony1[i];
            ajutx2[ajut_i] = this.joonx2[i];
            ajuty2[ajut_i] = this.joony2[i];
            ajutr[ajut_i] = this.raadius[i];
            ajutsuund[ajut_i] = this.joonsuund[i];
            ajut_i = ajut_i + 1;
        }
        this.ridu = ajut_i;
        for(let i = 0; i < this.ridu; i++){
            this.joonx1[i] = ajutx1[i];
            this.joony1[i] = ajuty1[i];
            this.joonx2[i] = ajutx2[i];
            this.joony2[i] = ajuty2[i];
            this.joonsuund[i] = ajutsuund[i];
            this.raadius[i] = ajutr[i];
        }
    }
    constructor(isRotated){
        super();
        this.rotated = isRotated;
    }
}
var $cd53ff756e192b16$export$2e2bcd8739ae039 = $cd53ff756e192b16$var$NcpFileParser;


/**
 * Created by ivo on 08.01.17.
 *
 * DAT files parser
 */ 

class $01e540950c270f37$var$DatFileParser extends (0, $07d0e999e7d9c0a7$export$2e2bcd8739ae039) {
    /**
   * Parses glass data file
   */ parseData() {
        // Vt rida 3993 failis dat2gr2.frm
        // Failis on andmed esitatud ridades, iga rida on jagatud veergudeks, veerueraldajaks on TAB sümbol
        // Esimene rida on tahvelx, tahvely - seda ignoreerime (see arvutatakse globaalselt uuesti)
        let l = this.getFloatLine(2);
        // this.tahvelx = l[0];
        // this.tahvely = l[1];
        // Teine rida sisldab joonte arvu
        l = this.getIntLine(1);
        let jooni = l[0];
        // Edasi tuleb joonte arv ridu, mis määravad ridade arvud
        this.ridu = 0;
        let i = 0;
        for(i = 0; i < jooni; i++){
            l = this.getIntLine(3);
            this.ridu += l[1] - l[0] + 1;
        }
        // Edasi ignoreerime järelejäänud 30-(joonte arv) ridu:
        for(; i < 30; i++)this.readLine();
        // Ridade arv punkte:
        for(i = 0; i < this.ridu; i++){
            l = this.getFloatLine(6);
            if (l[2] != 0) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid data, arcs are not supported on line %s", this.lineno);
            this.joony1[i] = l[0];
            this.joony2[i] = l[1];
            this.joonx1[i] = l[3];
            this.joonx2[i] = l[4];
        }
    }
    /**
   * Loeb rea, parsib sellest veerud, teisendab numbriteks (võivad olla nii täisarvud kui reaalarvud) ning tagastab need massiivina.
   * Massiivis saab esineda ka null väärtusi - need vastavad tühjadele veergudele
   * Vigased numbrid toovad kaasa throw
   * @returns {Array}
   */ getLine(len) {
        let l = this.readLine();
        let result = [];
        if (l != null && l != "") {
            let splittedLine = l.split("\t");
            for (let val of splittedLine)if (val == "") result.push(null);
            else result.push(val);
        }
        if (len && result.length != len) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid data on line %s", this.lineno);
        return result;
    }
    getFloatLine(len) {
        let l = this.getLine(len);
        let values = [];
        for (let v of l)values.push(this.getFloat(v));
        return values;
    }
    getIntLine(len) {
        let l = this.getLine(len);
        let values = [];
        for (let v of l)values.push(this.getInt(v));
        return values;
    }
    getInt(val) {
        let numVal = Number.parseInt(val);
        if (Number.isNaN(numVal)) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid data on line %s", this.lineno);
        return numVal;
    }
    getFloat(val) {
        let numVal = Number.parseFloat(val);
        if (Number.isNaN(numVal)) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid data on line %s", this.lineno);
        return numVal;
    }
}
var $01e540950c270f37$export$2e2bcd8739ae039 = $01e540950c270f37$var$DatFileParser;






/**
 * Tooteinfo haldamise store
 */ class $c71c1aee47fee504$var$ProductStore {
    onSetSchema(schema) {
        this.schema = schema;
    }
    readProductData(info) {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchNcp.defer(info.code, info.type);
    }
    saveProductData(code) {
        let newState = {
            'grFailiNimi': this.state.kood + '.gr2'
        };
        if (this.state.ncpData) {
            newState['failiNimi'] = this.state.kood + '.' + this.state.ncpType;
            (0, $c148c8994a598409$export$2e2bcd8739ae039).saveNcp.defer(code);
        }
        (0, $c148c8994a598409$export$2e2bcd8739ae039).saveProduct.defer(code);
        this.setState(newState);
    }
    /**
   * Toote laadimise käivitamine
   */ onFetchProduct(code) {
        let p = this.getInstance().fetchProduct(code);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote laadimine ebaõnnestus
   */ onFetchProductFailed(error) {
        if (error.response.status == 404) (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('%s data not found', "GR2"));
        else this.showError(error);
    }
    showError(error) {
        let message = (0, $865532d99f221026$export$2e2bcd8739ae039)('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) message = error.response.data.error.message;
            else switch(error.response.status){
                case 404:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Product was not found");
                    break;
                default:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            }
        }
        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(message);
    }
    /**
   * Toode sai laaditud
   */ onFetchProductDone(response) {
        // TODO: Toote andmete sisselaadimine
        try {
            if (!response.data.productsResult) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            let transformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)(this.state);
            let d = transformer.glassProductToState(response.data.productsResult);
            delete d.glass;
            if (this.state.lineCount != d.lineCount) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Line count does not match to current line count");
            let newState = this.cloneState();
            newState.extend(d);
            newState.grFailiNimi = newState.kood + '.gr2';
            if (newState.keeratud !== this.state.keeratud) newState.glass.rotate180();
            if (newState.peegeldatud && !this.state.peegeldatud) newState.glass.mirror();
            if (newState.rotated !== this.state.rotated) newState.glass.rotate90();
            newState.calcGlass();
            //newState.calcKoord();
            this.recalcPointsAngle(newState);
            this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
            (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('%s data loaded', "GR2"));
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Server error"));
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
        }
    }
    /**
   * Toote salvestamine
   */ onSaveProduct() {
        let p = this.getInstance().saveProduct();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote salvedstamine ebaõnnestus
   */ onSaveProductFailed(error) {
        this.showError(error);
    }
    onSaveProductDone() {
        (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('Product saved'));
    }
    onDeleteProduct(code) {
        let p = this.getInstance().deleteProduct(code);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    onDeleteProductFailed(error) {
        this.showError(error);
    }
    onDeleteProductDone() {
        this.setInitialState();
        (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('Product deleted'));
    }
    onFetchNcp(info) {
        if (info.type == null) info.type = this.getNextGlassFileType();
        let newState = this.cloneState();
        newState.kood = info.code;
        newState.ncpType = info.type;
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
        let p = this.getInstance().fetchNcp(info.code, info.type);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    onFetchNcpFailed(error) {
        // Kui feilas, proovime järgmist failitüüpi:
        let ncpType = this.getNextGlassFileType(this.state.ncpType);
        if (ncpType != null) {
            (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchNcp.defer(this.state.kood, ncpType);
            return;
        }
        // Vaatamata veale loeme tooteinfo sisse:
        (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchProduct.defer(this.state.kood);
        if (error.response.status == 404) (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('%s data not found', "NCP"));
        else this.showError(error);
    }
    getNcpFileTypes() {
        let types = (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getGlassFileType();
        return (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).map(types.split(","), function(v) {
            return v.trim();
        });
    }
    getNextGlassFileType(fileType) {
        let fileTypes = this.getNcpFileTypes();
        for(let i = 0; i < fileTypes.length; i++){
            if (fileType == null) return fileTypes[i];
            else if (fileType == fileTypes[i]) fileType = null;
        }
        return null;
    }
    onFetchNcpDone(response) {
        let rotated = (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).isNcpRotated();
        let kood = this.state.kood;
        let ncpType = this.state.ncpType;
        try {
            let newState = this.getInitialState();
            newState.ncpData = response.data;
            let ncpParser = this.createNcpFileParser(rotated, ncpType);
            newState.glass.loadGlassData(ncpParser.parse(response.data), rotated);
            newState.calcGlass();
            newState.failiNimi = kood + '.' + ncpType.toLowerCase();
            newState.calcKoord();
            this.recalcPointsAngle(newState);
            newState.kood = kood;
            newState.peegeldatud = newState.glass.peegeldatud;
            newState.keeratud = newState.glass.keeratud;
            newState.rotated = newState.glass.rotated;
            this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
            (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('%s data loaded', ncpType.toUpperCase()));
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid %s data", ncpType.toUpperCase()) + " " + e.toString());
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
        }
        // Loeme tooteinfo kah sisse:
        (0, $c148c8994a598409$export$2e2bcd8739ae039).fetchProduct.defer(kood);
    }
    onSaveNcp() {
        let p = this.getInstance().saveNcp();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    onSaveNcpFailed(error) {
        this.showError(error);
    }
    onSaveNcpDone() {
        (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('%s data saved', this.state.ncpType.toUpperCase()));
    }
    onCalcPoints() {
        let newState = this.cloneState();
        newState.calcJoonAY();
        newState.calcE();
        newState.calcP();
        newState.calcLengthE();
        newState.calcOffsetP();
        newState.calcOffsetHud();
        newState.calcKoord();
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    getInitialState() {
        let productConfig = (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getProductConfig();
        return new (0, $a96c27223eb4a3af$export$2e2bcd8739ae039)(productConfig);
    }
    setInitialState() {
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(this.getInitialState()));
    }
    cloneState() {
        return new (0, $a96c27223eb4a3af$export$2e2bcd8739ae039)(this.state);
    }
    onSettingsUpdated(settings) {
        this.waitFor((0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039));
        let productConfig = (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getProductConfig();
        if (!productConfig.isEqual(this.state)) this.setInitialState();
    }
    /**
   * Parsib faili sisse ning väärtustab andmed
   */ onUploadNcpFile(info) {
        /*
     * Call loefail(failinimi)
     * Vajalikud tegevused:
     Call arvuta_e
     Call arvuta_p
     Call koordinaadid
     Call joonista - tehakse Product.js failis!
     */ let rotated = (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).isNcpRotated();
        try {
            let newState = this.getInitialState();
            newState.ncpData = info.data;
            newState.ncpType = info.ncpType;
            let ncpParser = this.createNcpFileParser(rotated, info.ncpType);
            newState.glass.loadGlassData(ncpParser.parse(info.data), rotated);
            newState.calcGlass();
            newState.failiNimi = info.name;
            newState.calcKoord();
            this.recalcPointsAngle(newState);
            this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid %s file", info.ncpType.toUpperCase()) + " '" + info.name + "': " + e.toString());
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
        }
    }
    /**
   * GR2 faili laadimine
   * @param {object} info GR2 faili info objekt, selles peavad leiduma väljad "data" (GR2 faili struktuur) ja "name" (faili nimi)
   */ onUploadGrFile(info) {
        /*
     * Call loegrtfail(sisend_grt)
     * Call arvuta_e
     * 		arvuta_p
     * 		koordinaadid
     * Call koordinaadid
     * 		arvuta_Kalle
     */ try {
            let p = new (0, $ae7147190905e1cb$export$2e2bcd8739ae039)();
            let gp = p.parse(info.data);
            let transformer = new (0, $d02c132c9fe52fc9$export$2e2bcd8739ae039)(this.state);
            let d = transformer.glassProductToState(gp);
            // Eemaldame glass info:
            delete d.glass;
            // Arvutame Pi, neid GR2 failis pole.
            d.calcPi();
            // if (!_.isString(this.state.failiNimi) || this.state.failiNimi.length == 0) throw "No NCP file opened";
            if (this.state.lineCount != d.lineCount) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Line count does not match to current line count");
            let newState = this.cloneState();
            newState.extend(d);
            newState.grFailiNimi = info.name;
            if (newState.keeratud !== this.state.keeratud) newState.glass.rotate180();
            if (newState.peegeldatud && !this.state.peegeldatud) newState.glass.mirror();
            if (newState.rotated && !this.state.rotated) newState.glass.rotate90();
            newState.calcGlass();
            //newState.calcKoord();
            this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
        } catch (e) {
            if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
            else {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer("Invalid GR2 file");
            }
        }
    }
    /**
   * Joone peegeldamine
   */ onMirror() {
        let newState = this.cloneState();
        newState.mirror();
        // Kallet ei arvuta:
        newState.calcKoord(false);
        newState.copyKalle();
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    /**
   * Klaasi peegeldamine
   */ onMirrorShape() {
        let newState = this.cloneState();
        newState.glass.mirror();
        newState.peegeldatud = newState.glass.peegeldatud;
        newState.calcE();
        newState.calcP();
        newState.calcKoord();
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    /**
   * Klaasi keeramine 180 kraadi
   */ onRotate() {
        let newState = this.cloneState();
        newState.glass.rotate180();
        newState.keeratud = newState.glass.keeratud;
        newState.calcE();
        newState.calcP();
        newState.calcKoord();
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    /**
   * Klaasifaili sisu keeramine 90 kraadi
   */ onRotate90() {
        let newState = this.cloneState();
        newState.glass.rotate90();
        newState.rotated = newState.glass.rotated;
        newState.calcJoonAY();
        newState.calcE();
        newState.calcP();
        newState.calcGlass();
        newState.calcKoord();
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    /**
   * Parameetri muutmine
   */ onChangeValue(info) {
        if (!this.validateValue(info)) return;
        let newState = this.cloneState();
        let isChanged = false;
        if (Array.isArray(this.state[info.field]) || (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isObject(this.state[info.field])) {
            // Massiivi elemendi või objekti atribuudi väärtustamine:
            newState[info.field][info.idx] = info.value;
            if (newState[info.field][info.idx] !== this.state[info.field][info.idx]) isChanged = true;
        } else {
            // Lihtelemendi väärtustamine:
            switch(info.field){
                case 'keeratud_esimene':
                case 'keeratud_viimane':
                    if (info.value === null) info.value = false;
                    break;
                default:
                    break;
            }
            newState[info.field] = info.value;
            if (newState[info.field] !== this.state[info.field]) isChanged = true;
        }
        if (!isChanged) return;
        switch(info.field){
            case 'ex':
            case 'ey':
                newState.calcKalle();
                break;
            case 'ez':
                newState.ez[info.idx] = info.value;
                newState.calcKalle();
                break;
            case 'pNominaal':
                newState.calcKalle();
                break;
            case 'distants':
                // TODO: Viia 603 + 160 konfi konstandiks
                let yshiftOffset = (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getYshiftOffset();
                // newState.ynihe = Math.round(603 - info.value - ((newState.glass.maxy - newState.glass.miny) / 2)) + 160;
                newState.ynihe = Math.round(yshiftOffset - info.value - (newState.glass.maxy - newState.glass.miny) / 2);
                newState.calcKoord();
                break;
            case 'xnihe':
            case 'ynihe':
                newState.calcKoord();
                break;
            case 'tolerants1k':
                for(let i = 0; i < newState.lineCount * 3; i++)if (i % 3 == 1) // Keskmised punktid
                newState.pYlemineTolerants1[i] = newState.pAlumineTolerants1[i] = info.value;
                break;
            case 'tolerants2k':
                for(let i = 0; i < newState.lineCount * 3; i++)if (i % 3 == 1) // Keskmised punktid
                newState.pYlemineTolerants2[i] = newState.pAlumineTolerants2[i] = info.value;
                break;
            case 'tolerants1s':
                for(let i = 0; i < newState.lineCount * 3; i++)if (i % 3 != 1) // Otsapunktid
                newState.pYlemineTolerants1[i] = newState.pAlumineTolerants1[i] = info.value;
                break;
            case 'tolerants2s':
                for(let i = 0; i < newState.lineCount * 3; i++)if (i % 3 != 1) // Otsapunktid
                newState.pYlemineTolerants2[i] = newState.pAlumineTolerants2[i] = info.value;
                break;
            case 'hudLine':
                newState.calcHudFromOffset();
                break;
            case 'anglePoints':
            default:
                break;
        }
        this.recalcPointsAngle(newState);
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    recalcPointsAngle(newState) {
        let points = [];
        for(let i = 0; i < newState.pJoon.length; i++)if (newState.anglePoints[i]) points.push(i);
        if (points.length === 2) // Arvuta kahe punkti vaheline nurk:
        newState.calcPointsAngle(points[0], points[1]);
        else newState.angleValue = null;
    }
    /**
   * Punkti E nihutamine näidatud offsetiga (märk näitab nihutamise suunda)
   * @param {number} offset Offset (negative - left, positive - right)
   */ onMoveE(offset) {
        // valitud_e sisaldab vastava E punkti indeksit
        let newState = this.cloneState();
        newState.moveE(this.state.valitud_e, offset);
        newState.calcKoord();
        this.recalcPointsAngle(newState);
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    /**
   * @param {number} offset Offset (negative - down, positive - up)
   */ onMoveP(offset) {
        let newState = this.cloneState();
        newState.moveP(this.state.valitud_p, offset);
        newState.calcKoord();
        this.recalcPointsAngle(newState);
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    onMoveHud(offset) {
        let newState = this.cloneState();
        newState.moveHud(this.state.valitud_hud, offset);
        newState.calcOffsetHud();
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    onRemoveP() {
        let newState = this.cloneState();
        newState.removeP(this.state.valitud_p);
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    onAssignP() {
        let newState = this.cloneState();
        newState.assignP();
        this.setState((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(newState));
    }
    createNcpFileParser(rotated, ncpFileType) {
        switch(ncpFileType){
            case "dat":
                return new (0, $01e540950c270f37$export$2e2bcd8739ae039)();
            default:
                return new (0, $cd53ff756e192b16$export$2e2bcd8739ae039)(rotated);
        }
    }
    validateValue(info) {
        switch(info.field){
            case 'tolerants1k':
            case 'tolerants2k':
            case 'tolerants1s':
            case 'tolerants2s':
                if (info.value > 9.9) return false;
                if (info.value < 0) info.value = 0;
                break;
            case 's':
            case 'pNominaal':
            case 'pYlemineTolerants1':
            case 'pYlemineTolerants2':
            case 'pAlumineTolerants1':
            case 'pAlumineTolerants2':
            case 'hudNominaal':
            case 'hudYlemineTolerants1':
            case 'hudYlemineTolerants2':
            case 'hudAlumineTolerants1':
            case 'hudAlumineTolerants2':
                if (info.value < 0) return false;
                break;
            case 'hudLine':
                if (info.value == null || info.value == "") return true;
                if (info.value < 1 || info.value > this.state.lineCount) return false;
                break;
            default:
                break;
        }
        return true;
    }
    constructor(){
        this.state = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(this.getInitialState());
        this.bindActions((0, $c148c8994a598409$export$2e2bcd8739ae039));
        this.bindActions((0, $b1b3b27ecff41190$export$2e2bcd8739ae039));
        this.exportAsync((0, $6ccb96d500665de3$export$2e2bcd8739ae039));
        let schemaFactory = (0, $f82be28e3e6281b5$export$2e2bcd8739ae039).getInstance();
        this.schema = schemaFactory.getSchema("product");
    }
}
var $c71c1aee47fee504$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($c71c1aee47fee504$var$ProductStore, 'ProductStore');




var $7fPBF = parcelRequire("7fPBF");


const $0090596cf3a3b647$var$propTypes = {
    onClickOk: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onClickCancel: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    okText: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    cancelText: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node
};
const $0090596cf3a3b647$var$defaultProps = {
    okText: 'OK',
    cancelText: 'Cancel'
};
class $0090596cf3a3b647$var$NotificationModal extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    onClickOk(e) {
        e.preventDefault();
        if (this.props.onClickOk) this.props.onClickOk();
        else (0, $1e216dc96a46c373$exports.ModalManager).close();
    }
    onClickCancel(e) {
        e.preventDefault();
        if (this.props.onClickCancel) this.props.onClickCancel();
        else (0, $1e216dc96a46c373$exports.ModalManager).close();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1e216dc96a46c373$exports.Modal), {
            effect: (0, $1e216dc96a46c373$exports.Effect).ScaleUp,
            className: "modal-dialog",
            style: {
                content: {
                    width: '300px'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: "button",
            className: "close",
            onClick: this.onClickCancel,
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-times",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h4", {
            className: "modal-title"
        }, this.props.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", null, this.props.children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "modal-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: "button",
            className: "btn btn-default",
            onClick: this.onClickCancel
        }, this.props.cancelText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onClickOk
        }, this.props.okText)));
    }
    constructor(props){
        super(props);
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }
}
$0090596cf3a3b647$var$NotificationModal.propTypes = $0090596cf3a3b647$var$propTypes;
$0090596cf3a3b647$var$NotificationModal.defaultProps = $0090596cf3a3b647$var$defaultProps;
var $0090596cf3a3b647$export$2e2bcd8739ae039 = $0090596cf3a3b647$var$NotificationModal;







var $7fPBF = parcelRequire("7fPBF");



//import Legacy from '../Legacy';
const $ae74ecb2a4ab9dbb$var$propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).array,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any,
    /**
   * onChange(onChangeParam, value)
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onChangeParam: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).any
};
const $ae74ecb2a4ab9dbb$var$defaultProps = {
    value: null,
    className: "smallinput"
};
class $ae74ecb2a4ab9dbb$var$Tselect extends (0, $22201bd6542c8dbc$export$2e2bcd8739ae039) {
    componentWillReceiveProps(newProps) {
        if (this.state.value !== newProps.value) this.setState({
            value: newProps.value
        });
    }
    onChange(e) {
        let newValue = e.target.value;
        if (this.props.onChange) this.setState({
            value: newValue
        }, (function() {
            this.props.onChange(this.props.onChangeParam, newValue);
        }).bind(this));
        else this.setState({
            value: newValue
        });
    }
    onBlur(e) {
        let newValue = e.target.value;
        if (this.props.onChange) this.props.onChange(this.props.onChangeParam, newValue);
    }
    renderOptions() {
        let i = 1;
        let options = [];
        for (let o of this.getOptions())options.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("option", {
            key: 'k' + i++,
            value: o[0]
        }, o[1]));
        return options;
    }
    getOptions() {
        if (this.props.options == null) return [
            [
                "",
                ""
            ]
        ];
        let options = [];
        for (let o of this.props.options){
            let value = null;
            let title = null;
            if ((0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isArray(o)) {
                value = o[0];
                title = value;
                if (o.length > 1) title = o[1];
            } else {
                value = o;
                title = value;
            }
            if (value == null) value = "";
            if (title == null) title = "";
            options.push([
                value,
                title
            ]);
        }
        return options;
    }
    getSelectedValue() {
        if (this.state.value != null) return this.state.value;
        let options = this.getOptions();
        return options[0][0];
    }
    render() {
        let style = {};
        if (this.props.style) style = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.props.style);
        if (this.props.width) style.width = this.props.width;
        let classname = 'form-control';
        if (this.props.className) classname += ' ' + this.props.className;
        if (!this.state.isValid) classname += ' invalid';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("select", {
            id: this.props.id,
            className: classname,
            style: style,
            value: this.getSelectedValue(),
            onBlur: this.onBlur,
            onChange: this.onChange
        }, this.renderOptions());
    }
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }
}
$ae74ecb2a4ab9dbb$var$Tselect.propTypes = $ae74ecb2a4ab9dbb$var$propTypes;
$ae74ecb2a4ab9dbb$var$Tselect.defaultProps = $ae74ecb2a4ab9dbb$var$defaultProps;
var $ae74ecb2a4ab9dbb$export$2e2bcd8739ae039 = $ae74ecb2a4ab9dbb$var$Tselect;


class $4f96283e0fbf8fa4$var$Product extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    componentDidMount() {
        (0, $c71c1aee47fee504$export$2e2bcd8739ae039).listen(this.onChange);
        (0, $ff339c2931a3cc1b$export$2e2bcd8739ae039).listen(this.onChangeSchema);
        (0, $6b994e94efab8cbe$export$2e2bcd8739ae039).fetchSchema("product");
    }
    componentWillUnmount() {
        (0, $c71c1aee47fee504$export$2e2bcd8739ae039).unlisten(this.onChange);
        (0, $ff339c2931a3cc1b$export$2e2bcd8739ae039).unlisten(this.onChangeSchema);
    }
    onChange(state) {
        this.setState(state);
    }
    onChangeSchema(state) {
        if (state.schemas.product != null) (0, $c148c8994a598409$export$2e2bcd8739ae039).setSchema.defer(state.schemas.product);
    }
    onValueChanged(param, value) {
        // let newState = {};
        if (Array.isArray(param)) {
            // Massiivi elemendi väärtustamine:
            let field = param[0]; // Massiivi nimi
            let idx = param[1]; // Massiivi elemendi indeks
            (0, $c148c8994a598409$export$2e2bcd8739ae039).changeValue(field, value, idx);
        } else // Lihtelemendi väärtustamine:
        (0, $c148c8994a598409$export$2e2bcd8739ae039).changeValue(param, value);
    }
    askConfirmation(message, func) {
        (0, $1e216dc96a46c373$exports.ModalManager).open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0090596cf3a3b647$export$2e2bcd8739ae039), {
            title: (0, $865532d99f221026$export$2e2bcd8739ae039)("Confirmation"),
            onClickOk: function() {
                func();
                (0, $1e216dc96a46c373$exports.ModalManager).close();
            },
            okText: (0, $865532d99f221026$export$2e2bcd8739ae039)('OK'),
            cancelText: (0, $865532d99f221026$export$2e2bcd8739ae039)('Cancel')
        }, message));
    }
    /**
   * Command12 (Call avafaildialoog(1))
   */ onClickOpenNcp(param, fileData, fileName, fileType) {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).uploadNcpFile(fileName, fileData, fileType);
    }
    /**
   * Command14
   */ onClickOpenGr2(param, fileData, fileName) {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).uploadGrFile(fileName, fileData);
    }
    onClickCalcPoints() {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).calcPoints();
    }
    /**
   * Tooteinfo lugemine serverist
   */ onClickReadProduct() {
        // Veendume, et toote number on antud:
        if (!this.state.kood) {
            (0, $26a241f40377239c$export$2e2bcd8739ae039).error((0, $865532d99f221026$export$2e2bcd8739ae039)("Please enter product index!"));
            return;
        }
        (0, $c148c8994a598409$export$2e2bcd8739ae039).readProductData.defer(this.state.kood, null);
    //ProductActions.readProductData.defer(this.state.kood, "ncp");
    //ProductActions.readProductData.defer(this.state.kood, "dat");
    }
    /**
   * Tooteinfo salvestamine serverisse
   */ onClickSaveProduct() {
        // Veendume, et toote number on antud:
        if (!this.state.kood) {
            (0, $26a241f40377239c$export$2e2bcd8739ae039).error((0, $865532d99f221026$export$2e2bcd8739ae039)("Please enter product index!"));
            return;
        }
        this.askConfirmation((0, $865532d99f221026$export$2e2bcd8739ae039)("Save product?"), (function() {
            (0, $c148c8994a598409$export$2e2bcd8739ae039).saveProductData(this.state.kood);
        }).bind(this));
    }
    /**
   * Tooteinfo kustutamine serverist
   */ onClickDeleteProduct() {
        // Veendume, et toote number on antud:
        if (!this.state.kood) {
            (0, $26a241f40377239c$export$2e2bcd8739ae039).error((0, $865532d99f221026$export$2e2bcd8739ae039)("Please enter product index!"));
            return;
        }
        this.askConfirmation((0, $865532d99f221026$export$2e2bcd8739ae039)("Delete product?"), (function() {
            (0, $c148c8994a598409$export$2e2bcd8739ae039).deleteProduct(this.state.kood);
        }).bind(this));
    }
    /**
   * Command13
   */ onClickPrint() {}
    /**
   * Command7
   */ onClickMirror() {
        // Command7
        (0, $c148c8994a598409$export$2e2bcd8739ae039).mirror();
    }
    /**
   * Command9
   */ onClickMirrorShape() {
        // Command9
        (0, $c148c8994a598409$export$2e2bcd8739ae039).mirrorShape();
    }
    onClickRotate90() {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).rotate90();
    }
    onClickRotate() {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).rotate();
    }
    onClickRadio(field, value) {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).changeValue(field, value);
    }
    /**
   * Command1 - <<
   * Command2 - <
   * Command3 - >
   * Command4 - >>
   * @param {number} direction Direction: 1 - big step left, 2 - left, 3 - right, 4 - big step right
   */ onClickMoveE(direction) {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).moveE(direction);
    }
    /**
   * Command5 - up
   * Command6 - down
   * @param {number} direction 1 - up, 2 - down
   */ onClickMoveP(direction) {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).moveP(direction);
    }
    /**
   * Command5 - up
   * Command6 - down
   * @param {number} direction 1 - up, 2 - down
   */ onClickMoveHud(direction) {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).moveHud(direction);
    }
    onClickRemoveP() {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).removeP();
    }
    onClickAssignP() {
        (0, $c148c8994a598409$export$2e2bcd8739ae039).assignP();
    }
    getNcpFileTypes() {
        let types = (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getGlassFileType();
        return (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).map(types.split(","), function(v) {
            return v.trim();
        });
    }
    renderEpointRadioGroup() {
        let points1 = [];
        let points2 = [];
        for(let i = 0; i < this.state.lineCount * 2; i++){
            // Paigutame vaheldumisi üles ja alla:
            let p = i % 2 ? points2 : points1;
            p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a37cdf8f481b7468$export$2e2bcd8739ae039), {
                inline: true,
                name: "epoint",
                checked: this.state.valitud_e == i,
                onClick: this.onClickRadio,
                onClickParam: "valitud_e",
                value: i,
                key: 'epoint_radio_' + i
            }, 'E' + (i + 1).toString()));
        }
        return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "row",
                key: "epoint_radio_g1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "col-md-12 text-center"
            }, points1)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "row",
                key: "epoint_radio_g2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "col-md-12 text-center"
            }, points2))
        ];
    }
    getPointCount() {
        return this.state.lineCount * 3 + this.state.addPoints;
    }
    getBasePointCount() {
        return this.state.lineCount * 3;
    }
    renderPpointRadioGroup() {
        let points1 = [];
        let points2 = [];
        let pointsm = [];
        let pointsp = [];
        //let centerLineLastPoint = 3*Math.floor(this.state.lineCount/2 + 1) - 1;
        this.processPointsInOrder((function(i, line) {
            let p = null;
            if (i < this.state.lineCount * 3) {
                if (i % 3 == 0) p = points1;
                else if (i % 3 == 2) p = points2;
                else if (i % 3 == 1) p = pointsm;
            } else p = pointsp;
            if (p != null) p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a37cdf8f481b7468$export$2e2bcd8739ae039), {
                inline: true,
                name: "ppoint",
                checked: this.state.valitud_p == i,
                onClick: this.onClickRadio,
                onClickParam: "valitud_p",
                value: i,
                key: 'ppoint_radio_' + i
            }, this.state.pNimi[i]));
        }).bind(this));
        let noLeft = {
            paddingLeft: '0px'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row valign-parent",
            key: "ppoint_radio_g1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-2 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: "btn btn-default btn-xs",
            width: "30px",
            onClick: this.onClickMoveP,
            onClickParam: 10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-double-up",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: "btn btn-default btn-xs",
            width: "30px",
            onClick: this.onClickMoveP,
            onClickParam: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-up",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: "btn btn-default btn-xs",
            width: "30px",
            onClick: this.onClickMoveP,
            onClickParam: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-down",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: "btn btn-default btn-xs",
            width: "30px",
            onClick: this.onClickMoveP,
            onClickParam: -10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-double-down",
            "aria-hidden": "true"
        })), /*
        this.state.valitud_p >= this.state.lineCount*3 ?
                          	<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickRemoveP} onClickParam={null}>{this.state.pOlemas[this.state.valitud_p] ? "-" : "+"}</Tbutton>
        	: (this.state.valitud_p == centerLineLastPoint && this.state.addPoints > 0 ?
                              	<Tbutton className="btn btn-default btn-xs" width='30px' onClick={this.onClickAssignP} onClickParam={null}>{"="}</Tbutton>
        		: null)
        		*/ null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-10 text-center valign-middle",
            style: noLeft
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, points1), this.state.lineCount == 3 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, pointsm) : '', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, points2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, pointsp)));
    }
    renderHudRadioGroup() {
        let points = [];
        //let centerLineLastPoint = 3*Math.floor(this.state.lineCount/2 + 1) - 1;
        for(let i = 0; i < this.state.hudPoints; i++)points.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            key: 'ppoint_y_' + i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            width: "40px",
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a37cdf8f481b7468$export$2e2bcd8739ae039), {
            inline: true,
            name: "hudpoint",
            checked: this.state.valitud_hud == i,
            onClick: this.onClickRadio,
            onClickParam: "valitud_hud",
            value: i,
            key: 'hudpoint_radio_' + i
        }, "H" + (i + 1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22201bd6542c8dbc$export$2e2bcd8739ae039), {
            width: "50px",
            valueType: "number",
            valueDecimals: "1",
            value: this.state.hudv[i]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "50px",
            valueType: "number",
            valueDecimals: "1",
            value: this.state.hudKorrektsioon[i],
            onChange: this.onValueChanged,
            onChangeParam: [
                'hudKorrektsioon',
                i
            ]
        }))));
        let noLeft = {
            paddingLeft: '0px'
        };
        return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "row",
                key: "hudpoint_radio_g0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), {
                className: "col-sm-4",
                style: {
                    textAlign: "right"
                }
            }, "Line no"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                className: "smallinput col-sm-8",
                width: "40px",
                valueType: "integer",
                value: this.state.hudLine,
                onChange: this.onValueChanged,
                onChangeParam: "hudLine"
            })),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "row valign-parent align-items-center",
                key: "hudpoint_radio_g1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "col-md-2 text-center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
                className: "btn btn-default btn-xs",
                width: "30px",
                onClick: this.onClickMoveHud,
                onClickParam: 10
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
                className: "fa fa-angle-double-up",
                "aria-hidden": "true"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
                className: "btn btn-default btn-xs",
                width: "30px",
                onClick: this.onClickMoveHud,
                onClickParam: 1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
                className: "fa fa-angle-up",
                "aria-hidden": "true"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
                className: "btn btn-default btn-xs",
                width: "30px",
                onClick: this.onClickMoveHud,
                onClickParam: -1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
                className: "fa fa-angle-down",
                "aria-hidden": "true"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
                className: "btn btn-default btn-xs",
                width: "30px",
                onClick: this.onClickMoveHud,
                onClickParam: -10
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
                className: "fa fa-angle-double-down",
                "aria-hidden": "true"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "col-md-10 text-center valign-middle",
                style: noLeft
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
                style: {
                    margin: "auto"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
                className: "gridtablehead"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Y")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Correction"))), points))))
        ];
    }
    renderPpointY() {
        let p = [];
        this.processPointsInOrder((function(i, line) {
            if (!this.state.pOlemas[i]) return;
            p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
                key: 'ppoint_y_' + i
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                width: "40px",
                align: "center"
            }, this.state.pNimi[i]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                align: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22201bd6542c8dbc$export$2e2bcd8739ae039), {
                width: "50px",
                valueType: "number",
                valueDecimals: "1",
                value: this.state.pv[i]
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                align: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                width: "50px",
                valueType: "number",
                valueDecimals: "1",
                value: this.state.pKorrektsioon[i],
                onChange: this.onValueChanged,
                onChangeParam: [
                    'pKorrektsioon',
                    i
                ]
            }))));
        }).bind(this));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
            style: {
                margin: "auto"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "gridtablehead"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Y")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Correction"))), p));
    }
    renderEpoints() {
        let p = [];
        for(let i = 0; i < this.state.lineCount * 2; i++){
            // 1 -> 40px, 2 -> 50px
            let tdList = [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "epoint_i1",
                    align: "center"
                }, 'E' + (i + 1).toString()),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "epoint_i2",
                    align: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22201bd6542c8dbc$export$2e2bcd8739ae039), {
                    width: "50px",
                    valueType: "number",
                    valueDecimals: "1",
                    value: this.state.ex[i] + this.state.xnihe
                })),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "epoint_i3",
                    align: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22201bd6542c8dbc$export$2e2bcd8739ae039), {
                    width: "50px",
                    valueType: "number",
                    valueDecimals: "1",
                    value: this.state.ey[i] + this.state.ynihe
                })),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "epoint_i4",
                    align: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                    width: "50px",
                    valueType: "number",
                    valueDecimals: "1",
                    value: this.state.ez[i],
                    onChange: this.onValueChanged,
                    onChangeParam: [
                        'ez',
                        i
                    ]
                })),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "epoint_i5",
                    align: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                    width: "50px",
                    valueType: "number",
                    valueDecimals: "1",
                    value: this.state.eKalleA[i],
                    onChange: this.onValueChanged,
                    onChangeParam: [
                        'eKalleA',
                        i
                    ]
                })),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "epoint_i6",
                    align: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                    width: "50px",
                    valueType: "number",
                    valueDecimals: "1",
                    value: this.state.eKalleB[i],
                    onChange: this.onValueChanged,
                    onChangeParam: [
                        'eKalleB',
                        i
                    ]
                }))
            ];
            if (i % 2 == 0) tdList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                key: "epoint_i7",
                width: "50px",
                align: "center"
            }, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22201bd6542c8dbc$export$2e2bcd8739ae039), {
                width: "50px",
                valueType: "integer",
                value: this.state.pikkus[i / 2]
            }), " "));
            else tdList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                key: "epoint_i7",
                width: "50px",
                align: "center"
            }));
            tdList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                key: "epoint_i8"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                width: "50px",
                valueType: "number",
                valueDecimals: "1",
                value: this.state.s[i],
                onChange: this.onValueChanged,
                onChangeParam: [
                    's',
                    i
                ]
            })));
            p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
                key: 'epoint_' + i
            }, tdList));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
            style: {
                margin: "auto"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "gridtablehead"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            width: "55px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "55px"
        }, "X"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "55px"
        }, "Y"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "55px"
        }, "Z"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "55px"
        }, "A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "55px"
        }, "B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "55px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Length")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "55px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Print2"))), p, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            style: {
                height: "10px"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            colSpan: "8"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            colSpan: "3",
            align: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), null, "Glass thickness:")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            colSpan: "5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "50px",
            valueType: "number",
            valueDecimals: "1",
            value: this.state.klaasiPaksus,
            onChange: this.onValueChanged,
            onChangeParam: "klaasiPaksus"
        })))));
    }
    renderAdasPrintPanel() {
        if (this.state.adasAreasCount <= 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "ADAS Print")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderAdasPrint())));
    }
    renderAdasPrint() {
        let p = [];
        for(let i = 0; i < this.state.adasAreasCount; i++){
            let tdList = [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "apoint_i1",
                    width: "20%",
                    align: "center"
                }, (i + 1).toString()),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "apoint_i4",
                    align: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                    width: "50px",
                    valueType: "number",
                    valueDecimals: "1",
                    value: this.state.adasarea_distance[i],
                    onChange: this.onValueChanged,
                    onChangeParam: [
                        'adasarea_distance',
                        i
                    ]
                })),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                    key: "apoint_i6",
                    align: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ae74ecb2a4ab9dbb$export$2e2bcd8739ae039), {
                    width: "80px",
                    value: this.state.adasarea_type[i],
                    onChange: this.onValueChanged,
                    onChangeParam: [
                        'adasarea_type',
                        i
                    ],
                    options: [
                        [
                            "0",
                            (0, $865532d99f221026$export$2e2bcd8739ae039)("Glass")
                        ],
                        [
                            "1",
                            (0, $865532d99f221026$export$2e2bcd8739ae039)("Print2")
                        ]
                    ]
                }))
            ];
            p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
                key: 'epoint_' + i
            }, tdList));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
            style: {
                margin: "auto"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "gridtablehead"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Point")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            width: "100px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Distance from the edge")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Type"))), p));
    }
    /**
   * @param {function} func Function in form: func(pointIndex, lineIndex)
   */ processPointsInOrder(func) {
        let basePointCount = this.getBasePointCount();
        for(let i = 0; i < basePointCount; i++)func(i, this.state.pJoon[i]);
        for(let j = this.state.addPoints - 1; j >= 0; j--)func(basePointCount + j, this.state.pJoon[basePointCount + j]);
    }
    renderPpointsRowHead() {
        let p = [];
        this.processPointsInOrder((function(i) {
            if (!this.state.pOlemas[i]) return;
            p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
                key: 'ppoint_h_' + i
            }, this.state.pNimi[i]));
        }).bind(this));
        let pointCount = this.getPointCount();
        p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            key: 'ppoint_h_' + pointCount
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("ANGLE")));
        return p;
    }
    renderPpointsRow(field) {
        let p = [];
        this.processPointsInOrder((function(i) {
            if (!this.state.pOlemas[i]) return;
            p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                key: 'ppoint_i' + i,
                className: "tolerancecell"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
                width: "40px",
                valueDecimals: "1",
                valueType: "number",
                value: this.state[field][i],
                onChange: this.onValueChanged,
                onChangeParam: [
                    field,
                    i
                ]
            })));
        }).bind(this));
        let pointCount = this.getPointCount();
        p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            key: 'ppoint_i' + pointCount,
            className: "tolerancecell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "40px",
            valueDecimals: "1",
            valueType: "number",
            value: this.state.angle[field],
            onChange: this.onValueChanged,
            onChangeParam: [
                "angle",
                field
            ]
        })));
        return p;
    }
    renderHudRowHead() {
        let p = [];
        for(let i = 0; i < this.state.hudPoints; i++)p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            key: 'hud_h_' + i
        }, "H" + (i + 1)));
        return p;
    }
    renderHudRow(field) {
        let p = [];
        for(let i = 0; i < this.state.hudPoints; i++)p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            key: 'hud_i' + i,
            className: "tolerancecell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "40px",
            valueDecimals: "1",
            valueType: "number",
            value: this.state[field][i],
            onChange: this.onValueChanged,
            onChangeParam: [
                field,
                i
            ]
        })));
        return p;
    }
    renderAdasButtons() {
        let p = [];
        let centerLine = (this.state.lineCount - 1) / 2;
        let skip = 0;
        let isFirst = true;
        let order = 0;
        this.processPointsInOrder((function(i, line) {
            if (line == centerLine) {
                if (order++ > 1) {
                    // Center line
                    if (isFirst) {
                        p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                            key: "adas_title",
                            colSpan: skip,
                            align: "right"
                        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("ADAS window point") + ":"));
                        isFirst = false;
                        skip = 0;
                    }
                    p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                        key: "adas_" + i,
                        align: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a37cdf8f481b7468$export$2e2bcd8739ae039), {
                        name: "adas",
                        checked: this.state.adas === i,
                        onClick: this.onClickRadio,
                        onClickParam: "adas",
                        value: i,
                        key: 'adas_radio_' + i
                    })));
                } else if (isFirst) skip++;
            } else if (isFirst) skip++;
            else p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                key: "adas_" + i
            }));
        }).bind(this));
        p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            key: "adas_" + this.state.pJoon.length
        }));
        return p;
    }
    renderAngleButtons() {
        let p = [];
        let centerLine = (this.state.lineCount - 1) / 2;
        let skip = 0;
        let isFirst = true;
        let order = 0;
        this.processPointsInOrder((function(i, line) {
            if (line == centerLine) {
                if (order++ > 1) {
                    // Center line
                    if (isFirst) {
                        p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                            key: "angle_title",
                            colSpan: skip,
                            align: "right"
                        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Points used for ANGLE calculation") + ":"));
                        isFirst = false;
                        skip = 0;
                    }
                    p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                        key: "angle_" + i,
                        align: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $74065ae0ba4bb816$export$2e2bcd8739ae039), {
                        name: "anglePoints",
                        checked: this.state.anglePoints[i],
                        onClick: this.onValueChanged,
                        onClickParam: [
                            'anglePoints',
                            i
                        ],
                        value: true
                    })));
                } else if (isFirst) skip++;
            } else if (isFirst) skip++;
            else p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
                key: "angle_" + i
            }));
        }).bind(this));
        p.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", {
            key: "angle_" + this.state.pJoon.length
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22201bd6542c8dbc$export$2e2bcd8739ae039), {
            valueType: "integer",
            value: this.state.angleValue
        })));
        return p;
    }
    getPpointNamesCenter() {
        let names = [];
        let basePointCount = this.getBasePointCount();
        for(let i = 0; i < basePointCount; i++)if (i % 3 == 1) names.push((i + 1).toString());
        return 'P ' + names.join(', '); // P 2, 5, 8, 11, 14
    }
    getPpointNamesEdge() {
        let names = [];
        let basePointCount = this.getBasePointCount();
        for(let i = 0; i < basePointCount; i++)if (i % 3 == 0 || i % 3 == 2) names.push((i + 1).toString());
        return 'P ' + names.join(', '); // P 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
    }
    renderTolerances(type, tolerants1, tolerants2) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-horizontal form-horizontal-sm text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group tolerance1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), null, "Tolerance 1:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "40px",
            valueType: "number",
            valueDecimals: "1",
            value: tolerants1,
            onChange: this.onValueChanged,
            onChangeParam: 'tolerants1' + type
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group tolerance2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), null, "Tolerance 2:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "40px",
            valueType: "number",
            valueDecimals: "1",
            value: tolerants2,
            onChange: this.onValueChanged,
            onChangeParam: 'tolerants2' + type
        })));
    }
    renderProductButtons() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), null, "Code:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "80px",
            value: this.state.kood,
            onChange: this.onValueChanged,
            onChangeParam: "kood"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", null, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "100px",
            onClick: this.onClickReadProduct
        }, "Read product"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "100px",
            onClick: this.onClickSaveProduct
        }, "Save product"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "100px",
            onClick: this.onClickDeleteProduct
        }, "Delete product"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), null, "Model name:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "250px",
            value: this.state.mudeliNimi,
            onChange: this.onValueChanged,
            onChangeParam: "mudeliNimi"
        })), (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).isSimpleUi() ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), null, "SCAN:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            width: "100px",
            value: this.state.scan,
            onChange: this.onValueChanged,
            onChangeParam: "scan"
        })));
    }
    renderButtonsGroup() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            role: "group"
        }, this.renderNcpUploadButtons(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2c6d4165bfc0f946$export$2e2bcd8739ae039), {
            width: "100px",
            as: "text",
            accept: ".gr2",
            onClick: this.onClickOpenGr2
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Upload .%s", "GR2")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            role: "group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "120px",
            onClick: this.onClickRotate90
        }, "Rotate 90\xb0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "120px",
            onClick: this.onClickRotate
        }, "Rotate 180\xb0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "120px",
            onClick: this.onClickMirrorShape
        }, "Mirror glass shape"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "120px",
            onClick: this.onClickMirror
        }, "Mirror lines"))));
    }
    renderNcpUploadButtons() {
        let ncpFileTypes = this.getNcpFileTypes();
        let buttons = [];
        for (let type of ncpFileTypes)buttons.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2c6d4165bfc0f946$export$2e2bcd8739ae039), {
            key: type,
            width: "100px",
            as: "text",
            accept: '.' + type,
            onClick: (param, fileData, fileName)=>this.onClickOpenNcp(param, fileData, fileName, type)
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Upload .%s", type.toUpperCase())));
        return buttons;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-4"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("DAT/NCP file:") + " " + this.state.failiNimi + " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-8"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "GR2 file:"), " " + this.state.grFailiNimi + " "))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm form-inline"
        }, this.renderProductButtons())))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderButtonsGroup())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Center")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm form-horizontal form-horizontal-sm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), {
            className: "col-sm-6",
            style: {
                textAlign: "right"
            }
        }, "X-move:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            className: "smallinput col-sm-6",
            width: "40px",
            valueType: "integer",
            value: this.state.xnihe,
            onChange: this.onValueChanged,
            onChangeParam: "xnihe"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), {
            className: "col-sm-6",
            style: {
                textAlign: "right"
            }
        }, "Y-move:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            className: "smallinput col-sm-6",
            width: "40px",
            valueType: "integer",
            value: this.state.ynihe,
            onChange: this.onValueChanged,
            onChangeParam: "ynihe"
        })), (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).isSimpleUi() ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1851c71e1097d083$export$2e2bcd8739ae039), {
            className: "col-sm-6",
            style: {
                textAlign: "right"
            }
        }, "Distance:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            className: "smallinput col-sm-6",
            width: "40px",
            valueType: "integer",
            value: this.state.distants,
            onChange: this.onValueChanged,
            onChangeParam: "distants"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Move E-point")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderEpointRadioGroup(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "50px",
            className: "btn btn-default btn-xs",
            onClick: this.onClickMoveE,
            onClickParam: -10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-double-left",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "50px",
            className: "btn btn-default btn-xs",
            onClick: this.onClickMoveE,
            onClickParam: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-left",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "50px",
            className: "btn btn-default btn-xs",
            onClick: this.onClickMoveE,
            onClickParam: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-right",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            width: "50px",
            className: "btn btn-default btn-xs",
            onClick: this.onClickMoveE,
            onClickParam: 10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-angle-double-right",
            "aria-hidden": "true"
        })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Move P-point")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderPpointRadioGroup())))), (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getHudPoints() == 0 ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "HUD points")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderHudRadioGroup())))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "P-points")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderPpointY())))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, this.getPpointNamesCenter()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderTolerances("k", this.state.tolerants1k, this.state.tolerants2k))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, this.getPpointNamesEdge()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderTolerances("s", this.state.tolerants1s, this.state.tolerants2s)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Image")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $fc4a095999ffdfc8$export$2e2bcd8739ae039), {
            width: 880,
            height: 500,
            product: this.state
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "E-points")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, this.renderEpoints()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, this.renderAdasPrintPanel()), (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).isRotatedMeasurementAllowed() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "Rotated measurement")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $74065ae0ba4bb816$export$2e2bcd8739ae039), {
            inline: true,
            name: "rotatedFirstLine",
            checked: this.state.keeratud_esimene,
            onClick: this.onValueChanged,
            onClickParam: "keeratud_esimene",
            value: true
        }, "First line"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $74065ae0ba4bb816$export$2e2bcd8739ae039), {
            inline: true,
            name: "rotatedLastLine",
            checked: this.state.keeratud_viimane,
            onClick: this.onValueChanged,
            onClickParam: "keeratud_viimane",
            value: true
        }, "Last line"))))))))) : "")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
            width: "100%"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "gridtablehead"
        }, this.renderPpointsRowHead()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance2"
        }, this.renderPpointsRow('pYlemineTolerants2')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance1"
        }, this.renderPpointsRow('pYlemineTolerants1')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow"
        }, this.renderPpointsRow('pNominaal')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance1"
        }, this.renderPpointsRow('pAlumineTolerants1')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance2"
        }, this.renderPpointsRow('pAlumineTolerants2')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, this.renderAdasButtons()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, this.renderAngleButtons()))))))), (0, $25b5d8d272d0fdf3$export$2e2bcd8739ae039).getHudPoints() == 0 ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading",
            style: {
                padding: '1px 15px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9899d828d65283a$export$2e2bcd8739ae039), null, "HUD")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body panel-body-sm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
            width: "100%"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "gridtablehead"
        }, this.renderHudRowHead()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance2"
        }, this.renderHudRow('hudYlemineTolerants2')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance1"
        }, this.renderHudRow('hudYlemineTolerants1')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow"
        }, this.renderHudRow('hudNominaal')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance1"
        }, this.renderHudRow('hudAlumineTolerants1')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            className: "tolerancerow tolerance2"
        }, this.renderHudRow('hudAlumineTolerants2')))))))))));
    }
    /**
   *
   * @param props
   */ constructor(props){
        super(props);
        this.state = (0, $c71c1aee47fee504$export$2e2bcd8739ae039).getState();
        this.onChange = this.onChange.bind(this);
        this.onChangeSchema = this.onChangeSchema.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onClickOpenNcp = this.onClickOpenNcp.bind(this);
        this.onClickOpenGr2 = this.onClickOpenGr2.bind(this);
        this.onClickCalcPoints = this.onClickCalcPoints.bind(this);
        this.onClickReadProduct = this.onClickReadProduct.bind(this);
        this.onClickSaveProduct = this.onClickSaveProduct.bind(this);
        this.onClickDeleteProduct = this.onClickDeleteProduct.bind(this);
        this.onClickPrint = this.onClickPrint.bind(this);
        this.onClickMirror = this.onClickMirror.bind(this);
        this.onClickRotate90 = this.onClickRotate90.bind(this);
        this.onClickRotate = this.onClickRotate.bind(this);
        this.onClickMirrorShape = this.onClickMirrorShape.bind(this);
        this.onClickRadio = this.onClickRadio.bind(this);
        this.onClickMoveE = this.onClickMoveE.bind(this);
        this.onClickMoveP = this.onClickMoveP.bind(this);
        this.onClickMoveHud = this.onClickMoveHud.bind(this);
    }
}
var $4f96283e0fbf8fa4$export$2e2bcd8739ae039 = $4f96283e0fbf8fa4$var$Product;



var $7fPBF = parcelRequire("7fPBF");


/**
 * Teadete haldamise store
 */ 

class $65e4515738acd265$var$NotificationStore {
    onInfo(message) {
        this.notifications.push({
            type: 'info',
            message: message,
            timeout: 3000
        });
    }
    onWarning(message) {
        this.notifications.push({
            type: 'warning',
            message: message
        });
    }
    onSuccess(message) {
        this.notifications.push({
            type: 'success',
            message: message,
            timeout: 3000
        });
    }
    onError(message) {
        this.notifications.push({
            type: 'danger',
            message: message
        });
    }
    onDismiss(item) {
        this.notifications.splice(item.key, 1);
    }
    onClear() {
        this.notifications = [];
    }
    constructor(){
        this.notifications = [];
        this.bindActions((0, $26a241f40377239c$export$2e2bcd8739ae039));
    }
}
var $65e4515738acd265$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($65e4515738acd265$var$NotificationStore, 'NotificationStore');


function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f43c50d92a19d876$export$2e2bcd8739ae039.apply(this, arguments);
}


function $939dffaddf93a85b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $da27c96857818bcc$export$2e2bcd8739ae039(o, p) {
    $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da27c96857818bcc$export$2e2bcd8739ae039(o, p);
}


function $146ee816144a450d$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $da27c96857818bcc$export$2e2bcd8739ae039)(subClass, superClass);
}



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);


var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $61c94efb1735eff6$export$2e2bcd8739ae039);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;




var $f9e47e451b39ae9f$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $1e3f901d29816e8c$export$2e2bcd8739ae039)(node, c);
    });
};
var $f9e47e451b39ae9f$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $89edc8a1840ff9c1$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f9e47e451b39ae9f$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f9e47e451b39ae9f$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f9e47e451b39ae9f$var$removeClass(node, baseClassName);
        if (activeClassName) $f9e47e451b39ae9f$var$removeClass(node, activeClassName);
        if (doneClassName) $f9e47e451b39ae9f$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $623678cbb6daf054$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f9e47e451b39ae9f$var$CSSTransition.defaultProps = {
    classNames: ''
};
$f9e47e451b39ae9f$var$CSSTransition.propTypes = {};
var $f9e47e451b39ae9f$export$2e2bcd8739ae039 = $f9e47e451b39ae9f$var$CSSTransition;



function $298ff58efa174465$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;


class $4610186095f4e197$var$Notifier extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    dismiss(item) {
        if (this.props.onDismiss) //if callback specified, call it
        this.props.onDismiss(item);
        else {
            //if no callback for dismissal, just update our state
            let newData = this.state.dismissedAlerts.slice();
            newData.push(item);
            this.setState({
                dismissedAlerts: newData
            });
        }
    }
    render() {
        let alerts = [];
        let enterTimeout = 500;
        let exitTimeout = 300;
        for(let i = 0; i < this.props.alerts.length; i++)if (this.state.dismissedAlerts.indexOf(this.props.alerts[i]) < 0) {
            let alert = this.props.alerts[i];
            alerts.push(alert);
            if (alert.timeout || this.props.timeout) setTimeout(this.dismiss.bind(this, alert), (alert.timeout ? alert.timeout : this.props.timeout) + enterTimeout + exitTimeout);
        }
        let i = -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "alert-notifier-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), null, alerts.map((function(item) {
            i++;
            item.key = i;
            if ([
                "success",
                "info",
                "warning",
                "danger"
            ].indexOf(item.type) < 0) item.type = "info";
            let css = "alert alert-dismissible alert-" + item.type;
            let headline = item.headline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("strong", null, item.headline, "\xa0") : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f9e47e451b39ae9f$export$2e2bcd8739ae039), {
                key: i,
                classNames: "alert",
                timeout: {
                    enter: enterTimeout,
                    exit: exitTimeout
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: css,
                key: i
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
                type: "button",
                className: "close",
                title: "Dismiss",
                onClick: this.dismiss.bind(this, item)
            }, "\xd7"), headline, item.message));
        }).bind(this))));
    }
    constructor(props){
        super(props);
        this.state = {
            dismissedAlerts: []
        };
    }
}
$4610186095f4e197$var$Notifier.propTypes = {
    alerts: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).array.isRequired,
    onDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
class $4610186095f4e197$var$Notification extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    componentDidMount() {
        (0, $65e4515738acd265$export$2e2bcd8739ae039).listen(this.onChange);
    }
    componentWillUnmount() {
        (0, $65e4515738acd265$export$2e2bcd8739ae039).unlisten(this.onChange);
    }
    onChange(state) {
        this.setState(state);
    }
    dismissAlert(item) {
        (0, $26a241f40377239c$export$2e2bcd8739ae039).dismiss(item);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4610186095f4e197$var$Notifier, {
            alerts: this.props.onlyLast && this.state.notifications != null ? this.state.notifications.slice(-1) : this.state.notifications,
            onDismiss: this.dismissAlert
        });
    }
    constructor(props){
        super(props);
        this.state = (0, $65e4515738acd265$export$2e2bcd8739ae039).getState();
        this.onChange = this.onChange.bind(this);
        this.dismissAlert = this.dismissAlert.bind(this);
    }
}
$4610186095f4e197$var$Notification.propTypes = {
    onlyLast: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool
};
$4610186095f4e197$var$Notification.defaultProps = {
    onlyLast: false
};
var $4610186095f4e197$export$2e2bcd8739ae039 = $4610186095f4e197$var$Notification;


class $9e8968b377c4b4d9$var$ProductPage extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            id: "product_content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4610186095f4e197$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4f96283e0fbf8fa4$export$2e2bcd8739ae039), null));
    }
}
var $9e8968b377c4b4d9$export$2e2bcd8739ae039 = $9e8968b377c4b4d9$var$ProductPage;




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $505ebcb184373782$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $505ebcb184373782$export$2e2bcd8739ae039(o);
}



function $27f18dd8fc16da3b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $505ebcb184373782$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $505ebcb184373782$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $7fddabb4b045308c$export$2e2bcd8739ae039(t) {
    var i = (0, $27f18dd8fc16da3b$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $505ebcb184373782$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $8273a87573256c54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8273a87573256c54$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8273a87573256c54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8273a87573256c54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $74e249f0a1430824$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $e9005c7c032e54f6$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $6f9e7a38a1550ef5$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $4ca7aef5b7b26ccf$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
}


function $8927cf96e9e7e6b4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $1a6fc27d69850fe4$export$2e2bcd8739ae039(arr, i) {
    return (0, $74e249f0a1430824$export$2e2bcd8739ae039)(arr) || (0, $e9005c7c032e54f6$export$2e2bcd8739ae039)(arr, i) || (0, $4ca7aef5b7b26ccf$export$2e2bcd8739ae039)(arr, i) || (0, $8927cf96e9e7e6b4$export$2e2bcd8739ae039)();
}



function $f779b8b0ef990dda$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $7fPBF = parcelRequire("7fPBF");
var $c9af24aac0e2106d$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $c9af24aac0e2106d$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref, $c9af24aac0e2106d$var$_excluded);
    var _useState = (0, $7fPBF.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $7fPBF.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $7fPBF.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $7fPBF.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $7fPBF.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $7fPBF = parcelRequire("7fPBF");


function $009b183922525d46$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $381be8fad7784fe9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $381be8fad7784fe9$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $381be8fad7784fe9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $381be8fad7784fe9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $5236ac5195402c05$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $da27c96857818bcc$export$2e2bcd8739ae039)(subClass, superClass);
}


function $b48febf76cf3d138$export$2e2bcd8739ae039(o) {
    $b48febf76cf3d138$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b48febf76cf3d138$export$2e2bcd8739ae039(o);
}


function $cb0780e1471bbfb2$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cb0780e1471bbfb2$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $690e545d5a200a90$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $505ebcb184373782$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $298ff58efa174465$export$2e2bcd8739ae039)(self);
}


function $c2ec9395872a8e53$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $cb0780e1471bbfb2$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, result);
    };
}



function $ca91ad18e54285de$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(arr);
}


function $130341d5473c4bb5$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $796c3d48dfd34a55$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $91ec1961173e898a$export$2e2bcd8739ae039(arr) {
    return (0, $ca91ad18e54285de$export$2e2bcd8739ae039)(arr) || (0, $130341d5473c4bb5$export$2e2bcd8739ae039)(arr) || (0, $4ca7aef5b7b26ccf$export$2e2bcd8739ae039)(arr) || (0, $796c3d48dfd34a55$export$2e2bcd8739ae039)();
}



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $474a93eda108ec7a$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $474a93eda108ec7a$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $474a93eda108ec7a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($474a93eda108ec7a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $474a93eda108ec7a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $0bb108cf9f15301b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)) break;
        (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)();
    }
    return (0, $83f8df0fc4bef2f6$export$58adb3bec8346d0f)(begin, (0, $83f8df0fc4bef2f6$export$5880b8b5730aff45));
};
var $0bb108cf9f15301b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $0bb108cf9f15301b$var$identifierWithPointTracking((0, $83f8df0fc4bef2f6$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)());
    return parsed;
};
var $0bb108cf9f15301b$var$getRules = function getRules(value, points) {
    return (0, $83f8df0fc4bef2f6$export$45918ac1574455b1)($0bb108cf9f15301b$var$toRules((0, $83f8df0fc4bef2f6$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $0bb108cf9f15301b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $0bb108cf9f15301b$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$0bb108cf9f15301b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $0bb108cf9f15301b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $0bb108cf9f15301b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $0bb108cf9f15301b$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $0bb108cf9f15301b$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $0bb108cf9f15301b$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($0bb108cf9f15301b$var$ignoreFlag) > -1;
};
var $0bb108cf9f15301b$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($0bb108cf9f15301b$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $0bb108cf9f15301b$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $0bb108cf9f15301b$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$0bb108cf9f15301b$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $0bb108cf9f15301b$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $0bb108cf9f15301b$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$0bb108cf9f15301b$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    } else if ($0bb108cf9f15301b$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $0bb108cf9f15301b$var$prefix(value, length) {
    switch((0, $83f8df0fc4bef2f6$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, 'stretch') ? $0bb108cf9f15301b$var$prefix((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, (0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 3 - (~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $0bb108cf9f15301b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                element["return"] = $0bb108cf9f15301b$var$prefix(element.value, element.length);
                break;
            case 0, $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                    (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                        value: (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (element.length) return (0, $83f8df0fc4bef2f6$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $83f8df0fc4bef2f6$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $0bb108cf9f15301b$var$defaultStylisPlugins = [
    $0bb108cf9f15301b$var$prefixer
];
var $0bb108cf9f15301b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $0bb108cf9f15301b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $0bb108cf9f15301b$var$compat,
        $0bb108cf9f15301b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $83f8df0fc4bef2f6$export$fac44ee5b035f737),
        (0, $83f8df0fc4bef2f6$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $83f8df0fc4bef2f6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)((0, $83f8df0fc4bef2f6$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $474a93eda108ec7a$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $63fc9407ef8fcdfe$exports = {};
'use strict';
var $dddaf6f84c717660$exports = {};
'use strict';

$dddaf6f84c717660$exports = (parcelRequire("45MkT"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dddaf6f84c717660$exports.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$63fc9407ef8fcdfe$exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $e7e9142d234cc87f$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(targetComponent, sourceComponent);
};


var $48e4b1fcfcd646c1$var$isBrowser = true;
function $48e4b1fcfcd646c1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $48e4b1fcfcd646c1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $48e4b1fcfcd646c1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $48e4b1fcfcd646c1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $48e4b1fcfcd646c1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $26c7bf120a29b208$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $26c7bf120a29b208$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $26c7bf120a29b208$var$hyphenateRegex = /[A-Z]|^ms/g;
var $26c7bf120a29b208$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $26c7bf120a29b208$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $26c7bf120a29b208$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $26c7bf120a29b208$var$processStyleName = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(styleName) {
    return $26c7bf120a29b208$var$isCustomProperty(styleName) ? styleName : styleName.replace($26c7bf120a29b208$var$hyphenateRegex, '-$&').toLowerCase();
});
var $26c7bf120a29b208$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($26c7bf120a29b208$var$animationRegex, function(match, p1, p2) {
                $26c7bf120a29b208$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $26c7bf120a29b208$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039)[key] !== 1 && !$26c7bf120a29b208$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $26c7bf120a29b208$var$contentValuePattern, $26c7bf120a29b208$var$contentValues, $26c7bf120a29b208$var$oldProcessStyleValue, $26c7bf120a29b208$var$msPattern, $26c7bf120a29b208$var$hyphenPattern, $26c7bf120a29b208$var$hyphenatedCache;
var $26c7bf120a29b208$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $26c7bf120a29b208$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $26c7bf120a29b208$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $26c7bf120a29b208$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $26c7bf120a29b208$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $26c7bf120a29b208$var$cursor;
                var result = interpolation(mergedProps);
                $26c7bf120a29b208$var$cursor = previousCursor;
                return $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($26c7bf120a29b208$var$isProcessableValue(value)) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($26c7bf120a29b208$var$isProcessableValue(value[_i])) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $26c7bf120a29b208$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $26c7bf120a29b208$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $26c7bf120a29b208$var$cursor;
var $26c7bf120a29b208$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $26c7bf120a29b208$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $26c7bf120a29b208$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $26c7bf120a29b208$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1529d79d9aa6f066$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $26c7bf120a29b208$var$cursor
    };
};



var $7fPBF = parcelRequire("7fPBF");
var $f9f87826efdb8ce4$var$syncFallback = function syncFallback(create) {
    return create();
};
var $f9f87826efdb8ce4$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $f9f87826efdb8ce4$export$db21c7ffa21794e7 = $f9f87826efdb8ce4$var$useInsertionEffect || $f9f87826efdb8ce4$var$syncFallback;
var $f9f87826efdb8ce4$export$811a713a7276cb9d = $f9f87826efdb8ce4$var$useInsertionEffect || $7fPBF.useLayoutEffect;


var $d89be2faf31d200b$export$23f2a1d2818174ef = true;
var $d89be2faf31d200b$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d89be2faf31d200b$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $d89be2faf31d200b$export$e7094788287c5e9b = $d89be2faf31d200b$var$EmotionCacheContext.Provider;
var $d89be2faf31d200b$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($d89be2faf31d200b$var$EmotionCacheContext);
};
var $d89be2faf31d200b$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($d89be2faf31d200b$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$d89be2faf31d200b$export$23f2a1d2818174ef) $d89be2faf31d200b$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($d89be2faf31d200b$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($d89be2faf31d200b$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $d89be2faf31d200b$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $d89be2faf31d200b$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($d89be2faf31d200b$export$971d5caa766a69d7);
};
var $d89be2faf31d200b$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $d89be2faf31d200b$var$createCacheWithTheme = /* #__PURE__ */ (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(theme) {
        return $d89be2faf31d200b$var$getTheme(outerTheme, theme);
    });
});
var $d89be2faf31d200b$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($d89be2faf31d200b$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d89be2faf31d200b$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($d89be2faf31d200b$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d89be2faf31d200b$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $7fPBF.useContext($d89be2faf31d200b$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $e7e9142d234cc87f$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $d89be2faf31d200b$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $d89be2faf31d200b$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $d89be2faf31d200b$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $d89be2faf31d200b$var$getLastPart(match[1]);
    return undefined;
};
var $d89be2faf31d200b$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $d89be2faf31d200b$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $d89be2faf31d200b$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $d89be2faf31d200b$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($d89be2faf31d200b$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $d89be2faf31d200b$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $d89be2faf31d200b$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $d89be2faf31d200b$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $d89be2faf31d200b$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($d89be2faf31d200b$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$d89be2faf31d200b$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $d89be2faf31d200b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $f9f87826efdb8ce4$export$db21c7ffa21794e7)(function() {
        return (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $d89be2faf31d200b$var$Emotion = /* #__PURE__ */ $d89be2faf31d200b$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d89be2faf31d200b$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $26c7bf120a29b208$export$6321afa313b251b5)(registeredStyles, undefined, $7fPBF.useContext($d89be2faf31d200b$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($d89be2faf31d200b$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $d89be2faf31d200b$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d89be2faf31d200b$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $d89be2faf31d200b$export$a9c23c6ac3fc3eca = $d89be2faf31d200b$var$Emotion;



var $7fPBF = parcelRequire("7fPBF");




var $91b5651481cc9d5c$exports = {};
function $91b5651481cc9d5c$var$_extends() {
    $91b5651481cc9d5c$exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $91b5651481cc9d5c$exports.__esModule = true, $91b5651481cc9d5c$exports["default"] = $91b5651481cc9d5c$exports;
    return $91b5651481cc9d5c$var$_extends.apply(this, arguments);
}
$91b5651481cc9d5c$exports = $91b5651481cc9d5c$var$_extends, $91b5651481cc9d5c$exports.__esModule = true, $91b5651481cc9d5c$exports["default"] = $91b5651481cc9d5c$exports;





var $911cbdf1bb354eb9$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $911cbdf1bb354eb9$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $d89be2faf31d200b$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $d89be2faf31d200b$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $d89be2faf31d200b$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
var $911cbdf1bb354eb9$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $911cbdf1bb354eb9$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $d89be2faf31d200b$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $26c7bf120a29b208$export$6321afa313b251b5)([
        styles
    ], undefined, $7fPBF.useContext((0, $d89be2faf31d200b$export$971d5caa766a69d7)));
    if (!(0, $d89be2faf31d200b$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $f9f87826efdb8ce4$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $f9f87826efdb8ce4$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $911cbdf1bb354eb9$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $26c7bf120a29b208$export$6321afa313b251b5)(args);
}
var $911cbdf1bb354eb9$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $911cbdf1bb354eb9$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $911cbdf1bb354eb9$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $911cbdf1bb354eb9$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $911cbdf1bb354eb9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $f9f87826efdb8ce4$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $911cbdf1bb354eb9$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $d89be2faf31d200b$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $26c7bf120a29b208$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $911cbdf1bb354eb9$var$merge(cache.registered, css, $911cbdf1bb354eb9$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $d89be2faf31d200b$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($911cbdf1bb354eb9$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $911cbdf1bb354eb9$var$isBrowser, $911cbdf1bb354eb9$var$isTestEnv, $911cbdf1bb354eb9$var$globalContext, $911cbdf1bb354eb9$var$globalKey;





function $5a35ab2e435ec5a2$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $7fPBF = parcelRequire("7fPBF");





function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ 
const $f56410848bcbe11b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $f56410848bcbe11b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $f56410848bcbe11b$export$803cd8101b6c182b = /*#__PURE__*/ $f56410848bcbe11b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[0], side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[1]), []);
const $f56410848bcbe11b$export$96ec731ed4dcb222 = Math.min;
const $f56410848bcbe11b$export$8960430cfd85939f = Math.max;
const $f56410848bcbe11b$export$2077e0241d6afd3c = Math.round;
const $f56410848bcbe11b$export$a3fe094919f356fd = Math.floor;
const $f56410848bcbe11b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f56410848bcbe11b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $f56410848bcbe11b$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $f56410848bcbe11b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f56410848bcbe11b$export$8960430cfd85939f(start, $f56410848bcbe11b$export$96ec731ed4dcb222(value, end));
}
function $f56410848bcbe11b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $f56410848bcbe11b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $f56410848bcbe11b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $f56410848bcbe11b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $f56410848bcbe11b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $f56410848bcbe11b$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($f56410848bcbe11b$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement) {
    return $f56410848bcbe11b$export$8a000a963141ac32($f56410848bcbe11b$export$f28e8f882010718a(placement));
}
function $f56410848bcbe11b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement);
    const length = $f56410848bcbe11b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f56410848bcbe11b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f56410848bcbe11b$export$9c5e28bad23365fa(placement);
    return [
        $f56410848bcbe11b$export$2b182c584985588b(placement),
        oppositePlacement,
        $f56410848bcbe11b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f56410848bcbe11b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$f56410848bcbe11b$var$oppositeAlignmentMap[alignment]);
}
function $f56410848bcbe11b$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $f56410848bcbe11b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    let list = $f56410848bcbe11b$var$getSideList($f56410848bcbe11b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f56410848bcbe11b$export$2b182c584985588b));
    }
    return list;
}
function $f56410848bcbe11b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$f56410848bcbe11b$var$oppositeSideMap[side]);
}
function $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) {
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $f56410848bcbe11b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f56410848bcbe11b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $b8d321edac7a7d95$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $b8d321edac7a7d95$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, middlewareData), {
            [name]: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $b8d321edac7a7d95$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b8d321edac7a7d95$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $b8d321edac7a7d95$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f56410848bcbe11b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b8d321edac7a7d95$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f56410848bcbe11b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f56410848bcbe11b$export$803cd8101b6c182b) ? $b8d321edac7a7d95$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $f56410848bcbe11b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b8d321edac7a7d95$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f56410848bcbe11b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f56410848bcbe11b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') fallbackPlacements.push(...(0, $f56410848bcbe11b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f56410848bcbe11b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $b8d321edac7a7d95$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $b8d321edac7a7d95$var$isAnySideFullyClipped(overflow) {
    return (0, $f56410848bcbe11b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b8d321edac7a7d95$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { strategy: strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $b8d321edac7a7d95$var$getBoundingRect(rects) {
    const minX = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $b8d321edac7a7d95$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b8d321edac7a7d95$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $b8d321edac7a7d95$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $b8d321edac7a7d95$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b8d321edac7a7d95$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $b8d321edac7a7d95$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, diffCoords), {
                    placement: placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b8d321edac7a7d95$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b8d321edac7a7d95$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b8d321edac7a7d95$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "apply"
            ]);
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $d0eb1ce7e5ffa070$export$651544f548703224(node) {
    if ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $d0eb1ce7e5ffa070$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Node;
}
function $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Element;
}
function $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).HTMLElement;
}
function $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $d0eb1ce7e5ffa070$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $d0eb1ce7e5ffa070$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $d0eb1ce7e5ffa070$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(element));
}
function $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(element) {
    const webkit = $d0eb1ce7e5ffa070$export$78551043582a6a98();
    const css = $d0eb1ce7e5ffa070$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $d0eb1ce7e5ffa070$export$940d8225183e1404(element) {
    let currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(element);
    while($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(currentNode) && !$d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(currentNode)){
        if ($d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $d0eb1ce7e5ffa070$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(node));
}
function $d0eb1ce7e5ffa070$export$3735103072e4a80(element) {
    return $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $d0eb1ce7e5ffa070$export$dc8fc79fa2800137(element) {
    if ($d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node) {
    if ($d0eb1ce7e5ffa070$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $d0eb1ce7e5ffa070$export$e495491855dc5418(node);
    return $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node) {
    const parentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node);
    if ($d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(parentNode) && $d0eb1ce7e5ffa070$export$989e911fa9af580a(parentNode)) return parentNode;
    return $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(parentNode);
}
function $d0eb1ce7e5ffa070$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $d0eb1ce7e5ffa070$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $d0eb1ce7e5ffa070$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $d0eb1ce7e5ffa070$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $28b5c677ea6a5d8a$var$getCssDimensions(element) {
    const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $28b5c677ea6a5d8a$var$unwrapElement(element) {
    return !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $28b5c677ea6a5d8a$var$getScale(element) {
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(domElement)) return (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $28b5c677ea6a5d8a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $28b5c677ea6a5d8a$var$noOffsets = /*#__PURE__*/ (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
function $28b5c677ea6a5d8a$var$getVisualOffsets(element) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if (!(0, $d0eb1ce7e5ffa070$export$78551043582a6a98)() || !win.visualViewport) return $28b5c677ea6a5d8a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $28b5c677ea6a5d8a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent)) scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
        } else scale = $28b5c677ea6a5d8a$var$getScale(element);
    }
    const visualOffsets = $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $28b5c677ea6a5d8a$var$getVisualOffsets(domElement) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $28b5c677ea6a5d8a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $28b5c677ea6a5d8a$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $28b5c677ea6a5d8a$var$isTopLayer(element) {
    return $28b5c677ea6a5d8a$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $28b5c677ea6a5d8a$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== 'body' || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent);
            scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $28b5c677ea6a5d8a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $28b5c677ea6a5d8a$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $28b5c677ea6a5d8a$var$getBoundingClientRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element)).left + (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $28b5c677ea6a5d8a$var$getDocumentRect(element) {
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $28b5c677ea6a5d8a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getViewportRect(element, strategy) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $d0eb1ce7e5ffa070$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) ? $28b5c677ea6a5d8a$var$getScale(element) : (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $28b5c677ea6a5d8a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $28b5c677ea6a5d8a$var$getDocumentRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element));
    else if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $28b5c677ea6a5d8a$var$getVisualOffsets(element);
        rect = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(rect);
}
function $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(parentNode) || (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(parentNode).position === 'fixed' || $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(el) && (0, $d0eb1ce7e5ffa070$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(currentNode) && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $28b5c677ea6a5d8a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? $28b5c677ea6a5d8a$var$isTopLayer(element) ? [] : $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $28b5c677ea6a5d8a$var$getDimensions(element) {
    const { width: width, height: height } = $28b5c677ea6a5d8a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== 'body' || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $28b5c677ea6a5d8a$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $28b5c677ea6a5d8a$var$isStaticPositioned(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'static';
}
function $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) || (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $28b5c677ea6a5d8a$var$getOffsetParent(element, polyfill) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if ($28b5c677ea6a5d8a$var$isTopLayer(element)) return win;
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$28b5c677ea6a5d8a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $d0eb1ce7e5ffa070$export$71535ffaa902797f)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent))offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent) && !(0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $d0eb1ce7e5ffa070$export$940d8225183e1404)(element) || win;
}
const $28b5c677ea6a5d8a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $28b5c677ea6a5d8a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $28b5c677ea6a5d8a$var$isRTL(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).direction === 'rtl';
}
const $28b5c677ea6a5d8a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $d0eb1ce7e5ffa070$export$e495491855dc5418,
    getClippingRect: $28b5c677ea6a5d8a$var$getClippingRect,
    getOffsetParent: $28b5c677ea6a5d8a$var$getOffsetParent,
    getElementRects: $28b5c677ea6a5d8a$var$getElementRects,
    getClientRects: $28b5c677ea6a5d8a$var$getClientRects,
    getDimensions: $28b5c677ea6a5d8a$var$getDimensions,
    getScale: $28b5c677ea6a5d8a$var$getScale,
    isElement: $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d,
    isRTL: $28b5c677ea6a5d8a$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $28b5c677ea6a5d8a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f56410848bcbe11b$export$8960430cfd85939f)(0, (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $28b5c677ea6a5d8a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $28b5c677ea6a5d8a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $28b5c677ea6a5d8a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $28b5c677ea6a5d8a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $28b5c677ea6a5d8a$export$37b6bde19b108ecc = (0, $b8d321edac7a7d95$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28b5c677ea6a5d8a$export$cc800923e997bb8 = (0, $b8d321edac7a7d95$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28b5c677ea6a5d8a$export$91fb6ecbd551914 = (0, $b8d321edac7a7d95$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28b5c677ea6a5d8a$export$fba63a578e423eb = (0, $b8d321edac7a7d95$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28b5c677ea6a5d8a$export$8a83211c878a3f1f = (0, $b8d321edac7a7d95$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28b5c677ea6a5d8a$export$346677f925de839c = (0, $b8d321edac7a7d95$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28b5c677ea6a5d8a$export$fe8985bb6374093c = (0, $b8d321edac7a7d95$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28b5c677ea6a5d8a$export$f2120bbfa5450bd2 = (0, $b8d321edac7a7d95$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28b5c677ea6a5d8a$export$18c8ad048e32c7d5 = (0, $b8d321edac7a7d95$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28b5c677ea6a5d8a$export$7bf07e38f3dc4b69 = (0, $b8d321edac7a7d95$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $28b5c677ea6a5d8a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        platform: $28b5c677ea6a5d8a$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $b8d321edac7a7d95$export$48a53dcb22e581d0)(reference, floating, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedOptions), {
        platform: platformWithCache
    }));
};



var $7fPBF = parcelRequire("7fPBF");
var $cc0e64a9bd2c0187$var$index = (0, $7fPBF.useLayoutEffect);
var $cc0e64a9bd2c0187$export$2e2bcd8739ae039 = $cc0e64a9bd2c0187$var$index;


var $0dea675c3e6849be$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $0dea675c3e6849be$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $0dea675c3e6849be$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $0dea675c3e6849be$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($0dea675c3e6849be$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $0dea675c3e6849be$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($0dea675c3e6849be$var$isArray(value)) return value.filter(Boolean);
    if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $0dea675c3e6849be$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(props, $0dea675c3e6849be$var$_excluded$4);
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $0dea675c3e6849be$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $0dea675c3e6849be$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $0dea675c3e6849be$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $0dea675c3e6849be$var$normalizedHeight(el) {
    if ($0dea675c3e6849be$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $0dea675c3e6849be$var$getScrollTop(el) {
    if ($0dea675c3e6849be$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $0dea675c3e6849be$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($0dea675c3e6849be$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $0dea675c3e6849be$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $0dea675c3e6849be$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $0dea675c3e6849be$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $0dea675c3e6849be$export$b4171a6734a65d42;
    var start = $0dea675c3e6849be$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $0dea675c3e6849be$var$easeOutCubic(currentTime, start, change, duration);
        $0dea675c3e6849be$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $0dea675c3e6849be$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $0dea675c3e6849be$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $0dea675c3e6849be$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $0dea675c3e6849be$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $0dea675c3e6849be$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $0dea675c3e6849be$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $0dea675c3e6849be$var$passiveOptionAccessed = false;
var $0dea675c3e6849be$var$options = {
    get passive () {
        return $0dea675c3e6849be$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $0dea675c3e6849be$var$w = typeof window !== 'undefined' ? window : {};
if ($0dea675c3e6849be$var$w.addEventListener && $0dea675c3e6849be$var$w.removeEventListener) {
    $0dea675c3e6849be$var$w.addEventListener('p', $0dea675c3e6849be$export$b4171a6734a65d42, $0dea675c3e6849be$var$options);
    $0dea675c3e6849be$var$w.removeEventListener('p', $0dea675c3e6849be$export$b4171a6734a65d42, false);
}
var $0dea675c3e6849be$export$2408f22a0fab9ae5 = $0dea675c3e6849be$var$passiveOptionAccessed;
function $0dea675c3e6849be$export$3466f893ebf79586(item) {
    return item != null;
}
function $0dea675c3e6849be$var$isArray(arg) {
    return Array.isArray(arg);
}
function $0dea675c3e6849be$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $0dea675c3e6849be$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $0dea675c3e6849be$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $0dea675c3e6849be$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $0dea675c3e6849be$var$_excluded$3 = [
    "children",
    "innerProps"
], $0dea675c3e6849be$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $0dea675c3e6849be$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $0dea675c3e6849be$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $0dea675c3e6849be$var$normalizedHeight(scrollParent);
    var scrollTop = $0dea675c3e6849be$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $0dea675c3e6849be$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $0dea675c3e6849be$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $0dea675c3e6849be$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $0dea675c3e6849be$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $0dea675c3e6849be$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $0dea675c3e6849be$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $0dea675c3e6849be$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $0dea675c3e6849be$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_objectSpread2, $0dea675c3e6849be$var$alignToControl(placement), '100%'), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $0dea675c3e6849be$var$PortalPlacementContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
// NOTE: internal only
var $0dea675c3e6849be$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $7fPBF.useContext)($0dea675c3e6849be$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)(maxMenuHeight), _useState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(null), _useState4 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $cc0e64a9bd2c0187$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $0dea675c3e6849be$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $0dea675c3e6849be$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $0dea675c3e6849be$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $0dea675c3e6849be$var$Menu$1 = $0dea675c3e6849be$var$Menu;
// ==============================
// Menu List
// ==============================
var $0dea675c3e6849be$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $0dea675c3e6849be$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $0dea675c3e6849be$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $0dea675c3e6849be$export$3b14a55fb2447963 = $0dea675c3e6849be$var$noticeCSS;
var $0dea675c3e6849be$export$342063e11d6c3cad = $0dea675c3e6849be$var$noticeCSS;
var $0dea675c3e6849be$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref6, $0dea675c3e6849be$var$_excluded$3);
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $0dea675c3e6849be$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref7, $0dea675c3e6849be$var$_excluded2$1);
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $0dea675c3e6849be$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $0dea675c3e6849be$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $7fPBF.useRef)(null);
    var cleanupRef = (0, $7fPBF.useRef)(null);
    var _useState5 = (0, $7fPBF.useState)($0dea675c3e6849be$var$coercePlacement(menuPlacement)), _useState6 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $7fPBF.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $7fPBF.useState)(null), _useState8 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $7fPBF.useCallback)(function() {
        if (!controlElement) return;
        var rect = $0dea675c3e6849be$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $cc0e64a9bd2c0187$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $7fPBF.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $28b5c677ea6a5d8a$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $cc0e64a9bd2c0187$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $7fPBF.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $0dea675c3e6849be$var$getStyleProps((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $0dea675c3e6849be$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $0dea675c3e6849be$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $0dea675c3e6849be$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $0dea675c3e6849be$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $0dea675c3e6849be$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $0dea675c3e6849be$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $0dea675c3e6849be$var$_templateObject;
var $0dea675c3e6849be$var$_excluded$2 = [
    "size"
], $0dea675c3e6849be$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $0dea675c3e6849be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $0dea675c3e6849be$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $0dea675c3e6849be$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref, $0dea675c3e6849be$var$_excluded$2);
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("svg", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $0dea675c3e6849be$var$_ref2
    }, props));
};
var $0dea675c3e6849be$var$CrossIcon = function CrossIcon(props) {
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$Svg, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $0dea675c3e6849be$var$DownChevron = function DownChevron(props) {
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$Svg, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $0dea675c3e6849be$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $0dea675c3e6849be$export$f1e1789686576879 = $0dea675c3e6849be$var$baseCSS;
var $0dea675c3e6849be$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$DownChevron, null));
};
var $0dea675c3e6849be$export$407448d2b89b1813 = $0dea675c3e6849be$var$baseCSS;
var $0dea675c3e6849be$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $0dea675c3e6849be$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $0dea675c3e6849be$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("span", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerProps, $0dea675c3e6849be$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $0dea675c3e6849be$var$loadingDotAnimations = (0, $911cbdf1bb354eb9$export$d25ddfdf17c3ad3e)($0dea675c3e6849be$var$_templateObject || ($0dea675c3e6849be$var$_templateObject = (0, $5a35ab2e435ec5a2$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $0dea675c3e6849be$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $0dea675c3e6849be$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $911cbdf1bb354eb9$export$dbf350e5966cf602)({
            animation: "".concat($0dea675c3e6849be$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $0dea675c3e6849be$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref7, $0dea675c3e6849be$var$_excluded2);
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $0dea675c3e6849be$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $0dea675c3e6849be$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $0dea675c3e6849be$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $0dea675c3e6849be$var$Control$1 = $0dea675c3e6849be$var$Control;
var $0dea675c3e6849be$var$_excluded$1 = [
    "data"
];
var $0dea675c3e6849be$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $0dea675c3e6849be$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)(Heading, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", null, children));
};
var $0dea675c3e6849be$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $0dea675c3e6849be$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $0dea675c3e6849be$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_cleanCommonProps, $0dea675c3e6849be$var$_excluded$1);
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $0dea675c3e6849be$var$Group$1 = $0dea675c3e6849be$var$Group;
var $0dea675c3e6849be$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $0dea675c3e6849be$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $0dea675c3e6849be$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $0dea675c3e6849be$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $0dea675c3e6849be$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $0dea675c3e6849be$var$spacingStyle)
};
var $0dea675c3e6849be$var$inputStyle = function inputStyle(isHidden) {
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $0dea675c3e6849be$var$spacingStyle);
};
var $0dea675c3e6849be$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $0dea675c3e6849be$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_cleanCommonProps, $0dea675c3e6849be$var$_excluded);
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("input", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $0dea675c3e6849be$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $0dea675c3e6849be$var$Input$1 = $0dea675c3e6849be$var$Input;
var $0dea675c3e6849be$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $0dea675c3e6849be$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $0dea675c3e6849be$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $0dea675c3e6849be$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $0dea675c3e6849be$var$MultiValueContainer = $0dea675c3e6849be$var$MultiValueGeneric;
var $0dea675c3e6849be$var$MultiValueLabel = $0dea675c3e6849be$var$MultiValueGeneric;
function $0dea675c3e6849be$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($0dea675c3e6849be$var$CrossIcon, {
        size: 14
    }));
}
var $0dea675c3e6849be$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $8273a87573256c54$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $0dea675c3e6849be$var$MultiValue$1 = $0dea675c3e6849be$var$MultiValue;
var $0dea675c3e6849be$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $0dea675c3e6849be$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $0dea675c3e6849be$var$Option$1 = $0dea675c3e6849be$var$Option;
var $0dea675c3e6849be$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $0dea675c3e6849be$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $0dea675c3e6849be$var$Placeholder$1 = $0dea675c3e6849be$var$Placeholder;
var $0dea675c3e6849be$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $0dea675c3e6849be$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $0dea675c3e6849be$var$SingleValue$1 = $0dea675c3e6849be$var$SingleValue;
var $0dea675c3e6849be$export$db3b6bfb95261072 = {
    ClearIndicator: $0dea675c3e6849be$var$ClearIndicator,
    Control: $0dea675c3e6849be$var$Control$1,
    DropdownIndicator: $0dea675c3e6849be$var$DropdownIndicator,
    DownChevron: $0dea675c3e6849be$var$DownChevron,
    CrossIcon: $0dea675c3e6849be$var$CrossIcon,
    Group: $0dea675c3e6849be$var$Group$1,
    GroupHeading: $0dea675c3e6849be$var$GroupHeading,
    IndicatorsContainer: $0dea675c3e6849be$var$IndicatorsContainer,
    IndicatorSeparator: $0dea675c3e6849be$var$IndicatorSeparator,
    Input: $0dea675c3e6849be$var$Input$1,
    LoadingIndicator: $0dea675c3e6849be$var$LoadingIndicator,
    Menu: $0dea675c3e6849be$var$Menu$1,
    MenuList: $0dea675c3e6849be$var$MenuList,
    MenuPortal: $0dea675c3e6849be$var$MenuPortal,
    LoadingMessage: $0dea675c3e6849be$var$LoadingMessage,
    NoOptionsMessage: $0dea675c3e6849be$var$NoOptionsMessage,
    MultiValue: $0dea675c3e6849be$var$MultiValue$1,
    MultiValueContainer: $0dea675c3e6849be$var$MultiValueContainer,
    MultiValueLabel: $0dea675c3e6849be$var$MultiValueLabel,
    MultiValueRemove: $0dea675c3e6849be$var$MultiValueRemove,
    Option: $0dea675c3e6849be$var$Option$1,
    Placeholder: $0dea675c3e6849be$var$Placeholder$1,
    SelectContainer: $0dea675c3e6849be$var$SelectContainer,
    SingleValue: $0dea675c3e6849be$var$SingleValue$1,
    ValueContainer: $0dea675c3e6849be$var$ValueContainer
};
var $0dea675c3e6849be$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, $0dea675c3e6849be$export$db3b6bfb95261072), props.components);
};



var $859f0395401445ad$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $859f0395401445ad$var$isEqual(first, second) {
    if (first === second) return true;
    if ($859f0395401445ad$var$safeIsNaN(first) && $859f0395401445ad$var$safeIsNaN(second)) return true;
    return false;
}
function $859f0395401445ad$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$859f0395401445ad$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $859f0395401445ad$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $859f0395401445ad$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $667645dfe6d7b8e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $667645dfe6d7b8e2$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $667645dfe6d7b8e2$var$A11yText = function A11yText(props) {
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("span", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        css: $667645dfe6d7b8e2$var$_ref
    }, props));
};
var $667645dfe6d7b8e2$var$A11yText$1 = $667645dfe6d7b8e2$var$A11yText;
var $667645dfe6d7b8e2$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $667645dfe6d7b8e2$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $7fPBF.useMemo)(function() {
        return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, $667645dfe6d7b8e2$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $7fPBF.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $8273a87573256c54$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $7fPBF.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $7fPBF.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $7fPBF.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), null, (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), null, (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($667645dfe6d7b8e2$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)($667645dfe6d7b8e2$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $667645dfe6d7b8e2$var$LiveRegion$1 = $667645dfe6d7b8e2$var$LiveRegion;
var $667645dfe6d7b8e2$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $667645dfe6d7b8e2$var$anyDiacritic = new RegExp('[' + $667645dfe6d7b8e2$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $667645dfe6d7b8e2$var$diacriticToBase = {};
for(var $667645dfe6d7b8e2$var$i = 0; $667645dfe6d7b8e2$var$i < $667645dfe6d7b8e2$var$diacritics.length; $667645dfe6d7b8e2$var$i++){
    var $667645dfe6d7b8e2$var$diacritic = $667645dfe6d7b8e2$var$diacritics[$667645dfe6d7b8e2$var$i];
    for(var $667645dfe6d7b8e2$var$j = 0; $667645dfe6d7b8e2$var$j < $667645dfe6d7b8e2$var$diacritic.letters.length; $667645dfe6d7b8e2$var$j++)$667645dfe6d7b8e2$var$diacriticToBase[$667645dfe6d7b8e2$var$diacritic.letters[$667645dfe6d7b8e2$var$j]] = $667645dfe6d7b8e2$var$diacritic.base;
}
var $667645dfe6d7b8e2$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($667645dfe6d7b8e2$var$anyDiacritic, function(match) {
        return $667645dfe6d7b8e2$var$diacriticToBase[match];
    });
};
var $667645dfe6d7b8e2$var$memoizedStripDiacriticsForInput = (0, $859f0395401445ad$export$2e2bcd8739ae039)($667645dfe6d7b8e2$var$stripDiacritics);
var $667645dfe6d7b8e2$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $667645dfe6d7b8e2$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $667645dfe6d7b8e2$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $8273a87573256c54$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $667645dfe6d7b8e2$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $667645dfe6d7b8e2$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $667645dfe6d7b8e2$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $667645dfe6d7b8e2$var$memoizedStripDiacriticsForInput(input);
            candidate = $667645dfe6d7b8e2$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $667645dfe6d7b8e2$var$_excluded = [
    "innerRef"
];
function $667645dfe6d7b8e2$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref, $667645dfe6d7b8e2$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $0dea675c3e6849be$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("input", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $911cbdf1bb354eb9$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $667645dfe6d7b8e2$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $667645dfe6d7b8e2$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $7fPBF.useRef)(false);
    var isTop = (0, $7fPBF.useRef)(false);
    var touchStart = (0, $7fPBF.useRef)(0);
    var scrollTarget = (0, $7fPBF.useRef)(null);
    var handleEventDelta = (0, $7fPBF.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $667645dfe6d7b8e2$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $7fPBF.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $7fPBF.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $7fPBF.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $7fPBF.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $0dea675c3e6849be$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $7fPBF.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $667645dfe6d7b8e2$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $667645dfe6d7b8e2$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $667645dfe6d7b8e2$var$preventTouchMove(e) {
    e.preventDefault();
}
function $667645dfe6d7b8e2$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $667645dfe6d7b8e2$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $667645dfe6d7b8e2$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $667645dfe6d7b8e2$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $667645dfe6d7b8e2$var$activeScrollLocks = 0;
var $667645dfe6d7b8e2$var$listenerOptions = {
    capture: false,
    passive: false
};
function $667645dfe6d7b8e2$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $7fPBF.useRef)({});
    var scrollTarget = (0, $7fPBF.useRef)(null);
    var addScrollLock = (0, $7fPBF.useCallback)(function(touchScrollTarget) {
        if (!$667645dfe6d7b8e2$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $667645dfe6d7b8e2$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $667645dfe6d7b8e2$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($667645dfe6d7b8e2$var$LOCK_STYLES).forEach(function(key) {
                var val = $667645dfe6d7b8e2$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $667645dfe6d7b8e2$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $667645dfe6d7b8e2$var$preventTouchMove, $667645dfe6d7b8e2$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $667645dfe6d7b8e2$var$preventInertiaScroll, $667645dfe6d7b8e2$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $667645dfe6d7b8e2$var$allowTouchMove, $667645dfe6d7b8e2$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $667645dfe6d7b8e2$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $7fPBF.useCallback)(function(touchScrollTarget) {
        if (!$667645dfe6d7b8e2$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $667645dfe6d7b8e2$var$activeScrollLocks = Math.max($667645dfe6d7b8e2$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $667645dfe6d7b8e2$var$activeScrollLocks < 1) $667645dfe6d7b8e2$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $667645dfe6d7b8e2$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $667645dfe6d7b8e2$var$preventTouchMove, $667645dfe6d7b8e2$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $667645dfe6d7b8e2$var$preventInertiaScroll, $667645dfe6d7b8e2$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $667645dfe6d7b8e2$var$allowTouchMove, $667645dfe6d7b8e2$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $667645dfe6d7b8e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $667645dfe6d7b8e2$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $667645dfe6d7b8e2$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $667645dfe6d7b8e2$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $667645dfe6d7b8e2$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $667645dfe6d7b8e2$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), null, lockEnabled && (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("div", {
        onClick: $667645dfe6d7b8e2$var$blurSelectInput,
        css: $667645dfe6d7b8e2$var$_ref2$1
    }), children(targetRef));
}
function $667645dfe6d7b8e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $667645dfe6d7b8e2$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $667645dfe6d7b8e2$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $911cbdf1bb354eb9$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $667645dfe6d7b8e2$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $667645dfe6d7b8e2$var$RequiredInput$1 = $667645dfe6d7b8e2$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $667645dfe6d7b8e2$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $667645dfe6d7b8e2$var$isIPhone() {
    return $667645dfe6d7b8e2$var$testPlatform(/^iPhone/i);
}
function $667645dfe6d7b8e2$var$isMac() {
    return $667645dfe6d7b8e2$var$testPlatform(/^Mac/i);
}
function $667645dfe6d7b8e2$var$isIPad() {
    return $667645dfe6d7b8e2$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $667645dfe6d7b8e2$var$isMac() && navigator.maxTouchPoints > 1;
}
function $667645dfe6d7b8e2$var$isIOS() {
    return $667645dfe6d7b8e2$var$isIPhone() || $667645dfe6d7b8e2$var$isIPad();
}
function $667645dfe6d7b8e2$var$isAppleDevice() {
    return $667645dfe6d7b8e2$var$isMac() || $667645dfe6d7b8e2$var$isIOS();
}
var $667645dfe6d7b8e2$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $667645dfe6d7b8e2$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $667645dfe6d7b8e2$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $667645dfe6d7b8e2$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $667645dfe6d7b8e2$var$defaultStyles = {
    clearIndicator: (0, $0dea675c3e6849be$export$407448d2b89b1813),
    container: (0, $0dea675c3e6849be$export$8b22cf2602fb60ce),
    control: (0, $0dea675c3e6849be$export$4368d992c4eafac0),
    dropdownIndicator: (0, $0dea675c3e6849be$export$f1e1789686576879),
    group: (0, $0dea675c3e6849be$export$39b482c5e57630a8),
    groupHeading: (0, $0dea675c3e6849be$export$2d1720544b23b823),
    indicatorsContainer: (0, $0dea675c3e6849be$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $0dea675c3e6849be$export$dda1d9f60106f0e9),
    input: (0, $0dea675c3e6849be$export$35e795649ee09318),
    loadingIndicator: (0, $0dea675c3e6849be$export$882b5998b3b9117c),
    loadingMessage: (0, $0dea675c3e6849be$export$342063e11d6c3cad),
    menu: (0, $0dea675c3e6849be$export$953cecd6e717a553),
    menuList: (0, $0dea675c3e6849be$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $0dea675c3e6849be$export$ae1af26003f05816),
    multiValue: (0, $0dea675c3e6849be$export$ffb5f4729a158638),
    multiValueLabel: (0, $0dea675c3e6849be$export$9e5f44173e64f162),
    multiValueRemove: (0, $0dea675c3e6849be$export$625550452a3fa3ec),
    noOptionsMessage: (0, $0dea675c3e6849be$export$3b14a55fb2447963),
    option: (0, $0dea675c3e6849be$export$90a7f3efeed30595),
    placeholder: (0, $0dea675c3e6849be$export$efccba1c4a2ef57b),
    singleValue: (0, $0dea675c3e6849be$export$d141bba7fdc215a3),
    valueContainer: (0, $0dea675c3e6849be$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $667645dfe6d7b8e2$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $8273a87573256c54$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $667645dfe6d7b8e2$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $667645dfe6d7b8e2$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $667645dfe6d7b8e2$var$baseUnit = 4;
// The minimum height of the control
var $667645dfe6d7b8e2$var$controlHeight = 38;
// The amount of space between the control and menu */
var $667645dfe6d7b8e2$var$menuGutter = $667645dfe6d7b8e2$var$baseUnit * 2;
var $667645dfe6d7b8e2$var$spacing = {
    baseUnit: $667645dfe6d7b8e2$var$baseUnit,
    controlHeight: $667645dfe6d7b8e2$var$controlHeight,
    menuGutter: $667645dfe6d7b8e2$var$menuGutter
};
var $667645dfe6d7b8e2$export$4368d992c4eafac0 = {
    borderRadius: $667645dfe6d7b8e2$var$borderRadius,
    colors: $667645dfe6d7b8e2$var$colors,
    spacing: $667645dfe6d7b8e2$var$spacing
};
var $667645dfe6d7b8e2$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $0dea675c3e6849be$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $0dea675c3e6849be$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $667645dfe6d7b8e2$export$db3b6bfb95261072(),
    formatGroupLabel: $667645dfe6d7b8e2$var$formatGroupLabel,
    getOptionLabel: $667645dfe6d7b8e2$export$8b22cf2602fb60ce,
    getOptionValue: $667645dfe6d7b8e2$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $667645dfe6d7b8e2$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $0dea675c3e6849be$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $667645dfe6d7b8e2$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $667645dfe6d7b8e2$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $667645dfe6d7b8e2$var$_isOptionSelected(props, option, selectValue);
    var label = $667645dfe6d7b8e2$var$getOptionLabel(props, option);
    var value = $667645dfe6d7b8e2$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $667645dfe6d7b8e2$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $667645dfe6d7b8e2$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $667645dfe6d7b8e2$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $667645dfe6d7b8e2$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $667645dfe6d7b8e2$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $0dea675c3e6849be$export$3466f893ebf79586));
}
function $667645dfe6d7b8e2$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $91ec1961173e898a$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $667645dfe6d7b8e2$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $91ec1961173e898a$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $667645dfe6d7b8e2$var$buildFocusableOptions(props, selectValue) {
    return $667645dfe6d7b8e2$var$buildFocusableOptionsFromCategorizedOptions($667645dfe6d7b8e2$var$buildCategorizedOptions(props, selectValue));
}
function $667645dfe6d7b8e2$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$667645dfe6d7b8e2$var$shouldHideSelectedOptions(props) || !isSelected) && $667645dfe6d7b8e2$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $667645dfe6d7b8e2$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $667645dfe6d7b8e2$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $667645dfe6d7b8e2$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $667645dfe6d7b8e2$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $667645dfe6d7b8e2$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $667645dfe6d7b8e2$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $667645dfe6d7b8e2$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $667645dfe6d7b8e2$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $667645dfe6d7b8e2$var$getOptionValue(props, i) === candidate;
    });
}
function $667645dfe6d7b8e2$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $667645dfe6d7b8e2$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $667645dfe6d7b8e2$var$instanceId = 1;
var $667645dfe6d7b8e2$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $667645dfe6d7b8e2$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $0dea675c3e6849be$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $0dea675c3e6849be$export$ef35774e6d314e91)([].concat((0, $91ec1961173e898a$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $0dea675c3e6849be$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $0dea675c3e6849be$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $0dea675c3e6849be$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $0dea675c3e6849be$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $0dea675c3e6849be$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $667645dfe6d7b8e2$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $667645dfe6d7b8e2$var$buildFocusableOptionsWithIds($667645dfe6d7b8e2$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $0dea675c3e6849be$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $667645dfe6d7b8e2$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $667645dfe6d7b8e2$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $667645dfe6d7b8e2$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $0dea675c3e6849be$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $667645dfe6d7b8e2$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $667645dfe6d7b8e2$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $8273a87573256c54$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $0dea675c3e6849be$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $667645dfe6d7b8e2$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$667645dfe6d7b8e2$var$instanceId);
        _this.state.selectValue = (0, $0dea675c3e6849be$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $667645dfe6d7b8e2$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $0dea675c3e6849be$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $0dea675c3e6849be$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $667645dfe6d7b8e2$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($667645dfe6d7b8e2$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, $667645dfe6d7b8e2$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $667645dfe6d7b8e2$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $667645dfe6d7b8e2$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $667645dfe6d7b8e2$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $7fPBF.createElement($667645dfe6d7b8e2$var$DummyInput, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $0dea675c3e6849be$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $7fPBF.createElement(Input, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $7fPBF.createElement(Placeholder, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $7fPBF.createElement(MultiValue, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $7fPBF.createElement(SingleValue, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $7fPBF.createElement(ClearIndicator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $7fPBF.createElement(LoadingIndicator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $7fPBF.createElement(IndicatorSeparator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $7fPBF.createElement(DropdownIndicator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $7fPBF.createElement(Option, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $7fPBF.createElement(Group, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $7fPBF.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $7fPBF.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $7fPBF.createElement((0, $0dea675c3e6849be$export$3a1a48c8f6ef640e), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $7fPBF.createElement(Menu, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $7fPBF.createElement($667645dfe6d7b8e2$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $7fPBF.createElement(MenuList, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $7fPBF.createElement(MenuPortal, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $7fPBF.createElement($667645dfe6d7b8e2$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $7fPBF.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $7fPBF.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $7fPBF.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $7fPBF.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $7fPBF.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $7fPBF.createElement($667645dfe6d7b8e2$var$LiveRegion$1, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $7fPBF.createElement(SelectContainer, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $7fPBF.createElement(Control, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $7fPBF.createElement(ValueContainer, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $7fPBF.createElement(IndicatorsContainer, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $0dea675c3e6849be$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $667645dfe6d7b8e2$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $667645dfe6d7b8e2$var$buildFocusableOptionsWithIds($667645dfe6d7b8e2$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $667645dfe6d7b8e2$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $667645dfe6d7b8e2$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $667645dfe6d7b8e2$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $0dea675c3e6849be$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $7fPBF.Component));
$667645dfe6d7b8e2$export$25ce5a424b770e84.defaultProps = $667645dfe6d7b8e2$export$407448d2b89b1813;





var $52e386bdc3946b12$exports = {};
var $6655e33f0d2c88e7$exports = {};
var $e574bb2d4ac0a9b8$exports = {};
var $8a40824683152bd6$exports = {};
function $8a40824683152bd6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8a40824683152bd6$exports = $8a40824683152bd6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8a40824683152bd6$exports.__esModule = true, $8a40824683152bd6$exports["default"] = $8a40824683152bd6$exports, $8a40824683152bd6$var$_typeof(o);
}
$8a40824683152bd6$exports = $8a40824683152bd6$var$_typeof, $8a40824683152bd6$exports.__esModule = true, $8a40824683152bd6$exports["default"] = $8a40824683152bd6$exports;


var $e574bb2d4ac0a9b8$var$_typeof = $8a40824683152bd6$exports.default;
var $70dfc0196094649e$exports = {};

var $70dfc0196094649e$var$_typeof = $8a40824683152bd6$exports.default;
function $70dfc0196094649e$var$toPrimitive(t, r) {
    if ("object" != $70dfc0196094649e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $70dfc0196094649e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$70dfc0196094649e$exports = $70dfc0196094649e$var$toPrimitive, $70dfc0196094649e$exports.__esModule = true, $70dfc0196094649e$exports["default"] = $70dfc0196094649e$exports;


function $e574bb2d4ac0a9b8$var$toPropertyKey(t) {
    var i = $70dfc0196094649e$exports(t, "string");
    return "symbol" == $e574bb2d4ac0a9b8$var$_typeof(i) ? i : i + "";
}
$e574bb2d4ac0a9b8$exports = $e574bb2d4ac0a9b8$var$toPropertyKey, $e574bb2d4ac0a9b8$exports.__esModule = true, $e574bb2d4ac0a9b8$exports["default"] = $e574bb2d4ac0a9b8$exports;


function $6655e33f0d2c88e7$var$_defineProperty(obj, key, value) {
    key = $e574bb2d4ac0a9b8$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$6655e33f0d2c88e7$exports = $6655e33f0d2c88e7$var$_defineProperty, $6655e33f0d2c88e7$exports.__esModule = true, $6655e33f0d2c88e7$exports["default"] = $6655e33f0d2c88e7$exports;


function $52e386bdc3946b12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52e386bdc3946b12$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52e386bdc3946b12$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6655e33f0d2c88e7$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52e386bdc3946b12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$52e386bdc3946b12$exports = $52e386bdc3946b12$var$_objectSpread2, $52e386bdc3946b12$exports.__esModule = true, $52e386bdc3946b12$exports["default"] = $52e386bdc3946b12$exports;


var $da571d235d718dda$exports = {};
var $ce77166c8438e964$exports = {};
function $ce77166c8438e964$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$ce77166c8438e964$exports = $ce77166c8438e964$var$_arrayWithHoles, $ce77166c8438e964$exports.__esModule = true, $ce77166c8438e964$exports["default"] = $ce77166c8438e964$exports;


var $20e94df54b7e2c18$exports = {};
function $20e94df54b7e2c18$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$20e94df54b7e2c18$exports = $20e94df54b7e2c18$var$_iterableToArrayLimit, $20e94df54b7e2c18$exports.__esModule = true, $20e94df54b7e2c18$exports["default"] = $20e94df54b7e2c18$exports;


var $3e9b9f2b208dfc3f$exports = {};
var $cf96c9667eae972c$exports = {};
function $cf96c9667eae972c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$cf96c9667eae972c$exports = $cf96c9667eae972c$var$_arrayLikeToArray, $cf96c9667eae972c$exports.__esModule = true, $cf96c9667eae972c$exports["default"] = $cf96c9667eae972c$exports;


function $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cf96c9667eae972c$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cf96c9667eae972c$exports(o, minLen);
}
$3e9b9f2b208dfc3f$exports = $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray, $3e9b9f2b208dfc3f$exports.__esModule = true, $3e9b9f2b208dfc3f$exports["default"] = $3e9b9f2b208dfc3f$exports;


var $c41d81e3d1c59d7f$exports = {};
function $c41d81e3d1c59d7f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$c41d81e3d1c59d7f$exports = $c41d81e3d1c59d7f$var$_nonIterableRest, $c41d81e3d1c59d7f$exports.__esModule = true, $c41d81e3d1c59d7f$exports["default"] = $c41d81e3d1c59d7f$exports;


function $da571d235d718dda$var$_slicedToArray(arr, i) {
    return $ce77166c8438e964$exports(arr) || $20e94df54b7e2c18$exports(arr, i) || $3e9b9f2b208dfc3f$exports(arr, i) || $c41d81e3d1c59d7f$exports();
}
$da571d235d718dda$exports = $da571d235d718dda$var$_slicedToArray, $da571d235d718dda$exports.__esModule = true, $da571d235d718dda$exports["default"] = $da571d235d718dda$exports;


var $a74b0c43386c0a1b$exports = {};
var $0f13ac86de1755d2$exports = {};
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$0f13ac86de1755d2$exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, $0f13ac86de1755d2$exports.__esModule = true, $0f13ac86de1755d2$exports["default"] = $0f13ac86de1755d2$exports;


function $a74b0c43386c0a1b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0f13ac86de1755d2$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$a74b0c43386c0a1b$exports = $a74b0c43386c0a1b$var$_objectWithoutProperties, $a74b0c43386c0a1b$exports.__esModule = true, $a74b0c43386c0a1b$exports["default"] = $a74b0c43386c0a1b$exports;


var $9db39a503775575c$exports = {};
function $9db39a503775575c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$9db39a503775575c$exports = $9db39a503775575c$var$_classCallCheck, $9db39a503775575c$exports.__esModule = true, $9db39a503775575c$exports["default"] = $9db39a503775575c$exports;


var $4d1d8bace1bc5f55$exports = {};

function $4d1d8bace1bc5f55$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e574bb2d4ac0a9b8$exports(descriptor.key), descriptor);
    }
}
function $4d1d8bace1bc5f55$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4d1d8bace1bc5f55$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4d1d8bace1bc5f55$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$4d1d8bace1bc5f55$exports = $4d1d8bace1bc5f55$var$_createClass, $4d1d8bace1bc5f55$exports.__esModule = true, $4d1d8bace1bc5f55$exports["default"] = $4d1d8bace1bc5f55$exports;


var $f6445b9e0be2a3e5$exports = {};
var $12be2991dd9be400$exports = {};
function $12be2991dd9be400$var$_setPrototypeOf(o, p) {
    $12be2991dd9be400$exports = $12be2991dd9be400$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $12be2991dd9be400$exports.__esModule = true, $12be2991dd9be400$exports["default"] = $12be2991dd9be400$exports;
    return $12be2991dd9be400$var$_setPrototypeOf(o, p);
}
$12be2991dd9be400$exports = $12be2991dd9be400$var$_setPrototypeOf, $12be2991dd9be400$exports.__esModule = true, $12be2991dd9be400$exports["default"] = $12be2991dd9be400$exports;


function $f6445b9e0be2a3e5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $12be2991dd9be400$exports(subClass, superClass);
}
$f6445b9e0be2a3e5$exports = $f6445b9e0be2a3e5$var$_inherits, $f6445b9e0be2a3e5$exports.__esModule = true, $f6445b9e0be2a3e5$exports["default"] = $f6445b9e0be2a3e5$exports;


var $f632ff4ee56e1872$exports = {};
var $a51cf303e6548bcf$exports = {};
function $a51cf303e6548bcf$var$_getPrototypeOf(o) {
    $a51cf303e6548bcf$exports = $a51cf303e6548bcf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $a51cf303e6548bcf$exports.__esModule = true, $a51cf303e6548bcf$exports["default"] = $a51cf303e6548bcf$exports;
    return $a51cf303e6548bcf$var$_getPrototypeOf(o);
}
$a51cf303e6548bcf$exports = $a51cf303e6548bcf$var$_getPrototypeOf, $a51cf303e6548bcf$exports.__esModule = true, $a51cf303e6548bcf$exports["default"] = $a51cf303e6548bcf$exports;


var $821d2291835fd002$exports = {};
function $821d2291835fd002$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($821d2291835fd002$exports = $821d2291835fd002$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $821d2291835fd002$exports.__esModule = true, $821d2291835fd002$exports["default"] = $821d2291835fd002$exports)();
}
$821d2291835fd002$exports = $821d2291835fd002$var$_isNativeReflectConstruct, $821d2291835fd002$exports.__esModule = true, $821d2291835fd002$exports["default"] = $821d2291835fd002$exports;


var $a6805b89f289256d$exports = {};

var $a6805b89f289256d$var$_typeof = $8a40824683152bd6$exports.default;
var $034f8c7ceea7c4ac$exports = {};
function $034f8c7ceea7c4ac$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$034f8c7ceea7c4ac$exports = $034f8c7ceea7c4ac$var$_assertThisInitialized, $034f8c7ceea7c4ac$exports.__esModule = true, $034f8c7ceea7c4ac$exports["default"] = $034f8c7ceea7c4ac$exports;


function $a6805b89f289256d$var$_possibleConstructorReturn(self, call) {
    if (call && ($a6805b89f289256d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $034f8c7ceea7c4ac$exports(self);
}
$a6805b89f289256d$exports = $a6805b89f289256d$var$_possibleConstructorReturn, $a6805b89f289256d$exports.__esModule = true, $a6805b89f289256d$exports["default"] = $a6805b89f289256d$exports;


function $f632ff4ee56e1872$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $821d2291835fd002$exports();
    return function _createSuperInternal() {
        var Super = $a51cf303e6548bcf$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a51cf303e6548bcf$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a6805b89f289256d$exports(this, result);
    };
}
$f632ff4ee56e1872$exports = $f632ff4ee56e1872$var$_createSuper, $f632ff4ee56e1872$exports.__esModule = true, $f632ff4ee56e1872$exports["default"] = $f632ff4ee56e1872$exports;


var $df14e51c7c25c788$exports = {};
var $e4d5c3c2aaa74da7$exports = {};

function $e4d5c3c2aaa74da7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cf96c9667eae972c$exports(arr);
}
$e4d5c3c2aaa74da7$exports = $e4d5c3c2aaa74da7$var$_arrayWithoutHoles, $e4d5c3c2aaa74da7$exports.__esModule = true, $e4d5c3c2aaa74da7$exports["default"] = $e4d5c3c2aaa74da7$exports;


var $387209bfaa84eb03$exports = {};
function $387209bfaa84eb03$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$387209bfaa84eb03$exports = $387209bfaa84eb03$var$_iterableToArray, $387209bfaa84eb03$exports.__esModule = true, $387209bfaa84eb03$exports["default"] = $387209bfaa84eb03$exports;



var $fc4f8dbd031a00db$exports = {};
function $fc4f8dbd031a00db$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$fc4f8dbd031a00db$exports = $fc4f8dbd031a00db$var$_nonIterableSpread, $fc4f8dbd031a00db$exports.__esModule = true, $fc4f8dbd031a00db$exports["default"] = $fc4f8dbd031a00db$exports;


function $df14e51c7c25c788$var$_toConsumableArray(arr) {
    return $e4d5c3c2aaa74da7$exports(arr) || $387209bfaa84eb03$exports(arr) || $3e9b9f2b208dfc3f$exports(arr) || $fc4f8dbd031a00db$exports();
}
$df14e51c7c25c788$exports = $df14e51c7c25c788$var$_toConsumableArray, $df14e51c7c25c788$exports.__esModule = true, $df14e51c7c25c788$exports["default"] = $df14e51c7c25c788$exports;




var $154183a490042e57$exports = {};
function $154183a490042e57$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$154183a490042e57$exports = $154183a490042e57$var$_taggedTemplateLiteral, $154183a490042e57$exports.__esModule = true, $154183a490042e57$exports["default"] = $154183a490042e57$exports;






var $2980e0f397dc9d12$var$StateManagedSelect = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $c9af24aac0e2106d$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $7fPBF.createElement((0, $667645dfe6d7b8e2$export$25ce5a424b770e84), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $2980e0f397dc9d12$export$2e2bcd8739ae039 = $2980e0f397dc9d12$var$StateManagedSelect;
var $2980e0f397dc9d12$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $7fPBF.useMemo)(function() {
        return (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d89be2faf31d200b$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};







class $7fe264202fd0c16d$var$ConfigActions {
    changeValue(field, value) {
        return {
            field: field,
            value: value
        };
    }
    /**
   * Algatatakse toote laadimine serverist
   */ fetchConfig() {
        return {};
    }
    /**
   * Toote laadimine ebaõnnestus
   */ fetchConfigFailed(error) {
        return error;
    }
    /**
   * Toode sai laetud
   */ fetchConfigDone(data) {
        return data;
    }
    /**
   * Toote salvestamine serverisse
   */ saveConfig() {
        return {};
    }
    /**
   * Toote salvestamine ebaõnnestus
   */ saveConfigFailed(error) {
        return error;
    }
    /**
   * Toode sai salvestatud
   */ saveConfigDone() {
        return null;
    }
}
var $7fe264202fd0c16d$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($7fe264202fd0c16d$var$ConfigActions);



class $170382fabf001904$var$ActiveConfigActions {
    /**
   * Algatatakse toote laadimine serverist
   */ fetchConfig() {
        return {};
    }
    /**
   * Toote laadimine ebaõnnestus
   */ fetchConfigFailed(error) {
        return error;
    }
    /**
   * Toode sai laetud
   */ fetchConfigDone(data) {
        return data;
    }
}
var $170382fabf001904$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($170382fabf001904$var$ActiveConfigActions);










let $cc65b603f67dc120$var$ConfigSource = {
    fetchConfig () {
        return {
            remote (state) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).getConfig();
            },
            local () {
                return null;
            },
            success: (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).fetchConfigDone,
            error: (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).fetchConfigFailed
        };
    },
    saveConfig () {
        return {
            remote (state) {
                try {
                    return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).putConfig(state.config);
                } catch (e) {
                    if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                        console.log(e.toString());
                        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Internal error"));
                    } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
                    return new Promise((resolve, reject)=>{
                        reject(e);
                    });
                }
            },
            local () {
                return null;
            },
            success: (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).saveConfigDone,
            error: (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).saveConfigFailed
        };
    }
};
var $cc65b603f67dc120$export$2e2bcd8739ae039 = $cc65b603f67dc120$var$ConfigSource;





/**
 * Konfiguratsiooni haldamise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */ class $8ae296341ecbca86$var$ConfigStore {
    /**
   * Toote laadimise käivitamine
   */ onFetchConfig() {
        this.setState({
            state: "PROCESSING"
        });
        let p = this.getInstance().fetchConfig();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote laadimine ebaõnnestus
   */ onFetchConfigFailed(error) {
        this.processError(error);
    }
    processError(error) {
        let message = (0, $865532d99f221026$export$2e2bcd8739ae039)('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) message = error.response.data.error.message;
            else switch(error.response.status){
                case 401:
                case 403:
                    // Authentication required
                    console.log("ConfigStore.processError(): STATUS 401/403: invalidating session");
                    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid password");
                    break;
                case 503:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Service unavailable");
                    break;
                default:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            }
            switch(error.response.status){
                case 401:
                case 403:
                    // Authentication required
                    console.log("ConfigStore.processError(): STATUS 401/403: invalidating session");
                    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
                    this.setState({
                        state: "FAIL"
                    });
                    break;
                default:
                    this.setState({
                        state: "FAIL"
                    });
            }
        } else this.setState({
            state: "FAIL"
        });
        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(message);
    }
    onFetchConfigDone(response) {
        try {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).has(response.data, 'configurationResult')) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            if (response.data.configurationResult == null) this.setState({
                config: {},
                state: "OK"
            });
            else this.setState({
                config: response.data.configurationResult,
                state: "OK"
            });
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Server error"));
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
            this.setState({
                state: "FAIL"
            });
        }
    }
    onSaveConfig() {
        this.setState({
            state: "PROCESSING"
        });
        let p = this.getInstance().saveConfig();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    onSaveConfigFailed(error) {
        this.processError(error);
    }
    onSaveConfigDone() {
        (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('Configuration saved'));
        this.setState({
            state: "OK"
        });
    }
    /**
   * Parameetri muutmine
   */ onChangeValue(info) {
        if (!this.validateValue(info)) return;
        let newConfig = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(this.state.config);
        let isChanged = false;
        info.field;
        newConfig[info.field] = info.value;
        if (newConfig[info.field] !== this.state.config[info.field]) isChanged = true;
        if (!isChanged) return;
        info.field;
        this.setState({
            config: newConfig
        });
    }
    validateValue(info) {
        info.field;
        return true;
    }
    constructor(){
        this.state = {
            config: {},
            state: "OK"
        };
        this.bindActions((0, $7fe264202fd0c16d$export$2e2bcd8739ae039));
        this.exportAsync((0, $cc65b603f67dc120$export$2e2bcd8739ae039));
    }
}
var $8ae296341ecbca86$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($8ae296341ecbca86$var$ConfigStore, 'ConfigStore');







let $8631135d413e7456$var$ActiveConfigSource = {
    fetchConfig () {
        return {
            remote (state) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).getActiveConfig();
            },
            local () {
                return null;
            },
            success: (0, $170382fabf001904$export$2e2bcd8739ae039).fetchConfigDone,
            error: (0, $170382fabf001904$export$2e2bcd8739ae039).fetchConfigFailed
        };
    }
};
var $8631135d413e7456$export$2e2bcd8739ae039 = $8631135d413e7456$var$ActiveConfigSource;





/**
 * Tooteinfo haldamise store
 */ class $aff67c96b9bd96a2$var$ActiveConfigStore {
    /**
   * Toote laadimise käivitamine
   */ onFetchConfig() {
        this.setState({
            state: "PROCESSING"
        });
        let p = this.getInstance().fetchConfig();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote laadimine ebaõnnestus
   */ onFetchConfigFailed(error) {
        this.processError(error);
    }
    processError(error) {
        let message = (0, $865532d99f221026$export$2e2bcd8739ae039)('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) message = error.response.data.error.message;
            else switch(error.response.status){
                case 401:
                case 403:
                    // Authentication required
                    console.log("ActiveConfigStore.processError(): STATUS 401/403: invalidating session");
                    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid password");
                    break;
                default:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            }
            switch(error.response.status){
                case 401:
                case 403:
                    // Authentication required
                    console.log("ActiveConfigStore.processError(): STATUS 401/403: invalidating session");
                    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
                    this.setState({
                        state: "FAIL"
                    });
                    break;
                default:
                    this.setState({
                        state: "FAIL"
                    });
            }
        } else this.setState({
            state: "FAIL"
        });
        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(message);
    }
    onFetchConfigDone(response) {
        try {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).has(response.data, 'activeConfigurationResult')) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            if (response.data.activeConfigurationResult == null) this.setState({
                config: {},
                state: "OK"
            });
            else this.setState({
                config: response.data.activeConfigurationResult,
                state: "OK"
            });
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Server error"));
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
            this.setState({
                state: "FAIL"
            });
        }
    }
    constructor(){
        this.state = {
            config: {},
            // OK -> PROCESSING -> OK / FAIL
            state: "OK"
        };
        this.bindActions((0, $170382fabf001904$export$2e2bcd8739ae039));
        this.exportAsync((0, $8631135d413e7456$export$2e2bcd8739ae039));
    }
}
var $aff67c96b9bd96a2$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($aff67c96b9bd96a2$var$ActiveConfigStore, 'ActiveConfigStore');









const $0ea284af2e31bfc7$var$propTypes = {
    session: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object
};
class $0ea284af2e31bfc7$var$Config extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    componentDidMount() {
        (0, $8ae296341ecbca86$export$2e2bcd8739ae039).listen(this.onChange);
        (0, $aff67c96b9bd96a2$export$2e2bcd8739ae039).listen(this.onChangeActiveConfig);
        (0, $ff339c2931a3cc1b$export$2e2bcd8739ae039).listen(this.onChangeSchema);
        (0, $6b994e94efab8cbe$export$2e2bcd8739ae039).fetchSchema("config");
        (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).fetchConfig();
    }
    componentWillUnmount() {
        (0, $8ae296341ecbca86$export$2e2bcd8739ae039).unlisten(this.onChange);
        (0, $aff67c96b9bd96a2$export$2e2bcd8739ae039).unlisten(this.onChangeActiveConfig);
        (0, $ff339c2931a3cc1b$export$2e2bcd8739ae039).unlisten(this.onChangeSchema);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.config.state === "PROCESSING" && this.state.config.state !== "PROCESSING") // Configuration loading or saving finished
        // Load active configuration too:
        {
            if (this.state.activeConfig.state !== "PROCESSING") (0, $170382fabf001904$export$2e2bcd8739ae039).fetchConfig.defer();
        }
    }
    onChange(state) {
        this.setState({
            config: (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(state)
        });
    }
    onChangeActiveConfig(state) {
        this.setState({
            activeConfig: (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(state)
        });
    }
    onChangeSchema(state) {
        if (state.schemas.config != null) this.setState({
            configSchema: state.schemas.config
        });
    }
    onValueChanged(param, value) {
        let schema = this.getItemSchema(param);
        schema.type;
        if (value === "") value = null;
        (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).changeValue(param, value);
    }
    onClickLoad() {
        (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).fetchConfig();
    }
    onClickSave() {
        this.askConfirmation((0, $865532d99f221026$export$2e2bcd8739ae039)("Save configuration") + "?", function() {
            (0, $7fe264202fd0c16d$export$2e2bcd8739ae039).saveConfig.defer();
        });
    }
    askConfirmation(message, func) {
        (0, $1e216dc96a46c373$exports.ModalManager).open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0090596cf3a3b647$export$2e2bcd8739ae039), {
            title: (0, $865532d99f221026$export$2e2bcd8739ae039)("Confirmation"),
            onClickOk: function() {
                func();
                (0, $1e216dc96a46c373$exports.ModalManager).close();
            },
            okText: (0, $865532d99f221026$export$2e2bcd8739ae039)('OK'),
            cancelText: (0, $865532d99f221026$export$2e2bcd8739ae039)('Cancel')
        }, message));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: "btn btn-primary",
            onClick: this.onClickSave
        }, "Save configuration")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: "btn btn-primary",
            onClick: this.onClickLoad
        }, "Reload configuration"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
            className: "form-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
            className: "table table-hover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            className: "col-sm-2"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Parameter")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            className: "col-sm-6"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Value in configuration file")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            className: "col-sm-4"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Current effective value")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, this.renderConfigItems()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-md-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            className: "btn btn-primary",
            onClick: this.onClickSave
        }, "Save configuration"))));
    }
    renderConfigItems() {
        let configItems = this.getConfigItems();
        let result = [];
        for (let item of configItems){
            let renderedItem = this.renderConfigItem(item);
            if (renderedItem != null) result.push(renderedItem);
        }
        return result;
    }
    renderConfigItem(item) {
        let itemInfo = this.getConfigItemInfo(item);
        if (itemInfo == null) return null;
        let renderedItem = null;
        switch(itemInfo.type){
            case "boolean":
                renderedItem = this.renderFormBoolean(itemInfo);
                break;
            case "select":
                renderedItem = this.renderFormSelect(itemInfo);
                break;
            case "integer":
                renderedItem = this.renderFormInteger(itemInfo);
                break;
            case "string":
            default:
                renderedItem = this.renderFormText(itemInfo);
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            key: itemInfo.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null, (0, $865532d99f221026$export$2e2bcd8739ae039)(itemInfo.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null, renderedItem, this.renderHelp(itemInfo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null, this.renderActiveValue(itemInfo)));
    }
    renderFormBoolean(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $74065ae0ba4bb816$export$2e2bcd8739ae039), {
            className: "form-control",
            id: item.name,
            checked: this.state.config.config[item.name] == null ? false : this.state.config.config[item.name],
            value: true,
            onClickParam: item.name,
            onClick: this.onValueChanged
        }, item.title);
    }
    renderFormSelect(item) {
        let selectedValue = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).find(item.options, (function(o) {
            return o.value === (this.state.config.config[item.name] === undefined ? null : this.state.config.config[item.name]);
        }).bind(this));
        if (selectedValue == null) selectedValue = "";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2980e0f397dc9d12$export$2e2bcd8739ae039), {
            options: item.options,
            id: item.name,
            name: item.name,
            value: selectedValue,
            onChange: (o, action)=>this.onValueChanged(item.name, o.value),
            style: {
                width: 400
            }
        });
    }
    /**
   *
   * @param item
   * @returns {*}
   */ renderFormText(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            className: "form-control",
            id: item.name,
            type: "text",
            valueType: "string",
            value: this.state.config.config[item.name] == null ? "" : this.state.config.config[item.name],
            onChange: this.onValueChanged,
            onChangeParam: item.name
        });
    }
    renderFormInteger(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            className: "form-control",
            id: item.name,
            type: "text",
            valueType: "integer",
            value: this.state.config.config[item.name] == null ? "" : this.state.config.config[item.name],
            onChange: this.onValueChanged,
            onChangeParam: item.name
        });
    }
    renderHelp(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", {
            className: "help-block"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)(item.description), " ", item.default ? " (" + (0, $865532d99f221026$export$2e2bcd8739ae039)("default value") + ": \"" + item.default + "\")" : null);
    }
    renderActiveValue(item) {
        if (item.writeOnly) return null;
        if (item.type == "boolean") return this.state.activeConfig.config[item.name] ? (0, $865532d99f221026$export$2e2bcd8739ae039)("checked") : (0, $865532d99f221026$export$2e2bcd8739ae039)("unchecked");
        return this.state.activeConfig.config[item.name];
    }
    getConfigItemInfo(item) {
        let schema = this.getItemSchema(item);
        if (schema == null) return null;
        let itemInfo = {
            name: item,
            title: schema.title,
            description: schema.description,
            type: schema.type,
            default: schema.default,
            readOnly: schema.readOnly,
            writeOnly: schema.writeOnly
        };
        if (schema.enum) {
            itemInfo.type = "select";
            itemInfo.options = [
                {
                    value: "",
                    label: ""
                }
            ];
            for(let i = 0; i < schema.enum.length; i++)itemInfo.options.push({
                value: schema.enum[i],
                label: schema.enumNames ? schema.enumNames[i] : schema.enum[i].toString().charAt(0).toUpperCase() + schema.enum[i].toString().substring(1).toLowerCase()
            });
        }
        return itemInfo;
    }
    getItemSchema(item) {
        return this.state.configSchema.properties[item];
    }
    getConfigItems() {
        return this.state.configSchema.order;
    }
    getConfigSchema() {
        let schemaFactory = (0, $f82be28e3e6281b5$export$2e2bcd8739ae039).getInstance();
        return schemaFactory.getSchema("config");
    }
    constructor(props){
        super(props);
        this.state = {
            config: (0, $8ae296341ecbca86$export$2e2bcd8739ae039).getState(),
            activeConfig: (0, $aff67c96b9bd96a2$export$2e2bcd8739ae039).getState(),
            configSchema: this.getConfigSchema()
        };
        this.onChange = this.onChange.bind(this);
        this.onChangeActiveConfig = this.onChangeActiveConfig.bind(this);
        this.onChangeSchema = this.onChangeSchema.bind(this);
        this.onClickLoad = this.onClickLoad.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);
    }
}
$0ea284af2e31bfc7$var$Config.propTypes = $0ea284af2e31bfc7$var$propTypes;
var $0ea284af2e31bfc7$export$2e2bcd8739ae039 = $0ea284af2e31bfc7$var$Config;




var $7fPBF = parcelRequire("7fPBF");

var $Sd5lO = parcelRequire("Sd5lO");

var $7fPBF = parcelRequire("7fPBF");
if (!(0, $7fPBF.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $Sd5lO.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");






var $Sd5lO = parcelRequire("Sd5lO");
function $ecceac2cca580c48$export$fb2daceae6f5097a(callback) {
    callback();
}
function $ecceac2cca580c48$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $ecceac2cca580c48$export$fb2daceae6f5097a;
    (0, $Sd5lO.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $ecceac2cca580c48$export$13ce1459b9a04b51 = function() {
    return true;
};


var $a9a758f09d74560b$var$deprecatedMessages = [];
function $a9a758f09d74560b$export$be38475be17599d(msg) {
    if (!$a9a758f09d74560b$var$deprecatedMessages.includes(msg)) {
        $a9a758f09d74560b$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $Sd5lO = parcelRequire("Sd5lO");

var $7fPBF = parcelRequire("7fPBF");

var $Sd5lO = parcelRequire("Sd5lO");
function $e4522550d7931a6a$export$ef795f1f307682c7(v) {
    return (0, $Sd5lO.getDependencyTree)(v);
}


var $de7ece56ac5c318c$var$globalIsUsingStaticRendering = false;
function $de7ece56ac5c318c$export$5d52eaa7c0f24c9e(enable) {
    $de7ece56ac5c318c$var$globalIsUsingStaticRendering = enable;
}
function $de7ece56ac5c318c$export$55979271896d643e() {
    return $de7ece56ac5c318c$var$globalIsUsingStaticRendering;
}


var $5d2a5b4de6831296$export$e901ba0ffe10ba41 = 10000;
var $5d2a5b4de6831296$export$1ae22ce5a82f26b6 = 10000;
var $5d2a5b4de6831296$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $5d2a5b4de6831296$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $5d2a5b4de6831296$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $5d2a5b4de6831296$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $5d2a5b4de6831296$export$b7a00d372cedeedd;


var $d81f96642445563c$export$10e8a12fbfd8583c = new (0, $5d2a5b4de6831296$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $5bb219d38eaf8527$exports = {};
'use strict';

$5bb219d38eaf8527$exports = (parcelRequire("72UbZ"));


function $a6663c794fd19d3b$var$createReaction(adm) {
    adm.reaction = new (0, $Sd5lO.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $a6663c794fd19d3b$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $de7ece56ac5c318c$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $d81f96642445563c$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $a6663c794fd19d3b$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $a6663c794fd19d3b$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $d81f96642445563c$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useDebugValue(adm.reaction, (0, $e4522550d7931a6a$export$ef795f1f307682c7));
    (0, $5bb219d38eaf8527$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $7fPBF = parcelRequire("7fPBF");


var $0e9caff9ea7c2c9f$var$_a, $0e9caff9ea7c2c9f$var$_b;
var $0e9caff9ea7c2c9f$var$warnObserverOptionsDeprecated = true;
var $0e9caff9ea7c2c9f$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $0e9caff9ea7c2c9f$var$isFunctionNameConfigurable = ($0e9caff9ea7c2c9f$var$_b = ($0e9caff9ea7c2c9f$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $0e9caff9ea7c2c9f$var$_a === void 0 ? void 0 : $0e9caff9ea7c2c9f$var$_a.configurable) !== null && $0e9caff9ea7c2c9f$var$_b !== void 0 ? $0e9caff9ea7c2c9f$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $0e9caff9ea7c2c9f$var$ReactForwardRefSymbol = $0e9caff9ea7c2c9f$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $7fPBF.forwardRef) === "function" && (0, $7fPBF.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $0e9caff9ea7c2c9f$var$ReactMemoSymbol = $0e9caff9ea7c2c9f$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $7fPBF.memo) === "function" && (0, $7fPBF.memo)(function(props) {
    return null;
})["$$typeof"];
function $0e9caff9ea7c2c9f$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($0e9caff9ea7c2c9f$var$ReactMemoSymbol && baseComponent["$$typeof"] === $0e9caff9ea7c2c9f$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $de7ece56ac5c318c$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($0e9caff9ea7c2c9f$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $0e9caff9ea7c2c9f$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $a6663c794fd19d3b$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($0e9caff9ea7c2c9f$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $7fPBF.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $7fPBF.memo)(observerComponent);
    $0e9caff9ea7c2c9f$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $0e9caff9ea7c2c9f$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $0e9caff9ea7c2c9f$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$0e9caff9ea7c2c9f$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $5d592a4cc0318189$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $a6663c794fd19d3b$export$b9c7ecd090a87b14)(component);
}
$5d592a4cc0318189$export$c1cbdee04e18ea8b.displayName = "Observer";
function $5d592a4cc0318189$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $Sd5lO = parcelRequire("Sd5lO");

var $7fPBF = parcelRequire("7fPBF");
function $20b678b0d23871b3$export$aa207039f277c5f(initializer, annotations) {
    return (0, $7fPBF.useState)(function() {
        return (0, $Sd5lO.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $Sd5lO = parcelRequire("Sd5lO");

var $7fPBF = parcelRequire("7fPBF");



var $Sd5lO = parcelRequire("Sd5lO");

var $7fPBF = parcelRequire("7fPBF");
function $8019b46bf0cda23d$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $7fPBF.useState)(function() {
        return (0, $Sd5lO.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $Sd5lO.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $0fd716b81acab3ec$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $8019b46bf0cda23d$export$e0ded3646391939c)(current);
    return (0, $7fPBF.useState)(function() {
        return (0, $Sd5lO.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $0c33ab544cf99bf1$var$_a;
(0, $ecceac2cca580c48$export$294943bbc3c74f4f)((0, $b4ba1c853f6e1116$exports.unstable_batchedUpdates));
var $0c33ab544cf99bf1$export$469d51fb8d268227 = ($0c33ab544cf99bf1$var$_a = (0, $d81f96642445563c$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $0c33ab544cf99bf1$var$_a !== void 0 ? $0c33ab544cf99bf1$var$_a : function() {};
function $0c33ab544cf99bf1$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $a6663c794fd19d3b$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $0c33ab544cf99bf1$export$7613124ee4202834(enable) {
    (0, $de7ece56ac5c318c$export$5d52eaa7c0f24c9e)(enable);
}



const $52ea8fe6a20dc10b$var$AuthWrapper = (0, $0e9caff9ea7c2c9f$export$b6ae1bc530f4c149)(({ role: role, children: children })=>{
    const sessionStore = (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore;
    (0, $7fPBF.useEffect)(()=>{
        sessionStore.setRequiredRole(role);
        return ()=>sessionStore.setRequiredRole("user");
    }, [
        role
    ]);
    if (sessionStore.hasRole(role)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null);
});
var $52ea8fe6a20dc10b$export$2e2bcd8739ae039 = $52ea8fe6a20dc10b$var$AuthWrapper;


class $9af43539a7916a57$var$ConfigPage extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            id: "config_content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4610186095f4e197$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $52ea8fe6a20dc10b$export$2e2bcd8739ae039), {
            role: "admin"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0ea284af2e31bfc7$export$2e2bcd8739ae039), null)));
    }
}
var $9af43539a7916a57$export$2e2bcd8739ae039 = $9af43539a7916a57$var$ConfigPage;



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $ad18d7e10e43d002$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ad18d7e10e43d002$var$styles = {
    text: {
        marginTop: 52,
        color: "#888",
        marginLeft: 6
    },
    spinner: {
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
};
var $ad18d7e10e43d002$export$3b0d6d7590275603 = function Loader(_ref) {
    var loading = _ref.loading, _ref$text = _ref.text, text = _ref$text === undefined ? "Loading.." : _ref$text, fullPage = _ref.fullPage, containerStyle = _ref.containerStyle, textStyle = _ref.textStyle;
    if (!loading) return null;
    var mergedContainerStyle = $ad18d7e10e43d002$var$_extends({}, $ad18d7e10e43d002$var$styles.spinner, containerStyle, {
        position: fullPage ? "fixed" : "absolute"
    });
    return (0, $7fPBF.createElement)("div", {
        style: mergedContainerStyle
    }, (0, $7fPBF.createElement)("div", {
        className: "react-overlay-loader-spinner"
    }), (0, $7fPBF.createElement)("span", {
        style: $ad18d7e10e43d002$var$_extends({}, $ad18d7e10e43d002$var$styles.text, textStyle)
    }, text));
};
var $ad18d7e10e43d002$var$_extends$1 = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $ad18d7e10e43d002$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $ad18d7e10e43d002$export$3fb99980b01d36b1 = function LoadingOverlay(_ref) {
    var children = _ref.children, rest = $ad18d7e10e43d002$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return (0, $7fPBF.createElement)("div", $ad18d7e10e43d002$var$_extends$1({}, rest, {
        style: $ad18d7e10e43d002$var$_extends$1({}, rest.style, {
            position: "relative"
        })
    }), children);
};











class $f51bf5ef002efb71$var$SoftwareUpdateActions {
    /**
   * Algatatakse tarkvara info laadimine serverist
   */ fetchSoftwareInfo(user, passwd) {
        return {
            user: user,
            passwd: passwd
        };
    }
    /**
   * Info laadimine ebaõnnestus
   */ fetchSoftwareInfoFailed(error) {
        return error;
    }
    /**
   * Info sai laetud
   */ fetchSoftwareInfoDone(data) {
        return data;
    }
    /**
   * Tarkvara uuendamine
   * @param file Uuendusfail
   * @returns {*}
   */ update(file, user, passwd) {
        return {
            file: file,
            user: user,
            passwd: passwd
        };
    }
    /**
   * Uuendamine ebaõnnestus
   */ updateFailed(error) {
        return error;
    }
    /**
   * Uuendamine edukalt lõpetatud
   */ updateDone(data) {
        return data;
    }
    /**
   * Vana tarkvaraversiooni taastamine
   */ restore(user, passwd) {
        return {
            user: user,
            passwd: passwd
        };
    }
    /**
   * Tarkvaraversiooni taastamine ebaõnnestus
   */ restoreFailed(error) {
        return error;
    }
    /**
   * Tarkvaraversioon sai taastatud
   */ restoreDone() {
        return null;
    }
}
var $f51bf5ef002efb71$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($f51bf5ef002efb71$var$SoftwareUpdateActions);







let $7efd119d322c7dae$var$SoftwareUpdateSource = {
    fetchSoftwareInfo (user, passwd) {
        return {
            remote (state, user, passwd) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).getSoftwareInfo(user, passwd);
            },
            local () {
                return null;
            },
            success: (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).fetchSoftwareInfoDone,
            error: (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).fetchSoftwareInfoFailed
        };
    },
    update (file, user, passwd) {
        return {
            remote (state, file, user, passwd) {
                try {
                    return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).postSoftwareUpdate(file, user, passwd);
                } catch (e) {
                    if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                        console.log(e.toString());
                        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Internal error"));
                    } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
                    return new Promise((resolve, reject)=>{
                        reject(e);
                    });
                }
            },
            local () {
                return null;
            },
            success: (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).updateDone,
            error: (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).updateFailed
        };
    },
    restore (user, passwd) {
        return {
            remote (state, user, passwd) {
                try {
                    return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).postSoftwareRestore(user, passwd);
                } catch (e) {
                    if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                        console.log(e.toString());
                        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Internal error"));
                    } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
                    return new Promise((resolve, reject)=>{
                        reject(e);
                    });
                }
            },
            local () {
                return null;
            },
            success: (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).restoreDone,
            error: (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).restoreFailed
        };
    }
};
var $7efd119d322c7dae$export$2e2bcd8739ae039 = $7efd119d322c7dae$var$SoftwareUpdateSource;


/**
 * Konfiguratsiooni haldamise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */ class $8b0c60b0dd76d972$var$SoftwareUpdateStore {
    /**
   * Toote laadimise käivitamine
   */ onFetchSoftwareInfo(info) {
        if (info == null) info = {
            user: this.state.user,
            passwd: this.state.passwd
        };
        this.setState({
            action: "fetchSoftwareInfo",
            state: "PROCESSING",
            user: info.user,
            passwd: info.passwd
        });
        let p = this.getInstance().fetchSoftwareInfo(info.user, info.passwd);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote laadimine ebaõnnestus
   */ onFetchSoftwareInfoFailed(error) {
        this.processError(error);
    }
    onFetchSoftwareInfoDone(response) {
        try {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).has(response.data, 'firmwareInfoResult')) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            if (response.data.firmwareInfoResult == null) this.setState({
                firmwareInfo: {},
                auth: true,
                state: "OK"
            });
            else this.setState({
                firmwareInfo: response.data.firmwareInfoResult,
                auth: true,
                state: "OK"
            });
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Server error"));
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
            this.setState({
                state: "FAIL"
            });
        }
    }
    /**
   * Toote laadimise käivitamine
   */ onUpdate(params) {
        this.setState({
            action: "update",
            state: "PROCESSING"
        });
        let p = this.getInstance().update(params.file, params.user, params.passwd);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote laadimine ebaõnnestus
   */ onUpdateFailed(error) {
        this.processError(error);
    }
    processError(error) {
        let message = (0, $865532d99f221026$export$2e2bcd8739ae039)('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) message = error.response.data.error.message;
            else switch(error.response.status){
                case 403:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid password");
                    break;
                case 503:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Service unavailable");
                    break;
                default:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            }
            switch(error.response.status){
                case 403:
                    this.setState({
                        auth: false,
                        state: "FAIL"
                    });
                    break;
                default:
                    this.setState({
                        state: "FAIL"
                    });
            }
        } else this.setState({
            state: "FAIL"
        });
        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(message);
    }
    onUpdateDone(response) {
        (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('Software version updated'));
        this.setState({
            auth: true,
            state: "OK"
        });
    }
    onRestore(params) {
        this.setState({
            action: "restore",
            state: "PROCESSING"
        });
        let p = this.getInstance().restore(params.user, params.passwd);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    onRestoreFailed(error) {
        this.processError(error);
    }
    onRestoreDone() {
        (0, $26a241f40377239c$export$2e2bcd8739ae039).success.defer((0, $865532d99f221026$export$2e2bcd8739ae039)('Software previous version restored'));
        this.setState({
            auth: true,
            state: "OK"
        });
    }
    /**
   * Parameetri muutmine
   */ onChangeValue(info) {
        if (!this.validateValue(info)) return;
        let newConfig = (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(this.state.config);
        let isChanged = false;
        info.field;
        newConfig[info.field] = info.value;
        if (newConfig[info.field] !== this.state.config[info.field]) isChanged = true;
        if (!isChanged) return;
        info.field;
        this.setState({
            config: newConfig
        });
    }
    validateValue(info) {
        info.field;
        return true;
    }
    constructor(){
        this.state = {
            auth: false,
            user: null,
            passwd: null,
            state: "OK",
            action: null,
            firmwareInfo: {}
        };
        this.bindActions((0, $f51bf5ef002efb71$export$2e2bcd8739ae039));
        this.exportAsync((0, $7efd119d322c7dae$export$2e2bcd8739ae039));
    }
}
var $8b0c60b0dd76d972$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($8b0c60b0dd76d972$var$SoftwareUpdateStore, 'SoftwareUpdateStore');







class $853c6b36eaf14cb5$var$SoftwareUpdate extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    componentDidMount() {
        (0, $8b0c60b0dd76d972$export$2e2bcd8739ae039).listen(this.onChange);
        (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).fetchSoftwareInfo.defer((0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getUsername(), (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getPassword());
    }
    componentWillUnmount() {
        (0, $8b0c60b0dd76d972$export$2e2bcd8739ae039).unlisten(this.onChange);
    }
    componentDidUpdate(prevProps, prevState) {
        prevState.update.state === "PROCESSING" && this.state.update.state;
    }
    onChange(state) {
        this.setState({
            update: (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(state)
        });
    }
    onClickSelectFile(fileData, fileName) {
        this.setState({
            file: btoa(fileData),
            fileName: fileName
        });
    }
    onClickUpdate() {
        if (this.state.file == null) (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Update file not selected"));
        else this.askConfirmation((0, $865532d99f221026$export$2e2bcd8739ae039)("Update software") + "?", (function() {
            (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).update(this.state.file, (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getUsername(), (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getPassword());
        }).bind(this));
    }
    onClickRestore() {
        this.askConfirmation((0, $865532d99f221026$export$2e2bcd8739ae039)("Restore old software version") + "?", (function() {
            (0, $f51bf5ef002efb71$export$2e2bcd8739ae039).restore((0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getUsername(), (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.getPassword());
        }).bind(this));
    }
    onClickRestart() {
        window.location.reload(true);
    }
    askConfirmation(message, func) {
        (0, $1e216dc96a46c373$exports.ModalManager).open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0090596cf3a3b647$export$2e2bcd8739ae039), {
            title: (0, $865532d99f221026$export$2e2bcd8739ae039)("Confirmation"),
            onClickOk: function() {
                func();
                (0, $1e216dc96a46c373$exports.ModalManager).close();
            },
            okText: (0, $865532d99f221026$export$2e2bcd8739ae039)('OK'),
            cancelText: (0, $865532d99f221026$export$2e2bcd8739ae039)('Cancel')
        }, message));
    }
    renderCurrentSoftware() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h3", {
            className: "panel-title"
        }, "Current software version")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
            className: "form-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            htmlFor: "version-info",
            className: "col-sm-2 control-label"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Version") + ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-10"
        }, this.state.update.firmwareInfo.firmwareVersion || "")))));
    }
    renderUpdateSoftware() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h3", {
            className: "panel-title"
        }, "Update software")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
            className: "form-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            htmlFor: "file-input",
            className: "col-sm-2 control-label"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Software update file") + ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-10"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2c6d4165bfc0f946$export$2e2bcd8739ae039), {
            button: true,
            width: "100px",
            as: "binary",
            accept: ".zip",
            onClick: (param, fileData, fileName)=>this.onClickSelectFile(fileData, fileName)
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Select file")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-10"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onClickUpdate
        }, "Update software"))))));
    }
    renderRestoreSoftware() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h3", {
            className: "panel-title"
        }, "Restore software")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
            className: "form-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            htmlFor: "file-input",
            className: "col-sm-2 control-label"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Software update file") + ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-10"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2c6d4165bfc0f946$export$2e2bcd8739ae039), {
            button: true,
            width: "100px",
            as: "binary",
            accept: ".zip",
            onClick: (param, fileData, fileName)=>this.onClickSelectFile(fileData, fileName)
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Select file")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-10"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onClickRestore
        }, "Restore software to specified version"))))));
    }
    renderSpinner() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ad18d7e10e43d002$export$3b0d6d7590275603), {
            fullPage: true,
            loading: true,
            text: (0, $865532d99f221026$export$2e2bcd8739ae039)("Updating software, please wait...")
        });
    //return (<div style={{backgroundColor: "#EFEFEF", position: "fixed", width: "100%", height: "100%", zIndex: "1000", top: "0px", left: "0px", opacity: "0.5", filter: "alpha(opacity=50)"}}/>);
    }
    renderUpdateCompleted() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel panel-default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h3", {
            className: "panel-title"
        }, "Update software")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", null, (0, $865532d99f221026$export$2e2bcd8739ae039)("Update successfully completed, click button 'Restart'!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
            className: "form-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-10"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $37d2586b3195e7c1$export$2e2bcd8739ae039), {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onClickRestart
        }, "Restart"))))));
    }
    renderContent() {
        if (!this.state.update.auth) return null;
        let content = [];
        if (this.state.update.action == "update" && this.state.update.state == "OK") content = [
            this.renderUpdateCompleted()
        ];
        else {
            content = [
                this.renderCurrentSoftware(),
                this.renderUpdateSoftware()
            ];
            if (this.state.update.action == "update" && this.state.update.state == "PROCESSING") content.push(this.renderSpinner());
        }
        return content;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "container-fluid"
        }, this.renderContent());
    }
    constructor(props){
        super(props);
        this.state = {
            file: null,
            fileName: null,
            update: (0, $8b0c60b0dd76d972$export$2e2bcd8739ae039).getState()
        };
        this.onChange = this.onChange.bind(this);
        this.onClickUpdate = this.onClickUpdate.bind(this);
        this.onClickRestore = this.onClickRestore.bind(this);
        this.onClickRestart = this.onClickRestart.bind(this);
    }
}
var $853c6b36eaf14cb5$export$2e2bcd8739ae039 = $853c6b36eaf14cb5$var$SoftwareUpdate;



class $c028eb6a645b8a34$var$SoftwareUpdatePage extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            id: "update_content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4610186095f4e197$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $52ea8fe6a20dc10b$export$2e2bcd8739ae039), {
            role: "adminPassword"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $853c6b36eaf14cb5$export$2e2bcd8739ae039), null)));
    }
}
var $c028eb6a645b8a34$export$2e2bcd8739ae039 = $c028eb6a645b8a34$var$SoftwareUpdatePage;




// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
const $b8077eed590c44e8$var$isLocalhost = Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $b8077eed590c44e8$export$6503ec6e8aabbaf(config) {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener('load', ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($b8077eed590c44e8$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $b8077eed590c44e8$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://goo.gl/SC7cgQ");
                });
            } else // Is not local host. Just register service worker
            $b8077eed590c44e8$var$registerValidSW(swUrl, config);
        });
    }
}
function $b8077eed590c44e8$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the old content will have been purged and
                        // the fresh content will have been added to the cache.
                        // It's the perfect time to display a "New content is
                        // available; please refresh." message in your web app.
                        console.log('New content is available; please refresh.');
                        // Execute callback
                        if (config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error('Error during service worker registration:', error);
    });
}
function $b8077eed590c44e8$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 || response.headers.get('content-type').indexOf('javascript') === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $b8077eed590c44e8$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function $b8077eed590c44e8$export$d07f55d4c15c0440() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}














class $914d2fd58c1b1035$var$CsvGenerator {
    getCsvData() {
        let separator = this.separator;
        let addQuotes = this.addQuotes;
        let rows = this.dataArray.map(function(row) {
            let rowData = row.join(separator);
            if (rowData.length && addQuotes) return '"' + rowData + '"';
            return rowData;
        });
        return rows.join('\n');
    }
    getDownloadLink() {
        let type = 'data:text/csv;charset=utf-8';
        let data = this.getCsvData();
        if (typeof btoa === 'function') {
            type += ';base64';
            data = btoa(data);
        } else data = encodeURIComponent(data);
        return this.downloadLink = this.downloadLink || type + ',' + data;
    }
    getLinkElement(linkText) {
        let downloadLink = this.getDownloadLink();
        return this.linkElement = this.linkElement || (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('<a>' + (linkText || '') + '</a>', {
            href: downloadLink,
            download: this.fileName
        });
    }
    // call with removeAfterDownload = true if you want the link to be removed after downloading
    download(removeAfterDownload) {
        if (window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([
                this.getCsvData()
            ], {
                type: "text/csv;charset=utf-8;"
            });
            navigator.msSaveBlob(blob, this.fileName);
        } else {
            this.getLinkElement().css('display', 'none').appendTo('body');
            this.getLinkElement()[0].click();
            if (removeAfterDownload) this.getLinkElement().remove();
        }
    }
    constructor(dataArray, fileName, separator, addQuotes){
        this.dataArray = dataArray;
        this.fileName = fileName;
        this.separator = separator || ';';
        this.addQuotes = !!addQuotes;
        if (this.addQuotes) this.separator = '"' + this.separator + '"';
    }
}
var $914d2fd58c1b1035$export$2e2bcd8739ae039 = $914d2fd58c1b1035$var$CsvGenerator;







class $1b786243bb4bc857$var$ArchiveExport {
    export(current) {
        let data = this.getArchiveSearchResults(current == null ? false : current);
        if (!data) {
            (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_err((0, $865532d99f221026$export$2e2bcd8739ae039)("Data not found."));
            return;
        }
        let csv = new (0, $914d2fd58c1b1035$export$2e2bcd8739ae039)(data, "export.csv");
        csv.download(true);
    }
    getArchiveSearchResults(current) {
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results == null) return null;
        let data = [];
        data.push(this.getSearchResultHeader());
        if (current) {
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement == null) return null;
            let r = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"];
            if (r >= (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results.length) return null;
            let row = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results[r];
            let drow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_converted_results[r];
            let a = this.getSearchResultRow(row, drow);
            data.push(a);
        } else for(let r = 0; r < (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results.length; r++){
            let row = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results[r];
            let drow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_converted_results[r];
            let a = this.getSearchResultRow(row, drow);
            data.push(a);
        }
        return data;
    }
    getSearchResultHeader() {
        let a;
        if (this.isSimpleUi) a = [
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Skeleton no"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Time"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Product code"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Description")
        ];
        else a = [
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Wagon no"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Skeleton no"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Error code"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Time"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Product code"),
            (0, $865532d99f221026$export$2e2bcd8739ae039)("Description")
        ];
        // P1 - P9/15
        for(let i = 0; i < this.pointCount; i++)a.push("P" + (i + 1).toString());
        // P300 - P50
        for(let k = this.addPoints - 1; k >= 0; k--){
            let pName = (k + 1) * 50;
            a.push("P" + pName.toString());
        }
        // ANGLE
        a.push((0, $865532d99f221026$export$2e2bcd8739ae039)("Angle"));
        // HUD1 - HUD5
        for(let i = 0; i < this.hudPoints; i++)a.push("H" + (i + 1).toString());
        return a;
    }
    getSearchResultRow(row, drow) {
        let a = [];
        if (this.isSimpleUi) a = [
            row.vaguni_raam,
            (0, $30071e4d8f83fdfd$export$719af6d430903ba6)(row.lopp_aeg),
            row.toote_variant,
            (0, $30071e4d8f83fdfd$export$590567be997858b6)(row.kirjeldus1) + " " + (0, $30071e4d8f83fdfd$export$590567be997858b6)(row.kirjeldus2)
        ];
        else a = [
            row.vaguni_number,
            row.vaguni_raam,
            row.veakood,
            (0, $30071e4d8f83fdfd$export$719af6d430903ba6)(row.lopp_aeg),
            row.toote_variant,
            (0, $30071e4d8f83fdfd$export$590567be997858b6)(row.kirjeldus1) + " " + (0, $30071e4d8f83fdfd$export$590567be997858b6)(row.kirjeldus2)
        ];
        // P1 - P9/15
        for(let p = 0; p < this.pointCount; p++){
            if (this.showCenter && p % 3 != 1) continue;
            a.push(this.getSearchResultPointCol(drow, p));
        }
        // P300 - P50
        for(let k = this.addPoints - 1; k >= 0; k--)a.push(this.getSearchResultPointCol(drow, this.pointCount + k));
        // ANGLE
        let cvalue = "";
        if (drow.angles && drow.angles.length > 0 && drow.angles[0].length > 0 && drow.angles[0][0] != null && drow.analyzed_angles && drow.analyzed_angles.length > 0) // [diff, status, y]
        cvalue = (Math.round(drow.analyzed_angles[0][2]) / 10).toString();
        a.push(cvalue.replace(".", ","));
        // HUD1 - HUD5
        for(let k = 0; k < this.hudPoints; k++)a.push(this.getSearchResultPointCol(drow, this.pointCount + this.addPoints + k));
        return a;
    }
    getSearchResultPointCol(drow, p) {
        let cvalue = "";
        if (drow.required && drow.required[p] != null && drow.required[p].length > 0 && drow.required[p][0] != null && drow.analyzed && drow.analyzed.length > p) {
            cvalue = drow.analyzed[p][2];
            cvalue = Math.round(cvalue) / 10;
            // AA: -100 is a result of missing data; TODO: raw data should be set null earlier
            if (cvalue == -100) cvalue = "";
        }
        cvalue = cvalue + "";
        return cvalue.replace(".", ",");
    }
    constructor(){
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        this.isSimpleUi = settings.isSimpleUi();
        this.showCenter = settings.showOnlyCenterPoints();
        this.pointCount = settings.getMeasurementLineCount() * 3;
        this.addPoints = settings.getCenterAddPoints();
        this.hudPoints = settings.getHudPoints();
    }
}
var $1b786243bb4bc857$export$2e2bcd8739ae039 = $1b786243bb4bc857$var$ArchiveExport;







/**
 * Arhiivi moodul
 */ class $1cc3baa3865cee76$var$Archive {
    /**
   *
   * @returns {Archive}
   */ static getInstance() {
        if ($1cc3baa3865cee76$var$Archive.archiveInstance == null) $1cc3baa3865cee76$var$Archive.archiveInstance = new $1cc3baa3865cee76$var$Archive();
        return $1cc3baa3865cee76$var$Archive.archiveInstance;
    }
    archive_search() {
        this.load_archive();
    }
    load_archive() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        // toote_variant={toote_variant}&kirjeldus={kirjeldus}&aeg={aeg}
        let codeVariant = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#product_code_fid").val();
        let desc = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#desc_fid").val();
        let time = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#date_fid").val();
        let etime = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#edate_fid").val();
        let skeleton = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#skeleton_fid").val();
        let furnaceRing = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#furnace_ring_fid").val();
        let glassId = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#glass_id_fid").val();
        let useCurrentNominals = (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#use_current_nominals").is(':checked');
        if (!codeVariant && !desc && !time && !etime && !skeleton && !furnaceRing && !glassId) {
            (0, $03277cb1bca63048$export$5ea928c9faf85bd3)((0, $865532d99f221026$export$2e2bcd8739ae039)("Please fill some fields!"));
            return false;
        }
        let tmp = "arv=" + settings.getMaxRecords();
        if (codeVariant) tmp += "&toote_variant=" + encodeURIComponent(codeVariant);
        if (desc) tmp += "&kirjeldus=" + encodeURIComponent(desc);
        if (skeleton) tmp += "&vaguni_raam=" + encodeURIComponent(skeleton);
        if (furnaceRing) tmp += "&ahju_ring=" + encodeURIComponent(furnaceRing);
        if (glassId) tmp += "&klaasi_id=" + encodeURIComponent(glassId);
        if (time) {
            time = time.replace(" ", "T");
            tmp += "&algus=" + encodeURIComponent(time);
        }
        if (etime) {
            etime = etime.replace(" ", "T");
            tmp += "&lopp=" + encodeURIComponent(etime);
        }
        if (useCurrentNominals) tmp += "&use_current_nominals=y";
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_passwd) tmp += "&passwd=" + encodeURIComponent((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_passwd);
        let url = this.conf_archive_url + "?" + tmp;
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("loading " + url);
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: url,
            success: (function(data) {
                this.measurementscall(data);
            }).bind(this),
            statusCode: {
                403: function() {
                    console.log("load_archive(): STATUS 403: invalidating session, url: " + url);
                    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
                    (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_passwd = null;
                }
            },
            error: function(xhr, status, error) {
                (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_err((0, $865532d99f221026$export$2e2bcd8739ae039)("Error") + ": " + error);
            }
        });
    }
    measurementscall(data) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        if (data && data.measurementsResult) {
            // Legacy.debug(data["measurementsResult"][0]["joone_pikkus"]);
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results = data.measurementsResult;
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement = null;
            for(let y = 0; y < (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results.length; y++)(0, $03277cb1bca63048$export$2e2bcd8739ae039).a_converted_results[y] = (0, $2f5d8207b6c7af36$export$63550c27588333c3)((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results[y]);
            (0, $03277cb1bca63048$export$bf0f39e0389ca517)();
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results.length === settings.getMaxRecords()) (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_success((0, $865532d99f221026$export$2e2bcd8739ae039)("Maximum number of records exceeded"));
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).force_correct = false;
        } else {
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results = [];
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_converted_results = [];
            (0, $3bbe070f9dec5e64$export$2e2bcd8739ae039).show_err((0, $865532d99f221026$export$2e2bcd8739ae039)("Data not found."));
        }
    }
    /**
   *
   * @param {number} i
   * @returns {string}
   */ getPName(i) {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let m = settings.getMeasurementLineCount() * 3;
        if (i >= m) return "P" + ((i - m + 1) * 50).toString();
        else return "P" + (i + 1).toString();
    }
    getHudPName(i) {
        return "H" + (i + 1).toString();
    }
    /**
   *
   * @returns {string}
   */ make_a_results_table() {
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        let lst = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_results;
        let activeRow = -1;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement && (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"] !== undefined) activeRow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"];
        if (!lst || lst.length === 0) return (0, $865532d99f221026$export$2e2bcd8739ae039)("Data not found.");
        let tl = [];
        tl.push("\n<table id='a_resultstable' class='table tablesorter table-condensed table-hover'>\n");
        tl.push("<thead>\n");
        tl.push("<tr class='gridtr gridtrhead'>\n");
        tl.push("<th style='width: 20px;'>#</th>");
        if (!settings.isSimpleUi()) tl.push("<th style='width: 30px;' title='" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Wagon no") + "'>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("W") + "</th>");
        tl.push("<th style='width: 30px;' title='" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Skeleton no") + "'>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("S") + "</th>");
        if (!settings.isSimpleUi()) tl.push("<th style='width: 30px;' title='" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Error code") + "'>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("E") + "</th>");
        tl.push("<th style='width: 150px;'>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Time") + "</th>");
        tl.push("<th style='width: 50px;' title='" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Product code") + "'>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("C") + "</th>");
        tl.push("<th>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Description") + "</th>");
        let showCenter = settings.showOnlyCenterPoints();
        let i = 0;
        // P1 - P9/15
        let first = true;
        for(; i < settings.getMeasurementLineCount() * 3; i++){
            if (showCenter && i % 3 !== 1) continue;
            let cclass = first ? "gridthsep" : "";
            tl.push("<th style='width: 40px;' class='" + cclass + "'>" + this.getPName(i) + "</th>");
            first = false;
        }
        // P300 - P50
        first = true;
        for(let j = settings.getCenterAddPoints() - 1; j >= 0; j--){
            let cclass = first ? "gridthsep" : "";
            tl.push("<th style='width: 40px;' class='" + cclass + "'>" + this.getPName(i + j) + "</th>");
            first = false;
        }
        // ANGLE
        tl.push(`<th style="width: 40px;">${(0, $865532d99f221026$export$2e2bcd8739ae039)("angle")}</th>`);
        // HUD points
        first = true;
        for(let j = 0; j < settings.getHudPoints(); j++){
            let cclass = first ? "gridthsep" : "";
            tl.push("<th style='width: 40px;' class='" + cclass + "'>" + this.getHudPName(j) + "</th>");
            first = false;
        }
        tl.push("</tr>\n");
        tl.push("</thead>\n");
        tl.push("<tbody>\n");
        for(let r = 0; r < lst.length; r++){
            tl.push("<tr class='gridtr" + (activeRow === r ? " danger" : "") + "' id='gridtr" + r + "' onclick='graph.show_a_measurement(" + r + ")'>\n");
            tl.push("<td class='gridtd'>" + (r + 1) + "</td>");
            if (!settings.isSimpleUi()) {
                tl.push("<td class='gridtd'>");
                try {
                    tl.push((0, $30071e4d8f83fdfd$export$590567be997858b6)(lst[r]["vaguni_number"]));
                } catch (err) {}
                tl.push("</td>");
            }
            tl.push("<td class='gridtd'>");
            try {
                tl.push((0, $30071e4d8f83fdfd$export$590567be997858b6)(lst[r]["vaguni_raam"]));
            } catch (err) {}
            tl.push("</td>");
            if (!settings.isSimpleUi()) {
                tl.push("<td class='gridtd'>");
                try {
                    let value = (0, $30071e4d8f83fdfd$export$590567be997858b6)(lst[r]["veakood"]);
                    if (value == "0") value = "";
                    tl.push(value);
                } catch (err) {}
                tl.push("</td>");
            }
            tl.push("<td class='gridtd'>");
            try {
                tl.push(" " + (0, $30071e4d8f83fdfd$export$719af6d430903ba6)(lst[r]["lopp_aeg"]));
            } catch (err) {}
            tl.push("</td>");
            tl.push("<td class='gridtd'>");
            try {
                tl.push((0, $30071e4d8f83fdfd$export$590567be997858b6)(lst[r]["toote_variant"]) + " ");
            } catch (err) {}
            tl.push("</td>");
            tl.push("<td class='gridtd'>");
            try {
                tl.push((0, $30071e4d8f83fdfd$export$acafce1f52201e8f)((0, $30071e4d8f83fdfd$export$590567be997858b6)(lst[r]["kirjeldus1"]) + " " + (0, $30071e4d8f83fdfd$export$590567be997858b6)(lst[r]["kirjeldus2"])));
            } catch (err) {}
            tl.push("</td>");
            let drow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_converted_results[r];
            let p = 0;
            // P1 - P9/15
            first = true;
            for(; p < settings.getMeasurementLineCount() * 3; p++){
                if (showCenter && p % 3 != 1) continue;
                let cclass = first ? "gridsep" : "";
                tl.push(this.make_a_result_nominal_col(drow, p, cclass));
                first = false;
            }
            // P300 - P50
            first = true;
            for(let k = settings.getCenterAddPoints() - 1; k >= 0; k--){
                let cclass = first ? "gridsep" : "";
                tl.push(this.make_a_result_nominal_col(drow, p + k, cclass));
                first = false;
            }
            // ANGLE:
            let cvalue = "";
            let cclasses = "";
            if (drow && drow.angles && drow.angles.length > 0 && drow.angles[0].length > 0 && drow.angles[0][0] != null && drow.analyzed_angles && drow.analyzed_angles.length > 0) {
                // [diff, status, y]
                cvalue = (Math.round(drow.analyzed_angles[0][2]) / 10).toString();
                let cstatus = drow.analyzed_angles[0][1];
                cclasses += " row_status_" + cstatus;
            }
            tl.push(`<td class="gridtd ${cclasses}">${cvalue}</td>`);
            // HUD points
            p += settings.getCenterAddPoints();
            first = true;
            for(let k = 0; k < settings.getHudPoints(); k++){
                let cclass = first ? "gridsep" : "";
                tl.push(this.make_a_result_nominal_col(drow, p + k, cclass));
                first = false;
            }
            tl.push("</tr>\n");
        }
        tl.push("</tbody>\n");
        tl.push("</table>\n");
        return tl.join("");
    }
    make_a_result_nominal_col(drow, p, cclasses) {
        let cvalue = "";
        let cstatus = null;
        if (drow && drow.required && drow.required[p] != null && drow.required[p].length > 0 && drow.required[p][0] != null && drow.analyzed && drow.analyzed.length > p) {
            cvalue = drow.analyzed[p][2];
            cvalue = Math.round(cvalue) / 10;
            // AA: -100 is a result of missing data; TODO: raw data
            // should be set null earlier
            if (cvalue == -100) cvalue = "";
            cstatus = drow.analyzed[p][1];
            if (p % 3 == 1 && (cvalue || cvalue === 0) || drow.lineinfo[p][2]) cclasses += " gridtd_imp ";
            cclasses += " row_status_" + cstatus;
        }
        return '<td class="gridtd ' + cclasses + '">' + cvalue + '</td>';
    }
    make_a_export() {
        let exportActive = false;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement && (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement["rowNo"] !== undefined) {
            if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#a_measurement_li").hasClass("active")) exportActive = true;
            else if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#a_tolerances_li").hasClass("active")) exportActive = true;
        }
        let archiveExport = new (0, $1b786243bb4bc857$export$2e2bcd8739ae039)();
        archiveExport.export(exportActive);
    }
    constructor(){
        this.conf_archive_url = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/measurements";
    }
}
/**
   * @private
   * @type {?Archive}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($1cc3baa3865cee76$var$Archive, "archiveInstance", null);
var $1cc3baa3865cee76$export$2e2bcd8739ae039 = $1cc3baa3865cee76$var$Archive;












/**
 * Laadimisel oleva vaguni info kuvamise moodul
 */ class $7a306e9acc4e3ba7$var$LoadingGraph {
    /**
   * @returns {LoadingGraph}
   */ static getInstance() {
        if ($7a306e9acc4e3ba7$var$LoadingGraph.loadingGraphInstance == null) $7a306e9acc4e3ba7$var$LoadingGraph.loadingGraphInstance = new $7a306e9acc4e3ba7$var$LoadingGraph();
        return $7a306e9acc4e3ba7$var$LoadingGraph.loadingGraphInstance;
    }
    make_loading_graph_page() {
        // if (current_shown_wagon == loading_wagon) return;
        let graph = (0, $b2a0945f49afb6e5$export$2e2bcd8739ae039).getInstance();
        let settings = (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance();
        (0, $03277cb1bca63048$export$c31045a889981f00)();
        (0, $03277cb1bca63048$export$b0c1cba25cb0c370)();
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon = (0, $03277cb1bca63048$export$2e2bcd8739ae039).loading_wagon;
        graph.nominalButtonOn = settings.getNominalGraph();
        graph.show_analyze((0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon);
        (0, $30071e4d8f83fdfd$export$3c47130985814430)("graph");
    }
    // Laadimisel oleva vaguni info sisselaadimise käivitamine
    load_loadingwagon() {
        if (!(0, $03277cb1bca63048$export$2e2bcd8739ae039).do_loading_wagon) return;
        let wurl = this.loadingwagon_urlbase;
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("loading " + wurl);
        (0, $30071e4d8f83fdfd$export$46e8075064842a03)({
            type: "GET",
            url: wurl,
            success: (function(data) {
                this.loadingwagoncall(data);
            }).bind(this)
        });
    }
    loadingwagoncall(data) {
        (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug("loadingwagoncall");
        let wagons = (0, $f9a0e15f8468a3bd$export$2e2bcd8739ae039).getInstance();
        let graph = (0, $b2a0945f49afb6e5$export$2e2bcd8739ae039).getInstance();
        if (data) {
            (0, $03277cb1bca63048$export$2e2bcd8739ae039).loading_wagon = data['loadingResult'];
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).loading_wagon == null) (0, $03277cb1bca63048$export$2e2bcd8739ae039).loading_wagon = 0;
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon != (0, $03277cb1bca63048$export$2e2bcd8739ae039).loading_wagon) {
                wagons.load_wagon((0, $03277cb1bca63048$export$2e2bcd8739ae039).loading_wagon);
                (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon = (0, $03277cb1bca63048$export$2e2bcd8739ae039).loading_wagon;
                this.make_loading_graph_page();
            } else // Kui #graph0 ei eksisteeri, siis järelikult on vaja leht alles
            // teha, vastasel korral teeme graafikutele refresh
            if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)('#graph0').length == 0) this.make_loading_graph_page();
            else graph.refreshGraphs();
        }
    }
    constructor(){
        this.loadingwagon_urlbase = (0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL + "/loading";
    }
}
/**
   * @type {?LoadingGraph}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($7a306e9acc4e3ba7$var$LoadingGraph, "loadingGraphInstance", null);
var $7a306e9acc4e3ba7$export$2e2bcd8739ae039 = $7a306e9acc4e3ba7$var$LoadingGraph;













/**
 * Tolerantside moodul
 *
 */ class $35079ff6e2be289b$var$Tolerances {
    /**
   *
   * @returns {Tolerances}
   */ static getInstance() {
        if ($35079ff6e2be289b$var$Tolerances.tolerancesIntance == null) $35079ff6e2be289b$var$Tolerances.tolerancesIntance = new $35079ff6e2be289b$var$Tolerances();
        return $35079ff6e2be289b$var$Tolerances.tolerancesIntance;
    }
    make_tolerances_page(n) {
        (0, $03277cb1bca63048$export$c31045a889981f00)();
        (0, $03277cb1bca63048$export$b0c1cba25cb0c370)();
        if (n < 0) {
            if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon < 0) (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon = (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_wagon;
            n = (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon;
        } else (0, $03277cb1bca63048$export$2e2bcd8739ae039).current_shown_wagon = n;
        let drow = null;
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) drow = (0, $03277cb1bca63048$export$2e2bcd8739ae039).a_measurement;
        else {
            if ((0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#tolerances_li").hasClass("active")) return;
            (0, $30071e4d8f83fdfd$export$3c47130985814430)("tolerances");
            (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#content").html("");
            drow = (0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).getDrow();
        }
        if (!drow) return;
        // header text
        let s = "<span class='' ";
        s += " style='margin-bottom: 10px;'>";
        s += (0, $03277cb1bca63048$export$2eda0396a2eaa113)(drow);
        s += "</span>";
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#topy").css("height", "20px");
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop2").html(s);
        s = "";
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#intop1").html(s);
        (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)(".mbtn").button("toggle");
        // data
        let req = drow["required"]; // "corr_required"
        // content table
        s = "<div style='margin-left: 60px; margin-top: 18px'>";
        s += "<br><b>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Tolerances") + "</b><p>";
        s += "<table>";
        s += "<tr class='gridtablehead'>";
        let wagons = (0, $f9a0e15f8468a3bd$export$2e2bcd8739ae039).getInstance();
        let pointCount = 0;
        let points = wagons.getPointNumbers();
        if (drow.lineinfo) {
            for(let i = 0; i < points.length; i++){
                if (drow.lineinfo[points[i]] == null) {
                    s += "<th>P" + (points[i] + 1) + "</th>";
                    continue;
                }
                switch(drow.lineinfo[points[i]][1].substring(0, 1)){
                    case "A":
                    case "B":
                    case "C":
                        s += "<th>P" + (points[i] + 1) + "</th>";
                        break;
                    case "P":
                    default:
                        s += "<th>" + drow.lineinfo[points[i]][1] + "</th>";
                        break;
                }
            }
            pointCount = points.length;
        }
        /*
    var pointCount = settings.getMeasurementLineCount() * 3;
    for (var i = 1; i <= pointCount; i++ ) {
        s += "<th>P"+i+"</th>";
    }
    */ // "<th>P1</th><th>P2</th><th>P3</th><th>P4</th><th>P5</th><th>P6</th><th>P7</th><th>P8</th><th>P9</th></tr>";
        s += "</tr><tr><td colspan='" + pointCount + "' style='background-color: #ff3333; height: 10px;'></td></tr>";
        for(let r = 1; r < 6; r++){
            s += "<tr class='tolerancerow trow_" + r + "'>";
            for(let c = 1; c <= pointCount; c++){
                let k = 0;
                if (r == 1) k = 3;
                else if (r == 2) k = 1;
                else if (r == 3) k = 0;
                else if (r == 4) k = 2;
                else if (r == 5) k = 4;
                if ((0, $d02c132c9fe52fc9$export$2e2bcd8739ae039).isCenterPoint(drow.lineinfo[points[c - 1]][1])) s += "<td class='toleranceshowcell_imp'>";
                else s += "<td class='toleranceshowcell'>";
                let val = "";
                try {
                    val = Math.round(req[points[c - 1]][k]) / 10;
                } catch (err) {}
                s += val + "</td>";
            }
            s += "</tr>";
        }
        s += "<tr><td colspan='" + pointCount + "' style='background-color: #ff3333; height: 10px;'></td></tr>";
        s += "<tr><td colspan='" + pointCount + "' style='background-color: white; height: 50px;'><b>" + (0, $865532d99f221026$export$2e2bcd8739ae039)("Measurement") + "</b></td></tr>";
        s += "<tr>";
        let val = drow["analyzed"];
        for(let c = 1; c <= pointCount; c++)try {
            let cvalue = val[points[c - 1]][2];
            cvalue = Math.round(cvalue) / 10;
            // AA: -100 is a result of missing data; TODO: raw data should
            // be set null earlier
            if (cvalue == -100) cvalue = "";
            if ((0, $d02c132c9fe52fc9$export$2e2bcd8739ae039).isCenterPoint(drow.lineinfo[points[c - 1]][1])) s += "<td class='toleranceshowcell_imp'>";
            else s += "<td class='toleranceshowcell'>";
            s += cvalue + "</td>";
        } catch (err) {
            s += "<td class='toleranceshowcell'></td>";
        }
        s += "</tr></table></div>";
        if ((0, $03277cb1bca63048$export$2e2bcd8739ae039).archive_mode) (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#a_tolerances_content").html(s);
        else (0, $2679c250f7f84a9c$export$2e2bcd8739ae039)("#content").html(s);
    }
}
/**
   * @type {?Tolerances}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($35079ff6e2be289b$var$Tolerances, "tolerancesIntance", null);
var $35079ff6e2be289b$export$2e2bcd8739ae039 = $35079ff6e2be289b$var$Tolerances;






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");








class $feb56a08995ffd57$var$DiagnosticsActions {
    /**
   * Algatatakse laadimine serverist
   */ fetch() {
        return {};
    }
    /**
   * Laadimine ebaõnnestus
   */ fetchFailed(error) {
        return error;
    }
    /**
   * Sai laetud
   */ fetchDone(data) {
        return data;
    }
}
var $feb56a08995ffd57$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createActions($feb56a08995ffd57$var$DiagnosticsActions);




let $a438fcb89dbb8c3c$var$DiagnosticsSource = {
    fetch () {
        return {
            remote (state) {
                return (0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).getDiagnostics();
            },
            local () {
                return null;
            },
            success: (0, $feb56a08995ffd57$export$2e2bcd8739ae039).fetchDone,
            error: (0, $feb56a08995ffd57$export$2e2bcd8739ae039).fetchFailed
        };
    }
};
var $a438fcb89dbb8c3c$export$2e2bcd8739ae039 = $a438fcb89dbb8c3c$var$DiagnosticsSource;



/**
 * Diagnostikaparameetrite hoidmise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */ class $803194b6bb6fabd9$var$DiagnosticsStore {
    /**
   * Toote laadimise käivitamine
   */ onFetch(info) {
        this.setState({
            state: "PROCESSING"
        });
        let p = this.getInstance().fetch();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function() {});
    }
    /**
   * Toote laadimine ebaõnnestus
   */ onFetchFailed(error) {
        this.processError(error);
    }
    processError(error) {
        let message = (0, $865532d99f221026$export$2e2bcd8739ae039)('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) message = error.response.data.error.message;
            else switch(error.response.status){
                case 401:
                case 403:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Invalid password");
                    break;
                case 503:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Service unavailable");
                    break;
                default:
                    message = (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            }
            switch(error.response.status){
                case 401:
                case 403:
                    // Authentication required
                    console.log("DiagnosticStore.processError(): STATUS 401/403: invalidating session");
                    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
                    this.setState({
                        state: "FAIL"
                    });
                    break;
                default:
                    this.setState({
                        state: "FAIL"
                    });
            }
        } else this.setState({
            state: "FAIL"
        });
        (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(message);
    }
    onFetchDone(response) {
        try {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).has(response.data, 'diagnosticsResult')) throw (0, $865532d99f221026$export$2e2bcd8739ae039)("Server error");
            if (response.data.diagnosticsResult == null) this.setState({
                diagnostics: {},
                state: "OK"
            });
            else this.setState({
                diagnostics: response.data.diagnosticsResult,
                state: "OK"
            });
        } catch (e) {
            if (!(0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).isString(e)) {
                console.log(e.toString());
                (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer((0, $865532d99f221026$export$2e2bcd8739ae039)("Server error"));
            } else (0, $26a241f40377239c$export$2e2bcd8739ae039).error.defer(e);
            this.setState({
                state: "FAIL"
            });
        }
    }
    constructor(){
        this.state = {
            diagnostics: [],
            state: "OK"
        };
        this.bindActions((0, $feb56a08995ffd57$export$2e2bcd8739ae039));
        this.exportAsync((0, $a438fcb89dbb8c3c$export$2e2bcd8739ae039));
    }
}
var $803194b6bb6fabd9$export$2e2bcd8739ae039 = (0, $a00e419f736658e2$export$2e2bcd8739ae039).createStore($803194b6bb6fabd9$var$DiagnosticsStore, 'DiagnosticsStore');



class $a64c91e1cdb4efa8$var$Diagnostics extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    componentDidMount() {
        (0, $803194b6bb6fabd9$export$2e2bcd8739ae039).listen(this.onChange);
        (0, $feb56a08995ffd57$export$2e2bcd8739ae039).fetch.defer();
    }
    componentWillUnmount() {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
            this.setState({
                intervalId: null
            });
        }
        (0, $803194b6bb6fabd9$export$2e2bcd8739ae039).unlisten(this.onChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.diagnostics.state === "PROCESSING" && this.state.diagnostics.state !== "PROCESSING") // loading or saving finished
        {
            if (this.state.diagnostics.state === "FAIL" && this.state.intervalId != null) {
                // Request fails. Turn off automatic updates:
                clearInterval(this.state.intervalId);
                this.setState({
                    intervalId: null
                });
                return;
            }
        }
        if (this.state.intervalId == null && this.state.delay > 0 && this.state.diagnostics.state !== "FAIL") // Enable automatic data reloading:
        this.setState({
            intervalId: setInterval(this.onClickLoad, this.state.delay * 1000)
        });
    }
    onChange(state) {
        if (this.state.intervalId == null && this.state.delay > 0) // Enable automatic data reloading:
        this.setState({
            diagnostics: (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(state),
            intervalId: setInterval(this.onClickLoad, this.state.delay * 1000)
        });
        else this.setState({
            diagnostics: (0, $0c98ba8e5ffb6ee3$export$2e2bcd8739ae039).clone(state)
        });
    }
    onClickLoad() {
        (0, $feb56a08995ffd57$export$2e2bcd8739ae039).fetch.defer();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
            className: "form-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
            className: "table table-hover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            className: "col-sm-4"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Parameter")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            className: "col-sm-8"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Value")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, this.renderItems()))));
    }
    renderItems() {
        let items = this.getItems();
        let result = [];
        for (let item of items){
            let renderedItem = this.renderItem(item);
            if (renderedItem != null) result.push(renderedItem);
        }
        return result;
    }
    renderItem(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            key: item.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null, (0, $865532d99f221026$export$2e2bcd8739ae039)(item.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("td", null, item.value));
    }
    getItems() {
        return this.state.diagnostics.diagnostics;
    }
    constructor(props){
        super(props);
        this.state = {
            diagnostics: (0, $803194b6bb6fabd9$export$2e2bcd8739ae039).getState(),
            intervalId: null,
            delay: 1
        };
        this.onChange = this.onChange.bind(this);
        this.onClickLoad = this.onClickLoad.bind(this);
    }
}
var $a64c91e1cdb4efa8$export$2e2bcd8739ae039 = $a64c91e1cdb4efa8$var$Diagnostics;


class $167ccf59832cf643$var$DiagnosticsPage extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            id: "config_content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4610186095f4e197$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a64c91e1cdb4efa8$export$2e2bcd8739ae039), null));
    }
}
var $167ccf59832cf643$export$2e2bcd8739ae039 = $167ccf59832cf643$var$DiagnosticsPage;




var $7fPBF = parcelRequire("7fPBF");

const $ae85700c02d3eb3f$var$RootContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({});
var $ae85700c02d3eb3f$export$2e2bcd8739ae039 = $ae85700c02d3eb3f$var$RootContext;



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");





const $95508fc70554a033$var$propTypes = {
    onClickOk: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onClickCancel: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    okText: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    cancelText: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    noCancel: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    showNotifications: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool
};
const $95508fc70554a033$var$defaultProps = {
    okText: 'OK',
    cancelText: 'Cancel',
    noCancel: false,
    showNotifications: false,
    disabled: false
};
class $95508fc70554a033$var$AuthModal extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    componentDidMount() {
        this.goToUserField();
    }
    onClose() {
        if (this.props.noCancel) return false;
        if (this.props.onClickOk) {
            this.props.onClickOk(this.state.username, this.state.password);
            return false;
        } else return true;
    }
    onClickOk(e) {
        e.preventDefault();
        if (this.props.onClickOk) this.props.onClickOk(this.state.username, this.state.password);
        else (0, $1e216dc96a46c373$exports.ModalManager).close();
    }
    onClickCancel(e) {
        e.preventDefault();
        if (this.props.onClickCancel) this.props.onClickCancel();
        else (0, $1e216dc96a46c373$exports.ModalManager).close();
    }
    onChange(param, value) {
        this.setState({
            [param]: value
        });
    }
    goToPasswordField(e) {
        e.preventDefault();
        let el = document.getElementById("password");
        el.focus();
        el.select();
    }
    goToUserField() {
        let el = document.getElementById("username");
        el.focus();
        el.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1e216dc96a46c373$exports.Modal), {
            effect: (0, $1e216dc96a46c373$exports.Effect).ScaleUp,
            className: "modal-dialog",
            style: {
                content: {
                    width: '400px'
                }
            },
            onRequestClose: this.onClose,
            "data-keyboard": this.props.noCancel ? "false" : "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "modal-header"
        }, this.props.noCancel ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: "button",
            className: "close",
            onClick: this.onClickCancel,
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
            className: "fa fa-times",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h4", {
            className: "modal-title"
        }, this.props.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "modal-body"
        }, this.props.showNotifications ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4610186095f4e197$export$2e2bcd8739ae039), {
            onlyLast: true
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
            className: "form-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            htmlFor: "username",
            className: "col-sm-4 control-label"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Username")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            className: "form-control",
            id: "username",
            type: "text",
            valueType: "string",
            value: this.state.username,
            onChange: this.onChange,
            onChangeParam: "username",
            onEnter: this.goToPasswordField,
            disabled: this.props.disabled
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
            htmlFor: "password",
            className: "col-sm-4 control-label"
        }, (0, $865532d99f221026$export$2e2bcd8739ae039)("Password")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "col-sm-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $909670d6855077c9$export$2e2bcd8739ae039), {
            className: "form-control",
            id: "password",
            type: "password",
            valueType: "string",
            value: this.state.password,
            onChange: this.onChange,
            onChangeParam: "password",
            onEnter: this.onClickOk,
            disabled: this.props.disabled
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "modal-footer"
        }, this.props.noCancel ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: "button",
            className: "btn btn-default",
            onClick: this.onClickCancel,
            disabled: this.props.disabled
        }, this.props.cancelText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onClickOk,
            disabled: this.props.disabled
        }, this.props.okText)));
    }
    constructor(props){
        super(props);
        this.state = {
            username: "",
            password: ""
        };
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onClose = this.onClose.bind(this);
        this.goToPasswordField = this.goToPasswordField.bind(this);
    }
}
$95508fc70554a033$var$AuthModal.propTypes = $95508fc70554a033$var$propTypes;
$95508fc70554a033$var$AuthModal.defaultProps = $95508fc70554a033$var$defaultProps;
var $95508fc70554a033$export$2e2bcd8739ae039 = $95508fc70554a033$var$AuthModal;








const $c6a24f4bf5c40197$var$AuthUser = (0, $0e9caff9ea7c2c9f$export$b6ae1bc530f4c149)(()=>{
    const sessionStore = (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore;
    (0, $7fPBF.useEffect)(()=>{
        if (sessionStore.hasRequiredRole()) (0, $03277cb1bca63048$export$2e2bcd8739ae039).grobot_init();
        else // Set default langugage:
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).set_default_lang();
    }, [
        sessionStore.status,
        sessionStore.requiredRole
    ]);
    if (!sessionStore.hasRequiredRole()) {
        (0, $03277cb1bca63048$export$2e2bcd8739ae039).set_default_lang();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $95508fc70554a033$export$2e2bcd8739ae039), {
            title: (0, $865532d99f221026$export$2e2bcd8739ae039)("Please log in as") + ": " + sessionStore.getRequiredRoleName(),
            onClickOk: (user, password)=>{
                (0, $26a241f40377239c$export$2e2bcd8739ae039).clear.defer();
                sessionStore.logon(user, password).then(()=>{
                // WebApi.authorization("Bearer " + sessionStore.getSession().token);
                });
            },
            onClickCancel: ()=>{
                // Go to top page:
                if ((0, $30071e4d8f83fdfd$export$7945ba8eb1c827e6)() == "archive.html") window.location.href = "index.html";
                else window.location.reload();
            },
            noCancel: false,
            okText: (0, $865532d99f221026$export$2e2bcd8739ae039)('OK'),
            showNotifications: true,
            disabled: sessionStore.status == "in_progress"
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null);
});
var $c6a24f4bf5c40197$export$2e2bcd8739ae039 = $c6a24f4bf5c40197$var$AuthUser;


function $4a5191623062d5ff$var$reactMakeProductPage() {
    $4a5191623062d5ff$var$reactMakePage('ncp2gr', (0, $9e8968b377c4b4d9$export$2e2bcd8739ae039));
}
function $4a5191623062d5ff$var$reactMakeConfigPage() {
    $4a5191623062d5ff$var$reactMakePage('admin', (0, $9af43539a7916a57$export$2e2bcd8739ae039));
}
function $4a5191623062d5ff$var$reactMakeDiagnosticsPage() {
    $4a5191623062d5ff$var$reactMakePage('admin', (0, $167ccf59832cf643$export$2e2bcd8739ae039));
}
function $4a5191623062d5ff$var$reactMakeSoftwareUpdatePage() {
    $4a5191623062d5ff$var$reactMakePage('admin', (0, $c028eb6a645b8a34$export$2e2bcd8739ae039));
}
function $4a5191623062d5ff$var$reactMakePage(menuItem, Page) {
    (0, $03277cb1bca63048$export$c31045a889981f00)();
    (0, $03277cb1bca63048$export$b0c1cba25cb0c370)();
    (0, $30071e4d8f83fdfd$export$3c47130985814430)(menuItem);
    $4a5191623062d5ff$var$reactRenderComponent("content", Page);
    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    $b8077eed590c44e8$export$d07f55d4c15c0440();
}
function $4a5191623062d5ff$var$reactRenderComponent(elementId, Comp, props = null) {
    if (props == null) props = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Comp, props), document.getElementById(elementId));
}
function $4a5191623062d5ff$var$reactLogout() {
    console.log("reactLogout(): invalidating session");
    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.invalidate();
    window.location.reload();
}
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug(`KLPMS UI: ${""} ${""}`);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).debug(`BASE_URL: ${(0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL}`);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('ReactDOM', (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))));
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('reactMakeProductPage', $4a5191623062d5ff$var$reactMakeProductPage);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('reactMakeConfigPage', $4a5191623062d5ff$var$reactMakeConfigPage);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('reactMakeDiagnosticsPage', $4a5191623062d5ff$var$reactMakeDiagnosticsPage);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('reactMakeSoftwareUpdatePage', $4a5191623062d5ff$var$reactMakeSoftwareUpdatePage);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('reactLogout', $4a5191623062d5ff$var$reactLogout);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('SettingsActions', (0, $b1b3b27ecff41190$export$2e2bcd8739ae039));
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal('util', $30071e4d8f83fdfd$exports);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("correct_grid_row", $2f5d8207b6c7af36$export$4479559953567eb6);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("convert_data_format", $2f5d8207b6c7af36$export$71d161edb28ff086);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("convert_data_row", $2f5d8207b6c7af36$export$63550c27588333c3);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("limit_timestamp", $30071e4d8f83fdfd$exports.limit_timestamp);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("activateMenuItem", $30071e4d8f83fdfd$exports.activateMenuItem);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("getURLParameter", $30071e4d8f83fdfd$exports.getURLParameter);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("getCurrentPage", $30071e4d8f83fdfd$exports.getCurrentPage);
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("setLanguageIdx", (0, $865532d99f221026$export$63f71167c6a02e5f));
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("trans", (0, $865532d99f221026$export$4fa6d59685552a7c));
// Init modules:
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("settings", (0, $0c8a072ce56f6e2d$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("alarms", (0, $90a202b862875a28$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("archive", (0, $1cc3baa3865cee76$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("graph", (0, $b2a0945f49afb6e5$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("loadinggraph", (0, $7a306e9acc4e3ba7$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("wagons", (0, $f9a0e15f8468a3bd$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("nominalGraph", (0, $82412e69ca9e99a5$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("wagonConf", (0, $e201fb47f21e9b8a$export$2e2bcd8739ae039).getInstance());
(0, $b5ea4b23f7aaa130$export$2e2bcd8739ae039).setGlobal("tolerances", (0, $35079ff6e2be289b$export$2e2bcd8739ae039).getInstance());
(0, $2d56dcdc0f2f4752$export$2e2bcd8739ae039).url((0, $487b7e0315c147c0$export$2e2bcd8739ae039).BASE_URL);
if (document.getElementById("modal") != null) {
    let role = "user";
    if ((0, $30071e4d8f83fdfd$export$7945ba8eb1c827e6)() == "archive.html") role = "archive";
    (0, $1a271afb525e8cfa$export$2e2bcd8739ae039).sessionStore.setRequiredRole(role);
    $4a5191623062d5ff$var$reactRenderComponent("modal", (0, $c6a24f4bf5c40197$export$2e2bcd8739ae039));
}


//# sourceMappingURL=klpms-web.3306c23e.js.map
